
(function() {
'use strict';

function F2(fun)
{
  function wrapper(a) { return function(b) { return fun(a,b); }; }
  wrapper.arity = 2;
  wrapper.func = fun;
  return wrapper;
}

function F3(fun)
{
  function wrapper(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  }
  wrapper.arity = 3;
  wrapper.func = fun;
  return wrapper;
}

function F4(fun)
{
  function wrapper(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  }
  wrapper.arity = 4;
  wrapper.func = fun;
  return wrapper;
}

function F5(fun)
{
  function wrapper(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  }
  wrapper.arity = 5;
  wrapper.func = fun;
  return wrapper;
}

function F6(fun)
{
  function wrapper(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  }
  wrapper.arity = 6;
  wrapper.func = fun;
  return wrapper;
}

function F7(fun)
{
  function wrapper(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  }
  wrapper.arity = 7;
  wrapper.func = fun;
  return wrapper;
}

function F8(fun)
{
  function wrapper(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  }
  wrapper.arity = 8;
  wrapper.func = fun;
  return wrapper;
}

function F9(fun)
{
  function wrapper(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  }
  wrapper.arity = 9;
  wrapper.func = fun;
  return wrapper;
}

function A2(fun, a, b)
{
  return fun.arity === 2
    ? fun.func(a, b)
    : fun(a)(b);
}
function A3(fun, a, b, c)
{
  return fun.arity === 3
    ? fun.func(a, b, c)
    : fun(a)(b)(c);
}
function A4(fun, a, b, c, d)
{
  return fun.arity === 4
    ? fun.func(a, b, c, d)
    : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e)
{
  return fun.arity === 5
    ? fun.func(a, b, c, d, e)
    : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f)
{
  return fun.arity === 6
    ? fun.func(a, b, c, d, e, f)
    : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g)
{
  return fun.arity === 7
    ? fun.func(a, b, c, d, e, f, g)
    : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h)
{
  return fun.arity === 8
    ? fun.func(a, b, c, d, e, f, g, h)
    : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i)
{
  return fun.arity === 9
    ? fun.func(a, b, c, d, e, f, g, h, i)
    : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}

//import Native.List //

var _elm_lang$core$Native_Array = function() {

// A RRB-Tree has two distinct data types.
// Leaf -> "height"  is always 0
//         "table"   is an array of elements
// Node -> "height"  is always greater than 0
//         "table"   is an array of child nodes
//         "lengths" is an array of accumulated lengths of the child nodes

// M is the maximal table size. 32 seems fast. E is the allowed increase
// of search steps when concatting to find an index. Lower values will
// decrease balancing, but will increase search steps.
var M = 32;
var E = 2;

// An empty array.
var empty = {
	ctor: '_Array',
	height: 0,
	table: []
};


function get(i, array)
{
	if (i < 0 || i >= length(array))
	{
		throw new Error(
			'Index ' + i + ' is out of range. Check the length of ' +
			'your array first or use getMaybe or getWithDefault.');
	}
	return unsafeGet(i, array);
}


function unsafeGet(i, array)
{
	for (var x = array.height; x > 0; x--)
	{
		var slot = i >> (x * 5);
		while (array.lengths[slot] <= i)
		{
			slot++;
		}
		if (slot > 0)
		{
			i -= array.lengths[slot - 1];
		}
		array = array.table[slot];
	}
	return array.table[i];
}


// Sets the value at the index i. Only the nodes leading to i will get
// copied and updated.
function set(i, item, array)
{
	if (i < 0 || length(array) <= i)
	{
		return array;
	}
	return unsafeSet(i, item, array);
}


function unsafeSet(i, item, array)
{
	array = nodeCopy(array);

	if (array.height === 0)
	{
		array.table[i] = item;
	}
	else
	{
		var slot = getSlot(i, array);
		if (slot > 0)
		{
			i -= array.lengths[slot - 1];
		}
		array.table[slot] = unsafeSet(i, item, array.table[slot]);
	}
	return array;
}


function initialize(len, f)
{
	if (len <= 0)
	{
		return empty;
	}
	var h = Math.floor( Math.log(len) / Math.log(M) );
	return initialize_(f, h, 0, len);
}

function initialize_(f, h, from, to)
{
	if (h === 0)
	{
		var table = new Array((to - from) % (M + 1));
		for (var i = 0; i < table.length; i++)
		{
		  table[i] = f(from + i);
		}
		return {
			ctor: '_Array',
			height: 0,
			table: table
		};
	}

	var step = Math.pow(M, h);
	var table = new Array(Math.ceil((to - from) / step));
	var lengths = new Array(table.length);
	for (var i = 0; i < table.length; i++)
	{
		table[i] = initialize_(f, h - 1, from + (i * step), Math.min(from + ((i + 1) * step), to));
		lengths[i] = length(table[i]) + (i > 0 ? lengths[i-1] : 0);
	}
	return {
		ctor: '_Array',
		height: h,
		table: table,
		lengths: lengths
	};
}

function fromList(list)
{
	if (list.ctor === '[]')
	{
		return empty;
	}

	// Allocate M sized blocks (table) and write list elements to it.
	var table = new Array(M);
	var nodes = [];
	var i = 0;

	while (list.ctor !== '[]')
	{
		table[i] = list._0;
		list = list._1;
		i++;

		// table is full, so we can push a leaf containing it into the
		// next node.
		if (i === M)
		{
			var leaf = {
				ctor: '_Array',
				height: 0,
				table: table
			};
			fromListPush(leaf, nodes);
			table = new Array(M);
			i = 0;
		}
	}

	// Maybe there is something left on the table.
	if (i > 0)
	{
		var leaf = {
			ctor: '_Array',
			height: 0,
			table: table.splice(0, i)
		};
		fromListPush(leaf, nodes);
	}

	// Go through all of the nodes and eventually push them into higher nodes.
	for (var h = 0; h < nodes.length - 1; h++)
	{
		if (nodes[h].table.length > 0)
		{
			fromListPush(nodes[h], nodes);
		}
	}

	var head = nodes[nodes.length - 1];
	if (head.height > 0 && head.table.length === 1)
	{
		return head.table[0];
	}
	else
	{
		return head;
	}
}

// Push a node into a higher node as a child.
function fromListPush(toPush, nodes)
{
	var h = toPush.height;

	// Maybe the node on this height does not exist.
	if (nodes.length === h)
	{
		var node = {
			ctor: '_Array',
			height: h + 1,
			table: [],
			lengths: []
		};
		nodes.push(node);
	}

	nodes[h].table.push(toPush);
	var len = length(toPush);
	if (nodes[h].lengths.length > 0)
	{
		len += nodes[h].lengths[nodes[h].lengths.length - 1];
	}
	nodes[h].lengths.push(len);

	if (nodes[h].table.length === M)
	{
		fromListPush(nodes[h], nodes);
		nodes[h] = {
			ctor: '_Array',
			height: h + 1,
			table: [],
			lengths: []
		};
	}
}

// Pushes an item via push_ to the bottom right of a tree.
function push(item, a)
{
	var pushed = push_(item, a);
	if (pushed !== null)
	{
		return pushed;
	}

	var newTree = create(item, a.height);
	return siblise(a, newTree);
}

// Recursively tries to push an item to the bottom-right most
// tree possible. If there is no space left for the item,
// null will be returned.
function push_(item, a)
{
	// Handle resursion stop at leaf level.
	if (a.height === 0)
	{
		if (a.table.length < M)
		{
			var newA = {
				ctor: '_Array',
				height: 0,
				table: a.table.slice()
			};
			newA.table.push(item);
			return newA;
		}
		else
		{
		  return null;
		}
	}

	// Recursively push
	var pushed = push_(item, botRight(a));

	// There was space in the bottom right tree, so the slot will
	// be updated.
	if (pushed !== null)
	{
		var newA = nodeCopy(a);
		newA.table[newA.table.length - 1] = pushed;
		newA.lengths[newA.lengths.length - 1]++;
		return newA;
	}

	// When there was no space left, check if there is space left
	// for a new slot with a tree which contains only the item
	// at the bottom.
	if (a.table.length < M)
	{
		var newSlot = create(item, a.height - 1);
		var newA = nodeCopy(a);
		newA.table.push(newSlot);
		newA.lengths.push(newA.lengths[newA.lengths.length - 1] + length(newSlot));
		return newA;
	}
	else
	{
		return null;
	}
}

// Converts an array into a list of elements.
function toList(a)
{
	return toList_(_elm_lang$core$Native_List.Nil, a);
}

function toList_(list, a)
{
	for (var i = a.table.length - 1; i >= 0; i--)
	{
		list =
			a.height === 0
				? _elm_lang$core$Native_List.Cons(a.table[i], list)
				: toList_(list, a.table[i]);
	}
	return list;
}

// Maps a function over the elements of an array.
function map(f, a)
{
	var newA = {
		ctor: '_Array',
		height: a.height,
		table: new Array(a.table.length)
	};
	if (a.height > 0)
	{
		newA.lengths = a.lengths;
	}
	for (var i = 0; i < a.table.length; i++)
	{
		newA.table[i] =
			a.height === 0
				? f(a.table[i])
				: map(f, a.table[i]);
	}
	return newA;
}

// Maps a function over the elements with their index as first argument.
function indexedMap(f, a)
{
	return indexedMap_(f, a, 0);
}

function indexedMap_(f, a, from)
{
	var newA = {
		ctor: '_Array',
		height: a.height,
		table: new Array(a.table.length)
	};
	if (a.height > 0)
	{
		newA.lengths = a.lengths;
	}
	for (var i = 0; i < a.table.length; i++)
	{
		newA.table[i] =
			a.height === 0
				? A2(f, from + i, a.table[i])
				: indexedMap_(f, a.table[i], i == 0 ? from : from + a.lengths[i - 1]);
	}
	return newA;
}

function foldl(f, b, a)
{
	if (a.height === 0)
	{
		for (var i = 0; i < a.table.length; i++)
		{
			b = A2(f, a.table[i], b);
		}
	}
	else
	{
		for (var i = 0; i < a.table.length; i++)
		{
			b = foldl(f, b, a.table[i]);
		}
	}
	return b;
}

function foldr(f, b, a)
{
	if (a.height === 0)
	{
		for (var i = a.table.length; i--; )
		{
			b = A2(f, a.table[i], b);
		}
	}
	else
	{
		for (var i = a.table.length; i--; )
		{
			b = foldr(f, b, a.table[i]);
		}
	}
	return b;
}

// TODO: currently, it slices the right, then the left. This can be
// optimized.
function slice(from, to, a)
{
	if (from < 0)
	{
		from += length(a);
	}
	if (to < 0)
	{
		to += length(a);
	}
	return sliceLeft(from, sliceRight(to, a));
}

function sliceRight(to, a)
{
	if (to === length(a))
	{
		return a;
	}

	// Handle leaf level.
	if (a.height === 0)
	{
		var newA = { ctor:'_Array', height:0 };
		newA.table = a.table.slice(0, to);
		return newA;
	}

	// Slice the right recursively.
	var right = getSlot(to, a);
	var sliced = sliceRight(to - (right > 0 ? a.lengths[right - 1] : 0), a.table[right]);

	// Maybe the a node is not even needed, as sliced contains the whole slice.
	if (right === 0)
	{
		return sliced;
	}

	// Create new node.
	var newA = {
		ctor: '_Array',
		height: a.height,
		table: a.table.slice(0, right),
		lengths: a.lengths.slice(0, right)
	};
	if (sliced.table.length > 0)
	{
		newA.table[right] = sliced;
		newA.lengths[right] = length(sliced) + (right > 0 ? newA.lengths[right - 1] : 0);
	}
	return newA;
}

function sliceLeft(from, a)
{
	if (from === 0)
	{
		return a;
	}

	// Handle leaf level.
	if (a.height === 0)
	{
		var newA = { ctor:'_Array', height:0 };
		newA.table = a.table.slice(from, a.table.length + 1);
		return newA;
	}

	// Slice the left recursively.
	var left = getSlot(from, a);
	var sliced = sliceLeft(from - (left > 0 ? a.lengths[left - 1] : 0), a.table[left]);

	// Maybe the a node is not even needed, as sliced contains the whole slice.
	if (left === a.table.length - 1)
	{
		return sliced;
	}

	// Create new node.
	var newA = {
		ctor: '_Array',
		height: a.height,
		table: a.table.slice(left, a.table.length + 1),
		lengths: new Array(a.table.length - left)
	};
	newA.table[0] = sliced;
	var len = 0;
	for (var i = 0; i < newA.table.length; i++)
	{
		len += length(newA.table[i]);
		newA.lengths[i] = len;
	}

	return newA;
}

// Appends two trees.
function append(a,b)
{
	if (a.table.length === 0)
	{
		return b;
	}
	if (b.table.length === 0)
	{
		return a;
	}

	var c = append_(a, b);

	// Check if both nodes can be crunshed together.
	if (c[0].table.length + c[1].table.length <= M)
	{
		if (c[0].table.length === 0)
		{
			return c[1];
		}
		if (c[1].table.length === 0)
		{
			return c[0];
		}

		// Adjust .table and .lengths
		c[0].table = c[0].table.concat(c[1].table);
		if (c[0].height > 0)
		{
			var len = length(c[0]);
			for (var i = 0; i < c[1].lengths.length; i++)
			{
				c[1].lengths[i] += len;
			}
			c[0].lengths = c[0].lengths.concat(c[1].lengths);
		}

		return c[0];
	}

	if (c[0].height > 0)
	{
		var toRemove = calcToRemove(a, b);
		if (toRemove > E)
		{
			c = shuffle(c[0], c[1], toRemove);
		}
	}

	return siblise(c[0], c[1]);
}

// Returns an array of two nodes; right and left. One node _may_ be empty.
function append_(a, b)
{
	if (a.height === 0 && b.height === 0)
	{
		return [a, b];
	}

	if (a.height !== 1 || b.height !== 1)
	{
		if (a.height === b.height)
		{
			a = nodeCopy(a);
			b = nodeCopy(b);
			var appended = append_(botRight(a), botLeft(b));

			insertRight(a, appended[1]);
			insertLeft(b, appended[0]);
		}
		else if (a.height > b.height)
		{
			a = nodeCopy(a);
			var appended = append_(botRight(a), b);

			insertRight(a, appended[0]);
			b = parentise(appended[1], appended[1].height + 1);
		}
		else
		{
			b = nodeCopy(b);
			var appended = append_(a, botLeft(b));

			var left = appended[0].table.length === 0 ? 0 : 1;
			var right = left === 0 ? 1 : 0;
			insertLeft(b, appended[left]);
			a = parentise(appended[right], appended[right].height + 1);
		}
	}

	// Check if balancing is needed and return based on that.
	if (a.table.length === 0 || b.table.length === 0)
	{
		return [a, b];
	}

	var toRemove = calcToRemove(a, b);
	if (toRemove <= E)
	{
		return [a, b];
	}
	return shuffle(a, b, toRemove);
}

// Helperfunctions for append_. Replaces a child node at the side of the parent.
function insertRight(parent, node)
{
	var index = parent.table.length - 1;
	parent.table[index] = node;
	parent.lengths[index] = length(node);
	parent.lengths[index] += index > 0 ? parent.lengths[index - 1] : 0;
}

function insertLeft(parent, node)
{
	if (node.table.length > 0)
	{
		parent.table[0] = node;
		parent.lengths[0] = length(node);

		var len = length(parent.table[0]);
		for (var i = 1; i < parent.lengths.length; i++)
		{
			len += length(parent.table[i]);
			parent.lengths[i] = len;
		}
	}
	else
	{
		parent.table.shift();
		for (var i = 1; i < parent.lengths.length; i++)
		{
			parent.lengths[i] = parent.lengths[i] - parent.lengths[0];
		}
		parent.lengths.shift();
	}
}

// Returns the extra search steps for E. Refer to the paper.
function calcToRemove(a, b)
{
	var subLengths = 0;
	for (var i = 0; i < a.table.length; i++)
	{
		subLengths += a.table[i].table.length;
	}
	for (var i = 0; i < b.table.length; i++)
	{
		subLengths += b.table[i].table.length;
	}

	var toRemove = a.table.length + b.table.length;
	return toRemove - (Math.floor((subLengths - 1) / M) + 1);
}

// get2, set2 and saveSlot are helpers for accessing elements over two arrays.
function get2(a, b, index)
{
	return index < a.length
		? a[index]
		: b[index - a.length];
}

function set2(a, b, index, value)
{
	if (index < a.length)
	{
		a[index] = value;
	}
	else
	{
		b[index - a.length] = value;
	}
}

function saveSlot(a, b, index, slot)
{
	set2(a.table, b.table, index, slot);

	var l = (index === 0 || index === a.lengths.length)
		? 0
		: get2(a.lengths, a.lengths, index - 1);

	set2(a.lengths, b.lengths, index, l + length(slot));
}

// Creates a node or leaf with a given length at their arrays for perfomance.
// Is only used by shuffle.
function createNode(h, length)
{
	if (length < 0)
	{
		length = 0;
	}
	var a = {
		ctor: '_Array',
		height: h,
		table: new Array(length)
	};
	if (h > 0)
	{
		a.lengths = new Array(length);
	}
	return a;
}

// Returns an array of two balanced nodes.
function shuffle(a, b, toRemove)
{
	var newA = createNode(a.height, Math.min(M, a.table.length + b.table.length - toRemove));
	var newB = createNode(a.height, newA.table.length - (a.table.length + b.table.length - toRemove));

	// Skip the slots with size M. More precise: copy the slot references
	// to the new node
	var read = 0;
	while (get2(a.table, b.table, read).table.length % M === 0)
	{
		set2(newA.table, newB.table, read, get2(a.table, b.table, read));
		set2(newA.lengths, newB.lengths, read, get2(a.lengths, b.lengths, read));
		read++;
	}

	// Pulling items from left to right, caching in a slot before writing
	// it into the new nodes.
	var write = read;
	var slot = new createNode(a.height - 1, 0);
	var from = 0;

	// If the current slot is still containing data, then there will be at
	// least one more write, so we do not break this loop yet.
	while (read - write - (slot.table.length > 0 ? 1 : 0) < toRemove)
	{
		// Find out the max possible items for copying.
		var source = get2(a.table, b.table, read);
		var to = Math.min(M - slot.table.length, source.table.length);

		// Copy and adjust size table.
		slot.table = slot.table.concat(source.table.slice(from, to));
		if (slot.height > 0)
		{
			var len = slot.lengths.length;
			for (var i = len; i < len + to - from; i++)
			{
				slot.lengths[i] = length(slot.table[i]);
				slot.lengths[i] += (i > 0 ? slot.lengths[i - 1] : 0);
			}
		}

		from += to;

		// Only proceed to next slots[i] if the current one was
		// fully copied.
		if (source.table.length <= to)
		{
			read++; from = 0;
		}

		// Only create a new slot if the current one is filled up.
		if (slot.table.length === M)
		{
			saveSlot(newA, newB, write, slot);
			slot = createNode(a.height - 1, 0);
			write++;
		}
	}

	// Cleanup after the loop. Copy the last slot into the new nodes.
	if (slot.table.length > 0)
	{
		saveSlot(newA, newB, write, slot);
		write++;
	}

	// Shift the untouched slots to the left
	while (read < a.table.length + b.table.length )
	{
		saveSlot(newA, newB, write, get2(a.table, b.table, read));
		read++;
		write++;
	}

	return [newA, newB];
}

// Navigation functions
function botRight(a)
{
	return a.table[a.table.length - 1];
}
function botLeft(a)
{
	return a.table[0];
}

// Copies a node for updating. Note that you should not use this if
// only updating only one of "table" or "lengths" for performance reasons.
function nodeCopy(a)
{
	var newA = {
		ctor: '_Array',
		height: a.height,
		table: a.table.slice()
	};
	if (a.height > 0)
	{
		newA.lengths = a.lengths.slice();
	}
	return newA;
}

// Returns how many items are in the tree.
function length(array)
{
	if (array.height === 0)
	{
		return array.table.length;
	}
	else
	{
		return array.lengths[array.lengths.length - 1];
	}
}

// Calculates in which slot of "table" the item probably is, then
// find the exact slot via forward searching in  "lengths". Returns the index.
function getSlot(i, a)
{
	var slot = i >> (5 * a.height);
	while (a.lengths[slot] <= i)
	{
		slot++;
	}
	return slot;
}

// Recursively creates a tree with a given height containing
// only the given item.
function create(item, h)
{
	if (h === 0)
	{
		return {
			ctor: '_Array',
			height: 0,
			table: [item]
		};
	}
	return {
		ctor: '_Array',
		height: h,
		table: [create(item, h - 1)],
		lengths: [1]
	};
}

// Recursively creates a tree that contains the given tree.
function parentise(tree, h)
{
	if (h === tree.height)
	{
		return tree;
	}

	return {
		ctor: '_Array',
		height: h,
		table: [parentise(tree, h - 1)],
		lengths: [length(tree)]
	};
}

// Emphasizes blood brotherhood beneath two trees.
function siblise(a, b)
{
	return {
		ctor: '_Array',
		height: a.height + 1,
		table: [a, b],
		lengths: [length(a), length(a) + length(b)]
	};
}

function toJSArray(a)
{
	var jsArray = new Array(length(a));
	toJSArray_(jsArray, 0, a);
	return jsArray;
}

function toJSArray_(jsArray, i, a)
{
	for (var t = 0; t < a.table.length; t++)
	{
		if (a.height === 0)
		{
			jsArray[i + t] = a.table[t];
		}
		else
		{
			var inc = t === 0 ? 0 : a.lengths[t - 1];
			toJSArray_(jsArray, i + inc, a.table[t]);
		}
	}
}

function fromJSArray(jsArray)
{
	if (jsArray.length === 0)
	{
		return empty;
	}
	var h = Math.floor(Math.log(jsArray.length) / Math.log(M));
	return fromJSArray_(jsArray, h, 0, jsArray.length);
}

function fromJSArray_(jsArray, h, from, to)
{
	if (h === 0)
	{
		return {
			ctor: '_Array',
			height: 0,
			table: jsArray.slice(from, to)
		};
	}

	var step = Math.pow(M, h);
	var table = new Array(Math.ceil((to - from) / step));
	var lengths = new Array(table.length);
	for (var i = 0; i < table.length; i++)
	{
		table[i] = fromJSArray_(jsArray, h - 1, from + (i * step), Math.min(from + ((i + 1) * step), to));
		lengths[i] = length(table[i]) + (i > 0 ? lengths[i - 1] : 0);
	}
	return {
		ctor: '_Array',
		height: h,
		table: table,
		lengths: lengths
	};
}

return {
	empty: empty,
	fromList: fromList,
	toList: toList,
	initialize: F2(initialize),
	append: F2(append),
	push: F2(push),
	slice: F3(slice),
	get: F2(get),
	set: F3(set),
	map: F2(map),
	indexedMap: F2(indexedMap),
	foldl: F3(foldl),
	foldr: F3(foldr),
	length: length,

	toJSArray: toJSArray,
	fromJSArray: fromJSArray
};

}();
//import Native.Utils //

var _elm_lang$core$Native_Basics = function() {

function div(a, b)
{
	return (a / b) | 0;
}
function rem(a, b)
{
	return a % b;
}
function mod(a, b)
{
	if (b === 0)
	{
		throw new Error('Cannot perform mod 0. Division by zero error.');
	}
	var r = a % b;
	var m = a === 0 ? 0 : (b > 0 ? (a >= 0 ? r : r + b) : -mod(-a, -b));

	return m === b ? 0 : m;
}
function logBase(base, n)
{
	return Math.log(n) / Math.log(base);
}
function negate(n)
{
	return -n;
}
function abs(n)
{
	return n < 0 ? -n : n;
}

function min(a, b)
{
	return _elm_lang$core$Native_Utils.cmp(a, b) < 0 ? a : b;
}
function max(a, b)
{
	return _elm_lang$core$Native_Utils.cmp(a, b) > 0 ? a : b;
}
function clamp(lo, hi, n)
{
	return _elm_lang$core$Native_Utils.cmp(n, lo) < 0
		? lo
		: _elm_lang$core$Native_Utils.cmp(n, hi) > 0
			? hi
			: n;
}

var ord = ['LT', 'EQ', 'GT'];

function compare(x, y)
{
	return { ctor: ord[_elm_lang$core$Native_Utils.cmp(x, y) + 1] };
}

function xor(a, b)
{
	return a !== b;
}
function not(b)
{
	return !b;
}
function isInfinite(n)
{
	return n === Infinity || n === -Infinity;
}

function truncate(n)
{
	return n | 0;
}

function degrees(d)
{
	return d * Math.PI / 180;
}
function turns(t)
{
	return 2 * Math.PI * t;
}
function fromPolar(point)
{
	var r = point._0;
	var t = point._1;
	return _elm_lang$core$Native_Utils.Tuple2(r * Math.cos(t), r * Math.sin(t));
}
function toPolar(point)
{
	var x = point._0;
	var y = point._1;
	return _elm_lang$core$Native_Utils.Tuple2(Math.sqrt(x * x + y * y), Math.atan2(y, x));
}

return {
	div: F2(div),
	rem: F2(rem),
	mod: F2(mod),

	pi: Math.PI,
	e: Math.E,
	cos: Math.cos,
	sin: Math.sin,
	tan: Math.tan,
	acos: Math.acos,
	asin: Math.asin,
	atan: Math.atan,
	atan2: F2(Math.atan2),

	degrees: degrees,
	turns: turns,
	fromPolar: fromPolar,
	toPolar: toPolar,

	sqrt: Math.sqrt,
	logBase: F2(logBase),
	negate: negate,
	abs: abs,
	min: F2(min),
	max: F2(max),
	clamp: F3(clamp),
	compare: F2(compare),

	xor: F2(xor),
	not: not,

	truncate: truncate,
	ceiling: Math.ceil,
	floor: Math.floor,
	round: Math.round,
	toFloat: function(x) { return x; },
	isNaN: isNaN,
	isInfinite: isInfinite
};

}();
//import //

var _elm_lang$core$Native_Utils = function() {

// COMPARISONS

function eq(x, y)
{
	var stack = [];
	var isEqual = eqHelp(x, y, 0, stack);
	var pair;
	while (isEqual && (pair = stack.pop()))
	{
		isEqual = eqHelp(pair.x, pair.y, 0, stack);
	}
	return isEqual;
}


function eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push({ x: x, y: y });
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object')
	{
		if (typeof x === 'function')
		{
			throw new Error(
				'Trying to use `(==)` on functions. There is no way to know if functions are "the same" in the Elm sense.'
				+ ' Read more about this at http://package.elm-lang.org/packages/elm-lang/core/latest/Basics#=='
				+ ' which describes why it is this way and what the better version will look like.'
			);
		}
		return false;
	}

	if (x === null || y === null)
	{
		return false
	}

	if (x instanceof Date)
	{
		return x.getTime() === y.getTime();
	}

	if (!('ctor' in x))
	{
		for (var key in x)
		{
			if (!eqHelp(x[key], y[key], depth + 1, stack))
			{
				return false;
			}
		}
		return true;
	}

	// convert Dicts and Sets to lists
	if (x.ctor === 'RBNode_elm_builtin' || x.ctor === 'RBEmpty_elm_builtin')
	{
		x = _elm_lang$core$Dict$toList(x);
		y = _elm_lang$core$Dict$toList(y);
	}
	if (x.ctor === 'Set_elm_builtin')
	{
		x = _elm_lang$core$Set$toList(x);
		y = _elm_lang$core$Set$toList(y);
	}

	// check if lists are equal without recursion
	if (x.ctor === '::')
	{
		var a = x;
		var b = y;
		while (a.ctor === '::' && b.ctor === '::')
		{
			if (!eqHelp(a._0, b._0, depth + 1, stack))
			{
				return false;
			}
			a = a._1;
			b = b._1;
		}
		return a.ctor === b.ctor;
	}

	// check if Arrays are equal
	if (x.ctor === '_Array')
	{
		var xs = _elm_lang$core$Native_Array.toJSArray(x);
		var ys = _elm_lang$core$Native_Array.toJSArray(y);
		if (xs.length !== ys.length)
		{
			return false;
		}
		for (var i = 0; i < xs.length; i++)
		{
			if (!eqHelp(xs[i], ys[i], depth + 1, stack))
			{
				return false;
			}
		}
		return true;
	}

	if (!eqHelp(x.ctor, y.ctor, depth + 1, stack))
	{
		return false;
	}

	for (var key in x)
	{
		if (!eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

var LT = -1, EQ = 0, GT = 1;

function cmp(x, y)
{
	if (typeof x !== 'object')
	{
		return x === y ? EQ : x < y ? LT : GT;
	}

	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? EQ : a < b ? LT : GT;
	}

	if (x.ctor === '::' || x.ctor === '[]')
	{
		while (x.ctor === '::' && y.ctor === '::')
		{
			var ord = cmp(x._0, y._0);
			if (ord !== EQ)
			{
				return ord;
			}
			x = x._1;
			y = y._1;
		}
		return x.ctor === y.ctor ? EQ : x.ctor === '[]' ? LT : GT;
	}

	if (x.ctor.slice(0, 6) === '_Tuple')
	{
		var ord;
		var n = x.ctor.slice(6) - 0;
		var err = 'cannot compare tuples with more than 6 elements.';
		if (n === 0) return EQ;
		if (n >= 1) { ord = cmp(x._0, y._0); if (ord !== EQ) return ord;
		if (n >= 2) { ord = cmp(x._1, y._1); if (ord !== EQ) return ord;
		if (n >= 3) { ord = cmp(x._2, y._2); if (ord !== EQ) return ord;
		if (n >= 4) { ord = cmp(x._3, y._3); if (ord !== EQ) return ord;
		if (n >= 5) { ord = cmp(x._4, y._4); if (ord !== EQ) return ord;
		if (n >= 6) { ord = cmp(x._5, y._5); if (ord !== EQ) return ord;
		if (n >= 7) throw new Error('Comparison error: ' + err); } } } } } }
		return EQ;
	}

	throw new Error(
		'Comparison error: comparison is only defined on ints, '
		+ 'floats, times, chars, strings, lists of comparable values, '
		+ 'and tuples of comparable values.'
	);
}


// COMMON VALUES

var Tuple0 = {
	ctor: '_Tuple0'
};

function Tuple2(x, y)
{
	return {
		ctor: '_Tuple2',
		_0: x,
		_1: y
	};
}

function chr(c)
{
	return new String(c);
}


// GUID

var count = 0;
function guid(_)
{
	return count++;
}


// RECORDS

function update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


//// LIST STUFF ////

var Nil = { ctor: '[]' };

function Cons(hd, tl)
{
	return {
		ctor: '::',
		_0: hd,
		_1: tl
	};
}

function append(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (xs.ctor === '[]')
	{
		return ys;
	}
	var root = Cons(xs._0, Nil);
	var curr = root;
	xs = xs._1;
	while (xs.ctor !== '[]')
	{
		curr._1 = Cons(xs._0, Nil);
		xs = xs._1;
		curr = curr._1;
	}
	curr._1 = ys;
	return root;
}


// CRASHES

function crash(moduleName, region)
{
	return function(message) {
		throw new Error(
			'Ran into a `Debug.crash` in module `' + moduleName + '` ' + regionToString(region) + '\n'
			+ 'The message provided by the code author is:\n\n    '
			+ message
		);
	};
}

function crashCase(moduleName, region, value)
{
	return function(message) {
		throw new Error(
			'Ran into a `Debug.crash` in module `' + moduleName + '`\n\n'
			+ 'This was caused by the `case` expression ' + regionToString(region) + '.\n'
			+ 'One of the branches ended with a crash and the following value got through:\n\n    ' + toString(value) + '\n\n'
			+ 'The message provided by the code author is:\n\n    '
			+ message
		);
	};
}

function regionToString(region)
{
	if (region.start.line == region.end.line)
	{
		return 'on line ' + region.start.line;
	}
	return 'between lines ' + region.start.line + ' and ' + region.end.line;
}


// TO STRING

function toString(v)
{
	var type = typeof v;
	if (type === 'function')
	{
		return '<function>';
	}

	if (type === 'boolean')
	{
		return v ? 'True' : 'False';
	}

	if (type === 'number')
	{
		return v + '';
	}

	if (v instanceof String)
	{
		return '\'' + addSlashes(v, true) + '\'';
	}

	if (type === 'string')
	{
		return '"' + addSlashes(v, false) + '"';
	}

	if (v === null)
	{
		return 'null';
	}

	if (type === 'object' && 'ctor' in v)
	{
		var ctorStarter = v.ctor.substring(0, 5);

		if (ctorStarter === '_Tupl')
		{
			var output = [];
			for (var k in v)
			{
				if (k === 'ctor') continue;
				output.push(toString(v[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (ctorStarter === '_Task')
		{
			return '<task>'
		}

		if (v.ctor === '_Array')
		{
			var list = _elm_lang$core$Array$toList(v);
			return 'Array.fromList ' + toString(list);
		}

		if (v.ctor === '<decoder>')
		{
			return '<decoder>';
		}

		if (v.ctor === '_Process')
		{
			return '<process:' + v.id + '>';
		}

		if (v.ctor === '::')
		{
			var output = '[' + toString(v._0);
			v = v._1;
			while (v.ctor === '::')
			{
				output += ',' + toString(v._0);
				v = v._1;
			}
			return output + ']';
		}

		if (v.ctor === '[]')
		{
			return '[]';
		}

		if (v.ctor === 'Set_elm_builtin')
		{
			return 'Set.fromList ' + toString(_elm_lang$core$Set$toList(v));
		}

		if (v.ctor === 'RBNode_elm_builtin' || v.ctor === 'RBEmpty_elm_builtin')
		{
			return 'Dict.fromList ' + toString(_elm_lang$core$Dict$toList(v));
		}

		var output = '';
		for (var i in v)
		{
			if (i === 'ctor') continue;
			var str = toString(v[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return v.ctor + output;
	}

	if (type === 'object')
	{
		if (v instanceof Date)
		{
			return '<' + v.toString() + '>';
		}

		if (v.elm_web_socket)
		{
			return '<websocket>';
		}

		var output = [];
		for (var k in v)
		{
			output.push(k + ' = ' + toString(v[k]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return '<internal structure>';
}

function addSlashes(str, isChar)
{
	var s = str.replace(/\\/g, '\\\\')
			  .replace(/\n/g, '\\n')
			  .replace(/\t/g, '\\t')
			  .replace(/\r/g, '\\r')
			  .replace(/\v/g, '\\v')
			  .replace(/\0/g, '\\0');
	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}


return {
	eq: eq,
	cmp: cmp,
	Tuple0: Tuple0,
	Tuple2: Tuple2,
	chr: chr,
	update: update,
	guid: guid,

	append: F2(append),

	crash: crash,
	crashCase: crashCase,

	toString: toString
};

}();
var _elm_lang$core$Basics$never = function (_p0) {
	never:
	while (true) {
		var _p1 = _p0;
		var _v1 = _p1._0;
		_p0 = _v1;
		continue never;
	}
};
var _elm_lang$core$Basics$uncurry = F2(
	function (f, _p2) {
		var _p3 = _p2;
		return A2(f, _p3._0, _p3._1);
	});
var _elm_lang$core$Basics$curry = F3(
	function (f, a, b) {
		return f(
			{ctor: '_Tuple2', _0: a, _1: b});
	});
var _elm_lang$core$Basics$flip = F3(
	function (f, b, a) {
		return A2(f, a, b);
	});
var _elm_lang$core$Basics$always = F2(
	function (a, _p4) {
		return a;
	});
var _elm_lang$core$Basics$identity = function (x) {
	return x;
};
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['<|'] = F2(
	function (f, x) {
		return f(x);
	});
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['|>'] = F2(
	function (x, f) {
		return f(x);
	});
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['>>'] = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['<<'] = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['++'] = _elm_lang$core$Native_Utils.append;
var _elm_lang$core$Basics$toString = _elm_lang$core$Native_Utils.toString;
var _elm_lang$core$Basics$isInfinite = _elm_lang$core$Native_Basics.isInfinite;
var _elm_lang$core$Basics$isNaN = _elm_lang$core$Native_Basics.isNaN;
var _elm_lang$core$Basics$toFloat = _elm_lang$core$Native_Basics.toFloat;
var _elm_lang$core$Basics$ceiling = _elm_lang$core$Native_Basics.ceiling;
var _elm_lang$core$Basics$floor = _elm_lang$core$Native_Basics.floor;
var _elm_lang$core$Basics$truncate = _elm_lang$core$Native_Basics.truncate;
var _elm_lang$core$Basics$round = _elm_lang$core$Native_Basics.round;
var _elm_lang$core$Basics$not = _elm_lang$core$Native_Basics.not;
var _elm_lang$core$Basics$xor = _elm_lang$core$Native_Basics.xor;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['||'] = _elm_lang$core$Native_Basics.or;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['&&'] = _elm_lang$core$Native_Basics.and;
var _elm_lang$core$Basics$max = _elm_lang$core$Native_Basics.max;
var _elm_lang$core$Basics$min = _elm_lang$core$Native_Basics.min;
var _elm_lang$core$Basics$compare = _elm_lang$core$Native_Basics.compare;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['>='] = _elm_lang$core$Native_Basics.ge;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['<='] = _elm_lang$core$Native_Basics.le;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['>'] = _elm_lang$core$Native_Basics.gt;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['<'] = _elm_lang$core$Native_Basics.lt;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['/='] = _elm_lang$core$Native_Basics.neq;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['=='] = _elm_lang$core$Native_Basics.eq;
var _elm_lang$core$Basics$e = _elm_lang$core$Native_Basics.e;
var _elm_lang$core$Basics$pi = _elm_lang$core$Native_Basics.pi;
var _elm_lang$core$Basics$clamp = _elm_lang$core$Native_Basics.clamp;
var _elm_lang$core$Basics$logBase = _elm_lang$core$Native_Basics.logBase;
var _elm_lang$core$Basics$abs = _elm_lang$core$Native_Basics.abs;
var _elm_lang$core$Basics$negate = _elm_lang$core$Native_Basics.negate;
var _elm_lang$core$Basics$sqrt = _elm_lang$core$Native_Basics.sqrt;
var _elm_lang$core$Basics$atan2 = _elm_lang$core$Native_Basics.atan2;
var _elm_lang$core$Basics$atan = _elm_lang$core$Native_Basics.atan;
var _elm_lang$core$Basics$asin = _elm_lang$core$Native_Basics.asin;
var _elm_lang$core$Basics$acos = _elm_lang$core$Native_Basics.acos;
var _elm_lang$core$Basics$tan = _elm_lang$core$Native_Basics.tan;
var _elm_lang$core$Basics$sin = _elm_lang$core$Native_Basics.sin;
var _elm_lang$core$Basics$cos = _elm_lang$core$Native_Basics.cos;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['^'] = _elm_lang$core$Native_Basics.exp;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['%'] = _elm_lang$core$Native_Basics.mod;
var _elm_lang$core$Basics$rem = _elm_lang$core$Native_Basics.rem;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['//'] = _elm_lang$core$Native_Basics.div;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['/'] = _elm_lang$core$Native_Basics.floatDiv;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['*'] = _elm_lang$core$Native_Basics.mul;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['-'] = _elm_lang$core$Native_Basics.sub;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['+'] = _elm_lang$core$Native_Basics.add;
var _elm_lang$core$Basics$toPolar = _elm_lang$core$Native_Basics.toPolar;
var _elm_lang$core$Basics$fromPolar = _elm_lang$core$Native_Basics.fromPolar;
var _elm_lang$core$Basics$turns = _elm_lang$core$Native_Basics.turns;
var _elm_lang$core$Basics$degrees = _elm_lang$core$Native_Basics.degrees;
var _elm_lang$core$Basics$radians = function (t) {
	return t;
};
var _elm_lang$core$Basics$GT = {ctor: 'GT'};
var _elm_lang$core$Basics$EQ = {ctor: 'EQ'};
var _elm_lang$core$Basics$LT = {ctor: 'LT'};
var _elm_lang$core$Basics$JustOneMore = function (a) {
	return {ctor: 'JustOneMore', _0: a};
};

var _elm_lang$core$Maybe$withDefault = F2(
	function ($default, maybe) {
		var _p0 = maybe;
		if (_p0.ctor === 'Just') {
			return _p0._0;
		} else {
			return $default;
		}
	});
var _elm_lang$core$Maybe$Nothing = {ctor: 'Nothing'};
var _elm_lang$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		var _p1 = maybeValue;
		if (_p1.ctor === 'Just') {
			return callback(_p1._0);
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _elm_lang$core$Maybe$Just = function (a) {
	return {ctor: 'Just', _0: a};
};
var _elm_lang$core$Maybe$map = F2(
	function (f, maybe) {
		var _p2 = maybe;
		if (_p2.ctor === 'Just') {
			return _elm_lang$core$Maybe$Just(
				f(_p2._0));
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _elm_lang$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		var _p3 = {ctor: '_Tuple2', _0: ma, _1: mb};
		if (((_p3.ctor === '_Tuple2') && (_p3._0.ctor === 'Just')) && (_p3._1.ctor === 'Just')) {
			return _elm_lang$core$Maybe$Just(
				A2(func, _p3._0._0, _p3._1._0));
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _elm_lang$core$Maybe$map3 = F4(
	function (func, ma, mb, mc) {
		var _p4 = {ctor: '_Tuple3', _0: ma, _1: mb, _2: mc};
		if ((((_p4.ctor === '_Tuple3') && (_p4._0.ctor === 'Just')) && (_p4._1.ctor === 'Just')) && (_p4._2.ctor === 'Just')) {
			return _elm_lang$core$Maybe$Just(
				A3(func, _p4._0._0, _p4._1._0, _p4._2._0));
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _elm_lang$core$Maybe$map4 = F5(
	function (func, ma, mb, mc, md) {
		var _p5 = {ctor: '_Tuple4', _0: ma, _1: mb, _2: mc, _3: md};
		if (((((_p5.ctor === '_Tuple4') && (_p5._0.ctor === 'Just')) && (_p5._1.ctor === 'Just')) && (_p5._2.ctor === 'Just')) && (_p5._3.ctor === 'Just')) {
			return _elm_lang$core$Maybe$Just(
				A4(func, _p5._0._0, _p5._1._0, _p5._2._0, _p5._3._0));
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _elm_lang$core$Maybe$map5 = F6(
	function (func, ma, mb, mc, md, me) {
		var _p6 = {ctor: '_Tuple5', _0: ma, _1: mb, _2: mc, _3: md, _4: me};
		if ((((((_p6.ctor === '_Tuple5') && (_p6._0.ctor === 'Just')) && (_p6._1.ctor === 'Just')) && (_p6._2.ctor === 'Just')) && (_p6._3.ctor === 'Just')) && (_p6._4.ctor === 'Just')) {
			return _elm_lang$core$Maybe$Just(
				A5(func, _p6._0._0, _p6._1._0, _p6._2._0, _p6._3._0, _p6._4._0));
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});

//import Native.Utils //

var _elm_lang$core$Native_List = function() {

var Nil = { ctor: '[]' };

function Cons(hd, tl)
{
	return { ctor: '::', _0: hd, _1: tl };
}

function fromArray(arr)
{
	var out = Nil;
	for (var i = arr.length; i--; )
	{
		out = Cons(arr[i], out);
	}
	return out;
}

function toArray(xs)
{
	var out = [];
	while (xs.ctor !== '[]')
	{
		out.push(xs._0);
		xs = xs._1;
	}
	return out;
}

function foldr(f, b, xs)
{
	var arr = toArray(xs);
	var acc = b;
	for (var i = arr.length; i--; )
	{
		acc = A2(f, arr[i], acc);
	}
	return acc;
}

function map2(f, xs, ys)
{
	var arr = [];
	while (xs.ctor !== '[]' && ys.ctor !== '[]')
	{
		arr.push(A2(f, xs._0, ys._0));
		xs = xs._1;
		ys = ys._1;
	}
	return fromArray(arr);
}

function map3(f, xs, ys, zs)
{
	var arr = [];
	while (xs.ctor !== '[]' && ys.ctor !== '[]' && zs.ctor !== '[]')
	{
		arr.push(A3(f, xs._0, ys._0, zs._0));
		xs = xs._1;
		ys = ys._1;
		zs = zs._1;
	}
	return fromArray(arr);
}

function map4(f, ws, xs, ys, zs)
{
	var arr = [];
	while (   ws.ctor !== '[]'
		   && xs.ctor !== '[]'
		   && ys.ctor !== '[]'
		   && zs.ctor !== '[]')
	{
		arr.push(A4(f, ws._0, xs._0, ys._0, zs._0));
		ws = ws._1;
		xs = xs._1;
		ys = ys._1;
		zs = zs._1;
	}
	return fromArray(arr);
}

function map5(f, vs, ws, xs, ys, zs)
{
	var arr = [];
	while (   vs.ctor !== '[]'
		   && ws.ctor !== '[]'
		   && xs.ctor !== '[]'
		   && ys.ctor !== '[]'
		   && zs.ctor !== '[]')
	{
		arr.push(A5(f, vs._0, ws._0, xs._0, ys._0, zs._0));
		vs = vs._1;
		ws = ws._1;
		xs = xs._1;
		ys = ys._1;
		zs = zs._1;
	}
	return fromArray(arr);
}

function sortBy(f, xs)
{
	return fromArray(toArray(xs).sort(function(a, b) {
		return _elm_lang$core$Native_Utils.cmp(f(a), f(b));
	}));
}

function sortWith(f, xs)
{
	return fromArray(toArray(xs).sort(function(a, b) {
		var ord = f(a)(b).ctor;
		return ord === 'EQ' ? 0 : ord === 'LT' ? -1 : 1;
	}));
}

return {
	Nil: Nil,
	Cons: Cons,
	cons: F2(Cons),
	toArray: toArray,
	fromArray: fromArray,

	foldr: F3(foldr),

	map2: F3(map2),
	map3: F4(map3),
	map4: F5(map4),
	map5: F6(map5),
	sortBy: F2(sortBy),
	sortWith: F2(sortWith)
};

}();
var _elm_lang$core$List$sortWith = _elm_lang$core$Native_List.sortWith;
var _elm_lang$core$List$sortBy = _elm_lang$core$Native_List.sortBy;
var _elm_lang$core$List$sort = function (xs) {
	return A2(_elm_lang$core$List$sortBy, _elm_lang$core$Basics$identity, xs);
};
var _elm_lang$core$List$singleton = function (value) {
	return {
		ctor: '::',
		_0: value,
		_1: {ctor: '[]'}
	};
};
var _elm_lang$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (_elm_lang$core$Native_Utils.cmp(n, 0) < 1) {
				return list;
			} else {
				var _p0 = list;
				if (_p0.ctor === '[]') {
					return list;
				} else {
					var _v1 = n - 1,
						_v2 = _p0._1;
					n = _v1;
					list = _v2;
					continue drop;
				}
			}
		}
	});
var _elm_lang$core$List$map5 = _elm_lang$core$Native_List.map5;
var _elm_lang$core$List$map4 = _elm_lang$core$Native_List.map4;
var _elm_lang$core$List$map3 = _elm_lang$core$Native_List.map3;
var _elm_lang$core$List$map2 = _elm_lang$core$Native_List.map2;
var _elm_lang$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			var _p1 = list;
			if (_p1.ctor === '[]') {
				return false;
			} else {
				if (isOkay(_p1._0)) {
					return true;
				} else {
					var _v4 = isOkay,
						_v5 = _p1._1;
					isOkay = _v4;
					list = _v5;
					continue any;
				}
			}
		}
	});
var _elm_lang$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			_elm_lang$core$List$any,
			function (_p2) {
				return !isOkay(_p2);
			},
			list);
	});
var _elm_lang$core$List$foldr = _elm_lang$core$Native_List.foldr;
var _elm_lang$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			var _p3 = list;
			if (_p3.ctor === '[]') {
				return acc;
			} else {
				var _v7 = func,
					_v8 = A2(func, _p3._0, acc),
					_v9 = _p3._1;
				func = _v7;
				acc = _v8;
				list = _v9;
				continue foldl;
			}
		}
	});
var _elm_lang$core$List$length = function (xs) {
	return A3(
		_elm_lang$core$List$foldl,
		F2(
			function (_p4, i) {
				return i + 1;
			}),
		0,
		xs);
};
var _elm_lang$core$List$sum = function (numbers) {
	return A3(
		_elm_lang$core$List$foldl,
		F2(
			function (x, y) {
				return x + y;
			}),
		0,
		numbers);
};
var _elm_lang$core$List$product = function (numbers) {
	return A3(
		_elm_lang$core$List$foldl,
		F2(
			function (x, y) {
				return x * y;
			}),
		1,
		numbers);
};
var _elm_lang$core$List$maximum = function (list) {
	var _p5 = list;
	if (_p5.ctor === '::') {
		return _elm_lang$core$Maybe$Just(
			A3(_elm_lang$core$List$foldl, _elm_lang$core$Basics$max, _p5._0, _p5._1));
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _elm_lang$core$List$minimum = function (list) {
	var _p6 = list;
	if (_p6.ctor === '::') {
		return _elm_lang$core$Maybe$Just(
			A3(_elm_lang$core$List$foldl, _elm_lang$core$Basics$min, _p6._0, _p6._1));
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _elm_lang$core$List$member = F2(
	function (x, xs) {
		return A2(
			_elm_lang$core$List$any,
			function (a) {
				return _elm_lang$core$Native_Utils.eq(a, x);
			},
			xs);
	});
var _elm_lang$core$List$isEmpty = function (xs) {
	var _p7 = xs;
	if (_p7.ctor === '[]') {
		return true;
	} else {
		return false;
	}
};
var _elm_lang$core$List$tail = function (list) {
	var _p8 = list;
	if (_p8.ctor === '::') {
		return _elm_lang$core$Maybe$Just(_p8._1);
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _elm_lang$core$List$head = function (list) {
	var _p9 = list;
	if (_p9.ctor === '::') {
		return _elm_lang$core$Maybe$Just(_p9._0);
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _elm_lang$core$List_ops = _elm_lang$core$List_ops || {};
_elm_lang$core$List_ops['::'] = _elm_lang$core$Native_List.cons;
var _elm_lang$core$List$map = F2(
	function (f, xs) {
		return A3(
			_elm_lang$core$List$foldr,
			F2(
				function (x, acc) {
					return {
						ctor: '::',
						_0: f(x),
						_1: acc
					};
				}),
			{ctor: '[]'},
			xs);
	});
var _elm_lang$core$List$filter = F2(
	function (pred, xs) {
		var conditionalCons = F2(
			function (front, back) {
				return pred(front) ? {ctor: '::', _0: front, _1: back} : back;
			});
		return A3(
			_elm_lang$core$List$foldr,
			conditionalCons,
			{ctor: '[]'},
			xs);
	});
var _elm_lang$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _p10 = f(mx);
		if (_p10.ctor === 'Just') {
			return {ctor: '::', _0: _p10._0, _1: xs};
		} else {
			return xs;
		}
	});
var _elm_lang$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			_elm_lang$core$List$foldr,
			_elm_lang$core$List$maybeCons(f),
			{ctor: '[]'},
			xs);
	});
var _elm_lang$core$List$reverse = function (list) {
	return A3(
		_elm_lang$core$List$foldl,
		F2(
			function (x, y) {
				return {ctor: '::', _0: x, _1: y};
			}),
		{ctor: '[]'},
		list);
};
var _elm_lang$core$List$scanl = F3(
	function (f, b, xs) {
		var scan1 = F2(
			function (x, accAcc) {
				var _p11 = accAcc;
				if (_p11.ctor === '::') {
					return {
						ctor: '::',
						_0: A2(f, x, _p11._0),
						_1: accAcc
					};
				} else {
					return {ctor: '[]'};
				}
			});
		return _elm_lang$core$List$reverse(
			A3(
				_elm_lang$core$List$foldl,
				scan1,
				{
					ctor: '::',
					_0: b,
					_1: {ctor: '[]'}
				},
				xs));
	});
var _elm_lang$core$List$append = F2(
	function (xs, ys) {
		var _p12 = ys;
		if (_p12.ctor === '[]') {
			return xs;
		} else {
			return A3(
				_elm_lang$core$List$foldr,
				F2(
					function (x, y) {
						return {ctor: '::', _0: x, _1: y};
					}),
				ys,
				xs);
		}
	});
var _elm_lang$core$List$concat = function (lists) {
	return A3(
		_elm_lang$core$List$foldr,
		_elm_lang$core$List$append,
		{ctor: '[]'},
		lists);
};
var _elm_lang$core$List$concatMap = F2(
	function (f, list) {
		return _elm_lang$core$List$concat(
			A2(_elm_lang$core$List$map, f, list));
	});
var _elm_lang$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _p13) {
				var _p14 = _p13;
				var _p16 = _p14._0;
				var _p15 = _p14._1;
				return pred(x) ? {
					ctor: '_Tuple2',
					_0: {ctor: '::', _0: x, _1: _p16},
					_1: _p15
				} : {
					ctor: '_Tuple2',
					_0: _p16,
					_1: {ctor: '::', _0: x, _1: _p15}
				};
			});
		return A3(
			_elm_lang$core$List$foldr,
			step,
			{
				ctor: '_Tuple2',
				_0: {ctor: '[]'},
				_1: {ctor: '[]'}
			},
			list);
	});
var _elm_lang$core$List$unzip = function (pairs) {
	var step = F2(
		function (_p18, _p17) {
			var _p19 = _p18;
			var _p20 = _p17;
			return {
				ctor: '_Tuple2',
				_0: {ctor: '::', _0: _p19._0, _1: _p20._0},
				_1: {ctor: '::', _0: _p19._1, _1: _p20._1}
			};
		});
	return A3(
		_elm_lang$core$List$foldr,
		step,
		{
			ctor: '_Tuple2',
			_0: {ctor: '[]'},
			_1: {ctor: '[]'}
		},
		pairs);
};
var _elm_lang$core$List$intersperse = F2(
	function (sep, xs) {
		var _p21 = xs;
		if (_p21.ctor === '[]') {
			return {ctor: '[]'};
		} else {
			var step = F2(
				function (x, rest) {
					return {
						ctor: '::',
						_0: sep,
						_1: {ctor: '::', _0: x, _1: rest}
					};
				});
			var spersed = A3(
				_elm_lang$core$List$foldr,
				step,
				{ctor: '[]'},
				_p21._1);
			return {ctor: '::', _0: _p21._0, _1: spersed};
		}
	});
var _elm_lang$core$List$takeReverse = F3(
	function (n, list, taken) {
		takeReverse:
		while (true) {
			if (_elm_lang$core$Native_Utils.cmp(n, 0) < 1) {
				return taken;
			} else {
				var _p22 = list;
				if (_p22.ctor === '[]') {
					return taken;
				} else {
					var _v23 = n - 1,
						_v24 = _p22._1,
						_v25 = {ctor: '::', _0: _p22._0, _1: taken};
					n = _v23;
					list = _v24;
					taken = _v25;
					continue takeReverse;
				}
			}
		}
	});
var _elm_lang$core$List$takeTailRec = F2(
	function (n, list) {
		return _elm_lang$core$List$reverse(
			A3(
				_elm_lang$core$List$takeReverse,
				n,
				list,
				{ctor: '[]'}));
	});
var _elm_lang$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (_elm_lang$core$Native_Utils.cmp(n, 0) < 1) {
			return {ctor: '[]'};
		} else {
			var _p23 = {ctor: '_Tuple2', _0: n, _1: list};
			_v26_5:
			do {
				_v26_1:
				do {
					if (_p23.ctor === '_Tuple2') {
						if (_p23._1.ctor === '[]') {
							return list;
						} else {
							if (_p23._1._1.ctor === '::') {
								switch (_p23._0) {
									case 1:
										break _v26_1;
									case 2:
										return {
											ctor: '::',
											_0: _p23._1._0,
											_1: {
												ctor: '::',
												_0: _p23._1._1._0,
												_1: {ctor: '[]'}
											}
										};
									case 3:
										if (_p23._1._1._1.ctor === '::') {
											return {
												ctor: '::',
												_0: _p23._1._0,
												_1: {
													ctor: '::',
													_0: _p23._1._1._0,
													_1: {
														ctor: '::',
														_0: _p23._1._1._1._0,
														_1: {ctor: '[]'}
													}
												}
											};
										} else {
											break _v26_5;
										}
									default:
										if ((_p23._1._1._1.ctor === '::') && (_p23._1._1._1._1.ctor === '::')) {
											var _p28 = _p23._1._1._1._0;
											var _p27 = _p23._1._1._0;
											var _p26 = _p23._1._0;
											var _p25 = _p23._1._1._1._1._0;
											var _p24 = _p23._1._1._1._1._1;
											return (_elm_lang$core$Native_Utils.cmp(ctr, 1000) > 0) ? {
												ctor: '::',
												_0: _p26,
												_1: {
													ctor: '::',
													_0: _p27,
													_1: {
														ctor: '::',
														_0: _p28,
														_1: {
															ctor: '::',
															_0: _p25,
															_1: A2(_elm_lang$core$List$takeTailRec, n - 4, _p24)
														}
													}
												}
											} : {
												ctor: '::',
												_0: _p26,
												_1: {
													ctor: '::',
													_0: _p27,
													_1: {
														ctor: '::',
														_0: _p28,
														_1: {
															ctor: '::',
															_0: _p25,
															_1: A3(_elm_lang$core$List$takeFast, ctr + 1, n - 4, _p24)
														}
													}
												}
											};
										} else {
											break _v26_5;
										}
								}
							} else {
								if (_p23._0 === 1) {
									break _v26_1;
								} else {
									break _v26_5;
								}
							}
						}
					} else {
						break _v26_5;
					}
				} while(false);
				return {
					ctor: '::',
					_0: _p23._1._0,
					_1: {ctor: '[]'}
				};
			} while(false);
			return list;
		}
	});
var _elm_lang$core$List$take = F2(
	function (n, list) {
		return A3(_elm_lang$core$List$takeFast, 0, n, list);
	});
var _elm_lang$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (_elm_lang$core$Native_Utils.cmp(n, 0) < 1) {
				return result;
			} else {
				var _v27 = {ctor: '::', _0: value, _1: result},
					_v28 = n - 1,
					_v29 = value;
				result = _v27;
				n = _v28;
				value = _v29;
				continue repeatHelp;
			}
		}
	});
var _elm_lang$core$List$repeat = F2(
	function (n, value) {
		return A3(
			_elm_lang$core$List$repeatHelp,
			{ctor: '[]'},
			n,
			value);
	});
var _elm_lang$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_elm_lang$core$Native_Utils.cmp(lo, hi) < 1) {
				var _v30 = lo,
					_v31 = hi - 1,
					_v32 = {ctor: '::', _0: hi, _1: list};
				lo = _v30;
				hi = _v31;
				list = _v32;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var _elm_lang$core$List$range = F2(
	function (lo, hi) {
		return A3(
			_elm_lang$core$List$rangeHelp,
			lo,
			hi,
			{ctor: '[]'});
	});
var _elm_lang$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			_elm_lang$core$List$map2,
			f,
			A2(
				_elm_lang$core$List$range,
				0,
				_elm_lang$core$List$length(xs) - 1),
			xs);
	});

var _elm_lang$core$Array$append = _elm_lang$core$Native_Array.append;
var _elm_lang$core$Array$length = _elm_lang$core$Native_Array.length;
var _elm_lang$core$Array$isEmpty = function (array) {
	return _elm_lang$core$Native_Utils.eq(
		_elm_lang$core$Array$length(array),
		0);
};
var _elm_lang$core$Array$slice = _elm_lang$core$Native_Array.slice;
var _elm_lang$core$Array$set = _elm_lang$core$Native_Array.set;
var _elm_lang$core$Array$get = F2(
	function (i, array) {
		return ((_elm_lang$core$Native_Utils.cmp(0, i) < 1) && (_elm_lang$core$Native_Utils.cmp(
			i,
			_elm_lang$core$Native_Array.length(array)) < 0)) ? _elm_lang$core$Maybe$Just(
			A2(_elm_lang$core$Native_Array.get, i, array)) : _elm_lang$core$Maybe$Nothing;
	});
var _elm_lang$core$Array$push = _elm_lang$core$Native_Array.push;
var _elm_lang$core$Array$empty = _elm_lang$core$Native_Array.empty;
var _elm_lang$core$Array$filter = F2(
	function (isOkay, arr) {
		var update = F2(
			function (x, xs) {
				return isOkay(x) ? A2(_elm_lang$core$Native_Array.push, x, xs) : xs;
			});
		return A3(_elm_lang$core$Native_Array.foldl, update, _elm_lang$core$Native_Array.empty, arr);
	});
var _elm_lang$core$Array$foldr = _elm_lang$core$Native_Array.foldr;
var _elm_lang$core$Array$foldl = _elm_lang$core$Native_Array.foldl;
var _elm_lang$core$Array$indexedMap = _elm_lang$core$Native_Array.indexedMap;
var _elm_lang$core$Array$map = _elm_lang$core$Native_Array.map;
var _elm_lang$core$Array$toIndexedList = function (array) {
	return A3(
		_elm_lang$core$List$map2,
		F2(
			function (v0, v1) {
				return {ctor: '_Tuple2', _0: v0, _1: v1};
			}),
		A2(
			_elm_lang$core$List$range,
			0,
			_elm_lang$core$Native_Array.length(array) - 1),
		_elm_lang$core$Native_Array.toList(array));
};
var _elm_lang$core$Array$toList = _elm_lang$core$Native_Array.toList;
var _elm_lang$core$Array$fromList = _elm_lang$core$Native_Array.fromList;
var _elm_lang$core$Array$initialize = _elm_lang$core$Native_Array.initialize;
var _elm_lang$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			_elm_lang$core$Array$initialize,
			n,
			_elm_lang$core$Basics$always(e));
	});
var _elm_lang$core$Array$Array = {ctor: 'Array'};

//import Native.Utils //

var _elm_lang$core$Native_Debug = function() {

function log(tag, value)
{
	var msg = tag + ': ' + _elm_lang$core$Native_Utils.toString(value);
	var process = process || {};
	if (process.stdout)
	{
		process.stdout.write(msg);
	}
	else
	{
		console.log(msg);
	}
	return value;
}

function crash(message)
{
	throw new Error(message);
}

return {
	crash: crash,
	log: F2(log)
};

}();
//import Maybe, Native.List, Native.Utils, Result //

var _elm_lang$core$Native_String = function() {

function isEmpty(str)
{
	return str.length === 0;
}
function cons(chr, str)
{
	return chr + str;
}
function uncons(str)
{
	var hd = str[0];
	if (hd)
	{
		return _elm_lang$core$Maybe$Just(_elm_lang$core$Native_Utils.Tuple2(_elm_lang$core$Native_Utils.chr(hd), str.slice(1)));
	}
	return _elm_lang$core$Maybe$Nothing;
}
function append(a, b)
{
	return a + b;
}
function concat(strs)
{
	return _elm_lang$core$Native_List.toArray(strs).join('');
}
function length(str)
{
	return str.length;
}
function map(f, str)
{
	var out = str.split('');
	for (var i = out.length; i--; )
	{
		out[i] = f(_elm_lang$core$Native_Utils.chr(out[i]));
	}
	return out.join('');
}
function filter(pred, str)
{
	return str.split('').map(_elm_lang$core$Native_Utils.chr).filter(pred).join('');
}
function reverse(str)
{
	return str.split('').reverse().join('');
}
function foldl(f, b, str)
{
	var len = str.length;
	for (var i = 0; i < len; ++i)
	{
		b = A2(f, _elm_lang$core$Native_Utils.chr(str[i]), b);
	}
	return b;
}
function foldr(f, b, str)
{
	for (var i = str.length; i--; )
	{
		b = A2(f, _elm_lang$core$Native_Utils.chr(str[i]), b);
	}
	return b;
}
function split(sep, str)
{
	return _elm_lang$core$Native_List.fromArray(str.split(sep));
}
function join(sep, strs)
{
	return _elm_lang$core$Native_List.toArray(strs).join(sep);
}
function repeat(n, str)
{
	var result = '';
	while (n > 0)
	{
		if (n & 1)
		{
			result += str;
		}
		n >>= 1, str += str;
	}
	return result;
}
function slice(start, end, str)
{
	return str.slice(start, end);
}
function left(n, str)
{
	return n < 1 ? '' : str.slice(0, n);
}
function right(n, str)
{
	return n < 1 ? '' : str.slice(-n);
}
function dropLeft(n, str)
{
	return n < 1 ? str : str.slice(n);
}
function dropRight(n, str)
{
	return n < 1 ? str : str.slice(0, -n);
}
function pad(n, chr, str)
{
	var half = (n - str.length) / 2;
	return repeat(Math.ceil(half), chr) + str + repeat(half | 0, chr);
}
function padRight(n, chr, str)
{
	return str + repeat(n - str.length, chr);
}
function padLeft(n, chr, str)
{
	return repeat(n - str.length, chr) + str;
}

function trim(str)
{
	return str.trim();
}
function trimLeft(str)
{
	return str.replace(/^\s+/, '');
}
function trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function words(str)
{
	return _elm_lang$core$Native_List.fromArray(str.trim().split(/\s+/g));
}
function lines(str)
{
	return _elm_lang$core$Native_List.fromArray(str.split(/\r\n|\r|\n/g));
}

function toUpper(str)
{
	return str.toUpperCase();
}
function toLower(str)
{
	return str.toLowerCase();
}

function any(pred, str)
{
	for (var i = str.length; i--; )
	{
		if (pred(_elm_lang$core$Native_Utils.chr(str[i])))
		{
			return true;
		}
	}
	return false;
}
function all(pred, str)
{
	for (var i = str.length; i--; )
	{
		if (!pred(_elm_lang$core$Native_Utils.chr(str[i])))
		{
			return false;
		}
	}
	return true;
}

function contains(sub, str)
{
	return str.indexOf(sub) > -1;
}
function startsWith(sub, str)
{
	return str.indexOf(sub) === 0;
}
function endsWith(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
}
function indexes(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _elm_lang$core$Native_List.Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _elm_lang$core$Native_List.fromArray(is);
}


function toInt(s)
{
	var len = s.length;

	// if empty
	if (len === 0)
	{
		return intErr(s);
	}

	// if hex
	var c = s[0];
	if (c === '0' && s[1] === 'x')
	{
		for (var i = 2; i < len; ++i)
		{
			var c = s[i];
			if (('0' <= c && c <= '9') || ('A' <= c && c <= 'F') || ('a' <= c && c <= 'f'))
			{
				continue;
			}
			return intErr(s);
		}
		return _elm_lang$core$Result$Ok(parseInt(s, 16));
	}

	// is decimal
	if (c > '9' || (c < '0' && c !== '-' && c !== '+'))
	{
		return intErr(s);
	}
	for (var i = 1; i < len; ++i)
	{
		var c = s[i];
		if (c < '0' || '9' < c)
		{
			return intErr(s);
		}
	}

	return _elm_lang$core$Result$Ok(parseInt(s, 10));
}

function intErr(s)
{
	return _elm_lang$core$Result$Err("could not convert string '" + s + "' to an Int");
}


function toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return floatErr(s);
	}
	var n = +s;
	// faster isNaN check
	return n === n ? _elm_lang$core$Result$Ok(n) : floatErr(s);
}

function floatErr(s)
{
	return _elm_lang$core$Result$Err("could not convert string '" + s + "' to a Float");
}


function toList(str)
{
	return _elm_lang$core$Native_List.fromArray(str.split('').map(_elm_lang$core$Native_Utils.chr));
}
function fromList(chars)
{
	return _elm_lang$core$Native_List.toArray(chars).join('');
}

return {
	isEmpty: isEmpty,
	cons: F2(cons),
	uncons: uncons,
	append: F2(append),
	concat: concat,
	length: length,
	map: F2(map),
	filter: F2(filter),
	reverse: reverse,
	foldl: F3(foldl),
	foldr: F3(foldr),

	split: F2(split),
	join: F2(join),
	repeat: F2(repeat),

	slice: F3(slice),
	left: F2(left),
	right: F2(right),
	dropLeft: F2(dropLeft),
	dropRight: F2(dropRight),

	pad: F3(pad),
	padLeft: F3(padLeft),
	padRight: F3(padRight),

	trim: trim,
	trimLeft: trimLeft,
	trimRight: trimRight,

	words: words,
	lines: lines,

	toUpper: toUpper,
	toLower: toLower,

	any: F2(any),
	all: F2(all),

	contains: F2(contains),
	startsWith: F2(startsWith),
	endsWith: F2(endsWith),
	indexes: F2(indexes),

	toInt: toInt,
	toFloat: toFloat,
	toList: toList,
	fromList: fromList
};

}();

//import Native.Utils //

var _elm_lang$core$Native_Char = function() {

return {
	fromCode: function(c) { return _elm_lang$core$Native_Utils.chr(String.fromCharCode(c)); },
	toCode: function(c) { return c.charCodeAt(0); },
	toUpper: function(c) { return _elm_lang$core$Native_Utils.chr(c.toUpperCase()); },
	toLower: function(c) { return _elm_lang$core$Native_Utils.chr(c.toLowerCase()); },
	toLocaleUpper: function(c) { return _elm_lang$core$Native_Utils.chr(c.toLocaleUpperCase()); },
	toLocaleLower: function(c) { return _elm_lang$core$Native_Utils.chr(c.toLocaleLowerCase()); }
};

}();
var _elm_lang$core$Char$fromCode = _elm_lang$core$Native_Char.fromCode;
var _elm_lang$core$Char$toCode = _elm_lang$core$Native_Char.toCode;
var _elm_lang$core$Char$toLocaleLower = _elm_lang$core$Native_Char.toLocaleLower;
var _elm_lang$core$Char$toLocaleUpper = _elm_lang$core$Native_Char.toLocaleUpper;
var _elm_lang$core$Char$toLower = _elm_lang$core$Native_Char.toLower;
var _elm_lang$core$Char$toUpper = _elm_lang$core$Native_Char.toUpper;
var _elm_lang$core$Char$isBetween = F3(
	function (low, high, $char) {
		var code = _elm_lang$core$Char$toCode($char);
		return (_elm_lang$core$Native_Utils.cmp(
			code,
			_elm_lang$core$Char$toCode(low)) > -1) && (_elm_lang$core$Native_Utils.cmp(
			code,
			_elm_lang$core$Char$toCode(high)) < 1);
	});
var _elm_lang$core$Char$isUpper = A2(
	_elm_lang$core$Char$isBetween,
	_elm_lang$core$Native_Utils.chr('A'),
	_elm_lang$core$Native_Utils.chr('Z'));
var _elm_lang$core$Char$isLower = A2(
	_elm_lang$core$Char$isBetween,
	_elm_lang$core$Native_Utils.chr('a'),
	_elm_lang$core$Native_Utils.chr('z'));
var _elm_lang$core$Char$isDigit = A2(
	_elm_lang$core$Char$isBetween,
	_elm_lang$core$Native_Utils.chr('0'),
	_elm_lang$core$Native_Utils.chr('9'));
var _elm_lang$core$Char$isOctDigit = A2(
	_elm_lang$core$Char$isBetween,
	_elm_lang$core$Native_Utils.chr('0'),
	_elm_lang$core$Native_Utils.chr('7'));
var _elm_lang$core$Char$isHexDigit = function ($char) {
	return _elm_lang$core$Char$isDigit($char) || (A3(
		_elm_lang$core$Char$isBetween,
		_elm_lang$core$Native_Utils.chr('a'),
		_elm_lang$core$Native_Utils.chr('f'),
		$char) || A3(
		_elm_lang$core$Char$isBetween,
		_elm_lang$core$Native_Utils.chr('A'),
		_elm_lang$core$Native_Utils.chr('F'),
		$char));
};

var _elm_lang$core$Result$toMaybe = function (result) {
	var _p0 = result;
	if (_p0.ctor === 'Ok') {
		return _elm_lang$core$Maybe$Just(_p0._0);
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _elm_lang$core$Result$withDefault = F2(
	function (def, result) {
		var _p1 = result;
		if (_p1.ctor === 'Ok') {
			return _p1._0;
		} else {
			return def;
		}
	});
var _elm_lang$core$Result$Err = function (a) {
	return {ctor: 'Err', _0: a};
};
var _elm_lang$core$Result$andThen = F2(
	function (callback, result) {
		var _p2 = result;
		if (_p2.ctor === 'Ok') {
			return callback(_p2._0);
		} else {
			return _elm_lang$core$Result$Err(_p2._0);
		}
	});
var _elm_lang$core$Result$Ok = function (a) {
	return {ctor: 'Ok', _0: a};
};
var _elm_lang$core$Result$map = F2(
	function (func, ra) {
		var _p3 = ra;
		if (_p3.ctor === 'Ok') {
			return _elm_lang$core$Result$Ok(
				func(_p3._0));
		} else {
			return _elm_lang$core$Result$Err(_p3._0);
		}
	});
var _elm_lang$core$Result$map2 = F3(
	function (func, ra, rb) {
		var _p4 = {ctor: '_Tuple2', _0: ra, _1: rb};
		if (_p4._0.ctor === 'Ok') {
			if (_p4._1.ctor === 'Ok') {
				return _elm_lang$core$Result$Ok(
					A2(func, _p4._0._0, _p4._1._0));
			} else {
				return _elm_lang$core$Result$Err(_p4._1._0);
			}
		} else {
			return _elm_lang$core$Result$Err(_p4._0._0);
		}
	});
var _elm_lang$core$Result$map3 = F4(
	function (func, ra, rb, rc) {
		var _p5 = {ctor: '_Tuple3', _0: ra, _1: rb, _2: rc};
		if (_p5._0.ctor === 'Ok') {
			if (_p5._1.ctor === 'Ok') {
				if (_p5._2.ctor === 'Ok') {
					return _elm_lang$core$Result$Ok(
						A3(func, _p5._0._0, _p5._1._0, _p5._2._0));
				} else {
					return _elm_lang$core$Result$Err(_p5._2._0);
				}
			} else {
				return _elm_lang$core$Result$Err(_p5._1._0);
			}
		} else {
			return _elm_lang$core$Result$Err(_p5._0._0);
		}
	});
var _elm_lang$core$Result$map4 = F5(
	function (func, ra, rb, rc, rd) {
		var _p6 = {ctor: '_Tuple4', _0: ra, _1: rb, _2: rc, _3: rd};
		if (_p6._0.ctor === 'Ok') {
			if (_p6._1.ctor === 'Ok') {
				if (_p6._2.ctor === 'Ok') {
					if (_p6._3.ctor === 'Ok') {
						return _elm_lang$core$Result$Ok(
							A4(func, _p6._0._0, _p6._1._0, _p6._2._0, _p6._3._0));
					} else {
						return _elm_lang$core$Result$Err(_p6._3._0);
					}
				} else {
					return _elm_lang$core$Result$Err(_p6._2._0);
				}
			} else {
				return _elm_lang$core$Result$Err(_p6._1._0);
			}
		} else {
			return _elm_lang$core$Result$Err(_p6._0._0);
		}
	});
var _elm_lang$core$Result$map5 = F6(
	function (func, ra, rb, rc, rd, re) {
		var _p7 = {ctor: '_Tuple5', _0: ra, _1: rb, _2: rc, _3: rd, _4: re};
		if (_p7._0.ctor === 'Ok') {
			if (_p7._1.ctor === 'Ok') {
				if (_p7._2.ctor === 'Ok') {
					if (_p7._3.ctor === 'Ok') {
						if (_p7._4.ctor === 'Ok') {
							return _elm_lang$core$Result$Ok(
								A5(func, _p7._0._0, _p7._1._0, _p7._2._0, _p7._3._0, _p7._4._0));
						} else {
							return _elm_lang$core$Result$Err(_p7._4._0);
						}
					} else {
						return _elm_lang$core$Result$Err(_p7._3._0);
					}
				} else {
					return _elm_lang$core$Result$Err(_p7._2._0);
				}
			} else {
				return _elm_lang$core$Result$Err(_p7._1._0);
			}
		} else {
			return _elm_lang$core$Result$Err(_p7._0._0);
		}
	});
var _elm_lang$core$Result$mapError = F2(
	function (f, result) {
		var _p8 = result;
		if (_p8.ctor === 'Ok') {
			return _elm_lang$core$Result$Ok(_p8._0);
		} else {
			return _elm_lang$core$Result$Err(
				f(_p8._0));
		}
	});
var _elm_lang$core$Result$fromMaybe = F2(
	function (err, maybe) {
		var _p9 = maybe;
		if (_p9.ctor === 'Just') {
			return _elm_lang$core$Result$Ok(_p9._0);
		} else {
			return _elm_lang$core$Result$Err(err);
		}
	});

var _elm_lang$core$String$fromList = _elm_lang$core$Native_String.fromList;
var _elm_lang$core$String$toList = _elm_lang$core$Native_String.toList;
var _elm_lang$core$String$toFloat = _elm_lang$core$Native_String.toFloat;
var _elm_lang$core$String$toInt = _elm_lang$core$Native_String.toInt;
var _elm_lang$core$String$indices = _elm_lang$core$Native_String.indexes;
var _elm_lang$core$String$indexes = _elm_lang$core$Native_String.indexes;
var _elm_lang$core$String$endsWith = _elm_lang$core$Native_String.endsWith;
var _elm_lang$core$String$startsWith = _elm_lang$core$Native_String.startsWith;
var _elm_lang$core$String$contains = _elm_lang$core$Native_String.contains;
var _elm_lang$core$String$all = _elm_lang$core$Native_String.all;
var _elm_lang$core$String$any = _elm_lang$core$Native_String.any;
var _elm_lang$core$String$toLower = _elm_lang$core$Native_String.toLower;
var _elm_lang$core$String$toUpper = _elm_lang$core$Native_String.toUpper;
var _elm_lang$core$String$lines = _elm_lang$core$Native_String.lines;
var _elm_lang$core$String$words = _elm_lang$core$Native_String.words;
var _elm_lang$core$String$trimRight = _elm_lang$core$Native_String.trimRight;
var _elm_lang$core$String$trimLeft = _elm_lang$core$Native_String.trimLeft;
var _elm_lang$core$String$trim = _elm_lang$core$Native_String.trim;
var _elm_lang$core$String$padRight = _elm_lang$core$Native_String.padRight;
var _elm_lang$core$String$padLeft = _elm_lang$core$Native_String.padLeft;
var _elm_lang$core$String$pad = _elm_lang$core$Native_String.pad;
var _elm_lang$core$String$dropRight = _elm_lang$core$Native_String.dropRight;
var _elm_lang$core$String$dropLeft = _elm_lang$core$Native_String.dropLeft;
var _elm_lang$core$String$right = _elm_lang$core$Native_String.right;
var _elm_lang$core$String$left = _elm_lang$core$Native_String.left;
var _elm_lang$core$String$slice = _elm_lang$core$Native_String.slice;
var _elm_lang$core$String$repeat = _elm_lang$core$Native_String.repeat;
var _elm_lang$core$String$join = _elm_lang$core$Native_String.join;
var _elm_lang$core$String$split = _elm_lang$core$Native_String.split;
var _elm_lang$core$String$foldr = _elm_lang$core$Native_String.foldr;
var _elm_lang$core$String$foldl = _elm_lang$core$Native_String.foldl;
var _elm_lang$core$String$reverse = _elm_lang$core$Native_String.reverse;
var _elm_lang$core$String$filter = _elm_lang$core$Native_String.filter;
var _elm_lang$core$String$map = _elm_lang$core$Native_String.map;
var _elm_lang$core$String$length = _elm_lang$core$Native_String.length;
var _elm_lang$core$String$concat = _elm_lang$core$Native_String.concat;
var _elm_lang$core$String$append = _elm_lang$core$Native_String.append;
var _elm_lang$core$String$uncons = _elm_lang$core$Native_String.uncons;
var _elm_lang$core$String$cons = _elm_lang$core$Native_String.cons;
var _elm_lang$core$String$fromChar = function ($char) {
	return A2(_elm_lang$core$String$cons, $char, '');
};
var _elm_lang$core$String$isEmpty = _elm_lang$core$Native_String.isEmpty;

var _elm_lang$core$Dict$foldr = F3(
	function (f, acc, t) {
		foldr:
		while (true) {
			var _p0 = t;
			if (_p0.ctor === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var _v1 = f,
					_v2 = A3(
					f,
					_p0._1,
					_p0._2,
					A3(_elm_lang$core$Dict$foldr, f, acc, _p0._4)),
					_v3 = _p0._3;
				f = _v1;
				acc = _v2;
				t = _v3;
				continue foldr;
			}
		}
	});
var _elm_lang$core$Dict$keys = function (dict) {
	return A3(
		_elm_lang$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return {ctor: '::', _0: key, _1: keyList};
			}),
		{ctor: '[]'},
		dict);
};
var _elm_lang$core$Dict$values = function (dict) {
	return A3(
		_elm_lang$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return {ctor: '::', _0: value, _1: valueList};
			}),
		{ctor: '[]'},
		dict);
};
var _elm_lang$core$Dict$toList = function (dict) {
	return A3(
		_elm_lang$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: key, _1: value},
					_1: list
				};
			}),
		{ctor: '[]'},
		dict);
};
var _elm_lang$core$Dict$foldl = F3(
	function (f, acc, dict) {
		foldl:
		while (true) {
			var _p1 = dict;
			if (_p1.ctor === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var _v5 = f,
					_v6 = A3(
					f,
					_p1._1,
					_p1._2,
					A3(_elm_lang$core$Dict$foldl, f, acc, _p1._3)),
					_v7 = _p1._4;
				f = _v5;
				acc = _v6;
				dict = _v7;
				continue foldl;
			}
		}
	});
var _elm_lang$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _p2) {
				stepState:
				while (true) {
					var _p3 = _p2;
					var _p9 = _p3._1;
					var _p8 = _p3._0;
					var _p4 = _p8;
					if (_p4.ctor === '[]') {
						return {
							ctor: '_Tuple2',
							_0: _p8,
							_1: A3(rightStep, rKey, rValue, _p9)
						};
					} else {
						var _p7 = _p4._1;
						var _p6 = _p4._0._1;
						var _p5 = _p4._0._0;
						if (_elm_lang$core$Native_Utils.cmp(_p5, rKey) < 0) {
							var _v10 = rKey,
								_v11 = rValue,
								_v12 = {
								ctor: '_Tuple2',
								_0: _p7,
								_1: A3(leftStep, _p5, _p6, _p9)
							};
							rKey = _v10;
							rValue = _v11;
							_p2 = _v12;
							continue stepState;
						} else {
							if (_elm_lang$core$Native_Utils.cmp(_p5, rKey) > 0) {
								return {
									ctor: '_Tuple2',
									_0: _p8,
									_1: A3(rightStep, rKey, rValue, _p9)
								};
							} else {
								return {
									ctor: '_Tuple2',
									_0: _p7,
									_1: A4(bothStep, _p5, _p6, rValue, _p9)
								};
							}
						}
					}
				}
			});
		var _p10 = A3(
			_elm_lang$core$Dict$foldl,
			stepState,
			{
				ctor: '_Tuple2',
				_0: _elm_lang$core$Dict$toList(leftDict),
				_1: initialResult
			},
			rightDict);
		var leftovers = _p10._0;
		var intermediateResult = _p10._1;
		return A3(
			_elm_lang$core$List$foldl,
			F2(
				function (_p11, result) {
					var _p12 = _p11;
					return A3(leftStep, _p12._0, _p12._1, result);
				}),
			intermediateResult,
			leftovers);
	});
var _elm_lang$core$Dict$reportRemBug = F4(
	function (msg, c, lgot, rgot) {
		return _elm_lang$core$Native_Debug.crash(
			_elm_lang$core$String$concat(
				{
					ctor: '::',
					_0: 'Internal red-black tree invariant violated, expected ',
					_1: {
						ctor: '::',
						_0: msg,
						_1: {
							ctor: '::',
							_0: ' and got ',
							_1: {
								ctor: '::',
								_0: _elm_lang$core$Basics$toString(c),
								_1: {
									ctor: '::',
									_0: '/',
									_1: {
										ctor: '::',
										_0: lgot,
										_1: {
											ctor: '::',
											_0: '/',
											_1: {
												ctor: '::',
												_0: rgot,
												_1: {
													ctor: '::',
													_0: '\nPlease report this bug to <https://github.com/elm-lang/core/issues>',
													_1: {ctor: '[]'}
												}
											}
										}
									}
								}
							}
						}
					}
				}));
	});
var _elm_lang$core$Dict$isBBlack = function (dict) {
	var _p13 = dict;
	_v14_2:
	do {
		if (_p13.ctor === 'RBNode_elm_builtin') {
			if (_p13._0.ctor === 'BBlack') {
				return true;
			} else {
				break _v14_2;
			}
		} else {
			if (_p13._0.ctor === 'LBBlack') {
				return true;
			} else {
				break _v14_2;
			}
		}
	} while(false);
	return false;
};
var _elm_lang$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			var _p14 = dict;
			if (_p14.ctor === 'RBEmpty_elm_builtin') {
				return n;
			} else {
				var _v16 = A2(_elm_lang$core$Dict$sizeHelp, n + 1, _p14._4),
					_v17 = _p14._3;
				n = _v16;
				dict = _v17;
				continue sizeHelp;
			}
		}
	});
var _elm_lang$core$Dict$size = function (dict) {
	return A2(_elm_lang$core$Dict$sizeHelp, 0, dict);
};
var _elm_lang$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			var _p15 = dict;
			if (_p15.ctor === 'RBEmpty_elm_builtin') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				var _p16 = A2(_elm_lang$core$Basics$compare, targetKey, _p15._1);
				switch (_p16.ctor) {
					case 'LT':
						var _v20 = targetKey,
							_v21 = _p15._3;
						targetKey = _v20;
						dict = _v21;
						continue get;
					case 'EQ':
						return _elm_lang$core$Maybe$Just(_p15._2);
					default:
						var _v22 = targetKey,
							_v23 = _p15._4;
						targetKey = _v22;
						dict = _v23;
						continue get;
				}
			}
		}
	});
var _elm_lang$core$Dict$member = F2(
	function (key, dict) {
		var _p17 = A2(_elm_lang$core$Dict$get, key, dict);
		if (_p17.ctor === 'Just') {
			return true;
		} else {
			return false;
		}
	});
var _elm_lang$core$Dict$maxWithDefault = F3(
	function (k, v, r) {
		maxWithDefault:
		while (true) {
			var _p18 = r;
			if (_p18.ctor === 'RBEmpty_elm_builtin') {
				return {ctor: '_Tuple2', _0: k, _1: v};
			} else {
				var _v26 = _p18._1,
					_v27 = _p18._2,
					_v28 = _p18._4;
				k = _v26;
				v = _v27;
				r = _v28;
				continue maxWithDefault;
			}
		}
	});
var _elm_lang$core$Dict$NBlack = {ctor: 'NBlack'};
var _elm_lang$core$Dict$BBlack = {ctor: 'BBlack'};
var _elm_lang$core$Dict$Black = {ctor: 'Black'};
var _elm_lang$core$Dict$blackish = function (t) {
	var _p19 = t;
	if (_p19.ctor === 'RBNode_elm_builtin') {
		var _p20 = _p19._0;
		return _elm_lang$core$Native_Utils.eq(_p20, _elm_lang$core$Dict$Black) || _elm_lang$core$Native_Utils.eq(_p20, _elm_lang$core$Dict$BBlack);
	} else {
		return true;
	}
};
var _elm_lang$core$Dict$Red = {ctor: 'Red'};
var _elm_lang$core$Dict$moreBlack = function (color) {
	var _p21 = color;
	switch (_p21.ctor) {
		case 'Black':
			return _elm_lang$core$Dict$BBlack;
		case 'Red':
			return _elm_lang$core$Dict$Black;
		case 'NBlack':
			return _elm_lang$core$Dict$Red;
		default:
			return _elm_lang$core$Native_Debug.crash('Can\'t make a double black node more black!');
	}
};
var _elm_lang$core$Dict$lessBlack = function (color) {
	var _p22 = color;
	switch (_p22.ctor) {
		case 'BBlack':
			return _elm_lang$core$Dict$Black;
		case 'Black':
			return _elm_lang$core$Dict$Red;
		case 'Red':
			return _elm_lang$core$Dict$NBlack;
		default:
			return _elm_lang$core$Native_Debug.crash('Can\'t make a negative black node less black!');
	}
};
var _elm_lang$core$Dict$LBBlack = {ctor: 'LBBlack'};
var _elm_lang$core$Dict$LBlack = {ctor: 'LBlack'};
var _elm_lang$core$Dict$RBEmpty_elm_builtin = function (a) {
	return {ctor: 'RBEmpty_elm_builtin', _0: a};
};
var _elm_lang$core$Dict$empty = _elm_lang$core$Dict$RBEmpty_elm_builtin(_elm_lang$core$Dict$LBlack);
var _elm_lang$core$Dict$isEmpty = function (dict) {
	return _elm_lang$core$Native_Utils.eq(dict, _elm_lang$core$Dict$empty);
};
var _elm_lang$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {ctor: 'RBNode_elm_builtin', _0: a, _1: b, _2: c, _3: d, _4: e};
	});
var _elm_lang$core$Dict$ensureBlackRoot = function (dict) {
	var _p23 = dict;
	if ((_p23.ctor === 'RBNode_elm_builtin') && (_p23._0.ctor === 'Red')) {
		return A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, _p23._1, _p23._2, _p23._3, _p23._4);
	} else {
		return dict;
	}
};
var _elm_lang$core$Dict$lessBlackTree = function (dict) {
	var _p24 = dict;
	if (_p24.ctor === 'RBNode_elm_builtin') {
		return A5(
			_elm_lang$core$Dict$RBNode_elm_builtin,
			_elm_lang$core$Dict$lessBlack(_p24._0),
			_p24._1,
			_p24._2,
			_p24._3,
			_p24._4);
	} else {
		return _elm_lang$core$Dict$RBEmpty_elm_builtin(_elm_lang$core$Dict$LBlack);
	}
};
var _elm_lang$core$Dict$balancedTree = function (col) {
	return function (xk) {
		return function (xv) {
			return function (yk) {
				return function (yv) {
					return function (zk) {
						return function (zv) {
							return function (a) {
								return function (b) {
									return function (c) {
										return function (d) {
											return A5(
												_elm_lang$core$Dict$RBNode_elm_builtin,
												_elm_lang$core$Dict$lessBlack(col),
												yk,
												yv,
												A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, xk, xv, a, b),
												A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, zk, zv, c, d));
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _elm_lang$core$Dict$blacken = function (t) {
	var _p25 = t;
	if (_p25.ctor === 'RBEmpty_elm_builtin') {
		return _elm_lang$core$Dict$RBEmpty_elm_builtin(_elm_lang$core$Dict$LBlack);
	} else {
		return A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, _p25._1, _p25._2, _p25._3, _p25._4);
	}
};
var _elm_lang$core$Dict$redden = function (t) {
	var _p26 = t;
	if (_p26.ctor === 'RBEmpty_elm_builtin') {
		return _elm_lang$core$Native_Debug.crash('can\'t make a Leaf red');
	} else {
		return A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Red, _p26._1, _p26._2, _p26._3, _p26._4);
	}
};
var _elm_lang$core$Dict$balanceHelp = function (tree) {
	var _p27 = tree;
	_v36_6:
	do {
		_v36_5:
		do {
			_v36_4:
			do {
				_v36_3:
				do {
					_v36_2:
					do {
						_v36_1:
						do {
							_v36_0:
							do {
								if (_p27.ctor === 'RBNode_elm_builtin') {
									if (_p27._3.ctor === 'RBNode_elm_builtin') {
										if (_p27._4.ctor === 'RBNode_elm_builtin') {
											switch (_p27._3._0.ctor) {
												case 'Red':
													switch (_p27._4._0.ctor) {
														case 'Red':
															if ((_p27._3._3.ctor === 'RBNode_elm_builtin') && (_p27._3._3._0.ctor === 'Red')) {
																break _v36_0;
															} else {
																if ((_p27._3._4.ctor === 'RBNode_elm_builtin') && (_p27._3._4._0.ctor === 'Red')) {
																	break _v36_1;
																} else {
																	if ((_p27._4._3.ctor === 'RBNode_elm_builtin') && (_p27._4._3._0.ctor === 'Red')) {
																		break _v36_2;
																	} else {
																		if ((_p27._4._4.ctor === 'RBNode_elm_builtin') && (_p27._4._4._0.ctor === 'Red')) {
																			break _v36_3;
																		} else {
																			break _v36_6;
																		}
																	}
																}
															}
														case 'NBlack':
															if ((_p27._3._3.ctor === 'RBNode_elm_builtin') && (_p27._3._3._0.ctor === 'Red')) {
																break _v36_0;
															} else {
																if ((_p27._3._4.ctor === 'RBNode_elm_builtin') && (_p27._3._4._0.ctor === 'Red')) {
																	break _v36_1;
																} else {
																	if (((((_p27._0.ctor === 'BBlack') && (_p27._4._3.ctor === 'RBNode_elm_builtin')) && (_p27._4._3._0.ctor === 'Black')) && (_p27._4._4.ctor === 'RBNode_elm_builtin')) && (_p27._4._4._0.ctor === 'Black')) {
																		break _v36_4;
																	} else {
																		break _v36_6;
																	}
																}
															}
														default:
															if ((_p27._3._3.ctor === 'RBNode_elm_builtin') && (_p27._3._3._0.ctor === 'Red')) {
																break _v36_0;
															} else {
																if ((_p27._3._4.ctor === 'RBNode_elm_builtin') && (_p27._3._4._0.ctor === 'Red')) {
																	break _v36_1;
																} else {
																	break _v36_6;
																}
															}
													}
												case 'NBlack':
													switch (_p27._4._0.ctor) {
														case 'Red':
															if ((_p27._4._3.ctor === 'RBNode_elm_builtin') && (_p27._4._3._0.ctor === 'Red')) {
																break _v36_2;
															} else {
																if ((_p27._4._4.ctor === 'RBNode_elm_builtin') && (_p27._4._4._0.ctor === 'Red')) {
																	break _v36_3;
																} else {
																	if (((((_p27._0.ctor === 'BBlack') && (_p27._3._3.ctor === 'RBNode_elm_builtin')) && (_p27._3._3._0.ctor === 'Black')) && (_p27._3._4.ctor === 'RBNode_elm_builtin')) && (_p27._3._4._0.ctor === 'Black')) {
																		break _v36_5;
																	} else {
																		break _v36_6;
																	}
																}
															}
														case 'NBlack':
															if (_p27._0.ctor === 'BBlack') {
																if ((((_p27._4._3.ctor === 'RBNode_elm_builtin') && (_p27._4._3._0.ctor === 'Black')) && (_p27._4._4.ctor === 'RBNode_elm_builtin')) && (_p27._4._4._0.ctor === 'Black')) {
																	break _v36_4;
																} else {
																	if ((((_p27._3._3.ctor === 'RBNode_elm_builtin') && (_p27._3._3._0.ctor === 'Black')) && (_p27._3._4.ctor === 'RBNode_elm_builtin')) && (_p27._3._4._0.ctor === 'Black')) {
																		break _v36_5;
																	} else {
																		break _v36_6;
																	}
																}
															} else {
																break _v36_6;
															}
														default:
															if (((((_p27._0.ctor === 'BBlack') && (_p27._3._3.ctor === 'RBNode_elm_builtin')) && (_p27._3._3._0.ctor === 'Black')) && (_p27._3._4.ctor === 'RBNode_elm_builtin')) && (_p27._3._4._0.ctor === 'Black')) {
																break _v36_5;
															} else {
																break _v36_6;
															}
													}
												default:
													switch (_p27._4._0.ctor) {
														case 'Red':
															if ((_p27._4._3.ctor === 'RBNode_elm_builtin') && (_p27._4._3._0.ctor === 'Red')) {
																break _v36_2;
															} else {
																if ((_p27._4._4.ctor === 'RBNode_elm_builtin') && (_p27._4._4._0.ctor === 'Red')) {
																	break _v36_3;
																} else {
																	break _v36_6;
																}
															}
														case 'NBlack':
															if (((((_p27._0.ctor === 'BBlack') && (_p27._4._3.ctor === 'RBNode_elm_builtin')) && (_p27._4._3._0.ctor === 'Black')) && (_p27._4._4.ctor === 'RBNode_elm_builtin')) && (_p27._4._4._0.ctor === 'Black')) {
																break _v36_4;
															} else {
																break _v36_6;
															}
														default:
															break _v36_6;
													}
											}
										} else {
											switch (_p27._3._0.ctor) {
												case 'Red':
													if ((_p27._3._3.ctor === 'RBNode_elm_builtin') && (_p27._3._3._0.ctor === 'Red')) {
														break _v36_0;
													} else {
														if ((_p27._3._4.ctor === 'RBNode_elm_builtin') && (_p27._3._4._0.ctor === 'Red')) {
															break _v36_1;
														} else {
															break _v36_6;
														}
													}
												case 'NBlack':
													if (((((_p27._0.ctor === 'BBlack') && (_p27._3._3.ctor === 'RBNode_elm_builtin')) && (_p27._3._3._0.ctor === 'Black')) && (_p27._3._4.ctor === 'RBNode_elm_builtin')) && (_p27._3._4._0.ctor === 'Black')) {
														break _v36_5;
													} else {
														break _v36_6;
													}
												default:
													break _v36_6;
											}
										}
									} else {
										if (_p27._4.ctor === 'RBNode_elm_builtin') {
											switch (_p27._4._0.ctor) {
												case 'Red':
													if ((_p27._4._3.ctor === 'RBNode_elm_builtin') && (_p27._4._3._0.ctor === 'Red')) {
														break _v36_2;
													} else {
														if ((_p27._4._4.ctor === 'RBNode_elm_builtin') && (_p27._4._4._0.ctor === 'Red')) {
															break _v36_3;
														} else {
															break _v36_6;
														}
													}
												case 'NBlack':
													if (((((_p27._0.ctor === 'BBlack') && (_p27._4._3.ctor === 'RBNode_elm_builtin')) && (_p27._4._3._0.ctor === 'Black')) && (_p27._4._4.ctor === 'RBNode_elm_builtin')) && (_p27._4._4._0.ctor === 'Black')) {
														break _v36_4;
													} else {
														break _v36_6;
													}
												default:
													break _v36_6;
											}
										} else {
											break _v36_6;
										}
									}
								} else {
									break _v36_6;
								}
							} while(false);
							return _elm_lang$core$Dict$balancedTree(_p27._0)(_p27._3._3._1)(_p27._3._3._2)(_p27._3._1)(_p27._3._2)(_p27._1)(_p27._2)(_p27._3._3._3)(_p27._3._3._4)(_p27._3._4)(_p27._4);
						} while(false);
						return _elm_lang$core$Dict$balancedTree(_p27._0)(_p27._3._1)(_p27._3._2)(_p27._3._4._1)(_p27._3._4._2)(_p27._1)(_p27._2)(_p27._3._3)(_p27._3._4._3)(_p27._3._4._4)(_p27._4);
					} while(false);
					return _elm_lang$core$Dict$balancedTree(_p27._0)(_p27._1)(_p27._2)(_p27._4._3._1)(_p27._4._3._2)(_p27._4._1)(_p27._4._2)(_p27._3)(_p27._4._3._3)(_p27._4._3._4)(_p27._4._4);
				} while(false);
				return _elm_lang$core$Dict$balancedTree(_p27._0)(_p27._1)(_p27._2)(_p27._4._1)(_p27._4._2)(_p27._4._4._1)(_p27._4._4._2)(_p27._3)(_p27._4._3)(_p27._4._4._3)(_p27._4._4._4);
			} while(false);
			return A5(
				_elm_lang$core$Dict$RBNode_elm_builtin,
				_elm_lang$core$Dict$Black,
				_p27._4._3._1,
				_p27._4._3._2,
				A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, _p27._1, _p27._2, _p27._3, _p27._4._3._3),
				A5(
					_elm_lang$core$Dict$balance,
					_elm_lang$core$Dict$Black,
					_p27._4._1,
					_p27._4._2,
					_p27._4._3._4,
					_elm_lang$core$Dict$redden(_p27._4._4)));
		} while(false);
		return A5(
			_elm_lang$core$Dict$RBNode_elm_builtin,
			_elm_lang$core$Dict$Black,
			_p27._3._4._1,
			_p27._3._4._2,
			A5(
				_elm_lang$core$Dict$balance,
				_elm_lang$core$Dict$Black,
				_p27._3._1,
				_p27._3._2,
				_elm_lang$core$Dict$redden(_p27._3._3),
				_p27._3._4._3),
			A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, _p27._1, _p27._2, _p27._3._4._4, _p27._4));
	} while(false);
	return tree;
};
var _elm_lang$core$Dict$balance = F5(
	function (c, k, v, l, r) {
		var tree = A5(_elm_lang$core$Dict$RBNode_elm_builtin, c, k, v, l, r);
		return _elm_lang$core$Dict$blackish(tree) ? _elm_lang$core$Dict$balanceHelp(tree) : tree;
	});
var _elm_lang$core$Dict$bubble = F5(
	function (c, k, v, l, r) {
		return (_elm_lang$core$Dict$isBBlack(l) || _elm_lang$core$Dict$isBBlack(r)) ? A5(
			_elm_lang$core$Dict$balance,
			_elm_lang$core$Dict$moreBlack(c),
			k,
			v,
			_elm_lang$core$Dict$lessBlackTree(l),
			_elm_lang$core$Dict$lessBlackTree(r)) : A5(_elm_lang$core$Dict$RBNode_elm_builtin, c, k, v, l, r);
	});
var _elm_lang$core$Dict$removeMax = F5(
	function (c, k, v, l, r) {
		var _p28 = r;
		if (_p28.ctor === 'RBEmpty_elm_builtin') {
			return A3(_elm_lang$core$Dict$rem, c, l, r);
		} else {
			return A5(
				_elm_lang$core$Dict$bubble,
				c,
				k,
				v,
				l,
				A5(_elm_lang$core$Dict$removeMax, _p28._0, _p28._1, _p28._2, _p28._3, _p28._4));
		}
	});
var _elm_lang$core$Dict$rem = F3(
	function (color, left, right) {
		var _p29 = {ctor: '_Tuple2', _0: left, _1: right};
		if (_p29._0.ctor === 'RBEmpty_elm_builtin') {
			if (_p29._1.ctor === 'RBEmpty_elm_builtin') {
				var _p30 = color;
				switch (_p30.ctor) {
					case 'Red':
						return _elm_lang$core$Dict$RBEmpty_elm_builtin(_elm_lang$core$Dict$LBlack);
					case 'Black':
						return _elm_lang$core$Dict$RBEmpty_elm_builtin(_elm_lang$core$Dict$LBBlack);
					default:
						return _elm_lang$core$Native_Debug.crash('cannot have bblack or nblack nodes at this point');
				}
			} else {
				var _p33 = _p29._1._0;
				var _p32 = _p29._0._0;
				var _p31 = {ctor: '_Tuple3', _0: color, _1: _p32, _2: _p33};
				if ((((_p31.ctor === '_Tuple3') && (_p31._0.ctor === 'Black')) && (_p31._1.ctor === 'LBlack')) && (_p31._2.ctor === 'Red')) {
					return A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, _p29._1._1, _p29._1._2, _p29._1._3, _p29._1._4);
				} else {
					return A4(
						_elm_lang$core$Dict$reportRemBug,
						'Black/LBlack/Red',
						color,
						_elm_lang$core$Basics$toString(_p32),
						_elm_lang$core$Basics$toString(_p33));
				}
			}
		} else {
			if (_p29._1.ctor === 'RBEmpty_elm_builtin') {
				var _p36 = _p29._1._0;
				var _p35 = _p29._0._0;
				var _p34 = {ctor: '_Tuple3', _0: color, _1: _p35, _2: _p36};
				if ((((_p34.ctor === '_Tuple3') && (_p34._0.ctor === 'Black')) && (_p34._1.ctor === 'Red')) && (_p34._2.ctor === 'LBlack')) {
					return A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, _p29._0._1, _p29._0._2, _p29._0._3, _p29._0._4);
				} else {
					return A4(
						_elm_lang$core$Dict$reportRemBug,
						'Black/Red/LBlack',
						color,
						_elm_lang$core$Basics$toString(_p35),
						_elm_lang$core$Basics$toString(_p36));
				}
			} else {
				var _p40 = _p29._0._2;
				var _p39 = _p29._0._4;
				var _p38 = _p29._0._1;
				var newLeft = A5(_elm_lang$core$Dict$removeMax, _p29._0._0, _p38, _p40, _p29._0._3, _p39);
				var _p37 = A3(_elm_lang$core$Dict$maxWithDefault, _p38, _p40, _p39);
				var k = _p37._0;
				var v = _p37._1;
				return A5(_elm_lang$core$Dict$bubble, color, k, v, newLeft, right);
			}
		}
	});
var _elm_lang$core$Dict$map = F2(
	function (f, dict) {
		var _p41 = dict;
		if (_p41.ctor === 'RBEmpty_elm_builtin') {
			return _elm_lang$core$Dict$RBEmpty_elm_builtin(_elm_lang$core$Dict$LBlack);
		} else {
			var _p42 = _p41._1;
			return A5(
				_elm_lang$core$Dict$RBNode_elm_builtin,
				_p41._0,
				_p42,
				A2(f, _p42, _p41._2),
				A2(_elm_lang$core$Dict$map, f, _p41._3),
				A2(_elm_lang$core$Dict$map, f, _p41._4));
		}
	});
var _elm_lang$core$Dict$Same = {ctor: 'Same'};
var _elm_lang$core$Dict$Remove = {ctor: 'Remove'};
var _elm_lang$core$Dict$Insert = {ctor: 'Insert'};
var _elm_lang$core$Dict$update = F3(
	function (k, alter, dict) {
		var up = function (dict) {
			var _p43 = dict;
			if (_p43.ctor === 'RBEmpty_elm_builtin') {
				var _p44 = alter(_elm_lang$core$Maybe$Nothing);
				if (_p44.ctor === 'Nothing') {
					return {ctor: '_Tuple2', _0: _elm_lang$core$Dict$Same, _1: _elm_lang$core$Dict$empty};
				} else {
					return {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Dict$Insert,
						_1: A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Red, k, _p44._0, _elm_lang$core$Dict$empty, _elm_lang$core$Dict$empty)
					};
				}
			} else {
				var _p55 = _p43._2;
				var _p54 = _p43._4;
				var _p53 = _p43._3;
				var _p52 = _p43._1;
				var _p51 = _p43._0;
				var _p45 = A2(_elm_lang$core$Basics$compare, k, _p52);
				switch (_p45.ctor) {
					case 'EQ':
						var _p46 = alter(
							_elm_lang$core$Maybe$Just(_p55));
						if (_p46.ctor === 'Nothing') {
							return {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Dict$Remove,
								_1: A3(_elm_lang$core$Dict$rem, _p51, _p53, _p54)
							};
						} else {
							return {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Dict$Same,
								_1: A5(_elm_lang$core$Dict$RBNode_elm_builtin, _p51, _p52, _p46._0, _p53, _p54)
							};
						}
					case 'LT':
						var _p47 = up(_p53);
						var flag = _p47._0;
						var newLeft = _p47._1;
						var _p48 = flag;
						switch (_p48.ctor) {
							case 'Same':
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Dict$Same,
									_1: A5(_elm_lang$core$Dict$RBNode_elm_builtin, _p51, _p52, _p55, newLeft, _p54)
								};
							case 'Insert':
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Dict$Insert,
									_1: A5(_elm_lang$core$Dict$balance, _p51, _p52, _p55, newLeft, _p54)
								};
							default:
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Dict$Remove,
									_1: A5(_elm_lang$core$Dict$bubble, _p51, _p52, _p55, newLeft, _p54)
								};
						}
					default:
						var _p49 = up(_p54);
						var flag = _p49._0;
						var newRight = _p49._1;
						var _p50 = flag;
						switch (_p50.ctor) {
							case 'Same':
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Dict$Same,
									_1: A5(_elm_lang$core$Dict$RBNode_elm_builtin, _p51, _p52, _p55, _p53, newRight)
								};
							case 'Insert':
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Dict$Insert,
									_1: A5(_elm_lang$core$Dict$balance, _p51, _p52, _p55, _p53, newRight)
								};
							default:
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Dict$Remove,
									_1: A5(_elm_lang$core$Dict$bubble, _p51, _p52, _p55, _p53, newRight)
								};
						}
				}
			}
		};
		var _p56 = up(dict);
		var flag = _p56._0;
		var updatedDict = _p56._1;
		var _p57 = flag;
		switch (_p57.ctor) {
			case 'Same':
				return updatedDict;
			case 'Insert':
				return _elm_lang$core$Dict$ensureBlackRoot(updatedDict);
			default:
				return _elm_lang$core$Dict$blacken(updatedDict);
		}
	});
var _elm_lang$core$Dict$insert = F3(
	function (key, value, dict) {
		return A3(
			_elm_lang$core$Dict$update,
			key,
			_elm_lang$core$Basics$always(
				_elm_lang$core$Maybe$Just(value)),
			dict);
	});
var _elm_lang$core$Dict$singleton = F2(
	function (key, value) {
		return A3(_elm_lang$core$Dict$insert, key, value, _elm_lang$core$Dict$empty);
	});
var _elm_lang$core$Dict$union = F2(
	function (t1, t2) {
		return A3(_elm_lang$core$Dict$foldl, _elm_lang$core$Dict$insert, t2, t1);
	});
var _elm_lang$core$Dict$filter = F2(
	function (predicate, dictionary) {
		var add = F3(
			function (key, value, dict) {
				return A2(predicate, key, value) ? A3(_elm_lang$core$Dict$insert, key, value, dict) : dict;
			});
		return A3(_elm_lang$core$Dict$foldl, add, _elm_lang$core$Dict$empty, dictionary);
	});
var _elm_lang$core$Dict$intersect = F2(
	function (t1, t2) {
		return A2(
			_elm_lang$core$Dict$filter,
			F2(
				function (k, _p58) {
					return A2(_elm_lang$core$Dict$member, k, t2);
				}),
			t1);
	});
var _elm_lang$core$Dict$partition = F2(
	function (predicate, dict) {
		var add = F3(
			function (key, value, _p59) {
				var _p60 = _p59;
				var _p62 = _p60._1;
				var _p61 = _p60._0;
				return A2(predicate, key, value) ? {
					ctor: '_Tuple2',
					_0: A3(_elm_lang$core$Dict$insert, key, value, _p61),
					_1: _p62
				} : {
					ctor: '_Tuple2',
					_0: _p61,
					_1: A3(_elm_lang$core$Dict$insert, key, value, _p62)
				};
			});
		return A3(
			_elm_lang$core$Dict$foldl,
			add,
			{ctor: '_Tuple2', _0: _elm_lang$core$Dict$empty, _1: _elm_lang$core$Dict$empty},
			dict);
	});
var _elm_lang$core$Dict$fromList = function (assocs) {
	return A3(
		_elm_lang$core$List$foldl,
		F2(
			function (_p63, dict) {
				var _p64 = _p63;
				return A3(_elm_lang$core$Dict$insert, _p64._0, _p64._1, dict);
			}),
		_elm_lang$core$Dict$empty,
		assocs);
};
var _elm_lang$core$Dict$remove = F2(
	function (key, dict) {
		return A3(
			_elm_lang$core$Dict$update,
			key,
			_elm_lang$core$Basics$always(_elm_lang$core$Maybe$Nothing),
			dict);
	});
var _elm_lang$core$Dict$diff = F2(
	function (t1, t2) {
		return A3(
			_elm_lang$core$Dict$foldl,
			F3(
				function (k, v, t) {
					return A2(_elm_lang$core$Dict$remove, k, t);
				}),
			t1,
			t2);
	});

//import Maybe, Native.Array, Native.List, Native.Utils, Result //

var _elm_lang$core$Native_Json = function() {


// CORE DECODERS

function succeed(msg)
{
	return {
		ctor: '<decoder>',
		tag: 'succeed',
		msg: msg
	};
}

function fail(msg)
{
	return {
		ctor: '<decoder>',
		tag: 'fail',
		msg: msg
	};
}

function decodePrimitive(tag)
{
	return {
		ctor: '<decoder>',
		tag: tag
	};
}

function decodeContainer(tag, decoder)
{
	return {
		ctor: '<decoder>',
		tag: tag,
		decoder: decoder
	};
}

function decodeNull(value)
{
	return {
		ctor: '<decoder>',
		tag: 'null',
		value: value
	};
}

function decodeField(field, decoder)
{
	return {
		ctor: '<decoder>',
		tag: 'field',
		field: field,
		decoder: decoder
	};
}

function decodeIndex(index, decoder)
{
	return {
		ctor: '<decoder>',
		tag: 'index',
		index: index,
		decoder: decoder
	};
}

function decodeKeyValuePairs(decoder)
{
	return {
		ctor: '<decoder>',
		tag: 'key-value',
		decoder: decoder
	};
}

function mapMany(f, decoders)
{
	return {
		ctor: '<decoder>',
		tag: 'map-many',
		func: f,
		decoders: decoders
	};
}

function andThen(callback, decoder)
{
	return {
		ctor: '<decoder>',
		tag: 'andThen',
		decoder: decoder,
		callback: callback
	};
}

function oneOf(decoders)
{
	return {
		ctor: '<decoder>',
		tag: 'oneOf',
		decoders: decoders
	};
}


// DECODING OBJECTS

function map1(f, d1)
{
	return mapMany(f, [d1]);
}

function map2(f, d1, d2)
{
	return mapMany(f, [d1, d2]);
}

function map3(f, d1, d2, d3)
{
	return mapMany(f, [d1, d2, d3]);
}

function map4(f, d1, d2, d3, d4)
{
	return mapMany(f, [d1, d2, d3, d4]);
}

function map5(f, d1, d2, d3, d4, d5)
{
	return mapMany(f, [d1, d2, d3, d4, d5]);
}

function map6(f, d1, d2, d3, d4, d5, d6)
{
	return mapMany(f, [d1, d2, d3, d4, d5, d6]);
}

function map7(f, d1, d2, d3, d4, d5, d6, d7)
{
	return mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
}

function map8(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
}


// DECODE HELPERS

function ok(value)
{
	return { tag: 'ok', value: value };
}

function badPrimitive(type, value)
{
	return { tag: 'primitive', type: type, value: value };
}

function badIndex(index, nestedProblems)
{
	return { tag: 'index', index: index, rest: nestedProblems };
}

function badField(field, nestedProblems)
{
	return { tag: 'field', field: field, rest: nestedProblems };
}

function badIndex(index, nestedProblems)
{
	return { tag: 'index', index: index, rest: nestedProblems };
}

function badOneOf(problems)
{
	return { tag: 'oneOf', problems: problems };
}

function bad(msg)
{
	return { tag: 'fail', msg: msg };
}

function badToString(problem)
{
	var context = '_';
	while (problem)
	{
		switch (problem.tag)
		{
			case 'primitive':
				return 'Expecting ' + problem.type
					+ (context === '_' ? '' : ' at ' + context)
					+ ' but instead got: ' + jsToString(problem.value);

			case 'index':
				context += '[' + problem.index + ']';
				problem = problem.rest;
				break;

			case 'field':
				context += '.' + problem.field;
				problem = problem.rest;
				break;

			case 'oneOf':
				var problems = problem.problems;
				for (var i = 0; i < problems.length; i++)
				{
					problems[i] = badToString(problems[i]);
				}
				return 'I ran into the following problems'
					+ (context === '_' ? '' : ' at ' + context)
					+ ':\n\n' + problems.join('\n');

			case 'fail':
				return 'I ran into a `fail` decoder'
					+ (context === '_' ? '' : ' at ' + context)
					+ ': ' + problem.msg;
		}
	}
}

function jsToString(value)
{
	return value === undefined
		? 'undefined'
		: JSON.stringify(value);
}


// DECODE

function runOnString(decoder, string)
{
	var json;
	try
	{
		json = JSON.parse(string);
	}
	catch (e)
	{
		return _elm_lang$core$Result$Err('Given an invalid JSON: ' + e.message);
	}
	return run(decoder, json);
}

function run(decoder, value)
{
	var result = runHelp(decoder, value);
	return (result.tag === 'ok')
		? _elm_lang$core$Result$Ok(result.value)
		: _elm_lang$core$Result$Err(badToString(result));
}

function runHelp(decoder, value)
{
	switch (decoder.tag)
	{
		case 'bool':
			return (typeof value === 'boolean')
				? ok(value)
				: badPrimitive('a Bool', value);

		case 'int':
			if (typeof value !== 'number') {
				return badPrimitive('an Int', value);
			}

			if (-2147483647 < value && value < 2147483647 && (value | 0) === value) {
				return ok(value);
			}

			if (isFinite(value) && !(value % 1)) {
				return ok(value);
			}

			return badPrimitive('an Int', value);

		case 'float':
			return (typeof value === 'number')
				? ok(value)
				: badPrimitive('a Float', value);

		case 'string':
			return (typeof value === 'string')
				? ok(value)
				: (value instanceof String)
					? ok(value + '')
					: badPrimitive('a String', value);

		case 'null':
			return (value === null)
				? ok(decoder.value)
				: badPrimitive('null', value);

		case 'value':
			return ok(value);

		case 'list':
			if (!(value instanceof Array))
			{
				return badPrimitive('a List', value);
			}

			var list = _elm_lang$core$Native_List.Nil;
			for (var i = value.length; i--; )
			{
				var result = runHelp(decoder.decoder, value[i]);
				if (result.tag !== 'ok')
				{
					return badIndex(i, result)
				}
				list = _elm_lang$core$Native_List.Cons(result.value, list);
			}
			return ok(list);

		case 'array':
			if (!(value instanceof Array))
			{
				return badPrimitive('an Array', value);
			}

			var len = value.length;
			var array = new Array(len);
			for (var i = len; i--; )
			{
				var result = runHelp(decoder.decoder, value[i]);
				if (result.tag !== 'ok')
				{
					return badIndex(i, result);
				}
				array[i] = result.value;
			}
			return ok(_elm_lang$core$Native_Array.fromJSArray(array));

		case 'maybe':
			var result = runHelp(decoder.decoder, value);
			return (result.tag === 'ok')
				? ok(_elm_lang$core$Maybe$Just(result.value))
				: ok(_elm_lang$core$Maybe$Nothing);

		case 'field':
			var field = decoder.field;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return badPrimitive('an object with a field named `' + field + '`', value);
			}

			var result = runHelp(decoder.decoder, value[field]);
			return (result.tag === 'ok') ? result : badField(field, result);

		case 'index':
			var index = decoder.index;
			if (!(value instanceof Array))
			{
				return badPrimitive('an array', value);
			}
			if (index >= value.length)
			{
				return badPrimitive('a longer array. Need index ' + index + ' but there are only ' + value.length + ' entries', value);
			}

			var result = runHelp(decoder.decoder, value[index]);
			return (result.tag === 'ok') ? result : badIndex(index, result);

		case 'key-value':
			if (typeof value !== 'object' || value === null || value instanceof Array)
			{
				return badPrimitive('an object', value);
			}

			var keyValuePairs = _elm_lang$core$Native_List.Nil;
			for (var key in value)
			{
				var result = runHelp(decoder.decoder, value[key]);
				if (result.tag !== 'ok')
				{
					return badField(key, result);
				}
				var pair = _elm_lang$core$Native_Utils.Tuple2(key, result.value);
				keyValuePairs = _elm_lang$core$Native_List.Cons(pair, keyValuePairs);
			}
			return ok(keyValuePairs);

		case 'map-many':
			var answer = decoder.func;
			var decoders = decoder.decoders;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = runHelp(decoders[i], value);
				if (result.tag !== 'ok')
				{
					return result;
				}
				answer = answer(result.value);
			}
			return ok(answer);

		case 'andThen':
			var result = runHelp(decoder.decoder, value);
			return (result.tag !== 'ok')
				? result
				: runHelp(decoder.callback(result.value), value);

		case 'oneOf':
			var errors = [];
			var temp = decoder.decoders;
			while (temp.ctor !== '[]')
			{
				var result = runHelp(temp._0, value);

				if (result.tag === 'ok')
				{
					return result;
				}

				errors.push(result);

				temp = temp._1;
			}
			return badOneOf(errors);

		case 'fail':
			return bad(decoder.msg);

		case 'succeed':
			return ok(decoder.msg);
	}
}


// EQUALITY

function equality(a, b)
{
	if (a === b)
	{
		return true;
	}

	if (a.tag !== b.tag)
	{
		return false;
	}

	switch (a.tag)
	{
		case 'succeed':
		case 'fail':
			return a.msg === b.msg;

		case 'bool':
		case 'int':
		case 'float':
		case 'string':
		case 'value':
			return true;

		case 'null':
			return a.value === b.value;

		case 'list':
		case 'array':
		case 'maybe':
		case 'key-value':
			return equality(a.decoder, b.decoder);

		case 'field':
			return a.field === b.field && equality(a.decoder, b.decoder);

		case 'index':
			return a.index === b.index && equality(a.decoder, b.decoder);

		case 'map-many':
			if (a.func !== b.func)
			{
				return false;
			}
			return listEquality(a.decoders, b.decoders);

		case 'andThen':
			return a.callback === b.callback && equality(a.decoder, b.decoder);

		case 'oneOf':
			return listEquality(a.decoders, b.decoders);
	}
}

function listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

function encode(indentLevel, value)
{
	return JSON.stringify(value, null, indentLevel);
}

function identity(value)
{
	return value;
}

function encodeObject(keyValuePairs)
{
	var obj = {};
	while (keyValuePairs.ctor !== '[]')
	{
		var pair = keyValuePairs._0;
		obj[pair._0] = pair._1;
		keyValuePairs = keyValuePairs._1;
	}
	return obj;
}

return {
	encode: F2(encode),
	runOnString: F2(runOnString),
	run: F2(run),

	decodeNull: decodeNull,
	decodePrimitive: decodePrimitive,
	decodeContainer: F2(decodeContainer),

	decodeField: F2(decodeField),
	decodeIndex: F2(decodeIndex),

	map1: F2(map1),
	map2: F3(map2),
	map3: F4(map3),
	map4: F5(map4),
	map5: F6(map5),
	map6: F7(map6),
	map7: F8(map7),
	map8: F9(map8),
	decodeKeyValuePairs: decodeKeyValuePairs,

	andThen: F2(andThen),
	fail: fail,
	succeed: succeed,
	oneOf: oneOf,

	identity: identity,
	encodeNull: null,
	encodeArray: _elm_lang$core$Native_Array.toJSArray,
	encodeList: _elm_lang$core$Native_List.toArray,
	encodeObject: encodeObject,

	equality: equality
};

}();

var _elm_lang$core$Json_Encode$list = _elm_lang$core$Native_Json.encodeList;
var _elm_lang$core$Json_Encode$array = _elm_lang$core$Native_Json.encodeArray;
var _elm_lang$core$Json_Encode$object = _elm_lang$core$Native_Json.encodeObject;
var _elm_lang$core$Json_Encode$null = _elm_lang$core$Native_Json.encodeNull;
var _elm_lang$core$Json_Encode$bool = _elm_lang$core$Native_Json.identity;
var _elm_lang$core$Json_Encode$float = _elm_lang$core$Native_Json.identity;
var _elm_lang$core$Json_Encode$int = _elm_lang$core$Native_Json.identity;
var _elm_lang$core$Json_Encode$string = _elm_lang$core$Native_Json.identity;
var _elm_lang$core$Json_Encode$encode = _elm_lang$core$Native_Json.encode;
var _elm_lang$core$Json_Encode$Value = {ctor: 'Value'};

var _elm_lang$core$Json_Decode$null = _elm_lang$core$Native_Json.decodeNull;
var _elm_lang$core$Json_Decode$value = _elm_lang$core$Native_Json.decodePrimitive('value');
var _elm_lang$core$Json_Decode$andThen = _elm_lang$core$Native_Json.andThen;
var _elm_lang$core$Json_Decode$fail = _elm_lang$core$Native_Json.fail;
var _elm_lang$core$Json_Decode$succeed = _elm_lang$core$Native_Json.succeed;
var _elm_lang$core$Json_Decode$lazy = function (thunk) {
	return A2(
		_elm_lang$core$Json_Decode$andThen,
		thunk,
		_elm_lang$core$Json_Decode$succeed(
			{ctor: '_Tuple0'}));
};
var _elm_lang$core$Json_Decode$decodeValue = _elm_lang$core$Native_Json.run;
var _elm_lang$core$Json_Decode$decodeString = _elm_lang$core$Native_Json.runOnString;
var _elm_lang$core$Json_Decode$map8 = _elm_lang$core$Native_Json.map8;
var _elm_lang$core$Json_Decode$map7 = _elm_lang$core$Native_Json.map7;
var _elm_lang$core$Json_Decode$map6 = _elm_lang$core$Native_Json.map6;
var _elm_lang$core$Json_Decode$map5 = _elm_lang$core$Native_Json.map5;
var _elm_lang$core$Json_Decode$map4 = _elm_lang$core$Native_Json.map4;
var _elm_lang$core$Json_Decode$map3 = _elm_lang$core$Native_Json.map3;
var _elm_lang$core$Json_Decode$map2 = _elm_lang$core$Native_Json.map2;
var _elm_lang$core$Json_Decode$map = _elm_lang$core$Native_Json.map1;
var _elm_lang$core$Json_Decode$oneOf = _elm_lang$core$Native_Json.oneOf;
var _elm_lang$core$Json_Decode$maybe = function (decoder) {
	return A2(_elm_lang$core$Native_Json.decodeContainer, 'maybe', decoder);
};
var _elm_lang$core$Json_Decode$index = _elm_lang$core$Native_Json.decodeIndex;
var _elm_lang$core$Json_Decode$field = _elm_lang$core$Native_Json.decodeField;
var _elm_lang$core$Json_Decode$at = F2(
	function (fields, decoder) {
		return A3(_elm_lang$core$List$foldr, _elm_lang$core$Json_Decode$field, decoder, fields);
	});
var _elm_lang$core$Json_Decode$keyValuePairs = _elm_lang$core$Native_Json.decodeKeyValuePairs;
var _elm_lang$core$Json_Decode$dict = function (decoder) {
	return A2(
		_elm_lang$core$Json_Decode$map,
		_elm_lang$core$Dict$fromList,
		_elm_lang$core$Json_Decode$keyValuePairs(decoder));
};
var _elm_lang$core$Json_Decode$array = function (decoder) {
	return A2(_elm_lang$core$Native_Json.decodeContainer, 'array', decoder);
};
var _elm_lang$core$Json_Decode$list = function (decoder) {
	return A2(_elm_lang$core$Native_Json.decodeContainer, 'list', decoder);
};
var _elm_lang$core$Json_Decode$nullable = function (decoder) {
	return _elm_lang$core$Json_Decode$oneOf(
		{
			ctor: '::',
			_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
			_1: {
				ctor: '::',
				_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, decoder),
				_1: {ctor: '[]'}
			}
		});
};
var _elm_lang$core$Json_Decode$float = _elm_lang$core$Native_Json.decodePrimitive('float');
var _elm_lang$core$Json_Decode$int = _elm_lang$core$Native_Json.decodePrimitive('int');
var _elm_lang$core$Json_Decode$bool = _elm_lang$core$Native_Json.decodePrimitive('bool');
var _elm_lang$core$Json_Decode$string = _elm_lang$core$Native_Json.decodePrimitive('string');
var _elm_lang$core$Json_Decode$Decoder = {ctor: 'Decoder'};

var _elm_lang$core$Debug$crash = _elm_lang$core$Native_Debug.crash;
var _elm_lang$core$Debug$log = _elm_lang$core$Native_Debug.log;

var _elm_lang$core$Tuple$mapSecond = F2(
	function (func, _p0) {
		var _p1 = _p0;
		return {
			ctor: '_Tuple2',
			_0: _p1._0,
			_1: func(_p1._1)
		};
	});
var _elm_lang$core$Tuple$mapFirst = F2(
	function (func, _p2) {
		var _p3 = _p2;
		return {
			ctor: '_Tuple2',
			_0: func(_p3._0),
			_1: _p3._1
		};
	});
var _elm_lang$core$Tuple$second = function (_p4) {
	var _p5 = _p4;
	return _p5._1;
};
var _elm_lang$core$Tuple$first = function (_p6) {
	var _p7 = _p6;
	return _p7._0;
};

//import //

var _elm_lang$core$Native_Platform = function() {


// PROGRAMS

function program(impl)
{
	return function(flagDecoder)
	{
		return function(object, moduleName)
		{
			object['worker'] = function worker(flags)
			{
				if (typeof flags !== 'undefined')
				{
					throw new Error(
						'The `' + moduleName + '` module does not need flags.\n'
						+ 'Call ' + moduleName + '.worker() with no arguments and you should be all set!'
					);
				}

				return initialize(
					impl.init,
					impl.update,
					impl.subscriptions,
					renderer
				);
			};
		};
	};
}

function programWithFlags(impl)
{
	return function(flagDecoder)
	{
		return function(object, moduleName)
		{
			object['worker'] = function worker(flags)
			{
				if (typeof flagDecoder === 'undefined')
				{
					throw new Error(
						'Are you trying to sneak a Never value into Elm? Trickster!\n'
						+ 'It looks like ' + moduleName + '.main is defined with `programWithFlags` but has type `Program Never`.\n'
						+ 'Use `program` instead if you do not want flags.'
					);
				}

				var result = A2(_elm_lang$core$Native_Json.run, flagDecoder, flags);
				if (result.ctor === 'Err')
				{
					throw new Error(
						moduleName + '.worker(...) was called with an unexpected argument.\n'
						+ 'I tried to convert it to an Elm value, but ran into this problem:\n\n'
						+ result._0
					);
				}

				return initialize(
					impl.init(result._0),
					impl.update,
					impl.subscriptions,
					renderer
				);
			};
		};
	};
}

function renderer(enqueue, _)
{
	return function(_) {};
}


// HTML TO PROGRAM

function htmlToProgram(vnode)
{
	var emptyBag = batch(_elm_lang$core$Native_List.Nil);
	var noChange = _elm_lang$core$Native_Utils.Tuple2(
		_elm_lang$core$Native_Utils.Tuple0,
		emptyBag
	);

	return _elm_lang$virtual_dom$VirtualDom$program({
		init: noChange,
		view: function(model) { return main; },
		update: F2(function(msg, model) { return noChange; }),
		subscriptions: function (model) { return emptyBag; }
	});
}


// INITIALIZE A PROGRAM

function initialize(init, update, subscriptions, renderer)
{
	// ambient state
	var managers = {};
	var updateView;

	// init and update state in main process
	var initApp = _elm_lang$core$Native_Scheduler.nativeBinding(function(callback) {
		var model = init._0;
		updateView = renderer(enqueue, model);
		var cmds = init._1;
		var subs = subscriptions(model);
		dispatchEffects(managers, cmds, subs);
		callback(_elm_lang$core$Native_Scheduler.succeed(model));
	});

	function onMessage(msg, model)
	{
		return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback) {
			var results = A2(update, msg, model);
			model = results._0;
			updateView(model);
			var cmds = results._1;
			var subs = subscriptions(model);
			dispatchEffects(managers, cmds, subs);
			callback(_elm_lang$core$Native_Scheduler.succeed(model));
		});
	}

	var mainProcess = spawnLoop(initApp, onMessage);

	function enqueue(msg)
	{
		_elm_lang$core$Native_Scheduler.rawSend(mainProcess, msg);
	}

	var ports = setupEffects(managers, enqueue);

	return ports ? { ports: ports } : {};
}


// EFFECT MANAGERS

var effectManagers = {};

function setupEffects(managers, callback)
{
	var ports;

	// setup all necessary effect managers
	for (var key in effectManagers)
	{
		var manager = effectManagers[key];

		if (manager.isForeign)
		{
			ports = ports || {};
			ports[key] = manager.tag === 'cmd'
				? setupOutgoingPort(key)
				: setupIncomingPort(key, callback);
		}

		managers[key] = makeManager(manager, callback);
	}

	return ports;
}

function makeManager(info, callback)
{
	var router = {
		main: callback,
		self: undefined
	};

	var tag = info.tag;
	var onEffects = info.onEffects;
	var onSelfMsg = info.onSelfMsg;

	function onMessage(msg, state)
	{
		if (msg.ctor === 'self')
		{
			return A3(onSelfMsg, router, msg._0, state);
		}

		var fx = msg._0;
		switch (tag)
		{
			case 'cmd':
				return A3(onEffects, router, fx.cmds, state);

			case 'sub':
				return A3(onEffects, router, fx.subs, state);

			case 'fx':
				return A4(onEffects, router, fx.cmds, fx.subs, state);
		}
	}

	var process = spawnLoop(info.init, onMessage);
	router.self = process;
	return process;
}

function sendToApp(router, msg)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		router.main(msg);
		callback(_elm_lang$core$Native_Scheduler.succeed(_elm_lang$core$Native_Utils.Tuple0));
	});
}

function sendToSelf(router, msg)
{
	return A2(_elm_lang$core$Native_Scheduler.send, router.self, {
		ctor: 'self',
		_0: msg
	});
}


// HELPER for STATEFUL LOOPS

function spawnLoop(init, onMessage)
{
	var andThen = _elm_lang$core$Native_Scheduler.andThen;

	function loop(state)
	{
		var handleMsg = _elm_lang$core$Native_Scheduler.receive(function(msg) {
			return onMessage(msg, state);
		});
		return A2(andThen, loop, handleMsg);
	}

	var task = A2(andThen, loop, init);

	return _elm_lang$core$Native_Scheduler.rawSpawn(task);
}


// BAGS

function leaf(home)
{
	return function(value)
	{
		return {
			type: 'leaf',
			home: home,
			value: value
		};
	};
}

function batch(list)
{
	return {
		type: 'node',
		branches: list
	};
}

function map(tagger, bag)
{
	return {
		type: 'map',
		tagger: tagger,
		tree: bag
	}
}


// PIPE BAGS INTO EFFECT MANAGERS

function dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	gatherEffects(true, cmdBag, effectsDict, null);
	gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		var fx = home in effectsDict
			? effectsDict[home]
			: {
				cmds: _elm_lang$core$Native_List.Nil,
				subs: _elm_lang$core$Native_List.Nil
			};

		_elm_lang$core$Native_Scheduler.rawSend(managers[home], { ctor: 'fx', _0: fx });
	}
}

function gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.type)
	{
		case 'leaf':
			var home = bag.home;
			var effect = toEffect(isCmd, home, taggers, bag.value);
			effectsDict[home] = insert(isCmd, effect, effectsDict[home]);
			return;

		case 'node':
			var list = bag.branches;
			while (list.ctor !== '[]')
			{
				gatherEffects(isCmd, list._0, effectsDict, taggers);
				list = list._1;
			}
			return;

		case 'map':
			gatherEffects(isCmd, bag.tree, effectsDict, {
				tagger: bag.tagger,
				rest: taggers
			});
			return;
	}
}

function toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		var temp = taggers;
		while (temp)
		{
			x = temp.tagger(x);
			temp = temp.rest;
		}
		return x;
	}

	var map = isCmd
		? effectManagers[home].cmdMap
		: effectManagers[home].subMap;

	return A2(map, applyTaggers, value)
}

function insert(isCmd, newEffect, effects)
{
	effects = effects || {
		cmds: _elm_lang$core$Native_List.Nil,
		subs: _elm_lang$core$Native_List.Nil
	};
	if (isCmd)
	{
		effects.cmds = _elm_lang$core$Native_List.Cons(newEffect, effects.cmds);
		return effects;
	}
	effects.subs = _elm_lang$core$Native_List.Cons(newEffect, effects.subs);
	return effects;
}


// PORTS

function checkPortName(name)
{
	if (name in effectManagers)
	{
		throw new Error('There can only be one port named `' + name + '`, but your program has multiple.');
	}
}


// OUTGOING PORTS

function outgoingPort(name, converter)
{
	checkPortName(name);
	effectManagers[name] = {
		tag: 'cmd',
		cmdMap: outgoingPortMap,
		converter: converter,
		isForeign: true
	};
	return leaf(name);
}

var outgoingPortMap = F2(function cmdMap(tagger, value) {
	return value;
});

function setupOutgoingPort(name)
{
	var subs = [];
	var converter = effectManagers[name].converter;

	// CREATE MANAGER

	var init = _elm_lang$core$Native_Scheduler.succeed(null);

	function onEffects(router, cmdList, state)
	{
		while (cmdList.ctor !== '[]')
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = converter(cmdList._0);
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
			cmdList = cmdList._1;
		}
		return init;
	}

	effectManagers[name].init = init;
	effectManagers[name].onEffects = F3(onEffects);

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}


// INCOMING PORTS

function incomingPort(name, converter)
{
	checkPortName(name);
	effectManagers[name] = {
		tag: 'sub',
		subMap: incomingPortMap,
		converter: converter,
		isForeign: true
	};
	return leaf(name);
}

var incomingPortMap = F2(function subMap(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});

function setupIncomingPort(name, callback)
{
	var sentBeforeInit = [];
	var subs = _elm_lang$core$Native_List.Nil;
	var converter = effectManagers[name].converter;
	var currentOnEffects = preInitOnEffects;
	var currentSend = preInitSend;

	// CREATE MANAGER

	var init = _elm_lang$core$Native_Scheduler.succeed(null);

	function preInitOnEffects(router, subList, state)
	{
		var postInitResult = postInitOnEffects(router, subList, state);

		for(var i = 0; i < sentBeforeInit.length; i++)
		{
			postInitSend(sentBeforeInit[i]);
		}

		sentBeforeInit = null; // to release objects held in queue
		currentSend = postInitSend;
		currentOnEffects = postInitOnEffects;
		return postInitResult;
	}

	function postInitOnEffects(router, subList, state)
	{
		subs = subList;
		return init;
	}

	function onEffects(router, subList, state)
	{
		return currentOnEffects(router, subList, state);
	}

	effectManagers[name].init = init;
	effectManagers[name].onEffects = F3(onEffects);

	// PUBLIC API

	function preInitSend(value)
	{
		sentBeforeInit.push(value);
	}

	function postInitSend(value)
	{
		var temp = subs;
		while (temp.ctor !== '[]')
		{
			callback(temp._0(value));
			temp = temp._1;
		}
	}

	function send(incomingValue)
	{
		var result = A2(_elm_lang$core$Json_Decode$decodeValue, converter, incomingValue);
		if (result.ctor === 'Err')
		{
			throw new Error('Trying to send an unexpected type of value through port `' + name + '`:\n' + result._0);
		}

		currentSend(result._0);
	}

	return { send: send };
}

return {
	// routers
	sendToApp: F2(sendToApp),
	sendToSelf: F2(sendToSelf),

	// global setup
	effectManagers: effectManagers,
	outgoingPort: outgoingPort,
	incomingPort: incomingPort,

	htmlToProgram: htmlToProgram,
	program: program,
	programWithFlags: programWithFlags,
	initialize: initialize,

	// effect bags
	leaf: leaf,
	batch: batch,
	map: F2(map)
};

}();

//import Native.Utils //

var _elm_lang$core$Native_Scheduler = function() {

var MAX_STEPS = 10000;


// TASKS

function succeed(value)
{
	return {
		ctor: '_Task_succeed',
		value: value
	};
}

function fail(error)
{
	return {
		ctor: '_Task_fail',
		value: error
	};
}

function nativeBinding(callback)
{
	return {
		ctor: '_Task_nativeBinding',
		callback: callback,
		cancel: null
	};
}

function andThen(callback, task)
{
	return {
		ctor: '_Task_andThen',
		callback: callback,
		task: task
	};
}

function onError(callback, task)
{
	return {
		ctor: '_Task_onError',
		callback: callback,
		task: task
	};
}

function receive(callback)
{
	return {
		ctor: '_Task_receive',
		callback: callback
	};
}


// PROCESSES

function rawSpawn(task)
{
	var process = {
		ctor: '_Process',
		id: _elm_lang$core$Native_Utils.guid(),
		root: task,
		stack: null,
		mailbox: []
	};

	enqueue(process);

	return process;
}

function spawn(task)
{
	return nativeBinding(function(callback) {
		var process = rawSpawn(task);
		callback(succeed(process));
	});
}

function rawSend(process, msg)
{
	process.mailbox.push(msg);
	enqueue(process);
}

function send(process, msg)
{
	return nativeBinding(function(callback) {
		rawSend(process, msg);
		callback(succeed(_elm_lang$core$Native_Utils.Tuple0));
	});
}

function kill(process)
{
	return nativeBinding(function(callback) {
		var root = process.root;
		if (root.ctor === '_Task_nativeBinding' && root.cancel)
		{
			root.cancel();
		}

		process.root = null;

		callback(succeed(_elm_lang$core$Native_Utils.Tuple0));
	});
}

function sleep(time)
{
	return nativeBinding(function(callback) {
		var id = setTimeout(function() {
			callback(succeed(_elm_lang$core$Native_Utils.Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}


// STEP PROCESSES

function step(numSteps, process)
{
	while (numSteps < MAX_STEPS)
	{
		var ctor = process.root.ctor;

		if (ctor === '_Task_succeed')
		{
			while (process.stack && process.stack.ctor === '_Task_onError')
			{
				process.stack = process.stack.rest;
			}
			if (process.stack === null)
			{
				break;
			}
			process.root = process.stack.callback(process.root.value);
			process.stack = process.stack.rest;
			++numSteps;
			continue;
		}

		if (ctor === '_Task_fail')
		{
			while (process.stack && process.stack.ctor === '_Task_andThen')
			{
				process.stack = process.stack.rest;
			}
			if (process.stack === null)
			{
				break;
			}
			process.root = process.stack.callback(process.root.value);
			process.stack = process.stack.rest;
			++numSteps;
			continue;
		}

		if (ctor === '_Task_andThen')
		{
			process.stack = {
				ctor: '_Task_andThen',
				callback: process.root.callback,
				rest: process.stack
			};
			process.root = process.root.task;
			++numSteps;
			continue;
		}

		if (ctor === '_Task_onError')
		{
			process.stack = {
				ctor: '_Task_onError',
				callback: process.root.callback,
				rest: process.stack
			};
			process.root = process.root.task;
			++numSteps;
			continue;
		}

		if (ctor === '_Task_nativeBinding')
		{
			process.root.cancel = process.root.callback(function(newRoot) {
				process.root = newRoot;
				enqueue(process);
			});

			break;
		}

		if (ctor === '_Task_receive')
		{
			var mailbox = process.mailbox;
			if (mailbox.length === 0)
			{
				break;
			}

			process.root = process.root.callback(mailbox.shift());
			++numSteps;
			continue;
		}

		throw new Error(ctor);
	}

	if (numSteps < MAX_STEPS)
	{
		return numSteps + 1;
	}
	enqueue(process);

	return numSteps;
}


// WORK QUEUE

var working = false;
var workQueue = [];

function enqueue(process)
{
	workQueue.push(process);

	if (!working)
	{
		setTimeout(work, 0);
		working = true;
	}
}

function work()
{
	var numSteps = 0;
	var process;
	while (numSteps < MAX_STEPS && (process = workQueue.shift()))
	{
		if (process.root)
		{
			numSteps = step(numSteps, process);
		}
	}
	if (!process)
	{
		working = false;
		return;
	}
	setTimeout(work, 0);
}


return {
	succeed: succeed,
	fail: fail,
	nativeBinding: nativeBinding,
	andThen: F2(andThen),
	onError: F2(onError),
	receive: receive,

	spawn: spawn,
	kill: kill,
	sleep: sleep,
	send: F2(send),

	rawSpawn: rawSpawn,
	rawSend: rawSend
};

}();
var _elm_lang$core$Platform_Cmd$batch = _elm_lang$core$Native_Platform.batch;
var _elm_lang$core$Platform_Cmd$none = _elm_lang$core$Platform_Cmd$batch(
	{ctor: '[]'});
var _elm_lang$core$Platform_Cmd_ops = _elm_lang$core$Platform_Cmd_ops || {};
_elm_lang$core$Platform_Cmd_ops['!'] = F2(
	function (model, commands) {
		return {
			ctor: '_Tuple2',
			_0: model,
			_1: _elm_lang$core$Platform_Cmd$batch(commands)
		};
	});
var _elm_lang$core$Platform_Cmd$map = _elm_lang$core$Native_Platform.map;
var _elm_lang$core$Platform_Cmd$Cmd = {ctor: 'Cmd'};

var _elm_lang$core$Platform_Sub$batch = _elm_lang$core$Native_Platform.batch;
var _elm_lang$core$Platform_Sub$none = _elm_lang$core$Platform_Sub$batch(
	{ctor: '[]'});
var _elm_lang$core$Platform_Sub$map = _elm_lang$core$Native_Platform.map;
var _elm_lang$core$Platform_Sub$Sub = {ctor: 'Sub'};

var _elm_lang$core$Platform$hack = _elm_lang$core$Native_Scheduler.succeed;
var _elm_lang$core$Platform$sendToSelf = _elm_lang$core$Native_Platform.sendToSelf;
var _elm_lang$core$Platform$sendToApp = _elm_lang$core$Native_Platform.sendToApp;
var _elm_lang$core$Platform$programWithFlags = _elm_lang$core$Native_Platform.programWithFlags;
var _elm_lang$core$Platform$program = _elm_lang$core$Native_Platform.program;
var _elm_lang$core$Platform$Program = {ctor: 'Program'};
var _elm_lang$core$Platform$Task = {ctor: 'Task'};
var _elm_lang$core$Platform$ProcessId = {ctor: 'ProcessId'};
var _elm_lang$core$Platform$Router = {ctor: 'Router'};

var _NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode = _elm_lang$core$Json_Decode$succeed;
var _NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$resolve = _elm_lang$core$Json_Decode$andThen(_elm_lang$core$Basics$identity);
var _NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom = F2(
	function (decoder, wrapped) {
		return A3(
			_elm_lang$core$Json_Decode$map2,
			F2(
				function (x, y) {
					return x(y);
				}),
			wrapped,
			decoder);
	});
var _NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$hardcoded = function (_p0) {
	return _NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom(
		_elm_lang$core$Json_Decode$succeed(_p0));
};
var _NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return _elm_lang$core$Json_Decode$oneOf(
				{
					ctor: '::',
					_0: decoder,
					_1: {
						ctor: '::',
						_0: _elm_lang$core$Json_Decode$null(fallback),
						_1: {ctor: '[]'}
					}
				});
		};
		var handleResult = function (input) {
			var _p1 = A2(_elm_lang$core$Json_Decode$decodeValue, pathDecoder, input);
			if (_p1.ctor === 'Ok') {
				var _p2 = A2(
					_elm_lang$core$Json_Decode$decodeValue,
					nullOr(valDecoder),
					_p1._0);
				if (_p2.ctor === 'Ok') {
					return _elm_lang$core$Json_Decode$succeed(_p2._0);
				} else {
					return _elm_lang$core$Json_Decode$fail(_p2._0);
				}
			} else {
				var _p3 = A2(
					_elm_lang$core$Json_Decode$decodeValue,
					_elm_lang$core$Json_Decode$keyValuePairs(_elm_lang$core$Json_Decode$value),
					input);
				if (_p3.ctor === 'Ok') {
					return _elm_lang$core$Json_Decode$succeed(fallback);
				} else {
					return _elm_lang$core$Json_Decode$fail(_p3._0);
				}
			}
		};
		return A2(_elm_lang$core$Json_Decode$andThen, handleResult, _elm_lang$core$Json_Decode$value);
	});
var _NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optionalAt = F4(
	function (path, valDecoder, fallback, decoder) {
		return A2(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
			A3(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optionalDecoder,
				A2(_elm_lang$core$Json_Decode$at, path, _elm_lang$core$Json_Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var _NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
			A3(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optionalDecoder,
				A2(_elm_lang$core$Json_Decode$field, key, _elm_lang$core$Json_Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var _NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
			A2(_elm_lang$core$Json_Decode$at, path, valDecoder),
			decoder);
	});
var _NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
			A2(_elm_lang$core$Json_Decode$field, key, valDecoder),
			decoder);
	});

//import Maybe, Native.List //

var _elm_lang$core$Native_Regex = function() {

function escape(str)
{
	return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}
function caseInsensitive(re)
{
	return new RegExp(re.source, 'gi');
}
function regex(raw)
{
	return new RegExp(raw, 'g');
}

function contains(re, string)
{
	return string.match(re) !== null;
}

function find(n, re, str)
{
	n = n.ctor === 'All' ? Infinity : n._0;
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex === re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch === undefined
				? _elm_lang$core$Maybe$Nothing
				: _elm_lang$core$Maybe$Just(submatch);
		}
		out.push({
			match: result[0],
			submatches: _elm_lang$core$Native_List.fromArray(subs),
			index: result.index,
			number: number
		});
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _elm_lang$core$Native_List.fromArray(out);
}

function replace(n, re, replacer, string)
{
	n = n.ctor === 'All' ? Infinity : n._0;
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch === undefined
				? _elm_lang$core$Maybe$Nothing
				: _elm_lang$core$Maybe$Just(submatch);
		}
		return replacer({
			match: match,
			submatches: _elm_lang$core$Native_List.fromArray(submatches),
			index: arguments[arguments.length - 2],
			number: count
		});
	}
	return string.replace(re, jsReplacer);
}

function split(n, re, str)
{
	n = n.ctor === 'All' ? Infinity : n._0;
	if (n === Infinity)
	{
		return _elm_lang$core$Native_List.fromArray(str.split(re));
	}
	var string = str;
	var result;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		if (!(result = re.exec(string))) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _elm_lang$core$Native_List.fromArray(out);
}

return {
	regex: regex,
	caseInsensitive: caseInsensitive,
	escape: escape,

	contains: F2(contains),
	find: F3(find),
	replace: F4(replace),
	split: F3(split)
};

}();

var _elm_lang$core$Regex$split = _elm_lang$core$Native_Regex.split;
var _elm_lang$core$Regex$replace = _elm_lang$core$Native_Regex.replace;
var _elm_lang$core$Regex$find = _elm_lang$core$Native_Regex.find;
var _elm_lang$core$Regex$contains = _elm_lang$core$Native_Regex.contains;
var _elm_lang$core$Regex$caseInsensitive = _elm_lang$core$Native_Regex.caseInsensitive;
var _elm_lang$core$Regex$regex = _elm_lang$core$Native_Regex.regex;
var _elm_lang$core$Regex$escape = _elm_lang$core$Native_Regex.escape;
var _elm_lang$core$Regex$Match = F4(
	function (a, b, c, d) {
		return {match: a, submatches: b, index: c, number: d};
	});
var _elm_lang$core$Regex$Regex = {ctor: 'Regex'};
var _elm_lang$core$Regex$AtMost = function (a) {
	return {ctor: 'AtMost', _0: a};
};
var _elm_lang$core$Regex$All = {ctor: 'All'};

//import Native.Scheduler //

var _elm_lang$core$Native_Time = function() {

var now = _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
{
	callback(_elm_lang$core$Native_Scheduler.succeed(Date.now()));
});

function setInterval_(interval, task)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		var id = setInterval(function() {
			_elm_lang$core$Native_Scheduler.rawSpawn(task);
		}, interval);

		return function() { clearInterval(id); };
	});
}

return {
	now: now,
	setInterval_: F2(setInterval_)
};

}();
var _elm_lang$core$Task$onError = _elm_lang$core$Native_Scheduler.onError;
var _elm_lang$core$Task$andThen = _elm_lang$core$Native_Scheduler.andThen;
var _elm_lang$core$Task$spawnCmd = F2(
	function (router, _p0) {
		var _p1 = _p0;
		return _elm_lang$core$Native_Scheduler.spawn(
			A2(
				_elm_lang$core$Task$andThen,
				_elm_lang$core$Platform$sendToApp(router),
				_p1._0));
	});
var _elm_lang$core$Task$fail = _elm_lang$core$Native_Scheduler.fail;
var _elm_lang$core$Task$mapError = F2(
	function (convert, task) {
		return A2(
			_elm_lang$core$Task$onError,
			function (_p2) {
				return _elm_lang$core$Task$fail(
					convert(_p2));
			},
			task);
	});
var _elm_lang$core$Task$succeed = _elm_lang$core$Native_Scheduler.succeed;
var _elm_lang$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (a) {
				return _elm_lang$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var _elm_lang$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (a) {
				return A2(
					_elm_lang$core$Task$andThen,
					function (b) {
						return _elm_lang$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var _elm_lang$core$Task$map3 = F4(
	function (func, taskA, taskB, taskC) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (a) {
				return A2(
					_elm_lang$core$Task$andThen,
					function (b) {
						return A2(
							_elm_lang$core$Task$andThen,
							function (c) {
								return _elm_lang$core$Task$succeed(
									A3(func, a, b, c));
							},
							taskC);
					},
					taskB);
			},
			taskA);
	});
var _elm_lang$core$Task$map4 = F5(
	function (func, taskA, taskB, taskC, taskD) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (a) {
				return A2(
					_elm_lang$core$Task$andThen,
					function (b) {
						return A2(
							_elm_lang$core$Task$andThen,
							function (c) {
								return A2(
									_elm_lang$core$Task$andThen,
									function (d) {
										return _elm_lang$core$Task$succeed(
											A4(func, a, b, c, d));
									},
									taskD);
							},
							taskC);
					},
					taskB);
			},
			taskA);
	});
var _elm_lang$core$Task$map5 = F6(
	function (func, taskA, taskB, taskC, taskD, taskE) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (a) {
				return A2(
					_elm_lang$core$Task$andThen,
					function (b) {
						return A2(
							_elm_lang$core$Task$andThen,
							function (c) {
								return A2(
									_elm_lang$core$Task$andThen,
									function (d) {
										return A2(
											_elm_lang$core$Task$andThen,
											function (e) {
												return _elm_lang$core$Task$succeed(
													A5(func, a, b, c, d, e));
											},
											taskE);
									},
									taskD);
							},
							taskC);
					},
					taskB);
			},
			taskA);
	});
var _elm_lang$core$Task$sequence = function (tasks) {
	var _p3 = tasks;
	if (_p3.ctor === '[]') {
		return _elm_lang$core$Task$succeed(
			{ctor: '[]'});
	} else {
		return A3(
			_elm_lang$core$Task$map2,
			F2(
				function (x, y) {
					return {ctor: '::', _0: x, _1: y};
				}),
			_p3._0,
			_elm_lang$core$Task$sequence(_p3._1));
	}
};
var _elm_lang$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			_elm_lang$core$Task$map,
			function (_p4) {
				return {ctor: '_Tuple0'};
			},
			_elm_lang$core$Task$sequence(
				A2(
					_elm_lang$core$List$map,
					_elm_lang$core$Task$spawnCmd(router),
					commands)));
	});
var _elm_lang$core$Task$init = _elm_lang$core$Task$succeed(
	{ctor: '_Tuple0'});
var _elm_lang$core$Task$onSelfMsg = F3(
	function (_p7, _p6, _p5) {
		return _elm_lang$core$Task$succeed(
			{ctor: '_Tuple0'});
	});
var _elm_lang$core$Task$command = _elm_lang$core$Native_Platform.leaf('Task');
var _elm_lang$core$Task$Perform = function (a) {
	return {ctor: 'Perform', _0: a};
};
var _elm_lang$core$Task$perform = F2(
	function (toMessage, task) {
		return _elm_lang$core$Task$command(
			_elm_lang$core$Task$Perform(
				A2(_elm_lang$core$Task$map, toMessage, task)));
	});
var _elm_lang$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return _elm_lang$core$Task$command(
			_elm_lang$core$Task$Perform(
				A2(
					_elm_lang$core$Task$onError,
					function (_p8) {
						return _elm_lang$core$Task$succeed(
							resultToMessage(
								_elm_lang$core$Result$Err(_p8)));
					},
					A2(
						_elm_lang$core$Task$andThen,
						function (_p9) {
							return _elm_lang$core$Task$succeed(
								resultToMessage(
									_elm_lang$core$Result$Ok(_p9)));
						},
						task))));
	});
var _elm_lang$core$Task$cmdMap = F2(
	function (tagger, _p10) {
		var _p11 = _p10;
		return _elm_lang$core$Task$Perform(
			A2(_elm_lang$core$Task$map, tagger, _p11._0));
	});
_elm_lang$core$Native_Platform.effectManagers['Task'] = {pkg: 'elm-lang/core', init: _elm_lang$core$Task$init, onEffects: _elm_lang$core$Task$onEffects, onSelfMsg: _elm_lang$core$Task$onSelfMsg, tag: 'cmd', cmdMap: _elm_lang$core$Task$cmdMap};

var _elm_lang$core$Time$setInterval = _elm_lang$core$Native_Time.setInterval_;
var _elm_lang$core$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		var _p0 = intervals;
		if (_p0.ctor === '[]') {
			return _elm_lang$core$Task$succeed(processes);
		} else {
			var _p1 = _p0._0;
			var spawnRest = function (id) {
				return A3(
					_elm_lang$core$Time$spawnHelp,
					router,
					_p0._1,
					A3(_elm_lang$core$Dict$insert, _p1, id, processes));
			};
			var spawnTimer = _elm_lang$core$Native_Scheduler.spawn(
				A2(
					_elm_lang$core$Time$setInterval,
					_p1,
					A2(_elm_lang$core$Platform$sendToSelf, router, _p1)));
			return A2(_elm_lang$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var _elm_lang$core$Time$addMySub = F2(
	function (_p2, state) {
		var _p3 = _p2;
		var _p6 = _p3._1;
		var _p5 = _p3._0;
		var _p4 = A2(_elm_lang$core$Dict$get, _p5, state);
		if (_p4.ctor === 'Nothing') {
			return A3(
				_elm_lang$core$Dict$insert,
				_p5,
				{
					ctor: '::',
					_0: _p6,
					_1: {ctor: '[]'}
				},
				state);
		} else {
			return A3(
				_elm_lang$core$Dict$insert,
				_p5,
				{ctor: '::', _0: _p6, _1: _p4._0},
				state);
		}
	});
var _elm_lang$core$Time$inMilliseconds = function (t) {
	return t;
};
var _elm_lang$core$Time$millisecond = 1;
var _elm_lang$core$Time$second = 1000 * _elm_lang$core$Time$millisecond;
var _elm_lang$core$Time$minute = 60 * _elm_lang$core$Time$second;
var _elm_lang$core$Time$hour = 60 * _elm_lang$core$Time$minute;
var _elm_lang$core$Time$inHours = function (t) {
	return t / _elm_lang$core$Time$hour;
};
var _elm_lang$core$Time$inMinutes = function (t) {
	return t / _elm_lang$core$Time$minute;
};
var _elm_lang$core$Time$inSeconds = function (t) {
	return t / _elm_lang$core$Time$second;
};
var _elm_lang$core$Time$now = _elm_lang$core$Native_Time.now;
var _elm_lang$core$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _p7 = A2(_elm_lang$core$Dict$get, interval, state.taggers);
		if (_p7.ctor === 'Nothing') {
			return _elm_lang$core$Task$succeed(state);
		} else {
			var tellTaggers = function (time) {
				return _elm_lang$core$Task$sequence(
					A2(
						_elm_lang$core$List$map,
						function (tagger) {
							return A2(
								_elm_lang$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						_p7._0));
			};
			return A2(
				_elm_lang$core$Task$andThen,
				function (_p8) {
					return _elm_lang$core$Task$succeed(state);
				},
				A2(_elm_lang$core$Task$andThen, tellTaggers, _elm_lang$core$Time$now));
		}
	});
var _elm_lang$core$Time$subscription = _elm_lang$core$Native_Platform.leaf('Time');
var _elm_lang$core$Time$State = F2(
	function (a, b) {
		return {taggers: a, processes: b};
	});
var _elm_lang$core$Time$init = _elm_lang$core$Task$succeed(
	A2(_elm_lang$core$Time$State, _elm_lang$core$Dict$empty, _elm_lang$core$Dict$empty));
var _elm_lang$core$Time$onEffects = F3(
	function (router, subs, _p9) {
		var _p10 = _p9;
		var rightStep = F3(
			function (_p12, id, _p11) {
				var _p13 = _p11;
				return {
					ctor: '_Tuple3',
					_0: _p13._0,
					_1: _p13._1,
					_2: A2(
						_elm_lang$core$Task$andThen,
						function (_p14) {
							return _p13._2;
						},
						_elm_lang$core$Native_Scheduler.kill(id))
				};
			});
		var bothStep = F4(
			function (interval, taggers, id, _p15) {
				var _p16 = _p15;
				return {
					ctor: '_Tuple3',
					_0: _p16._0,
					_1: A3(_elm_lang$core$Dict$insert, interval, id, _p16._1),
					_2: _p16._2
				};
			});
		var leftStep = F3(
			function (interval, taggers, _p17) {
				var _p18 = _p17;
				return {
					ctor: '_Tuple3',
					_0: {ctor: '::', _0: interval, _1: _p18._0},
					_1: _p18._1,
					_2: _p18._2
				};
			});
		var newTaggers = A3(_elm_lang$core$List$foldl, _elm_lang$core$Time$addMySub, _elm_lang$core$Dict$empty, subs);
		var _p19 = A6(
			_elm_lang$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			_p10.processes,
			{
				ctor: '_Tuple3',
				_0: {ctor: '[]'},
				_1: _elm_lang$core$Dict$empty,
				_2: _elm_lang$core$Task$succeed(
					{ctor: '_Tuple0'})
			});
		var spawnList = _p19._0;
		var existingDict = _p19._1;
		var killTask = _p19._2;
		return A2(
			_elm_lang$core$Task$andThen,
			function (newProcesses) {
				return _elm_lang$core$Task$succeed(
					A2(_elm_lang$core$Time$State, newTaggers, newProcesses));
			},
			A2(
				_elm_lang$core$Task$andThen,
				function (_p20) {
					return A3(_elm_lang$core$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var _elm_lang$core$Time$Every = F2(
	function (a, b) {
		return {ctor: 'Every', _0: a, _1: b};
	});
var _elm_lang$core$Time$every = F2(
	function (interval, tagger) {
		return _elm_lang$core$Time$subscription(
			A2(_elm_lang$core$Time$Every, interval, tagger));
	});
var _elm_lang$core$Time$subMap = F2(
	function (f, _p21) {
		var _p22 = _p21;
		return A2(
			_elm_lang$core$Time$Every,
			_p22._0,
			function (_p23) {
				return f(
					_p22._1(_p23));
			});
	});
_elm_lang$core$Native_Platform.effectManagers['Time'] = {pkg: 'elm-lang/core', init: _elm_lang$core$Time$init, onEffects: _elm_lang$core$Time$onEffects, onSelfMsg: _elm_lang$core$Time$onSelfMsg, tag: 'sub', subMap: _elm_lang$core$Time$subMap};

var _elm_lang$virtual_dom$VirtualDom_Debug$wrap;
var _elm_lang$virtual_dom$VirtualDom_Debug$wrapWithFlags;

var _elm_lang$virtual_dom$Native_VirtualDom = function() {

var STYLE_KEY = 'STYLE';
var EVENT_KEY = 'EVENT';
var ATTR_KEY = 'ATTR';
var ATTR_NS_KEY = 'ATTR_NS';

var localDoc = typeof document !== 'undefined' ? document : {};


////////////  VIRTUAL DOM NODES  ////////////


function text(string)
{
	return {
		type: 'text',
		text: string
	};
}


function node(tag)
{
	return F2(function(factList, kidList) {
		return nodeHelp(tag, factList, kidList);
	});
}


function nodeHelp(tag, factList, kidList)
{
	var organized = organizeFacts(factList);
	var namespace = organized.namespace;
	var facts = organized.facts;

	var children = [];
	var descendantsCount = 0;
	while (kidList.ctor !== '[]')
	{
		var kid = kidList._0;
		descendantsCount += (kid.descendantsCount || 0);
		children.push(kid);
		kidList = kidList._1;
	}
	descendantsCount += children.length;

	return {
		type: 'node',
		tag: tag,
		facts: facts,
		children: children,
		namespace: namespace,
		descendantsCount: descendantsCount
	};
}


function keyedNode(tag, factList, kidList)
{
	var organized = organizeFacts(factList);
	var namespace = organized.namespace;
	var facts = organized.facts;

	var children = [];
	var descendantsCount = 0;
	while (kidList.ctor !== '[]')
	{
		var kid = kidList._0;
		descendantsCount += (kid._1.descendantsCount || 0);
		children.push(kid);
		kidList = kidList._1;
	}
	descendantsCount += children.length;

	return {
		type: 'keyed-node',
		tag: tag,
		facts: facts,
		children: children,
		namespace: namespace,
		descendantsCount: descendantsCount
	};
}


function custom(factList, model, impl)
{
	var facts = organizeFacts(factList).facts;

	return {
		type: 'custom',
		facts: facts,
		model: model,
		impl: impl
	};
}


function map(tagger, node)
{
	return {
		type: 'tagger',
		tagger: tagger,
		node: node,
		descendantsCount: 1 + (node.descendantsCount || 0)
	};
}


function thunk(func, args, thunk)
{
	return {
		type: 'thunk',
		func: func,
		args: args,
		thunk: thunk,
		node: undefined
	};
}

function lazy(fn, a)
{
	return thunk(fn, [a], function() {
		return fn(a);
	});
}

function lazy2(fn, a, b)
{
	return thunk(fn, [a,b], function() {
		return A2(fn, a, b);
	});
}

function lazy3(fn, a, b, c)
{
	return thunk(fn, [a,b,c], function() {
		return A3(fn, a, b, c);
	});
}



// FACTS


function organizeFacts(factList)
{
	var namespace, facts = {};

	while (factList.ctor !== '[]')
	{
		var entry = factList._0;
		var key = entry.key;

		if (key === ATTR_KEY || key === ATTR_NS_KEY || key === EVENT_KEY)
		{
			var subFacts = facts[key] || {};
			subFacts[entry.realKey] = entry.value;
			facts[key] = subFacts;
		}
		else if (key === STYLE_KEY)
		{
			var styles = facts[key] || {};
			var styleList = entry.value;
			while (styleList.ctor !== '[]')
			{
				var style = styleList._0;
				styles[style._0] = style._1;
				styleList = styleList._1;
			}
			facts[key] = styles;
		}
		else if (key === 'namespace')
		{
			namespace = entry.value;
		}
		else if (key === 'className')
		{
			var classes = facts[key];
			facts[key] = typeof classes === 'undefined'
				? entry.value
				: classes + ' ' + entry.value;
		}
 		else
		{
			facts[key] = entry.value;
		}
		factList = factList._1;
	}

	return {
		facts: facts,
		namespace: namespace
	};
}



////////////  PROPERTIES AND ATTRIBUTES  ////////////


function style(value)
{
	return {
		key: STYLE_KEY,
		value: value
	};
}


function property(key, value)
{
	return {
		key: key,
		value: value
	};
}


function attribute(key, value)
{
	return {
		key: ATTR_KEY,
		realKey: key,
		value: value
	};
}


function attributeNS(namespace, key, value)
{
	return {
		key: ATTR_NS_KEY,
		realKey: key,
		value: {
			value: value,
			namespace: namespace
		}
	};
}


function on(name, options, decoder)
{
	return {
		key: EVENT_KEY,
		realKey: name,
		value: {
			options: options,
			decoder: decoder
		}
	};
}


function equalEvents(a, b)
{
	if (a.options !== b.options)
	{
		if (a.options.stopPropagation !== b.options.stopPropagation || a.options.preventDefault !== b.options.preventDefault)
		{
			return false;
		}
	}
	return _elm_lang$core$Native_Json.equality(a.decoder, b.decoder);
}


function mapProperty(func, property)
{
	if (property.key !== EVENT_KEY)
	{
		return property;
	}
	return on(
		property.realKey,
		property.value.options,
		A2(_elm_lang$core$Json_Decode$map, func, property.value.decoder)
	);
}


////////////  RENDER  ////////////


function render(vNode, eventNode)
{
	switch (vNode.type)
	{
		case 'thunk':
			if (!vNode.node)
			{
				vNode.node = vNode.thunk();
			}
			return render(vNode.node, eventNode);

		case 'tagger':
			var subNode = vNode.node;
			var tagger = vNode.tagger;

			while (subNode.type === 'tagger')
			{
				typeof tagger !== 'object'
					? tagger = [tagger, subNode.tagger]
					: tagger.push(subNode.tagger);

				subNode = subNode.node;
			}

			var subEventRoot = { tagger: tagger, parent: eventNode };
			var domNode = render(subNode, subEventRoot);
			domNode.elm_event_node_ref = subEventRoot;
			return domNode;

		case 'text':
			return localDoc.createTextNode(vNode.text);

		case 'node':
			var domNode = vNode.namespace
				? localDoc.createElementNS(vNode.namespace, vNode.tag)
				: localDoc.createElement(vNode.tag);

			applyFacts(domNode, eventNode, vNode.facts);

			var children = vNode.children;

			for (var i = 0; i < children.length; i++)
			{
				domNode.appendChild(render(children[i], eventNode));
			}

			return domNode;

		case 'keyed-node':
			var domNode = vNode.namespace
				? localDoc.createElementNS(vNode.namespace, vNode.tag)
				: localDoc.createElement(vNode.tag);

			applyFacts(domNode, eventNode, vNode.facts);

			var children = vNode.children;

			for (var i = 0; i < children.length; i++)
			{
				domNode.appendChild(render(children[i]._1, eventNode));
			}

			return domNode;

		case 'custom':
			var domNode = vNode.impl.render(vNode.model);
			applyFacts(domNode, eventNode, vNode.facts);
			return domNode;
	}
}



////////////  APPLY FACTS  ////////////


function applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		switch (key)
		{
			case STYLE_KEY:
				applyStyles(domNode, value);
				break;

			case EVENT_KEY:
				applyEvents(domNode, eventNode, value);
				break;

			case ATTR_KEY:
				applyAttrs(domNode, value);
				break;

			case ATTR_NS_KEY:
				applyAttrsNS(domNode, value);
				break;

			case 'value':
				if (domNode[key] !== value)
				{
					domNode[key] = value;
				}
				break;

			default:
				domNode[key] = value;
				break;
		}
	}
}

function applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}

function applyEvents(domNode, eventNode, events)
{
	var allHandlers = domNode.elm_handlers || {};

	for (var key in events)
	{
		var handler = allHandlers[key];
		var value = events[key];

		if (typeof value === 'undefined')
		{
			domNode.removeEventListener(key, handler);
			allHandlers[key] = undefined;
		}
		else if (typeof handler === 'undefined')
		{
			var handler = makeEventHandler(eventNode, value);
			domNode.addEventListener(key, handler);
			allHandlers[key] = handler;
		}
		else
		{
			handler.info = value;
		}
	}

	domNode.elm_handlers = allHandlers;
}

function makeEventHandler(eventNode, info)
{
	function eventHandler(event)
	{
		var info = eventHandler.info;

		var value = A2(_elm_lang$core$Native_Json.run, info.decoder, event);

		if (value.ctor === 'Ok')
		{
			var options = info.options;
			if (options.stopPropagation)
			{
				event.stopPropagation();
			}
			if (options.preventDefault)
			{
				event.preventDefault();
			}

			var message = value._0;

			var currentEventNode = eventNode;
			while (currentEventNode)
			{
				var tagger = currentEventNode.tagger;
				if (typeof tagger === 'function')
				{
					message = tagger(message);
				}
				else
				{
					for (var i = tagger.length; i--; )
					{
						message = tagger[i](message);
					}
				}
				currentEventNode = currentEventNode.parent;
			}
		}
	};

	eventHandler.info = info;

	return eventHandler;
}

function applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		if (typeof value === 'undefined')
		{
			domNode.removeAttribute(key);
		}
		else
		{
			domNode.setAttribute(key, value);
		}
	}
}

function applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.namespace;
		var value = pair.value;

		if (typeof value === 'undefined')
		{
			domNode.removeAttributeNS(namespace, key);
		}
		else
		{
			domNode.setAttributeNS(namespace, key, value);
		}
	}
}



////////////  DIFF  ////////////


function diff(a, b)
{
	var patches = [];
	diffHelp(a, b, patches, 0);
	return patches;
}


function makePatch(type, index, data)
{
	return {
		index: index,
		type: type,
		data: data,
		domNode: undefined,
		eventNode: undefined
	};
}


function diffHelp(a, b, patches, index)
{
	if (a === b)
	{
		return;
	}

	var aType = a.type;
	var bType = b.type;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (aType !== bType)
	{
		patches.push(makePatch('p-redraw', index, b));
		return;
	}

	// Now we know that both nodes are the same type.
	switch (bType)
	{
		case 'thunk':
			var aArgs = a.args;
			var bArgs = b.args;
			var i = aArgs.length;
			var same = a.func === b.func && i === bArgs.length;
			while (same && i--)
			{
				same = aArgs[i] === bArgs[i];
			}
			if (same)
			{
				b.node = a.node;
				return;
			}
			b.node = b.thunk();
			var subPatches = [];
			diffHelp(a.node, b.node, subPatches, 0);
			if (subPatches.length > 0)
			{
				patches.push(makePatch('p-thunk', index, subPatches));
			}
			return;

		case 'tagger':
			// gather nested taggers
			var aTaggers = a.tagger;
			var bTaggers = b.tagger;
			var nesting = false;

			var aSubNode = a.node;
			while (aSubNode.type === 'tagger')
			{
				nesting = true;

				typeof aTaggers !== 'object'
					? aTaggers = [aTaggers, aSubNode.tagger]
					: aTaggers.push(aSubNode.tagger);

				aSubNode = aSubNode.node;
			}

			var bSubNode = b.node;
			while (bSubNode.type === 'tagger')
			{
				nesting = true;

				typeof bTaggers !== 'object'
					? bTaggers = [bTaggers, bSubNode.tagger]
					: bTaggers.push(bSubNode.tagger);

				bSubNode = bSubNode.node;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && aTaggers.length !== bTaggers.length)
			{
				patches.push(makePatch('p-redraw', index, b));
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !pairwiseRefEqual(aTaggers, bTaggers) : aTaggers !== bTaggers)
			{
				patches.push(makePatch('p-tagger', index, bTaggers));
			}

			// diff everything below the taggers
			diffHelp(aSubNode, bSubNode, patches, index + 1);
			return;

		case 'text':
			if (a.text !== b.text)
			{
				patches.push(makePatch('p-text', index, b.text));
				return;
			}

			return;

		case 'node':
			// Bail if obvious indicators have changed. Implies more serious
			// structural changes such that it's not worth it to diff.
			if (a.tag !== b.tag || a.namespace !== b.namespace)
			{
				patches.push(makePatch('p-redraw', index, b));
				return;
			}

			var factsDiff = diffFacts(a.facts, b.facts);

			if (typeof factsDiff !== 'undefined')
			{
				patches.push(makePatch('p-facts', index, factsDiff));
			}

			diffChildren(a, b, patches, index);
			return;

		case 'keyed-node':
			// Bail if obvious indicators have changed. Implies more serious
			// structural changes such that it's not worth it to diff.
			if (a.tag !== b.tag || a.namespace !== b.namespace)
			{
				patches.push(makePatch('p-redraw', index, b));
				return;
			}

			var factsDiff = diffFacts(a.facts, b.facts);

			if (typeof factsDiff !== 'undefined')
			{
				patches.push(makePatch('p-facts', index, factsDiff));
			}

			diffKeyedChildren(a, b, patches, index);
			return;

		case 'custom':
			if (a.impl !== b.impl)
			{
				patches.push(makePatch('p-redraw', index, b));
				return;
			}

			var factsDiff = diffFacts(a.facts, b.facts);
			if (typeof factsDiff !== 'undefined')
			{
				patches.push(makePatch('p-facts', index, factsDiff));
			}

			var patch = b.impl.diff(a,b);
			if (patch)
			{
				patches.push(makePatch('p-custom', index, patch));
				return;
			}

			return;
	}
}


// assumes the incoming arrays are the same length
function pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function diffFacts(a, b, category)
{
	var diff;

	// look for changes and removals
	for (var aKey in a)
	{
		if (aKey === STYLE_KEY || aKey === EVENT_KEY || aKey === ATTR_KEY || aKey === ATTR_NS_KEY)
		{
			var subDiff = diffFacts(a[aKey], b[aKey] || {}, aKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[aKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(aKey in b))
		{
			diff = diff || {};
			diff[aKey] =
				(typeof category === 'undefined')
					? (typeof a[aKey] === 'string' ? '' : null)
					:
				(category === STYLE_KEY)
					? ''
					:
				(category === EVENT_KEY || category === ATTR_KEY)
					? undefined
					:
				{ namespace: a[aKey].namespace, value: undefined };

			continue;
		}

		var aValue = a[aKey];
		var bValue = b[aKey];

		// reference equal, so don't worry about it
		if (aValue === bValue && aKey !== 'value'
			|| category === EVENT_KEY && equalEvents(aValue, bValue))
		{
			continue;
		}

		diff = diff || {};
		diff[aKey] = bValue;
	}

	// add new stuff
	for (var bKey in b)
	{
		if (!(bKey in a))
		{
			diff = diff || {};
			diff[bKey] = b[bKey];
		}
	}

	return diff;
}


function diffChildren(aParent, bParent, patches, rootIndex)
{
	var aChildren = aParent.children;
	var bChildren = bParent.children;

	var aLen = aChildren.length;
	var bLen = bChildren.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (aLen > bLen)
	{
		patches.push(makePatch('p-remove-last', rootIndex, aLen - bLen));
	}
	else if (aLen < bLen)
	{
		patches.push(makePatch('p-append', rootIndex, bChildren.slice(aLen)));
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	var index = rootIndex;
	var minLen = aLen < bLen ? aLen : bLen;
	for (var i = 0; i < minLen; i++)
	{
		index++;
		var aChild = aChildren[i];
		diffHelp(aChild, bChildren[i], patches, index);
		index += aChild.descendantsCount || 0;
	}
}



////////////  KEYED DIFF  ////////////


function diffKeyedChildren(aParent, bParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var aChildren = aParent.children;
	var bChildren = bParent.children;
	var aLen = aChildren.length;
	var bLen = bChildren.length;
	var aIndex = 0;
	var bIndex = 0;

	var index = rootIndex;

	while (aIndex < aLen && bIndex < bLen)
	{
		var a = aChildren[aIndex];
		var b = bChildren[bIndex];

		var aKey = a._0;
		var bKey = b._0;
		var aNode = a._1;
		var bNode = b._1;

		// check if keys match

		if (aKey === bKey)
		{
			index++;
			diffHelp(aNode, bNode, localPatches, index);
			index += aNode.descendantsCount || 0;

			aIndex++;
			bIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var aLookAhead = aIndex + 1 < aLen;
		var bLookAhead = bIndex + 1 < bLen;

		if (aLookAhead)
		{
			var aNext = aChildren[aIndex + 1];
			var aNextKey = aNext._0;
			var aNextNode = aNext._1;
			var oldMatch = bKey === aNextKey;
		}

		if (bLookAhead)
		{
			var bNext = bChildren[bIndex + 1];
			var bNextKey = bNext._0;
			var bNextNode = bNext._1;
			var newMatch = aKey === bNextKey;
		}


		// swap a and b
		if (aLookAhead && bLookAhead && newMatch && oldMatch)
		{
			index++;
			diffHelp(aNode, bNextNode, localPatches, index);
			insertNode(changes, localPatches, aKey, bNode, bIndex, inserts);
			index += aNode.descendantsCount || 0;

			index++;
			removeNode(changes, localPatches, aKey, aNextNode, index);
			index += aNextNode.descendantsCount || 0;

			aIndex += 2;
			bIndex += 2;
			continue;
		}

		// insert b
		if (bLookAhead && newMatch)
		{
			index++;
			insertNode(changes, localPatches, bKey, bNode, bIndex, inserts);
			diffHelp(aNode, bNextNode, localPatches, index);
			index += aNode.descendantsCount || 0;

			aIndex += 1;
			bIndex += 2;
			continue;
		}

		// remove a
		if (aLookAhead && oldMatch)
		{
			index++;
			removeNode(changes, localPatches, aKey, aNode, index);
			index += aNode.descendantsCount || 0;

			index++;
			diffHelp(aNextNode, bNode, localPatches, index);
			index += aNextNode.descendantsCount || 0;

			aIndex += 2;
			bIndex += 1;
			continue;
		}

		// remove a, insert b
		if (aLookAhead && bLookAhead && aNextKey === bNextKey)
		{
			index++;
			removeNode(changes, localPatches, aKey, aNode, index);
			insertNode(changes, localPatches, bKey, bNode, bIndex, inserts);
			index += aNode.descendantsCount || 0;

			index++;
			diffHelp(aNextNode, bNextNode, localPatches, index);
			index += aNextNode.descendantsCount || 0;

			aIndex += 2;
			bIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (aIndex < aLen)
	{
		index++;
		var a = aChildren[aIndex];
		var aNode = a._1;
		removeNode(changes, localPatches, a._0, aNode, index);
		index += aNode.descendantsCount || 0;
		aIndex++;
	}

	var endInserts;
	while (bIndex < bLen)
	{
		endInserts = endInserts || [];
		var b = bChildren[bIndex];
		insertNode(changes, localPatches, b._0, b._1, undefined, endInserts);
		bIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || typeof endInserts !== 'undefined')
	{
		patches.push(makePatch('p-reorder', rootIndex, {
			patches: localPatches,
			inserts: inserts,
			endInserts: endInserts
		}));
	}
}



////////////  CHANGES FROM KEYED DIFF  ////////////


var POSTFIX = '_elmW6BL';


function insertNode(changes, localPatches, key, vnode, bIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (typeof entry === 'undefined')
	{
		entry = {
			tag: 'insert',
			vnode: vnode,
			index: bIndex,
			data: undefined
		};

		inserts.push({ index: bIndex, entry: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.tag === 'remove')
	{
		inserts.push({ index: bIndex, entry: entry });

		entry.tag = 'move';
		var subPatches = [];
		diffHelp(entry.vnode, vnode, subPatches, entry.index);
		entry.index = bIndex;
		entry.data.data = {
			patches: subPatches,
			entry: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	insertNode(changes, localPatches, key + POSTFIX, vnode, bIndex, inserts);
}


function removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (typeof entry === 'undefined')
	{
		var patch = makePatch('p-remove', index, undefined);
		localPatches.push(patch);

		changes[key] = {
			tag: 'remove',
			vnode: vnode,
			index: index,
			data: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.tag === 'insert')
	{
		entry.tag = 'move';
		var subPatches = [];
		diffHelp(vnode, entry.vnode, subPatches, index);

		var patch = makePatch('p-remove', index, {
			patches: subPatches,
			entry: entry
		});
		localPatches.push(patch);

		return;
	}

	// this key has already been removed or moved, a duplicate!
	removeNode(changes, localPatches, key + POSTFIX, vnode, index);
}



////////////  ADD DOM NODES  ////////////
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function addDomNodes(domNode, vNode, patches, eventNode)
{
	addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.descendantsCount, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.index;

	while (index === low)
	{
		var patchType = patch.type;

		if (patchType === 'p-thunk')
		{
			addDomNodes(domNode, vNode.node, patch.data, eventNode);
		}
		else if (patchType === 'p-reorder')
		{
			patch.domNode = domNode;
			patch.eventNode = eventNode;

			var subPatches = patch.data.patches;
			if (subPatches.length > 0)
			{
				addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 'p-remove')
		{
			patch.domNode = domNode;
			patch.eventNode = eventNode;

			var data = patch.data;
			if (typeof data !== 'undefined')
			{
				data.entry.data = domNode;
				var subPatches = data.patches;
				if (subPatches.length > 0)
				{
					addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.domNode = domNode;
			patch.eventNode = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.index) > high)
		{
			return i;
		}
	}

	switch (vNode.type)
	{
		case 'tagger':
			var subNode = vNode.node;

			while (subNode.type === "tagger")
			{
				subNode = subNode.node;
			}

			return addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);

		case 'node':
			var vChildren = vNode.children;
			var childNodes = domNode.childNodes;
			for (var j = 0; j < vChildren.length; j++)
			{
				low++;
				var vChild = vChildren[j];
				var nextLow = low + (vChild.descendantsCount || 0);
				if (low <= index && index <= nextLow)
				{
					i = addDomNodesHelp(childNodes[j], vChild, patches, i, low, nextLow, eventNode);
					if (!(patch = patches[i]) || (index = patch.index) > high)
					{
						return i;
					}
				}
				low = nextLow;
			}
			return i;

		case 'keyed-node':
			var vChildren = vNode.children;
			var childNodes = domNode.childNodes;
			for (var j = 0; j < vChildren.length; j++)
			{
				low++;
				var vChild = vChildren[j]._1;
				var nextLow = low + (vChild.descendantsCount || 0);
				if (low <= index && index <= nextLow)
				{
					i = addDomNodesHelp(childNodes[j], vChild, patches, i, low, nextLow, eventNode);
					if (!(patch = patches[i]) || (index = patch.index) > high)
					{
						return i;
					}
				}
				low = nextLow;
			}
			return i;

		case 'text':
		case 'thunk':
			throw new Error('should never traverse `text` or `thunk` nodes like this');
	}
}



////////////  APPLY PATCHES  ////////////


function applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return applyPatchesHelp(rootDomNode, patches);
}

function applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.domNode
		var newNode = applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function applyPatch(domNode, patch)
{
	switch (patch.type)
	{
		case 'p-redraw':
			return applyPatchRedraw(domNode, patch.data, patch.eventNode);

		case 'p-facts':
			applyFacts(domNode, patch.eventNode, patch.data);
			return domNode;

		case 'p-text':
			domNode.replaceData(0, domNode.length, patch.data);
			return domNode;

		case 'p-thunk':
			return applyPatchesHelp(domNode, patch.data);

		case 'p-tagger':
			if (typeof domNode.elm_event_node_ref !== 'undefined')
			{
				domNode.elm_event_node_ref.tagger = patch.data;
			}
			else
			{
				domNode.elm_event_node_ref = { tagger: patch.data, parent: patch.eventNode };
			}
			return domNode;

		case 'p-remove-last':
			var i = patch.data;
			while (i--)
			{
				domNode.removeChild(domNode.lastChild);
			}
			return domNode;

		case 'p-append':
			var newNodes = patch.data;
			for (var i = 0; i < newNodes.length; i++)
			{
				domNode.appendChild(render(newNodes[i], patch.eventNode));
			}
			return domNode;

		case 'p-remove':
			var data = patch.data;
			if (typeof data === 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.entry;
			if (typeof entry.index !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.data = applyPatchesHelp(domNode, data.patches);
			return domNode;

		case 'p-reorder':
			return applyPatchReorder(domNode, patch);

		case 'p-custom':
			var impl = patch.data;
			return impl.applyPatch(domNode, impl.data);

		default:
			throw new Error('Ran into an unknown patch!');
	}
}


function applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = render(vNode, eventNode);

	if (typeof newNode.elm_event_node_ref === 'undefined')
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function applyPatchReorder(domNode, patch)
{
	var data = patch.data;

	// remove end inserts
	var frag = applyPatchReorderEndInsertsHelp(data.endInserts, patch);

	// removals
	domNode = applyPatchesHelp(domNode, data.patches);

	// inserts
	var inserts = data.inserts;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.entry;
		var node = entry.tag === 'move'
			? entry.data
			: render(entry.vnode, patch.eventNode);
		domNode.insertBefore(node, domNode.childNodes[insert.index]);
	}

	// add end inserts
	if (typeof frag !== 'undefined')
	{
		domNode.appendChild(frag);
	}

	return domNode;
}


function applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (typeof endInserts === 'undefined')
	{
		return;
	}

	var frag = localDoc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.entry;
		frag.appendChild(entry.tag === 'move'
			? entry.data
			: render(entry.vnode, patch.eventNode)
		);
	}
	return frag;
}


// PROGRAMS

var program = makeProgram(checkNoFlags);
var programWithFlags = makeProgram(checkYesFlags);

function makeProgram(flagChecker)
{
	return F2(function(debugWrap, impl)
	{
		return function(flagDecoder)
		{
			return function(object, moduleName, debugMetadata)
			{
				var checker = flagChecker(flagDecoder, moduleName);
				if (typeof debugMetadata === 'undefined')
				{
					normalSetup(impl, object, moduleName, checker);
				}
				else
				{
					debugSetup(A2(debugWrap, debugMetadata, impl), object, moduleName, checker);
				}
			};
		};
	});
}

function staticProgram(vNode)
{
	var nothing = _elm_lang$core$Native_Utils.Tuple2(
		_elm_lang$core$Native_Utils.Tuple0,
		_elm_lang$core$Platform_Cmd$none
	);
	return A2(program, _elm_lang$virtual_dom$VirtualDom_Debug$wrap, {
		init: nothing,
		view: function() { return vNode; },
		update: F2(function() { return nothing; }),
		subscriptions: function() { return _elm_lang$core$Platform_Sub$none; }
	})();
}


// FLAG CHECKERS

function checkNoFlags(flagDecoder, moduleName)
{
	return function(init, flags, domNode)
	{
		if (typeof flags === 'undefined')
		{
			return init;
		}

		var errorMessage =
			'The `' + moduleName + '` module does not need flags.\n'
			+ 'Initialize it with no arguments and you should be all set!';

		crash(errorMessage, domNode);
	};
}

function checkYesFlags(flagDecoder, moduleName)
{
	return function(init, flags, domNode)
	{
		if (typeof flagDecoder === 'undefined')
		{
			var errorMessage =
				'Are you trying to sneak a Never value into Elm? Trickster!\n'
				+ 'It looks like ' + moduleName + '.main is defined with `programWithFlags` but has type `Program Never`.\n'
				+ 'Use `program` instead if you do not want flags.'

			crash(errorMessage, domNode);
		}

		var result = A2(_elm_lang$core$Native_Json.run, flagDecoder, flags);
		if (result.ctor === 'Ok')
		{
			return init(result._0);
		}

		var errorMessage =
			'Trying to initialize the `' + moduleName + '` module with an unexpected flag.\n'
			+ 'I tried to convert it to an Elm value, but ran into this problem:\n\n'
			+ result._0;

		crash(errorMessage, domNode);
	};
}

function crash(errorMessage, domNode)
{
	if (domNode)
	{
		domNode.innerHTML =
			'<div style="padding-left:1em;">'
			+ '<h2 style="font-weight:normal;"><b>Oops!</b> Something went wrong when starting your Elm program.</h2>'
			+ '<pre style="padding-left:1em;">' + errorMessage + '</pre>'
			+ '</div>';
	}

	throw new Error(errorMessage);
}


//  NORMAL SETUP

function normalSetup(impl, object, moduleName, flagChecker)
{
	object['embed'] = function embed(node, flags)
	{
		while (node.lastChild)
		{
			node.removeChild(node.lastChild);
		}

		return _elm_lang$core$Native_Platform.initialize(
			flagChecker(impl.init, flags, node),
			impl.update,
			impl.subscriptions,
			normalRenderer(node, impl.view)
		);
	};

	object['fullscreen'] = function fullscreen(flags)
	{
		return _elm_lang$core$Native_Platform.initialize(
			flagChecker(impl.init, flags, document.body),
			impl.update,
			impl.subscriptions,
			normalRenderer(document.body, impl.view)
		);
	};
}

function normalRenderer(parentNode, view)
{
	return function(tagger, initialModel)
	{
		var eventNode = { tagger: tagger, parent: undefined };
		var initialVirtualNode = view(initialModel);
		var domNode = render(initialVirtualNode, eventNode);
		parentNode.appendChild(domNode);
		return makeStepper(domNode, view, initialVirtualNode, eventNode);
	};
}


// STEPPER

var rAF =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { setTimeout(callback, 1000 / 60); };

function makeStepper(domNode, view, initialVirtualNode, eventNode)
{
	var state = 'NO_REQUEST';
	var currNode = initialVirtualNode;
	var nextModel;

	function updateIfNeeded()
	{
		switch (state)
		{
			case 'NO_REQUEST':
				throw new Error(
					'Unexpected draw callback.\n' +
					'Please report this to <https://github.com/elm-lang/virtual-dom/issues>.'
				);

			case 'PENDING_REQUEST':
				rAF(updateIfNeeded);
				state = 'EXTRA_REQUEST';

				var nextNode = view(nextModel);
				var patches = diff(currNode, nextNode);
				domNode = applyPatches(domNode, currNode, patches, eventNode);
				currNode = nextNode;

				return;

			case 'EXTRA_REQUEST':
				state = 'NO_REQUEST';
				return;
		}
	}

	return function stepper(model)
	{
		if (state === 'NO_REQUEST')
		{
			rAF(updateIfNeeded);
		}
		state = 'PENDING_REQUEST';
		nextModel = model;
	};
}


// DEBUG SETUP

function debugSetup(impl, object, moduleName, flagChecker)
{
	object['fullscreen'] = function fullscreen(flags)
	{
		var popoutRef = { doc: undefined };
		return _elm_lang$core$Native_Platform.initialize(
			flagChecker(impl.init, flags, document.body),
			impl.update(scrollTask(popoutRef)),
			impl.subscriptions,
			debugRenderer(moduleName, document.body, popoutRef, impl.view, impl.viewIn, impl.viewOut)
		);
	};

	object['embed'] = function fullscreen(node, flags)
	{
		var popoutRef = { doc: undefined };
		return _elm_lang$core$Native_Platform.initialize(
			flagChecker(impl.init, flags, node),
			impl.update(scrollTask(popoutRef)),
			impl.subscriptions,
			debugRenderer(moduleName, node, popoutRef, impl.view, impl.viewIn, impl.viewOut)
		);
	};
}

function scrollTask(popoutRef)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		var doc = popoutRef.doc;
		if (doc)
		{
			var msgs = doc.getElementsByClassName('debugger-sidebar-messages')[0];
			if (msgs)
			{
				msgs.scrollTop = msgs.scrollHeight;
			}
		}
		callback(_elm_lang$core$Native_Scheduler.succeed(_elm_lang$core$Native_Utils.Tuple0));
	});
}


function debugRenderer(moduleName, parentNode, popoutRef, view, viewIn, viewOut)
{
	return function(tagger, initialModel)
	{
		var appEventNode = { tagger: tagger, parent: undefined };
		var eventNode = { tagger: tagger, parent: undefined };

		// make normal stepper
		var appVirtualNode = view(initialModel);
		var appNode = render(appVirtualNode, appEventNode);
		parentNode.appendChild(appNode);
		var appStepper = makeStepper(appNode, view, appVirtualNode, appEventNode);

		// make overlay stepper
		var overVirtualNode = viewIn(initialModel)._1;
		var overNode = render(overVirtualNode, eventNode);
		parentNode.appendChild(overNode);
		var wrappedViewIn = wrapViewIn(appEventNode, overNode, viewIn);
		var overStepper = makeStepper(overNode, wrappedViewIn, overVirtualNode, eventNode);

		// make debugger stepper
		var debugStepper = makeDebugStepper(initialModel, viewOut, eventNode, parentNode, moduleName, popoutRef);

		return function stepper(model)
		{
			appStepper(model);
			overStepper(model);
			debugStepper(model);
		}
	};
}

function makeDebugStepper(initialModel, view, eventNode, parentNode, moduleName, popoutRef)
{
	var curr;
	var domNode;

	return function stepper(model)
	{
		if (!model.isDebuggerOpen)
		{
			return;
		}

		if (!popoutRef.doc)
		{
			curr = view(model);
			domNode = openDebugWindow(moduleName, popoutRef, curr, eventNode);
			return;
		}

		// switch to document of popout
		localDoc = popoutRef.doc;

		var next = view(model);
		var patches = diff(curr, next);
		domNode = applyPatches(domNode, curr, patches, eventNode);
		curr = next;

		// switch back to normal document
		localDoc = document;
	};
}

function openDebugWindow(moduleName, popoutRef, virtualNode, eventNode)
{
	var w = 900;
	var h = 360;
	var x = screen.width - w;
	var y = screen.height - h;
	var debugWindow = window.open('', '', 'width=' + w + ',height=' + h + ',left=' + x + ',top=' + y);

	// switch to window document
	localDoc = debugWindow.document;

	popoutRef.doc = localDoc;
	localDoc.title = 'Debugger - ' + moduleName;
	localDoc.body.style.margin = '0';
	localDoc.body.style.padding = '0';
	var domNode = render(virtualNode, eventNode);
	localDoc.body.appendChild(domNode);

	localDoc.addEventListener('keydown', function(event) {
		if (event.metaKey && event.which === 82)
		{
			window.location.reload();
		}
		if (event.which === 38)
		{
			eventNode.tagger({ ctor: 'Up' });
			event.preventDefault();
		}
		if (event.which === 40)
		{
			eventNode.tagger({ ctor: 'Down' });
			event.preventDefault();
		}
	});

	function close()
	{
		popoutRef.doc = undefined;
		debugWindow.close();
	}
	window.addEventListener('unload', close);
	debugWindow.addEventListener('unload', function() {
		popoutRef.doc = undefined;
		window.removeEventListener('unload', close);
		eventNode.tagger({ ctor: 'Close' });
	});

	// switch back to the normal document
	localDoc = document;

	return domNode;
}


// BLOCK EVENTS

function wrapViewIn(appEventNode, overlayNode, viewIn)
{
	var ignorer = makeIgnorer(overlayNode);
	var blocking = 'Normal';
	var overflow;

	var normalTagger = appEventNode.tagger;
	var blockTagger = function() {};

	return function(model)
	{
		var tuple = viewIn(model);
		var newBlocking = tuple._0.ctor;
		appEventNode.tagger = newBlocking === 'Normal' ? normalTagger : blockTagger;
		if (blocking !== newBlocking)
		{
			traverse('removeEventListener', ignorer, blocking);
			traverse('addEventListener', ignorer, newBlocking);

			if (blocking === 'Normal')
			{
				overflow = document.body.style.overflow;
				document.body.style.overflow = 'hidden';
			}

			if (newBlocking === 'Normal')
			{
				document.body.style.overflow = overflow;
			}

			blocking = newBlocking;
		}
		return tuple._1;
	}
}

function traverse(verbEventListener, ignorer, blocking)
{
	switch(blocking)
	{
		case 'Normal':
			return;

		case 'Pause':
			return traverseHelp(verbEventListener, ignorer, mostEvents);

		case 'Message':
			return traverseHelp(verbEventListener, ignorer, allEvents);
	}
}

function traverseHelp(verbEventListener, handler, eventNames)
{
	for (var i = 0; i < eventNames.length; i++)
	{
		document.body[verbEventListener](eventNames[i], handler, true);
	}
}

function makeIgnorer(overlayNode)
{
	return function(event)
	{
		if (event.type === 'keydown' && event.metaKey && event.which === 82)
		{
			return;
		}

		var isScroll = event.type === 'scroll' || event.type === 'wheel';

		var node = event.target;
		while (node !== null)
		{
			if (node.className === 'elm-overlay-message-details' && isScroll)
			{
				return;
			}

			if (node === overlayNode && !isScroll)
			{
				return;
			}
			node = node.parentNode;
		}

		event.stopPropagation();
		event.preventDefault();
	}
}

var mostEvents = [
	'click', 'dblclick', 'mousemove',
	'mouseup', 'mousedown', 'mouseenter', 'mouseleave',
	'touchstart', 'touchend', 'touchcancel', 'touchmove',
	'pointerdown', 'pointerup', 'pointerover', 'pointerout',
	'pointerenter', 'pointerleave', 'pointermove', 'pointercancel',
	'dragstart', 'drag', 'dragend', 'dragenter', 'dragover', 'dragleave', 'drop',
	'keyup', 'keydown', 'keypress',
	'input', 'change',
	'focus', 'blur'
];

var allEvents = mostEvents.concat('wheel', 'scroll');


return {
	node: node,
	text: text,
	custom: custom,
	map: F2(map),

	on: F3(on),
	style: style,
	property: F2(property),
	attribute: F2(attribute),
	attributeNS: F3(attributeNS),
	mapProperty: F2(mapProperty),

	lazy: F2(lazy),
	lazy2: F3(lazy2),
	lazy3: F4(lazy3),
	keyedNode: F3(keyedNode),

	program: program,
	programWithFlags: programWithFlags,
	staticProgram: staticProgram
};

}();

var _elm_lang$virtual_dom$VirtualDom$programWithFlags = function (impl) {
	return A2(_elm_lang$virtual_dom$Native_VirtualDom.programWithFlags, _elm_lang$virtual_dom$VirtualDom_Debug$wrapWithFlags, impl);
};
var _elm_lang$virtual_dom$VirtualDom$program = function (impl) {
	return A2(_elm_lang$virtual_dom$Native_VirtualDom.program, _elm_lang$virtual_dom$VirtualDom_Debug$wrap, impl);
};
var _elm_lang$virtual_dom$VirtualDom$keyedNode = _elm_lang$virtual_dom$Native_VirtualDom.keyedNode;
var _elm_lang$virtual_dom$VirtualDom$lazy3 = _elm_lang$virtual_dom$Native_VirtualDom.lazy3;
var _elm_lang$virtual_dom$VirtualDom$lazy2 = _elm_lang$virtual_dom$Native_VirtualDom.lazy2;
var _elm_lang$virtual_dom$VirtualDom$lazy = _elm_lang$virtual_dom$Native_VirtualDom.lazy;
var _elm_lang$virtual_dom$VirtualDom$defaultOptions = {stopPropagation: false, preventDefault: false};
var _elm_lang$virtual_dom$VirtualDom$onWithOptions = _elm_lang$virtual_dom$Native_VirtualDom.on;
var _elm_lang$virtual_dom$VirtualDom$on = F2(
	function (eventName, decoder) {
		return A3(_elm_lang$virtual_dom$VirtualDom$onWithOptions, eventName, _elm_lang$virtual_dom$VirtualDom$defaultOptions, decoder);
	});
var _elm_lang$virtual_dom$VirtualDom$style = _elm_lang$virtual_dom$Native_VirtualDom.style;
var _elm_lang$virtual_dom$VirtualDom$mapProperty = _elm_lang$virtual_dom$Native_VirtualDom.mapProperty;
var _elm_lang$virtual_dom$VirtualDom$attributeNS = _elm_lang$virtual_dom$Native_VirtualDom.attributeNS;
var _elm_lang$virtual_dom$VirtualDom$attribute = _elm_lang$virtual_dom$Native_VirtualDom.attribute;
var _elm_lang$virtual_dom$VirtualDom$property = _elm_lang$virtual_dom$Native_VirtualDom.property;
var _elm_lang$virtual_dom$VirtualDom$map = _elm_lang$virtual_dom$Native_VirtualDom.map;
var _elm_lang$virtual_dom$VirtualDom$text = _elm_lang$virtual_dom$Native_VirtualDom.text;
var _elm_lang$virtual_dom$VirtualDom$node = _elm_lang$virtual_dom$Native_VirtualDom.node;
var _elm_lang$virtual_dom$VirtualDom$Options = F2(
	function (a, b) {
		return {stopPropagation: a, preventDefault: b};
	});
var _elm_lang$virtual_dom$VirtualDom$Node = {ctor: 'Node'};
var _elm_lang$virtual_dom$VirtualDom$Property = {ctor: 'Property'};

var _elm_lang$html$Html$programWithFlags = _elm_lang$virtual_dom$VirtualDom$programWithFlags;
var _elm_lang$html$Html$program = _elm_lang$virtual_dom$VirtualDom$program;
var _elm_lang$html$Html$beginnerProgram = function (_p0) {
	var _p1 = _p0;
	return _elm_lang$html$Html$program(
		{
			init: A2(
				_elm_lang$core$Platform_Cmd_ops['!'],
				_p1.model,
				{ctor: '[]'}),
			update: F2(
				function (msg, model) {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						A2(_p1.update, msg, model),
						{ctor: '[]'});
				}),
			view: _p1.view,
			subscriptions: function (_p2) {
				return _elm_lang$core$Platform_Sub$none;
			}
		});
};
var _elm_lang$html$Html$map = _elm_lang$virtual_dom$VirtualDom$map;
var _elm_lang$html$Html$text = _elm_lang$virtual_dom$VirtualDom$text;
var _elm_lang$html$Html$node = _elm_lang$virtual_dom$VirtualDom$node;
var _elm_lang$html$Html$body = _elm_lang$html$Html$node('body');
var _elm_lang$html$Html$section = _elm_lang$html$Html$node('section');
var _elm_lang$html$Html$nav = _elm_lang$html$Html$node('nav');
var _elm_lang$html$Html$article = _elm_lang$html$Html$node('article');
var _elm_lang$html$Html$aside = _elm_lang$html$Html$node('aside');
var _elm_lang$html$Html$h1 = _elm_lang$html$Html$node('h1');
var _elm_lang$html$Html$h2 = _elm_lang$html$Html$node('h2');
var _elm_lang$html$Html$h3 = _elm_lang$html$Html$node('h3');
var _elm_lang$html$Html$h4 = _elm_lang$html$Html$node('h4');
var _elm_lang$html$Html$h5 = _elm_lang$html$Html$node('h5');
var _elm_lang$html$Html$h6 = _elm_lang$html$Html$node('h6');
var _elm_lang$html$Html$header = _elm_lang$html$Html$node('header');
var _elm_lang$html$Html$footer = _elm_lang$html$Html$node('footer');
var _elm_lang$html$Html$address = _elm_lang$html$Html$node('address');
var _elm_lang$html$Html$main_ = _elm_lang$html$Html$node('main');
var _elm_lang$html$Html$p = _elm_lang$html$Html$node('p');
var _elm_lang$html$Html$hr = _elm_lang$html$Html$node('hr');
var _elm_lang$html$Html$pre = _elm_lang$html$Html$node('pre');
var _elm_lang$html$Html$blockquote = _elm_lang$html$Html$node('blockquote');
var _elm_lang$html$Html$ol = _elm_lang$html$Html$node('ol');
var _elm_lang$html$Html$ul = _elm_lang$html$Html$node('ul');
var _elm_lang$html$Html$li = _elm_lang$html$Html$node('li');
var _elm_lang$html$Html$dl = _elm_lang$html$Html$node('dl');
var _elm_lang$html$Html$dt = _elm_lang$html$Html$node('dt');
var _elm_lang$html$Html$dd = _elm_lang$html$Html$node('dd');
var _elm_lang$html$Html$figure = _elm_lang$html$Html$node('figure');
var _elm_lang$html$Html$figcaption = _elm_lang$html$Html$node('figcaption');
var _elm_lang$html$Html$div = _elm_lang$html$Html$node('div');
var _elm_lang$html$Html$a = _elm_lang$html$Html$node('a');
var _elm_lang$html$Html$em = _elm_lang$html$Html$node('em');
var _elm_lang$html$Html$strong = _elm_lang$html$Html$node('strong');
var _elm_lang$html$Html$small = _elm_lang$html$Html$node('small');
var _elm_lang$html$Html$s = _elm_lang$html$Html$node('s');
var _elm_lang$html$Html$cite = _elm_lang$html$Html$node('cite');
var _elm_lang$html$Html$q = _elm_lang$html$Html$node('q');
var _elm_lang$html$Html$dfn = _elm_lang$html$Html$node('dfn');
var _elm_lang$html$Html$abbr = _elm_lang$html$Html$node('abbr');
var _elm_lang$html$Html$time = _elm_lang$html$Html$node('time');
var _elm_lang$html$Html$code = _elm_lang$html$Html$node('code');
var _elm_lang$html$Html$var = _elm_lang$html$Html$node('var');
var _elm_lang$html$Html$samp = _elm_lang$html$Html$node('samp');
var _elm_lang$html$Html$kbd = _elm_lang$html$Html$node('kbd');
var _elm_lang$html$Html$sub = _elm_lang$html$Html$node('sub');
var _elm_lang$html$Html$sup = _elm_lang$html$Html$node('sup');
var _elm_lang$html$Html$i = _elm_lang$html$Html$node('i');
var _elm_lang$html$Html$b = _elm_lang$html$Html$node('b');
var _elm_lang$html$Html$u = _elm_lang$html$Html$node('u');
var _elm_lang$html$Html$mark = _elm_lang$html$Html$node('mark');
var _elm_lang$html$Html$ruby = _elm_lang$html$Html$node('ruby');
var _elm_lang$html$Html$rt = _elm_lang$html$Html$node('rt');
var _elm_lang$html$Html$rp = _elm_lang$html$Html$node('rp');
var _elm_lang$html$Html$bdi = _elm_lang$html$Html$node('bdi');
var _elm_lang$html$Html$bdo = _elm_lang$html$Html$node('bdo');
var _elm_lang$html$Html$span = _elm_lang$html$Html$node('span');
var _elm_lang$html$Html$br = _elm_lang$html$Html$node('br');
var _elm_lang$html$Html$wbr = _elm_lang$html$Html$node('wbr');
var _elm_lang$html$Html$ins = _elm_lang$html$Html$node('ins');
var _elm_lang$html$Html$del = _elm_lang$html$Html$node('del');
var _elm_lang$html$Html$img = _elm_lang$html$Html$node('img');
var _elm_lang$html$Html$iframe = _elm_lang$html$Html$node('iframe');
var _elm_lang$html$Html$embed = _elm_lang$html$Html$node('embed');
var _elm_lang$html$Html$object = _elm_lang$html$Html$node('object');
var _elm_lang$html$Html$param = _elm_lang$html$Html$node('param');
var _elm_lang$html$Html$video = _elm_lang$html$Html$node('video');
var _elm_lang$html$Html$audio = _elm_lang$html$Html$node('audio');
var _elm_lang$html$Html$source = _elm_lang$html$Html$node('source');
var _elm_lang$html$Html$track = _elm_lang$html$Html$node('track');
var _elm_lang$html$Html$canvas = _elm_lang$html$Html$node('canvas');
var _elm_lang$html$Html$math = _elm_lang$html$Html$node('math');
var _elm_lang$html$Html$table = _elm_lang$html$Html$node('table');
var _elm_lang$html$Html$caption = _elm_lang$html$Html$node('caption');
var _elm_lang$html$Html$colgroup = _elm_lang$html$Html$node('colgroup');
var _elm_lang$html$Html$col = _elm_lang$html$Html$node('col');
var _elm_lang$html$Html$tbody = _elm_lang$html$Html$node('tbody');
var _elm_lang$html$Html$thead = _elm_lang$html$Html$node('thead');
var _elm_lang$html$Html$tfoot = _elm_lang$html$Html$node('tfoot');
var _elm_lang$html$Html$tr = _elm_lang$html$Html$node('tr');
var _elm_lang$html$Html$td = _elm_lang$html$Html$node('td');
var _elm_lang$html$Html$th = _elm_lang$html$Html$node('th');
var _elm_lang$html$Html$form = _elm_lang$html$Html$node('form');
var _elm_lang$html$Html$fieldset = _elm_lang$html$Html$node('fieldset');
var _elm_lang$html$Html$legend = _elm_lang$html$Html$node('legend');
var _elm_lang$html$Html$label = _elm_lang$html$Html$node('label');
var _elm_lang$html$Html$input = _elm_lang$html$Html$node('input');
var _elm_lang$html$Html$button = _elm_lang$html$Html$node('button');
var _elm_lang$html$Html$select = _elm_lang$html$Html$node('select');
var _elm_lang$html$Html$datalist = _elm_lang$html$Html$node('datalist');
var _elm_lang$html$Html$optgroup = _elm_lang$html$Html$node('optgroup');
var _elm_lang$html$Html$option = _elm_lang$html$Html$node('option');
var _elm_lang$html$Html$textarea = _elm_lang$html$Html$node('textarea');
var _elm_lang$html$Html$keygen = _elm_lang$html$Html$node('keygen');
var _elm_lang$html$Html$output = _elm_lang$html$Html$node('output');
var _elm_lang$html$Html$progress = _elm_lang$html$Html$node('progress');
var _elm_lang$html$Html$meter = _elm_lang$html$Html$node('meter');
var _elm_lang$html$Html$details = _elm_lang$html$Html$node('details');
var _elm_lang$html$Html$summary = _elm_lang$html$Html$node('summary');
var _elm_lang$html$Html$menuitem = _elm_lang$html$Html$node('menuitem');
var _elm_lang$html$Html$menu = _elm_lang$html$Html$node('menu');

var _elm_lang$html$Html_Attributes$map = _elm_lang$virtual_dom$VirtualDom$mapProperty;
var _elm_lang$html$Html_Attributes$attribute = _elm_lang$virtual_dom$VirtualDom$attribute;
var _elm_lang$html$Html_Attributes$contextmenu = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'contextmenu', value);
};
var _elm_lang$html$Html_Attributes$draggable = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'draggable', value);
};
var _elm_lang$html$Html_Attributes$itemprop = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'itemprop', value);
};
var _elm_lang$html$Html_Attributes$tabindex = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'tabIndex',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$charset = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'charset', value);
};
var _elm_lang$html$Html_Attributes$height = function (value) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'height',
		_elm_lang$core$Basics$toString(value));
};
var _elm_lang$html$Html_Attributes$width = function (value) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'width',
		_elm_lang$core$Basics$toString(value));
};
var _elm_lang$html$Html_Attributes$formaction = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'formAction', value);
};
var _elm_lang$html$Html_Attributes$list = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'list', value);
};
var _elm_lang$html$Html_Attributes$minlength = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'minLength',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$maxlength = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'maxlength',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$size = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'size',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$form = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'form', value);
};
var _elm_lang$html$Html_Attributes$cols = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'cols',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$rows = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'rows',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$challenge = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'challenge', value);
};
var _elm_lang$html$Html_Attributes$media = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'media', value);
};
var _elm_lang$html$Html_Attributes$rel = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'rel', value);
};
var _elm_lang$html$Html_Attributes$datetime = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'datetime', value);
};
var _elm_lang$html$Html_Attributes$pubdate = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'pubdate', value);
};
var _elm_lang$html$Html_Attributes$colspan = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'colspan',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$rowspan = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'rowspan',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$manifest = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'manifest', value);
};
var _elm_lang$html$Html_Attributes$property = _elm_lang$virtual_dom$VirtualDom$property;
var _elm_lang$html$Html_Attributes$stringProperty = F2(
	function (name, string) {
		return A2(
			_elm_lang$html$Html_Attributes$property,
			name,
			_elm_lang$core$Json_Encode$string(string));
	});
var _elm_lang$html$Html_Attributes$class = function (name) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'className', name);
};
var _elm_lang$html$Html_Attributes$id = function (name) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'id', name);
};
var _elm_lang$html$Html_Attributes$title = function (name) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'title', name);
};
var _elm_lang$html$Html_Attributes$accesskey = function ($char) {
	return A2(
		_elm_lang$html$Html_Attributes$stringProperty,
		'accessKey',
		_elm_lang$core$String$fromChar($char));
};
var _elm_lang$html$Html_Attributes$dir = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'dir', value);
};
var _elm_lang$html$Html_Attributes$dropzone = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'dropzone', value);
};
var _elm_lang$html$Html_Attributes$lang = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'lang', value);
};
var _elm_lang$html$Html_Attributes$content = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'content', value);
};
var _elm_lang$html$Html_Attributes$httpEquiv = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'httpEquiv', value);
};
var _elm_lang$html$Html_Attributes$language = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'language', value);
};
var _elm_lang$html$Html_Attributes$src = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'src', value);
};
var _elm_lang$html$Html_Attributes$alt = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'alt', value);
};
var _elm_lang$html$Html_Attributes$preload = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'preload', value);
};
var _elm_lang$html$Html_Attributes$poster = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'poster', value);
};
var _elm_lang$html$Html_Attributes$kind = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'kind', value);
};
var _elm_lang$html$Html_Attributes$srclang = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'srclang', value);
};
var _elm_lang$html$Html_Attributes$sandbox = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'sandbox', value);
};
var _elm_lang$html$Html_Attributes$srcdoc = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'srcdoc', value);
};
var _elm_lang$html$Html_Attributes$type_ = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'type', value);
};
var _elm_lang$html$Html_Attributes$value = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'value', value);
};
var _elm_lang$html$Html_Attributes$defaultValue = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'defaultValue', value);
};
var _elm_lang$html$Html_Attributes$placeholder = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'placeholder', value);
};
var _elm_lang$html$Html_Attributes$accept = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'accept', value);
};
var _elm_lang$html$Html_Attributes$acceptCharset = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'acceptCharset', value);
};
var _elm_lang$html$Html_Attributes$action = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'action', value);
};
var _elm_lang$html$Html_Attributes$autocomplete = function (bool) {
	return A2(
		_elm_lang$html$Html_Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var _elm_lang$html$Html_Attributes$enctype = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'enctype', value);
};
var _elm_lang$html$Html_Attributes$method = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'method', value);
};
var _elm_lang$html$Html_Attributes$name = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'name', value);
};
var _elm_lang$html$Html_Attributes$pattern = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'pattern', value);
};
var _elm_lang$html$Html_Attributes$for = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'htmlFor', value);
};
var _elm_lang$html$Html_Attributes$max = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'max', value);
};
var _elm_lang$html$Html_Attributes$min = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'min', value);
};
var _elm_lang$html$Html_Attributes$step = function (n) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'step', n);
};
var _elm_lang$html$Html_Attributes$wrap = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'wrap', value);
};
var _elm_lang$html$Html_Attributes$usemap = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'useMap', value);
};
var _elm_lang$html$Html_Attributes$shape = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'shape', value);
};
var _elm_lang$html$Html_Attributes$coords = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'coords', value);
};
var _elm_lang$html$Html_Attributes$keytype = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'keytype', value);
};
var _elm_lang$html$Html_Attributes$align = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'align', value);
};
var _elm_lang$html$Html_Attributes$cite = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'cite', value);
};
var _elm_lang$html$Html_Attributes$href = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'href', value);
};
var _elm_lang$html$Html_Attributes$target = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'target', value);
};
var _elm_lang$html$Html_Attributes$downloadAs = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'download', value);
};
var _elm_lang$html$Html_Attributes$hreflang = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'hreflang', value);
};
var _elm_lang$html$Html_Attributes$ping = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'ping', value);
};
var _elm_lang$html$Html_Attributes$start = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$stringProperty,
		'start',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$headers = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'headers', value);
};
var _elm_lang$html$Html_Attributes$scope = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'scope', value);
};
var _elm_lang$html$Html_Attributes$boolProperty = F2(
	function (name, bool) {
		return A2(
			_elm_lang$html$Html_Attributes$property,
			name,
			_elm_lang$core$Json_Encode$bool(bool));
	});
var _elm_lang$html$Html_Attributes$hidden = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'hidden', bool);
};
var _elm_lang$html$Html_Attributes$contenteditable = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'contentEditable', bool);
};
var _elm_lang$html$Html_Attributes$spellcheck = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'spellcheck', bool);
};
var _elm_lang$html$Html_Attributes$async = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'async', bool);
};
var _elm_lang$html$Html_Attributes$defer = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'defer', bool);
};
var _elm_lang$html$Html_Attributes$scoped = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'scoped', bool);
};
var _elm_lang$html$Html_Attributes$autoplay = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'autoplay', bool);
};
var _elm_lang$html$Html_Attributes$controls = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'controls', bool);
};
var _elm_lang$html$Html_Attributes$loop = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'loop', bool);
};
var _elm_lang$html$Html_Attributes$default = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'default', bool);
};
var _elm_lang$html$Html_Attributes$seamless = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'seamless', bool);
};
var _elm_lang$html$Html_Attributes$checked = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'checked', bool);
};
var _elm_lang$html$Html_Attributes$selected = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'selected', bool);
};
var _elm_lang$html$Html_Attributes$autofocus = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'autofocus', bool);
};
var _elm_lang$html$Html_Attributes$disabled = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'disabled', bool);
};
var _elm_lang$html$Html_Attributes$multiple = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'multiple', bool);
};
var _elm_lang$html$Html_Attributes$novalidate = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'noValidate', bool);
};
var _elm_lang$html$Html_Attributes$readonly = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'readOnly', bool);
};
var _elm_lang$html$Html_Attributes$required = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'required', bool);
};
var _elm_lang$html$Html_Attributes$ismap = function (value) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'isMap', value);
};
var _elm_lang$html$Html_Attributes$download = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'download', bool);
};
var _elm_lang$html$Html_Attributes$reversed = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'reversed', bool);
};
var _elm_lang$html$Html_Attributes$classList = function (list) {
	return _elm_lang$html$Html_Attributes$class(
		A2(
			_elm_lang$core$String$join,
			' ',
			A2(
				_elm_lang$core$List$map,
				_elm_lang$core$Tuple$first,
				A2(_elm_lang$core$List$filter, _elm_lang$core$Tuple$second, list))));
};
var _elm_lang$html$Html_Attributes$style = _elm_lang$virtual_dom$VirtualDom$style;

var _elm_lang$html$Html_Events$keyCode = A2(_elm_lang$core$Json_Decode$field, 'keyCode', _elm_lang$core$Json_Decode$int);
var _elm_lang$html$Html_Events$targetChecked = A2(
	_elm_lang$core$Json_Decode$at,
	{
		ctor: '::',
		_0: 'target',
		_1: {
			ctor: '::',
			_0: 'checked',
			_1: {ctor: '[]'}
		}
	},
	_elm_lang$core$Json_Decode$bool);
var _elm_lang$html$Html_Events$targetValue = A2(
	_elm_lang$core$Json_Decode$at,
	{
		ctor: '::',
		_0: 'target',
		_1: {
			ctor: '::',
			_0: 'value',
			_1: {ctor: '[]'}
		}
	},
	_elm_lang$core$Json_Decode$string);
var _elm_lang$html$Html_Events$defaultOptions = _elm_lang$virtual_dom$VirtualDom$defaultOptions;
var _elm_lang$html$Html_Events$onWithOptions = _elm_lang$virtual_dom$VirtualDom$onWithOptions;
var _elm_lang$html$Html_Events$on = _elm_lang$virtual_dom$VirtualDom$on;
var _elm_lang$html$Html_Events$onFocus = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'focus',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onBlur = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'blur',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onSubmitOptions = _elm_lang$core$Native_Utils.update(
	_elm_lang$html$Html_Events$defaultOptions,
	{preventDefault: true});
var _elm_lang$html$Html_Events$onSubmit = function (msg) {
	return A3(
		_elm_lang$html$Html_Events$onWithOptions,
		'submit',
		_elm_lang$html$Html_Events$onSubmitOptions,
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onCheck = function (tagger) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'change',
		A2(_elm_lang$core$Json_Decode$map, tagger, _elm_lang$html$Html_Events$targetChecked));
};
var _elm_lang$html$Html_Events$onInput = function (tagger) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'input',
		A2(_elm_lang$core$Json_Decode$map, tagger, _elm_lang$html$Html_Events$targetValue));
};
var _elm_lang$html$Html_Events$onMouseOut = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'mouseout',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onMouseOver = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'mouseover',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onMouseLeave = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'mouseleave',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onMouseEnter = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'mouseenter',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onMouseUp = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'mouseup',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onMouseDown = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'mousedown',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onDoubleClick = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'dblclick',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onClick = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'click',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$Options = F2(
	function (a, b) {
		return {stopPropagation: a, preventDefault: b};
	});

var _elm_community$html_extra$Html_Events_Extra$onEnter = function (onEnterAction) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'keyup',
		A2(
			_elm_lang$core$Json_Decode$andThen,
			function (keyCode) {
				return _elm_lang$core$Native_Utils.eq(keyCode, 13) ? _elm_lang$core$Json_Decode$succeed(onEnterAction) : _elm_lang$core$Json_Decode$fail(
					_elm_lang$core$Basics$toString(keyCode));
			},
			_elm_lang$html$Html_Events$keyCode));
};
var _elm_community$html_extra$Html_Events_Extra$onClickPreventDefaultAndStopPropagation = function (msg) {
	return A3(
		_elm_lang$html$Html_Events$onWithOptions,
		'click',
		_elm_lang$core$Native_Utils.update(
			_elm_lang$html$Html_Events$defaultOptions,
			{stopPropagation: true, preventDefault: true}),
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_community$html_extra$Html_Events_Extra$onClickStopPropagation = function (msg) {
	return A3(
		_elm_lang$html$Html_Events$onWithOptions,
		'click',
		_elm_lang$core$Native_Utils.update(
			_elm_lang$html$Html_Events$defaultOptions,
			{stopPropagation: true}),
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_community$html_extra$Html_Events_Extra$onClickPreventDefault = function (msg) {
	return A3(
		_elm_lang$html$Html_Events$onWithOptions,
		'click',
		_elm_lang$core$Native_Utils.update(
			_elm_lang$html$Html_Events$defaultOptions,
			{preventDefault: true}),
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_community$html_extra$Html_Events_Extra$targetSelectedIndex = A2(
	_elm_lang$core$Json_Decode$at,
	{
		ctor: '::',
		_0: 'target',
		_1: {
			ctor: '::',
			_0: 'selectedIndex',
			_1: {ctor: '[]'}
		}
	},
	A2(
		_elm_lang$core$Json_Decode$map,
		function ($int) {
			return _elm_lang$core$Native_Utils.eq($int, -1) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just($int);
		},
		_elm_lang$core$Json_Decode$int));
var _elm_community$html_extra$Html_Events_Extra$targetValueInt = A2(
	_elm_lang$core$Json_Decode$at,
	{
		ctor: '::',
		_0: 'target',
		_1: {
			ctor: '::',
			_0: 'valueAsNumber',
			_1: {ctor: '[]'}
		}
	},
	_elm_lang$core$Json_Decode$int);
var _elm_community$html_extra$Html_Events_Extra$customDecoder = F2(
	function (d, f) {
		var resultDecoder = function (x) {
			var _p0 = x;
			if (_p0.ctor === 'Ok') {
				return _elm_lang$core$Json_Decode$succeed(_p0._0);
			} else {
				return _elm_lang$core$Json_Decode$fail(_p0._0);
			}
		};
		return A2(
			_elm_lang$core$Json_Decode$andThen,
			resultDecoder,
			A2(_elm_lang$core$Json_Decode$map, f, d));
	});
var _elm_community$html_extra$Html_Events_Extra$targetValueFloat = A2(
	_elm_community$html_extra$Html_Events_Extra$customDecoder,
	A2(
		_elm_lang$core$Json_Decode$at,
		{
			ctor: '::',
			_0: 'target',
			_1: {
				ctor: '::',
				_0: 'valueAsNumber',
				_1: {ctor: '[]'}
			}
		},
		_elm_lang$core$Json_Decode$float),
	function (v) {
		return _elm_lang$core$Basics$isNaN(v) ? _elm_lang$core$Result$Err('Not a number') : _elm_lang$core$Result$Ok(v);
	});
var _elm_community$html_extra$Html_Events_Extra$targetValueMaybe = A2(
	_elm_community$html_extra$Html_Events_Extra$customDecoder,
	_elm_lang$html$Html_Events$targetValue,
	function (s) {
		return _elm_lang$core$Result$Ok(
			_elm_lang$core$Native_Utils.eq(s, '') ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(s));
	});
var _elm_community$html_extra$Html_Events_Extra$targetValueMaybeFloat = A2(
	_elm_lang$core$Json_Decode$andThen,
	function (mval) {
		var _p1 = mval;
		if (_p1.ctor === 'Nothing') {
			return _elm_lang$core$Json_Decode$succeed(_elm_lang$core$Maybe$Nothing);
		} else {
			return A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_community$html_extra$Html_Events_Extra$targetValueFloat);
		}
	},
	_elm_community$html_extra$Html_Events_Extra$targetValueMaybe);
var _elm_community$html_extra$Html_Events_Extra$targetValueMaybeInt = function () {
	var traverse = F2(
		function (f, mx) {
			var _p2 = mx;
			if (_p2.ctor === 'Nothing') {
				return _elm_lang$core$Result$Ok(_elm_lang$core$Maybe$Nothing);
			} else {
				return A2(
					_elm_lang$core$Result$map,
					_elm_lang$core$Maybe$Just,
					f(_p2._0));
			}
		});
	return A2(
		_elm_community$html_extra$Html_Events_Extra$customDecoder,
		_elm_community$html_extra$Html_Events_Extra$targetValueMaybe,
		traverse(_elm_lang$core$String$toInt));
}();
var _elm_community$html_extra$Html_Events_Extra$targetValueFloatParse = A2(_elm_community$html_extra$Html_Events_Extra$customDecoder, _elm_lang$html$Html_Events$targetValue, _elm_lang$core$String$toFloat);
var _elm_community$html_extra$Html_Events_Extra$targetValueIntParse = A2(_elm_community$html_extra$Html_Events_Extra$customDecoder, _elm_lang$html$Html_Events$targetValue, _elm_lang$core$String$toInt);
var _elm_community$html_extra$Html_Events_Extra$targetValueMaybeFloatParse = function () {
	var traverse = F2(
		function (f, mx) {
			var _p3 = mx;
			if (_p3.ctor === 'Nothing') {
				return _elm_lang$core$Result$Ok(_elm_lang$core$Maybe$Nothing);
			} else {
				return A2(
					_elm_lang$core$Result$map,
					_elm_lang$core$Maybe$Just,
					f(_p3._0));
			}
		});
	return A2(
		_elm_community$html_extra$Html_Events_Extra$customDecoder,
		_elm_community$html_extra$Html_Events_Extra$targetValueMaybe,
		traverse(_elm_lang$core$String$toFloat));
}();
var _elm_community$html_extra$Html_Events_Extra$targetValueMaybeIntParse = function () {
	var traverse = F2(
		function (f, mx) {
			var _p4 = mx;
			if (_p4.ctor === 'Nothing') {
				return _elm_lang$core$Result$Ok(_elm_lang$core$Maybe$Nothing);
			} else {
				return A2(
					_elm_lang$core$Result$map,
					_elm_lang$core$Maybe$Just,
					f(_p4._0));
			}
		});
	return A2(
		_elm_community$html_extra$Html_Events_Extra$customDecoder,
		_elm_community$html_extra$Html_Events_Extra$targetValueMaybe,
		traverse(_elm_lang$core$String$toInt));
}();
var _elm_community$html_extra$Html_Events_Extra$charCode = A2(
	_elm_lang$core$Json_Decode$map,
	function (_p5) {
		return A2(
			_elm_lang$core$Maybe$map,
			_elm_lang$core$Tuple$first,
			_elm_lang$core$String$uncons(_p5));
	},
	A2(_elm_lang$core$Json_Decode$field, 'charCode', _elm_lang$core$Json_Decode$string));

//import Result //

var _elm_lang$core$Native_Date = function() {

function fromString(str)
{
	var date = new Date(str);
	return isNaN(date.getTime())
		? _elm_lang$core$Result$Err('Unable to parse \'' + str + '\' as a date. Dates must be in the ISO 8601 format.')
		: _elm_lang$core$Result$Ok(date);
}

var dayTable = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var monthTable =
	['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
	 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];


return {
	fromString: fromString,
	year: function(d) { return d.getFullYear(); },
	month: function(d) { return { ctor: monthTable[d.getMonth()] }; },
	day: function(d) { return d.getDate(); },
	hour: function(d) { return d.getHours(); },
	minute: function(d) { return d.getMinutes(); },
	second: function(d) { return d.getSeconds(); },
	millisecond: function(d) { return d.getMilliseconds(); },
	toTime: function(d) { return d.getTime(); },
	fromTime: function(t) { return new Date(t); },
	dayOfWeek: function(d) { return { ctor: dayTable[d.getDay()] }; }
};

}();
var _elm_lang$core$Date$millisecond = _elm_lang$core$Native_Date.millisecond;
var _elm_lang$core$Date$second = _elm_lang$core$Native_Date.second;
var _elm_lang$core$Date$minute = _elm_lang$core$Native_Date.minute;
var _elm_lang$core$Date$hour = _elm_lang$core$Native_Date.hour;
var _elm_lang$core$Date$dayOfWeek = _elm_lang$core$Native_Date.dayOfWeek;
var _elm_lang$core$Date$day = _elm_lang$core$Native_Date.day;
var _elm_lang$core$Date$month = _elm_lang$core$Native_Date.month;
var _elm_lang$core$Date$year = _elm_lang$core$Native_Date.year;
var _elm_lang$core$Date$fromTime = _elm_lang$core$Native_Date.fromTime;
var _elm_lang$core$Date$toTime = _elm_lang$core$Native_Date.toTime;
var _elm_lang$core$Date$fromString = _elm_lang$core$Native_Date.fromString;
var _elm_lang$core$Date$now = A2(_elm_lang$core$Task$map, _elm_lang$core$Date$fromTime, _elm_lang$core$Time$now);
var _elm_lang$core$Date$Date = {ctor: 'Date'};
var _elm_lang$core$Date$Sun = {ctor: 'Sun'};
var _elm_lang$core$Date$Sat = {ctor: 'Sat'};
var _elm_lang$core$Date$Fri = {ctor: 'Fri'};
var _elm_lang$core$Date$Thu = {ctor: 'Thu'};
var _elm_lang$core$Date$Wed = {ctor: 'Wed'};
var _elm_lang$core$Date$Tue = {ctor: 'Tue'};
var _elm_lang$core$Date$Mon = {ctor: 'Mon'};
var _elm_lang$core$Date$Dec = {ctor: 'Dec'};
var _elm_lang$core$Date$Nov = {ctor: 'Nov'};
var _elm_lang$core$Date$Oct = {ctor: 'Oct'};
var _elm_lang$core$Date$Sep = {ctor: 'Sep'};
var _elm_lang$core$Date$Aug = {ctor: 'Aug'};
var _elm_lang$core$Date$Jul = {ctor: 'Jul'};
var _elm_lang$core$Date$Jun = {ctor: 'Jun'};
var _elm_lang$core$Date$May = {ctor: 'May'};
var _elm_lang$core$Date$Apr = {ctor: 'Apr'};
var _elm_lang$core$Date$Mar = {ctor: 'Mar'};
var _elm_lang$core$Date$Feb = {ctor: 'Feb'};
var _elm_lang$core$Date$Jan = {ctor: 'Jan'};

var _elm_lang$core$Set$foldr = F3(
	function (f, b, _p0) {
		var _p1 = _p0;
		return A3(
			_elm_lang$core$Dict$foldr,
			F3(
				function (k, _p2, b) {
					return A2(f, k, b);
				}),
			b,
			_p1._0);
	});
var _elm_lang$core$Set$foldl = F3(
	function (f, b, _p3) {
		var _p4 = _p3;
		return A3(
			_elm_lang$core$Dict$foldl,
			F3(
				function (k, _p5, b) {
					return A2(f, k, b);
				}),
			b,
			_p4._0);
	});
var _elm_lang$core$Set$toList = function (_p6) {
	var _p7 = _p6;
	return _elm_lang$core$Dict$keys(_p7._0);
};
var _elm_lang$core$Set$size = function (_p8) {
	var _p9 = _p8;
	return _elm_lang$core$Dict$size(_p9._0);
};
var _elm_lang$core$Set$member = F2(
	function (k, _p10) {
		var _p11 = _p10;
		return A2(_elm_lang$core$Dict$member, k, _p11._0);
	});
var _elm_lang$core$Set$isEmpty = function (_p12) {
	var _p13 = _p12;
	return _elm_lang$core$Dict$isEmpty(_p13._0);
};
var _elm_lang$core$Set$Set_elm_builtin = function (a) {
	return {ctor: 'Set_elm_builtin', _0: a};
};
var _elm_lang$core$Set$empty = _elm_lang$core$Set$Set_elm_builtin(_elm_lang$core$Dict$empty);
var _elm_lang$core$Set$singleton = function (k) {
	return _elm_lang$core$Set$Set_elm_builtin(
		A2(
			_elm_lang$core$Dict$singleton,
			k,
			{ctor: '_Tuple0'}));
};
var _elm_lang$core$Set$insert = F2(
	function (k, _p14) {
		var _p15 = _p14;
		return _elm_lang$core$Set$Set_elm_builtin(
			A3(
				_elm_lang$core$Dict$insert,
				k,
				{ctor: '_Tuple0'},
				_p15._0));
	});
var _elm_lang$core$Set$fromList = function (xs) {
	return A3(_elm_lang$core$List$foldl, _elm_lang$core$Set$insert, _elm_lang$core$Set$empty, xs);
};
var _elm_lang$core$Set$map = F2(
	function (f, s) {
		return _elm_lang$core$Set$fromList(
			A2(
				_elm_lang$core$List$map,
				f,
				_elm_lang$core$Set$toList(s)));
	});
var _elm_lang$core$Set$remove = F2(
	function (k, _p16) {
		var _p17 = _p16;
		return _elm_lang$core$Set$Set_elm_builtin(
			A2(_elm_lang$core$Dict$remove, k, _p17._0));
	});
var _elm_lang$core$Set$union = F2(
	function (_p19, _p18) {
		var _p20 = _p19;
		var _p21 = _p18;
		return _elm_lang$core$Set$Set_elm_builtin(
			A2(_elm_lang$core$Dict$union, _p20._0, _p21._0));
	});
var _elm_lang$core$Set$intersect = F2(
	function (_p23, _p22) {
		var _p24 = _p23;
		var _p25 = _p22;
		return _elm_lang$core$Set$Set_elm_builtin(
			A2(_elm_lang$core$Dict$intersect, _p24._0, _p25._0));
	});
var _elm_lang$core$Set$diff = F2(
	function (_p27, _p26) {
		var _p28 = _p27;
		var _p29 = _p26;
		return _elm_lang$core$Set$Set_elm_builtin(
			A2(_elm_lang$core$Dict$diff, _p28._0, _p29._0));
	});
var _elm_lang$core$Set$filter = F2(
	function (p, _p30) {
		var _p31 = _p30;
		return _elm_lang$core$Set$Set_elm_builtin(
			A2(
				_elm_lang$core$Dict$filter,
				F2(
					function (k, _p32) {
						return p(k);
					}),
				_p31._0));
	});
var _elm_lang$core$Set$partition = F2(
	function (p, _p33) {
		var _p34 = _p33;
		var _p35 = A2(
			_elm_lang$core$Dict$partition,
			F2(
				function (k, _p36) {
					return p(k);
				}),
			_p34._0);
		var p1 = _p35._0;
		var p2 = _p35._1;
		return {
			ctor: '_Tuple2',
			_0: _elm_lang$core$Set$Set_elm_builtin(p1),
			_1: _elm_lang$core$Set$Set_elm_builtin(p2)
		};
	});

var _elm_community$json_extra$Json_Decode_Extra$when = F3(
	function (checkDecoder, check, passDecoder) {
		return A2(
			_elm_lang$core$Json_Decode$andThen,
			function (checkVal) {
				return check(checkVal) ? passDecoder : _elm_lang$core$Json_Decode$fail(
					A2(
						_elm_lang$core$Basics_ops['++'],
						'Check failed with input `',
						A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(checkVal),
							'`')));
			},
			checkDecoder);
	});
var _elm_community$json_extra$Json_Decode_Extra$combine = A2(
	_elm_lang$core$List$foldr,
	_elm_lang$core$Json_Decode$map2(
		F2(
			function (x, y) {
				return {ctor: '::', _0: x, _1: y};
			})),
	_elm_lang$core$Json_Decode$succeed(
		{ctor: '[]'}));
var _elm_community$json_extra$Json_Decode_Extra$collection = function (decoder) {
	return A2(
		_elm_lang$core$Json_Decode$andThen,
		function (length) {
			return _elm_community$json_extra$Json_Decode_Extra$combine(
				A2(
					_elm_lang$core$List$map,
					function (index) {
						return A2(
							_elm_lang$core$Json_Decode$field,
							_elm_lang$core$Basics$toString(index),
							decoder);
					},
					A2(_elm_lang$core$List$range, 0, length - 1)));
		},
		A2(_elm_lang$core$Json_Decode$field, 'length', _elm_lang$core$Json_Decode$int));
};
var _elm_community$json_extra$Json_Decode_Extra$fromResult = function (result) {
	var _p0 = result;
	if (_p0.ctor === 'Ok') {
		return _elm_lang$core$Json_Decode$succeed(_p0._0);
	} else {
		return _elm_lang$core$Json_Decode$fail(_p0._0);
	}
};
var _elm_community$json_extra$Json_Decode_Extra$parseInt = A2(
	_elm_lang$core$Json_Decode$andThen,
	function (_p1) {
		return _elm_community$json_extra$Json_Decode_Extra$fromResult(
			_elm_lang$core$String$toInt(_p1));
	},
	_elm_lang$core$Json_Decode$string);
var _elm_community$json_extra$Json_Decode_Extra$parseFloat = A2(
	_elm_lang$core$Json_Decode$andThen,
	function (_p2) {
		return _elm_community$json_extra$Json_Decode_Extra$fromResult(
			_elm_lang$core$String$toFloat(_p2));
	},
	_elm_lang$core$Json_Decode$string);
var _elm_community$json_extra$Json_Decode_Extra$doubleEncoded = function (decoder) {
	return A2(
		_elm_lang$core$Json_Decode$andThen,
		function (_p3) {
			return _elm_community$json_extra$Json_Decode_Extra$fromResult(
				A2(_elm_lang$core$Json_Decode$decodeString, decoder, _p3));
		},
		_elm_lang$core$Json_Decode$string);
};
var _elm_community$json_extra$Json_Decode_Extra$keys = A2(
	_elm_lang$core$Json_Decode$map,
	A2(
		_elm_lang$core$List$foldl,
		F2(
			function (_p4, acc) {
				var _p5 = _p4;
				return {ctor: '::', _0: _p5._0, _1: acc};
			}),
		{ctor: '[]'}),
	_elm_lang$core$Json_Decode$keyValuePairs(
		_elm_lang$core$Json_Decode$succeed(
			{ctor: '_Tuple0'})));
var _elm_community$json_extra$Json_Decode_Extra$sequenceHelp = F2(
	function (decoders, jsonValues) {
		return (!_elm_lang$core$Native_Utils.eq(
			_elm_lang$core$List$length(jsonValues),
			_elm_lang$core$List$length(decoders))) ? _elm_lang$core$Json_Decode$fail('Number of decoders does not match number of values') : _elm_community$json_extra$Json_Decode_Extra$fromResult(
			A3(
				_elm_lang$core$List$foldr,
				_elm_lang$core$Result$map2(
					F2(
						function (x, y) {
							return {ctor: '::', _0: x, _1: y};
						})),
				_elm_lang$core$Result$Ok(
					{ctor: '[]'}),
				A3(_elm_lang$core$List$map2, _elm_lang$core$Json_Decode$decodeValue, decoders, jsonValues)));
	});
var _elm_community$json_extra$Json_Decode_Extra$sequence = function (decoders) {
	return A2(
		_elm_lang$core$Json_Decode$andThen,
		_elm_community$json_extra$Json_Decode_Extra$sequenceHelp(decoders),
		_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$value));
};
var _elm_community$json_extra$Json_Decode_Extra$indexedList = function (indexedDecoder) {
	return A2(
		_elm_lang$core$Json_Decode$andThen,
		function (values) {
			return _elm_community$json_extra$Json_Decode_Extra$sequence(
				A2(
					_elm_lang$core$List$map,
					indexedDecoder,
					A2(
						_elm_lang$core$List$range,
						0,
						_elm_lang$core$List$length(values) - 1)));
		},
		_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$value));
};
var _elm_community$json_extra$Json_Decode_Extra$optionalField = F2(
	function (fieldName, decoder) {
		var finishDecoding = function (json) {
			var _p6 = A2(
				_elm_lang$core$Json_Decode$decodeValue,
				A2(_elm_lang$core$Json_Decode$field, fieldName, _elm_lang$core$Json_Decode$value),
				json);
			if (_p6.ctor === 'Ok') {
				return A2(
					_elm_lang$core$Json_Decode$map,
					_elm_lang$core$Maybe$Just,
					A2(_elm_lang$core$Json_Decode$field, fieldName, decoder));
			} else {
				return _elm_lang$core$Json_Decode$succeed(_elm_lang$core$Maybe$Nothing);
			}
		};
		return A2(_elm_lang$core$Json_Decode$andThen, finishDecoding, _elm_lang$core$Json_Decode$value);
	});
var _elm_community$json_extra$Json_Decode_Extra$withDefault = F2(
	function (fallback, decoder) {
		return A2(
			_elm_lang$core$Json_Decode$map,
			_elm_lang$core$Maybe$withDefault(fallback),
			_elm_lang$core$Json_Decode$maybe(decoder));
	});
var _elm_community$json_extra$Json_Decode_Extra$decodeDictFromTuples = F2(
	function (keyDecoder, tuples) {
		var _p7 = tuples;
		if (_p7.ctor === '[]') {
			return _elm_lang$core$Json_Decode$succeed(_elm_lang$core$Dict$empty);
		} else {
			var _p8 = A2(_elm_lang$core$Json_Decode$decodeString, keyDecoder, _p7._0._0);
			if (_p8.ctor === 'Ok') {
				return A2(
					_elm_lang$core$Json_Decode$andThen,
					function (_p9) {
						return _elm_lang$core$Json_Decode$succeed(
							A3(_elm_lang$core$Dict$insert, _p8._0, _p7._0._1, _p9));
					},
					A2(_elm_community$json_extra$Json_Decode_Extra$decodeDictFromTuples, keyDecoder, _p7._1));
			} else {
				return _elm_lang$core$Json_Decode$fail(_p8._0);
			}
		}
	});
var _elm_community$json_extra$Json_Decode_Extra$dict2 = F2(
	function (keyDecoder, valueDecoder) {
		return A2(
			_elm_lang$core$Json_Decode$andThen,
			_elm_community$json_extra$Json_Decode_Extra$decodeDictFromTuples(keyDecoder),
			_elm_lang$core$Json_Decode$keyValuePairs(valueDecoder));
	});
var _elm_community$json_extra$Json_Decode_Extra$set = function (decoder) {
	return A2(
		_elm_lang$core$Json_Decode$map,
		_elm_lang$core$Set$fromList,
		_elm_lang$core$Json_Decode$list(decoder));
};
var _elm_community$json_extra$Json_Decode_Extra$date = A2(
	_elm_lang$core$Json_Decode$andThen,
	function (_p10) {
		return _elm_community$json_extra$Json_Decode_Extra$fromResult(
			_elm_lang$core$Date$fromString(_p10));
	},
	_elm_lang$core$Json_Decode$string);
var _elm_community$json_extra$Json_Decode_Extra$andMap = _elm_lang$core$Json_Decode$map2(
	F2(
		function (x, y) {
			return y(x);
		}));
var _elm_community$json_extra$Json_Decode_Extra_ops = _elm_community$json_extra$Json_Decode_Extra_ops || {};
_elm_community$json_extra$Json_Decode_Extra_ops['|:'] = _elm_lang$core$Basics$flip(_elm_community$json_extra$Json_Decode_Extra$andMap);

var _elm_community$list_extra$List_Extra$greedyGroupsOfWithStep = F3(
	function (size, step, xs) {
		var okayXs = _elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$List$length(xs),
			0) > 0;
		var okayArgs = (_elm_lang$core$Native_Utils.cmp(size, 0) > 0) && (_elm_lang$core$Native_Utils.cmp(step, 0) > 0);
		var xs_ = A2(_elm_lang$core$List$drop, step, xs);
		var group = A2(_elm_lang$core$List$take, size, xs);
		return (okayArgs && okayXs) ? {
			ctor: '::',
			_0: group,
			_1: A3(_elm_community$list_extra$List_Extra$greedyGroupsOfWithStep, size, step, xs_)
		} : {ctor: '[]'};
	});
var _elm_community$list_extra$List_Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3(_elm_community$list_extra$List_Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var _elm_community$list_extra$List_Extra$groupsOfWithStep = F3(
	function (size, step, xs) {
		var okayArgs = (_elm_lang$core$Native_Utils.cmp(size, 0) > 0) && (_elm_lang$core$Native_Utils.cmp(step, 0) > 0);
		var xs_ = A2(_elm_lang$core$List$drop, step, xs);
		var group = A2(_elm_lang$core$List$take, size, xs);
		var okayLength = _elm_lang$core$Native_Utils.eq(
			size,
			_elm_lang$core$List$length(group));
		return (okayArgs && okayLength) ? {
			ctor: '::',
			_0: group,
			_1: A3(_elm_community$list_extra$List_Extra$groupsOfWithStep, size, step, xs_)
		} : {ctor: '[]'};
	});
var _elm_community$list_extra$List_Extra$groupsOf = F2(
	function (size, xs) {
		return A3(_elm_community$list_extra$List_Extra$groupsOfWithStep, size, size, xs);
	});
var _elm_community$list_extra$List_Extra$zip5 = _elm_lang$core$List$map5(
	F5(
		function (v0, v1, v2, v3, v4) {
			return {ctor: '_Tuple5', _0: v0, _1: v1, _2: v2, _3: v3, _4: v4};
		}));
var _elm_community$list_extra$List_Extra$zip4 = _elm_lang$core$List$map4(
	F4(
		function (v0, v1, v2, v3) {
			return {ctor: '_Tuple4', _0: v0, _1: v1, _2: v2, _3: v3};
		}));
var _elm_community$list_extra$List_Extra$zip3 = _elm_lang$core$List$map3(
	F3(
		function (v0, v1, v2) {
			return {ctor: '_Tuple3', _0: v0, _1: v1, _2: v2};
		}));
var _elm_community$list_extra$List_Extra$zip = _elm_lang$core$List$map2(
	F2(
		function (v0, v1) {
			return {ctor: '_Tuple2', _0: v0, _1: v1};
		}));
var _elm_community$list_extra$List_Extra$isSubsequenceOf = F2(
	function (subseq, list) {
		isSubsequenceOf:
		while (true) {
			var _p0 = {ctor: '_Tuple2', _0: subseq, _1: list};
			if (_p0._0.ctor === '[]') {
				return true;
			} else {
				if (_p0._1.ctor === '[]') {
					return false;
				} else {
					var _p1 = _p0._1._1;
					if (_elm_lang$core$Native_Utils.eq(_p0._0._0, _p0._1._0)) {
						var _v1 = _p0._0._1,
							_v2 = _p1;
						subseq = _v1;
						list = _v2;
						continue isSubsequenceOf;
					} else {
						var _v3 = subseq,
							_v4 = _p1;
						subseq = _v3;
						list = _v4;
						continue isSubsequenceOf;
					}
				}
			}
		}
	});
var _elm_community$list_extra$List_Extra$isPrefixOf = F2(
	function (prefix, xs) {
		var _p2 = {ctor: '_Tuple2', _0: prefix, _1: xs};
		if (_p2._0.ctor === '[]') {
			return true;
		} else {
			if (_p2._1.ctor === '[]') {
				return false;
			} else {
				return _elm_lang$core$Native_Utils.eq(_p2._0._0, _p2._1._0) && A2(_elm_community$list_extra$List_Extra$isPrefixOf, _p2._0._1, _p2._1._1);
			}
		}
	});
var _elm_community$list_extra$List_Extra$isSuffixOf = F2(
	function (suffix, xs) {
		return A2(
			_elm_community$list_extra$List_Extra$isPrefixOf,
			_elm_lang$core$List$reverse(suffix),
			_elm_lang$core$List$reverse(xs));
	});
var _elm_community$list_extra$List_Extra$isInfixOfHelp = F3(
	function (infixHead, infixTail, list) {
		isInfixOfHelp:
		while (true) {
			var _p3 = list;
			if (_p3.ctor === '[]') {
				return false;
			} else {
				var _p4 = _p3._1;
				if (_elm_lang$core$Native_Utils.eq(_p3._0, infixHead)) {
					return A2(_elm_community$list_extra$List_Extra$isPrefixOf, infixTail, _p4);
				} else {
					var _v7 = infixHead,
						_v8 = infixTail,
						_v9 = _p4;
					infixHead = _v7;
					infixTail = _v8;
					list = _v9;
					continue isInfixOfHelp;
				}
			}
		}
	});
var _elm_community$list_extra$List_Extra$isInfixOf = F2(
	function (infixList, list) {
		var _p5 = infixList;
		if (_p5.ctor === '[]') {
			return true;
		} else {
			return A3(_elm_community$list_extra$List_Extra$isInfixOfHelp, _p5._0, _p5._1, list);
		}
	});
var _elm_community$list_extra$List_Extra$selectSplit = function (xs) {
	var _p6 = xs;
	if (_p6.ctor === '[]') {
		return {ctor: '[]'};
	} else {
		var _p10 = _p6._1;
		var _p9 = _p6._0;
		return {
			ctor: '::',
			_0: {
				ctor: '_Tuple3',
				_0: {ctor: '[]'},
				_1: _p9,
				_2: _p10
			},
			_1: A2(
				_elm_lang$core$List$map,
				function (_p7) {
					var _p8 = _p7;
					return {
						ctor: '_Tuple3',
						_0: {ctor: '::', _0: _p9, _1: _p8._0},
						_1: _p8._1,
						_2: _p8._2
					};
				},
				_elm_community$list_extra$List_Extra$selectSplit(_p10))
		};
	}
};
var _elm_community$list_extra$List_Extra$select = function (xs) {
	var _p11 = xs;
	if (_p11.ctor === '[]') {
		return {ctor: '[]'};
	} else {
		var _p15 = _p11._1;
		var _p14 = _p11._0;
		return {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: _p14, _1: _p15},
			_1: A2(
				_elm_lang$core$List$map,
				function (_p12) {
					var _p13 = _p12;
					return {
						ctor: '_Tuple2',
						_0: _p13._0,
						_1: {ctor: '::', _0: _p14, _1: _p13._1}
					};
				},
				_elm_community$list_extra$List_Extra$select(_p15))
		};
	}
};
var _elm_community$list_extra$List_Extra$tailsHelp = F2(
	function (e, list) {
		var _p16 = list;
		if (_p16.ctor === '::') {
			var _p17 = _p16._0;
			return {
				ctor: '::',
				_0: {ctor: '::', _0: e, _1: _p17},
				_1: {ctor: '::', _0: _p17, _1: _p16._1}
			};
		} else {
			return {ctor: '[]'};
		}
	});
var _elm_community$list_extra$List_Extra$tails = A2(
	_elm_lang$core$List$foldr,
	_elm_community$list_extra$List_Extra$tailsHelp,
	{
		ctor: '::',
		_0: {ctor: '[]'},
		_1: {ctor: '[]'}
	});
var _elm_community$list_extra$List_Extra$inits = A2(
	_elm_lang$core$List$foldr,
	F2(
		function (e, acc) {
			return {
				ctor: '::',
				_0: {ctor: '[]'},
				_1: A2(
					_elm_lang$core$List$map,
					F2(
						function (x, y) {
							return {ctor: '::', _0: x, _1: y};
						})(e),
					acc)
			};
		}),
	{
		ctor: '::',
		_0: {ctor: '[]'},
		_1: {ctor: '[]'}
	});
var _elm_community$list_extra$List_Extra$groupWhileTransitivelyHelp = F4(
	function (result, currentGroup, compare, list) {
		groupWhileTransitivelyHelp:
		while (true) {
			var _p18 = list;
			if (_p18.ctor === '[]') {
				return _elm_lang$core$List$reverse(
					_elm_lang$core$List$isEmpty(currentGroup) ? result : _elm_lang$core$List$reverse(
						{ctor: '::', _0: currentGroup, _1: result}));
			} else {
				if (_p18._1.ctor === '[]') {
					return _elm_lang$core$List$reverse(
						{
							ctor: '::',
							_0: _elm_lang$core$List$reverse(
								{ctor: '::', _0: _p18._0, _1: currentGroup}),
							_1: result
						});
				} else {
					var _p20 = _p18._1;
					var _p19 = _p18._0;
					if (A2(compare, _p19, _p18._1._0)) {
						var _v17 = result,
							_v18 = {ctor: '::', _0: _p19, _1: currentGroup},
							_v19 = compare,
							_v20 = _p20;
						result = _v17;
						currentGroup = _v18;
						compare = _v19;
						list = _v20;
						continue groupWhileTransitivelyHelp;
					} else {
						var _v21 = {
							ctor: '::',
							_0: _elm_lang$core$List$reverse(
								{ctor: '::', _0: _p19, _1: currentGroup}),
							_1: result
						},
							_v22 = {ctor: '[]'},
							_v23 = compare,
							_v24 = _p20;
						result = _v21;
						currentGroup = _v22;
						compare = _v23;
						list = _v24;
						continue groupWhileTransitivelyHelp;
					}
				}
			}
		}
	});
var _elm_community$list_extra$List_Extra$groupWhileTransitively = F2(
	function (compare, list) {
		return A4(
			_elm_community$list_extra$List_Extra$groupWhileTransitivelyHelp,
			{ctor: '[]'},
			{ctor: '[]'},
			compare,
			list);
	});
var _elm_community$list_extra$List_Extra$stripPrefix = F2(
	function (prefix, xs) {
		var step = F2(
			function (e, m) {
				var _p21 = m;
				if (_p21.ctor === 'Nothing') {
					return _elm_lang$core$Maybe$Nothing;
				} else {
					if (_p21._0.ctor === '[]') {
						return _elm_lang$core$Maybe$Nothing;
					} else {
						return _elm_lang$core$Native_Utils.eq(e, _p21._0._0) ? _elm_lang$core$Maybe$Just(_p21._0._1) : _elm_lang$core$Maybe$Nothing;
					}
				}
			});
		return A3(
			_elm_lang$core$List$foldl,
			step,
			_elm_lang$core$Maybe$Just(xs),
			prefix);
	});
var _elm_community$list_extra$List_Extra$dropWhileRight = function (p) {
	return A2(
		_elm_lang$core$List$foldr,
		F2(
			function (x, xs) {
				return (p(x) && _elm_lang$core$List$isEmpty(xs)) ? {ctor: '[]'} : {ctor: '::', _0: x, _1: xs};
			}),
		{ctor: '[]'});
};
var _elm_community$list_extra$List_Extra$takeWhileRight = function (p) {
	var step = F2(
		function (x, _p22) {
			var _p23 = _p22;
			var _p24 = _p23._0;
			return (p(x) && _p23._1) ? {
				ctor: '_Tuple2',
				_0: {ctor: '::', _0: x, _1: _p24},
				_1: true
			} : {ctor: '_Tuple2', _0: _p24, _1: false};
		});
	return function (_p25) {
		return _elm_lang$core$Tuple$first(
			A3(
				_elm_lang$core$List$foldr,
				step,
				{
					ctor: '_Tuple2',
					_0: {ctor: '[]'},
					_1: true
				},
				_p25));
	};
};
var _elm_community$list_extra$List_Extra$splitAt = F2(
	function (n, xs) {
		return {
			ctor: '_Tuple2',
			_0: A2(_elm_lang$core$List$take, n, xs),
			_1: A2(_elm_lang$core$List$drop, n, xs)
		};
	});
var _elm_community$list_extra$List_Extra$groupsOfVarying_ = F3(
	function (listOflengths, list, accu) {
		groupsOfVarying_:
		while (true) {
			var _p26 = {ctor: '_Tuple2', _0: listOflengths, _1: list};
			if (((_p26.ctor === '_Tuple2') && (_p26._0.ctor === '::')) && (_p26._1.ctor === '::')) {
				var _p27 = A2(_elm_community$list_extra$List_Extra$splitAt, _p26._0._0, list);
				var head = _p27._0;
				var tail = _p27._1;
				var _v28 = _p26._0._1,
					_v29 = tail,
					_v30 = {ctor: '::', _0: head, _1: accu};
				listOflengths = _v28;
				list = _v29;
				accu = _v30;
				continue groupsOfVarying_;
			} else {
				return _elm_lang$core$List$reverse(accu);
			}
		}
	});
var _elm_community$list_extra$List_Extra$groupsOfVarying = F2(
	function (listOflengths, list) {
		return A3(
			_elm_community$list_extra$List_Extra$groupsOfVarying_,
			listOflengths,
			list,
			{ctor: '[]'});
	});
var _elm_community$list_extra$List_Extra$unfoldr = F2(
	function (f, seed) {
		var _p28 = f(seed);
		if (_p28.ctor === 'Nothing') {
			return {ctor: '[]'};
		} else {
			return {
				ctor: '::',
				_0: _p28._0._0,
				_1: A2(_elm_community$list_extra$List_Extra$unfoldr, f, _p28._0._1)
			};
		}
	});
var _elm_community$list_extra$List_Extra$mapAccumr = F3(
	function (f, acc0, list) {
		return A3(
			_elm_lang$core$List$foldr,
			F2(
				function (x, _p29) {
					var _p30 = _p29;
					var _p31 = A2(f, _p30._0, x);
					var acc2 = _p31._0;
					var y = _p31._1;
					return {
						ctor: '_Tuple2',
						_0: acc2,
						_1: {ctor: '::', _0: y, _1: _p30._1}
					};
				}),
			{
				ctor: '_Tuple2',
				_0: acc0,
				_1: {ctor: '[]'}
			},
			list);
	});
var _elm_community$list_extra$List_Extra$mapAccuml = F3(
	function (f, acc0, list) {
		var _p32 = A3(
			_elm_lang$core$List$foldl,
			F2(
				function (x, _p33) {
					var _p34 = _p33;
					var _p35 = A2(f, _p34._0, x);
					var acc2 = _p35._0;
					var y = _p35._1;
					return {
						ctor: '_Tuple2',
						_0: acc2,
						_1: {ctor: '::', _0: y, _1: _p34._1}
					};
				}),
			{
				ctor: '_Tuple2',
				_0: acc0,
				_1: {ctor: '[]'}
			},
			list);
		var accFinal = _p32._0;
		var generatedList = _p32._1;
		return {
			ctor: '_Tuple2',
			_0: accFinal,
			_1: _elm_lang$core$List$reverse(generatedList)
		};
	});
var _elm_community$list_extra$List_Extra$scanr1 = F2(
	function (f, xs_) {
		var _p36 = xs_;
		if (_p36.ctor === '[]') {
			return {ctor: '[]'};
		} else {
			if (_p36._1.ctor === '[]') {
				return {
					ctor: '::',
					_0: _p36._0,
					_1: {ctor: '[]'}
				};
			} else {
				var _p37 = A2(_elm_community$list_extra$List_Extra$scanr1, f, _p36._1);
				if (_p37.ctor === '::') {
					return {
						ctor: '::',
						_0: A2(f, _p36._0, _p37._0),
						_1: _p37
					};
				} else {
					return {ctor: '[]'};
				}
			}
		}
	});
var _elm_community$list_extra$List_Extra$scanr = F3(
	function (f, acc, xs_) {
		var _p38 = xs_;
		if (_p38.ctor === '[]') {
			return {
				ctor: '::',
				_0: acc,
				_1: {ctor: '[]'}
			};
		} else {
			var _p39 = A3(_elm_community$list_extra$List_Extra$scanr, f, acc, _p38._1);
			if (_p39.ctor === '::') {
				return {
					ctor: '::',
					_0: A2(f, _p38._0, _p39._0),
					_1: _p39
				};
			} else {
				return {ctor: '[]'};
			}
		}
	});
var _elm_community$list_extra$List_Extra$scanl1 = F2(
	function (f, xs_) {
		var _p40 = xs_;
		if (_p40.ctor === '[]') {
			return {ctor: '[]'};
		} else {
			return A3(_elm_lang$core$List$scanl, f, _p40._0, _p40._1);
		}
	});
var _elm_community$list_extra$List_Extra$indexedFoldr = F3(
	function (func, acc, list) {
		var step = F2(
			function (x, _p41) {
				var _p42 = _p41;
				var _p43 = _p42._0;
				return {
					ctor: '_Tuple2',
					_0: _p43 - 1,
					_1: A3(func, _p43, x, _p42._1)
				};
			});
		return _elm_lang$core$Tuple$second(
			A3(
				_elm_lang$core$List$foldr,
				step,
				{
					ctor: '_Tuple2',
					_0: _elm_lang$core$List$length(list) - 1,
					_1: acc
				},
				list));
	});
var _elm_community$list_extra$List_Extra$indexedFoldl = F3(
	function (func, acc, list) {
		var step = F2(
			function (x, _p44) {
				var _p45 = _p44;
				var _p46 = _p45._0;
				return {
					ctor: '_Tuple2',
					_0: _p46 + 1,
					_1: A3(func, _p46, x, _p45._1)
				};
			});
		return _elm_lang$core$Tuple$second(
			A3(
				_elm_lang$core$List$foldl,
				step,
				{ctor: '_Tuple2', _0: 0, _1: acc},
				list));
	});
var _elm_community$list_extra$List_Extra$foldr1 = F2(
	function (f, xs) {
		var mf = F2(
			function (x, m) {
				return _elm_lang$core$Maybe$Just(
					function () {
						var _p47 = m;
						if (_p47.ctor === 'Nothing') {
							return x;
						} else {
							return A2(f, x, _p47._0);
						}
					}());
			});
		return A3(_elm_lang$core$List$foldr, mf, _elm_lang$core$Maybe$Nothing, xs);
	});
var _elm_community$list_extra$List_Extra$foldl1 = F2(
	function (f, xs) {
		var mf = F2(
			function (x, m) {
				return _elm_lang$core$Maybe$Just(
					function () {
						var _p48 = m;
						if (_p48.ctor === 'Nothing') {
							return x;
						} else {
							return A2(f, _p48._0, x);
						}
					}());
			});
		return A3(_elm_lang$core$List$foldl, mf, _elm_lang$core$Maybe$Nothing, xs);
	});
var _elm_community$list_extra$List_Extra$reverseAppend = F2(
	function (list1, list2) {
		return A3(
			_elm_lang$core$List$foldl,
			F2(
				function (x, y) {
					return {ctor: '::', _0: x, _1: y};
				}),
			list2,
			list1);
	});
var _elm_community$list_extra$List_Extra$interweaveHelp = F3(
	function (acc, list1, list2) {
		interweaveHelp:
		while (true) {
			var _p49 = {ctor: '_Tuple2', _0: list1, _1: list2};
			if (_p49._0.ctor === '::') {
				if (_p49._1.ctor === '::') {
					var _v44 = {
						ctor: '::',
						_0: _p49._1._0,
						_1: {ctor: '::', _0: _p49._0._0, _1: acc}
					},
						_v45 = _p49._0._1,
						_v46 = _p49._1._1;
					acc = _v44;
					list1 = _v45;
					list2 = _v46;
					continue interweaveHelp;
				} else {
					return A2(_elm_community$list_extra$List_Extra$reverseAppend, acc, list1);
				}
			} else {
				return A2(_elm_community$list_extra$List_Extra$reverseAppend, acc, list2);
			}
		}
	});
var _elm_community$list_extra$List_Extra$interweave = _elm_community$list_extra$List_Extra$interweaveHelp(
	{ctor: '[]'});
var _elm_community$list_extra$List_Extra$permutations = function (xs_) {
	var _p50 = xs_;
	if (_p50.ctor === '[]') {
		return {
			ctor: '::',
			_0: {ctor: '[]'},
			_1: {ctor: '[]'}
		};
	} else {
		var f = function (_p51) {
			var _p52 = _p51;
			return A2(
				_elm_lang$core$List$map,
				F2(
					function (x, y) {
						return {ctor: '::', _0: x, _1: y};
					})(_p52._0),
				_elm_community$list_extra$List_Extra$permutations(_p52._1));
		};
		return A2(
			_elm_lang$core$List$concatMap,
			f,
			_elm_community$list_extra$List_Extra$select(_p50));
	}
};
var _elm_community$list_extra$List_Extra$isPermutationOf = F2(
	function (permut, xs) {
		return A2(
			_elm_lang$core$List$member,
			permut,
			_elm_community$list_extra$List_Extra$permutations(xs));
	});
var _elm_community$list_extra$List_Extra$subsequencesNonEmpty = function (xs) {
	var _p53 = xs;
	if (_p53.ctor === '[]') {
		return {ctor: '[]'};
	} else {
		var _p54 = _p53._0;
		var f = F2(
			function (ys, r) {
				return {
					ctor: '::',
					_0: ys,
					_1: {
						ctor: '::',
						_0: {ctor: '::', _0: _p54, _1: ys},
						_1: r
					}
				};
			});
		return {
			ctor: '::',
			_0: {
				ctor: '::',
				_0: _p54,
				_1: {ctor: '[]'}
			},
			_1: A3(
				_elm_lang$core$List$foldr,
				f,
				{ctor: '[]'},
				_elm_community$list_extra$List_Extra$subsequencesNonEmpty(_p53._1))
		};
	}
};
var _elm_community$list_extra$List_Extra$subsequences = function (xs) {
	return {
		ctor: '::',
		_0: {ctor: '[]'},
		_1: _elm_community$list_extra$List_Extra$subsequencesNonEmpty(xs)
	};
};
var _elm_community$list_extra$List_Extra$rowsLength = function (listOfLists) {
	var _p55 = listOfLists;
	if (_p55.ctor === '[]') {
		return 0;
	} else {
		return _elm_lang$core$List$length(_p55._0);
	}
};
var _elm_community$list_extra$List_Extra$transpose = function (listOfLists) {
	return A3(
		_elm_lang$core$List$foldr,
		_elm_lang$core$List$map2(
			F2(
				function (x, y) {
					return {ctor: '::', _0: x, _1: y};
				})),
		A2(
			_elm_lang$core$List$repeat,
			_elm_community$list_extra$List_Extra$rowsLength(listOfLists),
			{ctor: '[]'}),
		listOfLists);
};
var _elm_community$list_extra$List_Extra$intercalate = function (xs) {
	return function (_p56) {
		return _elm_lang$core$List$concat(
			A2(_elm_lang$core$List$intersperse, xs, _p56));
	};
};
var _elm_community$list_extra$List_Extra$filterNot = F2(
	function (pred, list) {
		return A2(
			_elm_lang$core$List$filter,
			function (_p57) {
				return !pred(_p57);
			},
			list);
	});
var _elm_community$list_extra$List_Extra$removeIfIndex = function (predicate) {
	return A2(
		_elm_community$list_extra$List_Extra$indexedFoldr,
		F3(
			function (index, item, acc) {
				return predicate(index) ? acc : {ctor: '::', _0: item, _1: acc};
			}),
		{ctor: '[]'});
};
var _elm_community$list_extra$List_Extra$removeAt = F2(
	function (index, l) {
		if (_elm_lang$core$Native_Utils.cmp(index, 0) < 0) {
			return l;
		} else {
			var tail = _elm_lang$core$List$tail(
				A2(_elm_lang$core$List$drop, index, l));
			var head = A2(_elm_lang$core$List$take, index, l);
			var _p58 = tail;
			if (_p58.ctor === 'Nothing') {
				return l;
			} else {
				return A2(_elm_lang$core$List$append, head, _p58._0);
			}
		}
	});
var _elm_community$list_extra$List_Extra$stableSortWith = F2(
	function (pred, list) {
		var predWithIndex = F2(
			function (_p60, _p59) {
				var _p61 = _p60;
				var _p62 = _p59;
				var result = A2(pred, _p61._0, _p62._0);
				var _p63 = result;
				if (_p63.ctor === 'EQ') {
					return A2(_elm_lang$core$Basics$compare, _p61._1, _p62._1);
				} else {
					return result;
				}
			});
		var listWithIndex = A2(
			_elm_lang$core$List$indexedMap,
			F2(
				function (i, a) {
					return {ctor: '_Tuple2', _0: a, _1: i};
				}),
			list);
		return A2(
			_elm_lang$core$List$map,
			_elm_lang$core$Tuple$first,
			A2(_elm_lang$core$List$sortWith, predWithIndex, listWithIndex));
	});
var _elm_community$list_extra$List_Extra$remove = F2(
	function (x, xs) {
		var _p64 = xs;
		if (_p64.ctor === '[]') {
			return {ctor: '[]'};
		} else {
			var _p66 = _p64._1;
			var _p65 = _p64._0;
			return _elm_lang$core$Native_Utils.eq(x, _p65) ? _p66 : {
				ctor: '::',
				_0: _p65,
				_1: A2(_elm_community$list_extra$List_Extra$remove, x, _p66)
			};
		}
	});
var _elm_community$list_extra$List_Extra$updateIfIndex = F3(
	function (predicate, update, list) {
		return A2(
			_elm_lang$core$List$indexedMap,
			F2(
				function (i, x) {
					return predicate(i) ? update(x) : x;
				}),
			list);
	});
var _elm_community$list_extra$List_Extra$updateAt = F3(
	function (index, fn, list) {
		if (_elm_lang$core$Native_Utils.cmp(index, 0) < 0) {
			return list;
		} else {
			var tail = A2(_elm_lang$core$List$drop, index, list);
			var head = A2(_elm_lang$core$List$take, index, list);
			var _p67 = tail;
			if (_p67.ctor === '::') {
				return A2(
					_elm_lang$core$Basics_ops['++'],
					head,
					{
						ctor: '::',
						_0: fn(_p67._0),
						_1: _p67._1
					});
			} else {
				return list;
			}
		}
	});
var _elm_community$list_extra$List_Extra$setAt = F2(
	function (index, value) {
		return A2(
			_elm_community$list_extra$List_Extra$updateAt,
			index,
			_elm_lang$core$Basics$always(value));
	});
var _elm_community$list_extra$List_Extra$updateIf = F3(
	function (predicate, update, list) {
		return A2(
			_elm_lang$core$List$map,
			function (item) {
				return predicate(item) ? update(item) : item;
			},
			list);
	});
var _elm_community$list_extra$List_Extra$replaceIf = F3(
	function (predicate, replacement, list) {
		return A3(
			_elm_community$list_extra$List_Extra$updateIf,
			predicate,
			_elm_lang$core$Basics$always(replacement),
			list);
	});
var _elm_community$list_extra$List_Extra$count = function (predicate) {
	return A2(
		_elm_lang$core$List$foldl,
		F2(
			function (x, acc) {
				return predicate(x) ? (acc + 1) : acc;
			}),
		0);
};
var _elm_community$list_extra$List_Extra$findIndices = function (predicate) {
	var consIndexIf = F3(
		function (index, x, acc) {
			return predicate(x) ? {ctor: '::', _0: index, _1: acc} : acc;
		});
	return A2(
		_elm_community$list_extra$List_Extra$indexedFoldr,
		consIndexIf,
		{ctor: '[]'});
};
var _elm_community$list_extra$List_Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			var _p68 = list;
			if (_p68.ctor === '[]') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				if (predicate(_p68._0)) {
					return _elm_lang$core$Maybe$Just(index);
				} else {
					var _v58 = index + 1,
						_v59 = predicate,
						_v60 = _p68._1;
					index = _v58;
					predicate = _v59;
					list = _v60;
					continue findIndexHelp;
				}
			}
		}
	});
var _elm_community$list_extra$List_Extra$findIndex = _elm_community$list_extra$List_Extra$findIndexHelp(0);
var _elm_community$list_extra$List_Extra$splitWhen = F2(
	function (predicate, list) {
		return A2(
			_elm_lang$core$Maybe$map,
			function (i) {
				return A2(_elm_community$list_extra$List_Extra$splitAt, i, list);
			},
			A2(_elm_community$list_extra$List_Extra$findIndex, predicate, list));
	});
var _elm_community$list_extra$List_Extra$elemIndices = function (x) {
	return _elm_community$list_extra$List_Extra$findIndices(
		F2(
			function (x, y) {
				return _elm_lang$core$Native_Utils.eq(x, y);
			})(x));
};
var _elm_community$list_extra$List_Extra$elemIndex = function (x) {
	return _elm_community$list_extra$List_Extra$findIndex(
		F2(
			function (x, y) {
				return _elm_lang$core$Native_Utils.eq(x, y);
			})(x));
};
var _elm_community$list_extra$List_Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			var _p69 = list;
			if (_p69.ctor === '[]') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				var _p70 = _p69._0;
				if (predicate(_p70)) {
					return _elm_lang$core$Maybe$Just(_p70);
				} else {
					var _v62 = predicate,
						_v63 = _p69._1;
					predicate = _v62;
					list = _v63;
					continue find;
				}
			}
		}
	});
var _elm_community$list_extra$List_Extra$notMember = function (x) {
	return function (_p71) {
		return !A2(_elm_lang$core$List$member, x, _p71);
	};
};
var _elm_community$list_extra$List_Extra$reverseMap = F2(
	function (f, xs) {
		return A3(
			_elm_lang$core$List$foldl,
			F2(
				function (x, acc) {
					return {
						ctor: '::',
						_0: f(x),
						_1: acc
					};
				}),
			{ctor: '[]'},
			xs);
	});
var _elm_community$list_extra$List_Extra$andThen = _elm_lang$core$List$concatMap;
var _elm_community$list_extra$List_Extra$lift2 = F3(
	function (f, la, lb) {
		return A2(
			_elm_community$list_extra$List_Extra$andThen,
			function (a) {
				return A2(
					_elm_community$list_extra$List_Extra$andThen,
					function (b) {
						return {
							ctor: '::',
							_0: A2(f, a, b),
							_1: {ctor: '[]'}
						};
					},
					lb);
			},
			la);
	});
var _elm_community$list_extra$List_Extra$cartesianProduct = function (ll) {
	var _p72 = ll;
	if (_p72.ctor === '[]') {
		return {
			ctor: '::',
			_0: {ctor: '[]'},
			_1: {ctor: '[]'}
		};
	} else {
		return A3(
			_elm_community$list_extra$List_Extra$lift2,
			F2(
				function (x, y) {
					return {ctor: '::', _0: x, _1: y};
				}),
			_p72._0,
			_elm_community$list_extra$List_Extra$cartesianProduct(_p72._1));
	}
};
var _elm_community$list_extra$List_Extra$lift3 = F4(
	function (f, la, lb, lc) {
		return A2(
			_elm_community$list_extra$List_Extra$andThen,
			function (a) {
				return A2(
					_elm_community$list_extra$List_Extra$andThen,
					function (b) {
						return A2(
							_elm_community$list_extra$List_Extra$andThen,
							function (c) {
								return {
									ctor: '::',
									_0: A3(f, a, b, c),
									_1: {ctor: '[]'}
								};
							},
							lc);
					},
					lb);
			},
			la);
	});
var _elm_community$list_extra$List_Extra$lift4 = F5(
	function (f, la, lb, lc, ld) {
		return A2(
			_elm_community$list_extra$List_Extra$andThen,
			function (a) {
				return A2(
					_elm_community$list_extra$List_Extra$andThen,
					function (b) {
						return A2(
							_elm_community$list_extra$List_Extra$andThen,
							function (c) {
								return A2(
									_elm_community$list_extra$List_Extra$andThen,
									function (d) {
										return {
											ctor: '::',
											_0: A4(f, a, b, c, d),
											_1: {ctor: '[]'}
										};
									},
									ld);
							},
							lc);
					},
					lb);
			},
			la);
	});
var _elm_community$list_extra$List_Extra$andMap = F2(
	function (l, fl) {
		return A3(
			_elm_lang$core$List$map2,
			F2(
				function (x, y) {
					return x(y);
				}),
			fl,
			l);
	});
var _elm_community$list_extra$List_Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			var _p73 = remaining;
			if (_p73.ctor === '[]') {
				return _elm_lang$core$List$reverse(accumulator);
			} else {
				var _p75 = _p73._1;
				var _p74 = _p73._0;
				var computedFirst = f(_p74);
				if (A2(_elm_lang$core$Set$member, computedFirst, existing)) {
					var _v66 = f,
						_v67 = existing,
						_v68 = _p75,
						_v69 = accumulator;
					f = _v66;
					existing = _v67;
					remaining = _v68;
					accumulator = _v69;
					continue uniqueHelp;
				} else {
					var _v70 = f,
						_v71 = A2(_elm_lang$core$Set$insert, computedFirst, existing),
						_v72 = _p75,
						_v73 = {ctor: '::', _0: _p74, _1: accumulator};
					f = _v70;
					existing = _v71;
					remaining = _v72;
					accumulator = _v73;
					continue uniqueHelp;
				}
			}
		}
	});
var _elm_community$list_extra$List_Extra$uniqueBy = F2(
	function (f, list) {
		return A4(
			_elm_community$list_extra$List_Extra$uniqueHelp,
			f,
			_elm_lang$core$Set$empty,
			list,
			{ctor: '[]'});
	});
var _elm_community$list_extra$List_Extra$allDifferentBy = F2(
	function (f, list) {
		return _elm_lang$core$Native_Utils.eq(
			_elm_lang$core$List$length(list),
			_elm_lang$core$List$length(
				A2(_elm_community$list_extra$List_Extra$uniqueBy, f, list)));
	});
var _elm_community$list_extra$List_Extra$allDifferent = function (list) {
	return A2(_elm_community$list_extra$List_Extra$allDifferentBy, _elm_lang$core$Basics$identity, list);
};
var _elm_community$list_extra$List_Extra$unique = function (list) {
	return A4(
		_elm_community$list_extra$List_Extra$uniqueHelp,
		_elm_lang$core$Basics$identity,
		_elm_lang$core$Set$empty,
		list,
		{ctor: '[]'});
};
var _elm_community$list_extra$List_Extra$dropWhile = F2(
	function (predicate, list) {
		dropWhile:
		while (true) {
			var _p76 = list;
			if (_p76.ctor === '[]') {
				return {ctor: '[]'};
			} else {
				if (predicate(_p76._0)) {
					var _v75 = predicate,
						_v76 = _p76._1;
					predicate = _v75;
					list = _v76;
					continue dropWhile;
				} else {
					return list;
				}
			}
		}
	});
var _elm_community$list_extra$List_Extra$takeWhile = function (predicate) {
	var takeWhileMemo = F2(
		function (memo, list) {
			takeWhileMemo:
			while (true) {
				var _p77 = list;
				if (_p77.ctor === '[]') {
					return _elm_lang$core$List$reverse(memo);
				} else {
					var _p78 = _p77._0;
					if (predicate(_p78)) {
						var _v78 = {ctor: '::', _0: _p78, _1: memo},
							_v79 = _p77._1;
						memo = _v78;
						list = _v79;
						continue takeWhileMemo;
					} else {
						return _elm_lang$core$List$reverse(memo);
					}
				}
			}
		});
	return takeWhileMemo(
		{ctor: '[]'});
};
var _elm_community$list_extra$List_Extra$span = F2(
	function (p, xs) {
		return {
			ctor: '_Tuple2',
			_0: A2(_elm_community$list_extra$List_Extra$takeWhile, p, xs),
			_1: A2(_elm_community$list_extra$List_Extra$dropWhile, p, xs)
		};
	});
var _elm_community$list_extra$List_Extra$break = function (p) {
	return _elm_community$list_extra$List_Extra$span(
		function (_p79) {
			return !p(_p79);
		});
};
var _elm_community$list_extra$List_Extra$groupWhile = F2(
	function (eq, xs_) {
		var _p80 = xs_;
		if (_p80.ctor === '[]') {
			return {ctor: '[]'};
		} else {
			var _p82 = _p80._0;
			var _p81 = A2(
				_elm_community$list_extra$List_Extra$span,
				eq(_p82),
				_p80._1);
			var ys = _p81._0;
			var zs = _p81._1;
			return {
				ctor: '::',
				_0: {ctor: '::', _0: _p82, _1: ys},
				_1: A2(_elm_community$list_extra$List_Extra$groupWhile, eq, zs)
			};
		}
	});
var _elm_community$list_extra$List_Extra$group = _elm_community$list_extra$List_Extra$groupWhile(
	F2(
		function (x, y) {
			return _elm_lang$core$Native_Utils.eq(x, y);
		}));
var _elm_community$list_extra$List_Extra$minimumBy = F2(
	function (f, ls) {
		var minBy = F2(
			function (x, _p83) {
				var _p84 = _p83;
				var _p85 = _p84._1;
				var fx = f(x);
				return (_elm_lang$core$Native_Utils.cmp(fx, _p85) < 0) ? {ctor: '_Tuple2', _0: x, _1: fx} : {ctor: '_Tuple2', _0: _p84._0, _1: _p85};
			});
		var _p86 = ls;
		if (_p86.ctor === '::') {
			if (_p86._1.ctor === '[]') {
				return _elm_lang$core$Maybe$Just(_p86._0);
			} else {
				var _p87 = _p86._0;
				return _elm_lang$core$Maybe$Just(
					_elm_lang$core$Tuple$first(
						A3(
							_elm_lang$core$List$foldl,
							minBy,
							{
								ctor: '_Tuple2',
								_0: _p87,
								_1: f(_p87)
							},
							_p86._1)));
			}
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _elm_community$list_extra$List_Extra$maximumBy = F2(
	function (f, ls) {
		var maxBy = F2(
			function (x, _p88) {
				var _p89 = _p88;
				var _p90 = _p89._1;
				var fx = f(x);
				return (_elm_lang$core$Native_Utils.cmp(fx, _p90) > 0) ? {ctor: '_Tuple2', _0: x, _1: fx} : {ctor: '_Tuple2', _0: _p89._0, _1: _p90};
			});
		var _p91 = ls;
		if (_p91.ctor === '::') {
			if (_p91._1.ctor === '[]') {
				return _elm_lang$core$Maybe$Just(_p91._0);
			} else {
				var _p92 = _p91._0;
				return _elm_lang$core$Maybe$Just(
					_elm_lang$core$Tuple$first(
						A3(
							_elm_lang$core$List$foldl,
							maxBy,
							{
								ctor: '_Tuple2',
								_0: _p92,
								_1: f(_p92)
							},
							_p91._1)));
			}
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _elm_community$list_extra$List_Extra$uncons = function (xs) {
	var _p93 = xs;
	if (_p93.ctor === '[]') {
		return _elm_lang$core$Maybe$Nothing;
	} else {
		return _elm_lang$core$Maybe$Just(
			{ctor: '_Tuple2', _0: _p93._0, _1: _p93._1});
	}
};
var _elm_community$list_extra$List_Extra$swapAt = F3(
	function (index1, index2, l) {
		swapAt:
		while (true) {
			if (_elm_lang$core$Native_Utils.eq(index1, index2) || (_elm_lang$core$Native_Utils.cmp(index1, 0) < 0)) {
				return l;
			} else {
				if (_elm_lang$core$Native_Utils.cmp(index1, index2) > 0) {
					var _v86 = index2,
						_v87 = index1,
						_v88 = l;
					index1 = _v86;
					index2 = _v87;
					l = _v88;
					continue swapAt;
				} else {
					var _p94 = A2(_elm_community$list_extra$List_Extra$splitAt, index1, l);
					var part1 = _p94._0;
					var tail1 = _p94._1;
					var _p95 = A2(_elm_community$list_extra$List_Extra$splitAt, index2 - index1, tail1);
					var head2 = _p95._0;
					var tail2 = _p95._1;
					var _p96 = {
						ctor: '_Tuple2',
						_0: _elm_community$list_extra$List_Extra$uncons(head2),
						_1: _elm_community$list_extra$List_Extra$uncons(tail2)
					};
					if (((((_p96.ctor === '_Tuple2') && (_p96._0.ctor === 'Just')) && (_p96._0._0.ctor === '_Tuple2')) && (_p96._1.ctor === 'Just')) && (_p96._1._0.ctor === '_Tuple2')) {
						return _elm_lang$core$List$concat(
							{
								ctor: '::',
								_0: part1,
								_1: {
									ctor: '::',
									_0: {ctor: '::', _0: _p96._1._0._0, _1: _p96._0._0._1},
									_1: {
										ctor: '::',
										_0: {ctor: '::', _0: _p96._0._0._0, _1: _p96._1._0._1},
										_1: {ctor: '[]'}
									}
								}
							});
					} else {
						return l;
					}
				}
			}
		}
	});
var _elm_community$list_extra$List_Extra$cycleHelp = F3(
	function (acc, n, list) {
		cycleHelp:
		while (true) {
			if (_elm_lang$core$Native_Utils.cmp(n, 0) > 0) {
				var _v90 = A2(_elm_community$list_extra$List_Extra$reverseAppend, list, acc),
					_v91 = n - 1,
					_v92 = list;
				acc = _v90;
				n = _v91;
				list = _v92;
				continue cycleHelp;
			} else {
				return acc;
			}
		}
	});
var _elm_community$list_extra$List_Extra$cycle = F2(
	function (len, list) {
		var cycleLength = _elm_lang$core$List$length(list);
		return (_elm_lang$core$Native_Utils.eq(cycleLength, 0) || _elm_lang$core$Native_Utils.eq(cycleLength, len)) ? list : ((_elm_lang$core$Native_Utils.cmp(cycleLength, len) < 0) ? _elm_lang$core$List$reverse(
			A2(
				_elm_community$list_extra$List_Extra$reverseAppend,
				A2(
					_elm_lang$core$List$take,
					A2(_elm_lang$core$Basics$rem, len, cycleLength),
					list),
				A3(
					_elm_community$list_extra$List_Extra$cycleHelp,
					{ctor: '[]'},
					(len / cycleLength) | 0,
					list))) : A2(_elm_lang$core$List$take, len, list));
	});
var _elm_community$list_extra$List_Extra$initialize = F2(
	function (n, f) {
		var step = F2(
			function (i, acc) {
				step:
				while (true) {
					if (_elm_lang$core$Native_Utils.cmp(i, 0) < 0) {
						return acc;
					} else {
						var _v93 = i - 1,
							_v94 = {
							ctor: '::',
							_0: f(i),
							_1: acc
						};
						i = _v93;
						acc = _v94;
						continue step;
					}
				}
			});
		return A2(
			step,
			n - 1,
			{ctor: '[]'});
	});
var _elm_community$list_extra$List_Extra$iterate = F2(
	function (f, x) {
		var _p97 = f(x);
		if (_p97.ctor === 'Just') {
			return {
				ctor: '::',
				_0: x,
				_1: A2(_elm_community$list_extra$List_Extra$iterate, f, _p97._0)
			};
		} else {
			return {
				ctor: '::',
				_0: x,
				_1: {ctor: '[]'}
			};
		}
	});
var _elm_community$list_extra$List_Extra$getAt = F2(
	function (idx, xs) {
		return (_elm_lang$core$Native_Utils.cmp(idx, 0) < 0) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$List$head(
			A2(_elm_lang$core$List$drop, idx, xs));
	});
var _elm_community$list_extra$List_Extra_ops = _elm_community$list_extra$List_Extra_ops || {};
_elm_community$list_extra$List_Extra_ops['!!'] = _elm_lang$core$Basics$flip(_elm_community$list_extra$List_Extra$getAt);
var _elm_community$list_extra$List_Extra$init = function (items) {
	var _p98 = items;
	if (_p98.ctor === '[]') {
		return _elm_lang$core$Maybe$Nothing;
	} else {
		return A2(
			_elm_lang$core$Maybe$map,
			_elm_lang$core$List$reverse,
			_elm_lang$core$List$tail(
				_elm_lang$core$List$reverse(_p98)));
	}
};
var _elm_community$list_extra$List_Extra$last = function (items) {
	last:
	while (true) {
		var _p99 = items;
		if (_p99.ctor === '[]') {
			return _elm_lang$core$Maybe$Nothing;
		} else {
			if (_p99._1.ctor === '[]') {
				return _elm_lang$core$Maybe$Just(_p99._0);
			} else {
				var _v98 = _p99._1;
				items = _v98;
				continue last;
			}
		}
	}
};

var _elm_community$maybe_extra$Maybe_Extra$foldrValues = F2(
	function (item, list) {
		var _p0 = item;
		if (_p0.ctor === 'Nothing') {
			return list;
		} else {
			return {ctor: '::', _0: _p0._0, _1: list};
		}
	});
var _elm_community$maybe_extra$Maybe_Extra$values = A2(
	_elm_lang$core$List$foldr,
	_elm_community$maybe_extra$Maybe_Extra$foldrValues,
	{ctor: '[]'});
var _elm_community$maybe_extra$Maybe_Extra$filter = F2(
	function (f, m) {
		var _p1 = A2(_elm_lang$core$Maybe$map, f, m);
		if ((_p1.ctor === 'Just') && (_p1._0 === true)) {
			return m;
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _elm_community$maybe_extra$Maybe_Extra$traverseArray = function (f) {
	var step = F2(
		function (e, acc) {
			var _p2 = f(e);
			if (_p2.ctor === 'Nothing') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				return A2(
					_elm_lang$core$Maybe$map,
					_elm_lang$core$Array$push(_p2._0),
					acc);
			}
		});
	return A2(
		_elm_lang$core$Array$foldl,
		step,
		_elm_lang$core$Maybe$Just(_elm_lang$core$Array$empty));
};
var _elm_community$maybe_extra$Maybe_Extra$combineArray = _elm_community$maybe_extra$Maybe_Extra$traverseArray(_elm_lang$core$Basics$identity);
var _elm_community$maybe_extra$Maybe_Extra$traverse = function (f) {
	var step = F2(
		function (e, acc) {
			var _p3 = f(e);
			if (_p3.ctor === 'Nothing') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				return A2(
					_elm_lang$core$Maybe$map,
					F2(
						function (x, y) {
							return {ctor: '::', _0: x, _1: y};
						})(_p3._0),
					acc);
			}
		});
	return A2(
		_elm_lang$core$List$foldr,
		step,
		_elm_lang$core$Maybe$Just(
			{ctor: '[]'}));
};
var _elm_community$maybe_extra$Maybe_Extra$combine = _elm_community$maybe_extra$Maybe_Extra$traverse(_elm_lang$core$Basics$identity);
var _elm_community$maybe_extra$Maybe_Extra$toArray = function (m) {
	var _p4 = m;
	if (_p4.ctor === 'Nothing') {
		return _elm_lang$core$Array$empty;
	} else {
		return A2(_elm_lang$core$Array$repeat, 1, _p4._0);
	}
};
var _elm_community$maybe_extra$Maybe_Extra$toList = function (m) {
	var _p5 = m;
	if (_p5.ctor === 'Nothing') {
		return {ctor: '[]'};
	} else {
		return {
			ctor: '::',
			_0: _p5._0,
			_1: {ctor: '[]'}
		};
	}
};
var _elm_community$maybe_extra$Maybe_Extra$orElse = F2(
	function (ma, mb) {
		var _p6 = mb;
		if (_p6.ctor === 'Nothing') {
			return ma;
		} else {
			return mb;
		}
	});
var _elm_community$maybe_extra$Maybe_Extra$orElseLazy = F2(
	function (fma, mb) {
		var _p7 = mb;
		if (_p7.ctor === 'Nothing') {
			return fma(
				{ctor: '_Tuple0'});
		} else {
			return mb;
		}
	});
var _elm_community$maybe_extra$Maybe_Extra$orLazy = F2(
	function (ma, fmb) {
		var _p8 = ma;
		if (_p8.ctor === 'Nothing') {
			return fmb(
				{ctor: '_Tuple0'});
		} else {
			return ma;
		}
	});
var _elm_community$maybe_extra$Maybe_Extra$or = F2(
	function (ma, mb) {
		var _p9 = ma;
		if (_p9.ctor === 'Nothing') {
			return mb;
		} else {
			return ma;
		}
	});
var _elm_community$maybe_extra$Maybe_Extra$prev = _elm_lang$core$Maybe$map2(_elm_lang$core$Basics$always);
var _elm_community$maybe_extra$Maybe_Extra$next = _elm_lang$core$Maybe$map2(
	_elm_lang$core$Basics$flip(_elm_lang$core$Basics$always));
var _elm_community$maybe_extra$Maybe_Extra$andMap = _elm_lang$core$Maybe$map2(
	F2(
		function (x, y) {
			return y(x);
		}));
var _elm_community$maybe_extra$Maybe_Extra$unpack = F3(
	function (d, f, m) {
		var _p10 = m;
		if (_p10.ctor === 'Nothing') {
			return d(
				{ctor: '_Tuple0'});
		} else {
			return f(_p10._0);
		}
	});
var _elm_community$maybe_extra$Maybe_Extra$unwrap = F3(
	function (d, f, m) {
		var _p11 = m;
		if (_p11.ctor === 'Nothing') {
			return d;
		} else {
			return f(_p11._0);
		}
	});
var _elm_community$maybe_extra$Maybe_Extra$isJust = function (m) {
	var _p12 = m;
	if (_p12.ctor === 'Nothing') {
		return false;
	} else {
		return true;
	}
};
var _elm_community$maybe_extra$Maybe_Extra$isNothing = function (m) {
	var _p13 = m;
	if (_p13.ctor === 'Nothing') {
		return true;
	} else {
		return false;
	}
};
var _elm_community$maybe_extra$Maybe_Extra$join = function (mx) {
	var _p14 = mx;
	if (_p14.ctor === 'Just') {
		return _p14._0;
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _elm_community$maybe_extra$Maybe_Extra_ops = _elm_community$maybe_extra$Maybe_Extra_ops || {};
_elm_community$maybe_extra$Maybe_Extra_ops['?'] = F2(
	function (mx, x) {
		return A2(_elm_lang$core$Maybe$withDefault, x, mx);
	});

var _elm_lang$core$Process$kill = _elm_lang$core$Native_Scheduler.kill;
var _elm_lang$core$Process$sleep = _elm_lang$core$Native_Scheduler.sleep;
var _elm_lang$core$Process$spawn = _elm_lang$core$Native_Scheduler.spawn;

var _elm_lang$dom$Native_Dom = function() {

var fakeNode = {
	addEventListener: function() {},
	removeEventListener: function() {}
};

var onDocument = on(typeof document !== 'undefined' ? document : fakeNode);
var onWindow = on(typeof window !== 'undefined' ? window : fakeNode);

function on(node)
{
	return function(eventName, decoder, toTask)
	{
		return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback) {

			function performTask(event)
			{
				var result = A2(_elm_lang$core$Json_Decode$decodeValue, decoder, event);
				if (result.ctor === 'Ok')
				{
					_elm_lang$core$Native_Scheduler.rawSpawn(toTask(result._0));
				}
			}

			node.addEventListener(eventName, performTask);

			return function()
			{
				node.removeEventListener(eventName, performTask);
			};
		});
	};
}

var rAF = typeof requestAnimationFrame !== 'undefined'
	? requestAnimationFrame
	: function(callback) { callback(); };

function withNode(id, doStuff)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		rAF(function()
		{
			var node = document.getElementById(id);
			if (node === null)
			{
				callback(_elm_lang$core$Native_Scheduler.fail({ ctor: 'NotFound', _0: id }));
				return;
			}
			callback(_elm_lang$core$Native_Scheduler.succeed(doStuff(node)));
		});
	});
}


// FOCUS

function focus(id)
{
	return withNode(id, function(node) {
		node.focus();
		return _elm_lang$core$Native_Utils.Tuple0;
	});
}

function blur(id)
{
	return withNode(id, function(node) {
		node.blur();
		return _elm_lang$core$Native_Utils.Tuple0;
	});
}


// SCROLLING

function getScrollTop(id)
{
	return withNode(id, function(node) {
		return node.scrollTop;
	});
}

function setScrollTop(id, desiredScrollTop)
{
	return withNode(id, function(node) {
		node.scrollTop = desiredScrollTop;
		return _elm_lang$core$Native_Utils.Tuple0;
	});
}

function toBottom(id)
{
	return withNode(id, function(node) {
		node.scrollTop = node.scrollHeight;
		return _elm_lang$core$Native_Utils.Tuple0;
	});
}

function getScrollLeft(id)
{
	return withNode(id, function(node) {
		return node.scrollLeft;
	});
}

function setScrollLeft(id, desiredScrollLeft)
{
	return withNode(id, function(node) {
		node.scrollLeft = desiredScrollLeft;
		return _elm_lang$core$Native_Utils.Tuple0;
	});
}

function toRight(id)
{
	return withNode(id, function(node) {
		node.scrollLeft = node.scrollWidth;
		return _elm_lang$core$Native_Utils.Tuple0;
	});
}


// SIZE

function width(options, id)
{
	return withNode(id, function(node) {
		switch (options.ctor)
		{
			case 'Content':
				return node.scrollWidth;
			case 'VisibleContent':
				return node.clientWidth;
			case 'VisibleContentWithBorders':
				return node.offsetWidth;
			case 'VisibleContentWithBordersAndMargins':
				var rect = node.getBoundingClientRect();
				return rect.right - rect.left;
		}
	});
}

function height(options, id)
{
	return withNode(id, function(node) {
		switch (options.ctor)
		{
			case 'Content':
				return node.scrollHeight;
			case 'VisibleContent':
				return node.clientHeight;
			case 'VisibleContentWithBorders':
				return node.offsetHeight;
			case 'VisibleContentWithBordersAndMargins':
				var rect = node.getBoundingClientRect();
				return rect.bottom - rect.top;
		}
	});
}

return {
	onDocument: F3(onDocument),
	onWindow: F3(onWindow),

	focus: focus,
	blur: blur,

	getScrollTop: getScrollTop,
	setScrollTop: F2(setScrollTop),
	getScrollLeft: getScrollLeft,
	setScrollLeft: F2(setScrollLeft),
	toBottom: toBottom,
	toRight: toRight,

	height: F2(height),
	width: F2(width)
};

}();

var _elm_lang$dom$Dom$blur = _elm_lang$dom$Native_Dom.blur;
var _elm_lang$dom$Dom$focus = _elm_lang$dom$Native_Dom.focus;
var _elm_lang$dom$Dom$NotFound = function (a) {
	return {ctor: 'NotFound', _0: a};
};

var _elm_lang$dom$Dom_LowLevel$onWindow = _elm_lang$dom$Native_Dom.onWindow;
var _elm_lang$dom$Dom_LowLevel$onDocument = _elm_lang$dom$Native_Dom.onDocument;

var _elm_lang$http$Native_Http = function() {


// ENCODING AND DECODING

function encodeUri(string)
{
	return encodeURIComponent(string);
}

function decodeUri(string)
{
	try
	{
		return _elm_lang$core$Maybe$Just(decodeURIComponent(string));
	}
	catch(e)
	{
		return _elm_lang$core$Maybe$Nothing;
	}
}


// SEND REQUEST

function toTask(request, maybeProgress)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		var xhr = new XMLHttpRequest();

		configureProgress(xhr, maybeProgress);

		xhr.addEventListener('error', function() {
			callback(_elm_lang$core$Native_Scheduler.fail({ ctor: 'NetworkError' }));
		});
		xhr.addEventListener('timeout', function() {
			callback(_elm_lang$core$Native_Scheduler.fail({ ctor: 'Timeout' }));
		});
		xhr.addEventListener('load', function() {
			callback(handleResponse(xhr, request.expect.responseToResult));
		});

		try
		{
			xhr.open(request.method, request.url, true);
		}
		catch (e)
		{
			return callback(_elm_lang$core$Native_Scheduler.fail({ ctor: 'BadUrl', _0: request.url }));
		}

		configureRequest(xhr, request);
		send(xhr, request.body);

		return function() { xhr.abort(); };
	});
}

function configureProgress(xhr, maybeProgress)
{
	if (maybeProgress.ctor === 'Nothing')
	{
		return;
	}

	xhr.addEventListener('progress', function(event) {
		if (!event.lengthComputable)
		{
			return;
		}
		_elm_lang$core$Native_Scheduler.rawSpawn(maybeProgress._0({
			bytes: event.loaded,
			bytesExpected: event.total
		}));
	});
}

function configureRequest(xhr, request)
{
	function setHeader(pair)
	{
		xhr.setRequestHeader(pair._0, pair._1);
	}

	A2(_elm_lang$core$List$map, setHeader, request.headers);
	xhr.responseType = request.expect.responseType;
	xhr.withCredentials = request.withCredentials;

	if (request.timeout.ctor === 'Just')
	{
		xhr.timeout = request.timeout._0;
	}
}

function send(xhr, body)
{
	switch (body.ctor)
	{
		case 'EmptyBody':
			xhr.send();
			return;

		case 'StringBody':
			xhr.setRequestHeader('Content-Type', body._0);
			xhr.send(body._1);
			return;

		case 'FormDataBody':
			xhr.send(body._0);
			return;
	}
}


// RESPONSES

function handleResponse(xhr, responseToResult)
{
	var response = toResponse(xhr);

	if (xhr.status < 200 || 300 <= xhr.status)
	{
		response.body = xhr.responseText;
		return _elm_lang$core$Native_Scheduler.fail({
			ctor: 'BadStatus',
			_0: response
		});
	}

	var result = responseToResult(response);

	if (result.ctor === 'Ok')
	{
		return _elm_lang$core$Native_Scheduler.succeed(result._0);
	}
	else
	{
		response.body = xhr.responseText;
		return _elm_lang$core$Native_Scheduler.fail({
			ctor: 'BadPayload',
			_0: result._0,
			_1: response
		});
	}
}

function toResponse(xhr)
{
	return {
		status: { code: xhr.status, message: xhr.statusText },
		headers: parseHeaders(xhr.getAllResponseHeaders()),
		url: xhr.responseURL,
		body: xhr.response
	};
}

function parseHeaders(rawHeaders)
{
	var headers = _elm_lang$core$Dict$empty;

	if (!rawHeaders)
	{
		return headers;
	}

	var headerPairs = rawHeaders.split('\u000d\u000a');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf('\u003a\u0020');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3(_elm_lang$core$Dict$update, key, function(oldValue) {
				if (oldValue.ctor === 'Just')
				{
					return _elm_lang$core$Maybe$Just(value + ', ' + oldValue._0);
				}
				return _elm_lang$core$Maybe$Just(value);
			}, headers);
		}
	}

	return headers;
}


// EXPECTORS

function expectStringResponse(responseToResult)
{
	return {
		responseType: 'text',
		responseToResult: responseToResult
	};
}

function mapExpect(func, expect)
{
	return {
		responseType: expect.responseType,
		responseToResult: function(response) {
			var convertedResponse = expect.responseToResult(response);
			return A2(_elm_lang$core$Result$map, func, convertedResponse);
		}
	};
}


// BODY

function multipart(parts)
{
	var formData = new FormData();

	while (parts.ctor !== '[]')
	{
		var part = parts._0;
		formData.append(part._0, part._1);
		parts = parts._1;
	}

	return { ctor: 'FormDataBody', _0: formData };
}

return {
	toTask: F2(toTask),
	expectStringResponse: expectStringResponse,
	mapExpect: F2(mapExpect),
	multipart: multipart,
	encodeUri: encodeUri,
	decodeUri: decodeUri
};

}();

var _elm_lang$http$Http_Internal$map = F2(
	function (func, request) {
		return _elm_lang$core$Native_Utils.update(
			request,
			{
				expect: A2(_elm_lang$http$Native_Http.mapExpect, func, request.expect)
			});
	});
var _elm_lang$http$Http_Internal$RawRequest = F7(
	function (a, b, c, d, e, f, g) {
		return {method: a, headers: b, url: c, body: d, expect: e, timeout: f, withCredentials: g};
	});
var _elm_lang$http$Http_Internal$Request = function (a) {
	return {ctor: 'Request', _0: a};
};
var _elm_lang$http$Http_Internal$Expect = {ctor: 'Expect'};
var _elm_lang$http$Http_Internal$FormDataBody = {ctor: 'FormDataBody'};
var _elm_lang$http$Http_Internal$StringBody = F2(
	function (a, b) {
		return {ctor: 'StringBody', _0: a, _1: b};
	});
var _elm_lang$http$Http_Internal$EmptyBody = {ctor: 'EmptyBody'};
var _elm_lang$http$Http_Internal$Header = F2(
	function (a, b) {
		return {ctor: 'Header', _0: a, _1: b};
	});

var _elm_lang$http$Http$decodeUri = _elm_lang$http$Native_Http.decodeUri;
var _elm_lang$http$Http$encodeUri = _elm_lang$http$Native_Http.encodeUri;
var _elm_lang$http$Http$expectStringResponse = _elm_lang$http$Native_Http.expectStringResponse;
var _elm_lang$http$Http$expectJson = function (decoder) {
	return _elm_lang$http$Http$expectStringResponse(
		function (response) {
			return A2(_elm_lang$core$Json_Decode$decodeString, decoder, response.body);
		});
};
var _elm_lang$http$Http$expectString = _elm_lang$http$Http$expectStringResponse(
	function (response) {
		return _elm_lang$core$Result$Ok(response.body);
	});
var _elm_lang$http$Http$multipartBody = _elm_lang$http$Native_Http.multipart;
var _elm_lang$http$Http$stringBody = _elm_lang$http$Http_Internal$StringBody;
var _elm_lang$http$Http$jsonBody = function (value) {
	return A2(
		_elm_lang$http$Http_Internal$StringBody,
		'application/json',
		A2(_elm_lang$core$Json_Encode$encode, 0, value));
};
var _elm_lang$http$Http$emptyBody = _elm_lang$http$Http_Internal$EmptyBody;
var _elm_lang$http$Http$header = _elm_lang$http$Http_Internal$Header;
var _elm_lang$http$Http$request = _elm_lang$http$Http_Internal$Request;
var _elm_lang$http$Http$post = F3(
	function (url, body, decoder) {
		return _elm_lang$http$Http$request(
			{
				method: 'POST',
				headers: {ctor: '[]'},
				url: url,
				body: body,
				expect: _elm_lang$http$Http$expectJson(decoder),
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: false
			});
	});
var _elm_lang$http$Http$get = F2(
	function (url, decoder) {
		return _elm_lang$http$Http$request(
			{
				method: 'GET',
				headers: {ctor: '[]'},
				url: url,
				body: _elm_lang$http$Http$emptyBody,
				expect: _elm_lang$http$Http$expectJson(decoder),
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: false
			});
	});
var _elm_lang$http$Http$getString = function (url) {
	return _elm_lang$http$Http$request(
		{
			method: 'GET',
			headers: {ctor: '[]'},
			url: url,
			body: _elm_lang$http$Http$emptyBody,
			expect: _elm_lang$http$Http$expectString,
			timeout: _elm_lang$core$Maybe$Nothing,
			withCredentials: false
		});
};
var _elm_lang$http$Http$toTask = function (_p0) {
	var _p1 = _p0;
	return A2(_elm_lang$http$Native_Http.toTask, _p1._0, _elm_lang$core$Maybe$Nothing);
};
var _elm_lang$http$Http$send = F2(
	function (resultToMessage, request) {
		return A2(
			_elm_lang$core$Task$attempt,
			resultToMessage,
			_elm_lang$http$Http$toTask(request));
	});
var _elm_lang$http$Http$Response = F4(
	function (a, b, c, d) {
		return {url: a, status: b, headers: c, body: d};
	});
var _elm_lang$http$Http$BadPayload = F2(
	function (a, b) {
		return {ctor: 'BadPayload', _0: a, _1: b};
	});
var _elm_lang$http$Http$BadStatus = function (a) {
	return {ctor: 'BadStatus', _0: a};
};
var _elm_lang$http$Http$NetworkError = {ctor: 'NetworkError'};
var _elm_lang$http$Http$Timeout = {ctor: 'Timeout'};
var _elm_lang$http$Http$BadUrl = function (a) {
	return {ctor: 'BadUrl', _0: a};
};
var _elm_lang$http$Http$StringPart = F2(
	function (a, b) {
		return {ctor: 'StringPart', _0: a, _1: b};
	});
var _elm_lang$http$Http$stringPart = _elm_lang$http$Http$StringPart;

var _elm_lang$navigation$Native_Navigation = function() {


// FAKE NAVIGATION

function go(n)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		if (n !== 0)
		{
			history.go(n);
		}
		callback(_elm_lang$core$Native_Scheduler.succeed(_elm_lang$core$Native_Utils.Tuple0));
	});
}

function pushState(url)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		history.pushState({}, '', url);
		callback(_elm_lang$core$Native_Scheduler.succeed(getLocation()));
	});
}

function replaceState(url)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		history.replaceState({}, '', url);
		callback(_elm_lang$core$Native_Scheduler.succeed(getLocation()));
	});
}


// REAL NAVIGATION

function reloadPage(skipCache)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		document.location.reload(skipCache);
		callback(_elm_lang$core$Native_Scheduler.succeed(_elm_lang$core$Native_Utils.Tuple0));
	});
}

function setLocation(url)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		try
		{
			window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			document.location.reload(false);
		}
		callback(_elm_lang$core$Native_Scheduler.succeed(_elm_lang$core$Native_Utils.Tuple0));
	});
}


// GET LOCATION

function getLocation()
{
	var location = document.location;

	return {
		href: location.href,
		host: location.host,
		hostname: location.hostname,
		protocol: location.protocol,
		origin: location.origin,
		port_: location.port,
		pathname: location.pathname,
		search: location.search,
		hash: location.hash,
		username: location.username,
		password: location.password
	};
}


// DETECT IE11 PROBLEMS

function isInternetExplorer11()
{
	return window.navigator.userAgent.indexOf('Trident') !== -1;
}


return {
	go: go,
	setLocation: setLocation,
	reloadPage: reloadPage,
	pushState: pushState,
	replaceState: replaceState,
	getLocation: getLocation,
	isInternetExplorer11: isInternetExplorer11
};

}();

var _elm_lang$navigation$Navigation$replaceState = _elm_lang$navigation$Native_Navigation.replaceState;
var _elm_lang$navigation$Navigation$pushState = _elm_lang$navigation$Native_Navigation.pushState;
var _elm_lang$navigation$Navigation$go = _elm_lang$navigation$Native_Navigation.go;
var _elm_lang$navigation$Navigation$reloadPage = _elm_lang$navigation$Native_Navigation.reloadPage;
var _elm_lang$navigation$Navigation$setLocation = _elm_lang$navigation$Native_Navigation.setLocation;
var _elm_lang$navigation$Navigation_ops = _elm_lang$navigation$Navigation_ops || {};
_elm_lang$navigation$Navigation_ops['&>'] = F2(
	function (task1, task2) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (_p0) {
				return task2;
			},
			task1);
	});
var _elm_lang$navigation$Navigation$notify = F3(
	function (router, subs, location) {
		var send = function (_p1) {
			var _p2 = _p1;
			return A2(
				_elm_lang$core$Platform$sendToApp,
				router,
				_p2._0(location));
		};
		return A2(
			_elm_lang$navigation$Navigation_ops['&>'],
			_elm_lang$core$Task$sequence(
				A2(_elm_lang$core$List$map, send, subs)),
			_elm_lang$core$Task$succeed(
				{ctor: '_Tuple0'}));
	});
var _elm_lang$navigation$Navigation$cmdHelp = F3(
	function (router, subs, cmd) {
		var _p3 = cmd;
		switch (_p3.ctor) {
			case 'Jump':
				return _elm_lang$navigation$Navigation$go(_p3._0);
			case 'New':
				return A2(
					_elm_lang$core$Task$andThen,
					A2(_elm_lang$navigation$Navigation$notify, router, subs),
					_elm_lang$navigation$Navigation$pushState(_p3._0));
			case 'Modify':
				return A2(
					_elm_lang$core$Task$andThen,
					A2(_elm_lang$navigation$Navigation$notify, router, subs),
					_elm_lang$navigation$Navigation$replaceState(_p3._0));
			case 'Visit':
				return _elm_lang$navigation$Navigation$setLocation(_p3._0);
			default:
				return _elm_lang$navigation$Navigation$reloadPage(_p3._0);
		}
	});
var _elm_lang$navigation$Navigation$killPopWatcher = function (popWatcher) {
	var _p4 = popWatcher;
	if (_p4.ctor === 'Normal') {
		return _elm_lang$core$Process$kill(_p4._0);
	} else {
		return A2(
			_elm_lang$navigation$Navigation_ops['&>'],
			_elm_lang$core$Process$kill(_p4._0),
			_elm_lang$core$Process$kill(_p4._1));
	}
};
var _elm_lang$navigation$Navigation$onSelfMsg = F3(
	function (router, location, state) {
		return A2(
			_elm_lang$navigation$Navigation_ops['&>'],
			A3(_elm_lang$navigation$Navigation$notify, router, state.subs, location),
			_elm_lang$core$Task$succeed(state));
	});
var _elm_lang$navigation$Navigation$subscription = _elm_lang$core$Native_Platform.leaf('Navigation');
var _elm_lang$navigation$Navigation$command = _elm_lang$core$Native_Platform.leaf('Navigation');
var _elm_lang$navigation$Navigation$Location = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return {href: a, host: b, hostname: c, protocol: d, origin: e, port_: f, pathname: g, search: h, hash: i, username: j, password: k};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _elm_lang$navigation$Navigation$State = F2(
	function (a, b) {
		return {subs: a, popWatcher: b};
	});
var _elm_lang$navigation$Navigation$init = _elm_lang$core$Task$succeed(
	A2(
		_elm_lang$navigation$Navigation$State,
		{ctor: '[]'},
		_elm_lang$core$Maybe$Nothing));
var _elm_lang$navigation$Navigation$Reload = function (a) {
	return {ctor: 'Reload', _0: a};
};
var _elm_lang$navigation$Navigation$reload = _elm_lang$navigation$Navigation$command(
	_elm_lang$navigation$Navigation$Reload(false));
var _elm_lang$navigation$Navigation$reloadAndSkipCache = _elm_lang$navigation$Navigation$command(
	_elm_lang$navigation$Navigation$Reload(true));
var _elm_lang$navigation$Navigation$Visit = function (a) {
	return {ctor: 'Visit', _0: a};
};
var _elm_lang$navigation$Navigation$load = function (url) {
	return _elm_lang$navigation$Navigation$command(
		_elm_lang$navigation$Navigation$Visit(url));
};
var _elm_lang$navigation$Navigation$Modify = function (a) {
	return {ctor: 'Modify', _0: a};
};
var _elm_lang$navigation$Navigation$modifyUrl = function (url) {
	return _elm_lang$navigation$Navigation$command(
		_elm_lang$navigation$Navigation$Modify(url));
};
var _elm_lang$navigation$Navigation$New = function (a) {
	return {ctor: 'New', _0: a};
};
var _elm_lang$navigation$Navigation$newUrl = function (url) {
	return _elm_lang$navigation$Navigation$command(
		_elm_lang$navigation$Navigation$New(url));
};
var _elm_lang$navigation$Navigation$Jump = function (a) {
	return {ctor: 'Jump', _0: a};
};
var _elm_lang$navigation$Navigation$back = function (n) {
	return _elm_lang$navigation$Navigation$command(
		_elm_lang$navigation$Navigation$Jump(0 - n));
};
var _elm_lang$navigation$Navigation$forward = function (n) {
	return _elm_lang$navigation$Navigation$command(
		_elm_lang$navigation$Navigation$Jump(n));
};
var _elm_lang$navigation$Navigation$cmdMap = F2(
	function (_p5, myCmd) {
		var _p6 = myCmd;
		switch (_p6.ctor) {
			case 'Jump':
				return _elm_lang$navigation$Navigation$Jump(_p6._0);
			case 'New':
				return _elm_lang$navigation$Navigation$New(_p6._0);
			case 'Modify':
				return _elm_lang$navigation$Navigation$Modify(_p6._0);
			case 'Visit':
				return _elm_lang$navigation$Navigation$Visit(_p6._0);
			default:
				return _elm_lang$navigation$Navigation$Reload(_p6._0);
		}
	});
var _elm_lang$navigation$Navigation$Monitor = function (a) {
	return {ctor: 'Monitor', _0: a};
};
var _elm_lang$navigation$Navigation$program = F2(
	function (locationToMessage, stuff) {
		var init = stuff.init(
			_elm_lang$navigation$Native_Navigation.getLocation(
				{ctor: '_Tuple0'}));
		var subs = function (model) {
			return _elm_lang$core$Platform_Sub$batch(
				{
					ctor: '::',
					_0: _elm_lang$navigation$Navigation$subscription(
						_elm_lang$navigation$Navigation$Monitor(locationToMessage)),
					_1: {
						ctor: '::',
						_0: stuff.subscriptions(model),
						_1: {ctor: '[]'}
					}
				});
		};
		return _elm_lang$html$Html$program(
			{init: init, view: stuff.view, update: stuff.update, subscriptions: subs});
	});
var _elm_lang$navigation$Navigation$programWithFlags = F2(
	function (locationToMessage, stuff) {
		var init = function (flags) {
			return A2(
				stuff.init,
				flags,
				_elm_lang$navigation$Native_Navigation.getLocation(
					{ctor: '_Tuple0'}));
		};
		var subs = function (model) {
			return _elm_lang$core$Platform_Sub$batch(
				{
					ctor: '::',
					_0: _elm_lang$navigation$Navigation$subscription(
						_elm_lang$navigation$Navigation$Monitor(locationToMessage)),
					_1: {
						ctor: '::',
						_0: stuff.subscriptions(model),
						_1: {ctor: '[]'}
					}
				});
		};
		return _elm_lang$html$Html$programWithFlags(
			{init: init, view: stuff.view, update: stuff.update, subscriptions: subs});
	});
var _elm_lang$navigation$Navigation$subMap = F2(
	function (func, _p7) {
		var _p8 = _p7;
		return _elm_lang$navigation$Navigation$Monitor(
			function (_p9) {
				return func(
					_p8._0(_p9));
			});
	});
var _elm_lang$navigation$Navigation$InternetExplorer = F2(
	function (a, b) {
		return {ctor: 'InternetExplorer', _0: a, _1: b};
	});
var _elm_lang$navigation$Navigation$Normal = function (a) {
	return {ctor: 'Normal', _0: a};
};
var _elm_lang$navigation$Navigation$spawnPopWatcher = function (router) {
	var reportLocation = function (_p10) {
		return A2(
			_elm_lang$core$Platform$sendToSelf,
			router,
			_elm_lang$navigation$Native_Navigation.getLocation(
				{ctor: '_Tuple0'}));
	};
	return _elm_lang$navigation$Native_Navigation.isInternetExplorer11(
		{ctor: '_Tuple0'}) ? A3(
		_elm_lang$core$Task$map2,
		_elm_lang$navigation$Navigation$InternetExplorer,
		_elm_lang$core$Process$spawn(
			A3(_elm_lang$dom$Dom_LowLevel$onWindow, 'popstate', _elm_lang$core$Json_Decode$value, reportLocation)),
		_elm_lang$core$Process$spawn(
			A3(_elm_lang$dom$Dom_LowLevel$onWindow, 'hashchange', _elm_lang$core$Json_Decode$value, reportLocation))) : A2(
		_elm_lang$core$Task$map,
		_elm_lang$navigation$Navigation$Normal,
		_elm_lang$core$Process$spawn(
			A3(_elm_lang$dom$Dom_LowLevel$onWindow, 'popstate', _elm_lang$core$Json_Decode$value, reportLocation)));
};
var _elm_lang$navigation$Navigation$onEffects = F4(
	function (router, cmds, subs, _p11) {
		var _p12 = _p11;
		var _p15 = _p12.popWatcher;
		var stepState = function () {
			var _p13 = {ctor: '_Tuple2', _0: subs, _1: _p15};
			_v6_2:
			do {
				if (_p13._0.ctor === '[]') {
					if (_p13._1.ctor === 'Just') {
						return A2(
							_elm_lang$navigation$Navigation_ops['&>'],
							_elm_lang$navigation$Navigation$killPopWatcher(_p13._1._0),
							_elm_lang$core$Task$succeed(
								A2(_elm_lang$navigation$Navigation$State, subs, _elm_lang$core$Maybe$Nothing)));
					} else {
						break _v6_2;
					}
				} else {
					if (_p13._1.ctor === 'Nothing') {
						return A2(
							_elm_lang$core$Task$map,
							function (_p14) {
								return A2(
									_elm_lang$navigation$Navigation$State,
									subs,
									_elm_lang$core$Maybe$Just(_p14));
							},
							_elm_lang$navigation$Navigation$spawnPopWatcher(router));
					} else {
						break _v6_2;
					}
				}
			} while(false);
			return _elm_lang$core$Task$succeed(
				A2(_elm_lang$navigation$Navigation$State, subs, _p15));
		}();
		return A2(
			_elm_lang$navigation$Navigation_ops['&>'],
			_elm_lang$core$Task$sequence(
				A2(
					_elm_lang$core$List$map,
					A2(_elm_lang$navigation$Navigation$cmdHelp, router, subs),
					cmds)),
			stepState);
	});
_elm_lang$core$Native_Platform.effectManagers['Navigation'] = {pkg: 'elm-lang/navigation', init: _elm_lang$navigation$Navigation$init, onEffects: _elm_lang$navigation$Navigation$onEffects, onSelfMsg: _elm_lang$navigation$Navigation$onSelfMsg, tag: 'fx', cmdMap: _elm_lang$navigation$Navigation$cmdMap, subMap: _elm_lang$navigation$Navigation$subMap};

var _evancz$url_parser$UrlParser$toKeyValuePair = function (segment) {
	var _p0 = A2(_elm_lang$core$String$split, '=', segment);
	if (((_p0.ctor === '::') && (_p0._1.ctor === '::')) && (_p0._1._1.ctor === '[]')) {
		return A3(
			_elm_lang$core$Maybe$map2,
			F2(
				function (v0, v1) {
					return {ctor: '_Tuple2', _0: v0, _1: v1};
				}),
			_elm_lang$http$Http$decodeUri(_p0._0),
			_elm_lang$http$Http$decodeUri(_p0._1._0));
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _evancz$url_parser$UrlParser$parseParams = function (queryString) {
	return _elm_lang$core$Dict$fromList(
		A2(
			_elm_lang$core$List$filterMap,
			_evancz$url_parser$UrlParser$toKeyValuePair,
			A2(
				_elm_lang$core$String$split,
				'&',
				A2(_elm_lang$core$String$dropLeft, 1, queryString))));
};
var _evancz$url_parser$UrlParser$splitUrl = function (url) {
	var _p1 = A2(_elm_lang$core$String$split, '/', url);
	if ((_p1.ctor === '::') && (_p1._0 === '')) {
		return _p1._1;
	} else {
		return _p1;
	}
};
var _evancz$url_parser$UrlParser$parseHelp = function (states) {
	parseHelp:
	while (true) {
		var _p2 = states;
		if (_p2.ctor === '[]') {
			return _elm_lang$core$Maybe$Nothing;
		} else {
			var _p4 = _p2._0;
			var _p3 = _p4.unvisited;
			if (_p3.ctor === '[]') {
				return _elm_lang$core$Maybe$Just(_p4.value);
			} else {
				if ((_p3._0 === '') && (_p3._1.ctor === '[]')) {
					return _elm_lang$core$Maybe$Just(_p4.value);
				} else {
					var _v4 = _p2._1;
					states = _v4;
					continue parseHelp;
				}
			}
		}
	}
};
var _evancz$url_parser$UrlParser$parse = F3(
	function (_p5, url, params) {
		var _p6 = _p5;
		return _evancz$url_parser$UrlParser$parseHelp(
			_p6._0(
				{
					visited: {ctor: '[]'},
					unvisited: _evancz$url_parser$UrlParser$splitUrl(url),
					params: params,
					value: _elm_lang$core$Basics$identity
				}));
	});
var _evancz$url_parser$UrlParser$parseHash = F2(
	function (parser, location) {
		return A3(
			_evancz$url_parser$UrlParser$parse,
			parser,
			A2(_elm_lang$core$String$dropLeft, 1, location.hash),
			_evancz$url_parser$UrlParser$parseParams(location.search));
	});
var _evancz$url_parser$UrlParser$parsePath = F2(
	function (parser, location) {
		return A3(
			_evancz$url_parser$UrlParser$parse,
			parser,
			location.pathname,
			_evancz$url_parser$UrlParser$parseParams(location.search));
	});
var _evancz$url_parser$UrlParser$intParamHelp = function (maybeValue) {
	var _p7 = maybeValue;
	if (_p7.ctor === 'Nothing') {
		return _elm_lang$core$Maybe$Nothing;
	} else {
		return _elm_lang$core$Result$toMaybe(
			_elm_lang$core$String$toInt(_p7._0));
	}
};
var _evancz$url_parser$UrlParser$mapHelp = F2(
	function (func, _p8) {
		var _p9 = _p8;
		return {
			visited: _p9.visited,
			unvisited: _p9.unvisited,
			params: _p9.params,
			value: func(_p9.value)
		};
	});
var _evancz$url_parser$UrlParser$State = F4(
	function (a, b, c, d) {
		return {visited: a, unvisited: b, params: c, value: d};
	});
var _evancz$url_parser$UrlParser$Parser = function (a) {
	return {ctor: 'Parser', _0: a};
};
var _evancz$url_parser$UrlParser$s = function (str) {
	return _evancz$url_parser$UrlParser$Parser(
		function (_p10) {
			var _p11 = _p10;
			var _p12 = _p11.unvisited;
			if (_p12.ctor === '[]') {
				return {ctor: '[]'};
			} else {
				var _p13 = _p12._0;
				return _elm_lang$core$Native_Utils.eq(_p13, str) ? {
					ctor: '::',
					_0: A4(
						_evancz$url_parser$UrlParser$State,
						{ctor: '::', _0: _p13, _1: _p11.visited},
						_p12._1,
						_p11.params,
						_p11.value),
					_1: {ctor: '[]'}
				} : {ctor: '[]'};
			}
		});
};
var _evancz$url_parser$UrlParser$custom = F2(
	function (tipe, stringToSomething) {
		return _evancz$url_parser$UrlParser$Parser(
			function (_p14) {
				var _p15 = _p14;
				var _p16 = _p15.unvisited;
				if (_p16.ctor === '[]') {
					return {ctor: '[]'};
				} else {
					var _p18 = _p16._0;
					var _p17 = stringToSomething(_p18);
					if (_p17.ctor === 'Ok') {
						return {
							ctor: '::',
							_0: A4(
								_evancz$url_parser$UrlParser$State,
								{ctor: '::', _0: _p18, _1: _p15.visited},
								_p16._1,
								_p15.params,
								_p15.value(_p17._0)),
							_1: {ctor: '[]'}
						};
					} else {
						return {ctor: '[]'};
					}
				}
			});
	});
var _evancz$url_parser$UrlParser$string = A2(_evancz$url_parser$UrlParser$custom, 'STRING', _elm_lang$core$Result$Ok);
var _evancz$url_parser$UrlParser$int = A2(_evancz$url_parser$UrlParser$custom, 'NUMBER', _elm_lang$core$String$toInt);
var _evancz$url_parser$UrlParser_ops = _evancz$url_parser$UrlParser_ops || {};
_evancz$url_parser$UrlParser_ops['</>'] = F2(
	function (_p20, _p19) {
		var _p21 = _p20;
		var _p22 = _p19;
		return _evancz$url_parser$UrlParser$Parser(
			function (state) {
				return A2(
					_elm_lang$core$List$concatMap,
					_p22._0,
					_p21._0(state));
			});
	});
var _evancz$url_parser$UrlParser$map = F2(
	function (subValue, _p23) {
		var _p24 = _p23;
		return _evancz$url_parser$UrlParser$Parser(
			function (_p25) {
				var _p26 = _p25;
				return A2(
					_elm_lang$core$List$map,
					_evancz$url_parser$UrlParser$mapHelp(_p26.value),
					_p24._0(
						{visited: _p26.visited, unvisited: _p26.unvisited, params: _p26.params, value: subValue}));
			});
	});
var _evancz$url_parser$UrlParser$oneOf = function (parsers) {
	return _evancz$url_parser$UrlParser$Parser(
		function (state) {
			return A2(
				_elm_lang$core$List$concatMap,
				function (_p27) {
					var _p28 = _p27;
					return _p28._0(state);
				},
				parsers);
		});
};
var _evancz$url_parser$UrlParser$top = _evancz$url_parser$UrlParser$Parser(
	function (state) {
		return {
			ctor: '::',
			_0: state,
			_1: {ctor: '[]'}
		};
	});
var _evancz$url_parser$UrlParser_ops = _evancz$url_parser$UrlParser_ops || {};
_evancz$url_parser$UrlParser_ops['<?>'] = F2(
	function (_p30, _p29) {
		var _p31 = _p30;
		var _p32 = _p29;
		return _evancz$url_parser$UrlParser$Parser(
			function (state) {
				return A2(
					_elm_lang$core$List$concatMap,
					_p32._0,
					_p31._0(state));
			});
	});
var _evancz$url_parser$UrlParser$QueryParser = function (a) {
	return {ctor: 'QueryParser', _0: a};
};
var _evancz$url_parser$UrlParser$customParam = F2(
	function (key, func) {
		return _evancz$url_parser$UrlParser$QueryParser(
			function (_p33) {
				var _p34 = _p33;
				var _p35 = _p34.params;
				return {
					ctor: '::',
					_0: A4(
						_evancz$url_parser$UrlParser$State,
						_p34.visited,
						_p34.unvisited,
						_p35,
						_p34.value(
							func(
								A2(_elm_lang$core$Dict$get, key, _p35)))),
					_1: {ctor: '[]'}
				};
			});
	});
var _evancz$url_parser$UrlParser$stringParam = function (name) {
	return A2(_evancz$url_parser$UrlParser$customParam, name, _elm_lang$core$Basics$identity);
};
var _evancz$url_parser$UrlParser$intParam = function (name) {
	return A2(_evancz$url_parser$UrlParser$customParam, name, _evancz$url_parser$UrlParser$intParamHelp);
};

var _lukewestby$elm_http_builder$HttpBuilder$replace = F2(
	function (old, $new) {
		return function (_p0) {
			return A2(
				_elm_lang$core$String$join,
				$new,
				A2(_elm_lang$core$String$split, old, _p0));
		};
	});
var _lukewestby$elm_http_builder$HttpBuilder$queryEscape = function (_p1) {
	return A3(
		_lukewestby$elm_http_builder$HttpBuilder$replace,
		'%20',
		'+',
		_elm_lang$http$Http$encodeUri(_p1));
};
var _lukewestby$elm_http_builder$HttpBuilder$queryPair = function (_p2) {
	var _p3 = _p2;
	return A2(
		_elm_lang$core$Basics_ops['++'],
		_lukewestby$elm_http_builder$HttpBuilder$queryEscape(_p3._0),
		A2(
			_elm_lang$core$Basics_ops['++'],
			'=',
			_lukewestby$elm_http_builder$HttpBuilder$queryEscape(_p3._1)));
};
var _lukewestby$elm_http_builder$HttpBuilder$joinUrlEncoded = function (args) {
	return A2(
		_elm_lang$core$String$join,
		'&',
		A2(_elm_lang$core$List$map, _lukewestby$elm_http_builder$HttpBuilder$queryPair, args));
};
var _lukewestby$elm_http_builder$HttpBuilder$toRequest = function (builder) {
	var encodedParams = _lukewestby$elm_http_builder$HttpBuilder$joinUrlEncoded(builder.queryParams);
	var fullUrl = _elm_lang$core$String$isEmpty(encodedParams) ? builder.url : A2(
		_elm_lang$core$Basics_ops['++'],
		builder.url,
		A2(_elm_lang$core$Basics_ops['++'], '?', encodedParams));
	return _elm_lang$http$Http$request(
		{method: builder.method, url: fullUrl, headers: builder.headers, body: builder.body, expect: builder.expect, timeout: builder.timeout, withCredentials: builder.withCredentials});
};
var _lukewestby$elm_http_builder$HttpBuilder$toTaskPlain = function (builder) {
	return _elm_lang$http$Http$toTask(
		_lukewestby$elm_http_builder$HttpBuilder$toRequest(builder));
};
var _lukewestby$elm_http_builder$HttpBuilder$withCacheBuster = F2(
	function (paramName, builder) {
		return _elm_lang$core$Native_Utils.update(
			builder,
			{
				cacheBuster: _elm_lang$core$Maybe$Just(paramName)
			});
	});
var _lukewestby$elm_http_builder$HttpBuilder$withQueryParams = F2(
	function (queryParams, builder) {
		return _elm_lang$core$Native_Utils.update(
			builder,
			{
				queryParams: A2(_elm_lang$core$Basics_ops['++'], builder.queryParams, queryParams)
			});
	});
var _lukewestby$elm_http_builder$HttpBuilder$toTaskWithCacheBuster = F2(
	function (paramName, builder) {
		var request = function (timestamp) {
			return _lukewestby$elm_http_builder$HttpBuilder$toTaskPlain(
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withQueryParams,
					{
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: paramName,
							_1: _elm_lang$core$Basics$toString(timestamp)
						},
						_1: {ctor: '[]'}
					},
					builder));
		};
		return A2(_elm_lang$core$Task$andThen, request, _elm_lang$core$Time$now);
	});
var _lukewestby$elm_http_builder$HttpBuilder$toTask = function (builder) {
	var _p4 = builder.cacheBuster;
	if (_p4.ctor === 'Just') {
		return A2(_lukewestby$elm_http_builder$HttpBuilder$toTaskWithCacheBuster, _p4._0, builder);
	} else {
		return _lukewestby$elm_http_builder$HttpBuilder$toTaskPlain(builder);
	}
};
var _lukewestby$elm_http_builder$HttpBuilder$send = F2(
	function (tagger, builder) {
		return A2(
			_elm_lang$core$Task$attempt,
			tagger,
			_lukewestby$elm_http_builder$HttpBuilder$toTask(builder));
	});
var _lukewestby$elm_http_builder$HttpBuilder$withExpectString = function (builder) {
	return _elm_lang$core$Native_Utils.update(
		builder,
		{expect: _elm_lang$http$Http$expectString});
};
var _lukewestby$elm_http_builder$HttpBuilder$withExpectJson = F2(
	function (decoder, builder) {
		return _elm_lang$core$Native_Utils.update(
			builder,
			{
				expect: _elm_lang$http$Http$expectJson(decoder)
			});
	});
var _lukewestby$elm_http_builder$HttpBuilder$withExpect = F2(
	function (expect, builder) {
		return _elm_lang$core$Native_Utils.update(
			builder,
			{expect: expect});
	});
var _lukewestby$elm_http_builder$HttpBuilder$withCredentials = function (builder) {
	return _elm_lang$core$Native_Utils.update(
		builder,
		{withCredentials: true});
};
var _lukewestby$elm_http_builder$HttpBuilder$withTimeout = F2(
	function (timeout, builder) {
		return _elm_lang$core$Native_Utils.update(
			builder,
			{
				timeout: _elm_lang$core$Maybe$Just(timeout)
			});
	});
var _lukewestby$elm_http_builder$HttpBuilder$withBody = F2(
	function (body, builder) {
		return _elm_lang$core$Native_Utils.update(
			builder,
			{body: body});
	});
var _lukewestby$elm_http_builder$HttpBuilder$withStringBody = F2(
	function (contentType, value) {
		return _lukewestby$elm_http_builder$HttpBuilder$withBody(
			A2(_elm_lang$http$Http$stringBody, contentType, value));
	});
var _lukewestby$elm_http_builder$HttpBuilder$withUrlEncodedBody = function (_p5) {
	return A2(
		_lukewestby$elm_http_builder$HttpBuilder$withStringBody,
		'application/x-www-form-urlencoded',
		_lukewestby$elm_http_builder$HttpBuilder$joinUrlEncoded(_p5));
};
var _lukewestby$elm_http_builder$HttpBuilder$withJsonBody = function (value) {
	return _lukewestby$elm_http_builder$HttpBuilder$withBody(
		_elm_lang$http$Http$jsonBody(value));
};
var _lukewestby$elm_http_builder$HttpBuilder$withMultipartStringBody = function (partPairs) {
	return _lukewestby$elm_http_builder$HttpBuilder$withBody(
		_elm_lang$http$Http$multipartBody(
			A2(
				_elm_lang$core$List$map,
				_elm_lang$core$Basics$uncurry(_elm_lang$http$Http$stringPart),
				partPairs)));
};
var _lukewestby$elm_http_builder$HttpBuilder$withBearerToken = F2(
	function (value, builder) {
		return _elm_lang$core$Native_Utils.update(
			builder,
			{
				headers: {
					ctor: '::',
					_0: A2(
						_elm_lang$http$Http$header,
						'Authorization',
						A2(_elm_lang$core$Basics_ops['++'], 'Bearer ', value)),
					_1: builder.headers
				}
			});
	});
var _lukewestby$elm_http_builder$HttpBuilder$withHeaders = F2(
	function (headerPairs, builder) {
		return _elm_lang$core$Native_Utils.update(
			builder,
			{
				headers: A2(
					_elm_lang$core$Basics_ops['++'],
					A2(
						_elm_lang$core$List$map,
						_elm_lang$core$Basics$uncurry(_elm_lang$http$Http$header),
						headerPairs),
					builder.headers)
			});
	});
var _lukewestby$elm_http_builder$HttpBuilder$withHeader = F3(
	function (key, value, builder) {
		return _elm_lang$core$Native_Utils.update(
			builder,
			{
				headers: {
					ctor: '::',
					_0: A2(_elm_lang$http$Http$header, key, value),
					_1: builder.headers
				}
			});
	});
var _lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl = F2(
	function (method, url) {
		return {
			method: method,
			url: url,
			headers: {ctor: '[]'},
			body: _elm_lang$http$Http$emptyBody,
			expect: _elm_lang$http$Http$expectStringResponse(
				function (_p6) {
					return _elm_lang$core$Result$Ok(
						{ctor: '_Tuple0'});
				}),
			timeout: _elm_lang$core$Maybe$Nothing,
			withCredentials: false,
			queryParams: {ctor: '[]'},
			cacheBuster: _elm_lang$core$Maybe$Nothing
		};
	});
var _lukewestby$elm_http_builder$HttpBuilder$get = _lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl('GET');
var _lukewestby$elm_http_builder$HttpBuilder$post = _lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl('POST');
var _lukewestby$elm_http_builder$HttpBuilder$put = _lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl('PUT');
var _lukewestby$elm_http_builder$HttpBuilder$patch = _lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl('PATCH');
var _lukewestby$elm_http_builder$HttpBuilder$delete = _lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl('DELETE');
var _lukewestby$elm_http_builder$HttpBuilder$options = _lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl('OPTIONS');
var _lukewestby$elm_http_builder$HttpBuilder$trace = _lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl('TRACE');
var _lukewestby$elm_http_builder$HttpBuilder$head = _lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl('HEAD');
var _lukewestby$elm_http_builder$HttpBuilder$RequestBuilder = F9(
	function (a, b, c, d, e, f, g, h, i) {
		return {method: a, headers: b, url: c, body: d, expect: e, timeout: f, withCredentials: g, queryParams: h, cacheBuster: i};
	});

var _rluiten$elm_date_extra$Date_Extra_Internal2$prevMonth = function (month) {
	var _p0 = month;
	switch (_p0.ctor) {
		case 'Jan':
			return _elm_lang$core$Date$Dec;
		case 'Feb':
			return _elm_lang$core$Date$Jan;
		case 'Mar':
			return _elm_lang$core$Date$Feb;
		case 'Apr':
			return _elm_lang$core$Date$Mar;
		case 'May':
			return _elm_lang$core$Date$Apr;
		case 'Jun':
			return _elm_lang$core$Date$May;
		case 'Jul':
			return _elm_lang$core$Date$Jun;
		case 'Aug':
			return _elm_lang$core$Date$Jul;
		case 'Sep':
			return _elm_lang$core$Date$Aug;
		case 'Oct':
			return _elm_lang$core$Date$Sep;
		case 'Nov':
			return _elm_lang$core$Date$Oct;
		default:
			return _elm_lang$core$Date$Nov;
	}
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$nextMonth = function (month) {
	var _p1 = month;
	switch (_p1.ctor) {
		case 'Jan':
			return _elm_lang$core$Date$Feb;
		case 'Feb':
			return _elm_lang$core$Date$Mar;
		case 'Mar':
			return _elm_lang$core$Date$Apr;
		case 'Apr':
			return _elm_lang$core$Date$May;
		case 'May':
			return _elm_lang$core$Date$Jun;
		case 'Jun':
			return _elm_lang$core$Date$Jul;
		case 'Jul':
			return _elm_lang$core$Date$Aug;
		case 'Aug':
			return _elm_lang$core$Date$Sep;
		case 'Sep':
			return _elm_lang$core$Date$Oct;
		case 'Oct':
			return _elm_lang$core$Date$Nov;
		case 'Nov':
			return _elm_lang$core$Date$Dec;
		default:
			return _elm_lang$core$Date$Jan;
	}
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$intToMonth = function (month) {
	return (_elm_lang$core$Native_Utils.cmp(month, 1) < 1) ? _elm_lang$core$Date$Jan : (_elm_lang$core$Native_Utils.eq(month, 2) ? _elm_lang$core$Date$Feb : (_elm_lang$core$Native_Utils.eq(month, 3) ? _elm_lang$core$Date$Mar : (_elm_lang$core$Native_Utils.eq(month, 4) ? _elm_lang$core$Date$Apr : (_elm_lang$core$Native_Utils.eq(month, 5) ? _elm_lang$core$Date$May : (_elm_lang$core$Native_Utils.eq(month, 6) ? _elm_lang$core$Date$Jun : (_elm_lang$core$Native_Utils.eq(month, 7) ? _elm_lang$core$Date$Jul : (_elm_lang$core$Native_Utils.eq(month, 8) ? _elm_lang$core$Date$Aug : (_elm_lang$core$Native_Utils.eq(month, 9) ? _elm_lang$core$Date$Sep : (_elm_lang$core$Native_Utils.eq(month, 10) ? _elm_lang$core$Date$Oct : (_elm_lang$core$Native_Utils.eq(month, 11) ? _elm_lang$core$Date$Nov : _elm_lang$core$Date$Dec))))))))));
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$monthToInt = function (month) {
	var _p2 = month;
	switch (_p2.ctor) {
		case 'Jan':
			return 1;
		case 'Feb':
			return 2;
		case 'Mar':
			return 3;
		case 'Apr':
			return 4;
		case 'May':
			return 5;
		case 'Jun':
			return 6;
		case 'Jul':
			return 7;
		case 'Aug':
			return 8;
		case 'Sep':
			return 9;
		case 'Oct':
			return 10;
		case 'Nov':
			return 11;
		default:
			return 12;
	}
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$isLeapYear = function (year) {
	return (_elm_lang$core$Native_Utils.eq(
		A2(_elm_lang$core$Basics_ops['%'], year, 4),
		0) && (!_elm_lang$core$Native_Utils.eq(
		A2(_elm_lang$core$Basics_ops['%'], year, 100),
		0))) || _elm_lang$core$Native_Utils.eq(
		A2(_elm_lang$core$Basics_ops['%'], year, 400),
		0);
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$isLeapYearDate = function (date) {
	return _rluiten$elm_date_extra$Date_Extra_Internal2$isLeapYear(
		_elm_lang$core$Date$year(date));
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$yearToDayLength = function (year) {
	return _rluiten$elm_date_extra$Date_Extra_Internal2$isLeapYear(year) ? 366 : 365;
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$daysInMonth = F2(
	function (year, month) {
		var _p3 = month;
		switch (_p3.ctor) {
			case 'Jan':
				return 31;
			case 'Feb':
				return _rluiten$elm_date_extra$Date_Extra_Internal2$isLeapYear(year) ? 29 : 28;
			case 'Mar':
				return 31;
			case 'Apr':
				return 30;
			case 'May':
				return 31;
			case 'Jun':
				return 30;
			case 'Jul':
				return 31;
			case 'Aug':
				return 31;
			case 'Sep':
				return 30;
			case 'Oct':
				return 31;
			case 'Nov':
				return 30;
			default:
				return 31;
		}
	});
var _rluiten$elm_date_extra$Date_Extra_Internal2$daysInMonthDate = function (date) {
	return A2(
		_rluiten$elm_date_extra$Date_Extra_Internal2$daysInMonth,
		_elm_lang$core$Date$year(date),
		_elm_lang$core$Date$month(date));
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$monthList = {
	ctor: '::',
	_0: _elm_lang$core$Date$Jan,
	_1: {
		ctor: '::',
		_0: _elm_lang$core$Date$Feb,
		_1: {
			ctor: '::',
			_0: _elm_lang$core$Date$Mar,
			_1: {
				ctor: '::',
				_0: _elm_lang$core$Date$Apr,
				_1: {
					ctor: '::',
					_0: _elm_lang$core$Date$May,
					_1: {
						ctor: '::',
						_0: _elm_lang$core$Date$Jun,
						_1: {
							ctor: '::',
							_0: _elm_lang$core$Date$Jul,
							_1: {
								ctor: '::',
								_0: _elm_lang$core$Date$Aug,
								_1: {
									ctor: '::',
									_0: _elm_lang$core$Date$Sep,
									_1: {
										ctor: '::',
										_0: _elm_lang$core$Date$Oct,
										_1: {
											ctor: '::',
											_0: _elm_lang$core$Date$Nov,
											_1: {
												ctor: '::',
												_0: _elm_lang$core$Date$Dec,
												_1: {ctor: '[]'}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$toTime = function (_p4) {
	return _elm_lang$core$Basics$floor(
		_elm_lang$core$Date$toTime(_p4));
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$fromTime = function (_p5) {
	return _elm_lang$core$Date$fromTime(
		_elm_lang$core$Basics$toFloat(_p5));
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$prevDay = function (day) {
	var _p6 = day;
	switch (_p6.ctor) {
		case 'Mon':
			return _elm_lang$core$Date$Sun;
		case 'Tue':
			return _elm_lang$core$Date$Mon;
		case 'Wed':
			return _elm_lang$core$Date$Tue;
		case 'Thu':
			return _elm_lang$core$Date$Wed;
		case 'Fri':
			return _elm_lang$core$Date$Thu;
		case 'Sat':
			return _elm_lang$core$Date$Fri;
		default:
			return _elm_lang$core$Date$Sat;
	}
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$nextDay = function (day) {
	var _p7 = day;
	switch (_p7.ctor) {
		case 'Mon':
			return _elm_lang$core$Date$Tue;
		case 'Tue':
			return _elm_lang$core$Date$Wed;
		case 'Wed':
			return _elm_lang$core$Date$Thu;
		case 'Thu':
			return _elm_lang$core$Date$Fri;
		case 'Fri':
			return _elm_lang$core$Date$Sat;
		case 'Sat':
			return _elm_lang$core$Date$Sun;
		default:
			return _elm_lang$core$Date$Mon;
	}
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$isoDayOfWeek = function (day) {
	var _p8 = day;
	switch (_p8.ctor) {
		case 'Mon':
			return 1;
		case 'Tue':
			return 2;
		case 'Wed':
			return 3;
		case 'Thu':
			return 4;
		case 'Fri':
			return 5;
		case 'Sat':
			return 6;
		default:
			return 7;
	}
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMillisecond = _elm_lang$core$Basics$floor(_elm_lang$core$Time$millisecond);
var _rluiten$elm_date_extra$Date_Extra_Internal2$ticksASecond = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMillisecond * 1000;
var _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMinute = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksASecond * 60;
var _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAnHour = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMinute * 60;
var _rluiten$elm_date_extra$Date_Extra_Internal2$ticksADay = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAnHour * 24;
var _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAWeek = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksADay * 7;
var _rluiten$elm_date_extra$Date_Extra_Internal2$lastOfMonthTicks = function (date) {
	var dateTicks = _rluiten$elm_date_extra$Date_Extra_Internal2$toTime(date);
	var day = _elm_lang$core$Date$day(date);
	var month = _elm_lang$core$Date$month(date);
	var year = _elm_lang$core$Date$year(date);
	var daysInMonthVal = A2(_rluiten$elm_date_extra$Date_Extra_Internal2$daysInMonth, year, month);
	var addDays = daysInMonthVal - day;
	return dateTicks + (addDays * _rluiten$elm_date_extra$Date_Extra_Internal2$ticksADay);
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$firstOfNextMonthDate = function (date) {
	return _rluiten$elm_date_extra$Date_Extra_Internal2$fromTime(
		_rluiten$elm_date_extra$Date_Extra_Internal2$lastOfMonthTicks(date) + _rluiten$elm_date_extra$Date_Extra_Internal2$ticksADay);
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$daysInNextMonth = function (date) {
	return _rluiten$elm_date_extra$Date_Extra_Internal2$daysInMonthDate(
		_rluiten$elm_date_extra$Date_Extra_Internal2$firstOfNextMonthDate(date));
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$firstOfMonthTicks = function (date) {
	var dateTicks = _rluiten$elm_date_extra$Date_Extra_Internal2$toTime(date);
	var day = _elm_lang$core$Date$day(date);
	return dateTicks + ((1 - day) * _rluiten$elm_date_extra$Date_Extra_Internal2$ticksADay);
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$lastOfPrevMonthDate = function (date) {
	return _rluiten$elm_date_extra$Date_Extra_Internal2$fromTime(
		_rluiten$elm_date_extra$Date_Extra_Internal2$firstOfMonthTicks(date) - _rluiten$elm_date_extra$Date_Extra_Internal2$ticksADay);
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$daysInPrevMonth = function (date) {
	return _rluiten$elm_date_extra$Date_Extra_Internal2$daysInMonthDate(
		_rluiten$elm_date_extra$Date_Extra_Internal2$lastOfPrevMonthDate(date));
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$epochDateStr = '1970-01-01T00:00:00Z';

var _rluiten$elm_date_extra$Date_Extra_Period$diff = F2(
	function (date1, date2) {
		var millisecondDiff = _elm_lang$core$Date$millisecond(date1) - _elm_lang$core$Date$millisecond(date2);
		var secondDiff = _elm_lang$core$Date$second(date1) - _elm_lang$core$Date$second(date2);
		var minuteDiff = _elm_lang$core$Date$minute(date1) - _elm_lang$core$Date$minute(date2);
		var hourDiff = _elm_lang$core$Date$hour(date1) - _elm_lang$core$Date$hour(date2);
		var ticksDiff = _rluiten$elm_date_extra$Date_Extra_Internal2$toTime(date1) - _rluiten$elm_date_extra$Date_Extra_Internal2$toTime(date2);
		var ticksDayDiff = (((ticksDiff - (hourDiff * _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAnHour)) - (minuteDiff * _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMinute)) - (secondDiff * _rluiten$elm_date_extra$Date_Extra_Internal2$ticksASecond)) - (millisecondDiff * _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMillisecond);
		var onlyDaysDiff = (ticksDayDiff / _rluiten$elm_date_extra$Date_Extra_Internal2$ticksADay) | 0;
		var _p0 = function () {
			if (_elm_lang$core$Native_Utils.cmp(onlyDaysDiff, 0) < 0) {
				var absDayDiff = _elm_lang$core$Basics$abs(onlyDaysDiff);
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Basics$negate((absDayDiff / 7) | 0),
					_1: _elm_lang$core$Basics$negate(
						A2(_elm_lang$core$Basics_ops['%'], absDayDiff, 7))
				};
			} else {
				return {
					ctor: '_Tuple2',
					_0: (onlyDaysDiff / 7) | 0,
					_1: A2(_elm_lang$core$Basics_ops['%'], onlyDaysDiff, 7)
				};
			}
		}();
		var weekDiff = _p0._0;
		var dayDiff = _p0._1;
		return {week: weekDiff, day: dayDiff, hour: hourDiff, minute: minuteDiff, second: secondDiff, millisecond: millisecondDiff};
	});
var _rluiten$elm_date_extra$Date_Extra_Period$addTimeUnit = F3(
	function (unit, addend, date) {
		return _rluiten$elm_date_extra$Date_Extra_Internal2$fromTime(
			A2(
				F2(
					function (x, y) {
						return x + y;
					}),
				addend * unit,
				_rluiten$elm_date_extra$Date_Extra_Internal2$toTime(date)));
	});
var _rluiten$elm_date_extra$Date_Extra_Period$toTicks = function (period) {
	var _p1 = period;
	switch (_p1.ctor) {
		case 'Millisecond':
			return _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMillisecond;
		case 'Second':
			return _rluiten$elm_date_extra$Date_Extra_Internal2$ticksASecond;
		case 'Minute':
			return _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMinute;
		case 'Hour':
			return _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAnHour;
		case 'Day':
			return _rluiten$elm_date_extra$Date_Extra_Internal2$ticksADay;
		case 'Week':
			return _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAWeek;
		default:
			var _p2 = _p1._0;
			return (((((_rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMillisecond * _p2.millisecond) + (_rluiten$elm_date_extra$Date_Extra_Internal2$ticksASecond * _p2.second)) + (_rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMinute * _p2.minute)) + (_rluiten$elm_date_extra$Date_Extra_Internal2$ticksAnHour * _p2.hour)) + (_rluiten$elm_date_extra$Date_Extra_Internal2$ticksADay * _p2.day)) + (_rluiten$elm_date_extra$Date_Extra_Internal2$ticksAWeek * _p2.week);
	}
};
var _rluiten$elm_date_extra$Date_Extra_Period$add = function (period) {
	return _rluiten$elm_date_extra$Date_Extra_Period$addTimeUnit(
		_rluiten$elm_date_extra$Date_Extra_Period$toTicks(period));
};
var _rluiten$elm_date_extra$Date_Extra_Period$zeroDelta = {week: 0, day: 0, hour: 0, minute: 0, second: 0, millisecond: 0};
var _rluiten$elm_date_extra$Date_Extra_Period$DeltaRecord = F6(
	function (a, b, c, d, e, f) {
		return {week: a, day: b, hour: c, minute: d, second: e, millisecond: f};
	});
var _rluiten$elm_date_extra$Date_Extra_Period$Delta = function (a) {
	return {ctor: 'Delta', _0: a};
};
var _rluiten$elm_date_extra$Date_Extra_Period$Week = {ctor: 'Week'};
var _rluiten$elm_date_extra$Date_Extra_Period$Day = {ctor: 'Day'};
var _rluiten$elm_date_extra$Date_Extra_Period$Hour = {ctor: 'Hour'};
var _rluiten$elm_date_extra$Date_Extra_Period$Minute = {ctor: 'Minute'};
var _rluiten$elm_date_extra$Date_Extra_Period$Second = {ctor: 'Second'};
var _rluiten$elm_date_extra$Date_Extra_Period$Millisecond = {ctor: 'Millisecond'};

var _rluiten$elm_date_extra$Date_Extra_TypeAlias$TimeFromFields = F4(
	function (a, b, c, d) {
		return {hour: a, minute: b, second: c, millisecond: d};
	});
var _rluiten$elm_date_extra$Date_Extra_TypeAlias$DateFromFields = F7(
	function (a, b, c, d, e, f, g) {
		return {year: a, month: b, day: c, hour: d, minute: e, second: f, millisecond: g};
	});

var _rluiten$elm_date_extra$Date_Extra_Internal$daysFromCivil = F3(
	function (year, month, day) {
		var doy = (((((153 * (month + ((_elm_lang$core$Native_Utils.cmp(month, 2) > 0) ? -3 : 9))) + 2) / 5) | 0) + day) - 1;
		var y = year - ((_elm_lang$core$Native_Utils.cmp(month, 2) < 1) ? 1 : 0);
		var era = (((_elm_lang$core$Native_Utils.cmp(y, 0) > -1) ? y : (y - 399)) / 400) | 0;
		var yoe = y - (era * 400);
		var doe = (((yoe * 365) + ((yoe / 4) | 0)) - ((yoe / 100) | 0)) + doy;
		return ((era * 146097) + doe) - 719468;
	});
var _rluiten$elm_date_extra$Date_Extra_Internal$ticksFromFields = F7(
	function (year, month, day, hour, minute, second, millisecond) {
		var monthInt = _rluiten$elm_date_extra$Date_Extra_Internal2$monthToInt(month);
		var clampYear = (_elm_lang$core$Native_Utils.cmp(year, 0) < 0) ? 0 : year;
		var clampDay = A3(
			_elm_lang$core$Basics$clamp,
			1,
			A2(_rluiten$elm_date_extra$Date_Extra_Internal2$daysInMonth, clampYear, month),
			day);
		var dayCount = A3(_rluiten$elm_date_extra$Date_Extra_Internal$daysFromCivil, clampYear, monthInt, clampDay);
		return _rluiten$elm_date_extra$Date_Extra_Period$toTicks(
			_rluiten$elm_date_extra$Date_Extra_Period$Delta(
				{
					millisecond: A3(_elm_lang$core$Basics$clamp, 0, 999, millisecond),
					second: A3(_elm_lang$core$Basics$clamp, 0, 59, second),
					minute: A3(_elm_lang$core$Basics$clamp, 0, 59, minute),
					hour: A3(_elm_lang$core$Basics$clamp, 0, 23, hour),
					day: dayCount,
					week: 0
				}));
	});
var _rluiten$elm_date_extra$Date_Extra_Internal$ticksFromDateFields = function (date) {
	return A7(
		_rluiten$elm_date_extra$Date_Extra_Internal$ticksFromFields,
		_elm_lang$core$Date$year(date),
		_elm_lang$core$Date$month(date),
		_elm_lang$core$Date$day(date),
		_elm_lang$core$Date$hour(date),
		_elm_lang$core$Date$minute(date),
		_elm_lang$core$Date$second(date),
		_elm_lang$core$Date$millisecond(date));
};
var _rluiten$elm_date_extra$Date_Extra_Internal$getTimezoneOffset = function (date) {
	var v1Ticks = _rluiten$elm_date_extra$Date_Extra_Internal$ticksFromDateFields(date);
	var dateTicks = _elm_lang$core$Basics$floor(
		_elm_lang$core$Date$toTime(date));
	return ((dateTicks - v1Ticks) / _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMinute) | 0;
};
var _rluiten$elm_date_extra$Date_Extra_Internal$ticksFromFieldsRecord = function (_p0) {
	var _p1 = _p0;
	return A7(_rluiten$elm_date_extra$Date_Extra_Internal$ticksFromFields, _p1.year, _p1.month, _p1.day, _p1.hour, _p1.minute, _p1.second, _p1.millisecond);
};
var _rluiten$elm_date_extra$Date_Extra_Internal$hackDateAsOffset = F2(
	function (offsetMinutes, date) {
		return _rluiten$elm_date_extra$Date_Extra_Internal2$fromTime(
			A2(
				F2(
					function (x, y) {
						return x + y;
					}),
				offsetMinutes * _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMinute,
				_rluiten$elm_date_extra$Date_Extra_Internal2$toTime(date)));
	});
var _rluiten$elm_date_extra$Date_Extra_Internal$hackDateAsUtc = function (date) {
	var offset = _rluiten$elm_date_extra$Date_Extra_Internal$getTimezoneOffset(date);
	var oHours = (offset / _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAnHour) | 0;
	var oMinutes = ((offset - (oHours * _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAnHour)) / _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMinute) | 0;
	return A2(_rluiten$elm_date_extra$Date_Extra_Internal$hackDateAsOffset, offset, date);
};

var _rluiten$elm_date_extra$Date_Extra_Core$compensateZoneOffset = F2(
	function (date1, date2) {
		return A3(
			_rluiten$elm_date_extra$Date_Extra_Period$add,
			_rluiten$elm_date_extra$Date_Extra_Period$Minute,
			_rluiten$elm_date_extra$Date_Extra_Internal$getTimezoneOffset(date2) - _rluiten$elm_date_extra$Date_Extra_Internal$getTimezoneOffset(date1),
			date2);
	});
var _rluiten$elm_date_extra$Date_Extra_Core$lastOfMonthDate = function (date) {
	return A2(
		_rluiten$elm_date_extra$Date_Extra_Core$compensateZoneOffset,
		date,
		_rluiten$elm_date_extra$Date_Extra_Internal2$fromTime(
			_rluiten$elm_date_extra$Date_Extra_Internal2$lastOfMonthTicks(date)));
};
var _rluiten$elm_date_extra$Date_Extra_Core$toFirstOfMonth = function (date) {
	return A2(
		_rluiten$elm_date_extra$Date_Extra_Core$compensateZoneOffset,
		date,
		_rluiten$elm_date_extra$Date_Extra_Internal2$fromTime(
			_rluiten$elm_date_extra$Date_Extra_Internal2$firstOfMonthTicks(date)));
};
var _rluiten$elm_date_extra$Date_Extra_Core$lastOfPrevMonthDate = function (date) {
	return A2(
		_rluiten$elm_date_extra$Date_Extra_Core$compensateZoneOffset,
		date,
		_rluiten$elm_date_extra$Date_Extra_Internal2$lastOfPrevMonthDate(date));
};
var _rluiten$elm_date_extra$Date_Extra_Core$firstOfNextMonthDate = function (date) {
	return A2(
		_rluiten$elm_date_extra$Date_Extra_Core$compensateZoneOffset,
		date,
		_rluiten$elm_date_extra$Date_Extra_Internal2$firstOfNextMonthDate(date));
};
var _rluiten$elm_date_extra$Date_Extra_Core$yearToDayLength = _rluiten$elm_date_extra$Date_Extra_Internal2$yearToDayLength;
var _rluiten$elm_date_extra$Date_Extra_Core$toTime = _rluiten$elm_date_extra$Date_Extra_Internal2$toTime;
var _rluiten$elm_date_extra$Date_Extra_Core$ticksAWeek = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAWeek;
var _rluiten$elm_date_extra$Date_Extra_Core$ticksASecond = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksASecond;
var _rluiten$elm_date_extra$Date_Extra_Core$ticksAMinute = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMinute;
var _rluiten$elm_date_extra$Date_Extra_Core$ticksAMillisecond = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMillisecond;
var _rluiten$elm_date_extra$Date_Extra_Core$ticksADay = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksADay;
var _rluiten$elm_date_extra$Date_Extra_Core$ticksAnHour = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAnHour;
var _rluiten$elm_date_extra$Date_Extra_Core$prevMonth = _rluiten$elm_date_extra$Date_Extra_Internal2$prevMonth;
var _rluiten$elm_date_extra$Date_Extra_Core$prevDay = _rluiten$elm_date_extra$Date_Extra_Internal2$prevDay;
var _rluiten$elm_date_extra$Date_Extra_Core$nextMonth = _rluiten$elm_date_extra$Date_Extra_Internal2$nextMonth;
var _rluiten$elm_date_extra$Date_Extra_Core$nextDay = _rluiten$elm_date_extra$Date_Extra_Internal2$nextDay;
var _rluiten$elm_date_extra$Date_Extra_Core$monthToInt = _rluiten$elm_date_extra$Date_Extra_Internal2$monthToInt;
var _rluiten$elm_date_extra$Date_Extra_Core$monthList = _rluiten$elm_date_extra$Date_Extra_Internal2$monthList;
var _rluiten$elm_date_extra$Date_Extra_Core$isoDayOfWeek = _rluiten$elm_date_extra$Date_Extra_Internal2$isoDayOfWeek;
var _rluiten$elm_date_extra$Date_Extra_Core$daysBackToStartOfWeek = F2(
	function (dateDay, startOfWeekDay) {
		var startOfWeekDayIndex = _rluiten$elm_date_extra$Date_Extra_Core$isoDayOfWeek(startOfWeekDay);
		var dateDayIndex = _rluiten$elm_date_extra$Date_Extra_Core$isoDayOfWeek(dateDay);
		return (_elm_lang$core$Native_Utils.cmp(dateDayIndex, startOfWeekDayIndex) < 0) ? ((7 + dateDayIndex) - startOfWeekDayIndex) : (dateDayIndex - startOfWeekDayIndex);
	});
var _rluiten$elm_date_extra$Date_Extra_Core$isLeapYearDate = _rluiten$elm_date_extra$Date_Extra_Internal2$isLeapYearDate;
var _rluiten$elm_date_extra$Date_Extra_Core$isLeapYear = _rluiten$elm_date_extra$Date_Extra_Internal2$isLeapYear;
var _rluiten$elm_date_extra$Date_Extra_Core$intToMonth = _rluiten$elm_date_extra$Date_Extra_Internal2$intToMonth;
var _rluiten$elm_date_extra$Date_Extra_Core$fromTime = _rluiten$elm_date_extra$Date_Extra_Internal2$fromTime;
var _rluiten$elm_date_extra$Date_Extra_Core$epochDateStr = _rluiten$elm_date_extra$Date_Extra_Internal2$epochDateStr;
var _rluiten$elm_date_extra$Date_Extra_Core$daysInMonthDate = _rluiten$elm_date_extra$Date_Extra_Internal2$daysInMonthDate;
var _rluiten$elm_date_extra$Date_Extra_Core$daysInPrevMonth = _rluiten$elm_date_extra$Date_Extra_Internal2$daysInPrevMonth;
var _rluiten$elm_date_extra$Date_Extra_Core$daysInNextMonth = _rluiten$elm_date_extra$Date_Extra_Internal2$daysInNextMonth;
var _rluiten$elm_date_extra$Date_Extra_Core$daysInMonth = _rluiten$elm_date_extra$Date_Extra_Internal2$daysInMonth;

var _rluiten$elm_date_extra$Date_Extra_Compare$is3 = F4(
	function (comp, date1, date2, date3) {
		var time3 = _rluiten$elm_date_extra$Date_Extra_Core$toTime(date3);
		var time2 = _rluiten$elm_date_extra$Date_Extra_Core$toTime(date2);
		var highBound = A2(_elm_lang$core$Basics$max, time2, time3);
		var lowBound = A2(_elm_lang$core$Basics$min, time2, time3);
		var time1 = _rluiten$elm_date_extra$Date_Extra_Core$toTime(date1);
		var _p0 = comp;
		switch (_p0.ctor) {
			case 'Between':
				return (_elm_lang$core$Native_Utils.cmp(time1, lowBound) > 0) && (_elm_lang$core$Native_Utils.cmp(time1, highBound) < 0);
			case 'BetweenOpenStart':
				return (_elm_lang$core$Native_Utils.cmp(time1, lowBound) > -1) && (_elm_lang$core$Native_Utils.cmp(time1, highBound) < 0);
			case 'BetweenOpenEnd':
				return (_elm_lang$core$Native_Utils.cmp(time1, lowBound) > 0) && (_elm_lang$core$Native_Utils.cmp(time1, highBound) < 1);
			default:
				return (_elm_lang$core$Native_Utils.cmp(time1, lowBound) > -1) && (_elm_lang$core$Native_Utils.cmp(time1, highBound) < 1);
		}
	});
var _rluiten$elm_date_extra$Date_Extra_Compare$is = F3(
	function (comp, date1, date2) {
		var time2 = _rluiten$elm_date_extra$Date_Extra_Core$toTime(date2);
		var time1 = _rluiten$elm_date_extra$Date_Extra_Core$toTime(date1);
		var _p1 = comp;
		switch (_p1.ctor) {
			case 'Before':
				return _elm_lang$core$Native_Utils.cmp(time1, time2) < 0;
			case 'After':
				return _elm_lang$core$Native_Utils.cmp(time1, time2) > 0;
			case 'Same':
				return _elm_lang$core$Native_Utils.eq(time1, time2);
			case 'SameOrBefore':
				return _elm_lang$core$Native_Utils.cmp(time1, time2) < 1;
			default:
				return _elm_lang$core$Native_Utils.cmp(time1, time2) > -1;
		}
	});
var _rluiten$elm_date_extra$Date_Extra_Compare$SameOrBefore = {ctor: 'SameOrBefore'};
var _rluiten$elm_date_extra$Date_Extra_Compare$SameOrAfter = {ctor: 'SameOrAfter'};
var _rluiten$elm_date_extra$Date_Extra_Compare$Same = {ctor: 'Same'};
var _rluiten$elm_date_extra$Date_Extra_Compare$Before = {ctor: 'Before'};
var _rluiten$elm_date_extra$Date_Extra_Compare$After = {ctor: 'After'};
var _rluiten$elm_date_extra$Date_Extra_Compare$BetweenOpen = {ctor: 'BetweenOpen'};
var _rluiten$elm_date_extra$Date_Extra_Compare$BetweenOpenEnd = {ctor: 'BetweenOpenEnd'};
var _rluiten$elm_date_extra$Date_Extra_Compare$BetweenOpenStart = {ctor: 'BetweenOpenStart'};
var _rluiten$elm_date_extra$Date_Extra_Compare$Between = {ctor: 'Between'};

var _rluiten$elm_date_extra$Date_Extra_TwelveHourClock$PM = {ctor: 'PM'};
var _rluiten$elm_date_extra$Date_Extra_TwelveHourClock$AM = {ctor: 'AM'};
var _rluiten$elm_date_extra$Date_Extra_TwelveHourClock$twelveHourPeriod = function (d) {
	return (_elm_lang$core$Native_Utils.cmp(
		_elm_lang$core$Date$hour(d),
		12) < 0) ? _rluiten$elm_date_extra$Date_Extra_TwelveHourClock$AM : _rluiten$elm_date_extra$Date_Extra_TwelveHourClock$PM;
};

var _rluiten$elm_date_extra$Date_Extra_Config$Config = F2(
	function (a, b) {
		return {i18n: a, format: b};
	});

var _rluiten$elm_date_extra$Date_Extra_I18n_I_default$twelveHourPeriod = function (period) {
	var _p0 = period;
	if (_p0.ctor === 'AM') {
		return 'AM';
	} else {
		return 'PM';
	}
};

var _rluiten$elm_date_extra$Date_Extra_I18n_I_en_us$dayOfMonthWithSuffix = F2(
	function (pad, day) {
		var value = function () {
			var _p0 = day;
			switch (_p0) {
				case 1:
					return '1st';
				case 21:
					return '21st';
				case 2:
					return '2nd';
				case 22:
					return '22nd';
				case 3:
					return '3rd';
				case 23:
					return '23rd';
				case 31:
					return '31st';
				default:
					return A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(day),
						'th');
			}
		}();
		return pad ? A3(
			_elm_lang$core$String$padLeft,
			4,
			_elm_lang$core$Native_Utils.chr(' '),
			value) : value;
	});
var _rluiten$elm_date_extra$Date_Extra_I18n_I_en_us$monthName = function (month) {
	var _p1 = month;
	switch (_p1.ctor) {
		case 'Jan':
			return 'January';
		case 'Feb':
			return 'February';
		case 'Mar':
			return 'March';
		case 'Apr':
			return 'April';
		case 'May':
			return 'May';
		case 'Jun':
			return 'June';
		case 'Jul':
			return 'July';
		case 'Aug':
			return 'August';
		case 'Sep':
			return 'September';
		case 'Oct':
			return 'October';
		case 'Nov':
			return 'November';
		default:
			return 'December';
	}
};
var _rluiten$elm_date_extra$Date_Extra_I18n_I_en_us$monthShort = function (month) {
	var _p2 = month;
	switch (_p2.ctor) {
		case 'Jan':
			return 'Jan';
		case 'Feb':
			return 'Feb';
		case 'Mar':
			return 'Mar';
		case 'Apr':
			return 'Apr';
		case 'May':
			return 'May';
		case 'Jun':
			return 'Jun';
		case 'Jul':
			return 'Jul';
		case 'Aug':
			return 'Aug';
		case 'Sep':
			return 'Sep';
		case 'Oct':
			return 'Oct';
		case 'Nov':
			return 'Nov';
		default:
			return 'Dec';
	}
};
var _rluiten$elm_date_extra$Date_Extra_I18n_I_en_us$dayName = function (day) {
	var _p3 = day;
	switch (_p3.ctor) {
		case 'Mon':
			return 'Monday';
		case 'Tue':
			return 'Tuesday';
		case 'Wed':
			return 'Wednesday';
		case 'Thu':
			return 'Thursday';
		case 'Fri':
			return 'Friday';
		case 'Sat':
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var _rluiten$elm_date_extra$Date_Extra_I18n_I_en_us$dayShort = function (day) {
	var _p4 = day;
	switch (_p4.ctor) {
		case 'Mon':
			return 'Mon';
		case 'Tue':
			return 'Tue';
		case 'Wed':
			return 'Wed';
		case 'Thu':
			return 'Thu';
		case 'Fri':
			return 'Fri';
		case 'Sat':
			return 'Sat';
		default:
			return 'Sun';
	}
};

var _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config = {
	i18n: {dayShort: _rluiten$elm_date_extra$Date_Extra_I18n_I_en_us$dayShort, dayName: _rluiten$elm_date_extra$Date_Extra_I18n_I_en_us$dayName, monthShort: _rluiten$elm_date_extra$Date_Extra_I18n_I_en_us$monthShort, monthName: _rluiten$elm_date_extra$Date_Extra_I18n_I_en_us$monthName, dayOfMonthWithSuffix: _rluiten$elm_date_extra$Date_Extra_I18n_I_en_us$dayOfMonthWithSuffix, twelveHourPeriod: _rluiten$elm_date_extra$Date_Extra_I18n_I_default$twelveHourPeriod},
	format: {date: '%-m/%-d/%Y', longDate: '%A, %B %d, %Y', time: '%-I:%M %p', longTime: '%-I:%M:%S %p', dateTime: '%-m/%-d/%Y %-I:%M %p', firstDayOfWeek: _elm_lang$core$Date$Sun}
};

var _rluiten$elm_date_extra$Date_Extra_Create$epochDate = _elm_lang$core$Date$fromTime(0);
var _rluiten$elm_date_extra$Date_Extra_Create$epochTimezoneOffset = function () {
	var inMinutes = (_elm_lang$core$Date$hour(_rluiten$elm_date_extra$Date_Extra_Create$epochDate) * 60) + _elm_lang$core$Date$minute(_rluiten$elm_date_extra$Date_Extra_Create$epochDate);
	return _elm_lang$core$Native_Utils.eq(
		_elm_lang$core$Date$year(_rluiten$elm_date_extra$Date_Extra_Create$epochDate),
		1969) ? (0 - (inMinutes - (24 * 60))) : (0 - inMinutes);
}();
var _rluiten$elm_date_extra$Date_Extra_Create$getTimezoneOffset = _rluiten$elm_date_extra$Date_Extra_Internal$getTimezoneOffset;
var _rluiten$elm_date_extra$Date_Extra_Create$adjustedTicksToDate = function (ticks) {
	var date = A3(_rluiten$elm_date_extra$Date_Extra_Period$add, _rluiten$elm_date_extra$Date_Extra_Period$Millisecond, ticks + (_rluiten$elm_date_extra$Date_Extra_Create$epochTimezoneOffset * _rluiten$elm_date_extra$Date_Extra_Core$ticksAMinute), _rluiten$elm_date_extra$Date_Extra_Create$epochDate);
	var dateOffset = _rluiten$elm_date_extra$Date_Extra_Create$getTimezoneOffset(date);
	return _elm_lang$core$Native_Utils.eq(dateOffset, _rluiten$elm_date_extra$Date_Extra_Create$epochTimezoneOffset) ? date : A3(_rluiten$elm_date_extra$Date_Extra_Period$add, _rluiten$elm_date_extra$Date_Extra_Period$Minute, dateOffset - _rluiten$elm_date_extra$Date_Extra_Create$epochTimezoneOffset, date);
};
var _rluiten$elm_date_extra$Date_Extra_Create$dateFromFields = F7(
	function (year, month, day, hour, minute, second, millisecond) {
		return _rluiten$elm_date_extra$Date_Extra_Create$adjustedTicksToDate(
			A7(_rluiten$elm_date_extra$Date_Extra_Internal$ticksFromFields, year, month, day, hour, minute, second, millisecond));
	});
var _rluiten$elm_date_extra$Date_Extra_Create$timeFromFields = A3(_rluiten$elm_date_extra$Date_Extra_Create$dateFromFields, 1970, _elm_lang$core$Date$Jan, 1);
var _rluiten$elm_date_extra$Date_Extra_Create$timeFromFieldsRecord = function (_p0) {
	var _p1 = _p0;
	return A7(_rluiten$elm_date_extra$Date_Extra_Create$dateFromFields, 1970, _elm_lang$core$Date$Jan, 1, _p1.hour, _p1.minute, _p1.second, _p1.millisecond);
};
var _rluiten$elm_date_extra$Date_Extra_Create$dateFromFieldsRecord = function (_p2) {
	return _rluiten$elm_date_extra$Date_Extra_Create$adjustedTicksToDate(
		_rluiten$elm_date_extra$Date_Extra_Internal$ticksFromFieldsRecord(_p2));
};

var _rluiten$elm_date_extra$Date_Extra_Duration$positiveDiffDays = F3(
	function (date1, date2, multiplier) {
		var date2DaysFromCivil = A3(
			_rluiten$elm_date_extra$Date_Extra_Internal$daysFromCivil,
			_elm_lang$core$Date$year(date2),
			_rluiten$elm_date_extra$Date_Extra_Core$monthToInt(
				_elm_lang$core$Date$month(date2)),
			_elm_lang$core$Date$day(date2));
		var date1DaysFromCivil = A3(
			_rluiten$elm_date_extra$Date_Extra_Internal$daysFromCivil,
			_elm_lang$core$Date$year(date1),
			_rluiten$elm_date_extra$Date_Extra_Core$monthToInt(
				_elm_lang$core$Date$month(date1)),
			_elm_lang$core$Date$day(date1));
		return (date1DaysFromCivil - date2DaysFromCivil) * multiplier;
	});
var _rluiten$elm_date_extra$Date_Extra_Duration$diffDays = F2(
	function (date1, date2) {
		return A3(_rluiten$elm_date_extra$Date_Extra_Compare$is, _rluiten$elm_date_extra$Date_Extra_Compare$After, date1, date2) ? A3(_rluiten$elm_date_extra$Date_Extra_Duration$positiveDiffDays, date1, date2, 1) : A3(_rluiten$elm_date_extra$Date_Extra_Duration$positiveDiffDays, date2, date1, -1);
	});
var _rluiten$elm_date_extra$Date_Extra_Duration$positiveDiff = F3(
	function (date1, date2, multiplier) {
		var propogateCarry = F3(
			function (current, carry, maxVal) {
				var adjusted = current + carry;
				return (_elm_lang$core$Native_Utils.cmp(adjusted, 0) < 0) ? {ctor: '_Tuple2', _0: maxVal + adjusted, _1: -1} : {ctor: '_Tuple2', _0: adjusted, _1: 0};
			});
		var accumulatedDiff = F4(
			function (acc, v1, v2, maxV2) {
				return (_elm_lang$core$Native_Utils.cmp(v1, v2) < 0) ? {ctor: '_Tuple2', _0: acc - 1, _1: (maxV2 + v1) - v2} : {ctor: '_Tuple2', _0: acc, _1: v1 - v2};
			});
		var msec2 = _elm_lang$core$Date$millisecond(date2);
		var msec1 = _elm_lang$core$Date$millisecond(date1);
		var second2 = _elm_lang$core$Date$second(date2);
		var second1 = _elm_lang$core$Date$second(date1);
		var minute2 = _elm_lang$core$Date$minute(date2);
		var minute1 = _elm_lang$core$Date$minute(date1);
		var hour2 = _elm_lang$core$Date$hour(date2);
		var hour1 = _elm_lang$core$Date$hour(date1);
		var day2 = _elm_lang$core$Date$day(date2);
		var day1 = _elm_lang$core$Date$day(date1);
		var month2Mon = _elm_lang$core$Date$month(date2);
		var month2 = _rluiten$elm_date_extra$Date_Extra_Core$monthToInt(month2Mon);
		var month1Mon = _elm_lang$core$Date$month(date1);
		var month1 = _rluiten$elm_date_extra$Date_Extra_Core$monthToInt(month1Mon);
		var year2 = _elm_lang$core$Date$year(date2);
		var daysInDate2Month = A2(_rluiten$elm_date_extra$Date_Extra_Core$daysInMonth, year2, month2Mon);
		var year1 = _elm_lang$core$Date$year(date1);
		var daysInDate1Month = A2(_rluiten$elm_date_extra$Date_Extra_Core$daysInMonth, year1, month1Mon);
		var _p0 = A4(accumulatedDiff, year1 - year2, month1, month2, 12);
		var yearDiff = _p0._0;
		var monthDiffA = _p0._1;
		var _p1 = A4(accumulatedDiff, monthDiffA, day1, day2, daysInDate2Month);
		var monthDiff = _p1._0;
		var dayDiffA = _p1._1;
		var _p2 = A4(accumulatedDiff, dayDiffA, hour1, hour2, 24);
		var dayDiff = _p2._0;
		var hourDiffA = _p2._1;
		var _p3 = A4(accumulatedDiff, hourDiffA, minute1, minute2, 60);
		var hourDiff = _p3._0;
		var minuteDiffA = _p3._1;
		var _p4 = A4(accumulatedDiff, minuteDiffA, second1, second2, 60);
		var minuteDiff = _p4._0;
		var secondDiffA = _p4._1;
		var _p5 = A4(accumulatedDiff, secondDiffA, msec1, msec2, 1000);
		var secondDiff = _p5._0;
		var msecDiff = _p5._1;
		var _p6 = A3(propogateCarry, msecDiff, 0, 1000);
		var msecX = _p6._0;
		var secondCarry = _p6._1;
		var _p7 = A3(propogateCarry, secondDiff, secondCarry, 60);
		var secondX = _p7._0;
		var minuteCarry = _p7._1;
		var _p8 = A3(propogateCarry, minuteDiff, minuteCarry, 60);
		var minuteX = _p8._0;
		var hourCarry = _p8._1;
		var _p9 = A3(propogateCarry, hourDiff, hourCarry, 60);
		var hourX = _p9._0;
		var dayCarry = _p9._1;
		var _p10 = A3(propogateCarry, dayDiff, dayCarry, daysInDate1Month);
		var dayX = _p10._0;
		var monthCarry = _p10._1;
		var _p11 = A3(propogateCarry, monthDiff, monthCarry, 12);
		var monthX = _p11._0;
		var yearCarry = _p11._1;
		var _p12 = A3(propogateCarry, yearDiff, yearCarry, 0);
		var yearX = _p12._0;
		return {year: yearX * multiplier, month: monthX * multiplier, day: dayX * multiplier, hour: hourX * multiplier, minute: minuteX * multiplier, second: secondX * multiplier, millisecond: msecX * multiplier};
	});
var _rluiten$elm_date_extra$Date_Extra_Duration$diff = F2(
	function (date1, date2) {
		return A3(_rluiten$elm_date_extra$Date_Extra_Compare$is, _rluiten$elm_date_extra$Date_Extra_Compare$After, date1, date2) ? A3(_rluiten$elm_date_extra$Date_Extra_Duration$positiveDiff, date1, date2, 1) : A3(_rluiten$elm_date_extra$Date_Extra_Duration$positiveDiff, date2, date1, -1);
	});
var _rluiten$elm_date_extra$Date_Extra_Duration$addMonth = F2(
	function (monthCount, date) {
		var day = _elm_lang$core$Date$day(date);
		var monthInt = _rluiten$elm_date_extra$Date_Extra_Core$monthToInt(
			_elm_lang$core$Date$month(date));
		var newMonthInt = monthInt + monthCount;
		var targetMonthInt = A2(_elm_lang$core$Basics_ops['%'], newMonthInt, 12);
		var yearOffset = ((_elm_lang$core$Native_Utils.cmp(newMonthInt, 0) < 0) && (!_elm_lang$core$Native_Utils.eq(targetMonthInt, 0))) ? (((newMonthInt / 12) | 0) - 1) : ((newMonthInt / 12) | 0);
		var year = _elm_lang$core$Date$year(date);
		var inputCivil = A3(_rluiten$elm_date_extra$Date_Extra_Internal$daysFromCivil, year, monthInt, day);
		var newYear = year + yearOffset;
		var newDay = A2(
			_elm_lang$core$Basics$min,
			A2(
				_rluiten$elm_date_extra$Date_Extra_Core$daysInMonth,
				newYear,
				_rluiten$elm_date_extra$Date_Extra_Core$intToMonth(newMonthInt)),
			day);
		var newCivil = A3(_rluiten$elm_date_extra$Date_Extra_Internal$daysFromCivil, newYear, targetMonthInt, newDay);
		var daysDifferent = newCivil - inputCivil;
		return A3(_rluiten$elm_date_extra$Date_Extra_Period$add, _rluiten$elm_date_extra$Date_Extra_Period$Day, daysDifferent, date);
	});
var _rluiten$elm_date_extra$Date_Extra_Duration$addYear = F2(
	function (yearCount, date) {
		return A2(_rluiten$elm_date_extra$Date_Extra_Duration$addMonth, 12 * yearCount, date);
	});
var _rluiten$elm_date_extra$Date_Extra_Duration$daylightOffsetCompensate = F2(
	function (dateBefore, dateAfter) {
		var offsetAfter = _rluiten$elm_date_extra$Date_Extra_Create$getTimezoneOffset(dateAfter);
		var offsetBefore = _rluiten$elm_date_extra$Date_Extra_Create$getTimezoneOffset(dateBefore);
		if (!_elm_lang$core$Native_Utils.eq(offsetBefore, offsetAfter)) {
			var adjustedDate = A3(_rluiten$elm_date_extra$Date_Extra_Period$add, _rluiten$elm_date_extra$Date_Extra_Period$Millisecond, (offsetAfter - offsetBefore) * _rluiten$elm_date_extra$Date_Extra_Core$ticksAMinute, dateAfter);
			var adjustedOffset = _rluiten$elm_date_extra$Date_Extra_Create$getTimezoneOffset(adjustedDate);
			return (!_elm_lang$core$Native_Utils.eq(adjustedOffset, offsetAfter)) ? dateAfter : adjustedDate;
		} else {
			return dateAfter;
		}
	});
var _rluiten$elm_date_extra$Date_Extra_Duration$requireDaylightCompensateInAdd = function (duration) {
	var _p13 = duration;
	switch (_p13.ctor) {
		case 'Millisecond':
			return false;
		case 'Second':
			return false;
		case 'Minute':
			return false;
		case 'Hour':
			return false;
		case 'Day':
			return true;
		case 'Week':
			return true;
		case 'Month':
			return true;
		case 'Year':
			return true;
		default:
			var _p14 = _p13._0;
			return (!_elm_lang$core$Native_Utils.eq(_p14.day, 0)) || ((!_elm_lang$core$Native_Utils.eq(_p14.month, 0)) || (!_elm_lang$core$Native_Utils.eq(_p14.year, 0)));
	}
};
var _rluiten$elm_date_extra$Date_Extra_Duration$zeroDelta = {year: 0, month: 0, day: 0, hour: 0, minute: 0, second: 0, millisecond: 0};
var _rluiten$elm_date_extra$Date_Extra_Duration$DeltaRecord = F7(
	function (a, b, c, d, e, f, g) {
		return {year: a, month: b, day: c, hour: d, minute: e, second: f, millisecond: g};
	});
var _rluiten$elm_date_extra$Date_Extra_Duration$Delta = function (a) {
	return {ctor: 'Delta', _0: a};
};
var _rluiten$elm_date_extra$Date_Extra_Duration$Year = {ctor: 'Year'};
var _rluiten$elm_date_extra$Date_Extra_Duration$Month = {ctor: 'Month'};
var _rluiten$elm_date_extra$Date_Extra_Duration$doAdd = F3(
	function (duration, addend, date) {
		var _p15 = duration;
		switch (_p15.ctor) {
			case 'Millisecond':
				return A3(_rluiten$elm_date_extra$Date_Extra_Period$add, _rluiten$elm_date_extra$Date_Extra_Period$Millisecond, addend, date);
			case 'Second':
				return A3(_rluiten$elm_date_extra$Date_Extra_Period$add, _rluiten$elm_date_extra$Date_Extra_Period$Second, addend, date);
			case 'Minute':
				return A3(_rluiten$elm_date_extra$Date_Extra_Period$add, _rluiten$elm_date_extra$Date_Extra_Period$Minute, addend, date);
			case 'Hour':
				return A3(_rluiten$elm_date_extra$Date_Extra_Period$add, _rluiten$elm_date_extra$Date_Extra_Period$Hour, addend, date);
			case 'Day':
				return A3(_rluiten$elm_date_extra$Date_Extra_Period$add, _rluiten$elm_date_extra$Date_Extra_Period$Day, addend, date);
			case 'Week':
				return A3(_rluiten$elm_date_extra$Date_Extra_Period$add, _rluiten$elm_date_extra$Date_Extra_Period$Week, addend, date);
			case 'Month':
				return A2(_rluiten$elm_date_extra$Date_Extra_Duration$addMonth, addend, date);
			case 'Year':
				return A2(_rluiten$elm_date_extra$Date_Extra_Duration$addYear, addend, date);
			default:
				var _p16 = _p15._0;
				return A3(
					_rluiten$elm_date_extra$Date_Extra_Period$add,
					_rluiten$elm_date_extra$Date_Extra_Period$Delta(
						{week: 0, day: _p16.day, hour: _p16.hour, minute: _p16.minute, second: _p16.second, millisecond: _p16.millisecond}),
					addend,
					A3(
						_rluiten$elm_date_extra$Date_Extra_Duration$doAdd,
						_rluiten$elm_date_extra$Date_Extra_Duration$Month,
						_p16.month,
						A3(_rluiten$elm_date_extra$Date_Extra_Duration$doAdd, _rluiten$elm_date_extra$Date_Extra_Duration$Year, _p16.year, date)));
		}
	});
var _rluiten$elm_date_extra$Date_Extra_Duration$add = F3(
	function (duration, addend, date) {
		var outputDate = A3(_rluiten$elm_date_extra$Date_Extra_Duration$doAdd, duration, addend, date);
		return _rluiten$elm_date_extra$Date_Extra_Duration$requireDaylightCompensateInAdd(duration) ? A2(_rluiten$elm_date_extra$Date_Extra_Duration$daylightOffsetCompensate, date, outputDate) : outputDate;
	});
var _rluiten$elm_date_extra$Date_Extra_Duration$Week = {ctor: 'Week'};
var _rluiten$elm_date_extra$Date_Extra_Duration$Day = {ctor: 'Day'};
var _rluiten$elm_date_extra$Date_Extra_Duration$Hour = {ctor: 'Hour'};
var _rluiten$elm_date_extra$Date_Extra_Duration$Minute = {ctor: 'Minute'};
var _rluiten$elm_date_extra$Date_Extra_Duration$Second = {ctor: 'Second'};
var _rluiten$elm_date_extra$Date_Extra_Duration$Millisecond = {ctor: 'Millisecond'};

var _rluiten$elm_date_extra$Date_Extra_Field$dayOfWeekToDate = F3(
	function (newDayOfWeek, startOfWeekDay, date) {
		var targetIsoDay = _rluiten$elm_date_extra$Date_Extra_Core$isoDayOfWeek(newDayOfWeek);
		var dayOfWeek = _elm_lang$core$Date$dayOfWeek(date);
		var daysToStartOfWeek = A2(_rluiten$elm_date_extra$Date_Extra_Core$daysBackToStartOfWeek, dayOfWeek, startOfWeekDay);
		var isoDay = _rluiten$elm_date_extra$Date_Extra_Core$isoDayOfWeek(dayOfWeek);
		var dayDiff = targetIsoDay - isoDay;
		var adjustedDiff = (_elm_lang$core$Native_Utils.cmp(daysToStartOfWeek + dayDiff, 0) < 0) ? (dayDiff + 7) : dayDiff;
		return A3(_rluiten$elm_date_extra$Date_Extra_Duration$add, _rluiten$elm_date_extra$Date_Extra_Duration$Day, adjustedDiff, date);
	});
var _rluiten$elm_date_extra$Date_Extra_Field$monthToDate = F2(
	function (month, date) {
		var monthInt = _rluiten$elm_date_extra$Date_Extra_Core$monthToInt(
			_elm_lang$core$Date$month(date));
		var targetMonthInt = _rluiten$elm_date_extra$Date_Extra_Core$monthToInt(month);
		return A3(_rluiten$elm_date_extra$Date_Extra_Duration$add, _rluiten$elm_date_extra$Date_Extra_Duration$Month, targetMonthInt - monthInt, date);
	});
var _rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp = F2(
	function (field, date) {
		var _p0 = field;
		switch (_p0.ctor) {
			case 'Millisecond':
				return A3(
					_rluiten$elm_date_extra$Date_Extra_Duration$add,
					_rluiten$elm_date_extra$Date_Extra_Duration$Millisecond,
					A3(_elm_lang$core$Basics$clamp, 0, 999, _p0._0) - _elm_lang$core$Date$millisecond(date),
					date);
			case 'Second':
				return A3(
					_rluiten$elm_date_extra$Date_Extra_Duration$add,
					_rluiten$elm_date_extra$Date_Extra_Duration$Second,
					A3(_elm_lang$core$Basics$clamp, 0, 59, _p0._0) - _elm_lang$core$Date$second(date),
					date);
			case 'Minute':
				return A3(
					_rluiten$elm_date_extra$Date_Extra_Duration$add,
					_rluiten$elm_date_extra$Date_Extra_Duration$Minute,
					A3(_elm_lang$core$Basics$clamp, 0, 59, _p0._0) - _elm_lang$core$Date$minute(date),
					date);
			case 'Hour':
				return A3(
					_rluiten$elm_date_extra$Date_Extra_Duration$add,
					_rluiten$elm_date_extra$Date_Extra_Duration$Hour,
					A3(_elm_lang$core$Basics$clamp, 0, 23, _p0._0) - _elm_lang$core$Date$hour(date),
					date);
			case 'DayOfWeek':
				return A3(_rluiten$elm_date_extra$Date_Extra_Field$dayOfWeekToDate, _p0._0._0, _p0._0._1, date);
			case 'DayOfMonth':
				var maxDays = _rluiten$elm_date_extra$Date_Extra_Core$daysInMonthDate(date);
				return A3(
					_rluiten$elm_date_extra$Date_Extra_Duration$add,
					_rluiten$elm_date_extra$Date_Extra_Duration$Day,
					A3(_elm_lang$core$Basics$clamp, 1, maxDays, _p0._0) - _elm_lang$core$Date$day(date),
					date);
			case 'Month':
				return A2(_rluiten$elm_date_extra$Date_Extra_Field$monthToDate, _p0._0, date);
			default:
				var _p1 = _p0._0;
				var minYear = (_elm_lang$core$Native_Utils.cmp(_p1, 0) < 0) ? 0 : _p1;
				return A3(
					_rluiten$elm_date_extra$Date_Extra_Duration$add,
					_rluiten$elm_date_extra$Date_Extra_Duration$Year,
					minYear - _elm_lang$core$Date$year(date),
					date);
		}
	});
var _rluiten$elm_date_extra$Date_Extra_Field$fieldToDate = F2(
	function (field, date) {
		var _p2 = field;
		switch (_p2.ctor) {
			case 'Millisecond':
				var _p3 = _p2._0;
				return ((_elm_lang$core$Native_Utils.cmp(_p3, 0) < 0) || (_elm_lang$core$Native_Utils.cmp(_p3, 999) > 0)) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
					A3(
						_rluiten$elm_date_extra$Date_Extra_Duration$add,
						_rluiten$elm_date_extra$Date_Extra_Duration$Millisecond,
						_p3 - _elm_lang$core$Date$millisecond(date),
						date));
			case 'Second':
				var _p4 = _p2._0;
				return ((_elm_lang$core$Native_Utils.cmp(_p4, 0) < 0) || (_elm_lang$core$Native_Utils.cmp(_p4, 59) > 0)) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
					A3(
						_rluiten$elm_date_extra$Date_Extra_Duration$add,
						_rluiten$elm_date_extra$Date_Extra_Duration$Second,
						_p4 - _elm_lang$core$Date$second(date),
						date));
			case 'Minute':
				var _p5 = _p2._0;
				return ((_elm_lang$core$Native_Utils.cmp(_p5, 0) < 0) || (_elm_lang$core$Native_Utils.cmp(_p5, 59) > 0)) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
					A3(
						_rluiten$elm_date_extra$Date_Extra_Duration$add,
						_rluiten$elm_date_extra$Date_Extra_Duration$Minute,
						_p5 - _elm_lang$core$Date$minute(date),
						date));
			case 'Hour':
				var _p6 = _p2._0;
				return ((_elm_lang$core$Native_Utils.cmp(_p6, 0) < 0) || (_elm_lang$core$Native_Utils.cmp(_p6, 23) > 0)) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
					A3(
						_rluiten$elm_date_extra$Date_Extra_Duration$add,
						_rluiten$elm_date_extra$Date_Extra_Duration$Hour,
						_p6 - _elm_lang$core$Date$hour(date),
						date));
			case 'DayOfWeek':
				return _elm_lang$core$Maybe$Just(
					A3(_rluiten$elm_date_extra$Date_Extra_Field$dayOfWeekToDate, _p2._0._0, _p2._0._1, date));
			case 'DayOfMonth':
				var _p7 = _p2._0;
				var maxDays = _rluiten$elm_date_extra$Date_Extra_Core$daysInMonthDate(date);
				return ((_elm_lang$core$Native_Utils.cmp(_p7, 1) < 0) || (_elm_lang$core$Native_Utils.cmp(_p7, maxDays) > 0)) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
					A3(
						_rluiten$elm_date_extra$Date_Extra_Duration$add,
						_rluiten$elm_date_extra$Date_Extra_Duration$Day,
						_p7 - _elm_lang$core$Date$day(date),
						date));
			case 'Month':
				return _elm_lang$core$Maybe$Just(
					A2(_rluiten$elm_date_extra$Date_Extra_Field$monthToDate, _p2._0, date));
			default:
				var _p8 = _p2._0;
				return (_elm_lang$core$Native_Utils.cmp(_p8, 0) < 0) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
					A3(
						_rluiten$elm_date_extra$Date_Extra_Duration$add,
						_rluiten$elm_date_extra$Date_Extra_Duration$Year,
						_p8 - _elm_lang$core$Date$year(date),
						date));
		}
	});
var _rluiten$elm_date_extra$Date_Extra_Field$Year = function (a) {
	return {ctor: 'Year', _0: a};
};
var _rluiten$elm_date_extra$Date_Extra_Field$Month = function (a) {
	return {ctor: 'Month', _0: a};
};
var _rluiten$elm_date_extra$Date_Extra_Field$DayOfMonth = function (a) {
	return {ctor: 'DayOfMonth', _0: a};
};
var _rluiten$elm_date_extra$Date_Extra_Field$DayOfWeek = function (a) {
	return {ctor: 'DayOfWeek', _0: a};
};
var _rluiten$elm_date_extra$Date_Extra_Field$Hour = function (a) {
	return {ctor: 'Hour', _0: a};
};
var _rluiten$elm_date_extra$Date_Extra_Field$Minute = function (a) {
	return {ctor: 'Minute', _0: a};
};
var _rluiten$elm_date_extra$Date_Extra_Field$Second = function (a) {
	return {ctor: 'Second', _0: a};
};
var _rluiten$elm_date_extra$Date_Extra_Field$Millisecond = function (a) {
	return {ctor: 'Millisecond', _0: a};
};

var _rluiten$elm_date_extra$Date_Extra_TimeUnit$Year = {ctor: 'Year'};
var _rluiten$elm_date_extra$Date_Extra_TimeUnit$Month = {ctor: 'Month'};
var _rluiten$elm_date_extra$Date_Extra_TimeUnit$Day = {ctor: 'Day'};
var _rluiten$elm_date_extra$Date_Extra_TimeUnit$Hour = {ctor: 'Hour'};
var _rluiten$elm_date_extra$Date_Extra_TimeUnit$Minute = {ctor: 'Minute'};
var _rluiten$elm_date_extra$Date_Extra_TimeUnit$Second = {ctor: 'Second'};
var _rluiten$elm_date_extra$Date_Extra_TimeUnit$startOfTime = F2(
	function (unit, date) {
		var _p0 = unit;
		switch (_p0.ctor) {
			case 'Millisecond':
				return date;
			case 'Second':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
					_rluiten$elm_date_extra$Date_Extra_Field$Millisecond(0),
					date);
			case 'Minute':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
					_rluiten$elm_date_extra$Date_Extra_Field$Second(0),
					A2(_rluiten$elm_date_extra$Date_Extra_TimeUnit$startOfTime, _rluiten$elm_date_extra$Date_Extra_TimeUnit$Second, date));
			case 'Hour':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
					_rluiten$elm_date_extra$Date_Extra_Field$Minute(0),
					A2(_rluiten$elm_date_extra$Date_Extra_TimeUnit$startOfTime, _rluiten$elm_date_extra$Date_Extra_TimeUnit$Minute, date));
			case 'Day':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
					_rluiten$elm_date_extra$Date_Extra_Field$Hour(0),
					A2(_rluiten$elm_date_extra$Date_Extra_TimeUnit$startOfTime, _rluiten$elm_date_extra$Date_Extra_TimeUnit$Hour, date));
			case 'Month':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
					_rluiten$elm_date_extra$Date_Extra_Field$DayOfMonth(1),
					A2(_rluiten$elm_date_extra$Date_Extra_TimeUnit$startOfTime, _rluiten$elm_date_extra$Date_Extra_TimeUnit$Day, date));
			default:
				return _rluiten$elm_date_extra$Date_Extra_TimeUnit$startOfTimeYear(date);
		}
	});
var _rluiten$elm_date_extra$Date_Extra_TimeUnit$startOfTimeYear = function (date) {
	var startMonthDate = A2(
		_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
		_rluiten$elm_date_extra$Date_Extra_Field$DayOfMonth(1),
		date);
	var startYearDate = A2(
		_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
		_rluiten$elm_date_extra$Date_Extra_Field$Month(_elm_lang$core$Date$Jan),
		startMonthDate);
	var monthTicks = _rluiten$elm_date_extra$Date_Extra_Core$toTime(startMonthDate) - _rluiten$elm_date_extra$Date_Extra_Core$toTime(startYearDate);
	var updatedDate = _rluiten$elm_date_extra$Date_Extra_Core$fromTime(
		_rluiten$elm_date_extra$Date_Extra_Core$toTime(date) - monthTicks);
	return A2(_rluiten$elm_date_extra$Date_Extra_TimeUnit$startOfTime, _rluiten$elm_date_extra$Date_Extra_TimeUnit$Month, updatedDate);
};
var _rluiten$elm_date_extra$Date_Extra_TimeUnit$endOfTime = F2(
	function (unit, date) {
		var _p1 = unit;
		switch (_p1.ctor) {
			case 'Millisecond':
				return date;
			case 'Second':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
					_rluiten$elm_date_extra$Date_Extra_Field$Millisecond(999),
					date);
			case 'Minute':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
					_rluiten$elm_date_extra$Date_Extra_Field$Second(59),
					A2(_rluiten$elm_date_extra$Date_Extra_TimeUnit$endOfTime, _rluiten$elm_date_extra$Date_Extra_TimeUnit$Second, date));
			case 'Hour':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
					_rluiten$elm_date_extra$Date_Extra_Field$Minute(59),
					A2(_rluiten$elm_date_extra$Date_Extra_TimeUnit$endOfTime, _rluiten$elm_date_extra$Date_Extra_TimeUnit$Minute, date));
			case 'Day':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
					_rluiten$elm_date_extra$Date_Extra_Field$Hour(23),
					A2(_rluiten$elm_date_extra$Date_Extra_TimeUnit$endOfTime, _rluiten$elm_date_extra$Date_Extra_TimeUnit$Hour, date));
			case 'Month':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
					_rluiten$elm_date_extra$Date_Extra_Field$DayOfMonth(31),
					A2(_rluiten$elm_date_extra$Date_Extra_TimeUnit$endOfTime, _rluiten$elm_date_extra$Date_Extra_TimeUnit$Day, date));
			default:
				var extraYear = A3(_rluiten$elm_date_extra$Date_Extra_Duration$add, _rluiten$elm_date_extra$Date_Extra_Duration$Year, 1, date);
				var startYear = A2(_rluiten$elm_date_extra$Date_Extra_TimeUnit$startOfTime, _rluiten$elm_date_extra$Date_Extra_TimeUnit$Year, extraYear);
				return A3(_rluiten$elm_date_extra$Date_Extra_Duration$add, _rluiten$elm_date_extra$Date_Extra_Duration$Millisecond, -1, startYear);
		}
	});
var _rluiten$elm_date_extra$Date_Extra_TimeUnit$Millisecond = {ctor: 'Millisecond'};

var _rluiten$elm_date_extra$Date_Extra_Utils$unsafeFromString = function (dateStr) {
	var _p0 = _elm_lang$core$Date$fromString(dateStr);
	if (_p0.ctor === 'Ok') {
		return _p0._0;
	} else {
		return _elm_lang$core$Native_Utils.crashCase(
			'Date.Extra.Utils',
			{
				start: {line: 146, column: 5},
				end: {line: 151, column: 43}
			},
			_p0)('unsafeFromString');
	}
};
var _rluiten$elm_date_extra$Date_Extra_Utils$isoDayofWeekMonday = _rluiten$elm_date_extra$Date_Extra_Core$isoDayOfWeek(_elm_lang$core$Date$Mon);
var _rluiten$elm_date_extra$Date_Extra_Utils$isoWeekOne = function (year) {
	var dateJan4 = A7(_rluiten$elm_date_extra$Date_Extra_Create$dateFromFields, year, _elm_lang$core$Date$Jan, 4, 0, 0, 0, 0);
	return A3(
		_rluiten$elm_date_extra$Date_Extra_Duration$add,
		_rluiten$elm_date_extra$Date_Extra_Duration$Day,
		_rluiten$elm_date_extra$Date_Extra_Utils$isoDayofWeekMonday - _rluiten$elm_date_extra$Date_Extra_Core$isoDayOfWeek(
			_elm_lang$core$Date$dayOfWeek(dateJan4)),
		dateJan4);
};
var _rluiten$elm_date_extra$Date_Extra_Utils$getYearIsoWeekDate = function (date) {
	var inputYear = _elm_lang$core$Date$year(date);
	var maxIsoWeekDateInYear = A7(_rluiten$elm_date_extra$Date_Extra_Create$dateFromFields, inputYear, _elm_lang$core$Date$Dec, 29, 0, 0, 0, 0);
	if (A3(_rluiten$elm_date_extra$Date_Extra_Compare$is, _rluiten$elm_date_extra$Date_Extra_Compare$SameOrAfter, date, maxIsoWeekDateInYear)) {
		var nextYearIsoWeek1Date = _rluiten$elm_date_extra$Date_Extra_Utils$isoWeekOne(inputYear + 1);
		return A3(_rluiten$elm_date_extra$Date_Extra_Compare$is, _rluiten$elm_date_extra$Date_Extra_Compare$Before, date, nextYearIsoWeek1Date) ? {
			ctor: '_Tuple2',
			_0: inputYear,
			_1: _rluiten$elm_date_extra$Date_Extra_Utils$isoWeekOne(inputYear)
		} : {ctor: '_Tuple2', _0: inputYear + 1, _1: nextYearIsoWeek1Date};
	} else {
		var thisYearIsoWeek1Date = _rluiten$elm_date_extra$Date_Extra_Utils$isoWeekOne(inputYear);
		return A3(_rluiten$elm_date_extra$Date_Extra_Compare$is, _rluiten$elm_date_extra$Date_Extra_Compare$Before, date, thisYearIsoWeek1Date) ? {
			ctor: '_Tuple2',
			_0: inputYear - 1,
			_1: _rluiten$elm_date_extra$Date_Extra_Utils$isoWeekOne(inputYear - 1)
		} : {ctor: '_Tuple2', _0: inputYear, _1: thisYearIsoWeek1Date};
	}
};
var _rluiten$elm_date_extra$Date_Extra_Utils$isoWeek = function (date) {
	var _p2 = _rluiten$elm_date_extra$Date_Extra_Utils$getYearIsoWeekDate(date);
	var year = _p2._0;
	var isoWeek1Date = _p2._1;
	var daysSinceIsoWeek1 = A2(_rluiten$elm_date_extra$Date_Extra_Duration$diffDays, date, isoWeek1Date);
	return {
		ctor: '_Tuple3',
		_0: year,
		_1: ((daysSinceIsoWeek1 / 7) | 0) + 1,
		_2: _rluiten$elm_date_extra$Date_Extra_Core$isoDayOfWeek(
			_elm_lang$core$Date$dayOfWeek(date))
	};
};
var _rluiten$elm_date_extra$Date_Extra_Utils$dayList_ = F3(
	function (dayCount, date, list) {
		dayList_:
		while (true) {
			if (_elm_lang$core$Native_Utils.eq(dayCount, 0)) {
				return list;
			} else {
				if (_elm_lang$core$Native_Utils.cmp(dayCount, 0) > 0) {
					var _v1 = dayCount - 1,
						_v2 = A3(_rluiten$elm_date_extra$Date_Extra_Duration$add, _rluiten$elm_date_extra$Date_Extra_Duration$Day, 1, date),
						_v3 = {ctor: '::', _0: date, _1: list};
					dayCount = _v1;
					date = _v2;
					list = _v3;
					continue dayList_;
				} else {
					var _v4 = dayCount + 1,
						_v5 = A3(_rluiten$elm_date_extra$Date_Extra_Duration$add, _rluiten$elm_date_extra$Date_Extra_Duration$Day, -1, date),
						_v6 = {ctor: '::', _0: date, _1: list};
					dayCount = _v4;
					date = _v5;
					list = _v6;
					continue dayList_;
				}
			}
		}
	});
var _rluiten$elm_date_extra$Date_Extra_Utils$dayList = F2(
	function (dayCount, startDate) {
		return _elm_lang$core$List$reverse(
			A3(
				_rluiten$elm_date_extra$Date_Extra_Utils$dayList_,
				dayCount,
				startDate,
				{ctor: '[]'}));
	});

var _rluiten$elm_date_extra$Date_Extra_Format$toHourMin = function (offsetMinutes) {
	return {
		ctor: '_Tuple2',
		_0: (offsetMinutes / 60) | 0,
		_1: A2(_elm_lang$core$Basics_ops['%'], offsetMinutes, 60)
	};
};
var _rluiten$elm_date_extra$Date_Extra_Format$padWithN = F2(
	function (n, c) {
		return function (_p0) {
			return A3(
				_elm_lang$core$String$padLeft,
				n,
				c,
				_elm_lang$core$Basics$toString(_p0));
		};
	});
var _rluiten$elm_date_extra$Date_Extra_Format$padWith = function (c) {
	return function (_p1) {
		return A3(
			_elm_lang$core$String$padLeft,
			2,
			c,
			_elm_lang$core$Basics$toString(_p1));
	};
};
var _rluiten$elm_date_extra$Date_Extra_Format$hourMod12 = function (h) {
	return _elm_lang$core$Native_Utils.eq(
		A2(_elm_lang$core$Basics_ops['%'], h, 12),
		0) ? 12 : A2(_elm_lang$core$Basics_ops['%'], h, 12);
};
var _rluiten$elm_date_extra$Date_Extra_Format$formatOffsetStr = F2(
	function (betweenHoursMinutes, offset) {
		var _p2 = _rluiten$elm_date_extra$Date_Extra_Format$toHourMin(
			_elm_lang$core$Basics$abs(offset));
		var hour = _p2._0;
		var minute = _p2._1;
		return A2(
			_elm_lang$core$Basics_ops['++'],
			(_elm_lang$core$Native_Utils.cmp(offset, 0) < 1) ? '+' : '-',
			A2(
				_elm_lang$core$Basics_ops['++'],
				A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr('0'),
					hour),
				A2(
					_elm_lang$core$Basics_ops['++'],
					betweenHoursMinutes,
					A2(
						_rluiten$elm_date_extra$Date_Extra_Format$padWith,
						_elm_lang$core$Native_Utils.chr('0'),
						minute))));
	});
var _rluiten$elm_date_extra$Date_Extra_Format$collapse = function (m) {
	return A2(_elm_lang$core$Maybe$andThen, _elm_lang$core$Basics$identity, m);
};
var _rluiten$elm_date_extra$Date_Extra_Format$formatToken = F4(
	function (config, offset, d, m) {
		var symbol = A2(
			_elm_lang$core$Maybe$withDefault,
			' ',
			_rluiten$elm_date_extra$Date_Extra_Format$collapse(
				_elm_lang$core$List$head(m.submatches)));
		var _p3 = symbol;
		switch (_p3) {
			case 'Y':
				return A3(
					_rluiten$elm_date_extra$Date_Extra_Format$padWithN,
					4,
					_elm_lang$core$Native_Utils.chr('0'),
					_elm_lang$core$Date$year(d));
			case 'y':
				return A2(
					_elm_lang$core$String$right,
					2,
					A3(
						_rluiten$elm_date_extra$Date_Extra_Format$padWithN,
						2,
						_elm_lang$core$Native_Utils.chr('0'),
						_elm_lang$core$Date$year(d)));
			case 'm':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr('0'),
					_rluiten$elm_date_extra$Date_Extra_Core$monthToInt(
						_elm_lang$core$Date$month(d)));
			case '_m':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr(' '),
					_rluiten$elm_date_extra$Date_Extra_Core$monthToInt(
						_elm_lang$core$Date$month(d)));
			case '-m':
				return _elm_lang$core$Basics$toString(
					_rluiten$elm_date_extra$Date_Extra_Core$monthToInt(
						_elm_lang$core$Date$month(d)));
			case 'B':
				return config.i18n.monthName(
					_elm_lang$core$Date$month(d));
			case '^B':
				return _elm_lang$core$String$toUpper(
					config.i18n.monthName(
						_elm_lang$core$Date$month(d)));
			case 'b':
				return config.i18n.monthShort(
					_elm_lang$core$Date$month(d));
			case '^b':
				return _elm_lang$core$String$toUpper(
					config.i18n.monthShort(
						_elm_lang$core$Date$month(d)));
			case 'd':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr('0'),
					_elm_lang$core$Date$day(d));
			case '-d':
				return _elm_lang$core$Basics$toString(
					_elm_lang$core$Date$day(d));
			case '-@d':
				return A2(
					config.i18n.dayOfMonthWithSuffix,
					false,
					_elm_lang$core$Date$day(d));
			case 'e':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr(' '),
					_elm_lang$core$Date$day(d));
			case '@e':
				return A2(
					config.i18n.dayOfMonthWithSuffix,
					true,
					_elm_lang$core$Date$day(d));
			case 'A':
				return config.i18n.dayName(
					_elm_lang$core$Date$dayOfWeek(d));
			case '^A':
				return _elm_lang$core$String$toUpper(
					config.i18n.dayName(
						_elm_lang$core$Date$dayOfWeek(d)));
			case 'a':
				return config.i18n.dayShort(
					_elm_lang$core$Date$dayOfWeek(d));
			case '^a':
				return _elm_lang$core$String$toUpper(
					config.i18n.dayShort(
						_elm_lang$core$Date$dayOfWeek(d)));
			case 'H':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr('0'),
					_elm_lang$core$Date$hour(d));
			case '-H':
				return _elm_lang$core$Basics$toString(
					_elm_lang$core$Date$hour(d));
			case 'k':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr(' '),
					_elm_lang$core$Date$hour(d));
			case 'I':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr('0'),
					_rluiten$elm_date_extra$Date_Extra_Format$hourMod12(
						_elm_lang$core$Date$hour(d)));
			case '-I':
				return _elm_lang$core$Basics$toString(
					_rluiten$elm_date_extra$Date_Extra_Format$hourMod12(
						_elm_lang$core$Date$hour(d)));
			case 'l':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr(' '),
					_rluiten$elm_date_extra$Date_Extra_Format$hourMod12(
						_elm_lang$core$Date$hour(d)));
			case 'p':
				return _elm_lang$core$String$toUpper(
					config.i18n.twelveHourPeriod(
						_rluiten$elm_date_extra$Date_Extra_TwelveHourClock$twelveHourPeriod(d)));
			case 'P':
				return config.i18n.twelveHourPeriod(
					_rluiten$elm_date_extra$Date_Extra_TwelveHourClock$twelveHourPeriod(d));
			case 'M':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr('0'),
					_elm_lang$core$Date$minute(d));
			case 'S':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr('0'),
					_elm_lang$core$Date$second(d));
			case 'L':
				return A3(
					_rluiten$elm_date_extra$Date_Extra_Format$padWithN,
					3,
					_elm_lang$core$Native_Utils.chr('0'),
					_elm_lang$core$Date$millisecond(d));
			case '%':
				return symbol;
			case 'z':
				return A2(_rluiten$elm_date_extra$Date_Extra_Format$formatOffsetStr, '', offset);
			case ':z':
				return A2(_rluiten$elm_date_extra$Date_Extra_Format$formatOffsetStr, ':', offset);
			case 'G':
				var _p4 = _rluiten$elm_date_extra$Date_Extra_Utils$isoWeek(d);
				return A3(
					_rluiten$elm_date_extra$Date_Extra_Format$padWithN,
					3,
					_elm_lang$core$Native_Utils.chr('0'),
					_p4._0);
			case 'V':
				var _p5 = _rluiten$elm_date_extra$Date_Extra_Utils$isoWeek(d);
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr('0'),
					_p5._1);
			case '-V':
				var _p6 = _rluiten$elm_date_extra$Date_Extra_Utils$isoWeek(d);
				return _elm_lang$core$Basics$toString(_p6._1);
			case 'u':
				var _p7 = _rluiten$elm_date_extra$Date_Extra_Utils$isoWeek(d);
				return _elm_lang$core$Basics$toString(_p7._2);
			default:
				return '';
		}
	});
var _rluiten$elm_date_extra$Date_Extra_Format$formatRegex = _elm_lang$core$Regex$regex('%(y|Y|m|_m|-m|B|^B|b|^b|d|-d|-@d|e|@e|A|^A|a|^a|H|-H|k|I|-I|l|p|P|M|S|%|L|z|:z|G|V|-V|u)');
var _rluiten$elm_date_extra$Date_Extra_Format$formatOffset = F4(
	function (config, targetOffset, formatStr, date) {
		var dateOffset = _rluiten$elm_date_extra$Date_Extra_Create$getTimezoneOffset(date);
		var hackOffset = dateOffset - targetOffset;
		return A4(
			_elm_lang$core$Regex$replace,
			_elm_lang$core$Regex$All,
			_rluiten$elm_date_extra$Date_Extra_Format$formatRegex,
			A3(
				_rluiten$elm_date_extra$Date_Extra_Format$formatToken,
				config,
				targetOffset,
				A2(_rluiten$elm_date_extra$Date_Extra_Internal$hackDateAsOffset, hackOffset, date)),
			formatStr);
	});
var _rluiten$elm_date_extra$Date_Extra_Format$format = F3(
	function (config, formatStr, date) {
		return A4(
			_rluiten$elm_date_extra$Date_Extra_Format$formatOffset,
			config,
			_rluiten$elm_date_extra$Date_Extra_Create$getTimezoneOffset(date),
			formatStr,
			date);
	});
var _rluiten$elm_date_extra$Date_Extra_Format$formatUtc = F3(
	function (config, formatStr, date) {
		return A4(_rluiten$elm_date_extra$Date_Extra_Format$formatOffset, config, 0, formatStr, date);
	});
var _rluiten$elm_date_extra$Date_Extra_Format$isoDateString = function (date) {
	var day = _elm_lang$core$Date$day(date);
	var month = _elm_lang$core$Date$month(date);
	var year = _elm_lang$core$Date$year(date);
	return A2(
		_elm_lang$core$Basics_ops['++'],
		A3(
			_elm_lang$core$String$padLeft,
			4,
			_elm_lang$core$Native_Utils.chr('0'),
			_elm_lang$core$Basics$toString(year)),
		A2(
			_elm_lang$core$Basics_ops['++'],
			'-',
			A2(
				_elm_lang$core$Basics_ops['++'],
				A3(
					_elm_lang$core$String$padLeft,
					2,
					_elm_lang$core$Native_Utils.chr('0'),
					_elm_lang$core$Basics$toString(
						_rluiten$elm_date_extra$Date_Extra_Core$monthToInt(month))),
				A2(
					_elm_lang$core$Basics_ops['++'],
					'-',
					A3(
						_elm_lang$core$String$padLeft,
						2,
						_elm_lang$core$Native_Utils.chr('0'),
						_elm_lang$core$Basics$toString(day))))));
};
var _rluiten$elm_date_extra$Date_Extra_Format$utcIsoDateString = function (date) {
	return _rluiten$elm_date_extra$Date_Extra_Format$isoDateString(
		_rluiten$elm_date_extra$Date_Extra_Internal$hackDateAsUtc(date));
};
var _rluiten$elm_date_extra$Date_Extra_Format$yearInt = function (year) {
	return A3(
		_elm_lang$core$String$padLeft,
		4,
		_elm_lang$core$Native_Utils.chr('0'),
		_elm_lang$core$Basics$toString(year));
};
var _rluiten$elm_date_extra$Date_Extra_Format$year = function (date) {
	return A3(
		_elm_lang$core$String$padLeft,
		4,
		_elm_lang$core$Native_Utils.chr('0'),
		_elm_lang$core$Basics$toString(
			_elm_lang$core$Date$year(date)));
};
var _rluiten$elm_date_extra$Date_Extra_Format$monthMonth = function (month) {
	return A3(
		_elm_lang$core$String$padLeft,
		2,
		_elm_lang$core$Native_Utils.chr('0'),
		_elm_lang$core$Basics$toString(
			_rluiten$elm_date_extra$Date_Extra_Core$monthToInt(month)));
};
var _rluiten$elm_date_extra$Date_Extra_Format$month = function (date) {
	return A3(
		_elm_lang$core$String$padLeft,
		2,
		_elm_lang$core$Native_Utils.chr('0'),
		_elm_lang$core$Basics$toString(
			_rluiten$elm_date_extra$Date_Extra_Core$monthToInt(
				_elm_lang$core$Date$month(date))));
};
var _rluiten$elm_date_extra$Date_Extra_Format$isoTimeFormat = '%H:%M:%S';
var _rluiten$elm_date_extra$Date_Extra_Format$isoDateFormat = '%Y-%m-%d';
var _rluiten$elm_date_extra$Date_Extra_Format$isoMsecOffsetFormat = '%Y-%m-%dT%H:%M:%S.%L%:z';
var _rluiten$elm_date_extra$Date_Extra_Format$isoString = A2(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, _rluiten$elm_date_extra$Date_Extra_Format$isoMsecOffsetFormat);
var _rluiten$elm_date_extra$Date_Extra_Format$isoOffsetFormat = '%Y-%m-%dT%H:%M:%S%z';
var _rluiten$elm_date_extra$Date_Extra_Format$isoMsecFormat = '%Y-%m-%dT%H:%M:%S.%L';
var _rluiten$elm_date_extra$Date_Extra_Format$isoStringNoOffset = A2(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, _rluiten$elm_date_extra$Date_Extra_Format$isoMsecFormat);
var _rluiten$elm_date_extra$Date_Extra_Format$utcIsoString = function (date) {
	return A2(
		_elm_lang$core$Basics_ops['++'],
		A3(_rluiten$elm_date_extra$Date_Extra_Format$formatUtc, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, _rluiten$elm_date_extra$Date_Extra_Format$isoMsecFormat, date),
		'Z');
};
var _rluiten$elm_date_extra$Date_Extra_Format$isoFormat = '%Y-%m-%dT%H:%M:%S';

var _rtfeldman$elm_validate$Validate$validEmail = _elm_lang$core$Regex$caseInsensitive(
	_elm_lang$core$Regex$regex('^[a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$'));
var _rtfeldman$elm_validate$Validate$lacksNonWhitespaceChars = _elm_lang$core$Regex$regex('^\\s*$');
var _rtfeldman$elm_validate$Validate$isInt = function (str) {
	var _p0 = _elm_lang$core$String$toInt(str);
	if (_p0.ctor === 'Ok') {
		return true;
	} else {
		return false;
	}
};
var _rtfeldman$elm_validate$Validate$isValidEmail = function (email) {
	return A2(_elm_lang$core$Regex$contains, _rtfeldman$elm_validate$Validate$validEmail, email);
};
var _rtfeldman$elm_validate$Validate$isBlank = function (str) {
	return A2(_elm_lang$core$Regex$contains, _rtfeldman$elm_validate$Validate$lacksNonWhitespaceChars, str);
};
var _rtfeldman$elm_validate$Validate$any = F2(
	function (validators, subject) {
		any:
		while (true) {
			var _p1 = validators;
			if (_p1.ctor === '[]') {
				return true;
			} else {
				var _p2 = _p1._0._0(subject);
				if (_p2.ctor === '[]') {
					var _v3 = _p1._1,
						_v4 = subject;
					validators = _v3;
					subject = _v4;
					continue any;
				} else {
					return false;
				}
			}
		}
	});
var _rtfeldman$elm_validate$Validate$firstErrorHelp = F2(
	function (validators, subject) {
		firstErrorHelp:
		while (true) {
			var _p3 = validators;
			if (_p3.ctor === '[]') {
				return {ctor: '[]'};
			} else {
				var _p4 = _p3._0._0(subject);
				if (_p4.ctor === '[]') {
					var _v7 = _p3._1,
						_v8 = subject;
					validators = _v7;
					subject = _v8;
					continue firstErrorHelp;
				} else {
					return _p4;
				}
			}
		}
	});
var _rtfeldman$elm_validate$Validate$validate = F2(
	function (_p5, subject) {
		var _p6 = _p5;
		return _p6._0(subject);
	});
var _rtfeldman$elm_validate$Validate$Validator = function (a) {
	return {ctor: 'Validator', _0: a};
};
var _rtfeldman$elm_validate$Validate$ifTrue = F2(
	function (test, error) {
		var getErrors = function (subject) {
			return test(subject) ? {
				ctor: '::',
				_0: error,
				_1: {ctor: '[]'}
			} : {ctor: '[]'};
		};
		return _rtfeldman$elm_validate$Validate$Validator(getErrors);
	});
var _rtfeldman$elm_validate$Validate$ifBlank = F2(
	function (subjectToString, error) {
		return A2(
			_rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return _rtfeldman$elm_validate$Validate$isBlank(
					subjectToString(subject));
			},
			error);
	});
var _rtfeldman$elm_validate$Validate$ifEmptyList = F2(
	function (subjectToList, error) {
		return A2(
			_rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return _elm_lang$core$List$isEmpty(
					subjectToList(subject));
			},
			error);
	});
var _rtfeldman$elm_validate$Validate$ifEmptyDict = F2(
	function (subjectToDict, error) {
		return A2(
			_rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return _elm_lang$core$Dict$isEmpty(
					subjectToDict(subject));
			},
			error);
	});
var _rtfeldman$elm_validate$Validate$ifEmptySet = F2(
	function (subjectToSet, error) {
		return A2(
			_rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return _elm_lang$core$Set$isEmpty(
					subjectToSet(subject));
			},
			error);
	});
var _rtfeldman$elm_validate$Validate$ifNothing = F2(
	function (subjectToMaybe, error) {
		return A2(
			_rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return _elm_lang$core$Native_Utils.eq(
					subjectToMaybe(subject),
					_elm_lang$core$Maybe$Nothing);
			},
			error);
	});
var _rtfeldman$elm_validate$Validate$ifFalse = F2(
	function (test, error) {
		var getErrors = function (subject) {
			return test(subject) ? {ctor: '[]'} : {
				ctor: '::',
				_0: error,
				_1: {ctor: '[]'}
			};
		};
		return _rtfeldman$elm_validate$Validate$Validator(getErrors);
	});
var _rtfeldman$elm_validate$Validate$ifNotInt = F2(
	function (subjectToString, error) {
		return A2(
			_rtfeldman$elm_validate$Validate$ifFalse,
			function (subject) {
				return _rtfeldman$elm_validate$Validate$isInt(
					subjectToString(subject));
			},
			error);
	});
var _rtfeldman$elm_validate$Validate$ifInvalidEmail = F2(
	function (subjectToEmail, error) {
		return A2(
			_rtfeldman$elm_validate$Validate$ifFalse,
			function (subject) {
				return _rtfeldman$elm_validate$Validate$isValidEmail(
					subjectToEmail(subject));
			},
			error);
	});
var _rtfeldman$elm_validate$Validate$all = function (validators) {
	var newGetErrors = function (subject) {
		var accumulateErrors = F2(
			function (_p7, totalErrors) {
				var _p8 = _p7;
				return A2(
					_elm_lang$core$Basics_ops['++'],
					totalErrors,
					_p8._0(subject));
			});
		return A3(
			_elm_lang$core$List$foldl,
			accumulateErrors,
			{ctor: '[]'},
			validators);
	};
	return _rtfeldman$elm_validate$Validate$Validator(newGetErrors);
};
var _rtfeldman$elm_validate$Validate$firstError = function (validators) {
	var getErrors = function (subject) {
		return A2(_rtfeldman$elm_validate$Validate$firstErrorHelp, validators, subject);
	};
	return _rtfeldman$elm_validate$Validate$Validator(getErrors);
};

var _user$project$Flags$Flags = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return function (p) {
																return function (q) {
																	return function (r) {
																		return function (s) {
																			return function (t) {
																				return function (u) {
																					return function (v) {
																						return function (w) {
																							return function (x) {
																								return function (y) {
																									return function (z) {
																										return function (_1) {
																											return function (_2) {
																												return function (_3) {
																													return function (_4) {
																														return function (_5) {
																															return function (_6) {
																																return function (_7) {
																																	return function (_8) {
																																		return function (_9) {
																																			return function (_10) {
																																				return function (_11) {
																																					return function (_12) {
																																						return function (_13) {
																																							return function (_14) {
																																								return function (_15) {
																																									return function (_16) {
																																										return function (_17) {
																																											return function (_18) {
																																												return function (_19) {
																																													return function (_20) {
																																														return function (_21) {
																																															return function (_22) {
																																																return function (_23) {
																																																	return function (_24) {
																																																		return function (_25) {
																																																			return function (_26) {
																																																				return function (_27) {
																																																					return function (_28) {
																																																						return function (_29) {
																																																							return function (_30) {
																																																								return function (_31) {
																																																									return function (_32) {
																																																										return function (_33) {
																																																											return function (_34) {
																																																												return function (_35) {
																																																													return function (_36) {
																																																														return function (_37) {
																																																															return function (_38) {
																																																																return function (_39) {
																																																																	return function (_40) {
																																																																		return function (_41) {
																																																																			return function (_42) {
																																																																				return function (_43) {
																																																																					return function (_44) {
																																																																						return function (_45) {
																																																																							return function (_46) {
																																																																								return function (_47) {
																																																																									return function (_48) {
																																																																										return function (_49) {
																																																																											return function (_50) {
																																																																												return function (_51) {
																																																																													return function (_52) {
																																																																														return function (_53) {
																																																																															return function (_54) {
																																																																																return function (_55) {
																																																																																	return function (_56) {
																																																																																		return function (_57) {
																																																																																			return function (_58) {
																																																																																				return function (_59) {
																																																																																					return function (_60) {
																																																																																						return function (_61) {
																																																																																							return function (_62) {
																																																																																								return function (_63) {
																																																																																									return function (_64) {
																																																																																										return function (_65) {
																																																																																											return function (_66) {
																																																																																												return function (_67) {
																																																																																													return function (_68) {
																																																																																														return function (_69) {
																																																																																															return function (_70) {
																																																																																																return function (_71) {
																																																																																																	return function (_72) {
																																																																																																		return function (_73) {
																																																																																																			return function (_74) {
																																																																																																				return function (_75) {
																																																																																																					return function (_76) {
																																																																																																						return function (_77) {
																																																																																																							return function (_78) {
																																																																																																								return function (_79) {
																																																																																																									return function (_80) {
																																																																																																										return function (_81) {
																																																																																																											return function (_82) {
																																																																																																												return function (_83) {
																																																																																																													return function (_84) {
																																																																																																														return function (_85) {
																																																																																																															return function (_86) {
																																																																																																																return function (_87) {
																																																																																																																	return function (_88) {
																																																																																																																		return function (_89) {
																																																																																																																			return function (_90) {
																																																																																																																				return function (_91) {
																																																																																																																					return function (_92) {
																																																																																																																						return function (_93) {
																																																																																																																							return function (_94) {
																																																																																																																								return function (_95) {
																																																																																																																									return function (_96) {
																																																																																																																										return function (_97) {
																																																																																																																											return function (_98) {
																																																																																																																												return function (_99) {
																																																																																																																													return function (_100) {
																																																																																																																														return function (_101) {
																																																																																																																															return function (_102) {
																																																																																																																																return function (_103) {
																																																																																																																																	return function (_104) {
																																																																																																																																		return function (_105) {
																																																																																																																																			return function (_106) {
																																																																																																																																				return function (_107) {
																																																																																																																																					return function (_108) {
																																																																																																																																						return function (_109) {
																																																																																																																																							return function (_110) {
																																																																																																																																								return function (_111) {
																																																																																																																																									return function (_112) {
																																																																																																																																										return function (_113) {
																																																																																																																																											return function (_114) {
																																																																																																																																												return function (_115) {
																																																																																																																																													return function (_116) {
																																																																																																																																														return function (_117) {
																																																																																																																																															return function (_118) {
																																																																																																																																																return function (_119) {
																																																																																																																																																	return function (_120) {
																																																																																																																																																		return function (_121) {
																																																																																																																																																			return function (_122) {
																																																																																																																																																				return function (_123) {
																																																																																																																																																					return function (_124) {
																																																																																																																																																						return function (_125) {
																																																																																																																																																							return function (_126) {
																																																																																																																																																								return function (_127) {
																																																																																																																																																									return function (_128) {
																																																																																																																																																										return function (_129) {
																																																																																																																																																											return function (_130) {
																																																																																																																																																												return function (_131) {
																																																																																																																																																													return function (_132) {
																																																																																																																																																														return function (_133) {
																																																																																																																																																															return function (_134) {
																																																																																																																																																																return function (_135) {
																																																																																																																																																																	return function (_136) {
																																																																																																																																																																		return function (_137) {
																																																																																																																																																																			return function (_138) {
																																																																																																																																																																				return function (_139) {
																																																																																																																																																																					return function (_140) {
																																																																																																																																																																						return function (_141) {
																																																																																																																																																																							return function (_142) {
																																																																																																																																																																								return function (_143) {
																																																																																																																																																																									return function (_144) {
																																																																																																																																																																										return function (_145) {
																																																																																																																																																																											return function (_146) {
																																																																																																																																																																												return function (_147) {
																																																																																																																																																																													return function (_148) {
																																																																																																																																																																														return function (_149) {
																																																																																																																																																																															return function (_150) {
																																																																																																																																																																																return function (_151) {
																																																																																																																																																																																	return function (_152) {
																																																																																																																																																																																		return function (_153) {
																																																																																																																																																																																			return function (_154) {
																																																																																																																																																																																				return function (_155) {
																																																																																																																																																																																					return function (_156) {
																																																																																																																																																																																						return function (_157) {
																																																																																																																																																																																							return function (_158) {
																																																																																																																																																																																								return function (_159) {
																																																																																																																																																																																									return function (_160) {
																																																																																																																																																																																										return function (_161) {
																																																																																																																																																																																											return function (_162) {
																																																																																																																																																																																												return function (_163) {
																																																																																																																																																																																													return function (_164) {
																																																																																																																																																																																														return function (_165) {
																																																																																																																																																																																															return function (_166) {
																																																																																																																																																																																																return function (_167) {
																																																																																																																																																																																																	return function (_168) {
																																																																																																																																																																																																		return function (_169) {
																																																																																																																																																																																																			return function (_170) {
																																																																																																																																																																																																				return {accessToken: a, userEmail: b, readOnly: c, clients: d, activeClient: e, reportFileService: f, haloLiteApi: g, termsAndConditions: h, i18nAccessDenied: i, i18nActive: j, i18nAdd: k, i18nAddParticipants: l, i18nAddParticipantsModalDescription: m, i18nAddParticipantsToStartProject: n, i18nAddReport: o, i18nAFewSecondsAgo: p, i18nAllProjects: q, i18nAlreadySelectedReportContainedInPackage: r, i18nApr: s, i18nApril: t, i18nAssessments: u, i18nAug: v, i18nAugust: w, i18nBackToProjectDashboard: x, i18nBackToProjectDetail: y, i18nCancel: z, i18nChangeBillableSettingWarning: _1, i18nClickHereToDownloadIds: _2, i18nComplete: _3, i18nCompleted: _4, i18nContactSupport: _5, i18nContinueWith: _6, i18nCreated: _7, i18nCreatedDate: _8, i18nCurrent: _9, i18nDateFormat: _10, i18nDaysAgoFormat: _11, i18nDec: _12, i18nDecember: _13, i18nDownload: _14, i18nDownloadReport: _15, i18nDownloadReports: _16, i18nDownloadUnusedIds: _17, i18nDraft: _18, i18nDuplicateEmailAddressForProjectParticipant: _19, i18nEdit: _20, i18nEditReports: _21, i18nEmail: _22, i18nEmailAddress: _23, i18nEmailContainsDoubleDot: _24, i18nEmailFailed: _25, i18nEmailInvalid: _26, i18nEmailLacksDotInDomain: _27, i18nEmailRequired: _28, i18nEmailSuccess: _29, i18nEmailSuccessfullySent: _30, i18nEmailTooLong: _31, i18nEmptyWarning: _32, i18nEnterEmailAddress: _33, i18nEnterValueWithinRange: _34, i18nError: _35, i18nErrorSavingEmail: _36, i18nErrorWithRequest: _37, i18nExitMessage: _38, i18nExitWithoutSaving: _39, i18nFailedToSend: _40, i18nFailedToSendEmail: _41, i18nFeb: _42, i18nFebruary: _43, i18nFirstName: _44, i18nFirstNameRequired: _45, i18nFri: _46, i18nFriday: _47, i18nGenerateIds: _48, i18nGenerateNewIds: _49, i18nGenerateIdsTitle: _50, i18nGenericError: _51, i18nGoBack: _52, i18nGoToParticipantsPage: _53, i18nHelpfulLinks: _54, i18nHoganIdWithOctothorpe: _55, i18nHoganIdWithoutOctothorpe: _56, i18nHoganPrivacyPolicy: _57, i18nHoursAgoFormat: _58, i18nInactive: _59, i18nInvalidEmailAddress: _60, i18nInviteParticipants: _61, i18nJan: _62, i18nJanuary: _63, i18nJobProfile: _64, i18nJul: _65, i18nJuly: _66, i18nJun: _67, i18nJune: _68, i18nLanguage: _69, i18nLanguages: _70, i18nLastName: _71, i18nLastNameCannotBeAsterisk: _72, i18nLastNameRequired: _73, i18nLoadingMessage: _74, i18nLoadingParticipants: _75, i18nLoadingProjects: _76, i18nClients: _77, i18nLoggedInAs: _78, i18nLogout: _79, i18nMar: _80, i18nMarch: _81, i18nMay: _82, i18nMinutesAgoFormat: _83, i18nModifyReports: _84, i18nMon: _85, i18nMonday: _86, i18nMonthsAgoFormat: _87, i18nMyReports: _88, i18nName: _89, i18nNameContainsInvalidCharacters: _90, i18nNameDuplicate: _91, i18nNameLength: _92, i18nNameRequired: _93, i18nNameIsConfigure: _94, i18nNewProject: _95, i18nProjectInformation: _96, i18nNext: _97, i18nNoParticipants: _98, i18nNoProjects: _99, i18nNoResultsWereFound: _100, i18nNorm: _101, i18nNotice: _102, i18nNotificationsFor: _103, i18nNotificationsMessage: _104, i18nNov: _105, i18nNovember: _106, i18nNumberOfIdsToGenerate: _107, i18nOct: _108, i18nOctober: _109, i18nOk: _110, i18nOneDayAgo: _111, i18nOneHourAgo: _112, i18nOneMinuteAgo: _113, i18nOneMonthAgo: _114, i18nOneWeekAgo: _115, i18nOneYearAgo: _116, i18nParticipant: _117, i18nParticipants: _118, i18nParticipantsHaveBeenAddedAndInvitationsSent: _119, i18nParticipantStatus: _120, i18nPending: _121, i18nPleaseSelectReports: _122, i18nProgressCounter: _123, i18nProject: _124, i18nProjectNameValidationHint: _125, i18nProjects: _126, i18nProjectTitle: _127, i18nRemoveReport: _128, i18nReports: _129, i18nRescoreReport: _130, i18nRescoreReportInProgress: _131, i18nResendInvitation: _132, i18nSat: _133, i18nSaturday: _134, i18nSave: _135, i18nSaveChanges: _136, i18nSearch: _137, i18nSearchParticipantsFor: _138, i18nSelectedReports: _139, i18nSelectReportPrompt: _140, i18nSendReminder: _141, i18nSendSampleInvitation: _142, i18nSent: _143, i18nSep: _144, i18nSeptember: _145, i18nSettings: _146, i18nStatus: _147, i18nSun: _148, i18nSunday: _149, i18nTermsOfUse: _150, i18nTheseChangesWillNotImpactGeneratedReports: _151, i18nThisEmailIsInvalid: _152, i18nThurs: _153, i18nThursday: _154, i18nToggleNavigationLore: _155, i18nTues: _156, i18nTuesday: _157, i18nUniqueIdWithOctothorpe: _158, i18nUpdateAllReports: _159, i18nUser: _160, i18nUserGuide: _161, i18nViewReportOptionsText: _162, i18nWed: _163, i18nWednesday: _164, i18nWeeksAgoFormat: _165, i18nYearsAgoFormat: _166, i18nYouHaveChosenToMakeBillableChangesToGeneratedReports: _167, i18nYouHaveChoseToUpdateGeneratedReports: _168, i18nYouHaveSuccessfullyGeneratedIds: _169, i18nYouMustAddReports: _170};
																																																																																																																																																																																																			};
																																																																																																																																																																																																		};
																																																																																																																																																																																																	};
																																																																																																																																																																																																};
																																																																																																																																																																																															};
																																																																																																																																																																																														};
																																																																																																																																																																																													};
																																																																																																																																																																																												};
																																																																																																																																																																																											};
																																																																																																																																																																																										};
																																																																																																																																																																																									};
																																																																																																																																																																																								};
																																																																																																																																																																																							};
																																																																																																																																																																																						};
																																																																																																																																																																																					};
																																																																																																																																																																																				};
																																																																																																																																																																																			};
																																																																																																																																																																																		};
																																																																																																																																																																																	};
																																																																																																																																																																																};
																																																																																																																																																																															};
																																																																																																																																																																														};
																																																																																																																																																																													};
																																																																																																																																																																												};
																																																																																																																																																																											};
																																																																																																																																																																										};
																																																																																																																																																																									};
																																																																																																																																																																								};
																																																																																																																																																																							};
																																																																																																																																																																						};
																																																																																																																																																																					};
																																																																																																																																																																				};
																																																																																																																																																																			};
																																																																																																																																																																		};
																																																																																																																																																																	};
																																																																																																																																																																};
																																																																																																																																																															};
																																																																																																																																																														};
																																																																																																																																																													};
																																																																																																																																																												};
																																																																																																																																																											};
																																																																																																																																																										};
																																																																																																																																																									};
																																																																																																																																																								};
																																																																																																																																																							};
																																																																																																																																																						};
																																																																																																																																																					};
																																																																																																																																																				};
																																																																																																																																																			};
																																																																																																																																																		};
																																																																																																																																																	};
																																																																																																																																																};
																																																																																																																																															};
																																																																																																																																														};
																																																																																																																																													};
																																																																																																																																												};
																																																																																																																																											};
																																																																																																																																										};
																																																																																																																																									};
																																																																																																																																								};
																																																																																																																																							};
																																																																																																																																						};
																																																																																																																																					};
																																																																																																																																				};
																																																																																																																																			};
																																																																																																																																		};
																																																																																																																																	};
																																																																																																																																};
																																																																																																																															};
																																																																																																																														};
																																																																																																																													};
																																																																																																																												};
																																																																																																																											};
																																																																																																																										};
																																																																																																																									};
																																																																																																																								};
																																																																																																																							};
																																																																																																																						};
																																																																																																																					};
																																																																																																																				};
																																																																																																																			};
																																																																																																																		};
																																																																																																																	};
																																																																																																																};
																																																																																																															};
																																																																																																														};
																																																																																																													};
																																																																																																												};
																																																																																																											};
																																																																																																										};
																																																																																																									};
																																																																																																								};
																																																																																																							};
																																																																																																						};
																																																																																																					};
																																																																																																				};
																																																																																																			};
																																																																																																		};
																																																																																																	};
																																																																																																};
																																																																																															};
																																																																																														};
																																																																																													};
																																																																																												};
																																																																																											};
																																																																																										};
																																																																																									};
																																																																																								};
																																																																																							};
																																																																																						};
																																																																																					};
																																																																																				};
																																																																																			};
																																																																																		};
																																																																																	};
																																																																																};
																																																																															};
																																																																														};
																																																																													};
																																																																												};
																																																																											};
																																																																										};
																																																																									};
																																																																								};
																																																																							};
																																																																						};
																																																																					};
																																																																				};
																																																																			};
																																																																		};
																																																																	};
																																																																};
																																																															};
																																																														};
																																																													};
																																																												};
																																																											};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};

var _user$project$I18n$dayOfMonthWithSuffix = F2(
	function (pad, day) {
		return _elm_lang$core$Basics$toString(day);
	});
var _user$project$I18n$monthShort = F2(
	function (flags, month) {
		var _p0 = month;
		switch (_p0.ctor) {
			case 'Jan':
				return flags.i18nJan;
			case 'Feb':
				return flags.i18nFeb;
			case 'Mar':
				return flags.i18nMar;
			case 'Apr':
				return flags.i18nApr;
			case 'May':
				return flags.i18nMay;
			case 'Jun':
				return flags.i18nJun;
			case 'Jul':
				return flags.i18nJul;
			case 'Aug':
				return flags.i18nAug;
			case 'Sep':
				return flags.i18nSep;
			case 'Oct':
				return flags.i18nOct;
			case 'Nov':
				return flags.i18nNov;
			default:
				return flags.i18nDec;
		}
	});
var _user$project$I18n$monthName = F2(
	function (flags, month) {
		var _p1 = month;
		switch (_p1.ctor) {
			case 'Jan':
				return flags.i18nJanuary;
			case 'Feb':
				return flags.i18nFebruary;
			case 'Mar':
				return flags.i18nMarch;
			case 'Apr':
				return flags.i18nApril;
			case 'May':
				return flags.i18nMay;
			case 'Jun':
				return flags.i18nJune;
			case 'Jul':
				return flags.i18nJuly;
			case 'Aug':
				return flags.i18nAugust;
			case 'Sep':
				return flags.i18nSeptember;
			case 'Oct':
				return flags.i18nOctober;
			case 'Nov':
				return flags.i18nNovember;
			default:
				return flags.i18nDecember;
		}
	});
var _user$project$I18n$dayShort = F2(
	function (flags, day) {
		var _p2 = day;
		switch (_p2.ctor) {
			case 'Mon':
				return flags.i18nMon;
			case 'Tue':
				return flags.i18nTues;
			case 'Wed':
				return flags.i18nWed;
			case 'Thu':
				return flags.i18nThurs;
			case 'Fri':
				return flags.i18nFri;
			case 'Sat':
				return flags.i18nSat;
			default:
				return flags.i18nSun;
		}
	});
var _user$project$I18n$dayName = F2(
	function (flags, day) {
		var _p3 = day;
		switch (_p3.ctor) {
			case 'Mon':
				return flags.i18nMonday;
			case 'Tue':
				return flags.i18nTuesday;
			case 'Wed':
				return flags.i18nWednesday;
			case 'Thu':
				return flags.i18nThursday;
			case 'Fri':
				return flags.i18nFriday;
			case 'Sat':
				return flags.i18nSaturday;
			default:
				return flags.i18nSunday;
		}
	});
var _user$project$I18n$createDateFormatConfig = function (flags) {
	return A2(
		_rluiten$elm_date_extra$Date_Extra_Config$Config,
		{
			dayShort: _user$project$I18n$dayShort(flags),
			dayName: _user$project$I18n$dayName(flags),
			monthShort: _user$project$I18n$monthShort(flags),
			monthName: _user$project$I18n$monthName(flags),
			dayOfMonthWithSuffix: _user$project$I18n$dayOfMonthWithSuffix,
			twelveHourPeriod: _rluiten$elm_date_extra$Date_Extra_I18n_I_default$twelveHourPeriod
		},
		{date: '', longDate: flags.i18nDateFormat, time: '', longTime: '', dateTime: '', firstDayOfWeek: _elm_lang$core$Date$Mon});
};
var _user$project$I18n$I18n = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return function (p) {
																return function (q) {
																	return function (r) {
																		return function (s) {
																			return function (t) {
																				return function (u) {
																					return function (v) {
																						return function (w) {
																							return function (x) {
																								return function (y) {
																									return function (z) {
																										return function (_1) {
																											return function (_2) {
																												return function (_3) {
																													return function (_4) {
																														return function (_5) {
																															return function (_6) {
																																return function (_7) {
																																	return function (_8) {
																																		return function (_9) {
																																			return function (_10) {
																																				return function (_11) {
																																					return function (_12) {
																																						return function (_13) {
																																							return function (_14) {
																																								return function (_15) {
																																									return function (_16) {
																																										return function (_17) {
																																											return function (_18) {
																																												return function (_19) {
																																													return function (_20) {
																																														return function (_21) {
																																															return function (_22) {
																																																return function (_23) {
																																																	return function (_24) {
																																																		return function (_25) {
																																																			return function (_26) {
																																																				return function (_27) {
																																																					return function (_28) {
																																																						return function (_29) {
																																																							return function (_30) {
																																																								return function (_31) {
																																																									return function (_32) {
																																																										return function (_33) {
																																																											return function (_34) {
																																																												return function (_35) {
																																																													return function (_36) {
																																																														return function (_37) {
																																																															return function (_38) {
																																																																return function (_39) {
																																																																	return function (_40) {
																																																																		return function (_41) {
																																																																			return function (_42) {
																																																																				return function (_43) {
																																																																					return function (_44) {
																																																																						return function (_45) {
																																																																							return function (_46) {
																																																																								return function (_47) {
																																																																									return function (_48) {
																																																																										return function (_49) {
																																																																											return function (_50) {
																																																																												return function (_51) {
																																																																													return function (_52) {
																																																																														return function (_53) {
																																																																															return function (_54) {
																																																																																return function (_55) {
																																																																																	return function (_56) {
																																																																																		return function (_57) {
																																																																																			return function (_58) {
																																																																																				return function (_59) {
																																																																																					return function (_60) {
																																																																																						return function (_61) {
																																																																																							return function (_62) {
																																																																																								return function (_63) {
																																																																																									return function (_64) {
																																																																																										return function (_65) {
																																																																																											return function (_66) {
																																																																																												return function (_67) {
																																																																																													return function (_68) {
																																																																																														return function (_69) {
																																																																																															return function (_70) {
																																																																																																return function (_71) {
																																																																																																	return function (_72) {
																																																																																																		return function (_73) {
																																																																																																			return function (_74) {
																																																																																																				return function (_75) {
																																																																																																					return function (_76) {
																																																																																																						return function (_77) {
																																																																																																							return function (_78) {
																																																																																																								return function (_79) {
																																																																																																									return function (_80) {
																																																																																																										return function (_81) {
																																																																																																											return function (_82) {
																																																																																																												return function (_83) {
																																																																																																													return function (_84) {
																																																																																																														return function (_85) {
																																																																																																															return function (_86) {
																																																																																																																return function (_87) {
																																																																																																																	return function (_88) {
																																																																																																																		return function (_89) {
																																																																																																																			return function (_90) {
																																																																																																																				return function (_91) {
																																																																																																																					return function (_92) {
																																																																																																																						return function (_93) {
																																																																																																																							return function (_94) {
																																																																																																																								return function (_95) {
																																																																																																																									return function (_96) {
																																																																																																																										return function (_97) {
																																																																																																																											return function (_98) {
																																																																																																																												return function (_99) {
																																																																																																																													return function (_100) {
																																																																																																																														return function (_101) {
																																																																																																																															return function (_102) {
																																																																																																																																return function (_103) {
																																																																																																																																	return function (_104) {
																																																																																																																																		return function (_105) {
																																																																																																																																			return function (_106) {
																																																																																																																																				return function (_107) {
																																																																																																																																					return function (_108) {
																																																																																																																																						return function (_109) {
																																																																																																																																							return function (_110) {
																																																																																																																																								return function (_111) {
																																																																																																																																									return function (_112) {
																																																																																																																																										return function (_113) {
																																																																																																																																											return function (_114) {
																																																																																																																																												return function (_115) {
																																																																																																																																													return function (_116) {
																																																																																																																																														return function (_117) {
																																																																																																																																															return function (_118) {
																																																																																																																																																return function (_119) {
																																																																																																																																																	return function (_120) {
																																																																																																																																																		return function (_121) {
																																																																																																																																																			return function (_122) {
																																																																																																																																																				return function (_123) {
																																																																																																																																																					return function (_124) {
																																																																																																																																																						return function (_125) {
																																																																																																																																																							return {accessDenied: a, active: b, add: c, addParticipants: d, addParticipantsModalDescription: e, addParticipantsToStartProject: f, addReport: g, aFewSecondsAgo: h, allProjects: i, alreadySelectedReportContainedInPackage: j, assessments: k, backToProjectDashboard: l, backToProjectDetail: m, cancel: n, changeBillableSettingWarning: o, clickHereToDownloadIds: p, complete: q, completed: r, contactSupport: s, continueWith: t, created: u, createdDate: v, current: w, dateFormatConfig: x, daysAgoFormat: y, download: z, downloadReport: _1, downloadReports: _2, downloadUnusedIds: _3, draft: _4, duplicateEmailAddressForProjectParticipant: _5, edit: _6, editReports: _7, email: _8, emailAddress: _9, emailContainsDoubleDot: _10, emailFailed: _11, emailInvalid: _12, emailLacksDotInDomain: _13, emailRequired: _14, emailSuccessfullySent: _15, emailSuccessTo: _16, emailTooLong: _17, emptyWarning: _18, enterEmailAddress: _19, enterValueWithinRange: _20, error: _21, errorSavingEmail: _22, errorWithRequest: _23, exitMessage: _24, exitWithoutSaving: _25, failedToSend: _26, failedToSendEmail: _27, firstName: _28, firstNameRequired: _29, generateIds: _30, generateNewIds: _31, generateIdsTitle: _32, genericError: _33, goBack: _34, goToParticipantsPage: _35, helpfulLinks: _36, hoganIdWithOctothorpe: _37, hoganIdWithoutOctothorpe: _38, hoganPrivacyPolicy: _39, hoursAgoFormat: _40, inactive: _41, invalidEmailAddress: _42, inviteParticipants: _43, jobProfile: _44, language: _45, languages: _46, lastName: _47, lastNameCannotBeAsterisk: _48, lastNameRequired: _49, loadingMessage: _50, loadingParticipants: _51, loadingProjects: _52, clients: _53, loggedInAs: _54, logout: _55, minutesAgoFormat: _56, modifyReports: _57, monthsAgoFormat: _58, myReports: _59, name: _60, nameContainsInvalidCharacters: _61, nameDuplicate: _62, nameLength: _63, nameRequired: _64, nameIsConfigure: _65, newProject: _66, projectInformation: _67, next: _68, noParticipants: _69, noProjects: _70, noResultsWereFound: _71, norm: _72, notice: _73, notificationsFor: _74, notificationsMessage: _75, numberOfIdsToGenerate: _76, ok: _77, oneDayAgo: _78, oneHourAgo: _79, oneMinuteAgo: _80, oneMonthAgo: _81, oneWeekAgo: _82, oneYearAgo: _83, participant: _84, participants: _85, participantsHaveBeenAddedAndInvitationsSent: _86, participantStatus: _87, pending: _88, pleaseSelectReports: _89, progressCounter: _90, project: _91, projectNameValidationHint: _92, projects: _93, projectTitle: _94, removeReport: _95, reports: _96, rescoreReport: _97, rescoreReportInProgress: _98, resendInvitation: _99, save: _100, saveChanges: _101, search: _102, searchParticipantsFor: _103, selectedReports: _104, selectReportPrompt: _105, sendReminder: _106, sendSampleInvitation: _107, sent: _108, settings: _109, status: _110, termsOfUse: _111, theseChangesWillNotImpactGeneratedReports: _112, thisEmailIsInvalid: _113, toggleNavigationLore: _114, uniqueIdWithOctothorpe: _115, updateAllReports: _116, user: _117, userGuide: _118, viewReportOptionsText: _119, weeksAgoFormat: _120, yearsAgoFormat: _121, youHaveChosenToMakeBillableChangesToGeneratedReports: _122, youHaveChoseToUpdateGeneratedReports: _123, youHaveSuccessfullyGeneratedIds: _124, youMustAddReports: _125};
																																																																																																																																																						};
																																																																																																																																																					};
																																																																																																																																																				};
																																																																																																																																																			};
																																																																																																																																																		};
																																																																																																																																																	};
																																																																																																																																																};
																																																																																																																																															};
																																																																																																																																														};
																																																																																																																																													};
																																																																																																																																												};
																																																																																																																																											};
																																																																																																																																										};
																																																																																																																																									};
																																																																																																																																								};
																																																																																																																																							};
																																																																																																																																						};
																																																																																																																																					};
																																																																																																																																				};
																																																																																																																																			};
																																																																																																																																		};
																																																																																																																																	};
																																																																																																																																};
																																																																																																																															};
																																																																																																																														};
																																																																																																																													};
																																																																																																																												};
																																																																																																																											};
																																																																																																																										};
																																																																																																																									};
																																																																																																																								};
																																																																																																																							};
																																																																																																																						};
																																																																																																																					};
																																																																																																																				};
																																																																																																																			};
																																																																																																																		};
																																																																																																																	};
																																																																																																																};
																																																																																																															};
																																																																																																														};
																																																																																																													};
																																																																																																												};
																																																																																																											};
																																																																																																										};
																																																																																																									};
																																																																																																								};
																																																																																																							};
																																																																																																						};
																																																																																																					};
																																																																																																				};
																																																																																																			};
																																																																																																		};
																																																																																																	};
																																																																																																};
																																																																																															};
																																																																																														};
																																																																																													};
																																																																																												};
																																																																																											};
																																																																																										};
																																																																																									};
																																																																																								};
																																																																																							};
																																																																																						};
																																																																																					};
																																																																																				};
																																																																																			};
																																																																																		};
																																																																																	};
																																																																																};
																																																																															};
																																																																														};
																																																																													};
																																																																												};
																																																																											};
																																																																										};
																																																																									};
																																																																								};
																																																																							};
																																																																						};
																																																																					};
																																																																				};
																																																																			};
																																																																		};
																																																																	};
																																																																};
																																																															};
																																																														};
																																																													};
																																																												};
																																																											};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _user$project$I18n$i18n = function (flags) {
	return _user$project$I18n$I18n(flags.i18nAccessDenied)(flags.i18nActive)(flags.i18nAdd)(flags.i18nAddParticipants)(flags.i18nAddParticipantsModalDescription)(flags.i18nAddParticipantsToStartProject)(flags.i18nAddReport)(flags.i18nAFewSecondsAgo)(flags.i18nAllProjects)(flags.i18nAlreadySelectedReportContainedInPackage)(flags.i18nAssessments)(flags.i18nBackToProjectDashboard)(flags.i18nBackToProjectDetail)(flags.i18nCancel)(flags.i18nChangeBillableSettingWarning)(flags.i18nClickHereToDownloadIds)(flags.i18nComplete)(flags.i18nCompleted)(flags.i18nContactSupport)(flags.i18nContinueWith)(flags.i18nCreated)(flags.i18nCreatedDate)(flags.i18nCurrent)(
		_user$project$I18n$createDateFormatConfig(flags))(flags.i18nDaysAgoFormat)(flags.i18nDownload)(flags.i18nDownloadReport)(flags.i18nDownloadReports)(flags.i18nDownloadUnusedIds)(flags.i18nDraft)(flags.i18nDuplicateEmailAddressForProjectParticipant)(flags.i18nEdit)(flags.i18nEditReports)(flags.i18nEmail)(flags.i18nEmailAddress)(flags.i18nEmailContainsDoubleDot)(flags.i18nEmailFailed)(flags.i18nEmailInvalid)(flags.i18nEmailLacksDotInDomain)(flags.i18nEmailRequired)(flags.i18nEmailSuccessfullySent)(flags.i18nEmailSuccess)(flags.i18nEmailTooLong)(flags.i18nEmptyWarning)(flags.i18nEnterEmailAddress)(flags.i18nEnterValueWithinRange)(flags.i18nError)(flags.i18nErrorSavingEmail)(flags.i18nErrorWithRequest)(flags.i18nExitMessage)(flags.i18nExitWithoutSaving)(flags.i18nFailedToSend)(flags.i18nFailedToSendEmail)(flags.i18nFirstName)(flags.i18nFirstNameRequired)(flags.i18nGenerateIds)(flags.i18nGenerateNewIds)(flags.i18nGenerateIdsTitle)(flags.i18nGenericError)(flags.i18nGoBack)(flags.i18nGoToParticipantsPage)(flags.i18nHelpfulLinks)(flags.i18nHoganIdWithOctothorpe)(flags.i18nHoganIdWithoutOctothorpe)(flags.i18nHoganPrivacyPolicy)(flags.i18nHoursAgoFormat)(flags.i18nInactive)(flags.i18nInvalidEmailAddress)(flags.i18nInviteParticipants)(flags.i18nJobProfile)(flags.i18nLanguage)(
		_elm_lang$core$Dict$fromList(flags.i18nLanguages))(flags.i18nLastName)(flags.i18nLastNameCannotBeAsterisk)(flags.i18nLastNameRequired)(flags.i18nLoadingMessage)(flags.i18nLoadingParticipants)(flags.i18nLoadingProjects)(flags.i18nClients)(flags.i18nLoggedInAs)(flags.i18nLogout)(flags.i18nMinutesAgoFormat)(flags.i18nModifyReports)(flags.i18nMonthsAgoFormat)(flags.i18nMyReports)(flags.i18nName)(flags.i18nNameContainsInvalidCharacters)(flags.i18nNameDuplicate)(flags.i18nNameLength)(flags.i18nNameRequired)(flags.i18nNameIsConfigure)(flags.i18nNewProject)(flags.i18nProjectInformation)(flags.i18nNext)(flags.i18nNoParticipants)(flags.i18nNoProjects)(flags.i18nNoResultsWereFound)(flags.i18nNorm)(flags.i18nNotice)(flags.i18nNotificationsFor)(flags.i18nNotificationsMessage)(flags.i18nNumberOfIdsToGenerate)(flags.i18nOk)(flags.i18nOneDayAgo)(flags.i18nOneHourAgo)(flags.i18nOneMinuteAgo)(flags.i18nOneMonthAgo)(flags.i18nOneWeekAgo)(flags.i18nOneYearAgo)(flags.i18nParticipant)(flags.i18nParticipants)(flags.i18nParticipantsHaveBeenAddedAndInvitationsSent)(flags.i18nParticipantStatus)(flags.i18nPending)(flags.i18nPleaseSelectReports)(flags.i18nProgressCounter)(flags.i18nProject)(flags.i18nProjectNameValidationHint)(flags.i18nProjects)(flags.i18nProjectTitle)(flags.i18nRemoveReport)(flags.i18nReports)(flags.i18nRescoreReport)(flags.i18nRescoreReportInProgress)(flags.i18nResendInvitation)(flags.i18nSave)(flags.i18nSaveChanges)(flags.i18nSearch)(flags.i18nSearchParticipantsFor)(flags.i18nSelectedReports)(flags.i18nSelectReportPrompt)(flags.i18nSendReminder)(flags.i18nSendSampleInvitation)(flags.i18nSent)(flags.i18nSettings)(flags.i18nStatus)(flags.i18nTermsOfUse)(flags.i18nTheseChangesWillNotImpactGeneratedReports)(flags.i18nThisEmailIsInvalid)(flags.i18nToggleNavigationLore)(flags.i18nUniqueIdWithOctothorpe)(flags.i18nUpdateAllReports)(flags.i18nUser)(flags.i18nUserGuide)(flags.i18nViewReportOptionsText)(flags.i18nWeeksAgoFormat)(flags.i18nYearsAgoFormat)(flags.i18nYouHaveChosenToMakeBillableChangesToGeneratedReports)(flags.i18nYouHaveChoseToUpdateGeneratedReports)(flags.i18nYouHaveSuccessfullyGeneratedIds)(flags.i18nYouMustAddReports);
};

var _user$project$IE$modalButtonFix = F2(
	function (modalHtml, htmlMap) {
		return A2(
			_elm_lang$html$Html$div,
			{ctor: '[]'},
			{
				ctor: '::',
				_0: htmlMap(
					A2(
						_elm_lang$html$Html$div,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: modalHtml,
							_1: {ctor: '[]'}
						})),
				_1: {ctor: '[]'}
			});
	});

var _user$project$Session$Session = F9(
	function (a, b, c, d, e, f, g, h, i) {
		return {i18n: a, accessToken: b, userEmail: c, readOnly: d, clients: e, activeClient: f, reportFileService: g, haloLiteApi: h, termsAndConditions: i};
	});
var _user$project$Session$session = function (flags) {
	return A9(
		_user$project$Session$Session,
		_user$project$I18n$i18n(flags),
		flags.accessToken,
		flags.userEmail,
		flags.readOnly,
		flags.clients,
		flags.activeClient,
		flags.reportFileService,
		flags.haloLiteApi,
		flags.termsAndConditions);
};

var _user$project$Request_Headers$defaultHeaders = function (session) {
	return {
		ctor: '::',
		_0: {
			ctor: '_Tuple2',
			_0: 'Authorization',
			_1: A2(_elm_lang$core$Basics_ops['++'], 'Bearer ', session.accessToken)
		},
		_1: {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'Accept', _1: 'application/json'},
			_1: {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: 'X-Active-Client', _1: session.activeClient},
				_1: {ctor: '[]'}
			}
		}
	};
};

var _user$project$Request_Client$Client = F2(
	function (a, b) {
		return {id: a, name: b};
	});
var _user$project$Request_Client$decodeClient = A4(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
	'name',
	_elm_lang$core$Json_Decode$string,
	'',
	A3(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
		'id',
		_elm_lang$core$Json_Decode$string,
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_user$project$Request_Client$Client)));
var _user$project$Request_Client$get = function (session) {
	var expect = _elm_lang$http$Http$expectJson(
		_elm_lang$core$Json_Decode$list(_user$project$Request_Client$decodeClient));
	var url = A2(_elm_lang$core$Basics_ops['++'], session.haloLiteApi, '/clients/');
	return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
		A2(
			_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
			_user$project$Request_Headers$defaultHeaders(session),
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withExpect,
				expect,
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withBody,
					_elm_lang$http$Http$emptyBody,
					_lukewestby$elm_http_builder$HttpBuilder$get(url)))));
};

var _user$project$Route$decodedString = A2(
	_evancz$url_parser$UrlParser$custom,
	'STRING',
	function (str) {
		var _p0 = _elm_lang$http$Http$decodeUri(str);
		if (_p0.ctor === 'Just') {
			return _elm_lang$core$Result$Ok(_p0._0);
		} else {
			return _elm_lang$core$Result$Err(str);
		}
	});
var _user$project$Route$routeToString = function (page) {
	var pieces = function () {
		var _p1 = page;
		switch (_p1.ctor) {
			case 'Search':
				return {
					ctor: '::',
					_0: 'SearchResults',
					_1: {
						ctor: '::',
						_0: _elm_lang$http$Http$encodeUri(_p1._0),
						_1: {ctor: '[]'}
					}
				};
			case 'ProjectLibrary':
				return {
					ctor: '::',
					_0: '',
					_1: {ctor: '[]'}
				};
			case 'ProjectDetail':
				return {
					ctor: '::',
					_0: 'Project',
					_1: {
						ctor: '::',
						_0: _p1._0,
						_1: {ctor: '[]'}
					}
				};
			case 'ProjectReportSelection':
				return {
					ctor: '::',
					_0: 'Project',
					_1: {
						ctor: '::',
						_0: _p1._0,
						_1: {
							ctor: '::',
							_0: 'Reports',
							_1: {ctor: '[]'}
						}
					}
				};
			case 'ProjectReportSettings':
				return {
					ctor: '::',
					_0: 'Project',
					_1: {
						ctor: '::',
						_0: _p1._0,
						_1: {
							ctor: '::',
							_0: 'Report',
							_1: {
								ctor: '::',
								_0: _p1._1,
								_1: {ctor: '[]'}
							}
						}
					}
				};
			case 'ProjectPackageSettings':
				return {
					ctor: '::',
					_0: 'Project',
					_1: {
						ctor: '::',
						_0: _p1._0,
						_1: {
							ctor: '::',
							_0: 'Package',
							_1: {
								ctor: '::',
								_0: _p1._1,
								_1: {ctor: '[]'}
							}
						}
					}
				};
			case 'Participants':
				return {
					ctor: '::',
					_0: 'Participants',
					_1: {
						ctor: '::',
						_0: _p1._0,
						_1: {ctor: '[]'}
					}
				};
			case 'Participant':
				return {
					ctor: '::',
					_0: 'Participants',
					_1: {
						ctor: '::',
						_0: _p1._0,
						_1: {
							ctor: '::',
							_0: 'Participant',
							_1: {
								ctor: '::',
								_0: _p1._1,
								_1: {ctor: '[]'}
							}
						}
					}
				};
			case 'ParticipantReportSelection':
				return {
					ctor: '::',
					_0: 'Project',
					_1: {
						ctor: '::',
						_0: _p1._0,
						_1: {
							ctor: '::',
							_0: 'Participant',
							_1: {
								ctor: '::',
								_0: _p1._1,
								_1: {
									ctor: '::',
									_0: 'Reports',
									_1: {ctor: '[]'}
								}
							}
						}
					}
				};
			case 'ParticipantReportSettings':
				return {
					ctor: '::',
					_0: 'Project',
					_1: {
						ctor: '::',
						_0: _p1._0,
						_1: {
							ctor: '::',
							_0: 'Participant',
							_1: {
								ctor: '::',
								_0: _p1._1,
								_1: {
									ctor: '::',
									_0: 'Report',
									_1: {
										ctor: '::',
										_0: _p1._2,
										_1: {ctor: '[]'}
									}
								}
							}
						}
					}
				};
			case 'ParticipantPackageSettings':
				return {
					ctor: '::',
					_0: 'Project',
					_1: {
						ctor: '::',
						_0: _p1._0,
						_1: {
							ctor: '::',
							_0: 'Participant',
							_1: {
								ctor: '::',
								_0: _p1._1,
								_1: {
									ctor: '::',
									_0: 'Package',
									_1: {
										ctor: '::',
										_0: _p1._2,
										_1: {ctor: '[]'}
									}
								}
							}
						}
					}
				};
			case 'AccessDenied':
				return {
					ctor: '::',
					_0: 'AccessDenied',
					_1: {ctor: '[]'}
				};
			default:
				return {
					ctor: '::',
					_0: 'Error',
					_1: {ctor: '[]'}
				};
		}
	}();
	return A2(
		_elm_lang$core$Basics_ops['++'],
		'#/',
		A2(_elm_lang$core$String$join, '/', pieces));
};
var _user$project$Route$newUrl = function (_p2) {
	return _elm_lang$navigation$Navigation$newUrl(
		_user$project$Route$routeToString(_p2));
};
var _user$project$Route$modifyUrl = function (_p3) {
	return _elm_lang$navigation$Navigation$modifyUrl(
		_user$project$Route$routeToString(_p3));
};
var _user$project$Route$href = function (route) {
	return _elm_lang$html$Html_Attributes$href(
		_user$project$Route$routeToString(route));
};
var _user$project$Route$notifyUnauthorized = _elm_lang$core$Native_Platform.outgoingPort(
	'notifyUnauthorized',
	function (v) {
		return null;
	});
var _user$project$Route$Error = {ctor: 'Error'};
var _user$project$Route$AccessDenied = {ctor: 'AccessDenied'};
var _user$project$Route$error = function (err) {
	var _p4 = A2(_elm_lang$core$Debug$log, 'error: ', err);
	switch (_p4.ctor) {
		case 'BadStatus':
			var _p5 = _p4._0;
			return _elm_lang$core$Native_Utils.eq(_p5.status.code, 401) ? _user$project$Route$notifyUnauthorized(
				{ctor: '_Tuple0'}) : (_elm_lang$core$Native_Utils.eq(_p5.status.code, 403) ? _user$project$Route$newUrl(_user$project$Route$AccessDenied) : _user$project$Route$newUrl(_user$project$Route$Error));
		case 'BadPayload':
			return A2(
				_elm_lang$core$Debug$log,
				_p4._0,
				_user$project$Route$newUrl(_user$project$Route$Error));
		default:
			return _user$project$Route$newUrl(_user$project$Route$Error);
	}
};
var _user$project$Route$ParticipantPackageSettings = F3(
	function (a, b, c) {
		return {ctor: 'ParticipantPackageSettings', _0: a, _1: b, _2: c};
	});
var _user$project$Route$ParticipantReportSettings = F3(
	function (a, b, c) {
		return {ctor: 'ParticipantReportSettings', _0: a, _1: b, _2: c};
	});
var _user$project$Route$ParticipantReportSelection = F2(
	function (a, b) {
		return {ctor: 'ParticipantReportSelection', _0: a, _1: b};
	});
var _user$project$Route$Participant = F2(
	function (a, b) {
		return {ctor: 'Participant', _0: a, _1: b};
	});
var _user$project$Route$Participants = function (a) {
	return {ctor: 'Participants', _0: a};
};
var _user$project$Route$ProjectPackageSettings = F2(
	function (a, b) {
		return {ctor: 'ProjectPackageSettings', _0: a, _1: b};
	});
var _user$project$Route$ProjectReportSettings = F2(
	function (a, b) {
		return {ctor: 'ProjectReportSettings', _0: a, _1: b};
	});
var _user$project$Route$ProjectReportSelection = function (a) {
	return {ctor: 'ProjectReportSelection', _0: a};
};
var _user$project$Route$ProjectDetail = function (a) {
	return {ctor: 'ProjectDetail', _0: a};
};
var _user$project$Route$Search = function (a) {
	return {ctor: 'Search', _0: a};
};
var _user$project$Route$ProjectLibrary = {ctor: 'ProjectLibrary'};
var _user$project$Route$route = _evancz$url_parser$UrlParser$oneOf(
	{
		ctor: '::',
		_0: A2(
			_evancz$url_parser$UrlParser$map,
			_user$project$Route$Search,
			A2(
				_evancz$url_parser$UrlParser_ops['</>'],
				_evancz$url_parser$UrlParser$s('SearchResults'),
				_user$project$Route$decodedString)),
		_1: {
			ctor: '::',
			_0: A2(
				_evancz$url_parser$UrlParser$map,
				_user$project$Route$ProjectLibrary,
				_evancz$url_parser$UrlParser$s('')),
			_1: {
				ctor: '::',
				_0: A2(
					_evancz$url_parser$UrlParser$map,
					_user$project$Route$ProjectDetail,
					A2(
						_evancz$url_parser$UrlParser_ops['</>'],
						_evancz$url_parser$UrlParser$s('Project'),
						_evancz$url_parser$UrlParser$string)),
				_1: {
					ctor: '::',
					_0: A2(
						_evancz$url_parser$UrlParser$map,
						_user$project$Route$ProjectReportSelection,
						A2(
							_evancz$url_parser$UrlParser_ops['</>'],
							_evancz$url_parser$UrlParser$s('Project'),
							A2(
								_evancz$url_parser$UrlParser_ops['</>'],
								_evancz$url_parser$UrlParser$string,
								_evancz$url_parser$UrlParser$s('Reports')))),
					_1: {
						ctor: '::',
						_0: A2(
							_evancz$url_parser$UrlParser$map,
							_user$project$Route$ProjectReportSettings,
							A2(
								_evancz$url_parser$UrlParser_ops['</>'],
								_evancz$url_parser$UrlParser$s('Project'),
								A2(
									_evancz$url_parser$UrlParser_ops['</>'],
									_evancz$url_parser$UrlParser$string,
									A2(
										_evancz$url_parser$UrlParser_ops['</>'],
										_evancz$url_parser$UrlParser$s('Report'),
										_evancz$url_parser$UrlParser$string)))),
						_1: {
							ctor: '::',
							_0: A2(
								_evancz$url_parser$UrlParser$map,
								_user$project$Route$ProjectPackageSettings,
								A2(
									_evancz$url_parser$UrlParser_ops['</>'],
									_evancz$url_parser$UrlParser$s('Project'),
									A2(
										_evancz$url_parser$UrlParser_ops['</>'],
										_evancz$url_parser$UrlParser$string,
										A2(
											_evancz$url_parser$UrlParser_ops['</>'],
											_evancz$url_parser$UrlParser$s('Package'),
											_evancz$url_parser$UrlParser$string)))),
							_1: {
								ctor: '::',
								_0: A2(
									_evancz$url_parser$UrlParser$map,
									_user$project$Route$Participants,
									A2(
										_evancz$url_parser$UrlParser_ops['</>'],
										_evancz$url_parser$UrlParser$s('Participants'),
										_evancz$url_parser$UrlParser$string)),
								_1: {
									ctor: '::',
									_0: A2(
										_evancz$url_parser$UrlParser$map,
										_user$project$Route$Participant,
										A2(
											_evancz$url_parser$UrlParser_ops['</>'],
											_evancz$url_parser$UrlParser$s('Participants'),
											A2(
												_evancz$url_parser$UrlParser_ops['</>'],
												_evancz$url_parser$UrlParser$string,
												A2(
													_evancz$url_parser$UrlParser_ops['</>'],
													_evancz$url_parser$UrlParser$s('Participant'),
													_evancz$url_parser$UrlParser$string)))),
									_1: {
										ctor: '::',
										_0: A2(
											_evancz$url_parser$UrlParser$map,
											_user$project$Route$ParticipantReportSelection,
											A2(
												_evancz$url_parser$UrlParser_ops['</>'],
												_evancz$url_parser$UrlParser$s('Project'),
												A2(
													_evancz$url_parser$UrlParser_ops['</>'],
													_evancz$url_parser$UrlParser$string,
													A2(
														_evancz$url_parser$UrlParser_ops['</>'],
														_evancz$url_parser$UrlParser$s('Participant'),
														A2(
															_evancz$url_parser$UrlParser_ops['</>'],
															_evancz$url_parser$UrlParser$string,
															_evancz$url_parser$UrlParser$s('Reports')))))),
										_1: {
											ctor: '::',
											_0: A2(
												_evancz$url_parser$UrlParser$map,
												_user$project$Route$ParticipantReportSettings,
												A2(
													_evancz$url_parser$UrlParser_ops['</>'],
													_evancz$url_parser$UrlParser$s('Project'),
													A2(
														_evancz$url_parser$UrlParser_ops['</>'],
														_evancz$url_parser$UrlParser$string,
														A2(
															_evancz$url_parser$UrlParser_ops['</>'],
															_evancz$url_parser$UrlParser$s('Participant'),
															A2(
																_evancz$url_parser$UrlParser_ops['</>'],
																_evancz$url_parser$UrlParser$string,
																A2(
																	_evancz$url_parser$UrlParser_ops['</>'],
																	_evancz$url_parser$UrlParser$s('Report'),
																	_evancz$url_parser$UrlParser$string)))))),
											_1: {
												ctor: '::',
												_0: A2(
													_evancz$url_parser$UrlParser$map,
													_user$project$Route$ParticipantPackageSettings,
													A2(
														_evancz$url_parser$UrlParser_ops['</>'],
														_evancz$url_parser$UrlParser$s('Project'),
														A2(
															_evancz$url_parser$UrlParser_ops['</>'],
															_evancz$url_parser$UrlParser$string,
															A2(
																_evancz$url_parser$UrlParser_ops['</>'],
																_evancz$url_parser$UrlParser$s('Participant'),
																A2(
																	_evancz$url_parser$UrlParser_ops['</>'],
																	_evancz$url_parser$UrlParser$string,
																	A2(
																		_evancz$url_parser$UrlParser_ops['</>'],
																		_evancz$url_parser$UrlParser$s('Package'),
																		_evancz$url_parser$UrlParser$string)))))),
												_1: {
													ctor: '::',
													_0: A2(
														_evancz$url_parser$UrlParser$map,
														_user$project$Route$AccessDenied,
														_evancz$url_parser$UrlParser$s('AccessDenied')),
													_1: {
														ctor: '::',
														_0: A2(
															_evancz$url_parser$UrlParser$map,
															_user$project$Route$Error,
															_evancz$url_parser$UrlParser$s('Error')),
														_1: {ctor: '[]'}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	});
var _user$project$Route$fromLocation = function (location) {
	return _elm_lang$core$String$isEmpty(location.hash) ? _user$project$Route$ProjectLibrary : A2(
		_elm_lang$core$Maybe$withDefault,
		_user$project$Route$ProjectLibrary,
		A2(_evancz$url_parser$UrlParser$parseHash, _user$project$Route$route, location));
};

var _user$project$Page_Menu$setClients = F2(
	function (clients, model) {
		return _elm_lang$core$Native_Utils.update(
			model,
			{clients: clients});
	});
var _user$project$Page_Menu$cleanSearchTerm = function (str) {
	var trimmedStr = _elm_lang$core$String$trim(str);
	var _p0 = _elm_lang$core$Native_Utils.cmp(
		_elm_lang$core$String$length(trimmedStr),
		0) > 0;
	if (_p0 === true) {
		return _elm_lang$core$Maybe$Just(trimmedStr);
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _user$project$Page_Menu$logout = _elm_lang$core$Native_Platform.outgoingPort(
	'logout',
	function (v) {
		return null;
	});
var _user$project$Page_Menu$userClickedAwayFromHelpDropdown = _elm_lang$core$Native_Platform.incomingPort(
	'userClickedAwayFromHelpDropdown',
	_elm_lang$core$Json_Decode$null(
		{ctor: '_Tuple0'}));
var _user$project$Page_Menu$userClickedAwayFromUserAccountDropdown = _elm_lang$core$Native_Platform.incomingPort(
	'userClickedAwayFromUserAccountDropdown',
	_elm_lang$core$Json_Decode$null(
		{ctor: '_Tuple0'}));
var _user$project$Page_Menu$updateActiveClient = _elm_lang$core$Native_Platform.outgoingPort(
	'updateActiveClient',
	function (v) {
		return v;
	});
var _user$project$Page_Menu$Model = F6(
	function (a, b, c, d, e, f) {
		return {searchValue: a, menuToggled: b, searchToggled: c, helpDropdownToggled: d, clientDropdownToggled: e, clients: f};
	});
var _user$project$Page_Menu$init = F2(
	function (searchTerm, clients) {
		return A6(
			_user$project$Page_Menu$Model,
			A2(
				_elm_lang$core$Maybe$withDefault,
				'',
				_user$project$Page_Menu$cleanSearchTerm(searchTerm)),
			false,
			!_elm_lang$core$Native_Utils.eq(
				_user$project$Page_Menu$cleanSearchTerm(searchTerm),
				_elm_lang$core$Maybe$Nothing),
			false,
			false,
			clients);
	});
var _user$project$Page_Menu$HandleFocus = {ctor: 'HandleFocus'};
var _user$project$Page_Menu$update = F2(
	function (msg, model) {
		var _p1 = msg;
		switch (_p1.ctor) {
			case 'ToggleSearch':
				var searchToggled = !model.searchToggled;
				var cmd = _elm_lang$core$Native_Utils.eq(searchToggled, true) ? A2(
					_elm_lang$core$Task$attempt,
					_elm_lang$core$Basics$always(_user$project$Page_Menu$HandleFocus),
					_elm_lang$dom$Dom$focus('SearchBox')) : _elm_lang$core$Platform_Cmd$none;
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{searchToggled: searchToggled, menuToggled: false}),
					_1: cmd
				};
			case 'ToggleHelpDropdown':
				return _p1._0 ? {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{helpDropdownToggled: true, clientDropdownToggled: false, searchToggled: false}),
					_1: _elm_lang$core$Platform_Cmd$none
				} : {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{helpDropdownToggled: false}),
					_1: _elm_lang$core$Platform_Cmd$none
				};
			case 'ToggleClients':
				return _p1._0 ? {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{clientDropdownToggled: true, helpDropdownToggled: false, searchToggled: false}),
					_1: _elm_lang$core$Platform_Cmd$none
				} : {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{clientDropdownToggled: false}),
					_1: _elm_lang$core$Platform_Cmd$none
				};
			case 'SetSearchTerm':
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{searchValue: _p1._0}),
					_1: _elm_lang$core$Platform_Cmd$none
				};
			case 'SubmitSearch':
				var cmd = function () {
					var _p2 = _user$project$Page_Menu$cleanSearchTerm(model.searchValue);
					if (_p2.ctor === 'Just') {
						return _user$project$Route$newUrl(
							_user$project$Route$Search(_p2._0));
					} else {
						return _elm_lang$core$Platform_Cmd$none;
					}
				}();
				return {ctor: '_Tuple2', _0: model, _1: cmd};
			case 'ToggleMenu':
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{menuToggled: _p1._0, searchToggled: false}),
					_1: _elm_lang$core$Platform_Cmd$none
				};
			case 'Logout':
				return {
					ctor: '_Tuple2',
					_0: model,
					_1: _user$project$Page_Menu$logout(
						{ctor: '_Tuple0'})
				};
			case 'SetActiveClient':
				return {
					ctor: '_Tuple2',
					_0: model,
					_1: _user$project$Page_Menu$updateActiveClient(_p1._0)
				};
			default:
				return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
		}
	});
var _user$project$Page_Menu$SetActiveClient = function (a) {
	return {ctor: 'SetActiveClient', _0: a};
};
var _user$project$Page_Menu$Logout = {ctor: 'Logout'};
var _user$project$Page_Menu$ToggleClients = function (a) {
	return {ctor: 'ToggleClients', _0: a};
};
var _user$project$Page_Menu$ToggleMenu = function (a) {
	return {ctor: 'ToggleMenu', _0: a};
};
var _user$project$Page_Menu$SubmitSearch = {ctor: 'SubmitSearch'};
var _user$project$Page_Menu$SetSearchTerm = function (a) {
	return {ctor: 'SetSearchTerm', _0: a};
};
var _user$project$Page_Menu$ToggleHelpDropdown = function (a) {
	return {ctor: 'ToggleHelpDropdown', _0: a};
};
var _user$project$Page_Menu$subscriptions = _elm_lang$core$Platform_Sub$batch(
	{
		ctor: '::',
		_0: _user$project$Page_Menu$userClickedAwayFromHelpDropdown(
			_elm_lang$core$Basics$always(
				_user$project$Page_Menu$ToggleHelpDropdown(false))),
		_1: {
			ctor: '::',
			_0: _user$project$Page_Menu$userClickedAwayFromUserAccountDropdown(
				_elm_lang$core$Basics$always(
					_user$project$Page_Menu$ToggleClients(false))),
			_1: {ctor: '[]'}
		}
	});
var _user$project$Page_Menu$ToggleSearch = {ctor: 'ToggleSearch'};

var _user$project$Request_Response$expectCreated = function () {
	var location = function (headers) {
		var _p0 = A2(_elm_lang$core$Dict$get, 'location', headers);
		if (_p0.ctor === 'Just') {
			return _elm_lang$core$Maybe$Just(_p0._0);
		} else {
			return A2(_elm_lang$core$Dict$get, 'Location', headers);
		}
	};
	var result = function (response) {
		return _elm_lang$core$Native_Utils.eq(response.status.code, 201) ? A2(
			_elm_lang$core$Result$fromMaybe,
			response.status.message,
			location(response.headers)) : _elm_lang$core$Result$Err(response.status.message);
	};
	return _elm_lang$http$Http$expectStringResponse(result);
}();
var _user$project$Request_Response$expectOk = function () {
	var result = function (response) {
		return _elm_lang$core$Native_Utils.eq(response.status.code, 200) ? _elm_lang$core$Result$Ok(
			{ctor: '_Tuple0'}) : _elm_lang$core$Result$Err(response.status.message);
	};
	return _elm_lang$http$Http$expectStringResponse(result);
}();

var _user$project$Request_Project$encode = function (project) {
	var maybeString = function (s) {
		var _p0 = s;
		if (_p0.ctor === 'Just') {
			return _elm_lang$core$Json_Encode$string(_p0._0);
		} else {
			return _elm_lang$core$Json_Encode$null;
		}
	};
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'id',
				_1: _elm_lang$core$Json_Encode$string(project.id)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'name',
					_1: _elm_lang$core$Json_Encode$string(project.name)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'created',
						_1: _elm_lang$core$Json_Encode$string('')
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'email1',
							_1: maybeString(project.email1)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'email2',
								_1: maybeString(project.email2)
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'email3',
									_1: maybeString(project.email3)
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'email4',
										_1: maybeString(project.email4)
									},
									_1: {ctor: '[]'}
								}
							}
						}
					}
				}
			}
		});
};
var _user$project$Request_Project$put = F2(
	function (session, project) {
		var body = _elm_lang$http$Http$jsonBody(
			_user$project$Request_Project$encode(project));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(_elm_lang$core$Basics_ops['++'], '/projects/', project.id));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withBody,
					body,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withExpect,
						_user$project$Request_Response$expectOk,
						_lukewestby$elm_http_builder$HttpBuilder$put(url)))));
	});
var _user$project$Request_Project$post = F2(
	function (session, name) {
		var body = _elm_lang$http$Http$jsonBody(
			_elm_lang$core$Json_Encode$string(name));
		var url = A2(_elm_lang$core$Basics_ops['++'], session.haloLiteApi, '/projects/');
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withBody,
					body,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withExpect,
						_user$project$Request_Response$expectCreated,
						_lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var _user$project$Request_Project$Project = F8(
	function (a, b, c, d, e, f, g, h) {
		return {id: a, name: b, created: c, email1: d, email2: e, email3: f, email4: g, isActive: h};
	});
var _user$project$Request_Project$decodeProject = A3(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
	'isActive',
	_elm_lang$core$Json_Decode$bool,
	A3(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
		'email4',
		_elm_lang$core$Json_Decode$maybe(_elm_lang$core$Json_Decode$string),
		A3(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
			'email3',
			_elm_lang$core$Json_Decode$maybe(_elm_lang$core$Json_Decode$string),
			A3(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
				'email2',
				_elm_lang$core$Json_Decode$maybe(_elm_lang$core$Json_Decode$string),
				A3(
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
					'email1',
					_elm_lang$core$Json_Decode$maybe(_elm_lang$core$Json_Decode$string),
					A3(
						_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
						'created',
						_elm_community$json_extra$Json_Decode_Extra$date,
						A3(
							_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
							'name',
							_elm_lang$core$Json_Decode$string,
							A3(
								_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
								'id',
								_elm_lang$core$Json_Decode$string,
								_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_user$project$Request_Project$Project)))))))));
var _user$project$Request_Project$getAll = function (session) {
	var expect = _elm_lang$http$Http$expectJson(
		_elm_lang$core$Json_Decode$list(_user$project$Request_Project$decodeProject));
	var url = A2(_elm_lang$core$Basics_ops['++'], session.haloLiteApi, '/projects/');
	return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
		A2(
			_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
			_user$project$Request_Headers$defaultHeaders(session),
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withExpect,
				expect,
				_lukewestby$elm_http_builder$HttpBuilder$get(url))));
};
var _user$project$Request_Project$getByURI = F2(
	function (session, uri) {
		var expect = _elm_lang$http$Http$expectJson(_user$project$Request_Project$decodeProject);
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					expect,
					_lukewestby$elm_http_builder$HttpBuilder$get(uri))));
	});
var _user$project$Request_Project$get = F2(
	function (session, projectId) {
		var expect = _elm_lang$http$Http$expectJson(_user$project$Request_Project$decodeProject);
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(_elm_lang$core$Basics_ops['++'], '/projects/', projectId));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					expect,
					_lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});

var _user$project$Page_Modal$ProjectName = function (a) {
	return {ctor: 'ProjectName', _0: a};
};
var _user$project$Page_Modal$None = {ctor: 'None'};
var _user$project$Page_Modal$Closed = {ctor: 'Closed'};
var _user$project$Page_Modal$NoOp = {ctor: 'NoOp'};

var _user$project$Request_Participant$encode = function (participant) {
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'ParticipantId',
				_1: _elm_lang$core$Json_Encode$string(participant.id)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'FirstName',
					_1: _elm_lang$core$Json_Encode$string(participant.firstName)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'LastName',
						_1: _elm_lang$core$Json_Encode$string(participant.lastName)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'Email',
							_1: _elm_lang$core$Json_Encode$string(participant.email)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'UniqueId',
								_1: _elm_lang$core$Json_Encode$string(participant.uniqueId)
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'PasswordSetByUser',
									_1: _elm_lang$core$Json_Encode$bool(participant.passwordSetByUser)
								},
								_1: {ctor: '[]'}
							}
						}
					}
				}
			}
		});
};
var _user$project$Request_Participant$postEmails = F3(
	function (session, projectId, emails) {
		var body = _elm_lang$http$Http$jsonBody(
			_elm_lang$core$Json_Encode$list(
				A2(_elm_lang$core$List$map, _elm_lang$core$Json_Encode$string, emails)));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/projects/',
				A2(_elm_lang$core$Basics_ops['++'], projectId, '/participants')));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					_user$project$Request_Response$expectCreated,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						body,
						_lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var _user$project$Request_Participant$put = F2(
	function (session, participant) {
		var body = _elm_lang$http$Http$jsonBody(
			_user$project$Request_Participant$encode(participant));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(_elm_lang$core$Basics_ops['++'], '/participants/', participant.id));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					_user$project$Request_Response$expectOk,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						body,
						_lukewestby$elm_http_builder$HttpBuilder$put(url)))));
	});
var _user$project$Request_Participant$isEmailValid = F2(
	function (session, participant) {
		var hasValidDomain = function (_p0) {
			var _p1 = _p0;
			var _p2 = A2(_elm_lang$core$String$split, '@', participant.email);
			if (((_p2.ctor === '::') && (_p2._1.ctor === '::')) && (_p2._1._1.ctor === '[]')) {
				return A2(_elm_lang$core$String$contains, '.', _p2._1._0) ? _elm_lang$core$Result$Ok(
					{ctor: '_Tuple0'}) : _elm_lang$core$Result$Err(session.i18n.emailLacksDotInDomain);
			} else {
				return _elm_lang$core$Result$Err(session.i18n.emailInvalid);
			}
		};
		var noDoubleDots = function (_p3) {
			var _p4 = _p3;
			return A2(_elm_lang$core$String$contains, '..', participant.email) ? _elm_lang$core$Result$Err(session.i18n.emailContainsDoubleDot) : _elm_lang$core$Result$Ok(
				{ctor: '_Tuple0'});
		};
		var required = (_elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$String$length(
				_elm_lang$core$String$trim(participant.email)),
			0) > 0) ? _elm_lang$core$Result$Ok(
			{ctor: '_Tuple0'}) : _elm_lang$core$Result$Err(session.i18n.emailRequired);
		return A2(
			_elm_lang$core$Result$andThen,
			hasValidDomain,
			A2(_elm_lang$core$Result$andThen, noDoubleDots, required));
	});
var _user$project$Request_Participant$isLastNameValid = F2(
	function (session, participant) {
		var _p5 = _elm_lang$core$String$trim(participant.lastName);
		switch (_p5) {
			case '':
				return _elm_lang$core$Result$Err(session.i18n.lastNameRequired);
			case '*':
				return _elm_lang$core$Result$Err(session.i18n.lastNameCannotBeAsterisk);
			default:
				return _elm_lang$core$Result$Ok(
					{ctor: '_Tuple0'});
		}
	});
var _user$project$Request_Participant$isFirstNameValid = F2(
	function (session, participant) {
		return _elm_lang$core$Native_Utils.eq(
			_elm_lang$core$String$trim(participant.firstName),
			'') ? _elm_lang$core$Result$Err(session.i18n.firstNameRequired) : _elm_lang$core$Result$Ok(
			{ctor: '_Tuple0'});
	});
var _user$project$Request_Participant$isValid = F2(
	function (session, participant) {
		return A2(
			_elm_lang$core$Result$andThen,
			function (a) {
				return A2(_user$project$Request_Participant$isEmailValid, session, participant);
			},
			A2(
				_elm_lang$core$Result$andThen,
				function (a) {
					return A2(_user$project$Request_Participant$isLastNameValid, session, participant);
				},
				A2(_user$project$Request_Participant$isFirstNameValid, session, participant)));
	});
var _user$project$Request_Participant$Participant = F6(
	function (a, b, c, d, e, f) {
		return {id: a, firstName: b, lastName: c, email: d, uniqueId: e, passwordSetByUser: f};
	});
var _user$project$Request_Participant$decodeParticipant = A3(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
	'passwordSetByUser',
	_elm_lang$core$Json_Decode$bool,
	A4(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
		'uniqueId',
		_elm_lang$core$Json_Decode$string,
		'',
		A4(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
			'email',
			_elm_lang$core$Json_Decode$string,
			'',
			A4(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
				'lastName',
				_elm_lang$core$Json_Decode$string,
				'',
				A4(
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
					'firstName',
					_elm_lang$core$Json_Decode$string,
					'',
					A3(
						_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
						'id',
						_elm_lang$core$Json_Decode$string,
						_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_user$project$Request_Participant$Participant)))))));
var _user$project$Request_Participant$get = F2(
	function (session, id) {
		var expect = _elm_lang$http$Http$expectJson(_user$project$Request_Participant$decodeParticipant);
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(_elm_lang$core$Basics_ops['++'], '/participants/', id));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					expect,
					_lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var _user$project$Request_Participant$getAllInProject = F2(
	function (session, projectId) {
		var expect = _elm_lang$http$Http$expectJson(
			_elm_lang$core$Json_Decode$list(_user$project$Request_Participant$decodeParticipant));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/projects/',
				A2(_elm_lang$core$Basics_ops['++'], projectId, '/participants')));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					expect,
					_lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});

var _user$project$Request_Report$encodeReport = function (report) {
	var encodeJobProfile = function (jobProfile) {
		var _p0 = jobProfile;
		if (_p0.ctor === 'Just') {
			return _elm_lang$core$Json_Encode$string(_p0._0);
		} else {
			return _elm_lang$core$Json_Encode$null;
		}
	};
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'Id',
				_1: _elm_lang$core$Json_Encode$string(report.id)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'Name',
					_1: _elm_lang$core$Json_Encode$string(report.name)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'Language',
						_1: _elm_lang$core$Json_Encode$string(report.language)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'Norm',
							_1: _elm_lang$core$Json_Encode$string(report.norm)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'JobProfile',
								_1: encodeJobProfile(report.jobProfile)
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'RequiredAssessmentIds',
									_1: _elm_lang$core$Json_Encode$list(
										A2(_elm_lang$core$List$map, _elm_lang$core$Json_Encode$string, report.requiredAssessmentIds))
								},
								_1: {ctor: '[]'}
							}
						}
					}
				}
			}
		});
};
var _user$project$Request_Report$deleteFromParticipant = F3(
	function (session, participantId, reportId) {
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/participants/',
				A2(
					_elm_lang$core$Basics_ops['++'],
					participantId,
					A2(_elm_lang$core$Basics_ops['++'], '/reports/', reportId))));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					_user$project$Request_Response$expectOk,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						_elm_lang$http$Http$emptyBody,
						_lukewestby$elm_http_builder$HttpBuilder$delete(url)))));
	});
var _user$project$Request_Report$deleteFromProject = F3(
	function (session, projectId, reportId) {
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/projects/',
				A2(
					_elm_lang$core$Basics_ops['++'],
					projectId,
					A2(_elm_lang$core$Basics_ops['++'], '/reports/', reportId))));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					_user$project$Request_Response$expectOk,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						_elm_lang$http$Http$emptyBody,
						_lukewestby$elm_http_builder$HttpBuilder$delete(url)))));
	});
var _user$project$Request_Report$putInAllParticipantsForProject = F4(
	function (session, projectId, updateGenerated, report) {
		var body = _elm_lang$http$Http$jsonBody(
			_user$project$Request_Report$encodeReport(report));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/projects/',
				A2(
					_elm_lang$core$Basics_ops['++'],
					projectId,
					A2(
						_elm_lang$core$Basics_ops['++'],
						'/participants/reports/',
						A2(
							_elm_lang$core$Basics_ops['++'],
							report.id,
							A2(
								_elm_lang$core$Basics_ops['++'],
								'?updateGenerated=',
								_elm_lang$core$Basics$toString(updateGenerated)))))));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					_user$project$Request_Response$expectOk,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						body,
						_lukewestby$elm_http_builder$HttpBuilder$put(url)))));
	});
var _user$project$Request_Report$putInParticipant = F3(
	function (session, participantId, report) {
		var body = _elm_lang$http$Http$jsonBody(
			_user$project$Request_Report$encodeReport(report));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/participants/',
				A2(
					_elm_lang$core$Basics_ops['++'],
					participantId,
					A2(_elm_lang$core$Basics_ops['++'], '/reports/', report.id))));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					_user$project$Request_Response$expectOk,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						body,
						_lukewestby$elm_http_builder$HttpBuilder$put(url)))));
	});
var _user$project$Request_Report$postInParticipant = F3(
	function (session, participantId, report) {
		var body = _elm_lang$http$Http$jsonBody(
			_user$project$Request_Report$encodeReport(report));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/participants/',
				A2(_elm_lang$core$Basics_ops['++'], participantId, '/reports')));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					_user$project$Request_Response$expectOk,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						body,
						_lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var _user$project$Request_Report$putInProject = F3(
	function (session, projectId, report) {
		var body = _elm_lang$http$Http$jsonBody(
			_user$project$Request_Report$encodeReport(report));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/projects/',
				A2(
					_elm_lang$core$Basics_ops['++'],
					projectId,
					A2(_elm_lang$core$Basics_ops['++'], '/reports/', report.id))));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					_user$project$Request_Response$expectOk,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						body,
						_lukewestby$elm_http_builder$HttpBuilder$put(url)))));
	});
var _user$project$Request_Report$postInProject = F3(
	function (session, projectId, report) {
		var body = _elm_lang$http$Http$jsonBody(
			_user$project$Request_Report$encodeReport(report));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/projects/',
				A2(_elm_lang$core$Basics_ops['++'], projectId, '/reports')));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					_user$project$Request_Response$expectOk,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						body,
						_lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var _user$project$Request_Report$Report = F6(
	function (a, b, c, d, e, f) {
		return {id: a, name: b, language: c, norm: d, jobProfile: e, requiredAssessmentIds: f};
	});
var _user$project$Request_Report$decodeReport = A3(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
	'requiredAssessmentIds',
	_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$string),
	A3(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
		'jobProfile',
		_elm_lang$core$Json_Decode$nullable(_elm_lang$core$Json_Decode$string),
		A3(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
			'norm',
			_elm_lang$core$Json_Decode$string,
			A3(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
				'language',
				_elm_lang$core$Json_Decode$string,
				A3(
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
					'name',
					_elm_lang$core$Json_Decode$string,
					A3(
						_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
						'id',
						_elm_lang$core$Json_Decode$string,
						_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_user$project$Request_Report$Report)))))));
var _user$project$Request_Report$getAll = function (session) {
	var expect = _elm_lang$http$Http$expectJson(
		_elm_lang$core$Json_Decode$list(_user$project$Request_Report$decodeReport));
	var url = A2(_elm_lang$core$Basics_ops['++'], session.haloLiteApi, '/reports');
	return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
		A2(
			_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
			_user$project$Request_Headers$defaultHeaders(session),
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withExpect,
				expect,
				_lukewestby$elm_http_builder$HttpBuilder$get(url))));
};
var _user$project$Request_Report$getInProject = F3(
	function (session, projectId, reportId) {
		var expect = _elm_lang$http$Http$expectJson(_user$project$Request_Report$decodeReport);
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/projects/',
				A2(
					_elm_lang$core$Basics_ops['++'],
					projectId,
					A2(_elm_lang$core$Basics_ops['++'], '/reports/', reportId))));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					expect,
					_lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var _user$project$Request_Report$getAllInProject = F2(
	function (session, projectId) {
		var expect = _elm_lang$http$Http$expectJson(
			_elm_lang$core$Json_Decode$list(_user$project$Request_Report$decodeReport));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/projects/',
				A2(_elm_lang$core$Basics_ops['++'], projectId, '/reports')));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					expect,
					_lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var _user$project$Request_Report$getInParticipant = F3(
	function (session, participantId, reportId) {
		var expect = _elm_lang$http$Http$expectJson(_user$project$Request_Report$decodeReport);
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/participants/',
				A2(
					_elm_lang$core$Basics_ops['++'],
					participantId,
					A2(_elm_lang$core$Basics_ops['++'], '/reports/', reportId))));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					expect,
					_lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var _user$project$Request_Report$getAllInParticipant = F2(
	function (session, participantId) {
		var expect = _elm_lang$http$Http$expectJson(
			_elm_lang$core$Json_Decode$list(_user$project$Request_Report$decodeReport));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/participants/',
				A2(_elm_lang$core$Basics_ops['++'], participantId, '/reports')));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					expect,
					_lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});

var _user$project$Page_Product$Product = F8(
	function (a, b, c, d, e, f, g, h) {
		return {id: a, name: b, language: c, norm: d, jobProfile: e, requiredAssessmentIds: f, reports: g, type_: h};
	});
var _user$project$Page_Product$Package = {ctor: 'Package'};
var _user$project$Page_Product$Report = {ctor: 'Report'};

var _user$project$Request_JobProfile$getForReport = F2(
	function (session, reportId) {
		var expect = _elm_lang$http$Http$expectJson(
			_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$string));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/reports/',
				A2(_elm_lang$core$Basics_ops['++'], reportId, '/job-profiles')));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					expect,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						_elm_lang$http$Http$emptyBody,
						_lukewestby$elm_http_builder$HttpBuilder$get(url)))));
	});

var _user$project$Request_Language$getForReport = F2(
	function (session, reportId) {
		var expect = _elm_lang$http$Http$expectJson(
			_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$string));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/reports/',
				A2(_elm_lang$core$Basics_ops['++'], reportId, '/languages')));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					expect,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						_elm_lang$http$Http$emptyBody,
						_lukewestby$elm_http_builder$HttpBuilder$get(url)))));
	});

var _user$project$Request_Norm$getForReport = F2(
	function (session, reportId) {
		var expect = _elm_lang$http$Http$expectJson(
			_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$string));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/reports/',
				A2(_elm_lang$core$Basics_ops['++'], reportId, '/norms')));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					expect,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						_elm_lang$http$Http$emptyBody,
						_lukewestby$elm_http_builder$HttpBuilder$get(url)))));
	});

var _user$project$Request_Package$encodePackage = function ($package) {
	var encodeJobProfile = function (jobProfile) {
		var _p0 = jobProfile;
		if (_p0.ctor === 'Just') {
			return _elm_lang$core$Json_Encode$string(_p0._0);
		} else {
			return _elm_lang$core$Json_Encode$null;
		}
	};
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'id',
				_1: _elm_lang$core$Json_Encode$string($package.id)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'name',
					_1: _elm_lang$core$Json_Encode$string($package.name)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'Language',
						_1: _elm_lang$core$Json_Encode$string($package.language)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'Norm',
							_1: _elm_lang$core$Json_Encode$string($package.norm)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'JobProfile',
								_1: encodeJobProfile($package.jobProfile)
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'RequiredAssessmentIds',
									_1: _elm_lang$core$Json_Encode$list(
										A2(_elm_lang$core$List$map, _elm_lang$core$Json_Encode$string, $package.requiredAssessmentIds))
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'reports',
										_1: _elm_lang$core$Json_Encode$list(
											A2(_elm_lang$core$List$map, _elm_lang$core$Json_Encode$string, $package.reports))
									},
									_1: {ctor: '[]'}
								}
							}
						}
					}
				}
			}
		});
};
var _user$project$Request_Package$deleteFromParticipant = F3(
	function (session, participantId, packageId) {
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/participants/',
				A2(
					_elm_lang$core$Basics_ops['++'],
					participantId,
					A2(_elm_lang$core$Basics_ops['++'], '/packages/', packageId))));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					_user$project$Request_Response$expectOk,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						_elm_lang$http$Http$emptyBody,
						_lukewestby$elm_http_builder$HttpBuilder$delete(url)))));
	});
var _user$project$Request_Package$deleteFromProject = F3(
	function (session, projectId, packageId) {
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/projects/',
				A2(
					_elm_lang$core$Basics_ops['++'],
					projectId,
					A2(_elm_lang$core$Basics_ops['++'], '/packages/', packageId))));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					_user$project$Request_Response$expectOk,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						_elm_lang$http$Http$emptyBody,
						_lukewestby$elm_http_builder$HttpBuilder$delete(url)))));
	});
var _user$project$Request_Package$putInAllParticipantsForProject = F4(
	function (session, projectId, updateGenerated, $package) {
		var body = _elm_lang$http$Http$jsonBody(
			_user$project$Request_Package$encodePackage($package));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/projects/',
				A2(
					_elm_lang$core$Basics_ops['++'],
					projectId,
					A2(
						_elm_lang$core$Basics_ops['++'],
						'/participants/packages/',
						A2(
							_elm_lang$core$Basics_ops['++'],
							$package.id,
							A2(
								_elm_lang$core$Basics_ops['++'],
								'?updateGenerated=',
								_elm_lang$core$Basics$toString(updateGenerated)))))));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					_user$project$Request_Response$expectOk,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						body,
						_lukewestby$elm_http_builder$HttpBuilder$put(url)))));
	});
var _user$project$Request_Package$putInParticipant = F3(
	function (session, participantId, $package) {
		var body = _elm_lang$http$Http$jsonBody(
			_user$project$Request_Package$encodePackage($package));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/participants/',
				A2(
					_elm_lang$core$Basics_ops['++'],
					participantId,
					A2(_elm_lang$core$Basics_ops['++'], '/packages/', $package.id))));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					_user$project$Request_Response$expectOk,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						body,
						_lukewestby$elm_http_builder$HttpBuilder$put(url)))));
	});
var _user$project$Request_Package$postInParticipant = F3(
	function (session, participantId, $package) {
		var body = _elm_lang$http$Http$jsonBody(
			_user$project$Request_Package$encodePackage($package));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/participants/',
				A2(_elm_lang$core$Basics_ops['++'], participantId, '/packages')));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					_user$project$Request_Response$expectOk,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						body,
						_lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var _user$project$Request_Package$putInProject = F3(
	function (session, projectId, $package) {
		var body = _elm_lang$http$Http$jsonBody(
			_user$project$Request_Package$encodePackage($package));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/projects/',
				A2(
					_elm_lang$core$Basics_ops['++'],
					projectId,
					A2(_elm_lang$core$Basics_ops['++'], '/packages/', $package.id))));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					_user$project$Request_Response$expectOk,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						body,
						_lukewestby$elm_http_builder$HttpBuilder$put(url)))));
	});
var _user$project$Request_Package$postInProject = F3(
	function (session, projectId, $package) {
		var body = _elm_lang$http$Http$jsonBody(
			_user$project$Request_Package$encodePackage($package));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/projects/',
				A2(_elm_lang$core$Basics_ops['++'], projectId, '/packages')));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					_user$project$Request_Response$expectOk,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						body,
						_lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var _user$project$Request_Package$Package = F7(
	function (a, b, c, d, e, f, g) {
		return {id: a, name: b, language: c, norm: d, jobProfile: e, requiredAssessmentIds: f, reports: g};
	});
var _user$project$Request_Package$decodePackage = A3(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
	'reports',
	_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$string),
	A3(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
		'requiredAssessmentIds',
		_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$string),
		A3(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
			'jobProfile',
			_elm_lang$core$Json_Decode$nullable(_elm_lang$core$Json_Decode$string),
			A3(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
				'norm',
				_elm_lang$core$Json_Decode$string,
				A3(
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
					'language',
					_elm_lang$core$Json_Decode$string,
					A3(
						_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
						'name',
						_elm_lang$core$Json_Decode$string,
						A3(
							_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
							'id',
							_elm_lang$core$Json_Decode$string,
							_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_user$project$Request_Package$Package))))))));
var _user$project$Request_Package$getAll = function (session) {
	var expect = _elm_lang$http$Http$expectJson(
		_elm_lang$core$Json_Decode$list(_user$project$Request_Package$decodePackage));
	var url = A2(_elm_lang$core$Basics_ops['++'], session.haloLiteApi, '/packages');
	return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
		A2(
			_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
			_user$project$Request_Headers$defaultHeaders(session),
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withExpect,
				expect,
				_lukewestby$elm_http_builder$HttpBuilder$get(url))));
};
var _user$project$Request_Package$getAllInProject = F2(
	function (session, projectId) {
		var expect = _elm_lang$http$Http$expectJson(
			_elm_lang$core$Json_Decode$list(_user$project$Request_Package$decodePackage));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/projects/',
				A2(_elm_lang$core$Basics_ops['++'], projectId, '/packages')));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					expect,
					_lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var _user$project$Request_Package$getInProject = F3(
	function (session, projectId, packageId) {
		var expect = _elm_lang$http$Http$expectJson(_user$project$Request_Package$decodePackage);
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/projects/',
				A2(
					_elm_lang$core$Basics_ops['++'],
					projectId,
					A2(_elm_lang$core$Basics_ops['++'], '/packages/', packageId))));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					expect,
					_lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var _user$project$Request_Package$getAllInParticipant = F2(
	function (session, participantId) {
		var expect = _elm_lang$http$Http$expectJson(
			_elm_lang$core$Json_Decode$list(_user$project$Request_Package$decodePackage));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/participants/',
				A2(_elm_lang$core$Basics_ops['++'], participantId, '/packages')));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					expect,
					_lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var _user$project$Request_Package$getInParticipant = F3(
	function (session, participantId, packageId) {
		var expect = _elm_lang$http$Http$expectJson(_user$project$Request_Package$decodePackage);
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/participants/',
				A2(
					_elm_lang$core$Basics_ops['++'],
					participantId,
					A2(_elm_lang$core$Basics_ops['++'], '/packages/', packageId))));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					expect,
					_lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});

var _user$project$Request_ReportAPI$rescoreReport = F5(
	function (session, clientId, projectId, userId, reportId) {
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.reportFileService,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/',
				A2(
					_elm_lang$core$Basics_ops['++'],
					clientId,
					A2(
						_elm_lang$core$Basics_ops['++'],
						'/',
						A2(
							_elm_lang$core$Basics_ops['++'],
							projectId,
							A2(
								_elm_lang$core$Basics_ops['++'],
								'/',
								A2(
									_elm_lang$core$Basics_ops['++'],
									userId,
									A2(
										_elm_lang$core$Basics_ops['++'],
										'/',
										A2(_elm_lang$core$Basics_ops['++'], reportId, '/generate')))))))));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					_user$project$Request_Response$expectOk,
					_lukewestby$elm_http_builder$HttpBuilder$post(url))));
	});
var _user$project$Request_ReportAPI$Rescoring = {ctor: 'Rescoring'};
var _user$project$Request_ReportAPI$NotAvailable = {ctor: 'NotAvailable'};
var _user$project$Request_ReportAPI$Available = {ctor: 'Available'};
var _user$project$Request_ReportAPI$decodeReportStatus = function () {
	var toReportStatus = function ($int) {
		var _p0 = $int;
		switch (_p0) {
			case 0:
				return _elm_lang$core$Json_Decode$succeed(_user$project$Request_ReportAPI$Available);
			case 1:
				return _elm_lang$core$Json_Decode$succeed(_user$project$Request_ReportAPI$Rescoring);
			case 2:
				return _elm_lang$core$Json_Decode$succeed(_user$project$Request_ReportAPI$NotAvailable);
			default:
				return _elm_lang$core$Json_Decode$fail('Expected ENUM value between 0 and 2');
		}
	};
	return A2(_elm_lang$core$Json_Decode$andThen, toReportStatus, _elm_lang$core$Json_Decode$int);
}();
var _user$project$Request_ReportAPI$isPackageAvailable = F4(
	function (session, clientId, userId, packageId) {
		var expect = _elm_lang$http$Http$expectJson(_user$project$Request_ReportAPI$decodeReportStatus);
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.reportFileService,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/',
				A2(
					_elm_lang$core$Basics_ops['++'],
					clientId,
					A2(
						_elm_lang$core$Basics_ops['++'],
						'/',
						A2(
							_elm_lang$core$Basics_ops['++'],
							userId,
							A2(
								_elm_lang$core$Basics_ops['++'],
								'/',
								A2(_elm_lang$core$Basics_ops['++'], packageId, '/package/status')))))));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					expect,
					_lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var _user$project$Request_ReportAPI$isReportAvailable = F4(
	function (session, clientId, userId, reportId) {
		var expect = _elm_lang$http$Http$expectJson(_user$project$Request_ReportAPI$decodeReportStatus);
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.reportFileService,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/',
				A2(
					_elm_lang$core$Basics_ops['++'],
					clientId,
					A2(
						_elm_lang$core$Basics_ops['++'],
						'/',
						A2(
							_elm_lang$core$Basics_ops['++'],
							userId,
							A2(
								_elm_lang$core$Basics_ops['++'],
								'/',
								A2(_elm_lang$core$Basics_ops['++'], reportId, '/report/status')))))));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					expect,
					_lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});

var _user$project$Page_ParticipantReportSettings$setReport = F2(
	function (product, model) {
		return _elm_lang$core$Native_Utils.update(
			model,
			{product: product});
	});
var _user$project$Page_ParticipantReportSettings$asReportIn = _elm_lang$core$Basics$flip(_user$project$Page_ParticipantReportSettings$setReport);
var _user$project$Page_ParticipantReportSettings$setLanguage = F2(
	function (language, product) {
		return _elm_lang$core$Native_Utils.update(
			product,
			{language: language});
	});
var _user$project$Page_ParticipantReportSettings$asLanguageIn = _elm_lang$core$Basics$flip(_user$project$Page_ParticipantReportSettings$setLanguage);
var _user$project$Page_ParticipantReportSettings$setNorm = F2(
	function (norm, product) {
		return _elm_lang$core$Native_Utils.update(
			product,
			{norm: norm});
	});
var _user$project$Page_ParticipantReportSettings$asNormIn = _elm_lang$core$Basics$flip(_user$project$Page_ParticipantReportSettings$setNorm);
var _user$project$Page_ParticipantReportSettings$setProfile = F2(
	function (profile, product) {
		return _elm_lang$core$Native_Utils.update(
			product,
			{
				jobProfile: _elm_lang$core$Maybe$Just(profile)
			});
	});
var _user$project$Page_ParticipantReportSettings$asProfileIn = _elm_lang$core$Basics$flip(_user$project$Page_ParticipantReportSettings$setProfile);
var _user$project$Page_ParticipantReportSettings$Model = F8(
	function (a, b, c, d, e, f, g, h) {
		return {projectId: a, participant: b, product: c, memento: d, availableJobProfiles: e, availableLanguages: f, availableNorms: g, isReportGenerated: h};
	});
var _user$project$Page_ParticipantReportSettings$SettingsMemento = F3(
	function (a, b, c) {
		return {norm: a, language: b, jobProfile: c};
	});
var _user$project$Page_ParticipantReportSettings$init = F5(
	function (session, projectId, participantId, reportId, productType) {
		var getJobProfiles = _elm_lang$http$Http$toTask(
			A2(_user$project$Request_JobProfile$getForReport, session, reportId));
		var getNorms = _elm_lang$http$Http$toTask(
			A2(_user$project$Request_Norm$getForReport, session, reportId));
		var getLanguages = _elm_lang$http$Http$toTask(
			A2(_user$project$Request_Language$getForReport, session, reportId));
		var _p0 = function () {
			var _p1 = productType;
			if (_p1.ctor === 'Report') {
				return {
					ctor: '_Tuple2',
					_0: A2(
						_elm_lang$core$Task$map,
						function (x) {
							return A8(
								_user$project$Page_Product$Product,
								x.id,
								x.name,
								x.language,
								x.norm,
								x.jobProfile,
								x.requiredAssessmentIds,
								{ctor: '[]'},
								productType);
						},
						_elm_lang$http$Http$toTask(
							A3(_user$project$Request_Report$getInParticipant, session, participantId, reportId))),
					_1: A2(
						_elm_lang$core$Task$map,
						function (x) {
							return !_elm_lang$core$Native_Utils.eq(x, _user$project$Request_ReportAPI$NotAvailable);
						},
						_elm_lang$http$Http$toTask(
							A4(_user$project$Request_ReportAPI$isReportAvailable, session, session.activeClient, participantId, reportId)))
				};
			} else {
				return {
					ctor: '_Tuple2',
					_0: A2(
						_elm_lang$core$Task$map,
						function (x) {
							return A8(_user$project$Page_Product$Product, x.id, x.name, x.language, x.norm, x.jobProfile, x.requiredAssessmentIds, x.reports, productType);
						},
						_elm_lang$http$Http$toTask(
							A3(_user$project$Request_Package$getInParticipant, session, participantId, reportId))),
					_1: A2(
						_elm_lang$core$Task$map,
						function (x) {
							return !_elm_lang$core$Native_Utils.eq(x, _user$project$Request_ReportAPI$NotAvailable);
						},
						_elm_lang$http$Http$toTask(
							A4(_user$project$Request_ReportAPI$isPackageAvailable, session, session.activeClient, participantId, reportId)))
				};
			}
		}();
		var getProduct = _p0._0;
		var getIsAvailableToDownload = _p0._1;
		var getParticipant = _elm_lang$http$Http$toTask(
			A2(_user$project$Request_Participant$get, session, participantId));
		return session.readOnly ? A3(
			_elm_lang$core$Task$map2,
			F2(
				function (part, prod) {
					return A8(
						_user$project$Page_ParticipantReportSettings$Model,
						projectId,
						part,
						prod,
						A3(_user$project$Page_ParticipantReportSettings$SettingsMemento, '', '', _elm_lang$core$Maybe$Nothing),
						{ctor: '[]'},
						{ctor: '[]'},
						{ctor: '[]'},
						false);
				}),
			getParticipant,
			getProduct) : A2(
			_elm_lang$core$Task$andThen,
			function (_p2) {
				var _p3 = _p2;
				var _p6 = _p3._1;
				var _p5 = _p3._0;
				var memento = A3(_user$project$Page_ParticipantReportSettings$SettingsMemento, _p6.norm, _p6.language, _p6.jobProfile);
				var _p4 = _p6.jobProfile;
				if (_p4.ctor === 'Just') {
					return A5(
						_elm_lang$core$Task$map4,
						A4(_user$project$Page_ParticipantReportSettings$Model, projectId, _p5, _p6, memento),
						getJobProfiles,
						getLanguages,
						getNorms,
						getIsAvailableToDownload);
				} else {
					return A4(
						_elm_lang$core$Task$map3,
						A5(
							_user$project$Page_ParticipantReportSettings$Model,
							projectId,
							_p5,
							_p6,
							memento,
							{ctor: '[]'}),
						getLanguages,
						getNorms,
						getIsAvailableToDownload);
				}
			},
			A3(
				_elm_lang$core$Task$map2,
				F2(
					function (part, product) {
						return {ctor: '_Tuple2', _0: part, _1: product};
					}),
				getParticipant,
				getProduct));
	});
var _user$project$Page_ParticipantReportSettings$Close = {ctor: 'Close'};
var _user$project$Page_ParticipantReportSettings$HandleResponse = function (a) {
	return {ctor: 'HandleResponse', _0: a};
};
var _user$project$Page_ParticipantReportSettings$UpdatePendingParticipant = function (a) {
	return {ctor: 'UpdatePendingParticipant', _0: a};
};
var _user$project$Page_ParticipantReportSettings$update = F3(
	function (msg, model, session) {
		var _p7 = msg;
		switch (_p7.ctor) {
			case 'SetLanguage':
				return {
					ctor: '_Tuple2',
					_0: A2(
						_user$project$Page_ParticipantReportSettings$asReportIn,
						model,
						A2(_user$project$Page_ParticipantReportSettings$asLanguageIn, model.product, _p7._0)),
					_1: _elm_lang$core$Platform_Cmd$none
				};
			case 'SetNorm':
				return {
					ctor: '_Tuple2',
					_0: A2(
						_user$project$Page_ParticipantReportSettings$asReportIn,
						model,
						A2(_user$project$Page_ParticipantReportSettings$asNormIn, model.product, _p7._0)),
					_1: _elm_lang$core$Platform_Cmd$none
				};
			case 'SetProfile':
				return {
					ctor: '_Tuple2',
					_0: A2(
						_user$project$Page_ParticipantReportSettings$asReportIn,
						model,
						A2(_user$project$Page_ParticipantReportSettings$asProfileIn, model.product, _p7._0)),
					_1: _elm_lang$core$Platform_Cmd$none
				};
			case 'Save':
				var save = function () {
					var _p8 = model.product.type_;
					if (_p8.ctor === 'Report') {
						return A3(
							_user$project$Request_Report$putInParticipant,
							session,
							model.participant.id,
							A6(_user$project$Request_Report$Report, model.product.id, model.product.name, model.product.language, model.product.norm, model.product.jobProfile, model.product.requiredAssessmentIds));
					} else {
						return A3(
							_user$project$Request_Package$putInParticipant,
							session,
							model.participant.id,
							A7(_user$project$Request_Package$Package, model.product.id, model.product.name, model.product.language, model.product.norm, model.product.jobProfile, model.product.requiredAssessmentIds, model.product.reports));
					}
				}();
				return {
					ctor: '_Tuple2',
					_0: model,
					_1: A2(_elm_lang$http$Http$send, _user$project$Page_ParticipantReportSettings$UpdatePendingParticipant, save)
				};
			case 'UpdatePendingParticipant':
				if (_p7._0.ctor === 'Ok') {
					return {
						ctor: '_Tuple2',
						_0: model,
						_1: A2(
							_elm_lang$http$Http$send,
							_user$project$Page_ParticipantReportSettings$HandleResponse,
							A5(_user$project$Request_ReportAPI$rescoreReport, session, session.activeClient, model.projectId, model.participant.id, model.product.id))
					};
				} else {
					return {
						ctor: '_Tuple2',
						_0: model,
						_1: _user$project$Route$error(_p7._0._0)
					};
				}
			case 'HandleResponse':
				if (_p7._0.ctor === 'Ok') {
					return {
						ctor: '_Tuple2',
						_0: model,
						_1: _user$project$Route$newUrl(
							A2(_user$project$Route$Participant, model.projectId, model.participant.id))
					};
				} else {
					return {
						ctor: '_Tuple2',
						_0: model,
						_1: _user$project$Route$error(_p7._0._0)
					};
				}
			default:
				return {
					ctor: '_Tuple2',
					_0: model,
					_1: _user$project$Route$newUrl(
						A2(_user$project$Route$Participant, model.projectId, model.participant.id))
				};
		}
	});
var _user$project$Page_ParticipantReportSettings$Save = {ctor: 'Save'};
var _user$project$Page_ParticipantReportSettings$SetProfile = function (a) {
	return {ctor: 'SetProfile', _0: a};
};
var _user$project$Page_ParticipantReportSettings$SetNorm = function (a) {
	return {ctor: 'SetNorm', _0: a};
};
var _user$project$Page_ParticipantReportSettings$SetLanguage = function (a) {
	return {ctor: 'SetLanguage', _0: a};
};

var _user$project$Page_EmailValidation$TooLong = {ctor: 'TooLong'};
var _user$project$Page_EmailValidation$MultipleConsecutiveDots = {ctor: 'MultipleConsecutiveDots'};
var _user$project$Page_EmailValidation$NoDotAfterCommercialAt = {ctor: 'NoDotAfterCommercialAt'};
var _user$project$Page_EmailValidation$Blank = {ctor: 'Blank'};
var _user$project$Page_EmailValidation$MissingCommercialAt = {ctor: 'MissingCommercialAt'};
var _user$project$Page_EmailValidation$emailValidator = _rtfeldman$elm_validate$Validate$firstError(
	{
		ctor: '::',
		_0: A2(_rtfeldman$elm_validate$Validate$ifBlank, _elm_lang$core$Basics$identity, _user$project$Page_EmailValidation$Blank),
		_1: {
			ctor: '::',
			_0: A2(_rtfeldman$elm_validate$Validate$ifInvalidEmail, _elm_lang$core$Basics$identity, _user$project$Page_EmailValidation$MissingCommercialAt),
			_1: {
				ctor: '::',
				_0: A2(
					_rtfeldman$elm_validate$Validate$ifTrue,
					function (x) {
						return A2(_elm_lang$core$String$contains, '..', x);
					},
					_user$project$Page_EmailValidation$MultipleConsecutiveDots),
				_1: {
					ctor: '::',
					_0: A2(
						_rtfeldman$elm_validate$Validate$ifTrue,
						function (email) {
							return !A2(
								_elm_lang$core$Regex$contains,
								_elm_lang$core$Regex$regex('@.*\\..*$'),
								email);
						},
						_user$project$Page_EmailValidation$NoDotAfterCommercialAt),
					_1: {
						ctor: '::',
						_0: A2(
							_rtfeldman$elm_validate$Validate$ifTrue,
							function (x) {
								return _elm_lang$core$Native_Utils.cmp(
									_elm_lang$core$String$length(x),
									50) > 0;
							},
							_user$project$Page_EmailValidation$TooLong),
						_1: {ctor: '[]'}
					}
				}
			}
		}
	});
var _user$project$Page_EmailValidation$validateEmail = function (email) {
	return A2(
		_elm_lang$core$Maybe$map,
		function (x) {
			return {ctor: '_Tuple2', _0: email, _1: x};
		},
		_elm_lang$core$List$head(
			A2(_rtfeldman$elm_validate$Validate$validate, _user$project$Page_EmailValidation$emailValidator, email)));
};

var _user$project$Request_SampleInvitation$get = function (session) {
	var url = A2(_elm_lang$core$Basics_ops['++'], session.haloLiteApi, '/sample-invitations');
	return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
		A2(
			_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
			_user$project$Request_Headers$defaultHeaders(session),
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withExpect,
				_user$project$Request_Response$expectOk,
				_lukewestby$elm_http_builder$HttpBuilder$get(url))));
};

var _user$project$Page_AddParticipantsModal$getImproperlyFormattedEmails = function (emails) {
	return A2(_elm_lang$core$List$filterMap, _user$project$Page_EmailValidation$validateEmail, emails);
};
var _user$project$Page_AddParticipantsModal$parseIntoEmailList = function (semicolonSeparatedEmails) {
	return _elm_community$list_extra$List_Extra$unique(
		A2(
			_elm_lang$core$List$filter,
			function (_p0) {
				return !_elm_lang$core$String$isEmpty(_p0);
			},
			A2(
				_elm_lang$core$List$map,
				_elm_lang$core$String$trim,
				A2(_elm_lang$core$String$split, ';', semicolonSeparatedEmails))));
};
var _user$project$Page_AddParticipantsModal$findDuplicateEmails = F2(
	function (existingParticipants, proposedEmails) {
		var participantEmailSet = _elm_lang$core$Set$fromList(
			A2(
				_elm_lang$core$List$map,
				function (_) {
					return _.email;
				},
				existingParticipants));
		var proposedEmailsSet = _elm_lang$core$Set$fromList(proposedEmails);
		return _elm_lang$core$Set$toList(
			A2(_elm_lang$core$Set$intersect, participantEmailSet, proposedEmailsSet));
	});
var _user$project$Page_AddParticipantsModal$Model = F6(
	function (a, b, c, d, e, f) {
		return {projectId: a, semicolonSeparatedEmails: b, improperlyFormattedEmails: c, duplicateEmails: d, sampleInvitationStatus: e, requestInProgress: f};
	});
var _user$project$Page_AddParticipantsModal$SampleInvitationCompleted = function (a) {
	return {ctor: 'SampleInvitationCompleted', _0: a};
};
var _user$project$Page_AddParticipantsModal$SendSampleInvitation = {ctor: 'SendSampleInvitation'};
var _user$project$Page_AddParticipantsModal$ParticipantsAdded = function (a) {
	return {ctor: 'ParticipantsAdded', _0: a};
};
var _user$project$Page_AddParticipantsModal$AddParticipants = {ctor: 'AddParticipants'};
var _user$project$Page_AddParticipantsModal$ValidateDistinctEmails = function (a) {
	return {ctor: 'ValidateDistinctEmails', _0: a};
};
var _user$project$Page_AddParticipantsModal$UpdateWithNewInput = function (a) {
	return {ctor: 'UpdateWithNewInput', _0: a};
};
var _user$project$Page_AddParticipantsModal$Close = {ctor: 'Close'};
var _user$project$Page_AddParticipantsModal$HandleFocus = {ctor: 'HandleFocus'};
var _user$project$Page_AddParticipantsModal$Open = {ctor: 'Open'};
var _user$project$Page_AddParticipantsModal$NotSent = {ctor: 'NotSent'};
var _user$project$Page_AddParticipantsModal$init = function (projectId) {
	return A6(
		_user$project$Page_AddParticipantsModal$Model,
		projectId,
		'',
		{ctor: '[]'},
		{ctor: '[]'},
		_user$project$Page_AddParticipantsModal$NotSent,
		false);
};
var _user$project$Page_AddParticipantsModal$FailedToSend = {ctor: 'FailedToSend'};
var _user$project$Page_AddParticipantsModal$SentSuccessfully = {ctor: 'SentSuccessfully'};
var _user$project$Page_AddParticipantsModal$update = F3(
	function (msg, model, session) {
		var emails = _user$project$Page_AddParticipantsModal$parseIntoEmailList(model.semicolonSeparatedEmails);
		var _p1 = msg;
		switch (_p1.ctor) {
			case 'Open':
				return {
					ctor: '_Tuple2',
					_0: {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Maybe$Just(model),
						_1: A2(
							_elm_lang$core$Task$attempt,
							_elm_lang$core$Basics$always(_user$project$Page_AddParticipantsModal$HandleFocus),
							_elm_lang$dom$Dom$focus('SemicolonSeparatedEmails'))
					},
					_1: _elm_lang$core$Maybe$Nothing
				};
			case 'HandleFocus':
				return {
					ctor: '_Tuple2',
					_0: {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Maybe$Just(model),
						_1: _elm_lang$core$Platform_Cmd$none
					},
					_1: _elm_lang$core$Maybe$Nothing
				};
			case 'Close':
				return {
					ctor: '_Tuple2',
					_0: {ctor: '_Tuple2', _0: _elm_lang$core$Maybe$Nothing, _1: _elm_lang$core$Platform_Cmd$none},
					_1: _elm_lang$core$Maybe$Nothing
				};
			case 'UpdateWithNewInput':
				return {
					ctor: '_Tuple2',
					_0: {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Maybe$Just(
							_elm_lang$core$Native_Utils.update(
								model,
								{semicolonSeparatedEmails: _p1._0})),
						_1: _elm_lang$core$Platform_Cmd$none
					},
					_1: _elm_lang$core$Maybe$Nothing
				};
			case 'AddParticipants':
				if (_elm_lang$core$List$isEmpty(emails)) {
					return {
						ctor: '_Tuple2',
						_0: {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Maybe$Just(model),
							_1: _elm_lang$core$Platform_Cmd$none
						},
						_1: _elm_lang$core$Maybe$Nothing
					};
				} else {
					var _p2 = _user$project$Page_AddParticipantsModal$getImproperlyFormattedEmails(emails);
					if (_p2.ctor === '[]') {
						return {
							ctor: '_Tuple2',
							_0: {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Maybe$Just(
									_elm_lang$core$Native_Utils.update(
										model,
										{
											requestInProgress: true,
											improperlyFormattedEmails: {ctor: '[]'},
											sampleInvitationStatus: _user$project$Page_AddParticipantsModal$NotSent
										})),
								_1: A2(
									_elm_lang$http$Http$send,
									_user$project$Page_AddParticipantsModal$ValidateDistinctEmails,
									A2(_user$project$Request_Participant$getAllInProject, session, model.projectId))
							},
							_1: _elm_lang$core$Maybe$Nothing
						};
					} else {
						return {
							ctor: '_Tuple2',
							_0: {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Maybe$Just(
									_elm_lang$core$Native_Utils.update(
										model,
										{improperlyFormattedEmails: _p2, sampleInvitationStatus: _user$project$Page_AddParticipantsModal$NotSent})),
								_1: _elm_lang$core$Platform_Cmd$none
							},
							_1: _elm_lang$core$Maybe$Nothing
						};
					}
				}
			case 'ValidateDistinctEmails':
				if (_p1._0.ctor === 'Ok') {
					var _p3 = A2(_user$project$Page_AddParticipantsModal$findDuplicateEmails, _p1._0._0, emails);
					if (_p3.ctor === '[]') {
						return {
							ctor: '_Tuple2',
							_0: {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Maybe$Just(
									_elm_lang$core$Native_Utils.update(
										model,
										{
											requestInProgress: true,
											duplicateEmails: {ctor: '[]'},
											sampleInvitationStatus: _user$project$Page_AddParticipantsModal$NotSent
										})),
								_1: A2(
									_elm_lang$http$Http$send,
									_user$project$Page_AddParticipantsModal$ParticipantsAdded,
									A3(_user$project$Request_Participant$postEmails, session, model.projectId, emails))
							},
							_1: _elm_lang$core$Maybe$Nothing
						};
					} else {
						return {
							ctor: '_Tuple2',
							_0: {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Maybe$Just(
									_elm_lang$core$Native_Utils.update(
										model,
										{requestInProgress: false, duplicateEmails: _p3, sampleInvitationStatus: _user$project$Page_AddParticipantsModal$NotSent})),
								_1: _elm_lang$core$Platform_Cmd$none
							},
							_1: _elm_lang$core$Maybe$Nothing
						};
					}
				} else {
					return {
						ctor: '_Tuple2',
						_0: {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Maybe$Just(
								_elm_lang$core$Native_Utils.update(
									model,
									{requestInProgress: false})),
							_1: _user$project$Route$error(_p1._0._0)
						},
						_1: _elm_lang$core$Maybe$Nothing
					};
				}
			case 'ParticipantsAdded':
				if (_p1._0.ctor === 'Ok') {
					return {
						ctor: '_Tuple2',
						_0: {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Maybe$Just(
								_elm_lang$core$Native_Utils.update(
									model,
									{requestInProgress: false})),
							_1: _user$project$Route$newUrl(
								_user$project$Route$Participants(model.projectId))
						},
						_1: _elm_lang$core$Maybe$Just(_p1._0._0)
					};
				} else {
					return {
						ctor: '_Tuple2',
						_0: {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Maybe$Nothing,
							_1: _user$project$Route$error(_p1._0._0)
						},
						_1: _elm_lang$core$Maybe$Nothing
					};
				}
			case 'SendSampleInvitation':
				return {
					ctor: '_Tuple2',
					_0: {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Maybe$Just(model),
						_1: A2(
							_elm_lang$http$Http$send,
							_user$project$Page_AddParticipantsModal$SampleInvitationCompleted,
							_user$project$Request_SampleInvitation$get(session))
					},
					_1: _elm_lang$core$Maybe$Nothing
				};
			default:
				if (_p1._0.ctor === 'Ok') {
					return {
						ctor: '_Tuple2',
						_0: {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Maybe$Just(
								_elm_lang$core$Native_Utils.update(
									model,
									{sampleInvitationStatus: _user$project$Page_AddParticipantsModal$SentSuccessfully})),
							_1: _elm_lang$core$Platform_Cmd$none
						},
						_1: _elm_lang$core$Maybe$Nothing
					};
				} else {
					return {
						ctor: '_Tuple2',
						_0: {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Maybe$Just(
								_elm_lang$core$Native_Utils.update(
									model,
									{sampleInvitationStatus: _user$project$Page_AddParticipantsModal$FailedToSend})),
							_1: _elm_lang$core$Platform_Cmd$none
						},
						_1: _elm_lang$core$Maybe$Nothing
					};
				}
		}
	});

var _user$project$Request_Assessment$Assessment = F4(
	function (a, b, c, d) {
		return {id: a, participantId: b, projectId: c, date: d};
	});
var _user$project$Request_Assessment$decode = A3(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
	'completedDate',
	_elm_lang$core$Json_Decode$nullable(_elm_community$json_extra$Json_Decode_Extra$date),
	A3(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
		'projectId',
		_elm_lang$core$Json_Decode$string,
		A3(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
			'participantId',
			_elm_lang$core$Json_Decode$string,
			A3(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
				'id',
				_elm_lang$core$Json_Decode$string,
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_user$project$Request_Assessment$Assessment)))));
var _user$project$Request_Assessment$getAll = function (session) {
	var expect = _elm_lang$http$Http$expectJson(
		_elm_lang$core$Json_Decode$list(_user$project$Request_Assessment$decode));
	var url = A2(_elm_lang$core$Basics_ops['++'], session.haloLiteApi, '/assessments');
	return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
		A2(
			_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
			_user$project$Request_Headers$defaultHeaders(session),
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withExpect,
				expect,
				_lukewestby$elm_http_builder$HttpBuilder$get(url))));
};
var _user$project$Request_Assessment$getForProject = F2(
	function (session, projectId) {
		var expect = _elm_lang$http$Http$expectJson(
			_elm_lang$core$Json_Decode$list(_user$project$Request_Assessment$decode));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/projects/',
				A2(_elm_lang$core$Basics_ops['++'], projectId, '/assessments')));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					expect,
					_lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});

var _user$project$Request_Invitation$post = F2(
	function (id, session) {
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/participants/',
				A2(_elm_lang$core$Basics_ops['++'], id, '/invitations')));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					_user$project$Request_Response$expectOk,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						_elm_lang$http$Http$emptyBody,
						_lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});

var _user$project$Request_Reminder$post = F2(
	function (id, session) {
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/participants/',
				A2(_elm_lang$core$Basics_ops['++'], id, '/reminders')));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					_user$project$Request_Response$expectOk,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						_elm_lang$http$Http$emptyBody,
						_lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});

var _user$project$Views_Interpolation$interpolate = F2(
	function (string, values) {
		var interp = F3(
			function (depth, values, format) {
				interp:
				while (true) {
					var next = depth + 1;
					var token = A2(
						_elm_lang$core$Basics_ops['++'],
						'{',
						A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(depth),
							'}'));
					var _p0 = values;
					if (_p0.ctor === '::') {
						var _v1 = next,
							_v2 = _p0._1,
							_v3 = A2(
							_elm_lang$core$String$join,
							'',
							A2(
								_elm_lang$core$List$intersperse,
								_p0._0,
								A2(_elm_lang$core$String$split, token, format)));
						depth = _v1;
						values = _v2;
						format = _v3;
						continue interp;
					} else {
						return format;
					}
				}
			});
		return A3(interp, 0, values, string);
	});

var _user$project$Page_Participants$setUniqueId = F2(
	function (newUniqueId, participant) {
		return _elm_lang$core$Native_Utils.update(
			participant,
			{uniqueId: newUniqueId});
	});
var _user$project$Page_Participants$asUniqueIdIn = _elm_lang$core$Basics$flip(_user$project$Page_Participants$setUniqueId);
var _user$project$Page_Participants$setEmail = F2(
	function (newEmail, participant) {
		return _elm_lang$core$Native_Utils.update(
			participant,
			{email: newEmail});
	});
var _user$project$Page_Participants$asEmailIn = _elm_lang$core$Basics$flip(_user$project$Page_Participants$setEmail);
var _user$project$Page_Participants$setLastName = F2(
	function (newLastName, participant) {
		return _elm_lang$core$Native_Utils.update(
			participant,
			{lastName: newLastName});
	});
var _user$project$Page_Participants$asLastNameIn = _elm_lang$core$Basics$flip(_user$project$Page_Participants$setLastName);
var _user$project$Page_Participants$setFirstName = F2(
	function (newFirstName, participant) {
		return _elm_lang$core$Native_Utils.update(
			participant,
			{firstName: newFirstName});
	});
var _user$project$Page_Participants$asFirstNameIn = _elm_lang$core$Basics$flip(_user$project$Page_Participants$setFirstName);
var _user$project$Page_Participants$getStatus = function (item) {
	var _p0 = item;
	if (_p0.ctor === 'Package') {
		return _p0._1;
	} else {
		return _p0._1;
	}
};
var _user$project$Page_Participants$getDownloadUrl = F3(
	function (item, participantId, session) {
		var _p1 = item;
		if (_p1.ctor === 'Report') {
			return A2(
				_elm_lang$core$Basics_ops['++'],
				session.reportFileService,
				A2(
					_elm_lang$core$Basics_ops['++'],
					'/',
					A2(
						_elm_lang$core$Basics_ops['++'],
						session.activeClient,
						A2(
							_elm_lang$core$Basics_ops['++'],
							'/',
							A2(
								_elm_lang$core$Basics_ops['++'],
								participantId,
								A2(
									_elm_lang$core$Basics_ops['++'],
									'/',
									A2(
										_elm_lang$core$Basics_ops['++'],
										_p1._0.id,
										A2(_elm_lang$core$Basics_ops['++'], '/downloadreport?access_token=', session.accessToken))))))));
		} else {
			return A2(
				_elm_lang$core$Basics_ops['++'],
				session.reportFileService,
				A2(
					_elm_lang$core$Basics_ops['++'],
					'/',
					A2(
						_elm_lang$core$Basics_ops['++'],
						session.activeClient,
						A2(
							_elm_lang$core$Basics_ops['++'],
							'/',
							A2(
								_elm_lang$core$Basics_ops['++'],
								participantId,
								A2(
									_elm_lang$core$Basics_ops['++'],
									'/',
									A2(
										_elm_lang$core$Basics_ops['++'],
										_p1._0.id,
										A2(_elm_lang$core$Basics_ops['++'], '/downloadpackage?access_token=', session.accessToken))))))));
		}
	});
var _user$project$Page_Participants$getId = function (item) {
	var _p2 = item;
	if (_p2.ctor === 'Report') {
		return _p2._0.id;
	} else {
		return _p2._0.id;
	}
};
var _user$project$Page_Participants$getName = function (item) {
	var _p3 = item;
	if (_p3.ctor === 'Report') {
		return _p3._0.name;
	} else {
		return _p3._0.name;
	}
};
var _user$project$Page_Participants$initDataTable = _elm_lang$core$Native_Platform.outgoingPort(
	'initDataTable',
	function (v) {
		return [
			_elm_lang$core$Native_List.toArray(v._0).map(
			function (v) {
				return {id: v.id, firstName: v.firstName, lastName: v.lastName, fullName: v.fullName, email: v.email, progress: v.progress};
			}),
			(v._1.ctor === 'Nothing') ? null : v._1._0
		];
	});
var _user$project$Page_Participants$updateParticipantInList = _elm_lang$core$Native_Platform.outgoingPort(
	'updateParticipantInList',
	function (v) {
		return {id: v.id, firstName: v.firstName, lastName: v.lastName, fullName: v.fullName, email: v.email, progress: v.progress};
	});
var _user$project$Page_Participants$deselectParticipant = _elm_lang$core$Native_Platform.outgoingPort(
	'deselectParticipant',
	function (v) {
		return null;
	});
var _user$project$Page_Participants$participantClicked = _elm_lang$core$Native_Platform.incomingPort('participantClicked', _elm_lang$core$Json_Decode$string);
var _user$project$Page_Participants$Model = F7(
	function (a, b, c, d, e, f, g) {
		return {projectId: a, projectName: b, participants: c, assessments: d, state: e, modal: f, alert: g};
	});
var _user$project$Page_Participants$GridModel = F6(
	function (a, b, c, d, e, f) {
		return {id: a, firstName: b, lastName: c, fullName: d, email: e, progress: f};
	});
var _user$project$Page_Participants$serializeToGrid = F3(
	function (i18n, model, participant) {
		var assessments = A2(
			_elm_lang$core$List$filter,
			function (x) {
				return _elm_lang$core$Native_Utils.eq(x.participantId, participant.id);
			},
			model.assessments);
		var assessmentCount = _elm_lang$core$List$length(assessments);
		var statusText = function () {
			var localizeDate = function (date) {
				return A4(
					_rluiten$elm_date_extra$Date_Extra_Format$formatOffset,
					i18n.dateFormatConfig,
					_rluiten$elm_date_extra$Date_Extra_Create$getTimezoneOffset(date),
					i18n.dateFormatConfig.format.longDate,
					date);
			};
			var foldStatus = F2(
				function (x, a) {
					var _p4 = x.date;
					if (_p4.ctor === 'Just') {
						var _p5 = _p4._0;
						return (_elm_lang$core$Native_Utils.cmp(
							_elm_lang$core$Date$toTime(_p5),
							a.maxDate) > 0) ? _elm_lang$core$Native_Utils.update(
							a,
							{
								maxDate: _elm_lang$core$Date$toTime(_p5),
								text: localizeDate(_p5)
							}) : a;
					} else {
						var infinity = 1 / 0;
						var newCount = a.incompleteCount + 1;
						var completeCount = assessmentCount - newCount;
						return _elm_lang$core$Native_Utils.update(
							a,
							{
								maxDate: infinity,
								incompleteCount: newCount,
								text: A2(
									_user$project$Views_Interpolation$interpolate,
									i18n.progressCounter,
									{
										ctor: '::',
										_0: _elm_lang$core$Basics$toString(completeCount),
										_1: {
											ctor: '::',
											_0: _elm_lang$core$Basics$toString(assessmentCount),
											_1: {ctor: '[]'}
										}
									})
							});
					}
				});
			return function (_) {
				return _.text;
			}(
				A3(
					_elm_lang$core$List$foldl,
					foldStatus,
					{maxDate: 0.0, incompleteCount: 0, text: ''},
					assessments));
		}();
		return A6(
			_user$project$Page_Participants$GridModel,
			participant.id,
			participant.firstName,
			participant.lastName,
			A2(
				_elm_lang$core$Basics_ops['++'],
				participant.firstName,
				A2(_elm_lang$core$Basics_ops['++'], ' ', participant.lastName)),
			participant.email,
			statusText);
	});
var _user$project$Page_Participants$initializeDataTable = F2(
	function (model, i18n) {
		var selectedParticipant = function () {
			var _p6 = model.state;
			switch (_p6.ctor) {
				case 'Selected':
					return _elm_lang$core$Maybe$Just(_p6._0);
				case 'Editing':
					return _elm_lang$core$Maybe$Just(_p6._0);
				default:
					return _elm_lang$core$Maybe$Nothing;
			}
		}();
		return _user$project$Page_Participants$initDataTable(
			{
				ctor: '_Tuple2',
				_0: A2(
					_elm_lang$core$List$map,
					A2(_user$project$Page_Participants$serializeToGrid, i18n, model),
					model.participants),
				_1: A2(
					_elm_lang$core$Maybe$map,
					function (_) {
						return _.id;
					},
					selectedParticipant)
			});
	});
var _user$project$Page_Participants$Editing = F2(
	function (a, b) {
		return {ctor: 'Editing', _0: a, _1: b};
	});
var _user$project$Page_Participants$Selected = F2(
	function (a, b) {
		return {ctor: 'Selected', _0: a, _1: b};
	});
var _user$project$Page_Participants$Loaded = {ctor: 'Loaded'};
var _user$project$Page_Participants$Report = F2(
	function (a, b) {
		return {ctor: 'Report', _0: a, _1: b};
	});
var _user$project$Page_Participants$Package = F2(
	function (a, b) {
		return {ctor: 'Package', _0: a, _1: b};
	});
var _user$project$Page_Participants$SendError = function (a) {
	return {ctor: 'SendError', _0: a};
};
var _user$project$Page_Participants$SentEmail = function (a) {
	return {ctor: 'SentEmail', _0: a};
};
var _user$project$Page_Participants$ParticipantsAddedAndInvitesSent = {ctor: 'ParticipantsAddedAndInvitesSent'};
var _user$project$Page_Participants$None = {ctor: 'None'};
var _user$project$Page_Participants$init = F4(
	function (session, projectId, participantId, modelAndReloadOption) {
		var selectParticipant = function (newModel) {
			var _p7 = participantId;
			if (_p7.ctor === 'Just') {
				var _p13 = _p7._0;
				var participant = A2(
					_elm_community$list_extra$List_Extra$find,
					function (x) {
						return _elm_lang$core$Native_Utils.eq(x.id, _p13);
					},
					newModel.participants);
				var _p8 = participant;
				if (_p8.ctor === 'Just') {
					var fetchPackageAvailability = function (partials) {
						return _elm_lang$core$Task$sequence(
							A2(
								_elm_lang$core$List$map,
								function (_p9) {
									var _p10 = _p9;
									return A2(
										_elm_lang$core$Task$map,
										_p10._1,
										_elm_lang$http$Http$toTask(
											A4(_user$project$Request_ReportAPI$isPackageAvailable, session, session.activeClient, _p13, _p10._0)));
								},
								partials));
					};
					var fetchPackages = A2(
						_elm_lang$core$Task$andThen,
						fetchPackageAvailability,
						A2(
							_elm_lang$core$Task$map,
							_elm_lang$core$List$map(
								function (p) {
									return {
										ctor: '_Tuple2',
										_0: p.id,
										_1: _user$project$Page_Participants$Package(p)
									};
								}),
							_elm_lang$http$Http$toTask(
								A2(_user$project$Request_Package$getAllInParticipant, session, _p13))));
					var fetchReportAvailability = function (partials) {
						return _elm_lang$core$Task$sequence(
							A2(
								_elm_lang$core$List$map,
								function (_p11) {
									var _p12 = _p11;
									return A2(
										_elm_lang$core$Task$map,
										_p12._1,
										_elm_lang$http$Http$toTask(
											A4(_user$project$Request_ReportAPI$isReportAvailable, session, session.activeClient, _p13, _p12._0)));
								},
								partials));
					};
					var fetchReports = A2(
						_elm_lang$core$Task$andThen,
						fetchReportAvailability,
						A2(
							_elm_lang$core$Task$map,
							_elm_lang$core$List$map(
								function (r) {
									return {
										ctor: '_Tuple2',
										_0: r.id,
										_1: _user$project$Page_Participants$Report(r)
									};
								}),
							_elm_lang$http$Http$toTask(
								A2(_user$project$Request_Report$getAllInParticipant, session, _p13))));
					var fetchReportsAndPackages = A3(
						_elm_lang$core$Task$map2,
						F2(
							function (reports, packages) {
								return _elm_lang$core$List$concat(
									{
										ctor: '::',
										_0: reports,
										_1: {
											ctor: '::',
											_0: packages,
											_1: {ctor: '[]'}
										}
									});
							}),
						fetchReports,
						fetchPackages);
					return A2(
						_elm_lang$core$Task$map,
						function (x) {
							return _elm_lang$core$Native_Utils.update(
								newModel,
								{
									state: A2(_user$project$Page_Participants$Selected, _p8._0, x)
								});
						},
						fetchReportsAndPackages);
				} else {
					return _elm_lang$core$Task$fail(
						_elm_lang$http$Http$BadUrl(''));
				}
			} else {
				return _elm_lang$core$Task$succeed(newModel);
			}
		};
		var loadAssessments = _elm_lang$http$Http$toTask(
			A2(_user$project$Request_Assessment$getForProject, session, projectId));
		var loadParticipants = _elm_lang$http$Http$toTask(
			A2(_user$project$Request_Participant$getAllInProject, session, projectId));
		var loadProject = _elm_lang$http$Http$toTask(
			A2(_user$project$Request_Project$get, session, projectId));
		var retrieveFromService = A4(
			_elm_lang$core$Task$map3,
			F3(
				function (a, b, c) {
					return A7(_user$project$Page_Participants$Model, a.id, a.name, b, c, _user$project$Page_Participants$Loaded, _elm_lang$core$Maybe$Nothing, _user$project$Page_Participants$None);
				}),
			loadProject,
			loadParticipants,
			loadAssessments);
		var loadProjectDetails = function () {
			var _p14 = modelAndReloadOption;
			if (_p14.ctor === 'Just') {
				var _p15 = _p14._0._0;
				return _elm_lang$core$Native_Utils.eq(_p15.projectId, projectId) ? (_p14._0._1 ? A3(
					_elm_lang$core$Task$map2,
					F2(
						function (participants, assessments) {
							return _elm_lang$core$Native_Utils.update(
								_p15,
								{participants: participants, assessments: assessments});
						}),
					loadParticipants,
					loadAssessments) : _elm_lang$core$Task$succeed(_p15)) : retrieveFromService;
			} else {
				return retrieveFromService;
			}
		}();
		return A2(_elm_lang$core$Task$andThen, selectParticipant, loadProjectDetails);
	});
var _user$project$Page_Participants$UniqueID = {ctor: 'UniqueID'};
var _user$project$Page_Participants$Email = {ctor: 'Email'};
var _user$project$Page_Participants$LastName = {ctor: 'LastName'};
var _user$project$Page_Participants$FirstName = {ctor: 'FirstName'};
var _user$project$Page_Participants$EmailSent = F2(
	function (a, b) {
		return {ctor: 'EmailSent', _0: a, _1: b};
	});
var _user$project$Page_Participants$EmailParticipant = {ctor: 'EmailParticipant'};
var _user$project$Page_Participants$DismissAlert = {ctor: 'DismissAlert'};
var _user$project$Page_Participants$AddParticipantsModalMsg = F2(
	function (a, b) {
		return {ctor: 'AddParticipantsModalMsg', _0: a, _1: b};
	});
var _user$project$Page_Participants$AddParticipantsClicked = {ctor: 'AddParticipantsClicked'};
var _user$project$Page_Participants$RescoredReport = function (a) {
	return {ctor: 'RescoredReport', _0: a};
};
var _user$project$Page_Participants$RescoreReport = function (a) {
	return {ctor: 'RescoreReport', _0: a};
};
var _user$project$Page_Participants$NavigateToParticipantReportSettings = function (a) {
	return {ctor: 'NavigateToParticipantReportSettings', _0: a};
};
var _user$project$Page_Participants$Focused = function (a) {
	return {ctor: 'Focused', _0: a};
};
var _user$project$Page_Participants$FinishEdit = function (a) {
	return {ctor: 'FinishEdit', _0: a};
};
var _user$project$Page_Participants$update = F3(
	function (msg, model, session) {
		update:
		while (true) {
			var _p16 = {ctor: '_Tuple2', _0: msg, _1: model.state};
			_v11_21:
			do {
				switch (_p16._0.ctor) {
					case 'ParticipantRowClicked':
						var _p18 = _p16._0._0;
						var getParticipant = function () {
							var _p17 = model.state;
							switch (_p17.ctor) {
								case 'Selected':
									return _elm_lang$core$Maybe$Just(_p17._0);
								case 'Editing':
									return _elm_lang$core$Maybe$Just(_p17._0);
								default:
									return _elm_lang$core$Maybe$Nothing;
							}
						}();
						var route = _elm_lang$core$Native_Utils.eq(
							A2(
								_elm_lang$core$Maybe$map,
								function (_) {
									return _.id;
								},
								getParticipant),
							_elm_lang$core$Maybe$Just(_p18)) ? _user$project$Route$Participants(model.projectId) : A2(_user$project$Route$Participant, model.projectId, _p18);
						return {
							ctor: '_Tuple2',
							_0: model,
							_1: _user$project$Route$newUrl(route)
						};
					case 'DeselectParticipant':
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{state: _user$project$Page_Participants$Loaded, alert: _user$project$Page_Participants$None}),
							_1: _user$project$Page_Participants$deselectParticipant(
								{ctor: '_Tuple0'})
						};
					case 'Edit':
						if (_p16._1.ctor === 'Selected') {
							return session.readOnly ? {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none} : {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Native_Utils.update(
									model,
									{
										state: A2(_user$project$Page_Participants$Editing, _p16._1._0, _p16._1._1)
									}),
								_1: _elm_lang$core$Platform_Cmd$none
							};
						} else {
							break _v11_21;
						}
					case 'CancelEdit':
						if (_p16._1.ctor === 'Editing') {
							var newState = function () {
								var _p19 = A2(
									_elm_community$list_extra$List_Extra$find,
									function (p) {
										return _elm_lang$core$Native_Utils.eq(p.id, _p16._1._0.id);
									},
									model.participants);
								if (_p19.ctor === 'Just') {
									return A2(_user$project$Page_Participants$Selected, _p19._0, _p16._1._1);
								} else {
									return _user$project$Page_Participants$Loaded;
								}
							}();
							return {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Native_Utils.update(
									model,
									{state: newState}),
								_1: _elm_lang$core$Platform_Cmd$none
							};
						} else {
							break _v11_21;
						}
					case 'UpdateFirstName':
						if (_p16._1.ctor === 'Editing') {
							var changedParticipant = A2(_user$project$Page_Participants$asFirstNameIn, _p16._1._0, _p16._0._0);
							return {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Native_Utils.update(
									model,
									{
										state: A2(_user$project$Page_Participants$Editing, changedParticipant, _p16._1._1)
									}),
								_1: _elm_lang$core$Platform_Cmd$none
							};
						} else {
							break _v11_21;
						}
					case 'UpdateLastName':
						if (_p16._1.ctor === 'Editing') {
							var changedParticipant = A2(_user$project$Page_Participants$asLastNameIn, _p16._1._0, _p16._0._0);
							return {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Native_Utils.update(
									model,
									{
										state: A2(_user$project$Page_Participants$Editing, changedParticipant, _p16._1._1)
									}),
								_1: _elm_lang$core$Platform_Cmd$none
							};
						} else {
							break _v11_21;
						}
					case 'UpdateEmail':
						if (_p16._1.ctor === 'Editing') {
							var changedParticipant = A2(_user$project$Page_Participants$asEmailIn, _p16._1._0, _p16._0._0);
							return {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Native_Utils.update(
									model,
									{
										state: A2(_user$project$Page_Participants$Editing, changedParticipant, _p16._1._1)
									}),
								_1: _elm_lang$core$Platform_Cmd$none
							};
						} else {
							break _v11_21;
						}
					case 'UpdateUniqueId':
						if (_p16._1.ctor === 'Editing') {
							var changedParticipant = A2(_user$project$Page_Participants$asUniqueIdIn, _p16._1._0, _p16._0._0);
							return {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Native_Utils.update(
									model,
									{
										state: A2(_user$project$Page_Participants$Editing, changedParticipant, _p16._1._1)
									}),
								_1: _elm_lang$core$Platform_Cmd$none
							};
						} else {
							break _v11_21;
						}
					case 'SaveParticipant':
						if (_p16._1.ctor === 'Editing') {
							var _p21 = _p16._1._0;
							var convertParticipant = A6(_user$project$Request_Participant$Participant, _p21.id, _p21.firstName, _p21.lastName, _p21.email, _p21.uniqueId, _p21.passwordSetByUser);
							var makeRequest = function () {
								var _p20 = A2(_user$project$Request_Participant$isValid, session, _p21);
								if (_p20.ctor === 'Ok') {
									return A2(
										_elm_lang$http$Http$send,
										_user$project$Page_Participants$FinishEdit,
										A2(_user$project$Request_Participant$put, session, convertParticipant));
								} else {
									return _elm_lang$core$Platform_Cmd$none;
								}
							}();
							return {ctor: '_Tuple2', _0: model, _1: makeRequest};
						} else {
							break _v11_21;
						}
					case 'FinishEdit':
						if (_p16._0._0.ctor === 'Ok') {
							if ((_p16._0._0._0.ctor === '_Tuple0') && (_p16._1.ctor === 'Editing')) {
								var _p22 = _p16._1._0;
								var updateGrid = _user$project$Page_Participants$updateParticipantInList(
									A3(_user$project$Page_Participants$serializeToGrid, session.i18n, model, _p22));
								var updatedParticipants = A3(
									_elm_community$list_extra$List_Extra$replaceIf,
									function (x) {
										return _elm_lang$core$Native_Utils.eq(x.id, _p22.id);
									},
									_p22,
									model.participants);
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Native_Utils.update(
										model,
										{
											state: A2(_user$project$Page_Participants$Selected, _p22, _p16._1._1),
											participants: updatedParticipants
										}),
									_1: updateGrid
								};
							} else {
								break _v11_21;
							}
						} else {
							return {
								ctor: '_Tuple2',
								_0: model,
								_1: _user$project$Route$error(_p16._0._0._0)
							};
						}
					case 'RescoreReport':
						if (_p16._1.ctor === 'Selected') {
							var _p25 = _p16._1._0;
							var _p24 = _p16._0._0;
							var updatedReports = A2(
								_elm_lang$core$List$map,
								function (reportOrPackage) {
									var toggleRescoring = F2(
										function (item, type_) {
											return _elm_lang$core$Native_Utils.eq(
												function (_) {
													return _.id;
												}(item),
												_p24) ? A2(type_, item, _user$project$Request_ReportAPI$Rescoring) : reportOrPackage;
										});
									var _p23 = reportOrPackage;
									if (_p23.ctor === 'Package') {
										return A2(toggleRescoring, _p23._0, _user$project$Page_Participants$Package);
									} else {
										return A2(toggleRescoring, _p23._0, _user$project$Page_Participants$Report);
									}
								},
								_p16._1._1);
							return {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Native_Utils.update(
									model,
									{
										state: A2(_user$project$Page_Participants$Selected, _p25, updatedReports)
									}),
								_1: A2(
									_elm_lang$http$Http$send,
									_user$project$Page_Participants$RescoredReport,
									A5(_user$project$Request_ReportAPI$rescoreReport, session, session.activeClient, model.projectId, _p25.id, _p24))
							};
						} else {
							break _v11_21;
						}
					case 'RescoredReport':
						if (_p16._0._0.ctor === 'Ok') {
							if (_p16._0._0._0.ctor === '_Tuple0') {
								return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
							} else {
								break _v11_21;
							}
						} else {
							return {
								ctor: '_Tuple2',
								_0: model,
								_1: _user$project$Route$error(_p16._0._0._0)
							};
						}
					case 'NavigateToParticipantReportSettings':
						if (_p16._1.ctor === 'Selected') {
							var _p27 = _p16._1._0;
							var route = function () {
								var _p26 = _p16._0._0;
								if (_p26.ctor === 'Package') {
									return A3(_user$project$Route$ParticipantPackageSettings, model.projectId, _p27.id, _p26._0.id);
								} else {
									return A3(_user$project$Route$ParticipantReportSettings, model.projectId, _p27.id, _p26._0.id);
								}
							}();
							return {
								ctor: '_Tuple2',
								_0: model,
								_1: _user$project$Route$newUrl(route)
							};
						} else {
							break _v11_21;
						}
					case 'AddParticipantsClicked':
						var _v17 = A2(
							_user$project$Page_Participants$AddParticipantsModalMsg,
							_user$project$Page_AddParticipantsModal$init(model.projectId),
							_user$project$Page_AddParticipantsModal$Open),
							_v18 = _elm_lang$core$Native_Utils.update(
							model,
							{alert: _user$project$Page_Participants$None}),
							_v19 = session;
						msg = _v17;
						model = _v18;
						session = _v19;
						continue update;
					case 'AddParticipantsModalMsg':
						var _p28 = A3(_user$project$Page_AddParticipantsModal$update, _p16._0._1, _p16._0._0, session);
						var newSubModel = _p28._0._0;
						var newSubCmd = _p28._0._1;
						var result = _p28._1;
						var _p29 = {ctor: '_Tuple2', _0: result, _1: newSubModel};
						if (_p29._0.ctor === 'Just') {
							if (_p29._1.ctor === 'Just') {
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Native_Utils.update(
										model,
										{alert: _user$project$Page_Participants$ParticipantsAddedAndInvitesSent, modal: _elm_lang$core$Maybe$Nothing}),
									_1: A2(
										_elm_lang$core$Platform_Cmd$map,
										_user$project$Page_Participants$AddParticipantsModalMsg(_p29._1._0),
										newSubCmd)
								};
							} else {
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Native_Utils.update(
										model,
										{modal: newSubModel}),
									_1: _elm_lang$core$Platform_Cmd$none
								};
							}
						} else {
							if (_p29._1.ctor === 'Just') {
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Native_Utils.update(
										model,
										{modal: newSubModel}),
									_1: A2(
										_elm_lang$core$Platform_Cmd$map,
										_user$project$Page_Participants$AddParticipantsModalMsg(_p29._1._0),
										newSubCmd)
								};
							} else {
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Native_Utils.update(
										model,
										{modal: newSubModel}),
									_1: _elm_lang$core$Platform_Cmd$none
								};
							}
						}
					case 'DismissAlert':
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{alert: _user$project$Page_Participants$None}),
							_1: _elm_lang$core$Platform_Cmd$none
						};
					case 'EmailParticipant':
						if (_p16._1.ctor === 'Selected') {
							var _p30 = _p16._1._0;
							var post = _p30.passwordSetByUser ? A2(_user$project$Request_Reminder$post, _p30.id, session) : A2(_user$project$Request_Invitation$post, _p30.id, session);
							return {
								ctor: '_Tuple2',
								_0: model,
								_1: A2(
									_elm_lang$http$Http$send,
									_user$project$Page_Participants$EmailSent(_p30),
									post)
							};
						} else {
							break _v11_21;
						}
					case 'EmailSent':
						if (_p16._0._1.ctor === 'Ok') {
							if (_p16._0._1._0.ctor === '_Tuple0') {
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Native_Utils.update(
										model,
										{
											alert: _user$project$Page_Participants$SentEmail(_p16._0._0)
										}),
									_1: _elm_lang$core$Platform_Cmd$none
								};
							} else {
								break _v11_21;
							}
						} else {
							return {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Native_Utils.update(
									model,
									{
										alert: _user$project$Page_Participants$SendError(_p16._0._0)
									}),
								_1: _elm_lang$core$Platform_Cmd$none
							};
						}
					default:
						break _v11_21;
				}
			} while(false);
			return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
		}
	});
var _user$project$Page_Participants$SaveParticipant = {ctor: 'SaveParticipant'};
var _user$project$Page_Participants$UpdateUniqueId = function (a) {
	return {ctor: 'UpdateUniqueId', _0: a};
};
var _user$project$Page_Participants$UpdateEmail = function (a) {
	return {ctor: 'UpdateEmail', _0: a};
};
var _user$project$Page_Participants$UpdateLastName = function (a) {
	return {ctor: 'UpdateLastName', _0: a};
};
var _user$project$Page_Participants$UpdateFirstName = function (a) {
	return {ctor: 'UpdateFirstName', _0: a};
};
var _user$project$Page_Participants$CancelEdit = {ctor: 'CancelEdit'};
var _user$project$Page_Participants$Edit = {ctor: 'Edit'};
var _user$project$Page_Participants$DeselectParticipant = {ctor: 'DeselectParticipant'};
var _user$project$Page_Participants$ParticipantRowClicked = function (a) {
	return {ctor: 'ParticipantRowClicked', _0: a};
};
var _user$project$Page_Participants$subscriptions = _elm_lang$core$Platform_Sub$batch(
	{
		ctor: '::',
		_0: _user$project$Page_Participants$participantClicked(_user$project$Page_Participants$ParticipantRowClicked),
		_1: {ctor: '[]'}
	});

var _user$project$Page_EmailNotifications$Model = F6(
	function (a, b, c, d, e, f) {
		return {project: a, editingSubscriber: b, subscriber1: c, subscriber2: d, subscriber3: e, subscriber4: f};
	});
var _user$project$Page_EmailNotifications$Subscriber = F3(
	function (a, b, c) {
		return {id: a, value: b, state: c};
	});
var _user$project$Page_EmailNotifications$HasError = function (a) {
	return {ctor: 'HasError', _0: a};
};
var _user$project$Page_EmailNotifications$NoError = {ctor: 'NoError'};
var _user$project$Page_EmailNotifications$init = F2(
	function (session, project) {
		return A6(
			_user$project$Page_EmailNotifications$Model,
			project,
			_elm_lang$core$Maybe$Nothing,
			A3(_user$project$Page_EmailNotifications$Subscriber, 1, project.email1, _user$project$Page_EmailNotifications$NoError),
			A3(_user$project$Page_EmailNotifications$Subscriber, 2, project.email2, _user$project$Page_EmailNotifications$NoError),
			A3(_user$project$Page_EmailNotifications$Subscriber, 3, project.email3, _user$project$Page_EmailNotifications$NoError),
			A3(_user$project$Page_EmailNotifications$Subscriber, 4, project.email4, _user$project$Page_EmailNotifications$NoError));
	});
var _user$project$Page_EmailNotifications$Posted = F2(
	function (a, b) {
		return {ctor: 'Posted', _0: a, _1: b};
	});
var _user$project$Page_EmailNotifications$ClearSubscriber = function (a) {
	return {ctor: 'ClearSubscriber', _0: a};
};
var _user$project$Page_EmailNotifications$update = F3(
	function (msg, model, session) {
		update:
		while (true) {
			var toSubscription = function (model_) {
				var project = model_.project;
				return _elm_lang$core$Native_Utils.update(
					project,
					{email1: model_.subscriber1.value, email2: model_.subscriber2.value, email3: model_.subscriber3.value, email4: model_.subscriber4.value});
			};
			var updateSubscription = F2(
				function (updatedSubscriber, model) {
					var _p0 = updatedSubscriber.id;
					switch (_p0) {
						case 1:
							return _elm_lang$core$Native_Utils.update(
								model,
								{subscriber1: updatedSubscriber});
						case 2:
							return _elm_lang$core$Native_Utils.update(
								model,
								{subscriber2: updatedSubscriber});
						case 3:
							return _elm_lang$core$Native_Utils.update(
								model,
								{subscriber3: updatedSubscriber});
						default:
							return _elm_lang$core$Native_Utils.update(
								model,
								{subscriber4: updatedSubscriber});
					}
				});
			var _p1 = msg;
			switch (_p1.ctor) {
				case 'ChangeSubscriber':
					var toMaybe = function (str) {
						return _elm_lang$core$String$isEmpty(str) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(str);
					};
					var updatedSubscriber = _elm_lang$core$Native_Utils.update(
						_p1._0,
						{
							value: toMaybe(_p1._1),
							state: _user$project$Page_EmailNotifications$NoError
						});
					var updatedModel = A2(updateSubscription, updatedSubscriber, model);
					return {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Native_Utils.update(
							updatedModel,
							{
								editingSubscriber: _elm_lang$core$Maybe$Just(updatedSubscriber)
							}),
						_1: _elm_lang$core$Platform_Cmd$none
					};
				case 'SubscriberChangeComplete':
					var _p2 = model.editingSubscriber;
					if (_p2.ctor === 'Just') {
						var _p5 = _p2._0;
						var _p3 = _p5.value;
						if (_p3.ctor === 'Just') {
							var _p4 = _user$project$Page_EmailValidation$validateEmail(
								A2(_elm_lang$core$Maybe$withDefault, '', _p5.value));
							if (_p4.ctor === 'Just') {
								return {
									ctor: '_Tuple2',
									_0: A2(
										updateSubscription,
										_elm_lang$core$Native_Utils.update(
											_p5,
											{
												state: _user$project$Page_EmailNotifications$HasError(
													_elm_lang$core$Maybe$Just(_p4._0._1))
											}),
										model),
									_1: _elm_lang$core$Platform_Cmd$none
								};
							} else {
								return {
									ctor: '_Tuple2',
									_0: model,
									_1: A2(
										_elm_lang$http$Http$send,
										_user$project$Page_EmailNotifications$Posted(_p5),
										A2(
											_user$project$Request_Project$put,
											session,
											toSubscription(model)))
								};
							}
						} else {
							var _v5 = _user$project$Page_EmailNotifications$ClearSubscriber(_p5),
								_v6 = model,
								_v7 = session;
							msg = _v5;
							model = _v6;
							session = _v7;
							continue update;
						}
					} else {
						return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
					}
				case 'ClearSubscriber':
					var _p7 = _p1._0;
					var updatedModel = function () {
						var _p6 = _p7.id;
						switch (_p6) {
							case 1:
								return A2(
									updateSubscription,
									A3(_user$project$Page_EmailNotifications$Subscriber, 4, _elm_lang$core$Maybe$Nothing, _user$project$Page_EmailNotifications$NoError),
									A2(
										updateSubscription,
										A3(_user$project$Page_EmailNotifications$Subscriber, 3, model.subscriber4.value, model.subscriber4.state),
										A2(
											updateSubscription,
											A3(_user$project$Page_EmailNotifications$Subscriber, 2, model.subscriber3.value, model.subscriber3.state),
											A2(
												updateSubscription,
												A3(_user$project$Page_EmailNotifications$Subscriber, 1, model.subscriber2.value, model.subscriber2.state),
												model))));
							case 2:
								return A2(
									updateSubscription,
									A3(_user$project$Page_EmailNotifications$Subscriber, 4, _elm_lang$core$Maybe$Nothing, _user$project$Page_EmailNotifications$NoError),
									A2(
										updateSubscription,
										A3(_user$project$Page_EmailNotifications$Subscriber, 3, model.subscriber4.value, model.subscriber4.state),
										A2(
											updateSubscription,
											A3(_user$project$Page_EmailNotifications$Subscriber, 2, model.subscriber3.value, model.subscriber3.state),
											model)));
							case 3:
								return A2(
									updateSubscription,
									A3(_user$project$Page_EmailNotifications$Subscriber, 4, _elm_lang$core$Maybe$Nothing, _user$project$Page_EmailNotifications$NoError),
									A2(
										updateSubscription,
										A3(_user$project$Page_EmailNotifications$Subscriber, 3, model.subscriber4.value, model.subscriber4.state),
										model));
							default:
								return A2(
									updateSubscription,
									A3(_user$project$Page_EmailNotifications$Subscriber, 4, _elm_lang$core$Maybe$Nothing, _user$project$Page_EmailNotifications$NoError),
									model);
						}
					}();
					return {
						ctor: '_Tuple2',
						_0: updatedModel,
						_1: A2(
							_elm_lang$http$Http$send,
							_user$project$Page_EmailNotifications$Posted(_p7),
							A2(
								_user$project$Request_Project$put,
								session,
								toSubscription(updatedModel)))
					};
				default:
					if (_p1._1.ctor === 'Ok') {
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{editingSubscriber: _elm_lang$core$Maybe$Nothing}),
							_1: _elm_lang$core$Platform_Cmd$none
						};
					} else {
						return {
							ctor: '_Tuple2',
							_0: A2(
								updateSubscription,
								_elm_lang$core$Native_Utils.update(
									_p1._0,
									{
										state: _user$project$Page_EmailNotifications$HasError(_elm_lang$core$Maybe$Nothing)
									}),
								model),
							_1: _elm_lang$core$Platform_Cmd$none
						};
					}
			}
		}
	});
var _user$project$Page_EmailNotifications$SubscriberChangeComplete = {ctor: 'SubscriberChangeComplete'};
var _user$project$Page_EmailNotifications$ChangeSubscriber = F2(
	function (a, b) {
		return {ctor: 'ChangeSubscriber', _0: a, _1: b};
	});

var _user$project$Request_Batch$postInProject = F3(
	function (session, projectId, count) {
		var body = _elm_lang$http$Http$jsonBody(
			_elm_lang$core$Json_Encode$int(count));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/projects/',
				A2(_elm_lang$core$Basics_ops['++'], projectId, '/batches')));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					_user$project$Request_Response$expectCreated,
					A2(
						_lukewestby$elm_http_builder$HttpBuilder$withBody,
						body,
						_lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});

var _user$project$Page_GenerateIdsModal$Model = F4(
	function (a, b, c, d) {
		return {projectId: a, input: b, state: c, requestInProgress: d};
	});
var _user$project$Page_GenerateIdsModal$Invalid = {ctor: 'Invalid'};
var _user$project$Page_GenerateIdsModal$Valid = function (a) {
	return {ctor: 'Valid', _0: a};
};
var _user$project$Page_GenerateIdsModal$Pristine = {ctor: 'Pristine'};
var _user$project$Page_GenerateIdsModal$init = function (projectId) {
	return A4(_user$project$Page_GenerateIdsModal$Model, projectId, '', _user$project$Page_GenerateIdsModal$Pristine, false);
};
var _user$project$Page_GenerateIdsModal$IdsGenerated = F2(
	function (a, b) {
		return {ctor: 'IdsGenerated', _0: a, _1: b};
	});
var _user$project$Page_GenerateIdsModal$Submit = {ctor: 'Submit'};
var _user$project$Page_GenerateIdsModal$CountChanged = function (a) {
	return {ctor: 'CountChanged', _0: a};
};
var _user$project$Page_GenerateIdsModal$Close = {ctor: 'Close'};
var _user$project$Page_GenerateIdsModal$HandleFocus = {ctor: 'HandleFocus'};
var _user$project$Page_GenerateIdsModal$update = F3(
	function (msg, model, session) {
		var _p0 = msg;
		switch (_p0.ctor) {
			case 'Open':
				return {
					ctor: '_Tuple2',
					_0: {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Maybe$Just(model),
						_1: A2(
							_elm_lang$core$Task$attempt,
							_elm_lang$core$Basics$always(_user$project$Page_GenerateIdsModal$HandleFocus),
							_elm_lang$dom$Dom$focus('Count'))
					},
					_1: _elm_lang$core$Maybe$Nothing
				};
			case 'HandleFocus':
				return {
					ctor: '_Tuple2',
					_0: {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Maybe$Just(model),
						_1: _elm_lang$core$Platform_Cmd$none
					},
					_1: _elm_lang$core$Maybe$Nothing
				};
			case 'Close':
				return {
					ctor: '_Tuple2',
					_0: {ctor: '_Tuple2', _0: _elm_lang$core$Maybe$Nothing, _1: _elm_lang$core$Platform_Cmd$none},
					_1: _elm_lang$core$Maybe$Nothing
				};
			case 'CountChanged':
				var _p3 = _p0._0;
				var state = function () {
					var _p1 = _elm_lang$core$String$toInt(_p3);
					if (_p1.ctor === 'Ok') {
						var _p2 = _p1._0;
						return ((_elm_lang$core$Native_Utils.cmp(_p2, 999) > 0) || (_elm_lang$core$Native_Utils.cmp(_p2, 1) < 0)) ? _user$project$Page_GenerateIdsModal$Invalid : _user$project$Page_GenerateIdsModal$Valid(_p2);
					} else {
						return _user$project$Page_GenerateIdsModal$Invalid;
					}
				}();
				return {
					ctor: '_Tuple2',
					_0: {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Maybe$Just(
							_elm_lang$core$Native_Utils.update(
								model,
								{input: _p3, state: state})),
						_1: _elm_lang$core$Platform_Cmd$none
					},
					_1: _elm_lang$core$Maybe$Nothing
				};
			case 'Submit':
				var _p4 = function () {
					var _p5 = model.state;
					if (_p5.ctor === 'Valid') {
						var _p6 = _p5._0;
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{requestInProgress: true}),
							_1: A2(
								_elm_lang$http$Http$send,
								_user$project$Page_GenerateIdsModal$IdsGenerated(_p6),
								A3(_user$project$Request_Batch$postInProject, session, model.projectId, _p6))
						};
					} else {
						return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
					}
				}();
				var model_ = _p4._0;
				var cmd = _p4._1;
				return {
					ctor: '_Tuple2',
					_0: {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Maybe$Just(model_),
						_1: cmd
					},
					_1: _elm_lang$core$Maybe$Nothing
				};
			default:
				if (_p0._1.ctor === 'Ok') {
					var activeProject = function (proj) {
						return _elm_lang$core$Native_Utils.update(
							proj,
							{isActive: true});
					};
					return {
						ctor: '_Tuple2',
						_0: {ctor: '_Tuple2', _0: _elm_lang$core$Maybe$Nothing, _1: _elm_lang$core$Platform_Cmd$none},
						_1: _elm_lang$core$Maybe$Just(
							{ctor: '_Tuple2', _0: _p0._1._0, _1: _p0._0})
					};
				} else {
					return {
						ctor: '_Tuple2',
						_0: {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Maybe$Just(
								_elm_lang$core$Native_Utils.update(
									model,
									{requestInProgress: false})),
							_1: _user$project$Route$newUrl(_user$project$Route$Error)
						},
						_1: _elm_lang$core$Maybe$Nothing
					};
				}
		}
	});
var _user$project$Page_GenerateIdsModal$Open = {ctor: 'Open'};

var _user$project$Request_UnclaimedIds$UnclaimedId = F4(
	function (a, b, c, d) {
		return {id: a, password: b, createdDate: c, projectName: d};
	});
var _user$project$Request_UnclaimedIds$decodeUnclaimedId = A3(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
	'projectName',
	_elm_lang$core$Json_Decode$string,
	A3(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
		'createdDate',
		_elm_community$json_extra$Json_Decode_Extra$date,
		A3(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
			'password',
			_elm_lang$core$Json_Decode$string,
			A3(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
				'id',
				_elm_lang$core$Json_Decode$string,
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_user$project$Request_UnclaimedIds$UnclaimedId)))));
var _user$project$Request_UnclaimedIds$getAllInProject = F2(
	function (session, id) {
		var expect = _elm_lang$http$Http$expectJson(
			_elm_lang$core$Json_Decode$list(_user$project$Request_UnclaimedIds$decodeUnclaimedId));
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/projects/',
				A2(_elm_lang$core$Basics_ops['++'], id, '/unclaimed-ids')));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					expect,
					_lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});

var _user$project$Page_ProjectDetail$refetchProjectAndUnclaimedCount = F2(
	function (session, projectId) {
		var getUnclaimedIdCount = A2(
			_elm_lang$core$Task$map,
			function (x) {
				return _elm_lang$core$List$length(x);
			},
			_elm_lang$http$Http$toTask(
				A2(_user$project$Request_UnclaimedIds$getAllInProject, session, projectId)));
		var getProject = _elm_lang$http$Http$toTask(
			A2(_user$project$Request_Project$get, session, projectId));
		return A3(
			_elm_lang$core$Task$map2,
			F2(
				function (v0, v1) {
					return {ctor: '_Tuple2', _0: v0, _1: v1};
				}),
			getProject,
			getUnclaimedIdCount);
	});
var _user$project$Page_ProjectDetail$Model = F8(
	function (a, b, c, d, e, f, g, h) {
		return {emailSection: a, alert: b, modal: c, project: d, participants: e, reports: f, packages: g, unclaimedIdCount: h};
	});
var _user$project$Page_ProjectDetail$init = F2(
	function (session, projectId) {
		var getPackages = _elm_lang$http$Http$toTask(
			A2(_user$project$Request_Package$getAllInProject, session, projectId));
		var getReports = _elm_lang$http$Http$toTask(
			A2(_user$project$Request_Report$getAllInProject, session, projectId));
		var getUnclaimedIdCount = session.readOnly ? _elm_lang$core$Task$succeed(0) : A2(
			_elm_lang$core$Task$map,
			function (x) {
				return _elm_lang$core$List$length(x);
			},
			_elm_lang$http$Http$toTask(
				A2(_user$project$Request_UnclaimedIds$getAllInProject, session, projectId)));
		var getParticipants = _elm_lang$http$Http$toTask(
			A2(_user$project$Request_Participant$getAllInProject, session, projectId));
		var getProject = _elm_lang$http$Http$toTask(
			A2(_user$project$Request_Project$get, session, projectId));
		return A6(
			_elm_lang$core$Task$map5,
			F5(
				function (project, participants, reports, packages, unclaimedIdsCount) {
					return A8(
						_user$project$Page_ProjectDetail$Model,
						A2(_user$project$Page_EmailNotifications$init, session, project),
						_elm_lang$core$Maybe$Nothing,
						_elm_lang$core$Maybe$Nothing,
						project,
						participants,
						reports,
						packages,
						unclaimedIdsCount);
				}),
			getProject,
			getParticipants,
			getReports,
			getPackages,
			getUnclaimedIdCount);
	});
var _user$project$Page_ProjectDetail$InviteParticipants = function (a) {
	return {ctor: 'InviteParticipants', _0: a};
};
var _user$project$Page_ProjectDetail$GenerateIds = function (a) {
	return {ctor: 'GenerateIds', _0: a};
};
var _user$project$Page_ProjectDetail$InvitedParticipants = {ctor: 'InvitedParticipants'};
var _user$project$Page_ProjectDetail$GeneratedIds = F2(
	function (a, b) {
		return {ctor: 'GeneratedIds', _0: a, _1: b};
	});
var _user$project$Page_ProjectDetail$RefreshProjectAndUnclaimedCount = function (a) {
	return {ctor: 'RefreshProjectAndUnclaimedCount', _0: a};
};
var _user$project$Page_ProjectDetail$AddParticipantsModalMsg = F2(
	function (a, b) {
		return {ctor: 'AddParticipantsModalMsg', _0: a, _1: b};
	});
var _user$project$Page_ProjectDetail$GenerateIdsModalMsg = F2(
	function (a, b) {
		return {ctor: 'GenerateIdsModalMsg', _0: a, _1: b};
	});
var _user$project$Page_ProjectDetail$DismissAlert = {ctor: 'DismissAlert'};
var _user$project$Page_ProjectDetail$DownloadIdsBatch = function (a) {
	return {ctor: 'DownloadIdsBatch', _0: a};
};
var _user$project$Page_ProjectDetail$EmailSectionMsg = function (a) {
	return {ctor: 'EmailSectionMsg', _0: a};
};
var _user$project$Page_ProjectDetail$update = F3(
	function (msg, model, session) {
		update:
		while (true) {
			var _p0 = msg;
			switch (_p0.ctor) {
				case 'AddParticipantsClicked':
					var _v1 = A2(
						_user$project$Page_ProjectDetail$AddParticipantsModalMsg,
						_user$project$Page_AddParticipantsModal$init(model.project.id),
						_user$project$Page_AddParticipantsModal$Open),
						_v2 = _elm_lang$core$Native_Utils.update(
						model,
						{alert: _elm_lang$core$Maybe$Nothing}),
						_v3 = session;
					msg = _v1;
					model = _v2;
					session = _v3;
					continue update;
				case 'GenerateIdsClicked':
					return {
						ctor: '_Tuple2',
						_0: {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{
									modal: _elm_lang$core$Maybe$Just(
										_user$project$Page_ProjectDetail$GenerateIds(
											_user$project$Page_GenerateIdsModal$init(model.project.id)))
								}),
							_1: _elm_lang$core$Platform_Cmd$none
						},
						_1: _user$project$Page_Modal$None
					};
				case 'EditProjectNameClicked':
					return {
						ctor: '_Tuple2',
						_0: {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none},
						_1: _user$project$Page_Modal$ProjectName(
							_elm_lang$core$Maybe$Just(model.project))
					};
				case 'EditReportsButtonClicked':
					return {
						ctor: '_Tuple2',
						_0: {
							ctor: '_Tuple2',
							_0: model,
							_1: _user$project$Route$newUrl(
								_user$project$Route$ProjectReportSelection(_p0._0))
						},
						_1: _user$project$Page_Modal$None
					};
				case 'ReportSettingsClicked':
					return {
						ctor: '_Tuple2',
						_0: {
							ctor: '_Tuple2',
							_0: model,
							_1: _user$project$Route$newUrl(
								A2(_user$project$Route$ProjectReportSettings, model.project.id, _p0._0))
						},
						_1: _user$project$Page_Modal$None
					};
				case 'PackageSettingsClicked':
					return {
						ctor: '_Tuple2',
						_0: {
							ctor: '_Tuple2',
							_0: model,
							_1: _user$project$Route$newUrl(
								A2(_user$project$Route$ProjectPackageSettings, model.project.id, _p0._0))
						},
						_1: _user$project$Page_Modal$None
					};
				case 'EmailSectionMsg':
					var _p1 = A3(_user$project$Page_EmailNotifications$update, _p0._0, model.emailSection, session);
					var subModel = _p1._0;
					var subCmd = _p1._1;
					return {
						ctor: '_Tuple2',
						_0: {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{emailSection: subModel}),
							_1: A2(_elm_lang$core$Platform_Cmd$map, _user$project$Page_ProjectDetail$EmailSectionMsg, subCmd)
						},
						_1: _user$project$Page_Modal$None
					};
				case 'DownloadIdsBatch':
					return {
						ctor: '_Tuple2',
						_0: {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{alert: _elm_lang$core$Maybe$Nothing}),
							_1: _elm_lang$navigation$Navigation$load(
								A2(
									_elm_lang$core$Basics_ops['++'],
									_p0._0,
									A2(
										_elm_lang$core$Basics_ops['++'],
										'?access_token=',
										A2(
											_elm_lang$core$Basics_ops['++'],
											session.accessToken,
											A2(_elm_lang$core$Basics_ops['++'], '&activeClient=', session.activeClient)))))
						},
						_1: _user$project$Page_Modal$None
					};
				case 'DismissAlert':
					return {
						ctor: '_Tuple2',
						_0: {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{alert: _elm_lang$core$Maybe$Nothing}),
							_1: _elm_lang$core$Platform_Cmd$none
						},
						_1: _user$project$Page_Modal$None
					};
				case 'GenerateIdsModalMsg':
					var _p2 = A3(_user$project$Page_GenerateIdsModal$update, _p0._1, _p0._0, session);
					var newSubModel = _p2._0._0;
					var newSubCmd = _p2._0._1;
					var result = _p2._1;
					var _p3 = result;
					if (_p3.ctor === 'Just') {
						return {
							ctor: '_Tuple2',
							_0: {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Native_Utils.update(
									model,
									{
										modal: _elm_lang$core$Maybe$Nothing,
										alert: _elm_lang$core$Maybe$Just(
											A2(_user$project$Page_ProjectDetail$GeneratedIds, _p3._0._0, _p3._0._1))
									}),
								_1: A2(
									_elm_lang$core$Task$attempt,
									_user$project$Page_ProjectDetail$RefreshProjectAndUnclaimedCount,
									A2(_user$project$Page_ProjectDetail$refetchProjectAndUnclaimedCount, session, model.project.id))
							},
							_1: _user$project$Page_Modal$None
						};
					} else {
						var _p4 = newSubModel;
						if (_p4.ctor === 'Just') {
							var _p5 = _p4._0;
							return {
								ctor: '_Tuple2',
								_0: {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Native_Utils.update(
										model,
										{
											modal: _elm_lang$core$Maybe$Just(
												_user$project$Page_ProjectDetail$GenerateIds(_p5))
										}),
									_1: A2(
										_elm_lang$core$Platform_Cmd$map,
										_user$project$Page_ProjectDetail$GenerateIdsModalMsg(_p5),
										newSubCmd)
								},
								_1: _user$project$Page_Modal$None
							};
						} else {
							return {
								ctor: '_Tuple2',
								_0: {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Native_Utils.update(
										model,
										{modal: _elm_lang$core$Maybe$Nothing}),
									_1: _elm_lang$core$Platform_Cmd$none
								},
								_1: _user$project$Page_Modal$None
							};
						}
					}
				case 'AddParticipantsModalMsg':
					var _p6 = A3(_user$project$Page_AddParticipantsModal$update, _p0._1, _p0._0, session);
					var newSubModel = _p6._0._0;
					var newSubCmd = _p6._0._1;
					var result = _p6._1;
					var _p7 = result;
					if (_p7.ctor === 'Just') {
						return {
							ctor: '_Tuple2',
							_0: {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Native_Utils.update(
									model,
									{
										modal: _elm_lang$core$Maybe$Nothing,
										alert: _elm_lang$core$Maybe$Just(_user$project$Page_ProjectDetail$InvitedParticipants)
									}),
								_1: _elm_lang$core$Platform_Cmd$none
							},
							_1: _user$project$Page_Modal$None
						};
					} else {
						var _p8 = newSubModel;
						if (_p8.ctor === 'Just') {
							var _p9 = _p8._0;
							return {
								ctor: '_Tuple2',
								_0: {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Native_Utils.update(
										model,
										{
											modal: _elm_lang$core$Maybe$Just(
												_user$project$Page_ProjectDetail$InviteParticipants(_p9))
										}),
									_1: A2(
										_elm_lang$core$Platform_Cmd$map,
										_user$project$Page_ProjectDetail$AddParticipantsModalMsg(_p9),
										newSubCmd)
								},
								_1: _user$project$Page_Modal$None
							};
						} else {
							return {
								ctor: '_Tuple2',
								_0: {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Native_Utils.update(
										model,
										{modal: _elm_lang$core$Maybe$Nothing}),
									_1: _elm_lang$core$Platform_Cmd$none
								},
								_1: _user$project$Page_Modal$None
							};
						}
					}
				default:
					if (_p0._0.ctor === 'Ok') {
						return {
							ctor: '_Tuple2',
							_0: {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Native_Utils.update(
									model,
									{project: _p0._0._0._0, unclaimedIdCount: _p0._0._0._1}),
								_1: _elm_lang$core$Platform_Cmd$none
							},
							_1: _user$project$Page_Modal$None
						};
					} else {
						return {
							ctor: '_Tuple2',
							_0: {
								ctor: '_Tuple2',
								_0: model,
								_1: _user$project$Route$error(_p0._0._0)
							},
							_1: _user$project$Page_Modal$None
						};
					}
			}
		}
	});
var _user$project$Page_ProjectDetail$PackageSettingsClicked = function (a) {
	return {ctor: 'PackageSettingsClicked', _0: a};
};
var _user$project$Page_ProjectDetail$ReportSettingsClicked = function (a) {
	return {ctor: 'ReportSettingsClicked', _0: a};
};
var _user$project$Page_ProjectDetail$EditReportsButtonClicked = function (a) {
	return {ctor: 'EditReportsButtonClicked', _0: a};
};
var _user$project$Page_ProjectDetail$EditProjectNameClicked = {ctor: 'EditProjectNameClicked'};
var _user$project$Page_ProjectDetail$GenerateIdsClicked = {ctor: 'GenerateIdsClicked'};
var _user$project$Page_ProjectDetail$AddParticipantsClicked = {ctor: 'AddParticipantsClicked'};

var _user$project$Page_ProjectLibrary$update = F3(
	function (msg, model, session) {
		var _p0 = msg;
		if (_p0.ctor === 'ProjectClicked') {
			return {
				ctor: '_Tuple2',
				_0: {
					ctor: '_Tuple2',
					_0: model,
					_1: _user$project$Route$newUrl(
						_user$project$Route$ProjectDetail(_p0._0))
				},
				_1: _user$project$Page_Modal$None
			};
		} else {
			return {
				ctor: '_Tuple2',
				_0: {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none},
				_1: _user$project$Page_Modal$ProjectName(_elm_lang$core$Maybe$Nothing)
			};
		}
	});
var _user$project$Page_ProjectLibrary$Model = F2(
	function (a, b) {
		return {now: a, library: b};
	});
var _user$project$Page_ProjectLibrary$ProjectCard = F2(
	function (a, b) {
		return {project: a, assessments: b};
	});
var _user$project$Page_ProjectLibrary$init = function (session) {
	var forProject = function (id) {
		return _elm_lang$core$List$filter(
			function (x) {
				return _elm_lang$core$Native_Utils.eq(x.projectId, id);
			});
	};
	var toCard = F2(
		function (assessments, project) {
			return A2(
				_user$project$Page_ProjectLibrary$ProjectCard,
				project,
				A2(forProject, project.id, assessments));
		});
	var getAssessments = _elm_lang$http$Http$toTask(
		_user$project$Request_Assessment$getAll(session));
	var getProjects = _elm_lang$http$Http$toTask(
		_user$project$Request_Project$getAll(session));
	return A4(
		_elm_lang$core$Task$map3,
		F3(
			function (projects, assessments, now) {
				return A2(
					_user$project$Page_ProjectLibrary$Model,
					now,
					A2(
						_elm_lang$core$List$map,
						toCard(assessments),
						projects));
			}),
		getProjects,
		getAssessments,
		_elm_lang$core$Date$now);
};
var _user$project$Page_ProjectLibrary$CreateProjectClicked = {ctor: 'CreateProjectClicked'};
var _user$project$Page_ProjectLibrary$ProjectClicked = function (a) {
	return {ctor: 'ProjectClicked', _0: a};
};

var _user$project$Page_ProjectModal$charactersAreValid = function ($char) {
	var charCode = _elm_lang$core$Char$toCode($char);
	var charCodeIsLowercaseAZ = (_elm_lang$core$Native_Utils.cmp(charCode, 97) > -1) && (_elm_lang$core$Native_Utils.cmp(charCode, 122) < 1);
	var charCodeIsCapitalAZ = (_elm_lang$core$Native_Utils.cmp(charCode, 65) > -1) && (_elm_lang$core$Native_Utils.cmp(charCode, 90) < 1);
	var charCodeIsSpace = _elm_lang$core$Native_Utils.eq(charCode, 32);
	var charCodeIsDash = _elm_lang$core$Native_Utils.eq(charCode, 45);
	return _elm_lang$core$Char$isDigit($char) || (charCodeIsLowercaseAZ || (charCodeIsCapitalAZ || (charCodeIsSpace || charCodeIsDash)));
};
var _user$project$Page_ProjectModal$Model = F3(
	function (a, b, c) {
		return {project: a, state: b, requestInProgress: c};
	});
var _user$project$Page_ProjectModal$Invalid = F2(
	function (a, b) {
		return {ctor: 'Invalid', _0: a, _1: b};
	});
var _user$project$Page_ProjectModal$Valid = function (a) {
	return {ctor: 'Valid', _0: a};
};
var _user$project$Page_ProjectModal$Pristine = {ctor: 'Pristine'};
var _user$project$Page_ProjectModal$init = function (project) {
	return A3(_user$project$Page_ProjectModal$Model, project, _user$project$Page_ProjectModal$Pristine, false);
};
var _user$project$Page_ProjectModal$IsNamedConfigure = {ctor: 'IsNamedConfigure'};
var _user$project$Page_ProjectModal$ContainsInvalidCharacters = {ctor: 'ContainsInvalidCharacters'};
var _user$project$Page_ProjectModal$Duplicate = {ctor: 'Duplicate'};
var _user$project$Page_ProjectModal$TooLong = {ctor: 'TooLong'};
var _user$project$Page_ProjectModal$Blank = {ctor: 'Blank'};
var _user$project$Page_ProjectModal$validateProjectName = function (input) {
	return _elm_lang$core$Native_Utils.eq(
		_elm_lang$core$String$trim(input),
		'') ? A2(_user$project$Page_ProjectModal$Invalid, input, _user$project$Page_ProjectModal$Blank) : ((_elm_lang$core$Native_Utils.cmp(
		_elm_lang$core$String$length(input),
		100) > 0) ? A2(_user$project$Page_ProjectModal$Invalid, input, _user$project$Page_ProjectModal$TooLong) : ((!A2(_elm_lang$core$String$all, _user$project$Page_ProjectModal$charactersAreValid, input)) ? A2(_user$project$Page_ProjectModal$Invalid, input, _user$project$Page_ProjectModal$ContainsInvalidCharacters) : (_elm_lang$core$Native_Utils.eq(
		_elm_lang$core$String$toUpper(input),
		'CONFIGURE') ? A2(_user$project$Page_ProjectModal$Invalid, input, _user$project$Page_ProjectModal$IsNamedConfigure) : _user$project$Page_ProjectModal$Valid(input))));
};
var _user$project$Page_ProjectModal$Submitted = function (a) {
	return {ctor: 'Submitted', _0: a};
};
var _user$project$Page_ProjectModal$ValidateName = F2(
	function (a, b) {
		return {ctor: 'ValidateName', _0: a, _1: b};
	});
var _user$project$Page_ProjectModal$Submit = {ctor: 'Submit'};
var _user$project$Page_ProjectModal$NameChanged = function (a) {
	return {ctor: 'NameChanged', _0: a};
};
var _user$project$Page_ProjectModal$Close = {ctor: 'Close'};
var _user$project$Page_ProjectModal$HandleFocus = {ctor: 'HandleFocus'};
var _user$project$Page_ProjectModal$update = F3(
	function (msg, model, session) {
		var _p0 = msg;
		switch (_p0.ctor) {
			case 'Open':
				return {
					ctor: '_Tuple2',
					_0: {
						ctor: '_Tuple2',
						_0: model,
						_1: A2(
							_elm_lang$core$Task$attempt,
							_elm_lang$core$Basics$always(_user$project$Page_ProjectModal$HandleFocus),
							_elm_lang$dom$Dom$focus('ProjectName'))
					},
					_1: _user$project$Page_Modal$NoOp
				};
			case 'HandleFocus':
				return {
					ctor: '_Tuple2',
					_0: {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none},
					_1: _user$project$Page_Modal$NoOp
				};
			case 'Close':
				return {
					ctor: '_Tuple2',
					_0: {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none},
					_1: _user$project$Page_Modal$Closed
				};
			case 'NameChanged':
				return {
					ctor: '_Tuple2',
					_0: {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{
								state: _user$project$Page_ProjectModal$validateProjectName(_p0._0)
							}),
						_1: _elm_lang$core$Platform_Cmd$none
					},
					_1: _user$project$Page_Modal$NoOp
				};
			case 'Submit':
				var _p1 = model.state;
				if (_p1.ctor === 'Valid') {
					return {
						ctor: '_Tuple2',
						_0: {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{requestInProgress: true}),
							_1: A2(
								_elm_lang$http$Http$send,
								_user$project$Page_ProjectModal$ValidateName(_p1._0),
								_user$project$Request_Project$getAll(session))
						},
						_1: _user$project$Page_Modal$NoOp
					};
				} else {
					return {
						ctor: '_Tuple2',
						_0: {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none},
						_1: _user$project$Page_Modal$NoOp
					};
				}
			case 'ValidateName':
				if (_p0._1.ctor === 'Ok') {
					var _p7 = _p0._0;
					var isNotDuplicate = !A2(
						_elm_lang$core$List$member,
						_elm_lang$core$String$toLower(_p7),
						A2(
							_elm_lang$core$List$map,
							function (_p2) {
								return _elm_lang$core$String$toLower(
									function (_) {
										return _.name;
									}(_p2));
							},
							_p0._1._0));
					var newModel = isNotDuplicate ? model : _elm_lang$core$Native_Utils.update(
						model,
						{
							state: A2(_user$project$Page_ProjectModal$Invalid, _p7, _user$project$Page_ProjectModal$Duplicate),
							requestInProgress: false
						});
					var newCmd = function () {
						if (isNotDuplicate) {
							var _p3 = model.project;
							if (_p3.ctor === 'Just') {
								var _p6 = _p3._0;
								return A2(
									_elm_lang$core$Task$attempt,
									_user$project$Page_ProjectModal$Submitted,
									A2(
										_elm_lang$core$Task$andThen,
										function (_p4) {
											var _p5 = _p4;
											return _elm_lang$core$Task$succeed(_p6);
										},
										_elm_lang$http$Http$toTask(
											A2(
												_user$project$Request_Project$put,
												session,
												_elm_lang$core$Native_Utils.update(
													_p6,
													{name: _p7})))));
							} else {
								return A2(
									_elm_lang$core$Task$attempt,
									_user$project$Page_ProjectModal$Submitted,
									A2(
										_elm_lang$core$Task$andThen,
										function (location) {
											return _elm_lang$http$Http$toTask(
												A2(_user$project$Request_Project$getByURI, session, location));
										},
										_elm_lang$http$Http$toTask(
											A2(_user$project$Request_Project$post, session, _p7))));
							}
						} else {
							return _elm_lang$core$Platform_Cmd$none;
						}
					}();
					return {
						ctor: '_Tuple2',
						_0: {ctor: '_Tuple2', _0: newModel, _1: newCmd},
						_1: _user$project$Page_Modal$NoOp
					};
				} else {
					return {
						ctor: '_Tuple2',
						_0: {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{requestInProgress: false}),
							_1: _user$project$Route$error(_p0._1._0)
						},
						_1: _user$project$Page_Modal$NoOp
					};
				}
			default:
				if (_p0._0.ctor === 'Ok') {
					var _p9 = _p0._0._0;
					var _p8 = model.project;
					if (_p8.ctor === 'Nothing') {
						var route = _elm_lang$core$Native_Utils.eq(session.readOnly, true) ? _user$project$Route$newUrl(
							_user$project$Route$ProjectDetail(_p9.id)) : _user$project$Route$newUrl(
							_user$project$Route$ProjectReportSelection(_p9.id));
						return {
							ctor: '_Tuple2',
							_0: {ctor: '_Tuple2', _0: model, _1: route},
							_1: _user$project$Page_Modal$Closed
						};
					} else {
						return {
							ctor: '_Tuple2',
							_0: {
								ctor: '_Tuple2',
								_0: model,
								_1: _user$project$Route$newUrl(
									_user$project$Route$ProjectDetail(_p8._0.id))
							},
							_1: _user$project$Page_Modal$Closed
						};
					}
				} else {
					return {
						ctor: '_Tuple2',
						_0: {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{requestInProgress: false}),
							_1: _user$project$Route$error(_p0._0._0)
						},
						_1: _user$project$Page_Modal$NoOp
					};
				}
		}
	});
var _user$project$Page_ProjectModal$Open = {ctor: 'Open'};

var _user$project$Page_ProjectReportSettings$Memento = F3(
	function (a, b, c) {
		return {language: a, norm: b, jobProfile: c};
	});
var _user$project$Page_ProjectReportSettings$Model = F8(
	function (a, b, c, d, e, f, g, h) {
		return {state: a, override: b, projectId: c, product: d, jobProfiles: e, languages: f, norms: g, hasCompletedParticipant: h};
	});
var _user$project$Page_ProjectReportSettings$Billable = function (a) {
	return {ctor: 'Billable', _0: a};
};
var _user$project$Page_ProjectReportSettings$Changed = function (a) {
	return {ctor: 'Changed', _0: a};
};
var _user$project$Page_ProjectReportSettings$Pristine = {ctor: 'Pristine'};
var _user$project$Page_ProjectReportSettings$init = F4(
	function (session, projectId, reportId, productType) {
		var loadHasAnyParticipantCompletedTheRequiredAssessments = function (requiredAssessmentIds) {
			var didAnyParticipantCompleteTheRequiredAssessments = function (assessments) {
				return A2(
					_elm_lang$core$List$any,
					function (asmtGrp) {
						return A3(
							_elm_lang$core$List$foldl,
							function (_p0) {
								return F2(
									function (x, y) {
										return x && y;
									})(
									_elm_community$maybe_extra$Maybe_Extra$isJust(
										function (reqAsmtId) {
											return A2(
												_elm_community$list_extra$List_Extra$find,
												function (asmt) {
													return _elm_lang$core$Native_Utils.eq(asmt.id, reqAsmtId) && (!_elm_lang$core$Native_Utils.eq(asmt.date, _elm_lang$core$Maybe$Nothing));
												},
												asmtGrp);
										}(_p0)));
							},
							true,
							requiredAssessmentIds);
					},
					A2(
						_elm_community$list_extra$List_Extra$groupWhile,
						F2(
							function (asmt1, asmt2) {
								return _elm_lang$core$Native_Utils.eq(asmt1.participantId, asmt2.participantId);
							}),
						A2(
							_elm_lang$core$List$sortBy,
							function (_) {
								return _.participantId;
							},
							assessments)));
			};
			return A2(
				_elm_lang$core$Task$map,
				didAnyParticipantCompleteTheRequiredAssessments,
				_elm_lang$http$Http$toTask(
					A2(_user$project$Request_Assessment$getForProject, session, projectId)));
		};
		var loadJobProfiles = _elm_lang$http$Http$toTask(
			A2(_user$project$Request_JobProfile$getForReport, session, reportId));
		var loadNorms = _elm_lang$http$Http$toTask(
			A2(_user$project$Request_Norm$getForReport, session, reportId));
		var loadLanguages = _elm_lang$http$Http$toTask(
			A2(_user$project$Request_Language$getForReport, session, reportId));
		var loadProduct = function () {
			var _p1 = productType;
			if (_p1.ctor === 'Report') {
				return A2(
					_elm_lang$core$Task$map,
					function (x) {
						return A8(
							_user$project$Page_Product$Product,
							x.id,
							x.name,
							x.language,
							x.norm,
							x.jobProfile,
							x.requiredAssessmentIds,
							{ctor: '[]'},
							productType);
					},
					_elm_lang$http$Http$toTask(
						A3(_user$project$Request_Report$getInProject, session, projectId, reportId)));
			} else {
				return A2(
					_elm_lang$core$Task$map,
					function (x) {
						return A8(_user$project$Page_Product$Product, x.id, x.name, x.language, x.norm, x.jobProfile, x.requiredAssessmentIds, x.reports, productType);
					},
					_elm_lang$http$Http$toTask(
						A3(_user$project$Request_Package$getInProject, session, projectId, reportId)));
			}
		}();
		return session.readOnly ? A2(
			_elm_lang$core$Task$map,
			function (x) {
				return A8(
					_user$project$Page_ProjectReportSettings$Model,
					_user$project$Page_ProjectReportSettings$Pristine,
					false,
					projectId,
					x,
					{ctor: '[]'},
					{ctor: '[]'},
					{ctor: '[]'},
					false);
			},
			loadProduct) : A2(
			_elm_lang$core$Task$andThen,
			function (product) {
				var _p2 = product.jobProfile;
				if (_p2.ctor === 'Just') {
					return A5(
						_elm_lang$core$Task$map4,
						A4(_user$project$Page_ProjectReportSettings$Model, _user$project$Page_ProjectReportSettings$Pristine, false, projectId, product),
						loadJobProfiles,
						loadLanguages,
						loadNorms,
						loadHasAnyParticipantCompletedTheRequiredAssessments(product.requiredAssessmentIds));
				} else {
					return A4(
						_elm_lang$core$Task$map3,
						A5(
							_user$project$Page_ProjectReportSettings$Model,
							_user$project$Page_ProjectReportSettings$Pristine,
							false,
							projectId,
							product,
							{ctor: '[]'}),
						loadLanguages,
						loadNorms,
						loadHasAnyParticipantCompletedTheRequiredAssessments(product.requiredAssessmentIds));
				}
			},
			loadProduct);
	});
var _user$project$Page_ProjectReportSettings$CloseView = {ctor: 'CloseView'};
var _user$project$Page_ProjectReportSettings$PostReportOptions = {ctor: 'PostReportOptions'};
var _user$project$Page_ProjectReportSettings$PostedReportOptions = function (a) {
	return {ctor: 'PostedReportOptions', _0: a};
};
var _user$project$Page_ProjectReportSettings$update = F3(
	function (msg, model, session) {
		var transition = function (updated) {
			var memento = function () {
				var _p3 = updated.state;
				switch (_p3.ctor) {
					case 'Pristine':
						return A3(_user$project$Page_ProjectReportSettings$Memento, model.product.language, model.product.norm, model.product.jobProfile);
					case 'Changed':
						return _p3._0;
					default:
						return _p3._0;
				}
			}();
			var _p4 = ((!_elm_lang$core$Native_Utils.eq(memento.norm, updated.product.norm)) || (!_elm_lang$core$Native_Utils.eq(memento.jobProfile, updated.product.jobProfile))) ? {
				ctor: '_Tuple2',
				_0: _user$project$Page_ProjectReportSettings$Billable(memento),
				_1: updated.override
			} : ((!_elm_lang$core$Native_Utils.eq(memento.language, updated.product.language)) ? {
				ctor: '_Tuple2',
				_0: _user$project$Page_ProjectReportSettings$Changed(memento),
				_1: updated.override
			} : {ctor: '_Tuple2', _0: _user$project$Page_ProjectReportSettings$Pristine, _1: false});
			var state = _p4._0;
			var override = _p4._1;
			return _elm_lang$core$Native_Utils.update(
				updated,
				{state: state, override: override});
		};
		var _p5 = msg;
		switch (_p5.ctor) {
			case 'ChangeLanguage':
				var changeLang = function (product) {
					return _elm_lang$core$Native_Utils.update(
						product,
						{language: _p5._0});
				};
				return {
					ctor: '_Tuple2',
					_0: transition(
						_elm_lang$core$Native_Utils.update(
							model,
							{
								product: changeLang(model.product)
							})),
					_1: _elm_lang$core$Platform_Cmd$none
				};
			case 'ChangeNorm':
				var changeNorm = function (product) {
					return _elm_lang$core$Native_Utils.update(
						product,
						{norm: _p5._0});
				};
				return {
					ctor: '_Tuple2',
					_0: transition(
						_elm_lang$core$Native_Utils.update(
							model,
							{
								product: changeNorm(model.product)
							})),
					_1: _elm_lang$core$Platform_Cmd$none
				};
			case 'ChangeProfile':
				var changeProfile = function (product) {
					return _elm_lang$core$Native_Utils.update(
						product,
						{
							jobProfile: _elm_lang$core$Maybe$Just(_p5._0)
						});
				};
				return {
					ctor: '_Tuple2',
					_0: transition(
						_elm_lang$core$Native_Utils.update(
							model,
							{
								product: changeProfile(model.product)
							})),
					_1: _elm_lang$core$Platform_Cmd$none
				};
			case 'Override':
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{override: true}),
					_1: _elm_lang$core$Platform_Cmd$none
				};
			case 'UndoOverride':
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{override: false}),
					_1: _elm_lang$core$Platform_Cmd$none
				};
			case 'PostReportOptions':
				var _p6 = function () {
					var _p7 = model.product.type_;
					if (_p7.ctor === 'Report') {
						var report = A6(_user$project$Request_Report$Report, model.product.id, model.product.name, model.product.language, model.product.norm, model.product.jobProfile, model.product.requiredAssessmentIds);
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$http$Http$toTask(
								A3(_user$project$Request_Report$putInProject, session, model.projectId, report)),
							_1: _elm_lang$http$Http$toTask(
								A4(_user$project$Request_Report$putInAllParticipantsForProject, session, model.projectId, model.override, report))
						};
					} else {
						var $package = A7(_user$project$Request_Package$Package, model.product.id, model.product.name, model.product.language, model.product.norm, model.product.jobProfile, model.product.requiredAssessmentIds, model.product.reports);
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$http$Http$toTask(
								A3(_user$project$Request_Package$putInProject, session, model.projectId, $package)),
							_1: _elm_lang$http$Http$toTask(
								A4(_user$project$Request_Package$putInAllParticipantsForProject, session, model.projectId, model.override, $package))
						};
					}
				}();
				var putInProject = _p6._0;
				var putInAllParticipantsForProject = _p6._1;
				var saveTask = A2(
					_elm_lang$core$Task$andThen,
					function (_p8) {
						var _p9 = _p8;
						return putInAllParticipantsForProject;
					},
					putInProject);
				var _p10 = model.state;
				if (_p10.ctor === 'Pristine') {
					return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
				} else {
					return {
						ctor: '_Tuple2',
						_0: model,
						_1: A2(_elm_lang$core$Task$attempt, _user$project$Page_ProjectReportSettings$PostedReportOptions, saveTask)
					};
				}
			case 'PostedReportOptions':
				if (_p5._0.ctor === 'Ok') {
					return {
						ctor: '_Tuple2',
						_0: model,
						_1: _user$project$Route$newUrl(
							_user$project$Route$ProjectDetail(model.projectId))
					};
				} else {
					return {
						ctor: '_Tuple2',
						_0: model,
						_1: _user$project$Route$error(_p5._0._0)
					};
				}
			default:
				return {
					ctor: '_Tuple2',
					_0: model,
					_1: _user$project$Route$newUrl(
						_user$project$Route$ProjectDetail(model.projectId))
				};
		}
	});
var _user$project$Page_ProjectReportSettings$UndoOverride = {ctor: 'UndoOverride'};
var _user$project$Page_ProjectReportSettings$Override = {ctor: 'Override'};
var _user$project$Page_ProjectReportSettings$ChangeProfile = function (a) {
	return {ctor: 'ChangeProfile', _0: a};
};
var _user$project$Page_ProjectReportSettings$ChangeNorm = function (a) {
	return {ctor: 'ChangeNorm', _0: a};
};
var _user$project$Page_ProjectReportSettings$ChangeLanguage = function (a) {
	return {ctor: 'ChangeLanguage', _0: a};
};

var _user$project$Page_ReportSelection$intersecty = F2(
	function (left, right) {
		return !_elm_lang$core$Set$isEmpty(
			A2(
				_elm_lang$core$Set$intersect,
				_elm_lang$core$Set$fromList(left),
				_elm_lang$core$Set$fromList(right)));
	});
var _user$project$Page_ReportSelection$Model = F6(
	function (a, b, c, d, e, f) {
		return {projectId: a, participantId: b, titleText: c, showClosingWarningModal: d, errors: e, reports: f};
	});
var _user$project$Page_ReportSelection$ReportCard = F6(
	function (a, b, c, d, e, f) {
		return {id: a, name: b, reportIds: c, requiredAssessmentIds: d, settings: e, state: f};
	});
var _user$project$Page_ReportSelection$ReportSettings = F3(
	function (a, b, c) {
		return {language: a, norm: b, jobProfile: c};
	});
var _user$project$Page_ReportSelection$Abandoned = {ctor: 'Abandoned'};
var _user$project$Page_ReportSelection$Disabled = function (a) {
	return {ctor: 'Disabled', _0: a};
};
var _user$project$Page_ReportSelection$Removed = {ctor: 'Removed'};
var _user$project$Page_ReportSelection$Available = {ctor: 'Available'};
var _user$project$Page_ReportSelection$Selected = function (a) {
	return {ctor: 'Selected', _0: a};
};
var _user$project$Page_ReportSelection$assimilate = F4(
	function (availableReports, selectedReports, availablePackages, selectedPackages) {
		var toReportCard = function (_p0) {
			var _p1 = _p0;
			var _p11 = _p1._1;
			var _p10 = _p1._0._5;
			var _p9 = _p1._0._0;
			var conflictPredicate = function (yReportIds) {
				var _p2 = _p10;
				if (_p2.ctor === 'Just') {
					return A2(_user$project$Page_ReportSelection$intersecty, _p2._0, yReportIds);
				} else {
					return A2(_elm_lang$core$List$member, _p9, yReportIds);
				}
			};
			var conflictsWithPackage = A2(
				F2(
					function (x, y) {
						return !_elm_lang$core$Native_Utils.eq(x, y);
					}),
				_elm_lang$core$Maybe$Nothing,
				A2(
					_elm_community$list_extra$List_Extra$find,
					function (y) {
						var _p3 = y;
						if (((_p3.ctor === '_Tuple8') && (_p3._5.ctor === 'Just')) && (_p3._7 === true)) {
							return conflictPredicate(_p3._5._0);
						} else {
							return false;
						}
					},
					_p11));
			var card = A5(
				_user$project$Page_ReportSelection$ReportCard,
				_p9,
				_p1._0._1,
				_p10,
				_p1._0._6,
				A3(_user$project$Page_ReportSelection$ReportSettings, _p1._0._2, _p1._0._3, _p1._0._4));
			var _p6 = A2(
				_elm_community$list_extra$List_Extra$find,
				function (_p4) {
					var _p5 = _p4;
					return _elm_lang$core$Native_Utils.eq(_p5._0, _p9);
				},
				_p11);
			if (_p6.ctor === 'Just') {
				return card(
					_user$project$Page_ReportSelection$Selected(_user$project$Page_ReportSelection$Removed));
			} else {
				var _p7 = _p1._0._7;
				if (_p7 === true) {
					return card(
						_user$project$Page_ReportSelection$Selected(_user$project$Page_ReportSelection$Abandoned));
				} else {
					var _p8 = conflictsWithPackage;
					if (_p8 === true) {
						return card(
							_user$project$Page_ReportSelection$Disabled(_user$project$Page_ReportSelection$Available));
					} else {
						return card(_user$project$Page_ReportSelection$Available);
					}
				}
			}
		};
		return A2(
			_elm_community$list_extra$List_Extra$uniqueBy,
			function (_) {
				return _.id;
			},
			A2(
				_elm_lang$core$List$map,
				toReportCard,
				_elm_community$list_extra$List_Extra$select(
					A2(
						_elm_lang$core$List$filter,
						function (_p12) {
							var _p13 = _p12;
							return !_elm_lang$core$Native_Utils.eq(_p13._0, 'NRConfigureScoresXML');
						},
						_elm_lang$core$List$concat(
							{
								ctor: '::',
								_0: A2(
									_elm_lang$core$List$map,
									function (x) {
										return {ctor: '_Tuple8', _0: x.id, _1: x.name, _2: x.language, _3: x.norm, _4: x.jobProfile, _5: _elm_lang$core$Maybe$Nothing, _6: x.requiredAssessmentIds, _7: false};
									},
									availableReports),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$core$List$map,
										function (x) {
											return {ctor: '_Tuple8', _0: x.id, _1: x.name, _2: x.language, _3: x.norm, _4: x.jobProfile, _5: _elm_lang$core$Maybe$Nothing, _6: x.requiredAssessmentIds, _7: true};
										},
										selectedReports),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$core$List$map,
											function (x) {
												return {
													ctor: '_Tuple8',
													_0: x.id,
													_1: x.name,
													_2: x.language,
													_3: x.norm,
													_4: x.jobProfile,
													_5: _elm_lang$core$Maybe$Just(x.reports),
													_6: x.requiredAssessmentIds,
													_7: false
												};
											},
											availablePackages),
										_1: {
											ctor: '::',
											_0: A2(
												_elm_lang$core$List$map,
												function (x) {
													return {
														ctor: '_Tuple8',
														_0: x.id,
														_1: x.name,
														_2: x.language,
														_3: x.norm,
														_4: x.jobProfile,
														_5: _elm_lang$core$Maybe$Just(x.reports),
														_6: x.requiredAssessmentIds,
														_7: true
													};
												},
												selectedPackages),
											_1: {ctor: '[]'}
										}
									}
								}
							})))));
	});
var _user$project$Page_ReportSelection$initWithProject = F6(
	function (projectId, availableReports, availablePackages, selectedReports, selectedPackages, project) {
		return A6(
			_user$project$Page_ReportSelection$Model,
			projectId,
			_elm_lang$core$Maybe$Nothing,
			project.name,
			false,
			{ctor: '[]'},
			A4(_user$project$Page_ReportSelection$assimilate, availableReports, selectedReports, availablePackages, selectedPackages));
	});
var _user$project$Page_ReportSelection$initWithParticipant = F6(
	function (projectId, availableReports, availablePackages, selectedReports, selectedPackages, participant) {
		return A6(
			_user$project$Page_ReportSelection$Model,
			projectId,
			_elm_lang$core$Maybe$Just(participant.id),
			A2(
				_elm_lang$core$Basics_ops['++'],
				participant.firstName,
				A2(_elm_lang$core$Basics_ops['++'], ' ', participant.lastName)),
			false,
			{ctor: '[]'},
			A4(_user$project$Page_ReportSelection$assimilate, availableReports, selectedReports, availablePackages, selectedPackages));
	});
var _user$project$Page_ReportSelection$init = F3(
	function (session, projectId, participantId) {
		var getParticipantPackages = function (id) {
			return _elm_lang$http$Http$toTask(
				A2(_user$project$Request_Package$getAllInParticipant, session, id));
		};
		var getProjectPackages = _elm_lang$http$Http$toTask(
			A2(_user$project$Request_Package$getAllInProject, session, projectId));
		var getAvailablePackages = _elm_lang$http$Http$toTask(
			_user$project$Request_Package$getAll(session));
		var getParticipantReports = function (id) {
			return _elm_lang$http$Http$toTask(
				A2(_user$project$Request_Report$getAllInParticipant, session, id));
		};
		var getProjectReports = _elm_lang$http$Http$toTask(
			A2(_user$project$Request_Report$getAllInProject, session, projectId));
		var getAvailableReports = _elm_lang$http$Http$toTask(
			_user$project$Request_Report$getAll(session));
		var getParticipant = function (id) {
			return _elm_lang$http$Http$toTask(
				A2(_user$project$Request_Participant$get, session, id));
		};
		var getProject = _elm_lang$http$Http$toTask(
			A2(_user$project$Request_Project$get, session, projectId));
		var _p14 = participantId;
		if (_p14.ctor === 'Just') {
			var _p15 = _p14._0;
			return A6(
				_elm_lang$core$Task$map5,
				_user$project$Page_ReportSelection$initWithParticipant(projectId),
				getAvailableReports,
				getAvailablePackages,
				getParticipantReports(_p15),
				getParticipantPackages(_p15),
				getParticipant(_p15));
		} else {
			return A6(
				_elm_lang$core$Task$map5,
				_user$project$Page_ReportSelection$initWithProject(projectId),
				getAvailableReports,
				getAvailablePackages,
				getProjectReports,
				getProjectPackages,
				getProject);
		}
	});
var _user$project$Page_ReportSelection$isChanged = function (info) {
	return _elm_lang$core$Native_Utils.eq(
		info.state,
		_user$project$Page_ReportSelection$Selected(_user$project$Page_ReportSelection$Available)) || (_elm_lang$core$Native_Utils.eq(info.state, _user$project$Page_ReportSelection$Removed) || (_elm_lang$core$Native_Utils.eq(
		info.state,
		_user$project$Page_ReportSelection$Disabled(_user$project$Page_ReportSelection$Removed)) || _elm_lang$core$Native_Utils.eq(info.state, _user$project$Page_ReportSelection$Abandoned)));
};
var _user$project$Page_ReportSelection$CancelClose = {ctor: 'CancelClose'};
var _user$project$Page_ReportSelection$ConfirmClose = {ctor: 'ConfirmClose'};
var _user$project$Page_ReportSelection$Close = {ctor: 'Close'};
var _user$project$Page_ReportSelection$SaveReportsResponse = function (a) {
	return {ctor: 'SaveReportsResponse', _0: a};
};
var _user$project$Page_ReportSelection$update = F3(
	function (msg, model, session) {
		var routeToContext = function () {
			var _p16 = model.participantId;
			if (_p16.ctor === 'Just') {
				return _user$project$Route$newUrl(
					A2(_user$project$Route$Participant, model.projectId, _p16._0));
			} else {
				return _user$project$Route$newUrl(
					_user$project$Route$ProjectDetail(model.projectId));
			}
		}();
		var _p17 = msg;
		switch (_p17.ctor) {
			case 'Toggle':
				var _p32 = _p17._0;
				var validate = function (reports) {
					var contains = F2(
						function (reportId, item) {
							return A2(
								_elm_lang$core$List$member,
								reportId,
								A2(
									_elm_lang$core$Maybe$withDefault,
									{ctor: '[]'},
									item.reportIds));
						});
					var isInvalid = function (_p18) {
						var _p19 = _p18;
						var _p21 = _p19._0;
						var _p20 = _p21.reportIds;
						if (_p20.ctor === 'Nothing') {
							return A2(
								_elm_lang$core$List$any,
								contains(_p21.id),
								_p19._1) ? _elm_lang$core$Maybe$Just(_p21.name) : _elm_lang$core$Maybe$Nothing;
						} else {
							return _elm_lang$core$Maybe$Nothing;
						}
					};
					var isSelected = function (report) {
						var _p22 = report.state;
						if (_p22.ctor === 'Selected') {
							return true;
						} else {
							return false;
						}
					};
					return A2(
						_elm_lang$core$List$filterMap,
						isInvalid,
						_elm_community$list_extra$List_Extra$select(
							A2(_elm_lang$core$List$filter, isSelected, reports)));
				};
				var updateOrNah = function (candidate) {
					var _p23 = validate(candidate);
					if (_p23.ctor === '[]') {
						return {
							ctor: '_Tuple2',
							_0: candidate,
							_1: {ctor: '[]'}
						};
					} else {
						return {ctor: '_Tuple2', _0: model.reports, _1: _p23};
					}
				};
				var processSideEffects = function (_p24) {
					var _p25 = _p24;
					var _p29 = _p25._0;
					var overlapPred = function (other) {
						var _p26 = other.state;
						if (_p26.ctor === 'Selected') {
							var _p27 = _p29.reportIds;
							if (_p27.ctor === 'Just') {
								return A2(
									_user$project$Page_ReportSelection$intersecty,
									_p27._0,
									A2(
										_elm_lang$core$Maybe$withDefault,
										{ctor: '[]'},
										other.reportIds));
							} else {
								return A2(
									_elm_lang$core$List$member,
									_p29.id,
									A2(
										_elm_lang$core$Maybe$withDefault,
										{ctor: '[]'},
										other.reportIds));
							}
						} else {
							return false;
						}
					};
					var overlaps = A2(_elm_lang$core$List$any, overlapPred, _p25._1);
					var itemState = function () {
						var _p28 = {ctor: '_Tuple2', _0: overlaps, _1: _p29.state};
						_v18_3:
						do {
							if (_p28.ctor === '_Tuple2') {
								if (_p28._0 === true) {
									switch (_p28._1.ctor) {
										case 'Available':
											return _user$project$Page_ReportSelection$Disabled(_p29.state);
										case 'Removed':
											return _user$project$Page_ReportSelection$Disabled(_p29.state);
										default:
											break _v18_3;
									}
								} else {
									if (_p28._1.ctor === 'Disabled') {
										return _p28._1._0;
									} else {
										break _v18_3;
									}
								}
							} else {
								break _v18_3;
							}
						} while(false);
						return _p29.state;
					}();
					return _elm_lang$core$Native_Utils.update(
						_p29,
						{state: itemState});
				};
				var newState = function () {
					var _p30 = _p32.state;
					switch (_p30.ctor) {
						case 'Selected':
							return _p30._0;
						case 'Available':
							return _user$project$Page_ReportSelection$Selected(_user$project$Page_ReportSelection$Available);
						case 'Removed':
							return _user$project$Page_ReportSelection$Selected(_user$project$Page_ReportSelection$Removed);
						default:
							return _p30;
					}
				}();
				var _p31 = updateOrNah(
					A2(
						_elm_lang$core$List$map,
						processSideEffects,
						_elm_community$list_extra$List_Extra$select(
							A3(
								_elm_community$list_extra$List_Extra$replaceIf,
								function (x) {
									return (!_elm_lang$core$Native_Utils.eq(_p32.state, newState)) && _elm_lang$core$Native_Utils.eq(x.id, _p32.id);
								},
								_elm_lang$core$Native_Utils.update(
									_p32,
									{state: newState}),
								model.reports))));
				var updatedReports = _p31._0;
				var conflictingReportNames = _p31._1;
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{reports: updatedReports, errors: conflictingReportNames}),
					_1: _elm_lang$core$Platform_Cmd$none
				};
			case 'SaveReports':
				var sortChanges = F2(
					function (_p33, items) {
						sortChanges:
						while (true) {
							var _p34 = _p33;
							var _p42 = _p34._0._1;
							var _p41 = _p34._1._1;
							var _p40 = _p34._0._0;
							var _p39 = _p34._1._0;
							var _p35 = items;
							if (_p35.ctor === '::') {
								var _p38 = _p35._1;
								var _p37 = _p35._0;
								var _p36 = _p37.reportIds;
								if (_p36.ctor === 'Nothing') {
									var report = A6(_user$project$Request_Report$Report, _p37.id, _p37.name, _p37.settings.language, _p37.settings.norm, _p37.settings.jobProfile, _p37.requiredAssessmentIds);
									if (_elm_lang$core$Native_Utils.eq(
										_p37.state,
										_user$project$Page_ReportSelection$Selected(_user$project$Page_ReportSelection$Available))) {
										var _v23 = {
											ctor: '_Tuple2',
											_0: {
												ctor: '_Tuple2',
												_0: {ctor: '::', _0: report, _1: _p40},
												_1: _p42
											},
											_1: {ctor: '_Tuple2', _0: _p39, _1: _p41}
										},
											_v24 = _p38;
										_p33 = _v23;
										items = _v24;
										continue sortChanges;
									} else {
										var _v25 = {
											ctor: '_Tuple2',
											_0: {
												ctor: '_Tuple2',
												_0: _p40,
												_1: {ctor: '::', _0: report, _1: _p42}
											},
											_1: {ctor: '_Tuple2', _0: _p39, _1: _p41}
										},
											_v26 = _p38;
										_p33 = _v25;
										items = _v26;
										continue sortChanges;
									}
								} else {
									var $package = A7(_user$project$Request_Package$Package, _p37.id, _p37.name, _p37.settings.language, _p37.settings.norm, _p37.settings.jobProfile, _p37.requiredAssessmentIds, _p36._0);
									if (_elm_lang$core$Native_Utils.eq(
										_p37.state,
										_user$project$Page_ReportSelection$Selected(_user$project$Page_ReportSelection$Available))) {
										var _v27 = {
											ctor: '_Tuple2',
											_0: {ctor: '_Tuple2', _0: _p40, _1: _p42},
											_1: {
												ctor: '_Tuple2',
												_0: {ctor: '::', _0: $package, _1: _p39},
												_1: _p41
											}
										},
											_v28 = _p38;
										_p33 = _v27;
										items = _v28;
										continue sortChanges;
									} else {
										var _v29 = {
											ctor: '_Tuple2',
											_0: {ctor: '_Tuple2', _0: _p40, _1: _p42},
											_1: {
												ctor: '_Tuple2',
												_0: _p39,
												_1: {ctor: '::', _0: $package, _1: _p41}
											}
										},
											_v30 = _p38;
										_p33 = _v29;
										items = _v30;
										continue sortChanges;
									}
								}
							} else {
								return {
									ctor: '_Tuple2',
									_0: {ctor: '_Tuple2', _0: _p40, _1: _p42},
									_1: {ctor: '_Tuple2', _0: _p39, _1: _p41}
								};
							}
						}
					});
				var _p43 = A2(
					sortChanges,
					{
						ctor: '_Tuple2',
						_0: {
							ctor: '_Tuple2',
							_0: {ctor: '[]'},
							_1: {ctor: '[]'}
						},
						_1: {
							ctor: '_Tuple2',
							_0: {ctor: '[]'},
							_1: {ctor: '[]'}
						}
					},
					A2(_elm_lang$core$List$filter, _user$project$Page_ReportSelection$isChanged, model.reports));
				var addedReports = _p43._0._0;
				var removedReports = _p43._0._1;
				var addedPackages = _p43._1._0;
				var removedPackages = _p43._1._1;
				var addReportTasks = A2(
					_elm_lang$core$List$map,
					function (x) {
						var _p44 = model.participantId;
						if (_p44.ctor === 'Just') {
							return _elm_lang$http$Http$toTask(
								A3(_user$project$Request_Report$postInParticipant, session, _p44._0, x));
						} else {
							return _elm_lang$http$Http$toTask(
								A3(_user$project$Request_Report$postInProject, session, model.projectId, x));
						}
					},
					addedReports);
				var removeReportTasks = A2(
					_elm_lang$core$List$map,
					function (x) {
						var _p45 = model.participantId;
						if (_p45.ctor === 'Just') {
							return _elm_lang$http$Http$toTask(
								A3(_user$project$Request_Report$deleteFromParticipant, session, _p45._0, x.id));
						} else {
							return _elm_lang$http$Http$toTask(
								A3(_user$project$Request_Report$deleteFromProject, session, model.projectId, x.id));
						}
					},
					removedReports);
				var addPackageTasks = A2(
					_elm_lang$core$List$map,
					function (x) {
						var _p46 = model.participantId;
						if (_p46.ctor === 'Just') {
							return _elm_lang$http$Http$toTask(
								A3(_user$project$Request_Package$postInParticipant, session, _p46._0, x));
						} else {
							return _elm_lang$http$Http$toTask(
								A3(_user$project$Request_Package$postInProject, session, model.projectId, x));
						}
					},
					addedPackages);
				var removePackageTasks = A2(
					_elm_lang$core$List$map,
					function (x) {
						var _p47 = model.participantId;
						if (_p47.ctor === 'Just') {
							return _elm_lang$http$Http$toTask(
								A3(_user$project$Request_Package$deleteFromParticipant, session, _p47._0, x.id));
						} else {
							return _elm_lang$http$Http$toTask(
								A3(_user$project$Request_Package$deleteFromProject, session, model.projectId, x.id));
						}
					},
					removedPackages);
				return {
					ctor: '_Tuple2',
					_0: model,
					_1: A2(
						_elm_lang$core$Task$attempt,
						_user$project$Page_ReportSelection$SaveReportsResponse,
						_elm_lang$core$Task$sequence(
							_elm_lang$core$List$concat(
								{
									ctor: '::',
									_0: removeReportTasks,
									_1: {
										ctor: '::',
										_0: removePackageTasks,
										_1: {
											ctor: '::',
											_0: addReportTasks,
											_1: {
												ctor: '::',
												_0: addPackageTasks,
												_1: {ctor: '[]'}
											}
										}
									}
								})))
				};
			case 'SaveReportsResponse':
				if (_p17._0.ctor === 'Ok') {
					return {ctor: '_Tuple2', _0: model, _1: routeToContext};
				} else {
					return {
						ctor: '_Tuple2',
						_0: model,
						_1: _user$project$Route$error(_p17._0._0)
					};
				}
			case 'Close':
				return A2(_elm_lang$core$List$any, _user$project$Page_ReportSelection$isChanged, model.reports) ? {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{showClosingWarningModal: true}),
					_1: _elm_lang$core$Platform_Cmd$none
				} : {ctor: '_Tuple2', _0: model, _1: routeToContext};
			case 'ConfirmClose':
				return {ctor: '_Tuple2', _0: model, _1: routeToContext};
			default:
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{showClosingWarningModal: false}),
					_1: _elm_lang$core$Platform_Cmd$none
				};
		}
	});
var _user$project$Page_ReportSelection$SaveReports = {ctor: 'SaveReports'};
var _user$project$Page_ReportSelection$Toggle = function (a) {
	return {ctor: 'Toggle', _0: a};
};

var _user$project$Request_SearchResult$SearchResults = F2(
	function (a, b) {
		return {participantSearchResults: a, projectSearchResults: b};
	});
var _user$project$Request_SearchResult$ParticipantSearchResult = F7(
	function (a, b, c, d, e, f, g) {
		return {projectId: a, projectName: b, participantId: c, uniqueId: d, firstName: e, lastName: f, email: g};
	});
var _user$project$Request_SearchResult$decodeParticipantSearchResult = A4(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
	'email',
	_elm_lang$core$Json_Decode$string,
	'',
	A4(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
		'lastName',
		_elm_lang$core$Json_Decode$string,
		'',
		A4(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
			'firstName',
			_elm_lang$core$Json_Decode$string,
			'',
			A4(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
				'uniqueId',
				_elm_lang$core$Json_Decode$string,
				'',
				A3(
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
					'participantId',
					_elm_lang$core$Json_Decode$string,
					A3(
						_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
						'projectName',
						_elm_lang$core$Json_Decode$string,
						A3(
							_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
							'projectId',
							_elm_lang$core$Json_Decode$string,
							_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_user$project$Request_SearchResult$ParticipantSearchResult))))))));
var _user$project$Request_SearchResult$ProjectSearchResult = F3(
	function (a, b, c) {
		return {projectId: a, projectName: b, createdDate: c};
	});
var _user$project$Request_SearchResult$decodeProjectSearchResult = A3(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
	'createdDate',
	_elm_community$json_extra$Json_Decode_Extra$date,
	A3(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
		'projectName',
		_elm_lang$core$Json_Decode$string,
		A3(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
			'projectId',
			_elm_lang$core$Json_Decode$string,
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_user$project$Request_SearchResult$ProjectSearchResult))));
var _user$project$Request_SearchResult$decode = A3(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
	'projectSearchResults',
	_elm_lang$core$Json_Decode$list(_user$project$Request_SearchResult$decodeProjectSearchResult),
	A3(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
		'participantSearchResults',
		_elm_lang$core$Json_Decode$list(_user$project$Request_SearchResult$decodeParticipantSearchResult),
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_user$project$Request_SearchResult$SearchResults)));
var _user$project$Request_SearchResult$get = F2(
	function (session, searchTerm) {
		var expect = _elm_lang$http$Http$expectJson(_user$project$Request_SearchResult$decode);
		var url = A2(
			_elm_lang$core$Basics_ops['++'],
			session.haloLiteApi,
			A2(_elm_lang$core$Basics_ops['++'], '/searches/', searchTerm));
		return _lukewestby$elm_http_builder$HttpBuilder$toRequest(
			A2(
				_lukewestby$elm_http_builder$HttpBuilder$withHeaders,
				_user$project$Request_Headers$defaultHeaders(session),
				A2(
					_lukewestby$elm_http_builder$HttpBuilder$withExpect,
					expect,
					_lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});

var _user$project$Page_Search$cleanSearchTerm = function (str) {
	var trimmedStr = _elm_lang$core$String$trim(str);
	var _p0 = _elm_lang$core$Native_Utils.cmp(
		_elm_lang$core$String$length(trimmedStr),
		0) > 0;
	if (_p0 === true) {
		return _elm_lang$core$Maybe$Just(trimmedStr);
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _user$project$Page_Search$update = F3(
	function (msg, model, session) {
		var _p1 = msg;
		if (_p1.ctor === 'NavigateToParticipantDetail') {
			return {
				ctor: '_Tuple2',
				_0: {
					ctor: '_Tuple2',
					_0: model,
					_1: _user$project$Route$newUrl(
						A2(_user$project$Route$Participant, _p1._0, _p1._1))
				},
				_1: _user$project$Page_Modal$None
			};
		} else {
			return {
				ctor: '_Tuple2',
				_0: {
					ctor: '_Tuple2',
					_0: model,
					_1: _user$project$Route$newUrl(
						_user$project$Route$ProjectDetail(_p1._0))
				},
				_1: _user$project$Page_Modal$None
			};
		}
	});
var _user$project$Page_Search$Model = F3(
	function (a, b, c) {
		return {results: a, searchTerm: b, now: c};
	});
var _user$project$Page_Search$EmptySearchTerm = {ctor: 'EmptySearchTerm'};
var _user$project$Page_Search$HttpError = function (a) {
	return {ctor: 'HttpError', _0: a};
};
var _user$project$Page_Search$init = F2(
	function (session, searchVal) {
		var _p2 = _user$project$Page_Search$cleanSearchTerm(searchVal);
		if (_p2.ctor === 'Just') {
			var _p3 = _p2._0;
			return A3(
				_elm_lang$core$Task$map2,
				F2(
					function (now, results) {
						return A3(_user$project$Page_Search$Model, results, _p3, now);
					}),
				_elm_lang$core$Date$now,
				A2(
					_elm_lang$core$Task$mapError,
					function (x) {
						return _user$project$Page_Search$HttpError(x);
					},
					_elm_lang$http$Http$toTask(
						A2(_user$project$Request_SearchResult$get, session, _p3))));
		} else {
			return _elm_lang$core$Task$fail(_user$project$Page_Search$EmptySearchTerm);
		}
	});
var _user$project$Page_Search$NavigateToProjectDetail = function (a) {
	return {ctor: 'NavigateToProjectDetail', _0: a};
};
var _user$project$Page_Search$NavigateToParticipantDetail = F2(
	function (a, b) {
		return {ctor: 'NavigateToParticipantDetail', _0: a, _1: b};
	});

var _user$project$Views_ErrorTemplate$view = F2(
	function (errorTitle, errorBody) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('error-backdrop'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('error-frame'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$header,
							{ctor: '[]'},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$h1,
									{ctor: '[]'},
									{
										ctor: '::',
										_0: _elm_lang$html$Html$text(errorTitle),
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$section,
								{ctor: '[]'},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$p,
										{ctor: '[]'},
										{
											ctor: '::',
											_0: _elm_lang$html$Html$text(errorBody),
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$hr,
											{ctor: '[]'},
											{ctor: '[]'}),
										_1: {ctor: '[]'}
									}
								}),
							_1: {ctor: '[]'}
						}
					}),
				_1: {ctor: '[]'}
			});
	});

var _user$project$Views_AccessDenied$view = function (i18n) {
	return A2(_user$project$Views_ErrorTemplate$view, i18n.accessDenied, i18n.contactSupport);
};

var _user$project$Views_Error$view = function (i18n) {
	return A2(
		_user$project$Views_ErrorTemplate$view,
		i18n.error,
		A2(
			_elm_lang$core$Basics_ops['++'],
			i18n.errorWithRequest,
			A2(_elm_lang$core$Basics_ops['++'], ' ', i18n.contactSupport)));
};

var _user$project$Views_Menu$view = F2(
	function (model, session) {
		var toggleOrSearch = _elm_lang$core$String$isEmpty(model.searchValue) ? _user$project$Page_Menu$ToggleSearch : _user$project$Page_Menu$SubmitSearch;
		var sortedClientListItems = function () {
			var template = function (client) {
				return _elm_lang$core$Native_Utils.eq(client.id, session.activeClient) ? A2(
					_elm_lang$html$Html$li,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('inset-sm active-client'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$i,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('icon-md ion-md-people'),
								_1: {ctor: '[]'}
							},
							{ctor: '[]'}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$span,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('overflow-ellipsis'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text(client.name),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}
					}) : A2(
					_elm_lang$html$Html$li,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('inset-sm'),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Events$onClick(
								_user$project$Page_Menu$SetActiveClient(client.id)),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$i,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('icon-md ion-md-people'),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$title(session.i18n.clients),
									_1: {ctor: '[]'}
								}
							},
							{ctor: '[]'}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$span,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('overflow-ellipsis'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text(client.name),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}
					});
			};
			return A2(
				_elm_lang$core$List$map,
				template,
				A2(
					_elm_lang$core$List$sortBy,
					function (_) {
						return _.name;
					},
					model.clients));
		}();
		var openClass = function (isToggled) {
			return isToggled ? ' open ' : '';
		};
		var clientDropdown = (_elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$List$length(model.clients),
			1) > 0) ? {
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('hamburger-group-toggle'),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Events$onClick(
							_user$project$Page_Menu$ToggleClients(!model.clientDropdownToggled)),
						_1: {ctor: '[]'}
					}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$i,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('glyphicon glyphicon-user'),
									_1: {ctor: '[]'}
								},
								{ctor: '[]'}),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$ul,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class(
							A2(
								_elm_lang$core$Basics_ops['++'],
								'hamburger-group inset-squish-xs',
								openClass(model.clientDropdownToggled))),
						_1: {ctor: '[]'}
					},
					sortedClientListItems),
				_1: {ctor: '[]'}
			}
		} : {ctor: '[]'};
		return A2(
			_elm_lang$html$Html$nav,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$id('PrimaryNavigation'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('container flex flex-justify-end'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$id('Logo'),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('flex'),
									_1: {ctor: '[]'}
								}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$button,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$id('hamburger-menu'),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Events$onClick(
												_user$project$Page_Menu$ToggleMenu(!model.menuToggled)),
											_1: {ctor: '[]'}
										}
									},
									{
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$i,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('icon-md ion-md-menu'),
												_1: {ctor: '[]'}
											},
											{ctor: '[]'}),
										_1: {ctor: '[]'}
									}),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$a,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$href('/'),
											_1: {ctor: '[]'}
										},
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$img,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$src('/images/HoganLogo.jpg'),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$id('HoganLogo'),
														_1: {ctor: '[]'}
													}
												},
												{ctor: '[]'}),
											_1: {ctor: '[]'}
										}),
									_1: {ctor: '[]'}
								}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('flex flex-align-center'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$div,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class(
												A2(
													_elm_lang$core$Basics_ops['++'],
													'search flex-align-center inset-squish-sm',
													openClass(model.searchToggled))),
											_1: {ctor: '[]'}
										},
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$i,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class('icon-md ion-md-arrow-back font-md inline-md show-below-md'),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_Menu$ToggleSearch),
														_1: {ctor: '[]'}
													}
												},
												{ctor: '[]'}),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$input,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$id('SearchBox'),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$type_('text'),
															_1: {
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$class('form-control'),
																_1: {
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$placeholder(session.i18n.search),
																	_1: {
																		ctor: '::',
																		_0: _elm_lang$html$Html_Events$onInput(_user$project$Page_Menu$SetSearchTerm),
																		_1: {
																			ctor: '::',
																			_0: _elm_community$html_extra$Html_Events_Extra$onEnter(_user$project$Page_Menu$SubmitSearch),
																			_1: {
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$value(model.searchValue),
																				_1: {ctor: '[]'}
																			}
																		}
																	}
																}
															}
														}
													},
													{ctor: '[]'}),
												_1: {ctor: '[]'}
											}
										}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$i,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('icon-md ion-ios-search inline-md'),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$title(session.i18n.search),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Events$onClick(toggleOrSearch),
														_1: {ctor: '[]'}
													}
												}
											},
											{ctor: '[]'}),
										_1: {ctor: '[]'}
									}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$id('MenuDropdown'),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class(
												A2(
													_elm_lang$core$Basics_ops['++'],
													'hamburger-items',
													openClass(model.menuToggled))),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html_Events$onClick(
													_user$project$Page_Menu$ToggleMenu(false)),
												_1: {ctor: '[]'}
											}
										}
									},
									A2(
										_elm_lang$core$Basics_ops['++'],
										clientDropdown,
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$div,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class('hamburger-group-toggle'),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Events$onClick(
															_user$project$Page_Menu$ToggleHelpDropdown(!model.helpDropdownToggled)),
														_1: {ctor: '[]'}
													}
												},
												{
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$div,
														{ctor: '[]'},
														{
															ctor: '::',
															_0: A2(
																_elm_lang$html$Html$i,
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$class('icon-md ion-md-help-circle'),
																	_1: {
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$title(session.i18n.helpfulLinks),
																		_1: {ctor: '[]'}
																	}
																},
																{ctor: '[]'}),
															_1: {ctor: '[]'}
														}),
													_1: {ctor: '[]'}
												}),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$ul,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class(
															A2(
																_elm_lang$core$Basics_ops['++'],
																'hamburger-group inset-squish-xs',
																openClass(model.helpDropdownToggled))),
														_1: {ctor: '[]'}
													},
													{
														ctor: '::',
														_0: A2(
															_elm_lang$html$Html$li,
															{
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$class('inset-sm'),
																_1: {ctor: '[]'}
															},
															{
																ctor: '::',
																_0: A2(
																	_elm_lang$html$Html$i,
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$class('icon-md ion-ios-journal inline-md'),
																		_1: {ctor: '[]'}
																	},
																	{ctor: '[]'}),
																_1: {
																	ctor: '::',
																	_0: A2(
																		_elm_lang$html$Html$a,
																		{
																			ctor: '::',
																			_0: _elm_lang$html$Html_Attributes$href('/Halo Lite User Guide.pdf'),
																			_1: {
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$target('_blank'),
																				_1: {ctor: '[]'}
																			}
																		},
																		{
																			ctor: '::',
																			_0: _elm_lang$html$Html$text(session.i18n.userGuide),
																			_1: {ctor: '[]'}
																		}),
																	_1: {ctor: '[]'}
																}
															}),
														_1: {
															ctor: '::',
															_0: A2(
																_elm_lang$html$Html$li,
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$class('inset-sm'),
																	_1: {ctor: '[]'}
																},
																{
																	ctor: '::',
																	_0: A2(
																		_elm_lang$html$Html$i,
																		{
																			ctor: '::',
																			_0: _elm_lang$html$Html_Attributes$class('icon-md ion-md-eye inline-md'),
																			_1: {ctor: '[]'}
																		},
																		{ctor: '[]'}),
																	_1: {
																		ctor: '::',
																		_0: A2(
																			_elm_lang$html$Html$a,
																			{
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$href('http://www.hoganassessments.com/privacy-policy'),
																				_1: {
																					ctor: '::',
																					_0: _elm_lang$html$Html_Attributes$target('_blank'),
																					_1: {ctor: '[]'}
																				}
																			},
																			{
																				ctor: '::',
																				_0: _elm_lang$html$Html$text(session.i18n.hoganPrivacyPolicy),
																				_1: {ctor: '[]'}
																			}),
																		_1: {ctor: '[]'}
																	}
																}),
															_1: {
																ctor: '::',
																_0: A2(
																	_elm_lang$html$Html$li,
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$class('inset-sm'),
																		_1: {ctor: '[]'}
																	},
																	{
																		ctor: '::',
																		_0: A2(
																			_elm_lang$html$Html$i,
																			{
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$class('icon-md ion-ios-paper inline-md'),
																				_1: {ctor: '[]'}
																			},
																			{ctor: '[]'}),
																		_1: {
																			ctor: '::',
																			_0: A2(
																				_elm_lang$html$Html$a,
																				{
																					ctor: '::',
																					_0: _elm_lang$html$Html_Attributes$href(session.termsAndConditions),
																					_1: {
																						ctor: '::',
																						_0: _elm_lang$html$Html_Attributes$target('_blank'),
																						_1: {ctor: '[]'}
																					}
																				},
																				{
																					ctor: '::',
																					_0: _elm_lang$html$Html$text(session.i18n.termsOfUse),
																					_1: {ctor: '[]'}
																				}),
																			_1: {ctor: '[]'}
																		}
																	}),
																_1: {ctor: '[]'}
															}
														}
													}),
												_1: {
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$div,
														{
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$class('hamburger-group logout'),
															_1: {ctor: '[]'}
														},
														{
															ctor: '::',
															_0: A2(
																_elm_lang$html$Html$div,
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_Menu$Logout),
																	_1: {ctor: '[]'}
																},
																{
																	ctor: '::',
																	_0: A2(
																		_elm_lang$html$Html$i,
																		{
																			ctor: '::',
																			_0: _elm_lang$html$Html_Attributes$class('icon-md ion-md-exit inline-md'),
																			_1: {
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$title(session.i18n.logout),
																				_1: {ctor: '[]'}
																			}
																		},
																		{ctor: '[]'}),
																	_1: {
																		ctor: '::',
																		_0: A2(
																			_elm_lang$html$Html$a,
																			{
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$class('text-normal'),
																				_1: {
																					ctor: '::',
																					_0: _elm_lang$html$Html_Attributes$id('Logout'),
																					_1: {ctor: '[]'}
																				}
																			},
																			{
																				ctor: '::',
																				_0: _elm_lang$html$Html$text(session.i18n.logout),
																				_1: {ctor: '[]'}
																			}),
																		_1: {ctor: '[]'}
																	}
																}),
															_1: {ctor: '[]'}
														}),
													_1: {ctor: '[]'}
												}
											}
										})),
								_1: {ctor: '[]'}
							}
						}
					}),
				_1: {ctor: '[]'}
			});
	});

var _user$project$Views_ReportImageMap$path = function (id) {
	var mapDefault = function (path) {
		var _p0 = path;
		if (_p0.ctor === 'Nothing') {
			return A2(_elm_lang$core$String$startsWith, 'RP', id) ? '/images/reports/Package.png' : '/images/reports/Custom.png';
		} else {
			return _p0._0;
		}
	};
	var imageMap = _elm_lang$core$Dict$fromList(
		{
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'EcEQEIR', _1: '/images/reports/EQ.png'},
			_1: {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: 'EcEQHPIHDSEIR', _1: '/images/reports/EQ.png'},
				_1: {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'EcHAAAR', _1: '/images/reports/Advantage.png'},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'EcHBRIV1IML', _1: '/images/reports/Interpret.png'},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'EcHDSINSRV2', _1: '/images/reports/InsightSeries.png'},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'EcHDSLFCML', _1: '/images/reports/Challenge.png'},
								_1: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'EcHDSLFCNLPML', _1: '/images/reports/Challenge.png'},
									_1: {
										ctor: '::',
										_0: {ctor: '_Tuple2', _0: 'EcHPIBSML', _1: '/images/reports/Basis.png'},
										_1: {
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: 'EcHPICBML', _1: '/images/reports/Career.png'},
											_1: {
												ctor: '::',
												_0: {ctor: '_Tuple2', _0: 'EcHPICBNGraML', _1: '/images/reports/Career.png'},
												_1: {
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'EcHPIEPMLAdmClr', _1: '/images/reports/Express.png'},
													_1: {
														ctor: '::',
														_0: {ctor: '_Tuple2', _0: 'EcHPIEPMLCustSupp', _1: '/images/reports/Express.png'},
														_1: {
															ctor: '::',
															_0: {ctor: '_Tuple2', _0: 'EcHPIEPMLManExe', _1: '/images/reports/Express.png'},
															_1: {
																ctor: '::',
																_0: {ctor: '_Tuple2', _0: 'EcHPIEPMLOpTra', _1: '/images/reports/Express.png'},
																_1: {
																	ctor: '::',
																	_0: {ctor: '_Tuple2', _0: 'EcHPIEPMLProf', _1: '/images/reports/Express.png'},
																	_1: {
																		ctor: '::',
																		_0: {ctor: '_Tuple2', _0: 'EcHPIEPMLSerSupp', _1: '/images/reports/Express.png'},
																		_1: {
																			ctor: '::',
																			_0: {ctor: '_Tuple2', _0: 'EcHPIEPMLTecSpec', _1: '/images/reports/Express.png'},
																			_1: {
																				ctor: '::',
																				_0: {ctor: '_Tuple2', _0: 'EcHPIHDSBSML', _1: '/images/reports/Basis.png'},
																				_1: {
																					ctor: '::',
																					_0: {ctor: '_Tuple2', _0: 'EcHPIHDSMVPIBSML', _1: '/images/reports/Basis.png'},
																					_1: {
																						ctor: '::',
																						_0: {ctor: '_Tuple2', _0: 'EcHPIHDSMVPIFR', _1: '/images/reports/Flash.png'},
																						_1: {
																							ctor: '::',
																							_0: {ctor: '_Tuple2', _0: 'EcHPIHDSMVPIHPARML', _1: '/images/reports/HighPotential.png'},
																							_1: {
																								ctor: '::',
																								_0: {ctor: '_Tuple2', _0: 'EcHPIHDSMVPIHPTR', _1: '/images/reports/HighPotential.png'},
																								_1: {
																									ctor: '::',
																									_0: {ctor: '_Tuple2', _0: 'EcHPIHDSMVPILFCRML', _1: '/images/reports/Coaching.png'},
																									_1: {
																										ctor: '::',
																										_0: {ctor: '_Tuple2', _0: 'EcHPIHDSMVPIPESML', _1: '/images/reports/Summary.png'},
																										_1: {
																											ctor: '::',
																											_0: {ctor: '_Tuple2', _0: 'EcHPIHDSMVPIPESNLPML', _1: '/images/reports/Summary.png'},
																											_1: {
																												ctor: '::',
																												_0: {ctor: '_Tuple2', _0: 'EcHPIHDSMVPISML', _1: '/images/reports/Fit.png'},
																												_1: {
																													ctor: '::',
																													_0: {ctor: '_Tuple2', _0: 'EcHPIHDSSML', _1: '/images/reports/Fit.png'},
																													_1: {
																														ctor: '::',
																														_0: {ctor: '_Tuple2', _0: 'EcHPIIML', _1: '/images/reports/Interpret.png'},
																														_1: {
																															ctor: '::',
																															_0: {ctor: '_Tuple2', _0: 'EcHPIINSRV2', _1: '/images/reports/InsightSeries.png'},
																															_1: {
																																ctor: '::',
																																_0: {ctor: '_Tuple2', _0: 'EcHPIIOML', _1: '/images/reports/Interpret.png'},
																																_1: {
																																	ctor: '::',
																																	_0: {ctor: '_Tuple2', _0: 'EcHPILDRCB', _1: '/images/reports/HoganPersonality.png'},
																																	_1: {
																																		ctor: '::',
																																		_0: {ctor: '_Tuple2', _0: 'EcHPILFPML', _1: '/images/reports/Potential.png'},
																																		_1: {
																																			ctor: '::',
																																			_0: {ctor: '_Tuple2', _0: 'EcHPILFPNLPML', _1: '/images/reports/Potential.png'},
																																			_1: {
																																				ctor: '::',
																																				_0: {ctor: '_Tuple2', _0: 'EcHPIMBML', _1: '/images/reports/Manage.png'},
																																				_1: {
																																					ctor: '::',
																																					_0: {ctor: '_Tuple2', _0: 'EcHPIMBNGraML', _1: '/images/reports/Manage.png'},
																																					_1: {
																																						ctor: '::',
																																						_0: {ctor: '_Tuple2', _0: 'EcHPIMD', _1: '/images/reports/Manage.png'},
																																						_1: {
																																							ctor: '::',
																																							_0: {ctor: '_Tuple2', _0: 'EcHPIMultiJobML', _1: '/images/reports/Fit.png'},
																																							_1: {
																																								ctor: '::',
																																								_0: {ctor: '_Tuple2', _0: 'EcHPIMVPIBSML', _1: '/images/reports/Basis.png'},
																																								_1: {
																																									ctor: '::',
																																									_0: {ctor: '_Tuple2', _0: 'EcHPIMVPILFR', _1: '/images/reports/ManagementFocus.png'},
																																									_1: {
																																										ctor: '::',
																																										_0: {ctor: '_Tuple2', _0: 'EcHPIMVPIMAMR', _1: '/images/reports/ManagementFocus.png'},
																																										_1: {
																																											ctor: '::',
																																											_0: {ctor: '_Tuple2', _0: 'EcHPIMVPISML', _1: '/images/reports/Fit.png'},
																																											_1: {
																																												ctor: '::',
																																												_0: {ctor: '_Tuple2', _0: 'EcHPISafetyML', _1: '/images/reports/SafeSystem.png'},
																																												_1: {
																																													ctor: '::',
																																													_0: {ctor: '_Tuple2', _0: 'EcHPISafetyMLV2', _1: '/images/reports/SafeSystem.png'},
																																													_1: {
																																														ctor: '::',
																																														_0: {ctor: '_Tuple2', _0: 'EcHPISafetyMLV2D', _1: '/images/reports/SafeSystem.png'},
																																														_1: {
																																															ctor: '::',
																																															_0: {ctor: '_Tuple2', _0: 'EcHPISafetyMLV2S', _1: '/images/reports/SafeSystem.png'},
																																															_1: {
																																																ctor: '::',
																																																_0: {ctor: '_Tuple2', _0: 'EcHPISML', _1: '/images/reports/Fit.png'},
																																																_1: {
																																																	ctor: '::',
																																																	_0: {ctor: '_Tuple2', _0: 'EcJUDCJUDVJUDAJR', _1: '/images/reports/Judgment.png'},
																																																	_1: {
																																																		ctor: '::',
																																																		_0: {ctor: '_Tuple2', _0: 'EcMVPICCML', _1: '/images/reports/Compass.png'},
																																																		_1: {
																																																			ctor: '::',
																																																			_0: {ctor: '_Tuple2', _0: 'EcMVPICCNGraML', _1: '/images/reports/Compass.png'},
																																																			_1: {
																																																				ctor: '::',
																																																				_0: {ctor: '_Tuple2', _0: 'EcMVPIIML', _1: '/images/reports/Interpret.png'},
																																																				_1: {
																																																					ctor: '::',
																																																					_0: {ctor: '_Tuple2', _0: 'EcMVPIINSRV2', _1: '/images/reports/InsightSeries.png'},
																																																					_1: {
																																																						ctor: '::',
																																																						_0: {ctor: '_Tuple2', _0: 'EcMVPILFVML', _1: '/images/reports/Values.png'},
																																																						_1: {
																																																							ctor: '::',
																																																							_0: {ctor: '_Tuple2', _0: 'EcMVPILFVNLPML', _1: '/images/reports/Values.png'},
																																																							_1: {
																																																								ctor: '::',
																																																								_0: {ctor: '_Tuple2', _0: 'HPIHDSMVPIHPAR', _1: '/images/reports/HighPotential.png'},
																																																								_1: {
																																																									ctor: '::',
																																																									_0: {ctor: '_Tuple2', _0: 'HAA', _1: '/images/reports/Advantage.png'},
																																																									_1: {
																																																										ctor: '::',
																																																										_0: {ctor: '_Tuple2', _0: 'JUDA', _1: '/images/reports/JUDA.png'},
																																																										_1: {
																																																											ctor: '::',
																																																											_0: {ctor: '_Tuple2', _0: 'JUDC', _1: '/images/reports/JUDC.png'},
																																																											_1: {
																																																												ctor: '::',
																																																												_0: {ctor: '_Tuple2', _0: 'JUDV', _1: '/images/reports/JUDV.png'},
																																																												_1: {
																																																													ctor: '::',
																																																													_0: {ctor: '_Tuple2', _0: 'MATR', _1: '/images/reports/MATR.png'},
																																																													_1: {
																																																														ctor: '::',
																																																														_0: {ctor: '_Tuple2', _0: 'HPI', _1: '/images/reports/HPI.png'},
																																																														_1: {
																																																															ctor: '::',
																																																															_0: {ctor: '_Tuple2', _0: 'HDS', _1: '/images/reports/HDS.png'},
																																																															_1: {
																																																																ctor: '::',
																																																																_0: {ctor: '_Tuple2', _0: 'MVPI', _1: '/images/reports/MVPI.png'},
																																																																_1: {
																																																																	ctor: '::',
																																																																	_0: {ctor: '_Tuple2', _0: 'HBRIV1', _1: '/images/reports/HBRIV1.png'},
																																																																	_1: {
																																																																		ctor: '::',
																																																																		_0: {ctor: '_Tuple2', _0: 'HBRI', _1: '/images/reports/HBRIV1.png'},
																																																																		_1: {
																																																																			ctor: '::',
																																																																			_0: {ctor: '_Tuple2', _0: 'EQ', _1: '/images/reports/EQ.png'},
																																																																			_1: {
																																																																				ctor: '::',
																																																																				_0: {ctor: '_Tuple2', _0: 'HPISFV2', _1: '/images/reports/HPI.png'},
																																																																				_1: {
																																																																					ctor: '::',
																																																																					_0: {ctor: '_Tuple2', _0: 'HDSSFV2', _1: '/images/reports/HDS.png'},
																																																																					_1: {
																																																																						ctor: '::',
																																																																						_0: {ctor: '_Tuple2', _0: 'MVPISFV2', _1: '/images/reports/MVPI.png'},
																																																																						_1: {ctor: '[]'}
																																																																					}
																																																																				}
																																																																			}
																																																																		}
																																																																	}
																																																																}
																																																															}
																																																														}
																																																													}
																																																												}
																																																											}
																																																										}
																																																									}
																																																								}
																																																							}
																																																						}
																																																					}
																																																				}
																																																			}
																																																		}
																																																	}
																																																}
																																															}
																																														}
																																													}
																																												}
																																											}
																																										}
																																									}
																																								}
																																							}
																																						}
																																					}
																																				}
																																			}
																																		}
																																	}
																																}
																															}
																														}
																													}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		});
	return mapDefault(
		A2(_elm_lang$core$Dict$get, id, imageMap));
};

var _user$project$Views_ReportSettings$view = function (reportId) {
	return function (headerText) {
		return function (isAvailableToClient) {
			return function (language) {
				return function (languages) {
					return function (changeLanguageMsg) {
						return function (norm) {
							return function (norms) {
								return function (changeNormMsg) {
									return function (jobProfile) {
										return function (jobProfiles) {
											return function (changeJobProfileMsg) {
												return function (saveMsg) {
													return function (closeMsg) {
														return function (alerts) {
															return function (session) {
																var onChange = function (message) {
																	return A2(
																		_elm_lang$html$Html_Events$on,
																		'change',
																		A2(_elm_lang$core$Json_Decode$map, message, _elm_lang$html$Html_Events$targetValue));
																};
																var disableSelection = _elm_lang$html$Html_Attributes$disabled(
																	session.readOnly || _elm_lang$core$Native_Utils.eq(isAvailableToClient, false));
																var optionsList = F2(
																	function (selected, available) {
																		var toOptionHtml = function (_p0) {
																			var _p1 = _p0;
																			var _p2 = _p1._0;
																			var isDisabled = !A2(_elm_lang$core$List$member, _p2, available);
																			var isSelected = A2(
																				F2(
																					function (x, y) {
																						return _elm_lang$core$Native_Utils.eq(x, y);
																					}),
																				selected,
																				_p2);
																			return A2(
																				_elm_lang$html$Html$option,
																				{
																					ctor: '::',
																					_0: _elm_lang$html$Html_Attributes$value(_p2),
																					_1: {
																						ctor: '::',
																						_0: _elm_lang$html$Html_Attributes$selected(isSelected),
																						_1: {
																							ctor: '::',
																							_0: _elm_lang$html$Html_Attributes$disabled(isDisabled),
																							_1: {ctor: '[]'}
																						}
																					}
																				},
																				{
																					ctor: '::',
																					_0: _elm_lang$html$Html$text(_p1._1),
																					_1: {ctor: '[]'}
																				});
																		};
																		var options = function () {
																			var withDisplay = function (value) {
																				return {
																					ctor: '_Tuple2',
																					_0: value,
																					_1: A2(
																						_elm_lang$core$Maybe$withDefault,
																						value,
																						A2(_elm_lang$core$Dict$get, value, session.i18n.languages))
																				};
																			};
																			var allValues = A2(_elm_lang$core$List$member, selected, available) ? available : {ctor: '::', _0: selected, _1: available};
																			return A2(
																				_elm_lang$core$List$sortBy,
																				function (_p3) {
																					return _elm_lang$core$String$toUpper(
																						_elm_lang$core$Tuple$second(_p3));
																				},
																				A2(_elm_lang$core$List$map, withDisplay, allValues));
																		}();
																		return A2(_elm_lang$core$List$map, toOptionHtml, options);
																	});
																return A2(
																	_elm_lang$html$Html$div,
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$id('ReportOptionsModalWrapper'),
																		_1: {ctor: '[]'}
																	},
																	{
																		ctor: '::',
																		_0: A2(
																			_elm_lang$html$Html$article,
																			{ctor: '[]'},
																			{
																				ctor: '::',
																				_0: A2(
																					_elm_lang$html$Html$header,
																					{ctor: '[]'},
																					{
																						ctor: '::',
																						_0: A2(
																							_elm_lang$html$Html$img,
																							{
																								ctor: '::',
																								_0: _elm_lang$html$Html_Attributes$src(
																									_user$project$Views_ReportImageMap$path(reportId)),
																								_1: {ctor: '[]'}
																							},
																							{ctor: '[]'}),
																						_1: {
																							ctor: '::',
																							_0: A2(
																								_elm_lang$html$Html$h3,
																								{ctor: '[]'},
																								{
																									ctor: '::',
																									_0: _elm_lang$html$Html$text(headerText),
																									_1: {ctor: '[]'}
																								}),
																							_1: {ctor: '[]'}
																						}
																					}),
																				_1: {
																					ctor: '::',
																					_0: A2(
																						_elm_lang$html$Html$section,
																						{ctor: '[]'},
																						{
																							ctor: '::',
																							_0: A2(
																								_elm_lang$html$Html$div,
																								{
																									ctor: '::',
																									_0: _elm_lang$html$Html_Attributes$class('column'),
																									_1: {ctor: '[]'}
																								},
																								{
																									ctor: '::',
																									_0: A2(
																										_elm_lang$html$Html$h3,
																										{ctor: '[]'},
																										{
																											ctor: '::',
																											_0: _elm_lang$html$Html$text(session.i18n.language),
																											_1: {ctor: '[]'}
																										}),
																									_1: {
																										ctor: '::',
																										_0: function () {
																											var sortedLanguages = A2(_elm_lang$core$List$sortBy, _elm_lang$core$String$toUpper, languages);
																											return A2(
																												_elm_lang$html$Html$select,
																												{
																													ctor: '::',
																													_0: _elm_lang$html$Html_Attributes$id('language'),
																													_1: {
																														ctor: '::',
																														_0: onChange(changeLanguageMsg),
																														_1: {
																															ctor: '::',
																															_0: disableSelection,
																															_1: {ctor: '[]'}
																														}
																													}
																												},
																												A2(optionsList, language, sortedLanguages));
																										}(),
																										_1: {ctor: '[]'}
																									}
																								}),
																							_1: {
																								ctor: '::',
																								_0: A2(
																									_elm_lang$html$Html$div,
																									{
																										ctor: '::',
																										_0: _elm_lang$html$Html_Attributes$class('column'),
																										_1: {ctor: '[]'}
																									},
																									{
																										ctor: '::',
																										_0: A2(
																											_elm_lang$html$Html$h3,
																											{ctor: '[]'},
																											{
																												ctor: '::',
																												_0: _elm_lang$html$Html$text(session.i18n.norm),
																												_1: {ctor: '[]'}
																											}),
																										_1: {
																											ctor: '::',
																											_0: A2(
																												_elm_lang$html$Html$select,
																												{
																													ctor: '::',
																													_0: _elm_lang$html$Html_Attributes$id('norm'),
																													_1: {
																														ctor: '::',
																														_0: onChange(changeNormMsg),
																														_1: {
																															ctor: '::',
																															_0: disableSelection,
																															_1: {ctor: '[]'}
																														}
																													}
																												},
																												A2(optionsList, norm, norms)),
																											_1: {ctor: '[]'}
																										}
																									}),
																								_1: {
																									ctor: '::',
																									_0: function () {
																										var _p4 = jobProfile;
																										if (_p4.ctor === 'Just') {
																											return A2(
																												_elm_lang$html$Html$div,
																												{
																													ctor: '::',
																													_0: _elm_lang$html$Html_Attributes$class('column'),
																													_1: {ctor: '[]'}
																												},
																												{
																													ctor: '::',
																													_0: A2(
																														_elm_lang$html$Html$h3,
																														{ctor: '[]'},
																														{
																															ctor: '::',
																															_0: _elm_lang$html$Html$text(session.i18n.jobProfile),
																															_1: {ctor: '[]'}
																														}),
																													_1: {
																														ctor: '::',
																														_0: A2(
																															_elm_lang$html$Html$select,
																															{
																																ctor: '::',
																																_0: _elm_lang$html$Html_Attributes$id('profile'),
																																_1: {
																																	ctor: '::',
																																	_0: onChange(changeJobProfileMsg),
																																	_1: {
																																		ctor: '::',
																																		_0: disableSelection,
																																		_1: {ctor: '[]'}
																																	}
																																}
																															},
																															A2(optionsList, _p4._0, jobProfiles)),
																														_1: {ctor: '[]'}
																													}
																												});
																										} else {
																											return _elm_lang$html$Html$text('');
																										}
																									}(),
																									_1: {ctor: '[]'}
																								}
																							}
																						}),
																					_1: {
																						ctor: '::',
																						_0: A2(
																							_elm_lang$html$Html$footer,
																							{ctor: '[]'},
																							{
																								ctor: '::',
																								_0: alerts,
																								_1: {
																									ctor: '::',
																									_0: A2(
																										_elm_lang$html$Html$button,
																										{
																											ctor: '::',
																											_0: _elm_lang$html$Html_Attributes$id('continue'),
																											_1: {
																												ctor: '::',
																												_0: _elm_lang$html$Html_Attributes$class('btn btn-report-options'),
																												_1: {
																													ctor: '::',
																													_0: _elm_lang$html$Html_Events$onClick(saveMsg),
																													_1: {
																														ctor: '::',
																														_0: disableSelection,
																														_1: {ctor: '[]'}
																													}
																												}
																											}
																										},
																										{
																											ctor: '::',
																											_0: _elm_lang$html$Html$text(session.i18n.save),
																											_1: {ctor: '[]'}
																										}),
																									_1: {
																										ctor: '::',
																										_0: A2(
																											_elm_lang$html$Html$button,
																											{
																												ctor: '::',
																												_0: _elm_lang$html$Html_Attributes$id('cancel'),
																												_1: {
																													ctor: '::',
																													_0: _elm_lang$html$Html_Attributes$class('btn btn-report-options'),
																													_1: {
																														ctor: '::',
																														_0: _elm_lang$html$Html_Attributes$id('CancelReportOptions'),
																														_1: {
																															ctor: '::',
																															_0: _elm_lang$html$Html_Events$onClick(closeMsg),
																															_1: {ctor: '[]'}
																														}
																													}
																												}
																											},
																											{
																												ctor: '::',
																												_0: _elm_lang$html$Html$text(session.i18n.cancel),
																												_1: {ctor: '[]'}
																											}),
																										_1: {ctor: '[]'}
																									}
																								}
																							}),
																						_1: {ctor: '[]'}
																					}
																				}
																			}),
																		_1: {ctor: '[]'}
																	});
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};

var _user$project$Views_ParticipantReportSettings$view = F2(
	function (model, session) {
		var heading = A2(
			_elm_lang$core$Basics_ops['++'],
			model.product.name,
			A2(
				_elm_lang$core$Basics_ops['++'],
				' - ',
				A2(
					_elm_lang$core$Basics_ops['++'],
					model.participant.firstName,
					A2(_elm_lang$core$Basics_ops['++'], ' ', model.participant.lastName))));
		var alerts = (model.isReportGenerated && ((!_elm_lang$core$Native_Utils.eq(model.product.norm, model.memento.norm)) || (!_elm_lang$core$Native_Utils.eq(model.product.jobProfile, model.memento.jobProfile)))) ? A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('alert alert-warning'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text(session.i18n.changeBillableSettingWarning),
				_1: {ctor: '[]'}
			}) : _elm_lang$html$Html$text('');
		return _user$project$Views_ReportSettings$view(model.product.id)(heading)(
			!_elm_lang$core$List$isEmpty(model.availableNorms))(model.product.language)(model.availableLanguages)(_user$project$Page_ParticipantReportSettings$SetLanguage)(model.product.norm)(model.availableNorms)(_user$project$Page_ParticipantReportSettings$SetNorm)(model.product.jobProfile)(model.availableJobProfiles)(_user$project$Page_ParticipantReportSettings$SetProfile)(_user$project$Page_ParticipantReportSettings$Save)(_user$project$Page_ParticipantReportSettings$Close)(alerts)(session);
	});

var _user$project$Views_AddParticipantsModal$buildErrorDiv = F2(
	function (session, model) {
		var getInvitiationMessage = function () {
			var _p0 = model.sampleInvitationStatus;
			switch (_p0.ctor) {
				case 'SentSuccessfully':
					return {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$span,
							{ctor: '[]'},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(
									A2(
										_user$project$Views_Interpolation$interpolate,
										session.i18n.emailSuccessTo,
										{
											ctor: '::',
											_0: session.userEmail,
											_1: {ctor: '[]'}
										})),
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					};
				case 'FailedToSend':
					return {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$span,
							{ctor: '[]'},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(session.i18n.emailFailed),
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					};
				default:
					return {
						ctor: '::',
						_0: _elm_lang$html$Html$text(''),
						_1: {ctor: '[]'}
					};
			}
		}();
		var getDuplicateEmailMessageElement = function (email) {
			return A2(
				_elm_lang$html$Html$p,
				{ctor: '[]'},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text(
						A2(
							_elm_lang$core$Basics_ops['++'],
							email,
							A2(_elm_lang$core$Basics_ops['++'], ' - ', session.i18n.duplicateEmailAddressForProjectParticipant))),
					_1: {ctor: '[]'}
				});
		};
		var getImproperlyFormattedEmailMessageElement = function (_p1) {
			var _p2 = _p1;
			var _p4 = _p2._0;
			var _p3 = _p2._1;
			switch (_p3.ctor) {
				case 'MultipleConsecutiveDots':
					return A2(
						_elm_lang$html$Html$p,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text(
								A2(
									_elm_lang$core$Basics_ops['++'],
									_p4,
									A2(_elm_lang$core$Basics_ops['++'], ' - ', session.i18n.emailContainsDoubleDot))),
							_1: {ctor: '[]'}
						});
				case 'NoDotAfterCommercialAt':
					return A2(
						_elm_lang$html$Html$p,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text(
								A2(
									_elm_lang$core$Basics_ops['++'],
									_p4,
									A2(_elm_lang$core$Basics_ops['++'], ' - ', session.i18n.emailLacksDotInDomain))),
							_1: {ctor: '[]'}
						});
				case 'TooLong':
					return A2(
						_elm_lang$html$Html$p,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text(
								A2(
									_elm_lang$core$Basics_ops['++'],
									_p4,
									A2(_elm_lang$core$Basics_ops['++'], ' - ', session.i18n.emailTooLong))),
							_1: {ctor: '[]'}
						});
				default:
					return A2(
						_elm_lang$html$Html$p,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text(
								A2(
									_elm_lang$core$Basics_ops['++'],
									_p4,
									A2(_elm_lang$core$Basics_ops['++'], ' - ', session.i18n.emailInvalid))),
							_1: {ctor: '[]'}
						});
			}
		};
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('notifications'),
				_1: {ctor: '[]'}
			},
			_elm_lang$core$List$concat(
				{
					ctor: '::',
					_0: A2(_elm_lang$core$List$map, getImproperlyFormattedEmailMessageElement, model.improperlyFormattedEmails),
					_1: {
						ctor: '::',
						_0: A2(_elm_lang$core$List$map, getDuplicateEmailMessageElement, model.duplicateEmails),
						_1: {
							ctor: '::',
							_0: getInvitiationMessage,
							_1: {ctor: '[]'}
						}
					}
				}));
	});
var _user$project$Views_AddParticipantsModal$view = F2(
	function (model, session) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$id('AddParticipantsModal'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('elm-modal'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('center-box'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$header,
									{ctor: '[]'},
									{
										ctor: '::',
										_0: _elm_lang$html$Html$text(session.i18n.inviteParticipants),
										_1: {ctor: '[]'}
									}),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$article,
										{ctor: '[]'},
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$textarea,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$id('SemicolonSeparatedEmails'),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Events$onInput(_user$project$Page_AddParticipantsModal$UpdateWithNewInput),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$value(model.semicolonSeparatedEmails),
															_1: {ctor: '[]'}
														}
													}
												},
												{ctor: '[]'}),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$span,
													{ctor: '[]'},
													{
														ctor: '::',
														_0: _elm_lang$html$Html$text(session.i18n.addParticipantsModalDescription),
														_1: {
															ctor: '::',
															_0: A2(
																_elm_lang$html$Html$button,
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$class('btn btn-link'),
																	_1: {
																		ctor: '::',
																		_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_AddParticipantsModal$SendSampleInvitation),
																		_1: {ctor: '[]'}
																	}
																},
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html$text(session.i18n.sendSampleInvitation),
																	_1: {ctor: '[]'}
																}),
															_1: {ctor: '[]'}
														}
													}),
												_1: {
													ctor: '::',
													_0: A2(_user$project$Views_AddParticipantsModal$buildErrorDiv, session, model),
													_1: {
														ctor: '::',
														_0: A2(
															_elm_lang$html$Html$div,
															{
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$class('actions'),
																_1: {ctor: '[]'}
															},
															{
																ctor: '::',
																_0: A2(
																	_elm_lang$html$Html$button,
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$class('btn btn-modal'),
																		_1: {
																			ctor: '::',
																			_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_AddParticipantsModal$AddParticipants),
																			_1: {
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$disabled(model.requestInProgress),
																				_1: {ctor: '[]'}
																			}
																		}
																	},
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html$text(session.i18n.add),
																		_1: {ctor: '[]'}
																	}),
																_1: {
																	ctor: '::',
																	_0: A2(
																		_elm_lang$html$Html$button,
																		{
																			ctor: '::',
																			_0: _elm_lang$html$Html_Attributes$class('btn btn-modal'),
																			_1: {
																				ctor: '::',
																				_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_AddParticipantsModal$Close),
																				_1: {
																					ctor: '::',
																					_0: _elm_lang$html$Html_Attributes$disabled(model.requestInProgress),
																					_1: {ctor: '[]'}
																				}
																			}
																		},
																		{
																			ctor: '::',
																			_0: _elm_lang$html$Html$text(session.i18n.cancel),
																			_1: {ctor: '[]'}
																		}),
																	_1: {ctor: '[]'}
																}
															}),
														_1: {
															ctor: '::',
															_0: A2(
																_elm_lang$html$Html$footer,
																{ctor: '[]'},
																{ctor: '[]'}),
															_1: {ctor: '[]'}
														}
													}
												}
											}
										}),
									_1: {ctor: '[]'}
								}
							}),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			});
	});

var _user$project$Views_Participants$canInviteParticipant = F2(
	function (participant, assessments) {
		return A2(
			F2(
				function (x, y) {
					return x && y;
				}),
			A2(
				_elm_lang$core$List$any,
				F2(
					function (x, y) {
						return _elm_lang$core$Native_Utils.eq(x, y);
					})(_elm_lang$core$Maybe$Nothing),
				A2(
					_elm_lang$core$List$map,
					function (_) {
						return _.date;
					},
					A2(
						_elm_lang$core$List$filter,
						function (x) {
							return _elm_lang$core$Native_Utils.eq(x.participantId, participant.id);
						},
						assessments))),
			!_elm_lang$core$String$isEmpty(participant.email));
	});
var _user$project$Views_Participants$viewModal = F2(
	function (model, session) {
		var _p0 = model.modal;
		if (_p0.ctor === 'Just') {
			var _p1 = _p0._0;
			return A2(
				_elm_lang$html$Html$map,
				_user$project$Page_Participants$AddParticipantsModalMsg(_p1),
				A2(_user$project$Views_AddParticipantsModal$view, _p1, session));
		} else {
			return _elm_lang$html$Html$text('');
		}
	});
var _user$project$Views_Participants$viewToolbar = F2(
	function (model, session) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('container flex flex-align-center flex-justify-between'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$a,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('flex flex-align-center'),
						_1: {
							ctor: '::',
							_0: _user$project$Route$href(
								_user$project$Route$ProjectDetail(model.projectId)),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$i,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('flex icon-md ion-md-arrow-back inline-sm'),
								_1: {ctor: '[]'}
							},
							{ctor: '[]'}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$span,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('font-italic text-lowercase'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text(session.i18n.backToProjectDetail),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}
					}),
				_1: {
					ctor: '::',
					_0: session.readOnly ? _elm_lang$html$Html$text('') : A2(
						_elm_lang$html$Html$span,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('container material-button'),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$title(session.i18n.inviteParticipants),
								_1: {ctor: '[]'}
							}
						},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$i,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('icon-md ion-md-add add-button'),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_Participants$AddParticipantsClicked),
										_1: {ctor: '[]'}
									}
								},
								{ctor: '[]'}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$span,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_Participants$AddParticipantsClicked),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: _elm_lang$html$Html$text(session.i18n.inviteParticipants),
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Views_Participants$assessments = F2(
	function (session, assessmentItems) {
		var myAssessments = A2(
			_elm_lang$core$List$sortBy,
			function (x) {
				return _elm_lang$core$String$toUpper(x.id);
			},
			assessmentItems);
		var toDisplay = function (date) {
			var _p2 = date;
			if (_p2.ctor === 'Just') {
				var _p3 = _p2._0;
				return A4(
					_rluiten$elm_date_extra$Date_Extra_Format$formatOffset,
					session.i18n.dateFormatConfig,
					_rluiten$elm_date_extra$Date_Extra_Create$getTimezoneOffset(_p3),
					session.i18n.dateFormatConfig.format.longDate,
					_p3);
			} else {
				return session.i18n.pending;
			}
		};
		var toRow = function (item) {
			return A2(
				_elm_lang$html$Html$li,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('c-assessments__row'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$img,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('c-assessments__image'),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$src(
									_user$project$Views_ReportImageMap$path(item.id)),
								_1: {ctor: '[]'}
							}
						},
						{ctor: '[]'}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$h3,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('c-assessments__text'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(item.id),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$span,
								{ctor: '[]'},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text(
										toDisplay(item.date)),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}
					}
				});
		};
		return A2(
			_elm_lang$html$Html$section,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('c-assessments'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('c-title-phrase'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$span,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('c-title-phrase__text'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(session.i18n.assessments),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$span,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('c-title-phrase__text'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text(session.i18n.status),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$ul,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('u-zero-inset'),
							_1: {ctor: '[]'}
						},
						A2(_elm_lang$core$List$map, toRow, myAssessments)),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Views_Participants$emptyTextIf = F2(
	function (predicate, origin) {
		return predicate ? _elm_lang$html$Html$text('') : origin;
	});
var _user$project$Views_Participants$editParticipant = F2(
	function (participant, session) {
		var validityModifier = function (rslt) {
			return (!_elm_lang$core$Native_Utils.eq(
				rslt,
				_elm_lang$core$Result$Ok(
					{ctor: '_Tuple0'}))) ? ' c-demographics__input--invalid' : '';
		};
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('c-demographics o-media-object'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$i,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('o-media-object__media ion-md-contact'),
						_1: {ctor: '[]'}
					},
					{ctor: '[]'}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('o-media-object__heading'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$input,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class(
										A2(
											_elm_lang$core$Basics_ops['++'],
											'c-demographics__input c-demographics__input',
											validityModifier(
												A2(_user$project$Request_Participant$isFirstNameValid, session, participant)))),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$type_('text'),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$value(participant.firstName),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html_Events$onInput(_user$project$Page_Participants$UpdateFirstName),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$placeholder(session.i18n.firstName),
													_1: {ctor: '[]'}
												}
											}
										}
									}
								},
								{ctor: '[]'}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$input,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class(
											A2(
												_elm_lang$core$Basics_ops['++'],
												'c-demographics__input c-demographics__input',
												validityModifier(
													A2(_user$project$Request_Participant$isLastNameValid, session, participant)))),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$type_('text'),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$value(participant.lastName),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Events$onInput(_user$project$Page_Participants$UpdateLastName),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$placeholder(session.i18n.lastName),
														_1: {ctor: '[]'}
													}
												}
											}
										}
									},
									{ctor: '[]'}),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$input,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class(
												A2(
													_elm_lang$core$Basics_ops['++'],
													'c-demographics__input',
													validityModifier(
														A2(_user$project$Request_Participant$isEmailValid, session, participant)))),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$type_('email'),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$value(participant.email),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Events$onInput(_user$project$Page_Participants$UpdateEmail),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$placeholder(session.i18n.emailAddress),
															_1: {ctor: '[]'}
														}
													}
												}
											}
										},
										{ctor: '[]'}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$input,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('c-demographics__input'),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$type_('text'),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$value(participant.uniqueId),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Events$onInput(_user$project$Page_Participants$UpdateUniqueId),
															_1: {
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$placeholder(session.i18n.uniqueIdWithOctothorpe),
																_1: {ctor: '[]'}
															}
														}
													}
												}
											},
											{ctor: '[]'}),
										_1: {
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$span,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class('c-demographics__field'),
													_1: {ctor: '[]'}
												},
												{
													ctor: '::',
													_0: _elm_lang$html$Html$text(
														A2(_elm_lang$core$Basics_ops['++'], session.i18n.hoganIdWithOctothorpe, participant.id)),
													_1: {ctor: '[]'}
												}),
											_1: {
												ctor: '::',
												_0: function () {
													var _p4 = A2(_user$project$Request_Participant$isValid, session, participant);
													if (_p4.ctor === 'Ok') {
														return _elm_lang$html$Html$text('');
													} else {
														return A2(
															_elm_lang$html$Html$div,
															{ctor: '[]'},
															{
																ctor: '::',
																_0: A2(
																	_elm_lang$html$Html$span,
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$class('c-demographics__error'),
																		_1: {ctor: '[]'}
																	},
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html$text(_p4._0),
																		_1: {ctor: '[]'}
																	}),
																_1: {ctor: '[]'}
															});
													}
												}(),
												_1: {
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$div,
														{ctor: '[]'},
														{
															ctor: '::',
															_0: A2(
																_user$project$Views_Participants$emptyTextIf,
																session.readOnly,
																A2(
																	_elm_lang$html$Html$span,
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$class('c-demographics__button c-demographics__button c-demographics__button--default'),
																		_1: {
																			ctor: '::',
																			_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_Participants$SaveParticipant),
																			_1: {ctor: '[]'}
																		}
																	},
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html$text(session.i18n.save),
																		_1: {ctor: '[]'}
																	})),
															_1: {
																ctor: '::',
																_0: A2(
																	_elm_lang$html$Html$span,
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$class('c-demographics__button c-demographics__button'),
																		_1: {
																			ctor: '::',
																			_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_Participants$CancelEdit),
																			_1: {ctor: '[]'}
																		}
																	},
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html$text(session.i18n.cancel),
																		_1: {ctor: '[]'}
																	}),
																_1: {ctor: '[]'}
															}
														}),
													_1: {ctor: '[]'}
												}
											}
										}
									}
								}
							}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _user$project$Views_Participants$demographics = F4(
	function (session, participant, assessments, alert) {
		var resendMsg = function (msg) {
			return A2(
				_elm_lang$html$Html$span,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('c-demographics__button c-demographics__button'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text(msg),
					_1: {ctor: '[]'}
				});
		};
		var resendButton = A2(
			_elm_lang$html$Html$span,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('c-demographics__button c-demographics__button'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_Participants$EmailParticipant),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: participant.passwordSetByUser ? _elm_lang$html$Html$text(session.i18n.sendReminder) : _elm_lang$html$Html$text(session.i18n.resendInvitation),
				_1: {ctor: '[]'}
			});
		var selectResendElement = F2(
			function (id, msg) {
				return _elm_lang$core$Native_Utils.eq(participant.id, id) ? resendMsg(msg) : resendButton;
			});
		var fullName = _elm_lang$core$String$trim(
			A2(
				_elm_lang$core$Basics_ops['++'],
				_elm_lang$core$String$trim(participant.firstName),
				A2(
					_elm_lang$core$Basics_ops['++'],
					' ',
					_elm_lang$core$String$trim(participant.lastName))));
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('c-demographics o-media-object'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$i,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('o-media-object__media ion-md-contact'),
						_1: {ctor: '[]'}
					},
					{ctor: '[]'}),
				_1: {
					ctor: '::',
					_0: A2(
						_user$project$Views_Participants$emptyTextIf,
						_elm_lang$core$Native_Utils.eq(fullName, ''),
						A2(
							_elm_lang$html$Html$span,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('c-demographics__field c-demographics__field--emphasis o-media-object__heading'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(fullName),
								_1: {ctor: '[]'}
							})),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('o-media-object__content'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_user$project$Views_Participants$emptyTextIf,
									_elm_lang$core$Native_Utils.eq(participant.email, ''),
									A2(
										_elm_lang$html$Html$span,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('c-demographics__field'),
											_1: {ctor: '[]'}
										},
										{
											ctor: '::',
											_0: _elm_lang$html$Html$text(participant.email),
											_1: {ctor: '[]'}
										})),
								_1: {
									ctor: '::',
									_0: A2(
										_user$project$Views_Participants$emptyTextIf,
										_elm_lang$core$Native_Utils.eq(participant.email, ''),
										A2(
											_elm_lang$html$Html$br,
											{ctor: '[]'},
											{ctor: '[]'})),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$span,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('c-demographics__field'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: _elm_lang$html$Html$text(
													A2(_elm_lang$core$Basics_ops['++'], session.i18n.hoganIdWithOctothorpe, participant.id)),
												_1: {ctor: '[]'}
											}),
										_1: {
											ctor: '::',
											_0: A2(
												_user$project$Views_Participants$emptyTextIf,
												_elm_lang$core$Native_Utils.eq(participant.uniqueId, ''),
												A2(
													_elm_lang$html$Html$span,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class('c-demographics__field'),
														_1: {ctor: '[]'}
													},
													{
														ctor: '::',
														_0: _elm_lang$html$Html$text(
															A2(_elm_lang$core$Basics_ops['++'], session.i18n.uniqueIdWithOctothorpe, participant.uniqueId)),
														_1: {ctor: '[]'}
													})),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$br,
													{ctor: '[]'},
													{ctor: '[]'}),
												_1: {
													ctor: '::',
													_0: A2(
														_user$project$Views_Participants$emptyTextIf,
														session.readOnly,
														A2(
															_elm_lang$html$Html$span,
															{
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$class('c-demographics__button c-demographics__button--default'),
																_1: {
																	ctor: '::',
																	_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_Participants$Edit),
																	_1: {ctor: '[]'}
																}
															},
															{
																ctor: '::',
																_0: _elm_lang$html$Html$text(session.i18n.edit),
																_1: {ctor: '[]'}
															})),
													_1: {
														ctor: '::',
														_0: A2(
															_user$project$Views_Participants$emptyTextIf,
															!A2(_user$project$Views_Participants$canInviteParticipant, participant, assessments),
															function () {
																var _p5 = alert;
																switch (_p5.ctor) {
																	case 'SentEmail':
																		return A2(selectResendElement, _p5._0.id, session.i18n.sent);
																	case 'SendError':
																		return A2(selectResendElement, _p5._0.id, session.i18n.failedToSend);
																	default:
																		return resendButton;
																}
															}()),
														_1: {ctor: '[]'}
													}
												}
											}
										}
									}
								}
							}),
						_1: {ctor: '[]'}
					}
				}
			});
	});
var _user$project$Views_Participants$reports = F4(
	function (session, participant, items, projectId) {
		var toRow = function (item) {
			return A2(
				_elm_lang$html$Html$li,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('c-reports__row'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$img,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('c-reports__image'),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$src(
									_user$project$Views_ReportImageMap$path(
										_user$project$Page_Participants$getId(item))),
								_1: {ctor: '[]'}
							}
						},
						{ctor: '[]'}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$h3,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('c-reports__text'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(
									_user$project$Page_Participants$getName(item)),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: function () {
								var _p6 = {
									ctor: '_Tuple2',
									_0: _user$project$Page_Participants$getStatus(item),
									_1: session.readOnly
								};
								_v4_2:
								do {
									if (_p6.ctor === '_Tuple2') {
										switch (_p6._0.ctor) {
											case 'Available':
												if (_p6._1 === false) {
													return A2(
														_elm_lang$html$Html$i,
														{
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$class(' c-reports__icon icon-md ion-md-refresh'),
															_1: {
																ctor: '::',
																_0: _elm_lang$html$Html_Events$onClick(
																	_user$project$Page_Participants$RescoreReport(
																		_user$project$Page_Participants$getId(item))),
																_1: {
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$title(session.i18n.rescoreReport),
																	_1: {ctor: '[]'}
																}
															}
														},
														{ctor: '[]'});
												} else {
													break _v4_2;
												}
											case 'Rescoring':
												return A2(
													_elm_lang$html$Html$i,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class('c-reports__icon icon-md ion-md-hourglass'),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$title(session.i18n.rescoreReportInProgress),
															_1: {ctor: '[]'}
														}
													},
													{ctor: '[]'});
											default:
												break _v4_2;
										}
									} else {
										break _v4_2;
									}
								} while(false);
								return _elm_lang$html$Html$text('');
							}(),
							_1: {
								ctor: '::',
								_0: A2(
									_user$project$Views_Participants$emptyTextIf,
									!_elm_lang$core$Native_Utils.eq(
										_user$project$Page_Participants$getStatus(item),
										_user$project$Request_ReportAPI$Available),
									A2(
										_elm_lang$html$Html$a,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$target('_blank'),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$download(true),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$href(
														A3(_user$project$Page_Participants$getDownloadUrl, item, participant.id, session)),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$title(session.i18n.downloadReport),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$class('c-reports__icon'),
															_1: {ctor: '[]'}
														}
													}
												}
											}
										},
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$i,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class('icon-md ion-md-download'),
													_1: {ctor: '[]'}
												},
												{ctor: '[]'}),
											_1: {ctor: '[]'}
										})),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$i,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$title(session.i18n.viewReportOptionsText),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('c-reports__icon icon-md ion-md-settings'),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Events$onClick(
														_user$project$Page_Participants$NavigateToParticipantReportSettings(item)),
													_1: {ctor: '[]'}
												}
											}
										},
										{ctor: '[]'}),
									_1: {ctor: '[]'}
								}
							}
						}
					}
				});
		};
		return A2(
			_elm_lang$html$Html$section,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('c-reports'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$h2,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('c-reports__title'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(session.i18n.reports),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$ul,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('u-zero-inset'),
							_1: {ctor: '[]'}
						},
						A2(
							_elm_lang$core$List$map,
							toRow,
							A2(
								_elm_lang$core$List$sortBy,
								function (_p7) {
									return _elm_lang$core$String$toUpper(
										_user$project$Page_Participants$getName(_p7));
								},
								items))),
					_1: {
						ctor: '::',
						_0: A2(
							_user$project$Views_Participants$emptyTextIf,
							session.readOnly,
							A2(
								_elm_lang$html$Html$div,
								{ctor: '[]'},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$a,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('c-reports__link'),
											_1: {
												ctor: '::',
												_0: _user$project$Route$href(
													A2(_user$project$Route$ParticipantReportSelection, projectId, participant.id)),
												_1: {ctor: '[]'}
											}
										},
										{
											ctor: '::',
											_0: _elm_lang$html$Html$text(session.i18n.modifyReports),
											_1: {ctor: '[]'}
										}),
									_1: {ctor: '[]'}
								})),
						_1: {ctor: '[]'}
					}
				}
			});
	});
var _user$project$Views_Participants$view = F2(
	function (model, session) {
		var downloadReportsUrl = A2(
			_elm_lang$core$Basics_ops['++'],
			session.reportFileService,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/',
				A2(
					_elm_lang$core$Basics_ops['++'],
					session.activeClient,
					A2(
						_elm_lang$core$Basics_ops['++'],
						'/',
						A2(
							_elm_lang$core$Basics_ops['++'],
							model.projectId,
							A2(_elm_lang$core$Basics_ops['++'], '/downloadallreports?access_token=', session.accessToken))))));
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('row o-flex-column u-flex-grow-1'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('c-participants-header container'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: function () {
							var _p8 = model.alert;
							switch (_p8.ctor) {
								case 'ParticipantsAddedAndInvitesSent':
									return A2(
										_elm_lang$html$Html$div,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('o-alert alert alert-success'),
											_1: {ctor: '[]'}
										},
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$span,
												{ctor: '[]'},
												{
													ctor: '::',
													_0: _elm_lang$html$Html$text(session.i18n.participantsHaveBeenAddedAndInvitationsSent),
													_1: {ctor: '[]'}
												}),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$button,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class('close'),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$type_('button'),
															_1: {
																ctor: '::',
																_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_Participants$DismissAlert),
																_1: {ctor: '[]'}
															}
														}
													},
													{
														ctor: '::',
														_0: A2(
															_elm_lang$html$Html$i,
															{
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$class('glyphicon glyphicon-remove'),
																_1: {ctor: '[]'}
															},
															{ctor: '[]'}),
														_1: {ctor: '[]'}
													}),
												_1: {ctor: '[]'}
											}
										});
								case 'SentEmail':
									return A2(
										_elm_lang$html$Html$div,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('o-alert o-alert--desktop-only alert alert-success'),
											_1: {ctor: '[]'}
										},
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$span,
												{ctor: '[]'},
												{
													ctor: '::',
													_0: _elm_lang$html$Html$text(
														A2(
															_user$project$Views_Interpolation$interpolate,
															session.i18n.emailSuccessfullySent,
															{
																ctor: '::',
																_0: _p8._0.email,
																_1: {ctor: '[]'}
															})),
													_1: {ctor: '[]'}
												}),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$button,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class('close'),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$type_('button'),
															_1: {
																ctor: '::',
																_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_Participants$DismissAlert),
																_1: {ctor: '[]'}
															}
														}
													},
													{
														ctor: '::',
														_0: A2(
															_elm_lang$html$Html$i,
															{
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$class('glyphicon glyphicon-remove'),
																_1: {ctor: '[]'}
															},
															{ctor: '[]'}),
														_1: {ctor: '[]'}
													}),
												_1: {ctor: '[]'}
											}
										});
								case 'SendError':
									return A2(
										_elm_lang$html$Html$div,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('o-alert o-alert--desktop-only alert alert-danger'),
											_1: {ctor: '[]'}
										},
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$span,
												{ctor: '[]'},
												{
													ctor: '::',
													_0: _elm_lang$html$Html$text(
														A2(
															_user$project$Views_Interpolation$interpolate,
															session.i18n.failedToSendEmail,
															{
																ctor: '::',
																_0: _p8._0.email,
																_1: {ctor: '[]'}
															})),
													_1: {ctor: '[]'}
												}),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$button,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class('close'),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$type_('button'),
															_1: {
																ctor: '::',
																_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_Participants$DismissAlert),
																_1: {ctor: '[]'}
															}
														}
													},
													{
														ctor: '::',
														_0: A2(
															_elm_lang$html$Html$i,
															{
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$class('glyphicon glyphicon-remove'),
																_1: {ctor: '[]'}
															},
															{ctor: '[]'}),
														_1: {ctor: '[]'}
													}),
												_1: {ctor: '[]'}
											}
										});
								default:
									return _elm_lang$html$Html$text('');
							}
						}(),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$h3,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('c-participants-header__text'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text(model.projectName),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('c-participants-toolbar inset-sm'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('container'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$a,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$target('_blank'),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$download(true),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$href(downloadReportsUrl),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$title(session.i18n.downloadReports),
														_1: {ctor: '[]'}
													}
												}
											}
										},
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$i,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class('icon-md ion-md-download inline-sm'),
													_1: {ctor: '[]'}
												},
												{ctor: '[]'}),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html$text(session.i18n.downloadReports),
												_1: {ctor: '[]'}
											}
										}),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('c-participants container u-flex-grow-1'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('c-participants__table'),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$table,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$id('js-participants__table'),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class('table table-hover hover nowrap'),
													_1: {
														ctor: '::',
														_0: A2(_elm_lang$html$Html_Attributes$attribute, 'data-project-id', model.projectId),
														_1: {ctor: '[]'}
													}
												}
											},
											{
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$thead,
													{ctor: '[]'},
													{
														ctor: '::',
														_0: A2(
															_elm_lang$html$Html$tr,
															{ctor: '[]'},
															{
																ctor: '::',
																_0: A2(
																	_elm_lang$html$Html$td,
																	{ctor: '[]'},
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html$text(session.i18n.firstName),
																		_1: {ctor: '[]'}
																	}),
																_1: {
																	ctor: '::',
																	_0: A2(
																		_elm_lang$html$Html$td,
																		{ctor: '[]'},
																		{
																			ctor: '::',
																			_0: _elm_lang$html$Html$text(session.i18n.lastName),
																			_1: {ctor: '[]'}
																		}),
																	_1: {
																		ctor: '::',
																		_0: A2(
																			_elm_lang$html$Html$td,
																			{ctor: '[]'},
																			{
																				ctor: '::',
																				_0: _elm_lang$html$Html$text(session.i18n.email),
																				_1: {ctor: '[]'}
																			}),
																		_1: {
																			ctor: '::',
																			_0: A2(
																				_elm_lang$html$Html$td,
																				{ctor: '[]'},
																				{
																					ctor: '::',
																					_0: _elm_lang$html$Html$text(session.i18n.completed),
																					_1: {ctor: '[]'}
																				}),
																			_1: {ctor: '[]'}
																		}
																	}
																}
															}),
														_1: {ctor: '[]'}
													}),
												_1: {
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$tbody,
														{ctor: '[]'},
														{ctor: '[]'}),
													_1: {ctor: '[]'}
												}
											}),
										_1: {ctor: '[]'}
									}),
								_1: {
									ctor: '::',
									_0: function () {
										var panelModifier = function () {
											var _p9 = model.state;
											switch (_p9.ctor) {
												case 'Selected':
													return ' c-participant-info';
												case 'Editing':
													return ' c-participant-info';
												default:
													return ' c-panel-placeholder';
											}
										}();
										return A2(
											_elm_lang$html$Html$div,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class(panelModifier),
												_1: {ctor: '[]'}
											},
											function () {
												var _p10 = model.state;
												switch (_p10.ctor) {
													case 'Selected':
														var _p11 = _p10._0;
														return {
															ctor: '::',
															_0: A2(
																_elm_lang$html$Html$i,
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$class('c-participant-info__close icon-lg ion-ios-close'),
																	_1: {
																		ctor: '::',
																		_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_Participants$DeselectParticipant),
																		_1: {ctor: '[]'}
																	}
																},
																{ctor: '[]'}),
															_1: {
																ctor: '::',
																_0: A4(_user$project$Views_Participants$demographics, session, _p11, model.assessments, model.alert),
																_1: {
																	ctor: '::',
																	_0: A4(
																		_user$project$Views_Participants$reports,
																		session,
																		_p11,
																		A2(
																			_elm_lang$core$List$filter,
																			function (x) {
																				return !_elm_lang$core$Native_Utils.eq(
																					_user$project$Page_Participants$getId(x),
																					'NRConfigureScoresXML');
																			},
																			_p10._1),
																		model.projectId),
																	_1: {
																		ctor: '::',
																		_0: A2(
																			_user$project$Views_Participants$assessments,
																			session,
																			A2(
																				_elm_lang$core$List$filter,
																				function (x) {
																					return _elm_lang$core$Native_Utils.eq(x.participantId, _p11.id);
																				},
																				model.assessments)),
																		_1: {ctor: '[]'}
																	}
																}
															}
														};
													case 'Editing':
														var _p12 = _p10._0;
														return {
															ctor: '::',
															_0: A2(
																_elm_lang$html$Html$i,
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$class('c-participant-info__close icon-lg ion-ios-close'),
																	_1: {
																		ctor: '::',
																		_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_Participants$DeselectParticipant),
																		_1: {ctor: '[]'}
																	}
																},
																{ctor: '[]'}),
															_1: {
																ctor: '::',
																_0: A2(_user$project$Views_Participants$editParticipant, _p12, session),
																_1: {
																	ctor: '::',
																	_0: A4(
																		_user$project$Views_Participants$reports,
																		session,
																		_p12,
																		A2(
																			_elm_lang$core$List$filter,
																			function (x) {
																				return !_elm_lang$core$Native_Utils.eq(
																					_user$project$Page_Participants$getId(x),
																					'NRConfigureScoresXML');
																			},
																			_p10._1),
																		model.projectId),
																	_1: {
																		ctor: '::',
																		_0: A2(
																			_user$project$Views_Participants$assessments,
																			session,
																			A2(
																				_elm_lang$core$List$filter,
																				function (x) {
																					return _elm_lang$core$Native_Utils.eq(x.participantId, _p12.id);
																				},
																				model.assessments)),
																		_1: {ctor: '[]'}
																	}
																}
															}
														};
													default:
														return {
															ctor: '::',
															_0: A2(
																_elm_lang$html$Html$img,
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$class('c-panel-placeholder__person'),
																	_1: {
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$src('/images/participantLogo.png'),
																		_1: {ctor: '[]'}
																	}
																},
																{ctor: '[]'}),
															_1: {
																ctor: '::',
																_0: A2(
																	_elm_lang$html$Html$span,
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$class('c-panel-placeholder__message'),
																		_1: {ctor: '[]'}
																	},
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html$text(session.i18n.inactive),
																		_1: {ctor: '[]'}
																	}),
																_1: {ctor: '[]'}
															}
														};
												}
											}());
									}(),
									_1: {ctor: '[]'}
								}
							}),
						_1: {ctor: '[]'}
					}
				}
			});
	});

var _user$project$Views_EmailNotifications$emailLineItem = F4(
	function (model, current, previous, session) {
		var checkForErrors = function (sub) {
			var _p0 = sub.state;
			if (_p0.ctor === 'HasError') {
				return _elm_lang$core$Native_Utils.eq(sub.id, current.id) ? false : true;
			} else {
				return false;
			}
		};
		var disableModification = session.readOnly ? true : A2(
			_elm_lang$core$List$any,
			checkForErrors,
			{
				ctor: '::',
				_0: model.subscriber1,
				_1: {
					ctor: '::',
					_0: model.subscriber2,
					_1: {
						ctor: '::',
						_0: model.subscriber3,
						_1: {
							ctor: '::',
							_0: model.subscriber4,
							_1: {ctor: '[]'}
						}
					}
				}
			});
		var lineItem = A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('notificationRow'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('emailOption'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$input,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$type_('email'),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('emailSpecified inline-edit valid'),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$placeholder(session.i18n.enterEmailAddress),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$id(
												A2(
													_elm_lang$core$Basics_ops['++'],
													'EmailAddress',
													_elm_lang$core$Basics$toString(current.id))),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$autocomplete(true),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$value(
														A2(_elm_lang$core$Maybe$withDefault, '', current.value)),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Events$onBlur(_user$project$Page_EmailNotifications$SubscriberChangeComplete),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Events$onInput(
																_user$project$Page_EmailNotifications$ChangeSubscriber(current)),
															_1: {
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$disabled(disableModification),
																_1: {ctor: '[]'}
															}
														}
													}
												}
											}
										}
									}
								}
							},
							{ctor: '[]'}),
						_1: {
							ctor: '::',
							_0: function () {
								var _p1 = _elm_lang$core$Native_Utils.eq(current.value, _elm_lang$core$Maybe$Nothing) || disableModification;
								if (_p1 === true) {
									return _elm_lang$html$Html$text('');
								} else {
									return A2(
										_elm_lang$html$Html$i,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('icon-md ion-ios-close clear-email-icon'),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html_Events$onClick(
													_user$project$Page_EmailNotifications$ClearSubscriber(current)),
												_1: {ctor: '[]'}
											}
										},
										{ctor: '[]'});
								}
							}(),
							_1: {ctor: '[]'}
						}
					}),
				_1: {
					ctor: '::',
					_0: function () {
						var _p2 = current.state;
						if (_p2.ctor === 'HasError') {
							if (_p2._0.ctor === 'Just') {
								var _p3 = _p2._0._0;
								switch (_p3.ctor) {
									case 'MultipleConsecutiveDots':
										return A2(
											_elm_lang$html$Html$span,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('field-validation-error'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: _elm_lang$html$Html$text(session.i18n.emailContainsDoubleDot),
												_1: {ctor: '[]'}
											});
									case 'NoDotAfterCommercialAt':
										return A2(
											_elm_lang$html$Html$span,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('field-validation-error'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: _elm_lang$html$Html$text(session.i18n.emailLacksDotInDomain),
												_1: {ctor: '[]'}
											});
									case 'TooLong':
										return A2(
											_elm_lang$html$Html$span,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('field-validation-error'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: _elm_lang$html$Html$text(session.i18n.emailTooLong),
												_1: {ctor: '[]'}
											});
									default:
										return A2(
											_elm_lang$html$Html$span,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('field-validation-error'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: _elm_lang$html$Html$text(session.i18n.emailInvalid),
												_1: {ctor: '[]'}
											});
								}
							} else {
								return A2(
									_elm_lang$html$Html$span,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('field-validation-error'),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: _elm_lang$html$Html$text(session.i18n.errorSavingEmail),
										_1: {ctor: '[]'}
									});
							}
						} else {
							return _elm_lang$html$Html$text('');
						}
					}(),
					_1: {ctor: '[]'}
				}
			});
		var _p4 = previous;
		if (_p4.ctor === 'Just') {
			var _p5 = _p4._0.value;
			if (_p5.ctor === 'Just') {
				return lineItem;
			} else {
				return _elm_lang$html$Html$text('');
			}
		} else {
			return lineItem;
		}
	});
var _user$project$Views_EmailNotifications$getEmailLineItems = F2(
	function (model, session) {
		var sortId = F2(
			function (id1, id2) {
				return (_elm_lang$core$Native_Utils.cmp(id1, id2) < 0) ? _elm_lang$core$Basics$LT : _elm_lang$core$Basics$GT;
			});
		var compare = F2(
			function (s1, s2) {
				var _p6 = {ctor: '_Tuple2', _0: s1.value, _1: s2.value};
				_v6_3:
				do {
					if (_p6.ctor === '_Tuple2') {
						if (_p6._0.ctor === 'Nothing') {
							if (_p6._1.ctor === 'Just') {
								return _elm_lang$core$Basics$GT;
							} else {
								return A2(sortId, s1.id, s2.id);
							}
						} else {
							if (_p6._1.ctor === 'Just') {
								return A2(sortId, s1.id, s2.id);
							} else {
								break _v6_3;
							}
						}
					} else {
						break _v6_3;
					}
				} while(false);
				return _elm_lang$core$Basics$LT;
			});
		var _p7 = function () {
			var _p8 = A2(
				_elm_lang$core$List$sortWith,
				compare,
				{
					ctor: '::',
					_0: model.subscriber1,
					_1: {
						ctor: '::',
						_0: model.subscriber2,
						_1: {
							ctor: '::',
							_0: model.subscriber3,
							_1: {
								ctor: '::',
								_0: model.subscriber4,
								_1: {ctor: '[]'}
							}
						}
					}
				});
			if (((((_p8.ctor === '::') && (_p8._1.ctor === '::')) && (_p8._1._1.ctor === '::')) && (_p8._1._1._1.ctor === '::')) && (_p8._1._1._1._1.ctor === '[]')) {
				return {ctor: '_Tuple4', _0: _p8._0, _1: _p8._1._0, _2: _p8._1._1._0, _3: _p8._1._1._1._0};
			} else {
				return {ctor: '_Tuple4', _0: model.subscriber1, _1: model.subscriber2, _2: model.subscriber3, _3: model.subscriber4};
			}
		}();
		var first = _p7._0;
		var second = _p7._1;
		var third = _p7._2;
		var fourth = _p7._3;
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$id('NotificationsBody'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A4(_user$project$Views_EmailNotifications$emailLineItem, model, first, _elm_lang$core$Maybe$Nothing, session),
				_1: {
					ctor: '::',
					_0: A4(
						_user$project$Views_EmailNotifications$emailLineItem,
						model,
						second,
						_elm_lang$core$Maybe$Just(first),
						session),
					_1: {
						ctor: '::',
						_0: A4(
							_user$project$Views_EmailNotifications$emailLineItem,
							model,
							third,
							_elm_lang$core$Maybe$Just(second),
							session),
						_1: {
							ctor: '::',
							_0: A4(
								_user$project$Views_EmailNotifications$emailLineItem,
								model,
								fourth,
								_elm_lang$core$Maybe$Just(third),
								session),
							_1: {ctor: '[]'}
						}
					}
				}
			});
	});
var _user$project$Views_EmailNotifications$view = F2(
	function (model, session) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$id('NotificationsSection'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$id('EmailDeliveryHeader'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$h4,
							{ctor: '[]'},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(session.i18n.notificationsFor),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$span,
								{ctor: '[]'},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text(session.i18n.notificationsMessage),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}
					}),
				_1: {
					ctor: '::',
					_0: A2(_user$project$Views_EmailNotifications$getEmailLineItems, model, session),
					_1: {ctor: '[]'}
				}
			});
	});

var _user$project$Views_GenerateIdsModal$view = F2(
	function (model, session) {
		var error = function () {
			var _p0 = model.state;
			if (_p0.ctor === 'Invalid') {
				return session.i18n.enterValueWithinRange;
			} else {
				return '';
			}
		}();
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$id('GenerateParticipants'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('elm-modal'),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$article,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('center-box'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$header,
							{ctor: '[]'},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(session.i18n.generateIds),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$article,
								{ctor: '[]'},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$label,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$for('Count'),
											_1: {ctor: '[]'}
										},
										{
											ctor: '::',
											_0: _elm_lang$html$Html$text(session.i18n.numberOfIdsToGenerate),
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$input,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$id('Count'),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$type_('number'),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$max('999'),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$min('1'),
															_1: {
																ctor: '::',
																_0: _elm_lang$html$Html_Events$onInput(_user$project$Page_GenerateIdsModal$CountChanged),
																_1: {
																	ctor: '::',
																	_0: _elm_community$html_extra$Html_Events_Extra$onEnter(_user$project$Page_GenerateIdsModal$Submit),
																	_1: {ctor: '[]'}
																}
															}
														}
													}
												}
											},
											{ctor: '[]'}),
										_1: {
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$div,
												{ctor: '[]'},
												{
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$span,
														{
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$class('errors'),
															_1: {ctor: '[]'}
														},
														{
															ctor: '::',
															_0: _elm_lang$html$Html$text(error),
															_1: {ctor: '[]'}
														}),
													_1: {ctor: '[]'}
												}),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$div,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class('actions'),
														_1: {ctor: '[]'}
													},
													{
														ctor: '::',
														_0: A2(
															_elm_lang$html$Html$button,
															{
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$id('Generate'),
																_1: {
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$type_('button'),
																	_1: {
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$class('btn btn-modal'),
																		_1: {
																			ctor: '::',
																			_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_GenerateIdsModal$Submit),
																			_1: {
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$disabled(model.requestInProgress),
																				_1: {ctor: '[]'}
																			}
																		}
																	}
																}
															},
															{
																ctor: '::',
																_0: _elm_lang$html$Html$text(session.i18n.ok),
																_1: {ctor: '[]'}
															}),
														_1: {
															ctor: '::',
															_0: A2(
																_elm_lang$html$Html$button,
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$type_('button'),
																	_1: {
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$class('btn btn-modal'),
																		_1: {
																			ctor: '::',
																			_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_GenerateIdsModal$Close),
																			_1: {
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$disabled(model.requestInProgress),
																				_1: {ctor: '[]'}
																			}
																		}
																	}
																},
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html$text(session.i18n.cancel),
																	_1: {ctor: '[]'}
																}),
															_1: {ctor: '[]'}
														}
													}),
												_1: {ctor: '[]'}
											}
										}
									}
								}),
							_1: {ctor: '[]'}
						}
					}),
				_1: {ctor: '[]'}
			});
	});

var _user$project$Views_ProjectDetail$viewToolbar = function (i18n) {
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('container flex flex-align-center'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$a,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('flex flex-align-center'),
					_1: {
						ctor: '::',
						_0: _user$project$Route$href(_user$project$Route$ProjectLibrary),
						_1: {ctor: '[]'}
					}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$i,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('flex icon-md ion-md-arrow-back inline-sm'),
							_1: {ctor: '[]'}
						},
						{ctor: '[]'}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$span,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('font-italic text-lowercase'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(i18n.backToProjectDashboard),
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					}
				}),
			_1: {ctor: '[]'}
		});
};
var _user$project$Views_ProjectDetail$viewModal = F2(
	function (model, session) {
		var _p0 = model.modal;
		if (_p0.ctor === 'Just') {
			if (_p0._0.ctor === 'GenerateIds') {
				var _p1 = _p0._0._0;
				return A2(
					_elm_lang$html$Html$map,
					_user$project$Page_ProjectDetail$GenerateIdsModalMsg(_p1),
					A2(_user$project$Views_GenerateIdsModal$view, _p1, session));
			} else {
				var _p2 = _p0._0._0;
				return A2(
					_elm_lang$html$Html$map,
					_user$project$Page_ProjectDetail$AddParticipantsModalMsg(_p2),
					A2(_user$project$Views_AddParticipantsModal$view, _p2, session));
			}
		} else {
			return _elm_lang$html$Html$text('');
		}
	});
var _user$project$Views_ProjectDetail$view = F2(
	function (model, session) {
		var _p3 = function () {
			var _p4 = model.project.isActive;
			if (_p4 === true) {
				return {ctor: '_Tuple2', _0: 'active', _1: session.i18n.active};
			} else {
				return {ctor: '_Tuple2', _0: 'draft', _1: session.i18n.draft};
			}
		}();
		var activeStatusClassQualifier = _p3._0;
		var activeStatusText = _p3._1;
		var authSecuredNameEditIcon = (session.readOnly || _elm_lang$core$Native_Utils.eq(
			_elm_lang$core$String$toUpper(model.project.name),
			'CONFIGURE')) ? _elm_lang$html$Html$text('') : A2(
			_elm_lang$html$Html$i,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('icon-md ion-ios-create editable'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_ProjectDetail$EditProjectNameClicked),
					_1: {ctor: '[]'}
				}
			},
			{ctor: '[]'});
		var hasReports = _elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$List$length(model.packages) + _elm_lang$core$List$length(model.reports),
			0) > 0;
		var participantCount = _elm_lang$core$List$length(model.participants);
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$id('ProjectDetail'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('container'),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: function () {
					var _p5 = model.alert;
					if (_p5.ctor === 'Just') {
						if (_p5._0.ctor === 'GeneratedIds') {
							return A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$id('Alert'),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('alert alert-success'),
										_1: {ctor: '[]'}
									}
								},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$span,
										{ctor: '[]'},
										{
											ctor: '::',
											_0: _elm_lang$html$Html$text(
												A2(
													_user$project$Views_Interpolation$interpolate,
													session.i18n.youHaveSuccessfullyGeneratedIds,
													{
														ctor: '::',
														_0: _elm_lang$core$Basics$toString(_p5._0._1),
														_1: {ctor: '[]'}
													})),
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$button,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('close'),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$type_('button'),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_ProjectDetail$DismissAlert),
														_1: {ctor: '[]'}
													}
												}
											},
											{
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$i,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class('glyphicon glyphicon-remove'),
														_1: {ctor: '[]'}
													},
													{ctor: '[]'}),
												_1: {ctor: '[]'}
											}),
										_1: {
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$button,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$id('DownloadNewIds'),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class('btn btn-success'),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Events$onClick(
																_user$project$Page_ProjectDetail$DownloadIdsBatch(_p5._0._0)),
															_1: {ctor: '[]'}
														}
													}
												},
												{
													ctor: '::',
													_0: _elm_lang$html$Html$text(session.i18n.download),
													_1: {ctor: '[]'}
												}),
											_1: {ctor: '[]'}
										}
									}
								});
						} else {
							return A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$id('Alert'),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('alert alert-success'),
										_1: {ctor: '[]'}
									}
								},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$span,
										{ctor: '[]'},
										{
											ctor: '::',
											_0: _elm_lang$html$Html$text(session.i18n.participantsHaveBeenAddedAndInvitationsSent),
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$button,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('close'),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$type_('button'),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_ProjectDetail$DismissAlert),
														_1: {ctor: '[]'}
													}
												}
											},
											{
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$i,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class('glyphicon glyphicon-remove'),
														_1: {ctor: '[]'}
													},
													{ctor: '[]'}),
												_1: {ctor: '[]'}
											}),
										_1: {
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$a,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class('alert-link'),
													_1: {
														ctor: '::',
														_0: _user$project$Route$href(
															_user$project$Route$Participants(model.project.id)),
														_1: {ctor: '[]'}
													}
												},
												{
													ctor: '::',
													_0: _elm_lang$html$Html$text(session.i18n.goToParticipantsPage),
													_1: {ctor: '[]'}
												}),
											_1: {ctor: '[]'}
										}
									}
								});
						}
					} else {
						return _elm_lang$html$Html$text('');
					}
				}(),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$section,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{ctor: '[]'},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$h1,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$id('ProjectTitle'),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('authEditProjectName'),
												_1: {
													ctor: '::',
													_0: A2(_elm_lang$html$Html_Attributes$attribute, 'data-project-id', model.project.id),
													_1: {
														ctor: '::',
														_0: A2(_elm_lang$html$Html_Attributes$attribute, 'data-project-name', model.project.name),
														_1: {ctor: '[]'}
													}
												}
											}
										},
										{
											ctor: '::',
											_0: _elm_lang$html$Html$text(model.project.name),
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: authSecuredNameEditIcon,
										_1: {ctor: '[]'}
									}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									{ctor: '[]'},
									{
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$div,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$id('ProjectStatus'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$i,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class(
															A2(_elm_lang$core$Basics_ops['++'], 'circle color-', activeStatusClassQualifier)),
														_1: {ctor: '[]'}
													},
													{ctor: '[]'}),
												_1: {
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$span,
														{
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$class('h4'),
															_1: {ctor: '[]'}
														},
														{
															ctor: '::',
															_0: _elm_lang$html$Html$text(activeStatusText),
															_1: {ctor: '[]'}
														}),
													_1: {ctor: '[]'}
												}
											}),
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$section,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$id('Participants'),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('section'),
									_1: {ctor: '[]'}
								}
							},
							{
								ctor: '::',
								_0: function () {
									var _p6 = {
										ctor: '_Tuple2',
										_0: _elm_lang$core$Native_Utils.cmp(participantCount, 0) > 0,
										_1: hasReports
									};
									if (_p6._0 === true) {
										return A2(
											_elm_lang$html$Html$div,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$id('ActiveParticipantsBlock'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$h4,
													{ctor: '[]'},
													{
														ctor: '::',
														_0: _elm_lang$html$Html$text(session.i18n.participantStatus),
														_1: {ctor: '[]'}
													}),
												_1: {
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$div,
														{
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$class('section-block'),
															_1: {ctor: '[]'}
														},
														A2(
															F2(
																function (x, y) {
																	return A2(_elm_lang$core$Basics_ops['++'], x, y);
																}),
															{
																ctor: '::',
																_0: A2(
																	_elm_lang$html$Html$div,
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$class('header'),
																		_1: {ctor: '[]'}
																	},
																	{
																		ctor: '::',
																		_0: A2(
																			_elm_lang$html$Html$a,
																			{
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$id('ParticipantsLink'),
																				_1: {
																					ctor: '::',
																					_0: _user$project$Route$href(
																						_user$project$Route$Participants(model.project.id)),
																					_1: {ctor: '[]'}
																				}
																			},
																			{
																				ctor: '::',
																				_0: A2(
																					_elm_lang$html$Html$h1,
																					{ctor: '[]'},
																					{
																						ctor: '::',
																						_0: _elm_lang$html$Html$text(
																							A2(
																								_elm_lang$core$Basics_ops['++'],
																								_elm_lang$core$Basics$toString(
																									_elm_lang$core$List$length(model.participants)),
																								A2(_elm_lang$core$Basics_ops['++'], ' ', session.i18n.participants))),
																						_1: {ctor: '[]'}
																					}),
																				_1: {
																					ctor: '::',
																					_0: A2(
																						_elm_lang$html$Html$i,
																						{
																							ctor: '::',
																							_0: _elm_lang$html$Html_Attributes$class('icon-lg ion-ios-arrow-forward'),
																							_1: {
																								ctor: '::',
																								_0: A2(_elm_lang$html$Html_Attributes$attribute, 'aria-hidden', 'true'),
																								_1: {ctor: '[]'}
																							}
																						},
																						{ctor: '[]'}),
																					_1: {ctor: '[]'}
																				}
																			}),
																		_1: {ctor: '[]'}
																	}),
																_1: {
																	ctor: '::',
																	_0: A2(
																		_elm_lang$html$Html$hr,
																		{ctor: '[]'},
																		{ctor: '[]'}),
																	_1: {ctor: '[]'}
																}
															},
															_elm_lang$core$Native_Utils.eq(hasReports, false) ? {
																ctor: '::',
																_0: _elm_lang$html$Html$text(session.i18n.youMustAddReports),
																_1: {ctor: '[]'}
															} : {
																ctor: '::',
																_0: (session.readOnly || _elm_lang$core$Native_Utils.eq(hasReports, false)) ? _elm_lang$html$Html$text('') : A2(
																	_elm_lang$html$Html$button,
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$id('AddParticipantsButton'),
																		_1: {
																			ctor: '::',
																			_0: _elm_lang$html$Html_Attributes$class('btn btn-green'),
																			_1: {
																				ctor: '::',
																				_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_ProjectDetail$AddParticipantsClicked),
																				_1: {
																					ctor: '::',
																					_0: _elm_lang$html$Html_Attributes$title(session.i18n.inviteParticipants),
																					_1: {ctor: '[]'}
																				}
																			}
																		}
																	},
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html$text(session.i18n.inviteParticipants),
																		_1: {ctor: '[]'}
																	}),
																_1: {
																	ctor: '::',
																	_0: (session.readOnly || _elm_lang$core$Native_Utils.eq(hasReports, false)) ? _elm_lang$html$Html$text('') : A2(
																		_elm_lang$html$Html$button,
																		{
																			ctor: '::',
																			_0: _elm_lang$html$Html_Attributes$id('GenerateIdsButton'),
																			_1: {
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$class('btn btn-dark-blue'),
																				_1: {
																					ctor: '::',
																					_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_ProjectDetail$GenerateIdsClicked),
																					_1: {
																						ctor: '::',
																						_0: _elm_lang$html$Html_Attributes$title(session.i18n.generateIdsTitle),
																						_1: {ctor: '[]'}
																					}
																				}
																			}
																		},
																		{
																			ctor: '::',
																			_0: _elm_lang$html$Html$text(session.i18n.generateNewIds),
																			_1: {ctor: '[]'}
																		}),
																	_1: {
																		ctor: '::',
																		_0: (session.readOnly || _elm_lang$core$Native_Utils.eq(model.unclaimedIdCount, 0)) ? _elm_lang$html$Html$text('') : A2(
																			_elm_lang$html$Html$a,
																			{
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$id('DownloadIdsButton'),
																				_1: {
																					ctor: '::',
																					_0: _elm_lang$html$Html_Attributes$href(
																						A2(
																							_elm_lang$core$Basics_ops['++'],
																							session.haloLiteApi,
																							A2(
																								_elm_lang$core$Basics_ops['++'],
																								'/projects/',
																								A2(
																									_elm_lang$core$Basics_ops['++'],
																									model.project.id,
																									A2(
																										_elm_lang$core$Basics_ops['++'],
																										'/unclaimed-ids/csv',
																										A2(
																											_elm_lang$core$Basics_ops['++'],
																											'?access_token=',
																											A2(
																												_elm_lang$core$Basics_ops['++'],
																												session.accessToken,
																												A2(_elm_lang$core$Basics_ops['++'], '&activeClient=', session.activeClient)))))))),
																					_1: {ctor: '[]'}
																				}
																			},
																			{
																				ctor: '::',
																				_0: _elm_lang$html$Html$text(
																					A2(
																						_elm_lang$core$Basics_ops['++'],
																						session.i18n.downloadUnusedIds,
																						A2(
																							_elm_lang$core$Basics_ops['++'],
																							' ',
																							A2(
																								_elm_lang$core$Basics_ops['++'],
																								'(',
																								A2(
																									_elm_lang$core$Basics_ops['++'],
																									_elm_lang$core$Basics$toString(model.unclaimedIdCount),
																									')'))))),
																				_1: {ctor: '[]'}
																			}),
																		_1: {ctor: '[]'}
																	}
																}
															})),
													_1: {ctor: '[]'}
												}
											});
									} else {
										if (_p6._1 === true) {
											return A2(
												_elm_lang$html$Html$div,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$id('DraftProjectParticipants'),
													_1: {ctor: '[]'}
												},
												session.readOnly ? {ctor: '[]'} : {
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$div,
														{
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$class('flex flex-align-center'),
															_1: {ctor: '[]'}
														},
														{
															ctor: '::',
															_0: A2(
																_elm_lang$html$Html$button,
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$id('AddParticipantsButton'),
																	_1: {
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$class('btn btn-green'),
																		_1: {
																			ctor: '::',
																			_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_ProjectDetail$AddParticipantsClicked),
																			_1: {
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$title(session.i18n.inviteParticipants),
																				_1: {ctor: '[]'}
																			}
																		}
																	}
																},
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html$text(session.i18n.inviteParticipants),
																	_1: {ctor: '[]'}
																}),
															_1: {
																ctor: '::',
																_0: A2(
																	_elm_lang$html$Html$button,
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$id('GenerateIdsButton'),
																		_1: {
																			ctor: '::',
																			_0: _elm_lang$html$Html_Attributes$class('btn btn-dark-blue'),
																			_1: {
																				ctor: '::',
																				_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_ProjectDetail$GenerateIdsClicked),
																				_1: {
																					ctor: '::',
																					_0: _elm_lang$html$Html_Attributes$title(session.i18n.generateIdsTitle),
																					_1: {ctor: '[]'}
																				}
																			}
																		}
																	},
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html$text(session.i18n.generateNewIds),
																		_1: {ctor: '[]'}
																	}),
																_1: {
																	ctor: '::',
																	_0: _elm_lang$core$Native_Utils.eq(model.unclaimedIdCount, 0) ? _elm_lang$html$Html$text('') : A2(
																		_elm_lang$html$Html$a,
																		{
																			ctor: '::',
																			_0: _elm_lang$html$Html_Attributes$id('DownloadIdsButton'),
																			_1: {
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$href(
																					A2(
																						_elm_lang$core$Basics_ops['++'],
																						session.haloLiteApi,
																						A2(
																							_elm_lang$core$Basics_ops['++'],
																							'/projects/',
																							A2(
																								_elm_lang$core$Basics_ops['++'],
																								model.project.id,
																								A2(
																									_elm_lang$core$Basics_ops['++'],
																									'/unclaimed-ids/csv',
																									A2(
																										_elm_lang$core$Basics_ops['++'],
																										'?access_token=',
																										A2(
																											_elm_lang$core$Basics_ops['++'],
																											session.accessToken,
																											A2(_elm_lang$core$Basics_ops['++'], '&activeClient=', session.activeClient)))))))),
																				_1: {ctor: '[]'}
																			}
																		},
																		{
																			ctor: '::',
																			_0: _elm_lang$html$Html$text(
																				A2(
																					_elm_lang$core$Basics_ops['++'],
																					session.i18n.downloadUnusedIds,
																					A2(
																						_elm_lang$core$Basics_ops['++'],
																						' ',
																						A2(
																							_elm_lang$core$Basics_ops['++'],
																							'(',
																							A2(
																								_elm_lang$core$Basics_ops['++'],
																								_elm_lang$core$Basics$toString(model.unclaimedIdCount),
																								')'))))),
																			_1: {ctor: '[]'}
																		}),
																	_1: {ctor: '[]'}
																}
															}
														}),
													_1: {
														ctor: '::',
														_0: A2(
															_elm_lang$html$Html$h4,
															{
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$class('xs'),
																_1: {ctor: '[]'}
															},
															{
																ctor: '::',
																_0: _elm_lang$html$Html$text(session.i18n.addParticipantsToStartProject),
																_1: {ctor: '[]'}
															}),
														_1: {ctor: '[]'}
													}
												});
										} else {
											return _elm_lang$html$Html$text('');
										}
									}
								}(),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$section,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('section'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$h4,
										{ctor: '[]'},
										{
											ctor: '::',
											_0: _elm_lang$html$Html$text(session.i18n.reports),
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$div,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('flex'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$div,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$id('ProjectReports'),
														_1: {ctor: '[]'}
													},
													function () {
														var toReportCard = function (_p7) {
															var _p8 = _p7;
															var _p14 = _p8._3;
															var _p13 = _p8._1;
															var _p12 = _p8._2;
															var _p11 = _p8._5;
															var languageDisplayText = A2(
																_elm_lang$core$Maybe$withDefault,
																_p12,
																A2(_elm_lang$core$Dict$get, _p12, session.i18n.languages));
															var divSettings = session.readOnly ? _elm_lang$html$Html$div(
																{
																	ctor: '::',
																	_0: A2(_elm_lang$html$Html_Attributes$attribute, 'data-test-id', 'settings-content'),
																	_1: {ctor: '[]'}
																}) : _elm_lang$html$Html$div(
																{
																	ctor: '::',
																	_0: A2(_elm_lang$html$Html_Attributes$attribute, 'data-test-id', 'settings-content'),
																	_1: {
																		ctor: '::',
																		_0: _elm_lang$html$Html_Events$onClick(_p11),
																		_1: {ctor: '[]'}
																	}
																});
															return A2(
																_elm_lang$html$Html$div,
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$class('report-card'),
																	_1: {ctor: '[]'}
																},
																{
																	ctor: '::',
																	_0: A2(
																		_elm_lang$html$Html$div,
																		{
																			ctor: '::',
																			_0: _elm_lang$html$Html_Attributes$class('card-header'),
																			_1: {
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$title(_p13),
																				_1: {ctor: '[]'}
																			}
																		},
																		{
																			ctor: '::',
																			_0: A2(
																				_elm_lang$html$Html$span,
																				{ctor: '[]'},
																				{
																					ctor: '::',
																					_0: _elm_lang$html$Html$text(_p13),
																					_1: {ctor: '[]'}
																				}),
																			_1: {
																				ctor: '::',
																				_0: A2(
																					_elm_lang$html$Html$img,
																					{
																						ctor: '::',
																						_0: _elm_lang$html$Html_Attributes$src(
																							_user$project$Views_ReportImageMap$path(_p8._0)),
																						_1: {
																							ctor: '::',
																							_0: _elm_lang$html$Html_Attributes$class('img-responsive'),
																							_1: {ctor: '[]'}
																						}
																					},
																					{ctor: '[]'}),
																				_1: {ctor: '[]'}
																			}
																		}),
																	_1: {
																		ctor: '::',
																		_0: session.readOnly ? A2(
																			_elm_lang$html$Html$div,
																			{
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$class('card-setting'),
																				_1: {ctor: '[]'}
																			},
																			{
																				ctor: '::',
																				_0: A2(
																					_elm_lang$html$Html$span,
																					{ctor: '[]'},
																					{
																						ctor: '::',
																						_0: _elm_lang$html$Html$text(session.i18n.settings),
																						_1: {ctor: '[]'}
																					}),
																				_1: {ctor: '[]'}
																			}) : A2(
																			_elm_lang$html$Html$div,
																			{
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$class('card-setting'),
																				_1: {
																					ctor: '::',
																					_0: _elm_lang$html$Html_Events$onClick(_p11),
																					_1: {ctor: '[]'}
																				}
																			},
																			{
																				ctor: '::',
																				_0: A2(
																					_elm_lang$html$Html$span,
																					{ctor: '[]'},
																					{
																						ctor: '::',
																						_0: _elm_lang$html$Html$text(session.i18n.settings),
																						_1: {ctor: '[]'}
																					}),
																				_1: {
																					ctor: '::',
																					_0: A2(
																						_elm_lang$html$Html$button,
																						{
																							ctor: '::',
																							_0: _elm_lang$html$Html_Attributes$class('ReportOptions'),
																							_1: {ctor: '[]'}
																						},
																						{
																							ctor: '::',
																							_0: A2(
																								_elm_lang$html$Html$i,
																								{
																									ctor: '::',
																									_0: _elm_lang$html$Html_Attributes$class('icon-md ion-md-settings'),
																									_1: {ctor: '[]'}
																								},
																								{ctor: '[]'}),
																							_1: {ctor: '[]'}
																						}),
																					_1: {ctor: '[]'}
																				}
																			}),
																		_1: {
																			ctor: '::',
																			_0: divSettings(
																				{
																					ctor: '::',
																					_0: A2(
																						_elm_lang$html$Html$div,
																						{
																							ctor: '::',
																							_0: _elm_lang$html$Html_Attributes$class('card-option-lang'),
																							_1: {
																								ctor: '::',
																								_0: _elm_lang$html$Html_Attributes$title(languageDisplayText),
																								_1: {ctor: '[]'}
																							}
																						},
																						{
																							ctor: '::',
																							_0: A2(
																								_elm_lang$html$Html$i,
																								{
																									ctor: '::',
																									_0: _elm_lang$html$Html_Attributes$class('icon-md ion-md-chatbubbles'),
																									_1: {ctor: '[]'}
																								},
																								{ctor: '[]'}),
																							_1: {
																								ctor: '::',
																								_0: A2(
																									_elm_lang$html$Html$span,
																									{ctor: '[]'},
																									{
																										ctor: '::',
																										_0: _elm_lang$html$Html$text(languageDisplayText),
																										_1: {ctor: '[]'}
																									}),
																								_1: {ctor: '[]'}
																							}
																						}),
																					_1: {
																						ctor: '::',
																						_0: A2(
																							_elm_lang$html$Html$div,
																							{
																								ctor: '::',
																								_0: _elm_lang$html$Html_Attributes$class('card-option-norm'),
																								_1: {
																									ctor: '::',
																									_0: _elm_lang$html$Html_Attributes$title(_p14),
																									_1: {ctor: '[]'}
																								}
																							},
																							{
																								ctor: '::',
																								_0: A2(
																									_elm_lang$html$Html$i,
																									{
																										ctor: '::',
																										_0: _elm_lang$html$Html_Attributes$class('icon-md ion-ios-stats'),
																										_1: {ctor: '[]'}
																									},
																									{ctor: '[]'}),
																								_1: {
																									ctor: '::',
																									_0: A2(
																										_elm_lang$html$Html$span,
																										{ctor: '[]'},
																										{
																											ctor: '::',
																											_0: _elm_lang$html$Html$text(_p14),
																											_1: {ctor: '[]'}
																										}),
																									_1: {ctor: '[]'}
																								}
																							}),
																						_1: {
																							ctor: '::',
																							_0: function () {
																								var _p9 = _p8._4;
																								if (_p9.ctor === 'Just') {
																									var _p10 = _p9._0;
																									return A2(
																										_elm_lang$html$Html$div,
																										{
																											ctor: '::',
																											_0: _elm_lang$html$Html_Attributes$class('card-option-job-profile'),
																											_1: {
																												ctor: '::',
																												_0: _elm_lang$html$Html_Attributes$title(_p10),
																												_1: {ctor: '[]'}
																											}
																										},
																										{
																											ctor: '::',
																											_0: A2(
																												_elm_lang$html$Html$i,
																												{
																													ctor: '::',
																													_0: _elm_lang$html$Html_Attributes$class('icon-md ion-ios-analytics'),
																													_1: {ctor: '[]'}
																												},
																												{ctor: '[]'}),
																											_1: {
																												ctor: '::',
																												_0: A2(
																													_elm_lang$html$Html$span,
																													{ctor: '[]'},
																													{
																														ctor: '::',
																														_0: _elm_lang$html$Html$text(_p10),
																														_1: {ctor: '[]'}
																													}),
																												_1: {ctor: '[]'}
																											}
																										});
																								} else {
																									return _elm_lang$html$Html$text('');
																								}
																							}(),
																							_1: {ctor: '[]'}
																						}
																					}
																				}),
																			_1: {ctor: '[]'}
																		}
																	}
																});
														};
														var packages = A2(
															_elm_lang$core$List$map,
															function (x) {
																return {
																	ctor: '_Tuple6',
																	_0: x.id,
																	_1: x.name,
																	_2: x.language,
																	_3: x.norm,
																	_4: x.jobProfile,
																	_5: _user$project$Page_ProjectDetail$PackageSettingsClicked(x.id)
																};
															},
															model.packages);
														var reports = A2(
															_elm_lang$core$List$map,
															function (x) {
																return {
																	ctor: '_Tuple6',
																	_0: x.id,
																	_1: x.name,
																	_2: x.language,
																	_3: x.norm,
																	_4: x.jobProfile,
																	_5: _user$project$Page_ProjectDetail$ReportSettingsClicked(x.id)
																};
															},
															model.reports);
														var editReportsOrNah = function () {
															if (session.readOnly) {
																return _elm_lang$html$Html$text('');
															} else {
																var btnClass = _elm_lang$core$List$isEmpty(model.reports) ? 'btn-green' : 'btn-dark-blue';
																return A2(
																	_elm_lang$html$Html$div,
																	{ctor: '[]'},
																	{
																		ctor: '::',
																		_0: A2(
																			_elm_lang$html$Html$button,
																			{
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$class(
																					A2(_elm_lang$core$Basics_ops['++'], 'btn ', btnClass)),
																				_1: {
																					ctor: '::',
																					_0: _elm_lang$html$Html_Attributes$id('EditReportsButton'),
																					_1: {
																						ctor: '::',
																						_0: _elm_lang$html$Html_Events$onClick(
																							_user$project$Page_ProjectDetail$EditReportsButtonClicked(model.project.id)),
																						_1: {ctor: '[]'}
																					}
																				}
																			},
																			{
																				ctor: '::',
																				_0: _elm_lang$html$Html$text(session.i18n.editReports),
																				_1: {ctor: '[]'}
																			}),
																		_1: {ctor: '[]'}
																	});
															}
														}();
														return A2(
															_elm_lang$core$List$append,
															A2(
																_elm_lang$core$List$map,
																toReportCard,
																A2(
																	_elm_lang$core$List$filter,
																	function (_p15) {
																		var _p16 = _p15;
																		return !_elm_lang$core$Native_Utils.eq(_p16._0, 'NRConfigureScoresXML');
																	},
																	A2(
																		_elm_lang$core$List$sortBy,
																		function (_p17) {
																			var _p18 = _p17;
																			return _elm_lang$core$String$toUpper(_p18._1);
																		},
																		A2(_elm_lang$core$List$append, reports, packages)))),
															{
																ctor: '::',
																_0: editReportsOrNah,
																_1: {ctor: '[]'}
															});
													}()),
												_1: {ctor: '[]'}
											}),
										_1: {ctor: '[]'}
									}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$section,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$id('Notifications'),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('section'),
											_1: {ctor: '[]'}
										}
									},
									{
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$map,
											_user$project$Page_ProjectDetail$EmailSectionMsg,
											A2(_user$project$Views_EmailNotifications$view, model.emailSection, session)),
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							}
						}
					}
				}
			});
	});

var _user$project$Views_DateTimeMessageBuilder$createRelativeTimeMessage = F3(
	function (created, now, i18n) {
		var timeZoneOffset = _rluiten$elm_date_extra$Date_Extra_Create$getTimezoneOffset(now);
		var dateNowToGMT = A2(
			F2(
				function (x, y) {
					return x + y;
				}),
			_rluiten$elm_date_extra$Date_Extra_Core$ticksAMinute * timeZoneOffset,
			_rluiten$elm_date_extra$Date_Extra_Core$toTime(now));
		var delta = _elm_lang$core$Basics$toFloat(
			A2(
				F2(
					function (x, y) {
						return x - y;
					}),
				dateNowToGMT,
				_rluiten$elm_date_extra$Date_Extra_Core$toTime(created)));
		var convert = function (ticksPer) {
			return _elm_lang$core$Basics$round(
				A2(
					F2(
						function (x, y) {
							return x / y;
						}),
					delta,
					_elm_lang$core$Basics$toFloat(ticksPer)));
		};
		var seconds = convert(_rluiten$elm_date_extra$Date_Extra_Core$ticksASecond);
		var minutes = convert(_rluiten$elm_date_extra$Date_Extra_Core$ticksAMinute);
		var hours = convert(_rluiten$elm_date_extra$Date_Extra_Core$ticksAnHour);
		var days = convert(_rluiten$elm_date_extra$Date_Extra_Core$ticksADay);
		var weeks = convert(_rluiten$elm_date_extra$Date_Extra_Core$ticksAWeek);
		var convertWeeks = function (by) {
			return _elm_lang$core$Basics$round(
				A2(
					F2(
						function (x, y) {
							return x / y;
						}),
					delta,
					A2(
						F2(
							function (x, y) {
								return x * y;
							}),
						_elm_lang$core$Basics$toFloat(_rluiten$elm_date_extra$Date_Extra_Core$ticksAWeek),
						by)));
		};
		var months = convertWeeks(4.34);
		var years = convertWeeks(52.17);
		var relativeTime = (_elm_lang$core$Native_Utils.cmp(seconds, 44) < 1) ? i18n.aFewSecondsAgo : ((_elm_lang$core$Native_Utils.cmp(minutes, 1) < 1) ? i18n.oneMinuteAgo : ((_elm_lang$core$Native_Utils.cmp(minutes, 45) < 0) ? A2(
			_user$project$Views_Interpolation$interpolate,
			i18n.minutesAgoFormat,
			{
				ctor: '::',
				_0: _elm_lang$core$Basics$toString(minutes),
				_1: {ctor: '[]'}
			}) : ((_elm_lang$core$Native_Utils.cmp(hours, 1) < 1) ? i18n.oneHourAgo : ((_elm_lang$core$Native_Utils.cmp(hours, 22) < 0) ? A2(
			_user$project$Views_Interpolation$interpolate,
			i18n.hoursAgoFormat,
			{
				ctor: '::',
				_0: _elm_lang$core$Basics$toString(hours),
				_1: {ctor: '[]'}
			}) : ((_elm_lang$core$Native_Utils.cmp(days, 1) < 1) ? i18n.oneDayAgo : ((_elm_lang$core$Native_Utils.cmp(days, 6) < 0) ? A2(
			_user$project$Views_Interpolation$interpolate,
			i18n.daysAgoFormat,
			{
				ctor: '::',
				_0: _elm_lang$core$Basics$toString(days),
				_1: {ctor: '[]'}
			}) : ((_elm_lang$core$Native_Utils.cmp(weeks, 1) < 1) ? i18n.oneWeekAgo : ((_elm_lang$core$Native_Utils.cmp(weeks, 4) < 0) ? A2(
			_user$project$Views_Interpolation$interpolate,
			i18n.weeksAgoFormat,
			{
				ctor: '::',
				_0: _elm_lang$core$Basics$toString(weeks),
				_1: {ctor: '[]'}
			}) : ((_elm_lang$core$Native_Utils.cmp(months, 1) < 1) ? i18n.oneMonthAgo : ((_elm_lang$core$Native_Utils.cmp(months, 11) < 0) ? A2(
			_user$project$Views_Interpolation$interpolate,
			i18n.monthsAgoFormat,
			{
				ctor: '::',
				_0: _elm_lang$core$Basics$toString(months),
				_1: {ctor: '[]'}
			}) : ((_elm_lang$core$Native_Utils.cmp(years, 1) < 1) ? i18n.oneYearAgo : A2(
			_user$project$Views_Interpolation$interpolate,
			i18n.yearsAgoFormat,
			{
				ctor: '::',
				_0: _elm_lang$core$Basics$toString(years),
				_1: {ctor: '[]'}
			}))))))))))));
		return A2(
			_user$project$Views_Interpolation$interpolate,
			i18n.created,
			{
				ctor: '::',
				_0: relativeTime,
				_1: {ctor: '[]'}
			});
	});

var _user$project$Views_ProjectLibrary$toolbarContent = function (session) {
	return session.readOnly ? _elm_lang$html$Html$text('') : A2(
		_elm_lang$html$Html$span,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('container material-button'),
			_1: {
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$title(session.i18n.newProject),
				_1: {ctor: '[]'}
			}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$i,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('icon-md ion-md-add add-button'),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_ProjectLibrary$CreateProjectClicked),
						_1: {ctor: '[]'}
					}
				},
				{ctor: '[]'}),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$span,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_ProjectLibrary$CreateProjectClicked),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(session.i18n.newProject),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			}
		});
};
var _user$project$Views_ProjectLibrary$view = F2(
	function (model, session) {
		var makeCard = function (projectCard) {
			var participantMessage = function () {
				var participantCount = _elm_lang$core$List$length(
					A2(
						_elm_community$list_extra$List_Extra$uniqueBy,
						function (_) {
							return _.participantId;
						},
						projectCard.assessments));
				return _elm_lang$core$Native_Utils.eq(participantCount, 1) ? A2(
					_elm_lang$core$Basics_ops['++'],
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(participantCount),
						' '),
					session.i18n.participant) : A2(
					_elm_lang$core$Basics_ops['++'],
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(participantCount),
						' '),
					session.i18n.participants);
			}();
			var status = function () {
				var _p0 = projectCard.project.isActive;
				if (_p0 === true) {
					return 'active';
				} else {
					return 'draft';
				}
			}();
			var incompleteParticipantIds = A2(
				_elm_lang$core$List$map,
				function (_) {
					return _.participantId;
				},
				A2(
					_elm_community$list_extra$List_Extra$uniqueBy,
					function (_) {
						return _.participantId;
					},
					A2(
						_elm_lang$core$List$filter,
						function (assessment) {
							return _elm_lang$core$Native_Utils.eq(assessment.date, _elm_lang$core$Maybe$Nothing);
						},
						projectCard.assessments)));
			var completeParticipantCount = _elm_lang$core$List$length(
				A2(
					_elm_lang$core$List$filter,
					function (assessment) {
						return !A2(_elm_lang$core$List$member, assessment.participantId, incompleteParticipantIds);
					},
					A2(
						_elm_community$list_extra$List_Extra$uniqueBy,
						function (_) {
							return _.participantId;
						},
						projectCard.assessments)));
			return A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class(
						A2(_elm_lang$core$Basics_ops['++'], 'card color-', status)),
					_1: {
						ctor: '::',
						_0: A2(_elm_lang$html$Html_Attributes$attribute, 'data-test-project-status', status),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Events$onClick(
								_user$project$Page_ProjectLibrary$ProjectClicked(projectCard.project.id)),
							_1: {
								ctor: '::',
								_0: A2(_elm_lang$html$Html_Attributes$attribute, 'data-test-name', projectCard.project.name),
								_1: {ctor: '[]'}
							}
						}
					}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$h5,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$em,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('createdDateMessage'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text(
										A3(_user$project$Views_DateTimeMessageBuilder$createRelativeTimeMessage, projectCard.project.created, model.now, session.i18n)),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$h1,
							{ctor: '[]'},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(projectCard.project.name),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{ctor: '[]'},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$h5,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('totalParticipants'),
											_1: {ctor: '[]'}
										},
										{
											ctor: '::',
											_0: _elm_lang$html$Html$text(participantMessage),
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$h5,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('completedParticipants'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: _elm_lang$html$Html$text(
													A2(
														_elm_lang$core$Basics_ops['++'],
														_elm_lang$core$Basics$toString(completeParticipantCount),
														A2(_elm_lang$core$Basics_ops['++'], ' ', session.i18n.complete))),
												_1: {ctor: '[]'}
											}),
										_1: {ctor: '[]'}
									}
								}),
							_1: {ctor: '[]'}
						}
					}
				});
		};
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('container u-no-stretch'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('row'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$id('cardWindow'),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('col-xs-12 flex flex-wrap flex-justify-start flex-align-center cont contentWindow'),
									_1: {ctor: '[]'}
								}
							},
							_elm_lang$core$List$isEmpty(model.library) ? {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$h3,
									{ctor: '[]'},
									{
										ctor: '::',
										_0: _elm_lang$html$Html$text(session.i18n.noProjects),
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							} : A2(
								_elm_lang$core$List$map,
								makeCard,
								A2(
									_elm_lang$core$List$sortBy,
									function (x) {
										return _elm_lang$core$String$toUpper(x.project.name);
									},
									model.library))),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			});
	});

var _user$project$Views_ProjectModal$view = F2(
	function (i18n, model) {
		var _p0 = function () {
			var _p1 = {ctor: '_Tuple2', _0: model.state, _1: model.project};
			switch (_p1._0.ctor) {
				case 'Pristine':
					if (_p1._1.ctor === 'Just') {
						return {name: _p1._1._0.name, error: ''};
					} else {
						return {name: '', error: ''};
					}
				case 'Valid':
					return {name: _p1._0._0, error: ''};
				default:
					var _p3 = _p1._0._0;
					var _p2 = _p1._0._1;
					switch (_p2.ctor) {
						case 'Blank':
							return {name: _p3, error: i18n.nameRequired};
						case 'TooLong':
							return {name: _p3, error: i18n.nameLength};
						case 'Duplicate':
							return {name: _p3, error: i18n.nameDuplicate};
						case 'ContainsInvalidCharacters':
							return {name: _p3, error: i18n.nameContainsInvalidCharacters};
						default:
							return {name: _p3, error: i18n.nameIsConfigure};
					}
			}
		}();
		var name = _p0.name;
		var error = _p0.error;
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$id('NewProjectNameModalWrapper'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('elm-modal'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('center-box'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$header,
									{ctor: '[]'},
									{
										ctor: '::',
										_0: _elm_lang$html$Html$text(i18n.projectInformation),
										_1: {ctor: '[]'}
									}),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$article,
										{ctor: '[]'},
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$label,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$for('ProjectName'),
													_1: {ctor: '[]'}
												},
												{
													ctor: '::',
													_0: _elm_lang$html$Html$text(i18n.projectTitle),
													_1: {ctor: '[]'}
												}),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$input,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$type_('text'),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$id('ProjectName'),
															_1: {
																ctor: '::',
																_0: _elm_lang$html$Html_Events$onInput(_user$project$Page_ProjectModal$NameChanged),
																_1: {
																	ctor: '::',
																	_0: _elm_community$html_extra$Html_Events_Extra$onEnter(_user$project$Page_ProjectModal$Submit),
																	_1: {
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$value(name),
																		_1: {ctor: '[]'}
																	}
																}
															}
														}
													},
													{ctor: '[]'}),
												_1: {
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$span,
														{
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$id('ProjectNameHelp'),
															_1: {
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$class('help-block'),
																_1: {ctor: '[]'}
															}
														},
														{
															ctor: '::',
															_0: _elm_lang$html$Html$text(i18n.projectNameValidationHint),
															_1: {ctor: '[]'}
														}),
													_1: {
														ctor: '::',
														_0: A2(
															_elm_lang$html$Html$div,
															{
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$class('errors'),
																_1: {ctor: '[]'}
															},
															{
																ctor: '::',
																_0: A2(
																	_elm_lang$html$Html$span,
																	{ctor: '[]'},
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html$text(error),
																		_1: {ctor: '[]'}
																	}),
																_1: {ctor: '[]'}
															}),
														_1: {
															ctor: '::',
															_0: A2(
																_elm_lang$html$Html$div,
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$class('actions'),
																	_1: {ctor: '[]'}
																},
																{
																	ctor: '::',
																	_0: A2(
																		_elm_lang$html$Html$button,
																		{
																			ctor: '::',
																			_0: _elm_lang$html$Html_Attributes$type_('button'),
																			_1: {
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$class('btn btn-modal'),
																				_1: {
																					ctor: '::',
																					_0: _elm_lang$html$Html_Attributes$id('ok'),
																					_1: {
																						ctor: '::',
																						_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_ProjectModal$Submit),
																						_1: {
																							ctor: '::',
																							_0: _elm_lang$html$Html_Attributes$disabled(model.requestInProgress),
																							_1: {ctor: '[]'}
																						}
																					}
																				}
																			}
																		},
																		{
																			ctor: '::',
																			_0: _elm_lang$html$Html$text(i18n.ok),
																			_1: {ctor: '[]'}
																		}),
																	_1: {
																		ctor: '::',
																		_0: A2(
																			_elm_lang$html$Html$button,
																			{
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$type_('button'),
																				_1: {
																					ctor: '::',
																					_0: _elm_lang$html$Html_Attributes$class('btn btn-modal'),
																					_1: {
																						ctor: '::',
																						_0: _elm_lang$html$Html_Attributes$id('CancelNewProject'),
																						_1: {
																							ctor: '::',
																							_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_ProjectModal$Close),
																							_1: {
																								ctor: '::',
																								_0: _elm_lang$html$Html_Attributes$disabled(model.requestInProgress),
																								_1: {ctor: '[]'}
																							}
																						}
																					}
																				}
																			},
																			{
																				ctor: '::',
																				_0: _elm_lang$html$Html$text(i18n.cancel),
																				_1: {ctor: '[]'}
																			}),
																		_1: {ctor: '[]'}
																	}
																}),
															_1: {ctor: '[]'}
														}
													}
												}
											}
										}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$footer,
											{ctor: '[]'},
											{ctor: '[]'}),
										_1: {ctor: '[]'}
									}
								}
							}),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			});
	});

var _user$project$Views_ProjectReportSettings$viewAlert = F2(
	function (model, i18n) {
		var alert = F4(
			function (warningText, style, btnMsg, btnText) {
				return A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class(
							A2(_elm_lang$core$Basics_ops['++'], 'alert alert-', style)),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$span,
							{ctor: '[]'},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(warningText),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$button,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class(
										A2(_elm_lang$core$Basics_ops['++'], 'btn btn-', style)),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Events$onClick(btnMsg),
										_1: {ctor: '[]'}
									}
								},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text(btnText),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}
					});
			});
		var _p0 = model.hasCompletedParticipant;
		if (_p0 === false) {
			return _elm_lang$html$Html$text('');
		} else {
			var _p1 = {ctor: '_Tuple2', _0: model.state, _1: model.override};
			_v1_0:
			do {
				if (_p1._1 === false) {
					if (_p1._0.ctor === 'Pristine') {
						break _v1_0;
					} else {
						return A4(alert, i18n.theseChangesWillNotImpactGeneratedReports, 'info', _user$project$Page_ProjectReportSettings$Override, i18n.updateAllReports);
					}
				} else {
					switch (_p1._0.ctor) {
						case 'Pristine':
							break _v1_0;
						case 'Changed':
							return A4(alert, i18n.youHaveChoseToUpdateGeneratedReports, 'success', _user$project$Page_ProjectReportSettings$UndoOverride, i18n.goBack);
						default:
							return A4(alert, i18n.youHaveChosenToMakeBillableChangesToGeneratedReports, 'warning', _user$project$Page_ProjectReportSettings$UndoOverride, i18n.goBack);
					}
				}
			} while(false);
			return _elm_lang$html$Html$text('');
		}
	});
var _user$project$Views_ProjectReportSettings$view = F2(
	function (model, session) {
		return _user$project$Views_ReportSettings$view(model.product.id)(model.product.name)(
			!_elm_lang$core$List$isEmpty(model.norms))(model.product.language)(model.languages)(_user$project$Page_ProjectReportSettings$ChangeLanguage)(model.product.norm)(model.norms)(_user$project$Page_ProjectReportSettings$ChangeNorm)(model.product.jobProfile)(model.jobProfiles)(_user$project$Page_ProjectReportSettings$ChangeProfile)(_user$project$Page_ProjectReportSettings$PostReportOptions)(_user$project$Page_ProjectReportSettings$CloseView)(
			A2(_user$project$Views_ProjectReportSettings$viewAlert, model, session.i18n))(session);
	});

var _user$project$Views_CloseWarningModal$modalView = F4(
	function (display, i18n, exitMsg, cancelMsg) {
		return display ? A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$id('CloseWarningModal'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('elm-modal'),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('center-box'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$header,
							{ctor: '[]'},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(i18n.notice),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$article,
								{ctor: '[]'},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$p,
										{ctor: '[]'},
										{
											ctor: '::',
											_0: _elm_lang$html$Html$text(i18n.exitMessage),
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$div,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('actions'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$button,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$id('Exit'),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$type_('button'),
															_1: {
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$class('btn btn-report'),
																_1: {
																	ctor: '::',
																	_0: _elm_lang$html$Html_Events$onClick(exitMsg),
																	_1: {ctor: '[]'}
																}
															}
														}
													},
													{
														ctor: '::',
														_0: _elm_lang$html$Html$text(i18n.exitWithoutSaving),
														_1: {ctor: '[]'}
													}),
												_1: {
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$button,
														{
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$id('Cancel'),
															_1: {
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$type_('button'),
																_1: {
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$class('btn btn-report'),
																	_1: {
																		ctor: '::',
																		_0: _elm_lang$html$Html_Events$onClick(cancelMsg),
																		_1: {ctor: '[]'}
																	}
																}
															}
														},
														{
															ctor: '::',
															_0: _elm_lang$html$Html$text(i18n.cancel),
															_1: {ctor: '[]'}
														}),
													_1: {ctor: '[]'}
												}
											}),
										_1: {ctor: '[]'}
									}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$footer,
									{ctor: '[]'},
									{ctor: '[]'}),
								_1: {ctor: '[]'}
							}
						}
					}),
				_1: {ctor: '[]'}
			}) : _elm_lang$html$Html$text('');
	});

var _user$project$Views_ReportSelection$view = F2(
	function (model, session) {
		var selectedReports = A2(
			_elm_lang$core$List$filter,
			function (x) {
				var _p0 = x.state;
				if (_p0.ctor === 'Selected') {
					return true;
				} else {
					return false;
				}
			},
			model.reports);
		var reportCard = function (info) {
			var classes = function () {
				var _p1 = info.state;
				switch (_p1.ctor) {
					case 'Selected':
						return 'report-card selected';
					case 'Available':
						return 'report-card not-selected';
					case 'Removed':
						return 'report-card not-selected';
					case 'Disabled':
						return 'report-card disabled';
					default:
						return 'report-card hidden';
				}
			}();
			return A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class(classes),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Events$onClick(
							_user$project$Page_ReportSelection$Toggle(info)),
						_1: {ctor: '[]'}
					}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('card-header'),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$title(info.name),
								_1: {ctor: '[]'}
							}
						},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$span,
								{ctor: '[]'},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text(info.name),
									_1: {ctor: '[]'}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$img,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('img-responsive'),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$src(
												_user$project$Views_ReportImageMap$path(info.id)),
											_1: {ctor: '[]'}
										}
									},
									{ctor: '[]'}),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$i,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('ion-md-checkmark-circle-outline'),
											_1: {ctor: '[]'}
										},
										{ctor: '[]'}),
									_1: {ctor: '[]'}
								}
							}
						}),
					_1: {ctor: '[]'}
				});
		};
		var availableReportCards = A2(
			_elm_lang$core$List$map,
			reportCard,
			A2(
				_elm_lang$core$List$sortBy,
				function (x) {
					return _elm_lang$core$String$toUpper(x.name);
				},
				A2(
					_elm_lang$core$List$filter,
					function (x) {
						return (!_elm_lang$core$Native_Utils.eq(
							x.state,
							_user$project$Page_ReportSelection$Selected(_user$project$Page_ReportSelection$Abandoned))) && (!_elm_lang$core$Native_Utils.eq(x.state, _user$project$Page_ReportSelection$Abandoned));
					},
					model.reports)));
		var selectedReportCards = A2(
			_elm_lang$core$List$map,
			reportCard,
			A2(
				_elm_lang$core$List$sortBy,
				function (x) {
					return _elm_lang$core$String$toUpper(x.name);
				},
				selectedReports));
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$id('PageMaker'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$id('ReportSelection'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$header,
							{ctor: '[]'},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									{ctor: '[]'},
									{
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$h3,
											{ctor: '[]'},
											{
												ctor: '::',
												_0: _elm_lang$html$Html$text(model.titleText),
												_1: {ctor: '[]'}
											}),
										_1: {
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$button,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class('close'),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$type_('button'),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_ReportSelection$Close),
															_1: {ctor: '[]'}
														}
													}
												},
												{
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$i,
														{
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$class('icon-lg ion-ios-close'),
															_1: {ctor: '[]'}
														},
														{ctor: '[]'}),
													_1: {ctor: '[]'}
												}),
											_1: {ctor: '[]'}
										}
									}),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$section,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('window'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$div,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('container'),
											_1: {ctor: '[]'}
										},
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$section,
												{ctor: '[]'},
												{
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$h3,
														{ctor: '[]'},
														{
															ctor: '::',
															_0: _elm_lang$html$Html$text(session.i18n.myReports),
															_1: {ctor: '[]'}
														}),
													_1: {
														ctor: '::',
														_0: A2(
															_elm_lang$html$Html$p,
															{ctor: '[]'},
															{
																ctor: '::',
																_0: _elm_lang$html$Html$text(session.i18n.selectReportPrompt),
																_1: {ctor: '[]'}
															}),
														_1: {ctor: '[]'}
													}
												}),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$div,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$id('ReportCatalog'),
														_1: {ctor: '[]'}
													},
													availableReportCards),
												_1: {ctor: '[]'}
											}
										}),
									_1: {ctor: '[]'}
								}),
							_1: {
								ctor: '::',
								_0: function () {
									var _p2 = model.errors;
									if (_p2.ctor === '[]') {
										return _elm_lang$html$Html$text('');
									} else {
										return A2(
											_elm_lang$html$Html$div,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('error-container'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$div,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$id('Warnings'),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$class('alert alert-danger'),
															_1: {ctor: '[]'}
														}
													},
													{
														ctor: '::',
														_0: _elm_lang$html$Html$text(session.i18n.alreadySelectedReportContainedInPackage),
														_1: {
															ctor: '::',
															_0: A2(
																_elm_lang$html$Html$ul,
																{ctor: '[]'},
																A2(
																	_elm_lang$core$List$map,
																	function (l) {
																		return A2(
																			_elm_lang$html$Html$li,
																			{ctor: '[]'},
																			{
																				ctor: '::',
																				_0: _elm_lang$html$Html$text(l),
																				_1: {ctor: '[]'}
																			});
																	},
																	_p2)),
															_1: {ctor: '[]'}
														}
													}),
												_1: {ctor: '[]'}
											});
									}
								}(),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$footer,
										{ctor: '[]'},
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$section,
												{ctor: '[]'},
												{
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$h3,
														{ctor: '[]'},
														{
															ctor: '::',
															_0: _elm_lang$html$Html$text(session.i18n.selectedReports),
															_1: {ctor: '[]'}
														}),
													_1: {
														ctor: '::',
														_0: A2(
															_elm_lang$html$Html$div,
															{
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$id('reportsForm'),
																_1: {ctor: '[]'}
															},
															{
																ctor: '::',
																_0: A2(
																	_elm_lang$html$Html$div,
																	{
																		ctor: '::',
																		_0: _elm_lang$html$Html_Attributes$id('SelectedReports'),
																		_1: {ctor: '[]'}
																	},
																	selectedReportCards),
																_1: {
																	ctor: '::',
																	_0: A2(
																		_elm_lang$html$Html$button,
																		{
																			ctor: '::',
																			_0: _elm_lang$html$Html_Attributes$class('btn btn-continue'),
																			_1: {
																				ctor: '::',
																				_0: _elm_lang$html$Html_Attributes$id('UpdateReports'),
																				_1: {
																					ctor: '::',
																					_0: _elm_lang$html$Html_Events$onClick(_user$project$Page_ReportSelection$SaveReports),
																					_1: {ctor: '[]'}
																				}
																			}
																		},
																		{
																			ctor: '::',
																			_0: _elm_lang$html$Html$text(
																				A2(
																					_user$project$Views_Interpolation$interpolate,
																					session.i18n.continueWith,
																					{
																						ctor: '::',
																						_0: _elm_lang$core$Basics$toString(
																							_elm_lang$core$List$length(selectedReports)),
																						_1: {ctor: '[]'}
																					})),
																			_1: {
																				ctor: '::',
																				_0: A2(
																					_elm_lang$html$Html$i,
																					{
																						ctor: '::',
																						_0: _elm_lang$html$Html_Attributes$class('icon-md ion-ios-arrow-forward inset-sm'),
																						_1: {ctor: '[]'}
																					},
																					{ctor: '[]'}),
																				_1: {ctor: '[]'}
																			}
																		}),
																	_1: {ctor: '[]'}
																}
															}),
														_1: {ctor: '[]'}
													}
												}),
											_1: {ctor: '[]'}
										}),
									_1: {ctor: '[]'}
								}
							}
						}
					}),
				_1: {
					ctor: '::',
					_0: A4(_user$project$Views_CloseWarningModal$modalView, model.showClosingWarningModal, session.i18n, _user$project$Page_ReportSelection$ConfirmClose, _user$project$Page_ReportSelection$CancelClose),
					_1: {ctor: '[]'}
				}
			});
	});

var _user$project$Views_Search$view = F2(
	function (model, session) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('container'),
				_1: {ctor: '[]'}
			},
			function () {
				if (_elm_lang$core$List$isEmpty(model.results.participantSearchResults) && _elm_lang$core$List$isEmpty(model.results.projectSearchResults)) {
					return {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('row'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$id('results'),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('col-xs-12 flex contentWindow'),
											_1: {ctor: '[]'}
										}
									},
									{
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$h3,
											{ctor: '[]'},
											{
												ctor: '::',
												_0: _elm_lang$html$Html$text(session.i18n.noResultsWereFound),
												_1: {ctor: '[]'}
											}),
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					};
				} else {
					var createCellContent = F2(
						function (value, headerText) {
							return {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$tr,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('row'),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$td,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('searchValue col-xs-12'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: _elm_lang$html$Html$text(value),
												_1: {ctor: '[]'}
											}),
										_1: {ctor: '[]'}
									}),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$tr,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('row'),
											_1: {ctor: '[]'}
										},
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$td,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class('headerText  col-xs-12'),
													_1: {ctor: '[]'}
												},
												{
													ctor: '::',
													_0: _elm_lang$html$Html$text(headerText),
													_1: {ctor: '[]'}
												}),
											_1: {ctor: '[]'}
										}),
									_1: {ctor: '[]'}
								}
							};
						});
					var participantSearchResultRow = function (searchResult) {
						return A2(
							_elm_lang$html$Html$tr,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Events$onClick(
									A2(_user$project$Page_Search$NavigateToParticipantDetail, searchResult.projectId, searchResult.participantId)),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$td,
									{ctor: '[]'},
									A2(
										createCellContent,
										A2(
											_elm_lang$core$Basics_ops['++'],
											searchResult.firstName,
											A2(_elm_lang$core$Basics_ops['++'], ' ', searchResult.lastName)),
										session.i18n.name)),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$td,
										{ctor: '[]'},
										A2(createCellContent, searchResult.projectName, session.i18n.project)),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$td,
											{ctor: '[]'},
											A2(createCellContent, searchResult.participantId, session.i18n.hoganIdWithOctothorpe)),
										_1: {
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$td,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class('uniqueResultsColumn'),
													_1: {ctor: '[]'}
												},
												A2(createCellContent, searchResult.uniqueId, session.i18n.uniqueIdWithOctothorpe)),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$td,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class('emailResultsColumn'),
														_1: {ctor: '[]'}
													},
													A2(createCellContent, searchResult.email, session.i18n.email)),
												_1: {
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$td,
														{
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$class('chevron-link'),
															_1: {ctor: '[]'}
														},
														{
															ctor: '::',
															_0: A2(
																_elm_lang$html$Html$i,
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html_Attributes$class('searchChevron glyphicon glyphicon-chevron-up'),
																	_1: {ctor: '[]'}
																},
																{ctor: '[]'}),
															_1: {ctor: '[]'}
														}),
													_1: {ctor: '[]'}
												}
											}
										}
									}
								}
							});
					};
					var projectSearchResultRow = function (searchResult) {
						return A2(
							_elm_lang$html$Html$tr,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Events$onClick(
									_user$project$Page_Search$NavigateToProjectDetail(searchResult.projectId)),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$td,
									{ctor: '[]'},
									A2(createCellContent, searchResult.projectName, session.i18n.project)),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$td,
										{ctor: '[]'},
										A2(
											createCellContent,
											A3(_user$project$Views_DateTimeMessageBuilder$createRelativeTimeMessage, searchResult.createdDate, model.now, session.i18n),
											session.i18n.createdDate)),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$td,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('chevron-link'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$i,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class('searchChevron glyphicon glyphicon-chevron-up'),
														_1: {ctor: '[]'}
													},
													{ctor: '[]'}),
												_1: {ctor: '[]'}
											}),
										_1: {ctor: '[]'}
									}
								}
							});
					};
					return {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('row'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$id('results'),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('col-xs-12 flex contentWindow'),
											_1: {ctor: '[]'}
										}
									},
									{
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$h3,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('searchResultsText'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: _elm_lang$html$Html$text(
													A2(
														_elm_lang$core$Basics_ops['++'],
														session.i18n.searchParticipantsFor,
														A2(
															_elm_lang$core$Basics_ops['++'],
															' \'',
															A2(_elm_lang$core$Basics_ops['++'], model.searchTerm, '\'')))),
												_1: {ctor: '[]'}
											}),
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('row flex flex-wrap search-result-header'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$i,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('glyphicon glyphicon-user'),
											_1: {ctor: '[]'}
										},
										{ctor: '[]'}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$h2,
											{ctor: '[]'},
											{
												ctor: '::',
												_0: _elm_lang$html$Html$text(session.i18n.participants),
												_1: {ctor: '[]'}
											}),
										_1: {ctor: '[]'}
									}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$id('ParticipantSearchResults'),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$table,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('table table-striped table-hover table-responsive'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$thead,
													{ctor: '[]'},
													{ctor: '[]'}),
												_1: {
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$tbody,
														{ctor: '[]'},
														A2(_elm_lang$core$List$map, participantSearchResultRow, model.results.participantSearchResults)),
													_1: {ctor: '[]'}
												}
											}),
										_1: {ctor: '[]'}
									}),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$div,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('row flex flex-wrap search-result-header'),
											_1: {ctor: '[]'}
										},
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$i,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class('glyphicon glyphicon-user'),
													_1: {ctor: '[]'}
												},
												{ctor: '[]'}),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$h2,
													{ctor: '[]'},
													{
														ctor: '::',
														_0: _elm_lang$html$Html$text('Projects'),
														_1: {ctor: '[]'}
													}),
												_1: {ctor: '[]'}
											}
										}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$div,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$id('ProjectSearchResults'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$table,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class('table table-striped table-hover table-responsive'),
														_1: {ctor: '[]'}
													},
													{
														ctor: '::',
														_0: A2(
															_elm_lang$html$Html$thead,
															{ctor: '[]'},
															{ctor: '[]'}),
														_1: {
															ctor: '::',
															_0: A2(
																_elm_lang$html$Html$tbody,
																{ctor: '[]'},
																A2(_elm_lang$core$List$map, projectSearchResultRow, model.results.projectSearchResults)),
															_1: {ctor: '[]'}
														}
													}),
												_1: {ctor: '[]'}
											}),
										_1: {ctor: '[]'}
									}
								}
							}
						}
					};
				}
			}());
	});

var _user$project$Main$notifyOfAction = _elm_lang$core$Native_Platform.outgoingPort(
	'notifyOfAction',
	function (v) {
		return null;
	});
var _user$project$Main$Model = F5(
	function (a, b, c, d, e) {
		return {page: a, modal: b, menu: c, session: d, location: e};
	});
var _user$project$Main$Error = {ctor: 'Error'};
var _user$project$Main$AccessDenied = {ctor: 'AccessDenied'};
var _user$project$Main$ParticipantReportSettings = function (a) {
	return {ctor: 'ParticipantReportSettings', _0: a};
};
var _user$project$Main$ParticipantReportSelection = function (a) {
	return {ctor: 'ParticipantReportSelection', _0: a};
};
var _user$project$Main$Participants = function (a) {
	return {ctor: 'Participants', _0: a};
};
var _user$project$Main$ProjectReportSettings = function (a) {
	return {ctor: 'ProjectReportSettings', _0: a};
};
var _user$project$Main$ProjectReportSelection = function (a) {
	return {ctor: 'ProjectReportSelection', _0: a};
};
var _user$project$Main$ProjectDetail = function (a) {
	return {ctor: 'ProjectDetail', _0: a};
};
var _user$project$Main$Library = function (a) {
	return {ctor: 'Library', _0: a};
};
var _user$project$Main$Search = function (a) {
	return {ctor: 'Search', _0: a};
};
var _user$project$Main$Blank = {ctor: 'Blank'};
var _user$project$Main$ProjectName = function (a) {
	return {ctor: 'ProjectName', _0: a};
};
var _user$project$Main$None = {ctor: 'None'};
var _user$project$Main$SetClientInfo = function (a) {
	return {ctor: 'SetClientInfo', _0: a};
};
var _user$project$Main$init = F2(
	function (flags, location) {
		var model = A5(
			_user$project$Main$Model,
			_user$project$Main$Blank,
			_user$project$Main$None,
			A2(
				_user$project$Page_Menu$init,
				'',
				{ctor: '[]'}),
			_user$project$Session$session(flags),
			location);
		return {
			ctor: '_Tuple2',
			_0: model,
			_1: A2(
				_elm_lang$http$Http$send,
				_user$project$Main$SetClientInfo,
				_user$project$Request_Client$get(model.session))
		};
	});
var _user$project$Main$ParticipantReportSettingsMsg = function (a) {
	return {ctor: 'ParticipantReportSettingsMsg', _0: a};
};
var _user$project$Main$ProjectModalMsg = F2(
	function (a, b) {
		return {ctor: 'ProjectModalMsg', _0: a, _1: b};
	});
var _user$project$Main$SearchMsg = function (a) {
	return {ctor: 'SearchMsg', _0: a};
};
var _user$project$Main$ParticipantReportSelectionMsg = function (a) {
	return {ctor: 'ParticipantReportSelectionMsg', _0: a};
};
var _user$project$Main$ParticipantsMsg = function (a) {
	return {ctor: 'ParticipantsMsg', _0: a};
};
var _user$project$Main$ProjectReportSettingsMsg = function (a) {
	return {ctor: 'ProjectReportSettingsMsg', _0: a};
};
var _user$project$Main$ProjectReportSelectionMsg = function (a) {
	return {ctor: 'ProjectReportSelectionMsg', _0: a};
};
var _user$project$Main$ProjectDetailMsg = function (a) {
	return {ctor: 'ProjectDetailMsg', _0: a};
};
var _user$project$Main$ProjectLibraryMsg = function (a) {
	return {ctor: 'ProjectLibraryMsg', _0: a};
};
var _user$project$Main$MenuMsg = function (a) {
	return {ctor: 'MenuMsg', _0: a};
};
var _user$project$Main$frame = F4(
	function (bodyContent, toolbarContent, modalContent, model) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$id('AppContainer'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$map,
					_user$project$Main$MenuMsg,
					A2(_user$project$Views_Menu$view, model.menu, model.session)),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$nav,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$id('Toolbar'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: toolbarContent,
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('body-content'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: bodyContent,
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: modalContent,
							_1: {ctor: '[]'}
						}
					}
				}
			});
	});
var _user$project$Main$view = function (model) {
	var mainModalOr = function (ownedModal) {
		var _p0 = model.modal;
		if (_p0.ctor === 'None') {
			return ownedModal;
		} else {
			var _p1 = _p0._0;
			return A2(
				_user$project$IE$modalButtonFix,
				A2(_user$project$Views_ProjectModal$view, model.session.i18n, _p1),
				_elm_lang$html$Html$map(
					_user$project$Main$ProjectModalMsg(_p1)));
		}
	};
	var mainModal = mainModalOr(
		_elm_lang$html$Html$text(''));
	var _p2 = function () {
		var _p3 = model.page;
		switch (_p3.ctor) {
			case 'Search':
				return {
					ctor: '_Tuple3',
					_0: A2(
						_elm_lang$html$Html$map,
						_user$project$Main$SearchMsg,
						A2(_user$project$Views_Search$view, _p3._0, model.session)),
					_1: _elm_lang$html$Html$text(''),
					_2: mainModal
				};
			case 'Library':
				return {
					ctor: '_Tuple3',
					_0: A2(
						_elm_lang$html$Html$map,
						_user$project$Main$ProjectLibraryMsg,
						A2(_user$project$Views_ProjectLibrary$view, _p3._0, model.session)),
					_1: A2(
						_elm_lang$html$Html$map,
						_user$project$Main$ProjectLibraryMsg,
						_user$project$Views_ProjectLibrary$toolbarContent(model.session)),
					_2: mainModal
				};
			case 'ProjectDetail':
				var _p4 = _p3._0;
				return {
					ctor: '_Tuple3',
					_0: A2(
						_elm_lang$html$Html$map,
						_user$project$Main$ProjectDetailMsg,
						A2(_user$project$Views_ProjectDetail$view, _p4, model.session)),
					_1: A2(
						_elm_lang$html$Html$map,
						_user$project$Main$ProjectDetailMsg,
						_user$project$Views_ProjectDetail$viewToolbar(model.session.i18n)),
					_2: mainModalOr(
						A2(
							_elm_lang$html$Html$map,
							_user$project$Main$ProjectDetailMsg,
							A2(_user$project$Views_ProjectDetail$viewModal, _p4, model.session)))
				};
			case 'Participants':
				var _p5 = _p3._0;
				return {
					ctor: '_Tuple3',
					_0: A2(
						_elm_lang$html$Html$map,
						_user$project$Main$ParticipantsMsg,
						A2(_user$project$Views_Participants$view, _p5, model.session)),
					_1: A2(
						_elm_lang$html$Html$map,
						_user$project$Main$ParticipantsMsg,
						A2(_user$project$Views_Participants$viewToolbar, _p5, model.session)),
					_2: mainModalOr(
						A2(
							_elm_lang$html$Html$map,
							_user$project$Main$ParticipantsMsg,
							A2(_user$project$Views_Participants$viewModal, _p5, model.session)))
				};
			default:
				return {
					ctor: '_Tuple3',
					_0: _elm_lang$html$Html$text(''),
					_1: _elm_lang$html$Html$text(''),
					_2: _elm_lang$html$Html$text('')
				};
		}
	}();
	var bodyContent = _p2._0;
	var toolbarContent = _p2._1;
	var modalContent = _p2._2;
	var _p6 = model.page;
	switch (_p6.ctor) {
		case 'ProjectReportSelection':
			return A2(
				_elm_lang$html$Html$map,
				_user$project$Main$ProjectReportSelectionMsg,
				A2(_user$project$Views_ReportSelection$view, _p6._0, model.session));
		case 'ProjectReportSettings':
			return A2(
				_elm_lang$html$Html$map,
				_user$project$Main$ProjectReportSettingsMsg,
				A2(_user$project$Views_ProjectReportSettings$view, _p6._0, model.session));
		case 'ParticipantReportSelection':
			return A2(
				_elm_lang$html$Html$map,
				_user$project$Main$ParticipantReportSelectionMsg,
				A2(_user$project$Views_ReportSelection$view, _p6._0, model.session));
		case 'ParticipantReportSettings':
			return A2(
				_elm_lang$html$Html$map,
				_user$project$Main$ParticipantReportSettingsMsg,
				A2(_user$project$Views_ParticipantReportSettings$view, _p6._0, model.session));
		case 'AccessDenied':
			return _user$project$Views_AccessDenied$view(model.session.i18n);
		case 'Error':
			return _user$project$Views_Error$view(model.session.i18n);
		default:
			return A4(_user$project$Main$frame, bodyContent, toolbarContent, modalContent, model);
	}
};
var _user$project$Main$subscriptions = function (model) {
	return _elm_lang$core$Platform_Sub$batch(
		{
			ctor: '::',
			_0: A2(_elm_lang$core$Platform_Sub$map, _user$project$Main$ParticipantsMsg, _user$project$Page_Participants$subscriptions),
			_1: {
				ctor: '::',
				_0: A2(_elm_lang$core$Platform_Sub$map, _user$project$Main$MenuMsg, _user$project$Page_Menu$subscriptions),
				_1: {ctor: '[]'}
			}
		});
};
var _user$project$Main$ParticipantReportSelectionLoaded = function (a) {
	return {ctor: 'ParticipantReportSelectionLoaded', _0: a};
};
var _user$project$Main$ParticipantPackageSettingsLoaded = function (a) {
	return {ctor: 'ParticipantPackageSettingsLoaded', _0: a};
};
var _user$project$Main$ParticipantReportSettingsLoaded = function (a) {
	return {ctor: 'ParticipantReportSettingsLoaded', _0: a};
};
var _user$project$Main$ParticipantsLoaded = function (a) {
	return {ctor: 'ParticipantsLoaded', _0: a};
};
var _user$project$Main$ProjectPackageSettingsLoaded = function (a) {
	return {ctor: 'ProjectPackageSettingsLoaded', _0: a};
};
var _user$project$Main$ProjectReportSettingsLoaded = function (a) {
	return {ctor: 'ProjectReportSettingsLoaded', _0: a};
};
var _user$project$Main$ProjectReportSelectionLoaded = function (a) {
	return {ctor: 'ProjectReportSelectionLoaded', _0: a};
};
var _user$project$Main$ProjectDetailLoaded = function (a) {
	return {ctor: 'ProjectDetailLoaded', _0: a};
};
var _user$project$Main$ProjectLibraryLoaded = function (a) {
	return {ctor: 'ProjectLibraryLoaded', _0: a};
};
var _user$project$Main$SearchLoaded = function (a) {
	return {ctor: 'SearchLoaded', _0: a};
};
var _user$project$Main$setRoute = F2(
	function (route, model) {
		var _p7 = {ctor: '_Tuple2', _0: route, _1: model.page};
		switch (_p7._0.ctor) {
			case 'Search':
				var _p8 = _p7._0._0;
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							menu: A2(_user$project$Page_Menu$init, _p8, model.menu.clients)
						}),
					_1: A2(
						_elm_lang$core$Task$attempt,
						_user$project$Main$SearchLoaded,
						A2(_user$project$Page_Search$init, model.session, _p8))
				};
			case 'ProjectLibrary':
				return {
					ctor: '_Tuple2',
					_0: model,
					_1: A2(
						_elm_lang$core$Task$attempt,
						_user$project$Main$ProjectLibraryLoaded,
						_user$project$Page_ProjectLibrary$init(model.session))
				};
			case 'ProjectDetail':
				return {
					ctor: '_Tuple2',
					_0: model,
					_1: A2(
						_elm_lang$core$Task$attempt,
						_user$project$Main$ProjectDetailLoaded,
						A2(_user$project$Page_ProjectDetail$init, model.session, _p7._0._0))
				};
			case 'ProjectReportSelection':
				return model.session.readOnly ? {
					ctor: '_Tuple2',
					_0: model,
					_1: _user$project$Route$modifyUrl(_user$project$Route$AccessDenied)
				} : {
					ctor: '_Tuple2',
					_0: model,
					_1: A2(
						_elm_lang$core$Task$attempt,
						_user$project$Main$ProjectReportSelectionLoaded,
						A3(_user$project$Page_ReportSelection$init, model.session, _p7._0._0, _elm_lang$core$Maybe$Nothing))
				};
			case 'ProjectReportSettings':
				return {
					ctor: '_Tuple2',
					_0: model,
					_1: A2(
						_elm_lang$core$Task$attempt,
						_user$project$Main$ProjectReportSettingsLoaded,
						A4(_user$project$Page_ProjectReportSettings$init, model.session, _p7._0._0, _p7._0._1, _user$project$Page_Product$Report))
				};
			case 'ProjectPackageSettings':
				return {
					ctor: '_Tuple2',
					_0: model,
					_1: A2(
						_elm_lang$core$Task$attempt,
						_user$project$Main$ProjectPackageSettingsLoaded,
						A4(_user$project$Page_ProjectReportSettings$init, model.session, _p7._0._0, _p7._0._1, _user$project$Page_Product$Package))
				};
			case 'Participants':
				if (_p7._1.ctor === 'Participants') {
					return {
						ctor: '_Tuple2',
						_0: model,
						_1: A2(
							_elm_lang$core$Task$attempt,
							_user$project$Main$ParticipantsLoaded,
							A4(
								_user$project$Page_Participants$init,
								model.session,
								_p7._0._0,
								_elm_lang$core$Maybe$Nothing,
								_elm_lang$core$Maybe$Just(
									{ctor: '_Tuple2', _0: _p7._1._0, _1: true})))
					};
				} else {
					return {
						ctor: '_Tuple2',
						_0: model,
						_1: A2(
							_elm_lang$core$Task$attempt,
							_user$project$Main$ParticipantsLoaded,
							A4(_user$project$Page_Participants$init, model.session, _p7._0._0, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing))
					};
				}
			case 'Participant':
				if (_p7._1.ctor === 'Participants') {
					return {
						ctor: '_Tuple2',
						_0: model,
						_1: A2(
							_elm_lang$core$Task$attempt,
							_user$project$Main$ParticipantsLoaded,
							A4(
								_user$project$Page_Participants$init,
								model.session,
								_p7._0._0,
								_elm_lang$core$Maybe$Just(_p7._0._1),
								_elm_lang$core$Maybe$Just(
									{ctor: '_Tuple2', _0: _p7._1._0, _1: false})))
					};
				} else {
					return {
						ctor: '_Tuple2',
						_0: model,
						_1: A2(
							_elm_lang$core$Task$attempt,
							_user$project$Main$ParticipantsLoaded,
							A4(
								_user$project$Page_Participants$init,
								model.session,
								_p7._0._0,
								_elm_lang$core$Maybe$Just(_p7._0._1),
								_elm_lang$core$Maybe$Nothing))
					};
				}
			case 'ParticipantReportSelection':
				return model.session.readOnly ? {
					ctor: '_Tuple2',
					_0: model,
					_1: _user$project$Route$modifyUrl(_user$project$Route$AccessDenied)
				} : {
					ctor: '_Tuple2',
					_0: model,
					_1: A2(
						_elm_lang$core$Task$attempt,
						_user$project$Main$ParticipantReportSelectionLoaded,
						A3(
							_user$project$Page_ReportSelection$init,
							model.session,
							_p7._0._0,
							_elm_lang$core$Maybe$Just(_p7._0._1)))
				};
			case 'ParticipantReportSettings':
				return {
					ctor: '_Tuple2',
					_0: model,
					_1: A2(
						_elm_lang$core$Task$attempt,
						_user$project$Main$ParticipantReportSettingsLoaded,
						A5(_user$project$Page_ParticipantReportSettings$init, model.session, _p7._0._0, _p7._0._1, _p7._0._2, _user$project$Page_Product$Report))
				};
			case 'ParticipantPackageSettings':
				return {
					ctor: '_Tuple2',
					_0: model,
					_1: A2(
						_elm_lang$core$Task$attempt,
						_user$project$Main$ParticipantPackageSettingsLoaded,
						A5(_user$project$Page_ParticipantReportSettings$init, model.session, _p7._0._0, _p7._0._1, _p7._0._2, _user$project$Page_Product$Package))
				};
			case 'AccessDenied':
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{page: _user$project$Main$AccessDenied}),
					_1: _elm_lang$core$Platform_Cmd$none
				};
			default:
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{page: _user$project$Main$Error}),
					_1: _elm_lang$core$Platform_Cmd$none
				};
		}
	});
var _user$project$Main$update = F2(
	function (msg, model) {
		var toModal = F5(
			function (toModel, toMsg, subUpdate, subMsg, subModel) {
				var _p9 = A3(subUpdate, subMsg, subModel, model.session);
				var newSubModel = _p9._0._0;
				var subCmd = _p9._0._1;
				var resultMsg = _p9._1;
				var _p10 = resultMsg;
				if (_p10.ctor === 'NoOp') {
					return {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{
								modal: toModel(newSubModel)
							}),
						_1: A2(
							_elm_lang$core$Platform_Cmd$map,
							toMsg(newSubModel),
							subCmd)
					};
				} else {
					return {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{modal: _user$project$Main$None}),
						_1: A2(
							_elm_lang$core$Platform_Cmd$map,
							toMsg(newSubModel),
							subCmd)
					};
				}
			});
		var toPageWithModal = F5(
			function (toModel, toMsg, subUpdate, subMsg, subModel) {
				var _p11 = A3(subUpdate, subMsg, subModel, model.session);
				var newSubModel = _p11._0._0;
				var subCmd = _p11._0._1;
				var requestedModal = _p11._1;
				var _p12 = requestedModal;
				if (_p12.ctor === 'None') {
					return {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{
								page: toModel(newSubModel)
							}),
						_1: A2(_elm_lang$core$Platform_Cmd$map, toMsg, subCmd)
					};
				} else {
					return A2(
						_user$project$Main$update,
						A2(
							_user$project$Main$ProjectModalMsg,
							_user$project$Page_ProjectModal$init(_p12._0),
							_user$project$Page_ProjectModal$Open),
						model);
				}
			});
		var toPage = F5(
			function (toModel, toMsg, subUpdate, subMsg, subModel) {
				var _p13 = A3(subUpdate, subMsg, subModel, model.session);
				var newSubModel = _p13._0;
				var subCmd = _p13._1;
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							page: toModel(newSubModel)
						}),
					_1: A2(_elm_lang$core$Platform_Cmd$map, toMsg, subCmd)
				};
			});
		var _p14 = {ctor: '_Tuple2', _0: msg, _1: model.page};
		_v6_34:
		do {
			switch (_p14._0.ctor) {
				case 'SetRoute':
					return A2(_user$project$Main$setRoute, _p14._0._0, model);
				case 'SetClientInfo':
					if (_p14._0._0.ctor === 'Ok') {
						var newMenu = A2(
							_user$project$Page_Menu$setClients,
							_p14._0._0._0,
							function (_) {
								return _.menu;
							}(model));
						var newModelMenu = _elm_lang$core$Native_Utils.update(
							model,
							{menu: newMenu});
						return A2(
							_user$project$Main$setRoute,
							_user$project$Route$fromLocation(model.location),
							newModelMenu);
					} else {
						return {
							ctor: '_Tuple2',
							_0: model,
							_1: _user$project$Route$error(_p14._0._0._0)
						};
					}
				case 'SearchLoaded':
					if (_p14._0._0.ctor === 'Ok') {
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{
									page: _user$project$Main$Search(_p14._0._0._0)
								}),
							_1: _elm_lang$core$Platform_Cmd$none
						};
					} else {
						if (_p14._0._0._0.ctor === 'HttpError') {
							return {
								ctor: '_Tuple2',
								_0: model,
								_1: _user$project$Route$error(_p14._0._0._0._0)
							};
						} else {
							return {
								ctor: '_Tuple2',
								_0: model,
								_1: _user$project$Route$newUrl(_user$project$Route$ProjectLibrary)
							};
						}
					}
				case 'ProjectLibraryLoaded':
					if (_p14._0._0.ctor === 'Ok') {
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{
									page: _user$project$Main$Library(_p14._0._0._0)
								}),
							_1: _elm_lang$core$Platform_Cmd$none
						};
					} else {
						return {
							ctor: '_Tuple2',
							_0: model,
							_1: _user$project$Route$error(_p14._0._0._0)
						};
					}
				case 'ProjectDetailLoaded':
					if (_p14._0._0.ctor === 'Ok') {
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{
									page: _user$project$Main$ProjectDetail(_p14._0._0._0)
								}),
							_1: _elm_lang$core$Platform_Cmd$none
						};
					} else {
						return {
							ctor: '_Tuple2',
							_0: model,
							_1: _user$project$Route$error(_p14._0._0._0)
						};
					}
				case 'ProjectReportSelectionLoaded':
					if (_p14._0._0.ctor === 'Ok') {
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{
									page: _user$project$Main$ProjectReportSelection(_p14._0._0._0)
								}),
							_1: _elm_lang$core$Platform_Cmd$none
						};
					} else {
						return {
							ctor: '_Tuple2',
							_0: model,
							_1: _user$project$Route$error(_p14._0._0._0)
						};
					}
				case 'ProjectReportSettingsLoaded':
					if (_p14._0._0.ctor === 'Ok') {
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{
									page: _user$project$Main$ProjectReportSettings(_p14._0._0._0)
								}),
							_1: _elm_lang$core$Platform_Cmd$none
						};
					} else {
						return {
							ctor: '_Tuple2',
							_0: model,
							_1: _user$project$Route$error(_p14._0._0._0)
						};
					}
				case 'ProjectPackageSettingsLoaded':
					if (_p14._0._0.ctor === 'Ok') {
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{
									page: _user$project$Main$ProjectReportSettings(_p14._0._0._0)
								}),
							_1: _elm_lang$core$Platform_Cmd$none
						};
					} else {
						return {
							ctor: '_Tuple2',
							_0: model,
							_1: _user$project$Route$error(_p14._0._0._0)
						};
					}
				case 'ParticipantsLoaded':
					if (_p14._0._0.ctor === 'Ok') {
						var _p15 = _p14._0._0._0;
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{
									page: _user$project$Main$Participants(_p15)
								}),
							_1: A2(
								_elm_lang$core$Platform_Cmd$map,
								_user$project$Main$ParticipantsMsg,
								A2(_user$project$Page_Participants$initializeDataTable, _p15, model.session.i18n))
						};
					} else {
						return {
							ctor: '_Tuple2',
							_0: model,
							_1: _user$project$Route$error(_p14._0._0._0)
						};
					}
				case 'ParticipantReportSettingsLoaded':
					if (_p14._0._0.ctor === 'Ok') {
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{
									page: _user$project$Main$ParticipantReportSettings(_p14._0._0._0)
								}),
							_1: _elm_lang$core$Platform_Cmd$none
						};
					} else {
						return {
							ctor: '_Tuple2',
							_0: model,
							_1: _user$project$Route$error(_p14._0._0._0)
						};
					}
				case 'ParticipantPackageSettingsLoaded':
					if (_p14._0._0.ctor === 'Ok') {
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{
									page: _user$project$Main$ParticipantReportSettings(_p14._0._0._0)
								}),
							_1: _elm_lang$core$Platform_Cmd$none
						};
					} else {
						return {
							ctor: '_Tuple2',
							_0: model,
							_1: _user$project$Route$error(_p14._0._0._0)
						};
					}
				case 'ParticipantReportSelectionLoaded':
					if (_p14._0._0.ctor === 'Ok') {
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{
									page: _user$project$Main$ParticipantReportSelection(_p14._0._0._0)
								}),
							_1: _elm_lang$core$Platform_Cmd$none
						};
					} else {
						return {
							ctor: '_Tuple2',
							_0: model,
							_1: _user$project$Route$error(_p14._0._0._0)
						};
					}
				case 'SearchMsg':
					if (_p14._1.ctor === 'Search') {
						return A5(toPageWithModal, _user$project$Main$Search, _user$project$Main$SearchMsg, _user$project$Page_Search$update, _p14._0._0, _p14._1._0);
					} else {
						break _v6_34;
					}
				case 'ProjectLibraryMsg':
					if (_p14._1.ctor === 'Library') {
						return A5(toPageWithModal, _user$project$Main$Library, _user$project$Main$ProjectLibraryMsg, _user$project$Page_ProjectLibrary$update, _p14._0._0, _p14._1._0);
					} else {
						break _v6_34;
					}
				case 'ProjectDetailMsg':
					if (_p14._1.ctor === 'ProjectDetail') {
						return A5(toPageWithModal, _user$project$Main$ProjectDetail, _user$project$Main$ProjectDetailMsg, _user$project$Page_ProjectDetail$update, _p14._0._0, _p14._1._0);
					} else {
						break _v6_34;
					}
				case 'ProjectReportSelectionMsg':
					if (_p14._1.ctor === 'ProjectReportSelection') {
						return A5(toPage, _user$project$Main$ProjectReportSelection, _user$project$Main$ProjectReportSelectionMsg, _user$project$Page_ReportSelection$update, _p14._0._0, _p14._1._0);
					} else {
						break _v6_34;
					}
				case 'ProjectReportSettingsMsg':
					if (_p14._1.ctor === 'ProjectReportSettings') {
						return A5(toPage, _user$project$Main$ProjectReportSettings, _user$project$Main$ProjectReportSettingsMsg, _user$project$Page_ProjectReportSettings$update, _p14._0._0, _p14._1._0);
					} else {
						break _v6_34;
					}
				case 'ParticipantsMsg':
					if (_p14._1.ctor === 'Participants') {
						return A5(toPage, _user$project$Main$Participants, _user$project$Main$ParticipantsMsg, _user$project$Page_Participants$update, _p14._0._0, _p14._1._0);
					} else {
						break _v6_34;
					}
				case 'ParticipantReportSelectionMsg':
					if (_p14._1.ctor === 'ParticipantReportSelection') {
						return A5(toPage, _user$project$Main$ParticipantReportSelection, _user$project$Main$ParticipantReportSelectionMsg, _user$project$Page_ReportSelection$update, _p14._0._0, _p14._1._0);
					} else {
						break _v6_34;
					}
				case 'ParticipantReportSettingsMsg':
					if (_p14._1.ctor === 'ParticipantReportSettings') {
						return A5(toPage, _user$project$Main$ParticipantReportSettings, _user$project$Main$ParticipantReportSettingsMsg, _user$project$Page_ParticipantReportSettings$update, _p14._0._0, _p14._1._0);
					} else {
						break _v6_34;
					}
				case 'MenuMsg':
					var _p18 = _p14._0._0;
					var newSession = function () {
						var _p16 = _p18;
						if (_p16.ctor === 'SetActiveClient') {
							var oldSession = model.session;
							return _elm_lang$core$Native_Utils.update(
								oldSession,
								{activeClient: _p16._0});
						} else {
							return model.session;
						}
					}();
					var _p17 = A2(_user$project$Page_Menu$update, _p18, model.menu);
					var newSubModel = _p17._0;
					var subCmd = _p17._1;
					return {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{menu: newSubModel, session: newSession}),
						_1: A2(_elm_lang$core$Platform_Cmd$map, _user$project$Main$MenuMsg, subCmd)
					};
				default:
					return A5(toModal, _user$project$Main$ProjectName, _user$project$Main$ProjectModalMsg, _user$project$Page_ProjectModal$update, _p14._0._1, _p14._0._0);
			}
		} while(false);
		return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
	});
var _user$project$Main$wrapLastAction = F2(
	function (msg, model) {
		var _p19 = A2(_user$project$Main$update, msg, model);
		var subModel = _p19._0;
		var subMsg = _p19._1;
		return {
			ctor: '_Tuple2',
			_0: subModel,
			_1: _elm_lang$core$Platform_Cmd$batch(
				{
					ctor: '::',
					_0: _user$project$Main$notifyOfAction(
						{ctor: '_Tuple0'}),
					_1: {
						ctor: '::',
						_0: subMsg,
						_1: {ctor: '[]'}
					}
				})
		};
	});
var _user$project$Main$SetRoute = function (a) {
	return {ctor: 'SetRoute', _0: a};
};
var _user$project$Main$main = A2(
	_elm_lang$navigation$Navigation$programWithFlags,
	function (_p20) {
		return _user$project$Main$SetRoute(
			_user$project$Route$fromLocation(_p20));
	},
	{init: _user$project$Main$init, view: _user$project$Main$view, update: _user$project$Main$wrapLastAction, subscriptions: _user$project$Main$subscriptions})(
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (accessToken) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (activeClient) {
					return A2(
						_elm_lang$core$Json_Decode$andThen,
						function (clients) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (haloLiteApi) {
									return A2(
										_elm_lang$core$Json_Decode$andThen,
										function (i18nAFewSecondsAgo) {
											return A2(
												_elm_lang$core$Json_Decode$andThen,
												function (i18nAccessDenied) {
													return A2(
														_elm_lang$core$Json_Decode$andThen,
														function (i18nActive) {
															return A2(
																_elm_lang$core$Json_Decode$andThen,
																function (i18nAdd) {
																	return A2(
																		_elm_lang$core$Json_Decode$andThen,
																		function (i18nAddParticipants) {
																			return A2(
																				_elm_lang$core$Json_Decode$andThen,
																				function (i18nAddParticipantsModalDescription) {
																					return A2(
																						_elm_lang$core$Json_Decode$andThen,
																						function (i18nAddParticipantsToStartProject) {
																							return A2(
																								_elm_lang$core$Json_Decode$andThen,
																								function (i18nAddReport) {
																									return A2(
																										_elm_lang$core$Json_Decode$andThen,
																										function (i18nAllProjects) {
																											return A2(
																												_elm_lang$core$Json_Decode$andThen,
																												function (i18nAlreadySelectedReportContainedInPackage) {
																													return A2(
																														_elm_lang$core$Json_Decode$andThen,
																														function (i18nApr) {
																															return A2(
																																_elm_lang$core$Json_Decode$andThen,
																																function (i18nApril) {
																																	return A2(
																																		_elm_lang$core$Json_Decode$andThen,
																																		function (i18nAssessments) {
																																			return A2(
																																				_elm_lang$core$Json_Decode$andThen,
																																				function (i18nAug) {
																																					return A2(
																																						_elm_lang$core$Json_Decode$andThen,
																																						function (i18nAugust) {
																																							return A2(
																																								_elm_lang$core$Json_Decode$andThen,
																																								function (i18nBackToProjectDashboard) {
																																									return A2(
																																										_elm_lang$core$Json_Decode$andThen,
																																										function (i18nBackToProjectDetail) {
																																											return A2(
																																												_elm_lang$core$Json_Decode$andThen,
																																												function (i18nCancel) {
																																													return A2(
																																														_elm_lang$core$Json_Decode$andThen,
																																														function (i18nChangeBillableSettingWarning) {
																																															return A2(
																																																_elm_lang$core$Json_Decode$andThen,
																																																function (i18nClickHereToDownloadIds) {
																																																	return A2(
																																																		_elm_lang$core$Json_Decode$andThen,
																																																		function (i18nClients) {
																																																			return A2(
																																																				_elm_lang$core$Json_Decode$andThen,
																																																				function (i18nComplete) {
																																																					return A2(
																																																						_elm_lang$core$Json_Decode$andThen,
																																																						function (i18nCompleted) {
																																																							return A2(
																																																								_elm_lang$core$Json_Decode$andThen,
																																																								function (i18nContactSupport) {
																																																									return A2(
																																																										_elm_lang$core$Json_Decode$andThen,
																																																										function (i18nContinueWith) {
																																																											return A2(
																																																												_elm_lang$core$Json_Decode$andThen,
																																																												function (i18nCreated) {
																																																													return A2(
																																																														_elm_lang$core$Json_Decode$andThen,
																																																														function (i18nCreatedDate) {
																																																															return A2(
																																																																_elm_lang$core$Json_Decode$andThen,
																																																																function (i18nCurrent) {
																																																																	return A2(
																																																																		_elm_lang$core$Json_Decode$andThen,
																																																																		function (i18nDateFormat) {
																																																																			return A2(
																																																																				_elm_lang$core$Json_Decode$andThen,
																																																																				function (i18nDaysAgoFormat) {
																																																																					return A2(
																																																																						_elm_lang$core$Json_Decode$andThen,
																																																																						function (i18nDec) {
																																																																							return A2(
																																																																								_elm_lang$core$Json_Decode$andThen,
																																																																								function (i18nDecember) {
																																																																									return A2(
																																																																										_elm_lang$core$Json_Decode$andThen,
																																																																										function (i18nDownload) {
																																																																											return A2(
																																																																												_elm_lang$core$Json_Decode$andThen,
																																																																												function (i18nDownloadReport) {
																																																																													return A2(
																																																																														_elm_lang$core$Json_Decode$andThen,
																																																																														function (i18nDownloadReports) {
																																																																															return A2(
																																																																																_elm_lang$core$Json_Decode$andThen,
																																																																																function (i18nDownloadUnusedIds) {
																																																																																	return A2(
																																																																																		_elm_lang$core$Json_Decode$andThen,
																																																																																		function (i18nDraft) {
																																																																																			return A2(
																																																																																				_elm_lang$core$Json_Decode$andThen,
																																																																																				function (i18nDuplicateEmailAddressForProjectParticipant) {
																																																																																					return A2(
																																																																																						_elm_lang$core$Json_Decode$andThen,
																																																																																						function (i18nEdit) {
																																																																																							return A2(
																																																																																								_elm_lang$core$Json_Decode$andThen,
																																																																																								function (i18nEditReports) {
																																																																																									return A2(
																																																																																										_elm_lang$core$Json_Decode$andThen,
																																																																																										function (i18nEmail) {
																																																																																											return A2(
																																																																																												_elm_lang$core$Json_Decode$andThen,
																																																																																												function (i18nEmailAddress) {
																																																																																													return A2(
																																																																																														_elm_lang$core$Json_Decode$andThen,
																																																																																														function (i18nEmailContainsDoubleDot) {
																																																																																															return A2(
																																																																																																_elm_lang$core$Json_Decode$andThen,
																																																																																																function (i18nEmailFailed) {
																																																																																																	return A2(
																																																																																																		_elm_lang$core$Json_Decode$andThen,
																																																																																																		function (i18nEmailInvalid) {
																																																																																																			return A2(
																																																																																																				_elm_lang$core$Json_Decode$andThen,
																																																																																																				function (i18nEmailLacksDotInDomain) {
																																																																																																					return A2(
																																																																																																						_elm_lang$core$Json_Decode$andThen,
																																																																																																						function (i18nEmailRequired) {
																																																																																																							return A2(
																																																																																																								_elm_lang$core$Json_Decode$andThen,
																																																																																																								function (i18nEmailSuccess) {
																																																																																																									return A2(
																																																																																																										_elm_lang$core$Json_Decode$andThen,
																																																																																																										function (i18nEmailSuccessfullySent) {
																																																																																																											return A2(
																																																																																																												_elm_lang$core$Json_Decode$andThen,
																																																																																																												function (i18nEmailTooLong) {
																																																																																																													return A2(
																																																																																																														_elm_lang$core$Json_Decode$andThen,
																																																																																																														function (i18nEmptyWarning) {
																																																																																																															return A2(
																																																																																																																_elm_lang$core$Json_Decode$andThen,
																																																																																																																function (i18nEnterEmailAddress) {
																																																																																																																	return A2(
																																																																																																																		_elm_lang$core$Json_Decode$andThen,
																																																																																																																		function (i18nEnterValueWithinRange) {
																																																																																																																			return A2(
																																																																																																																				_elm_lang$core$Json_Decode$andThen,
																																																																																																																				function (i18nError) {
																																																																																																																					return A2(
																																																																																																																						_elm_lang$core$Json_Decode$andThen,
																																																																																																																						function (i18nErrorSavingEmail) {
																																																																																																																							return A2(
																																																																																																																								_elm_lang$core$Json_Decode$andThen,
																																																																																																																								function (i18nErrorWithRequest) {
																																																																																																																									return A2(
																																																																																																																										_elm_lang$core$Json_Decode$andThen,
																																																																																																																										function (i18nExitMessage) {
																																																																																																																											return A2(
																																																																																																																												_elm_lang$core$Json_Decode$andThen,
																																																																																																																												function (i18nExitWithoutSaving) {
																																																																																																																													return A2(
																																																																																																																														_elm_lang$core$Json_Decode$andThen,
																																																																																																																														function (i18nFailedToSend) {
																																																																																																																															return A2(
																																																																																																																																_elm_lang$core$Json_Decode$andThen,
																																																																																																																																function (i18nFailedToSendEmail) {
																																																																																																																																	return A2(
																																																																																																																																		_elm_lang$core$Json_Decode$andThen,
																																																																																																																																		function (i18nFeb) {
																																																																																																																																			return A2(
																																																																																																																																				_elm_lang$core$Json_Decode$andThen,
																																																																																																																																				function (i18nFebruary) {
																																																																																																																																					return A2(
																																																																																																																																						_elm_lang$core$Json_Decode$andThen,
																																																																																																																																						function (i18nFirstName) {
																																																																																																																																							return A2(
																																																																																																																																								_elm_lang$core$Json_Decode$andThen,
																																																																																																																																								function (i18nFirstNameRequired) {
																																																																																																																																									return A2(
																																																																																																																																										_elm_lang$core$Json_Decode$andThen,
																																																																																																																																										function (i18nFri) {
																																																																																																																																											return A2(
																																																																																																																																												_elm_lang$core$Json_Decode$andThen,
																																																																																																																																												function (i18nFriday) {
																																																																																																																																													return A2(
																																																																																																																																														_elm_lang$core$Json_Decode$andThen,
																																																																																																																																														function (i18nGenerateIds) {
																																																																																																																																															return A2(
																																																																																																																																																_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																function (i18nGenerateIdsTitle) {
																																																																																																																																																	return A2(
																																																																																																																																																		_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																		function (i18nGenerateNewIds) {
																																																																																																																																																			return A2(
																																																																																																																																																				_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																				function (i18nGenericError) {
																																																																																																																																																					return A2(
																																																																																																																																																						_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																						function (i18nGoBack) {
																																																																																																																																																							return A2(
																																																																																																																																																								_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																								function (i18nGoToParticipantsPage) {
																																																																																																																																																									return A2(
																																																																																																																																																										_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																										function (i18nHelpfulLinks) {
																																																																																																																																																											return A2(
																																																																																																																																																												_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																												function (i18nHoganIdWithOctothorpe) {
																																																																																																																																																													return A2(
																																																																																																																																																														_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																														function (i18nHoganIdWithoutOctothorpe) {
																																																																																																																																																															return A2(
																																																																																																																																																																_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																function (i18nHoganPrivacyPolicy) {
																																																																																																																																																																	return A2(
																																																																																																																																																																		_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																		function (i18nHoursAgoFormat) {
																																																																																																																																																																			return A2(
																																																																																																																																																																				_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																				function (i18nInactive) {
																																																																																																																																																																					return A2(
																																																																																																																																																																						_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																						function (i18nInvalidEmailAddress) {
																																																																																																																																																																							return A2(
																																																																																																																																																																								_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																								function (i18nInviteParticipants) {
																																																																																																																																																																									return A2(
																																																																																																																																																																										_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																										function (i18nJan) {
																																																																																																																																																																											return A2(
																																																																																																																																																																												_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																												function (i18nJanuary) {
																																																																																																																																																																													return A2(
																																																																																																																																																																														_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																														function (i18nJobProfile) {
																																																																																																																																																																															return A2(
																																																																																																																																																																																_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																function (i18nJul) {
																																																																																																																																																																																	return A2(
																																																																																																																																																																																		_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																		function (i18nJuly) {
																																																																																																																																																																																			return A2(
																																																																																																																																																																																				_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																				function (i18nJun) {
																																																																																																																																																																																					return A2(
																																																																																																																																																																																						_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																						function (i18nJune) {
																																																																																																																																																																																							return A2(
																																																																																																																																																																																								_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																								function (i18nLanguage) {
																																																																																																																																																																																									return A2(
																																																																																																																																																																																										_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																										function (i18nLanguages) {
																																																																																																																																																																																											return A2(
																																																																																																																																																																																												_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																												function (i18nLastName) {
																																																																																																																																																																																													return A2(
																																																																																																																																																																																														_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																														function (i18nLastNameCannotBeAsterisk) {
																																																																																																																																																																																															return A2(
																																																																																																																																																																																																_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																function (i18nLastNameRequired) {
																																																																																																																																																																																																	return A2(
																																																																																																																																																																																																		_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																		function (i18nLoadingMessage) {
																																																																																																																																																																																																			return A2(
																																																																																																																																																																																																				_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																				function (i18nLoadingParticipants) {
																																																																																																																																																																																																					return A2(
																																																																																																																																																																																																						_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																						function (i18nLoadingProjects) {
																																																																																																																																																																																																							return A2(
																																																																																																																																																																																																								_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																								function (i18nLoggedInAs) {
																																																																																																																																																																																																									return A2(
																																																																																																																																																																																																										_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																										function (i18nLogout) {
																																																																																																																																																																																																											return A2(
																																																																																																																																																																																																												_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																												function (i18nMar) {
																																																																																																																																																																																																													return A2(
																																																																																																																																																																																																														_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																														function (i18nMarch) {
																																																																																																																																																																																																															return A2(
																																																																																																																																																																																																																_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																function (i18nMay) {
																																																																																																																																																																																																																	return A2(
																																																																																																																																																																																																																		_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																		function (i18nMinutesAgoFormat) {
																																																																																																																																																																																																																			return A2(
																																																																																																																																																																																																																				_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																				function (i18nModifyReports) {
																																																																																																																																																																																																																					return A2(
																																																																																																																																																																																																																						_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																						function (i18nMon) {
																																																																																																																																																																																																																							return A2(
																																																																																																																																																																																																																								_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																								function (i18nMonday) {
																																																																																																																																																																																																																									return A2(
																																																																																																																																																																																																																										_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																										function (i18nMonthsAgoFormat) {
																																																																																																																																																																																																																											return A2(
																																																																																																																																																																																																																												_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																												function (i18nMyReports) {
																																																																																																																																																																																																																													return A2(
																																																																																																																																																																																																																														_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																														function (i18nName) {
																																																																																																																																																																																																																															return A2(
																																																																																																																																																																																																																																_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																function (i18nNameContainsInvalidCharacters) {
																																																																																																																																																																																																																																	return A2(
																																																																																																																																																																																																																																		_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																		function (i18nNameDuplicate) {
																																																																																																																																																																																																																																			return A2(
																																																																																																																																																																																																																																				_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																				function (i18nNameIsConfigure) {
																																																																																																																																																																																																																																					return A2(
																																																																																																																																																																																																																																						_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																						function (i18nNameLength) {
																																																																																																																																																																																																																																							return A2(
																																																																																																																																																																																																																																								_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																								function (i18nNameRequired) {
																																																																																																																																																																																																																																									return A2(
																																																																																																																																																																																																																																										_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																										function (i18nNewProject) {
																																																																																																																																																																																																																																											return A2(
																																																																																																																																																																																																																																												_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																												function (i18nNext) {
																																																																																																																																																																																																																																													return A2(
																																																																																																																																																																																																																																														_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																														function (i18nNoParticipants) {
																																																																																																																																																																																																																																															return A2(
																																																																																																																																																																																																																																																_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																function (i18nNoProjects) {
																																																																																																																																																																																																																																																	return A2(
																																																																																																																																																																																																																																																		_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																		function (i18nNoResultsWereFound) {
																																																																																																																																																																																																																																																			return A2(
																																																																																																																																																																																																																																																				_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																				function (i18nNorm) {
																																																																																																																																																																																																																																																					return A2(
																																																																																																																																																																																																																																																						_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																						function (i18nNotice) {
																																																																																																																																																																																																																																																							return A2(
																																																																																																																																																																																																																																																								_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																								function (i18nNotificationsFor) {
																																																																																																																																																																																																																																																									return A2(
																																																																																																																																																																																																																																																										_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																										function (i18nNotificationsMessage) {
																																																																																																																																																																																																																																																											return A2(
																																																																																																																																																																																																																																																												_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																												function (i18nNov) {
																																																																																																																																																																																																																																																													return A2(
																																																																																																																																																																																																																																																														_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																														function (i18nNovember) {
																																																																																																																																																																																																																																																															return A2(
																																																																																																																																																																																																																																																																_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																function (i18nNumberOfIdsToGenerate) {
																																																																																																																																																																																																																																																																	return A2(
																																																																																																																																																																																																																																																																		_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																		function (i18nOct) {
																																																																																																																																																																																																																																																																			return A2(
																																																																																																																																																																																																																																																																				_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																				function (i18nOctober) {
																																																																																																																																																																																																																																																																					return A2(
																																																																																																																																																																																																																																																																						_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																						function (i18nOk) {
																																																																																																																																																																																																																																																																							return A2(
																																																																																																																																																																																																																																																																								_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																								function (i18nOneDayAgo) {
																																																																																																																																																																																																																																																																									return A2(
																																																																																																																																																																																																																																																																										_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																										function (i18nOneHourAgo) {
																																																																																																																																																																																																																																																																											return A2(
																																																																																																																																																																																																																																																																												_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																												function (i18nOneMinuteAgo) {
																																																																																																																																																																																																																																																																													return A2(
																																																																																																																																																																																																																																																																														_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																														function (i18nOneMonthAgo) {
																																																																																																																																																																																																																																																																															return A2(
																																																																																																																																																																																																																																																																																_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																function (i18nOneWeekAgo) {
																																																																																																																																																																																																																																																																																	return A2(
																																																																																																																																																																																																																																																																																		_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																		function (i18nOneYearAgo) {
																																																																																																																																																																																																																																																																																			return A2(
																																																																																																																																																																																																																																																																																				_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																				function (i18nParticipant) {
																																																																																																																																																																																																																																																																																					return A2(
																																																																																																																																																																																																																																																																																						_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																						function (i18nParticipantStatus) {
																																																																																																																																																																																																																																																																																							return A2(
																																																																																																																																																																																																																																																																																								_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																								function (i18nParticipants) {
																																																																																																																																																																																																																																																																																									return A2(
																																																																																																																																																																																																																																																																																										_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																										function (i18nParticipantsHaveBeenAddedAndInvitationsSent) {
																																																																																																																																																																																																																																																																																											return A2(
																																																																																																																																																																																																																																																																																												_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																												function (i18nPending) {
																																																																																																																																																																																																																																																																																													return A2(
																																																																																																																																																																																																																																																																																														_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																														function (i18nPleaseSelectReports) {
																																																																																																																																																																																																																																																																																															return A2(
																																																																																																																																																																																																																																																																																																_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																function (i18nProgressCounter) {
																																																																																																																																																																																																																																																																																																	return A2(
																																																																																																																																																																																																																																																																																																		_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																		function (i18nProject) {
																																																																																																																																																																																																																																																																																																			return A2(
																																																																																																																																																																																																																																																																																																				_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																				function (i18nProjectInformation) {
																																																																																																																																																																																																																																																																																																					return A2(
																																																																																																																																																																																																																																																																																																						_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																						function (i18nProjectNameValidationHint) {
																																																																																																																																																																																																																																																																																																							return A2(
																																																																																																																																																																																																																																																																																																								_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																								function (i18nProjectTitle) {
																																																																																																																																																																																																																																																																																																									return A2(
																																																																																																																																																																																																																																																																																																										_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																										function (i18nProjects) {
																																																																																																																																																																																																																																																																																																											return A2(
																																																																																																																																																																																																																																																																																																												_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																												function (i18nRemoveReport) {
																																																																																																																																																																																																																																																																																																													return A2(
																																																																																																																																																																																																																																																																																																														_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																														function (i18nReports) {
																																																																																																																																																																																																																																																																																																															return A2(
																																																																																																																																																																																																																																																																																																																_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																function (i18nRescoreReport) {
																																																																																																																																																																																																																																																																																																																	return A2(
																																																																																																																																																																																																																																																																																																																		_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																		function (i18nRescoreReportInProgress) {
																																																																																																																																																																																																																																																																																																																			return A2(
																																																																																																																																																																																																																																																																																																																				_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																				function (i18nResendInvitation) {
																																																																																																																																																																																																																																																																																																																					return A2(
																																																																																																																																																																																																																																																																																																																						_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																						function (i18nSat) {
																																																																																																																																																																																																																																																																																																																							return A2(
																																																																																																																																																																																																																																																																																																																								_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																								function (i18nSaturday) {
																																																																																																																																																																																																																																																																																																																									return A2(
																																																																																																																																																																																																																																																																																																																										_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																										function (i18nSave) {
																																																																																																																																																																																																																																																																																																																											return A2(
																																																																																																																																																																																																																																																																																																																												_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																												function (i18nSaveChanges) {
																																																																																																																																																																																																																																																																																																																													return A2(
																																																																																																																																																																																																																																																																																																																														_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																														function (i18nSearch) {
																																																																																																																																																																																																																																																																																																																															return A2(
																																																																																																																																																																																																																																																																																																																																_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																function (i18nSearchParticipantsFor) {
																																																																																																																																																																																																																																																																																																																																	return A2(
																																																																																																																																																																																																																																																																																																																																		_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																		function (i18nSelectReportPrompt) {
																																																																																																																																																																																																																																																																																																																																			return A2(
																																																																																																																																																																																																																																																																																																																																				_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																				function (i18nSelectedReports) {
																																																																																																																																																																																																																																																																																																																																					return A2(
																																																																																																																																																																																																																																																																																																																																						_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																						function (i18nSendReminder) {
																																																																																																																																																																																																																																																																																																																																							return A2(
																																																																																																																																																																																																																																																																																																																																								_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																								function (i18nSendSampleInvitation) {
																																																																																																																																																																																																																																																																																																																																									return A2(
																																																																																																																																																																																																																																																																																																																																										_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																										function (i18nSent) {
																																																																																																																																																																																																																																																																																																																																											return A2(
																																																																																																																																																																																																																																																																																																																																												_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																												function (i18nSep) {
																																																																																																																																																																																																																																																																																																																																													return A2(
																																																																																																																																																																																																																																																																																																																																														_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																														function (i18nSeptember) {
																																																																																																																																																																																																																																																																																																																																															return A2(
																																																																																																																																																																																																																																																																																																																																																_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																function (i18nSettings) {
																																																																																																																																																																																																																																																																																																																																																	return A2(
																																																																																																																																																																																																																																																																																																																																																		_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																		function (i18nStatus) {
																																																																																																																																																																																																																																																																																																																																																			return A2(
																																																																																																																																																																																																																																																																																																																																																				_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																				function (i18nSun) {
																																																																																																																																																																																																																																																																																																																																																					return A2(
																																																																																																																																																																																																																																																																																																																																																						_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																						function (i18nSunday) {
																																																																																																																																																																																																																																																																																																																																																							return A2(
																																																																																																																																																																																																																																																																																																																																																								_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																								function (i18nTermsOfUse) {
																																																																																																																																																																																																																																																																																																																																																									return A2(
																																																																																																																																																																																																																																																																																																																																																										_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																										function (i18nTheseChangesWillNotImpactGeneratedReports) {
																																																																																																																																																																																																																																																																																																																																																											return A2(
																																																																																																																																																																																																																																																																																																																																																												_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																												function (i18nThisEmailIsInvalid) {
																																																																																																																																																																																																																																																																																																																																																													return A2(
																																																																																																																																																																																																																																																																																																																																																														_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																														function (i18nThurs) {
																																																																																																																																																																																																																																																																																																																																																															return A2(
																																																																																																																																																																																																																																																																																																																																																																_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																																function (i18nThursday) {
																																																																																																																																																																																																																																																																																																																																																																	return A2(
																																																																																																																																																																																																																																																																																																																																																																		_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																																		function (i18nToggleNavigationLore) {
																																																																																																																																																																																																																																																																																																																																																																			return A2(
																																																																																																																																																																																																																																																																																																																																																																				_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																																				function (i18nTues) {
																																																																																																																																																																																																																																																																																																																																																																					return A2(
																																																																																																																																																																																																																																																																																																																																																																						_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																																						function (i18nTuesday) {
																																																																																																																																																																																																																																																																																																																																																																							return A2(
																																																																																																																																																																																																																																																																																																																																																																								_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																																								function (i18nUniqueIdWithOctothorpe) {
																																																																																																																																																																																																																																																																																																																																																																									return A2(
																																																																																																																																																																																																																																																																																																																																																																										_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																																										function (i18nUpdateAllReports) {
																																																																																																																																																																																																																																																																																																																																																																											return A2(
																																																																																																																																																																																																																																																																																																																																																																												_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																																												function (i18nUser) {
																																																																																																																																																																																																																																																																																																																																																																													return A2(
																																																																																																																																																																																																																																																																																																																																																																														_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																																														function (i18nUserGuide) {
																																																																																																																																																																																																																																																																																																																																																																															return A2(
																																																																																																																																																																																																																																																																																																																																																																																_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																																																function (i18nViewReportOptionsText) {
																																																																																																																																																																																																																																																																																																																																																																																	return A2(
																																																																																																																																																																																																																																																																																																																																																																																		_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																																																		function (i18nWed) {
																																																																																																																																																																																																																																																																																																																																																																																			return A2(
																																																																																																																																																																																																																																																																																																																																																																																				_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																																																				function (i18nWednesday) {
																																																																																																																																																																																																																																																																																																																																																																																					return A2(
																																																																																																																																																																																																																																																																																																																																																																																						_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																																																						function (i18nWeeksAgoFormat) {
																																																																																																																																																																																																																																																																																																																																																																																							return A2(
																																																																																																																																																																																																																																																																																																																																																																																								_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																																																								function (i18nYearsAgoFormat) {
																																																																																																																																																																																																																																																																																																																																																																																									return A2(
																																																																																																																																																																																																																																																																																																																																																																																										_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																																																										function (i18nYouHaveChoseToUpdateGeneratedReports) {
																																																																																																																																																																																																																																																																																																																																																																																											return A2(
																																																																																																																																																																																																																																																																																																																																																																																												_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																																																												function (i18nYouHaveChosenToMakeBillableChangesToGeneratedReports) {
																																																																																																																																																																																																																																																																																																																																																																																													return A2(
																																																																																																																																																																																																																																																																																																																																																																																														_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																																																														function (i18nYouHaveSuccessfullyGeneratedIds) {
																																																																																																																																																																																																																																																																																																																																																																																															return A2(
																																																																																																																																																																																																																																																																																																																																																																																																_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																																																																function (i18nYouMustAddReports) {
																																																																																																																																																																																																																																																																																																																																																																																																	return A2(
																																																																																																																																																																																																																																																																																																																																																																																																		_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																																																																		function (readOnly) {
																																																																																																																																																																																																																																																																																																																																																																																																			return A2(
																																																																																																																																																																																																																																																																																																																																																																																																				_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																																																																				function (reportFileService) {
																																																																																																																																																																																																																																																																																																																																																																																																					return A2(
																																																																																																																																																																																																																																																																																																																																																																																																						_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																																																																						function (termsAndConditions) {
																																																																																																																																																																																																																																																																																																																																																																																																							return A2(
																																																																																																																																																																																																																																																																																																																																																																																																								_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																																																																																																																																																																																																																																								function (userEmail) {
																																																																																																																																																																																																																																																																																																																																																																																																									return _elm_lang$core$Json_Decode$succeed(
																																																																																																																																																																																																																																																																																																																																																																																																										{accessToken: accessToken, activeClient: activeClient, clients: clients, haloLiteApi: haloLiteApi, i18nAFewSecondsAgo: i18nAFewSecondsAgo, i18nAccessDenied: i18nAccessDenied, i18nActive: i18nActive, i18nAdd: i18nAdd, i18nAddParticipants: i18nAddParticipants, i18nAddParticipantsModalDescription: i18nAddParticipantsModalDescription, i18nAddParticipantsToStartProject: i18nAddParticipantsToStartProject, i18nAddReport: i18nAddReport, i18nAllProjects: i18nAllProjects, i18nAlreadySelectedReportContainedInPackage: i18nAlreadySelectedReportContainedInPackage, i18nApr: i18nApr, i18nApril: i18nApril, i18nAssessments: i18nAssessments, i18nAug: i18nAug, i18nAugust: i18nAugust, i18nBackToProjectDashboard: i18nBackToProjectDashboard, i18nBackToProjectDetail: i18nBackToProjectDetail, i18nCancel: i18nCancel, i18nChangeBillableSettingWarning: i18nChangeBillableSettingWarning, i18nClickHereToDownloadIds: i18nClickHereToDownloadIds, i18nClients: i18nClients, i18nComplete: i18nComplete, i18nCompleted: i18nCompleted, i18nContactSupport: i18nContactSupport, i18nContinueWith: i18nContinueWith, i18nCreated: i18nCreated, i18nCreatedDate: i18nCreatedDate, i18nCurrent: i18nCurrent, i18nDateFormat: i18nDateFormat, i18nDaysAgoFormat: i18nDaysAgoFormat, i18nDec: i18nDec, i18nDecember: i18nDecember, i18nDownload: i18nDownload, i18nDownloadReport: i18nDownloadReport, i18nDownloadReports: i18nDownloadReports, i18nDownloadUnusedIds: i18nDownloadUnusedIds, i18nDraft: i18nDraft, i18nDuplicateEmailAddressForProjectParticipant: i18nDuplicateEmailAddressForProjectParticipant, i18nEdit: i18nEdit, i18nEditReports: i18nEditReports, i18nEmail: i18nEmail, i18nEmailAddress: i18nEmailAddress, i18nEmailContainsDoubleDot: i18nEmailContainsDoubleDot, i18nEmailFailed: i18nEmailFailed, i18nEmailInvalid: i18nEmailInvalid, i18nEmailLacksDotInDomain: i18nEmailLacksDotInDomain, i18nEmailRequired: i18nEmailRequired, i18nEmailSuccess: i18nEmailSuccess, i18nEmailSuccessfullySent: i18nEmailSuccessfullySent, i18nEmailTooLong: i18nEmailTooLong, i18nEmptyWarning: i18nEmptyWarning, i18nEnterEmailAddress: i18nEnterEmailAddress, i18nEnterValueWithinRange: i18nEnterValueWithinRange, i18nError: i18nError, i18nErrorSavingEmail: i18nErrorSavingEmail, i18nErrorWithRequest: i18nErrorWithRequest, i18nExitMessage: i18nExitMessage, i18nExitWithoutSaving: i18nExitWithoutSaving, i18nFailedToSend: i18nFailedToSend, i18nFailedToSendEmail: i18nFailedToSendEmail, i18nFeb: i18nFeb, i18nFebruary: i18nFebruary, i18nFirstName: i18nFirstName, i18nFirstNameRequired: i18nFirstNameRequired, i18nFri: i18nFri, i18nFriday: i18nFriday, i18nGenerateIds: i18nGenerateIds, i18nGenerateIdsTitle: i18nGenerateIdsTitle, i18nGenerateNewIds: i18nGenerateNewIds, i18nGenericError: i18nGenericError, i18nGoBack: i18nGoBack, i18nGoToParticipantsPage: i18nGoToParticipantsPage, i18nHelpfulLinks: i18nHelpfulLinks, i18nHoganIdWithOctothorpe: i18nHoganIdWithOctothorpe, i18nHoganIdWithoutOctothorpe: i18nHoganIdWithoutOctothorpe, i18nHoganPrivacyPolicy: i18nHoganPrivacyPolicy, i18nHoursAgoFormat: i18nHoursAgoFormat, i18nInactive: i18nInactive, i18nInvalidEmailAddress: i18nInvalidEmailAddress, i18nInviteParticipants: i18nInviteParticipants, i18nJan: i18nJan, i18nJanuary: i18nJanuary, i18nJobProfile: i18nJobProfile, i18nJul: i18nJul, i18nJuly: i18nJuly, i18nJun: i18nJun, i18nJune: i18nJune, i18nLanguage: i18nLanguage, i18nLanguages: i18nLanguages, i18nLastName: i18nLastName, i18nLastNameCannotBeAsterisk: i18nLastNameCannotBeAsterisk, i18nLastNameRequired: i18nLastNameRequired, i18nLoadingMessage: i18nLoadingMessage, i18nLoadingParticipants: i18nLoadingParticipants, i18nLoadingProjects: i18nLoadingProjects, i18nLoggedInAs: i18nLoggedInAs, i18nLogout: i18nLogout, i18nMar: i18nMar, i18nMarch: i18nMarch, i18nMay: i18nMay, i18nMinutesAgoFormat: i18nMinutesAgoFormat, i18nModifyReports: i18nModifyReports, i18nMon: i18nMon, i18nMonday: i18nMonday, i18nMonthsAgoFormat: i18nMonthsAgoFormat, i18nMyReports: i18nMyReports, i18nName: i18nName, i18nNameContainsInvalidCharacters: i18nNameContainsInvalidCharacters, i18nNameDuplicate: i18nNameDuplicate, i18nNameIsConfigure: i18nNameIsConfigure, i18nNameLength: i18nNameLength, i18nNameRequired: i18nNameRequired, i18nNewProject: i18nNewProject, i18nNext: i18nNext, i18nNoParticipants: i18nNoParticipants, i18nNoProjects: i18nNoProjects, i18nNoResultsWereFound: i18nNoResultsWereFound, i18nNorm: i18nNorm, i18nNotice: i18nNotice, i18nNotificationsFor: i18nNotificationsFor, i18nNotificationsMessage: i18nNotificationsMessage, i18nNov: i18nNov, i18nNovember: i18nNovember, i18nNumberOfIdsToGenerate: i18nNumberOfIdsToGenerate, i18nOct: i18nOct, i18nOctober: i18nOctober, i18nOk: i18nOk, i18nOneDayAgo: i18nOneDayAgo, i18nOneHourAgo: i18nOneHourAgo, i18nOneMinuteAgo: i18nOneMinuteAgo, i18nOneMonthAgo: i18nOneMonthAgo, i18nOneWeekAgo: i18nOneWeekAgo, i18nOneYearAgo: i18nOneYearAgo, i18nParticipant: i18nParticipant, i18nParticipantStatus: i18nParticipantStatus, i18nParticipants: i18nParticipants, i18nParticipantsHaveBeenAddedAndInvitationsSent: i18nParticipantsHaveBeenAddedAndInvitationsSent, i18nPending: i18nPending, i18nPleaseSelectReports: i18nPleaseSelectReports, i18nProgressCounter: i18nProgressCounter, i18nProject: i18nProject, i18nProjectInformation: i18nProjectInformation, i18nProjectNameValidationHint: i18nProjectNameValidationHint, i18nProjectTitle: i18nProjectTitle, i18nProjects: i18nProjects, i18nRemoveReport: i18nRemoveReport, i18nReports: i18nReports, i18nRescoreReport: i18nRescoreReport, i18nRescoreReportInProgress: i18nRescoreReportInProgress, i18nResendInvitation: i18nResendInvitation, i18nSat: i18nSat, i18nSaturday: i18nSaturday, i18nSave: i18nSave, i18nSaveChanges: i18nSaveChanges, i18nSearch: i18nSearch, i18nSearchParticipantsFor: i18nSearchParticipantsFor, i18nSelectReportPrompt: i18nSelectReportPrompt, i18nSelectedReports: i18nSelectedReports, i18nSendReminder: i18nSendReminder, i18nSendSampleInvitation: i18nSendSampleInvitation, i18nSent: i18nSent, i18nSep: i18nSep, i18nSeptember: i18nSeptember, i18nSettings: i18nSettings, i18nStatus: i18nStatus, i18nSun: i18nSun, i18nSunday: i18nSunday, i18nTermsOfUse: i18nTermsOfUse, i18nTheseChangesWillNotImpactGeneratedReports: i18nTheseChangesWillNotImpactGeneratedReports, i18nThisEmailIsInvalid: i18nThisEmailIsInvalid, i18nThurs: i18nThurs, i18nThursday: i18nThursday, i18nToggleNavigationLore: i18nToggleNavigationLore, i18nTues: i18nTues, i18nTuesday: i18nTuesday, i18nUniqueIdWithOctothorpe: i18nUniqueIdWithOctothorpe, i18nUpdateAllReports: i18nUpdateAllReports, i18nUser: i18nUser, i18nUserGuide: i18nUserGuide, i18nViewReportOptionsText: i18nViewReportOptionsText, i18nWed: i18nWed, i18nWednesday: i18nWednesday, i18nWeeksAgoFormat: i18nWeeksAgoFormat, i18nYearsAgoFormat: i18nYearsAgoFormat, i18nYouHaveChoseToUpdateGeneratedReports: i18nYouHaveChoseToUpdateGeneratedReports, i18nYouHaveChosenToMakeBillableChangesToGeneratedReports: i18nYouHaveChosenToMakeBillableChangesToGeneratedReports, i18nYouHaveSuccessfullyGeneratedIds: i18nYouHaveSuccessfullyGeneratedIds, i18nYouMustAddReports: i18nYouMustAddReports, readOnly: readOnly, reportFileService: reportFileService, termsAndConditions: termsAndConditions, userEmail: userEmail});
																																																																																																																																																																																																																																																																																																																																																																																																								},
																																																																																																																																																																																																																																																																																																																																																																																																								A2(_elm_lang$core$Json_Decode$field, 'userEmail', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																																																																						},
																																																																																																																																																																																																																																																																																																																																																																																																						A2(_elm_lang$core$Json_Decode$field, 'termsAndConditions', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																																																																				},
																																																																																																																																																																																																																																																																																																																																																																																																				A2(_elm_lang$core$Json_Decode$field, 'reportFileService', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																																																																		},
																																																																																																																																																																																																																																																																																																																																																																																																		A2(_elm_lang$core$Json_Decode$field, 'readOnly', _elm_lang$core$Json_Decode$bool));
																																																																																																																																																																																																																																																																																																																																																																																																},
																																																																																																																																																																																																																																																																																																																																																																																																A2(_elm_lang$core$Json_Decode$field, 'i18nYouMustAddReports', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																																																														},
																																																																																																																																																																																																																																																																																																																																																																																														A2(_elm_lang$core$Json_Decode$field, 'i18nYouHaveSuccessfullyGeneratedIds', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																																																												},
																																																																																																																																																																																																																																																																																																																																																																																												A2(_elm_lang$core$Json_Decode$field, 'i18nYouHaveChosenToMakeBillableChangesToGeneratedReports', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																																																										},
																																																																																																																																																																																																																																																																																																																																																																																										A2(_elm_lang$core$Json_Decode$field, 'i18nYouHaveChoseToUpdateGeneratedReports', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																																																								},
																																																																																																																																																																																																																																																																																																																																																																																								A2(_elm_lang$core$Json_Decode$field, 'i18nYearsAgoFormat', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																																																						},
																																																																																																																																																																																																																																																																																																																																																																																						A2(_elm_lang$core$Json_Decode$field, 'i18nWeeksAgoFormat', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																																																				},
																																																																																																																																																																																																																																																																																																																																																																																				A2(_elm_lang$core$Json_Decode$field, 'i18nWednesday', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																																																		},
																																																																																																																																																																																																																																																																																																																																																																																		A2(_elm_lang$core$Json_Decode$field, 'i18nWed', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																																																},
																																																																																																																																																																																																																																																																																																																																																																																A2(_elm_lang$core$Json_Decode$field, 'i18nViewReportOptionsText', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																																														},
																																																																																																																																																																																																																																																																																																																																																																														A2(_elm_lang$core$Json_Decode$field, 'i18nUserGuide', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																																												},
																																																																																																																																																																																																																																																																																																																																																																												A2(_elm_lang$core$Json_Decode$field, 'i18nUser', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																																										},
																																																																																																																																																																																																																																																																																																																																																																										A2(_elm_lang$core$Json_Decode$field, 'i18nUpdateAllReports', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																																								},
																																																																																																																																																																																																																																																																																																																																																																								A2(_elm_lang$core$Json_Decode$field, 'i18nUniqueIdWithOctothorpe', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																																						},
																																																																																																																																																																																																																																																																																																																																																																						A2(_elm_lang$core$Json_Decode$field, 'i18nTuesday', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																																				},
																																																																																																																																																																																																																																																																																																																																																																				A2(_elm_lang$core$Json_Decode$field, 'i18nTues', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																																		},
																																																																																																																																																																																																																																																																																																																																																																		A2(_elm_lang$core$Json_Decode$field, 'i18nToggleNavigationLore', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																																},
																																																																																																																																																																																																																																																																																																																																																																A2(_elm_lang$core$Json_Decode$field, 'i18nThursday', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																														},
																																																																																																																																																																																																																																																																																																																																																														A2(_elm_lang$core$Json_Decode$field, 'i18nThurs', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																												},
																																																																																																																																																																																																																																																																																																																																																												A2(_elm_lang$core$Json_Decode$field, 'i18nThisEmailIsInvalid', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																										},
																																																																																																																																																																																																																																																																																																																																																										A2(_elm_lang$core$Json_Decode$field, 'i18nTheseChangesWillNotImpactGeneratedReports', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																								},
																																																																																																																																																																																																																																																																																																																																																								A2(_elm_lang$core$Json_Decode$field, 'i18nTermsOfUse', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																						},
																																																																																																																																																																																																																																																																																																																																																						A2(_elm_lang$core$Json_Decode$field, 'i18nSunday', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																				},
																																																																																																																																																																																																																																																																																																																																																				A2(_elm_lang$core$Json_Decode$field, 'i18nSun', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																		},
																																																																																																																																																																																																																																																																																																																																																		A2(_elm_lang$core$Json_Decode$field, 'i18nStatus', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																																},
																																																																																																																																																																																																																																																																																																																																																A2(_elm_lang$core$Json_Decode$field, 'i18nSettings', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																														},
																																																																																																																																																																																																																																																																																																																																														A2(_elm_lang$core$Json_Decode$field, 'i18nSeptember', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																												},
																																																																																																																																																																																																																																																																																																																																												A2(_elm_lang$core$Json_Decode$field, 'i18nSep', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																										},
																																																																																																																																																																																																																																																																																																																																										A2(_elm_lang$core$Json_Decode$field, 'i18nSent', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																								},
																																																																																																																																																																																																																																																																																																																																								A2(_elm_lang$core$Json_Decode$field, 'i18nSendSampleInvitation', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																						},
																																																																																																																																																																																																																																																																																																																																						A2(_elm_lang$core$Json_Decode$field, 'i18nSendReminder', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																				},
																																																																																																																																																																																																																																																																																																																																				A2(_elm_lang$core$Json_Decode$field, 'i18nSelectedReports', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																		},
																																																																																																																																																																																																																																																																																																																																		A2(_elm_lang$core$Json_Decode$field, 'i18nSelectReportPrompt', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																																},
																																																																																																																																																																																																																																																																																																																																A2(_elm_lang$core$Json_Decode$field, 'i18nSearchParticipantsFor', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																														},
																																																																																																																																																																																																																																																																																																																														A2(_elm_lang$core$Json_Decode$field, 'i18nSearch', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																												},
																																																																																																																																																																																																																																																																																																																												A2(_elm_lang$core$Json_Decode$field, 'i18nSaveChanges', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																										},
																																																																																																																																																																																																																																																																																																																										A2(_elm_lang$core$Json_Decode$field, 'i18nSave', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																								},
																																																																																																																																																																																																																																																																																																																								A2(_elm_lang$core$Json_Decode$field, 'i18nSaturday', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																						},
																																																																																																																																																																																																																																																																																																																						A2(_elm_lang$core$Json_Decode$field, 'i18nSat', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																				},
																																																																																																																																																																																																																																																																																																																				A2(_elm_lang$core$Json_Decode$field, 'i18nResendInvitation', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																		},
																																																																																																																																																																																																																																																																																																																		A2(_elm_lang$core$Json_Decode$field, 'i18nRescoreReportInProgress', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																																},
																																																																																																																																																																																																																																																																																																																A2(_elm_lang$core$Json_Decode$field, 'i18nRescoreReport', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																														},
																																																																																																																																																																																																																																																																																																														A2(_elm_lang$core$Json_Decode$field, 'i18nReports', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																												},
																																																																																																																																																																																																																																																																																																												A2(_elm_lang$core$Json_Decode$field, 'i18nRemoveReport', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																										},
																																																																																																																																																																																																																																																																																																										A2(_elm_lang$core$Json_Decode$field, 'i18nProjects', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																								},
																																																																																																																																																																																																																																																																																																								A2(_elm_lang$core$Json_Decode$field, 'i18nProjectTitle', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																						},
																																																																																																																																																																																																																																																																																																						A2(_elm_lang$core$Json_Decode$field, 'i18nProjectNameValidationHint', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																				},
																																																																																																																																																																																																																																																																																																				A2(_elm_lang$core$Json_Decode$field, 'i18nProjectInformation', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																		},
																																																																																																																																																																																																																																																																																																		A2(_elm_lang$core$Json_Decode$field, 'i18nProject', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																																},
																																																																																																																																																																																																																																																																																																A2(_elm_lang$core$Json_Decode$field, 'i18nProgressCounter', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																														},
																																																																																																																																																																																																																																																																																														A2(_elm_lang$core$Json_Decode$field, 'i18nPleaseSelectReports', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																												},
																																																																																																																																																																																																																																																																																												A2(_elm_lang$core$Json_Decode$field, 'i18nPending', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																										},
																																																																																																																																																																																																																																																																																										A2(_elm_lang$core$Json_Decode$field, 'i18nParticipantsHaveBeenAddedAndInvitationsSent', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																								},
																																																																																																																																																																																																																																																																																								A2(_elm_lang$core$Json_Decode$field, 'i18nParticipants', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																						},
																																																																																																																																																																																																																																																																																						A2(_elm_lang$core$Json_Decode$field, 'i18nParticipantStatus', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																				},
																																																																																																																																																																																																																																																																																				A2(_elm_lang$core$Json_Decode$field, 'i18nParticipant', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																		},
																																																																																																																																																																																																																																																																																		A2(_elm_lang$core$Json_Decode$field, 'i18nOneYearAgo', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																																},
																																																																																																																																																																																																																																																																																A2(_elm_lang$core$Json_Decode$field, 'i18nOneWeekAgo', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																														},
																																																																																																																																																																																																																																																																														A2(_elm_lang$core$Json_Decode$field, 'i18nOneMonthAgo', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																												},
																																																																																																																																																																																																																																																																												A2(_elm_lang$core$Json_Decode$field, 'i18nOneMinuteAgo', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																										},
																																																																																																																																																																																																																																																																										A2(_elm_lang$core$Json_Decode$field, 'i18nOneHourAgo', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																								},
																																																																																																																																																																																																																																																																								A2(_elm_lang$core$Json_Decode$field, 'i18nOneDayAgo', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																						},
																																																																																																																																																																																																																																																																						A2(_elm_lang$core$Json_Decode$field, 'i18nOk', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																				},
																																																																																																																																																																																																																																																																				A2(_elm_lang$core$Json_Decode$field, 'i18nOctober', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																		},
																																																																																																																																																																																																																																																																		A2(_elm_lang$core$Json_Decode$field, 'i18nOct', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																																},
																																																																																																																																																																																																																																																																A2(_elm_lang$core$Json_Decode$field, 'i18nNumberOfIdsToGenerate', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																														},
																																																																																																																																																																																																																																																														A2(_elm_lang$core$Json_Decode$field, 'i18nNovember', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																												},
																																																																																																																																																																																																																																																												A2(_elm_lang$core$Json_Decode$field, 'i18nNov', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																										},
																																																																																																																																																																																																																																																										A2(_elm_lang$core$Json_Decode$field, 'i18nNotificationsMessage', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																								},
																																																																																																																																																																																																																																																								A2(_elm_lang$core$Json_Decode$field, 'i18nNotificationsFor', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																						},
																																																																																																																																																																																																																																																						A2(_elm_lang$core$Json_Decode$field, 'i18nNotice', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																				},
																																																																																																																																																																																																																																																				A2(_elm_lang$core$Json_Decode$field, 'i18nNorm', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																		},
																																																																																																																																																																																																																																																		A2(_elm_lang$core$Json_Decode$field, 'i18nNoResultsWereFound', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																																},
																																																																																																																																																																																																																																																A2(_elm_lang$core$Json_Decode$field, 'i18nNoProjects', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																														},
																																																																																																																																																																																																																																														A2(_elm_lang$core$Json_Decode$field, 'i18nNoParticipants', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																												},
																																																																																																																																																																																																																																												A2(_elm_lang$core$Json_Decode$field, 'i18nNext', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																										},
																																																																																																																																																																																																																																										A2(_elm_lang$core$Json_Decode$field, 'i18nNewProject', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																								},
																																																																																																																																																																																																																																								A2(_elm_lang$core$Json_Decode$field, 'i18nNameRequired', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																						},
																																																																																																																																																																																																																																						A2(_elm_lang$core$Json_Decode$field, 'i18nNameLength', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																				},
																																																																																																																																																																																																																																				A2(_elm_lang$core$Json_Decode$field, 'i18nNameIsConfigure', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																		},
																																																																																																																																																																																																																																		A2(_elm_lang$core$Json_Decode$field, 'i18nNameDuplicate', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																																},
																																																																																																																																																																																																																																A2(_elm_lang$core$Json_Decode$field, 'i18nNameContainsInvalidCharacters', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																														},
																																																																																																																																																																																																																														A2(_elm_lang$core$Json_Decode$field, 'i18nName', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																												},
																																																																																																																																																																																																																												A2(_elm_lang$core$Json_Decode$field, 'i18nMyReports', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																										},
																																																																																																																																																																																																																										A2(_elm_lang$core$Json_Decode$field, 'i18nMonthsAgoFormat', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																								},
																																																																																																																																																																																																																								A2(_elm_lang$core$Json_Decode$field, 'i18nMonday', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																						},
																																																																																																																																																																																																																						A2(_elm_lang$core$Json_Decode$field, 'i18nMon', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																				},
																																																																																																																																																																																																																				A2(_elm_lang$core$Json_Decode$field, 'i18nModifyReports', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																		},
																																																																																																																																																																																																																		A2(_elm_lang$core$Json_Decode$field, 'i18nMinutesAgoFormat', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																																},
																																																																																																																																																																																																																A2(_elm_lang$core$Json_Decode$field, 'i18nMay', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																														},
																																																																																																																																																																																																														A2(_elm_lang$core$Json_Decode$field, 'i18nMarch', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																												},
																																																																																																																																																																																																												A2(_elm_lang$core$Json_Decode$field, 'i18nMar', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																										},
																																																																																																																																																																																																										A2(_elm_lang$core$Json_Decode$field, 'i18nLogout', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																								},
																																																																																																																																																																																																								A2(_elm_lang$core$Json_Decode$field, 'i18nLoggedInAs', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																						},
																																																																																																																																																																																																						A2(_elm_lang$core$Json_Decode$field, 'i18nLoadingProjects', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																				},
																																																																																																																																																																																																				A2(_elm_lang$core$Json_Decode$field, 'i18nLoadingParticipants', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																		},
																																																																																																																																																																																																		A2(_elm_lang$core$Json_Decode$field, 'i18nLoadingMessage', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																																},
																																																																																																																																																																																																A2(_elm_lang$core$Json_Decode$field, 'i18nLastNameRequired', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																														},
																																																																																																																																																																																														A2(_elm_lang$core$Json_Decode$field, 'i18nLastNameCannotBeAsterisk', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																												},
																																																																																																																																																																																												A2(_elm_lang$core$Json_Decode$field, 'i18nLastName', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																										},
																																																																																																																																																																																										A2(
																																																																																																																																																																																											_elm_lang$core$Json_Decode$field,
																																																																																																																																																																																											'i18nLanguages',
																																																																																																																																																																																											_elm_lang$core$Json_Decode$list(
																																																																																																																																																																																												A2(
																																																																																																																																																																																													_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																													function (x0) {
																																																																																																																																																																																														return A2(
																																																																																																																																																																																															_elm_lang$core$Json_Decode$andThen,
																																																																																																																																																																																															function (x1) {
																																																																																																																																																																																																return _elm_lang$core$Json_Decode$succeed(
																																																																																																																																																																																																	{ctor: '_Tuple2', _0: x0, _1: x1});
																																																																																																																																																																																															},
																																																																																																																																																																																															A2(_elm_lang$core$Json_Decode$index, 1, _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																													},
																																																																																																																																																																																													A2(_elm_lang$core$Json_Decode$index, 0, _elm_lang$core$Json_Decode$string)))));
																																																																																																																																																																																								},
																																																																																																																																																																																								A2(_elm_lang$core$Json_Decode$field, 'i18nLanguage', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																						},
																																																																																																																																																																																						A2(_elm_lang$core$Json_Decode$field, 'i18nJune', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																				},
																																																																																																																																																																																				A2(_elm_lang$core$Json_Decode$field, 'i18nJun', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																		},
																																																																																																																																																																																		A2(_elm_lang$core$Json_Decode$field, 'i18nJuly', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																																},
																																																																																																																																																																																A2(_elm_lang$core$Json_Decode$field, 'i18nJul', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																														},
																																																																																																																																																																														A2(_elm_lang$core$Json_Decode$field, 'i18nJobProfile', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																												},
																																																																																																																																																																												A2(_elm_lang$core$Json_Decode$field, 'i18nJanuary', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																										},
																																																																																																																																																																										A2(_elm_lang$core$Json_Decode$field, 'i18nJan', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																								},
																																																																																																																																																																								A2(_elm_lang$core$Json_Decode$field, 'i18nInviteParticipants', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																						},
																																																																																																																																																																						A2(_elm_lang$core$Json_Decode$field, 'i18nInvalidEmailAddress', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																				},
																																																																																																																																																																				A2(_elm_lang$core$Json_Decode$field, 'i18nInactive', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																		},
																																																																																																																																																																		A2(_elm_lang$core$Json_Decode$field, 'i18nHoursAgoFormat', _elm_lang$core$Json_Decode$string));
																																																																																																																																																																},
																																																																																																																																																																A2(_elm_lang$core$Json_Decode$field, 'i18nHoganPrivacyPolicy', _elm_lang$core$Json_Decode$string));
																																																																																																																																																														},
																																																																																																																																																														A2(_elm_lang$core$Json_Decode$field, 'i18nHoganIdWithoutOctothorpe', _elm_lang$core$Json_Decode$string));
																																																																																																																																																												},
																																																																																																																																																												A2(_elm_lang$core$Json_Decode$field, 'i18nHoganIdWithOctothorpe', _elm_lang$core$Json_Decode$string));
																																																																																																																																																										},
																																																																																																																																																										A2(_elm_lang$core$Json_Decode$field, 'i18nHelpfulLinks', _elm_lang$core$Json_Decode$string));
																																																																																																																																																								},
																																																																																																																																																								A2(_elm_lang$core$Json_Decode$field, 'i18nGoToParticipantsPage', _elm_lang$core$Json_Decode$string));
																																																																																																																																																						},
																																																																																																																																																						A2(_elm_lang$core$Json_Decode$field, 'i18nGoBack', _elm_lang$core$Json_Decode$string));
																																																																																																																																																				},
																																																																																																																																																				A2(_elm_lang$core$Json_Decode$field, 'i18nGenericError', _elm_lang$core$Json_Decode$string));
																																																																																																																																																		},
																																																																																																																																																		A2(_elm_lang$core$Json_Decode$field, 'i18nGenerateNewIds', _elm_lang$core$Json_Decode$string));
																																																																																																																																																},
																																																																																																																																																A2(_elm_lang$core$Json_Decode$field, 'i18nGenerateIdsTitle', _elm_lang$core$Json_Decode$string));
																																																																																																																																														},
																																																																																																																																														A2(_elm_lang$core$Json_Decode$field, 'i18nGenerateIds', _elm_lang$core$Json_Decode$string));
																																																																																																																																												},
																																																																																																																																												A2(_elm_lang$core$Json_Decode$field, 'i18nFriday', _elm_lang$core$Json_Decode$string));
																																																																																																																																										},
																																																																																																																																										A2(_elm_lang$core$Json_Decode$field, 'i18nFri', _elm_lang$core$Json_Decode$string));
																																																																																																																																								},
																																																																																																																																								A2(_elm_lang$core$Json_Decode$field, 'i18nFirstNameRequired', _elm_lang$core$Json_Decode$string));
																																																																																																																																						},
																																																																																																																																						A2(_elm_lang$core$Json_Decode$field, 'i18nFirstName', _elm_lang$core$Json_Decode$string));
																																																																																																																																				},
																																																																																																																																				A2(_elm_lang$core$Json_Decode$field, 'i18nFebruary', _elm_lang$core$Json_Decode$string));
																																																																																																																																		},
																																																																																																																																		A2(_elm_lang$core$Json_Decode$field, 'i18nFeb', _elm_lang$core$Json_Decode$string));
																																																																																																																																},
																																																																																																																																A2(_elm_lang$core$Json_Decode$field, 'i18nFailedToSendEmail', _elm_lang$core$Json_Decode$string));
																																																																																																																														},
																																																																																																																														A2(_elm_lang$core$Json_Decode$field, 'i18nFailedToSend', _elm_lang$core$Json_Decode$string));
																																																																																																																												},
																																																																																																																												A2(_elm_lang$core$Json_Decode$field, 'i18nExitWithoutSaving', _elm_lang$core$Json_Decode$string));
																																																																																																																										},
																																																																																																																										A2(_elm_lang$core$Json_Decode$field, 'i18nExitMessage', _elm_lang$core$Json_Decode$string));
																																																																																																																								},
																																																																																																																								A2(_elm_lang$core$Json_Decode$field, 'i18nErrorWithRequest', _elm_lang$core$Json_Decode$string));
																																																																																																																						},
																																																																																																																						A2(_elm_lang$core$Json_Decode$field, 'i18nErrorSavingEmail', _elm_lang$core$Json_Decode$string));
																																																																																																																				},
																																																																																																																				A2(_elm_lang$core$Json_Decode$field, 'i18nError', _elm_lang$core$Json_Decode$string));
																																																																																																																		},
																																																																																																																		A2(_elm_lang$core$Json_Decode$field, 'i18nEnterValueWithinRange', _elm_lang$core$Json_Decode$string));
																																																																																																																},
																																																																																																																A2(_elm_lang$core$Json_Decode$field, 'i18nEnterEmailAddress', _elm_lang$core$Json_Decode$string));
																																																																																																														},
																																																																																																														A2(_elm_lang$core$Json_Decode$field, 'i18nEmptyWarning', _elm_lang$core$Json_Decode$string));
																																																																																																												},
																																																																																																												A2(_elm_lang$core$Json_Decode$field, 'i18nEmailTooLong', _elm_lang$core$Json_Decode$string));
																																																																																																										},
																																																																																																										A2(_elm_lang$core$Json_Decode$field, 'i18nEmailSuccessfullySent', _elm_lang$core$Json_Decode$string));
																																																																																																								},
																																																																																																								A2(_elm_lang$core$Json_Decode$field, 'i18nEmailSuccess', _elm_lang$core$Json_Decode$string));
																																																																																																						},
																																																																																																						A2(_elm_lang$core$Json_Decode$field, 'i18nEmailRequired', _elm_lang$core$Json_Decode$string));
																																																																																																				},
																																																																																																				A2(_elm_lang$core$Json_Decode$field, 'i18nEmailLacksDotInDomain', _elm_lang$core$Json_Decode$string));
																																																																																																		},
																																																																																																		A2(_elm_lang$core$Json_Decode$field, 'i18nEmailInvalid', _elm_lang$core$Json_Decode$string));
																																																																																																},
																																																																																																A2(_elm_lang$core$Json_Decode$field, 'i18nEmailFailed', _elm_lang$core$Json_Decode$string));
																																																																																														},
																																																																																														A2(_elm_lang$core$Json_Decode$field, 'i18nEmailContainsDoubleDot', _elm_lang$core$Json_Decode$string));
																																																																																												},
																																																																																												A2(_elm_lang$core$Json_Decode$field, 'i18nEmailAddress', _elm_lang$core$Json_Decode$string));
																																																																																										},
																																																																																										A2(_elm_lang$core$Json_Decode$field, 'i18nEmail', _elm_lang$core$Json_Decode$string));
																																																																																								},
																																																																																								A2(_elm_lang$core$Json_Decode$field, 'i18nEditReports', _elm_lang$core$Json_Decode$string));
																																																																																						},
																																																																																						A2(_elm_lang$core$Json_Decode$field, 'i18nEdit', _elm_lang$core$Json_Decode$string));
																																																																																				},
																																																																																				A2(_elm_lang$core$Json_Decode$field, 'i18nDuplicateEmailAddressForProjectParticipant', _elm_lang$core$Json_Decode$string));
																																																																																		},
																																																																																		A2(_elm_lang$core$Json_Decode$field, 'i18nDraft', _elm_lang$core$Json_Decode$string));
																																																																																},
																																																																																A2(_elm_lang$core$Json_Decode$field, 'i18nDownloadUnusedIds', _elm_lang$core$Json_Decode$string));
																																																																														},
																																																																														A2(_elm_lang$core$Json_Decode$field, 'i18nDownloadReports', _elm_lang$core$Json_Decode$string));
																																																																												},
																																																																												A2(_elm_lang$core$Json_Decode$field, 'i18nDownloadReport', _elm_lang$core$Json_Decode$string));
																																																																										},
																																																																										A2(_elm_lang$core$Json_Decode$field, 'i18nDownload', _elm_lang$core$Json_Decode$string));
																																																																								},
																																																																								A2(_elm_lang$core$Json_Decode$field, 'i18nDecember', _elm_lang$core$Json_Decode$string));
																																																																						},
																																																																						A2(_elm_lang$core$Json_Decode$field, 'i18nDec', _elm_lang$core$Json_Decode$string));
																																																																				},
																																																																				A2(_elm_lang$core$Json_Decode$field, 'i18nDaysAgoFormat', _elm_lang$core$Json_Decode$string));
																																																																		},
																																																																		A2(_elm_lang$core$Json_Decode$field, 'i18nDateFormat', _elm_lang$core$Json_Decode$string));
																																																																},
																																																																A2(_elm_lang$core$Json_Decode$field, 'i18nCurrent', _elm_lang$core$Json_Decode$string));
																																																														},
																																																														A2(_elm_lang$core$Json_Decode$field, 'i18nCreatedDate', _elm_lang$core$Json_Decode$string));
																																																												},
																																																												A2(_elm_lang$core$Json_Decode$field, 'i18nCreated', _elm_lang$core$Json_Decode$string));
																																																										},
																																																										A2(_elm_lang$core$Json_Decode$field, 'i18nContinueWith', _elm_lang$core$Json_Decode$string));
																																																								},
																																																								A2(_elm_lang$core$Json_Decode$field, 'i18nContactSupport', _elm_lang$core$Json_Decode$string));
																																																						},
																																																						A2(_elm_lang$core$Json_Decode$field, 'i18nCompleted', _elm_lang$core$Json_Decode$string));
																																																				},
																																																				A2(_elm_lang$core$Json_Decode$field, 'i18nComplete', _elm_lang$core$Json_Decode$string));
																																																		},
																																																		A2(_elm_lang$core$Json_Decode$field, 'i18nClients', _elm_lang$core$Json_Decode$string));
																																																},
																																																A2(_elm_lang$core$Json_Decode$field, 'i18nClickHereToDownloadIds', _elm_lang$core$Json_Decode$string));
																																														},
																																														A2(_elm_lang$core$Json_Decode$field, 'i18nChangeBillableSettingWarning', _elm_lang$core$Json_Decode$string));
																																												},
																																												A2(_elm_lang$core$Json_Decode$field, 'i18nCancel', _elm_lang$core$Json_Decode$string));
																																										},
																																										A2(_elm_lang$core$Json_Decode$field, 'i18nBackToProjectDetail', _elm_lang$core$Json_Decode$string));
																																								},
																																								A2(_elm_lang$core$Json_Decode$field, 'i18nBackToProjectDashboard', _elm_lang$core$Json_Decode$string));
																																						},
																																						A2(_elm_lang$core$Json_Decode$field, 'i18nAugust', _elm_lang$core$Json_Decode$string));
																																				},
																																				A2(_elm_lang$core$Json_Decode$field, 'i18nAug', _elm_lang$core$Json_Decode$string));
																																		},
																																		A2(_elm_lang$core$Json_Decode$field, 'i18nAssessments', _elm_lang$core$Json_Decode$string));
																																},
																																A2(_elm_lang$core$Json_Decode$field, 'i18nApril', _elm_lang$core$Json_Decode$string));
																														},
																														A2(_elm_lang$core$Json_Decode$field, 'i18nApr', _elm_lang$core$Json_Decode$string));
																												},
																												A2(_elm_lang$core$Json_Decode$field, 'i18nAlreadySelectedReportContainedInPackage', _elm_lang$core$Json_Decode$string));
																										},
																										A2(_elm_lang$core$Json_Decode$field, 'i18nAllProjects', _elm_lang$core$Json_Decode$string));
																								},
																								A2(_elm_lang$core$Json_Decode$field, 'i18nAddReport', _elm_lang$core$Json_Decode$string));
																						},
																						A2(_elm_lang$core$Json_Decode$field, 'i18nAddParticipantsToStartProject', _elm_lang$core$Json_Decode$string));
																				},
																				A2(_elm_lang$core$Json_Decode$field, 'i18nAddParticipantsModalDescription', _elm_lang$core$Json_Decode$string));
																		},
																		A2(_elm_lang$core$Json_Decode$field, 'i18nAddParticipants', _elm_lang$core$Json_Decode$string));
																},
																A2(_elm_lang$core$Json_Decode$field, 'i18nAdd', _elm_lang$core$Json_Decode$string));
														},
														A2(_elm_lang$core$Json_Decode$field, 'i18nActive', _elm_lang$core$Json_Decode$string));
												},
												A2(_elm_lang$core$Json_Decode$field, 'i18nAccessDenied', _elm_lang$core$Json_Decode$string));
										},
										A2(_elm_lang$core$Json_Decode$field, 'i18nAFewSecondsAgo', _elm_lang$core$Json_Decode$string));
								},
								A2(_elm_lang$core$Json_Decode$field, 'haloLiteApi', _elm_lang$core$Json_Decode$string));
						},
						A2(
							_elm_lang$core$Json_Decode$field,
							'clients',
							_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$string)));
				},
				A2(_elm_lang$core$Json_Decode$field, 'activeClient', _elm_lang$core$Json_Decode$string));
		},
		A2(_elm_lang$core$Json_Decode$field, 'accessToken', _elm_lang$core$Json_Decode$string)));

var Elm = {};
Elm['Main'] = Elm['Main'] || {};
if (typeof _user$project$Main$main !== 'undefined') {
    _user$project$Main$main(Elm['Main'], 'Main', undefined);
}

if (typeof define === "function" && define['amd'])
{
  define([], function() { return Elm; });
  return;
}

if (typeof module === "object")
{
  module['exports'] = Elm;
  return;
}

var globalElm = this['Elm'];
if (typeof globalElm === "undefined")
{
  this['Elm'] = Elm;
  return;
}

for (var publicModule in Elm)
{
  if (publicModule in globalElm)
  {
    throw new Error('There are two Elm modules called `' + publicModule + '` on this page! Rename one of them.');
  }
  globalElm[publicModule] = Elm[publicModule];
}

}).call(this);

